/* eslint-disable */
const i18n = {
  "en-US": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "de-DE": {
    "billing.essential_apps": "Grundlegende Apps",
    "billing.essential_apps.dialog_desc": "Fördern und verwalten Sie Ihr Unternehmen mit Apps – Notizen im Meeting, mehr Engagement im Team durch interaktive Aktivitäten und bessere Kundengespräche dank Erkenntnissen. Kostenlose Premium-Apps in Ihrem Abo 1 Jahr lang kostenlos nutzen.",
    "billing.see_more_details": "Weitere Einzelheiten ansehen",
    "billing.essential_app.legal_copy": "Das Angebot gilt nur für Benutzer mit einer aktuellen Lizenz mit dem Stand ab 4. Januar 2023, die über den Online-Kanal von Zoom, zoom.us/buy, ein Pro-, Business- oder Business Plus-Abo für Zoom One erworben haben. Benutzer, deren Abo mit einem Konto im Gesundheitswesen, Bildungsbereich oder Verwaltungswesen verknüpft ist, können dieses Angebot leider nicht in Anspruch nehmen.  Der Nutzungszeitraum für jede App außer Coda beginnt mit der App-Aktivierung durch den Benutzer und endet ein Jahr danach. Der Nutzungszeitraum für Coda für Benutzer im selben Zoom Konto beginnt mit der ersten Aktivierung von Coda eines Benutzers unter diesem Konto und endet für alle Benutzer desselben Kontos nach einem Jahr. Dabei ist unerheblich, wann die App von weiteren Benutzern unter demselben Zoom Konto aktiviert wurde.Bei allen Apps beendet eine Neuzuweisung oder Kündigung der Lizenz oder des Abonnements eines Benutzers den Nutzungszeitraum. Dabei ist unerheblich, ob der Ein-Jahres-Zeitraum bereits abgelaufen ist.Jede App ist an eigene Nutzungsbedingungen und Datenschutzbestimmungen gebunden, die zum Zeitpunkt der Aktivierung bestätigt werden müssen.Die enthaltenen Apps unterstützen nur die englische Sprache.Nicht alle Apps funktionieren auf Mobilgeräten.Das Angebot kann nicht gegen Bargeld eingelöst oder erstattet werden.Das Angebot gilt nur für diese Apps, die im <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> als grundlegende Apps aufgeführt sind. Benutzer, die bereits ein Abo für eine oder mehrere der Apps besitzen, sind in Bezug auf die betreffenden Apps vom Angebot ausgenommen.Zoom behält sich vor, dieses Angebot jederzeit und ohne vorherige Ankündigung zu ändern oder zu stornieren. Eine Haftung ist ausgeschlossen.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Besucherverwaltung"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Live-Chat und Telefonsupport rund um die Uhr"
      },
      "learn_more": "Weitere Informationen",
      "new": "NEU",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Bis zu {0} Teilnehmer hosten",
          "meeting_hours": "Unbegrenzte Meetings von bis zu 30 Stunden pro Meeting",
          "recording_storage": "{0} GB Cloud-Speicher für Aufzeichnungen (pro Lizenz)",
          "auto_captions": "Automatische Untertitel"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} bearbeitbare Boards",
          "standard_features": "Standard-Funktionen"
        },
        "team_chat": {
          "title": "Team-Chat",
          "desc": "Gruppenchat und Dateifreigabe"
        },
        "main_calendar": {
          "title": "Mail und Kalender",
          "desc": "Mail- und Kalender-Client und -Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Editierbare Dokumente in Zoom erstellen und freigeben",
          "desc2": "Dokumente eigenständig und kollaborativ mit Rich-Text-Formatierung bearbeiten"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Kurzvideos einfach aufnehmen, schneiden und teilen",
          "desc2": "Unbegrenzte Videos und erweiterte Funktionen"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Meetings schnell zusammenfassen lassen, Unterstützung beim Verfassen von Nachrichten erhalten und vieles mehr"
        },
        "EssentialApp": {
          "title": "Grundlegende Apps",
          "desc1": "Premium-Apps 1 Jahr lang kostenlos (es gelten die Angebotsbedingungen)",
          "desc2": "Mehr kollaboratives Arbeiten und Produktivität im Team"
        },
        "livechat": {
          "title": "Live-Chat-Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Zu Zoom Workplace Pro wechseln?",
            "content": "Sie haben zuvor Zoom Workplace Business ausgewählt mit bis zu 300 Teilnehmern pro Meeting, Zoom Scheduler und mehr. Möchten Sie trotzdem zu Pro wechseln?",
            "confirm": "Änderung bestätigen",
            "keep_current": "Aktuelles Abo behalten"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Zuschauer",
          "participants": "{0} Teilnehmer",
          "user_range": "{0}–{1} Benutzer",
          "items": "{num} Artikel"
        },
        "button": {
          "ok": "OK",
          "add": "Hinzufügen",
          "buy_now": "Jetzt kaufen",
          "try_for_days": "{0} Tage lang testen",
          "contact_sales": "Vertrieb kontaktieren",
          "close": "Schließen",
          "cancel": "Abbrechen",
          "edit": "Bearbeiten",
          "got_it": "Verstanden"
        },
        "title": {
          "everything_in_and": "Alles in {0} und:"
        },
        "tag": {
          "new": "NEU",
          "free_trial": "Kostenloser Test"
        },
        "billing_cycle": {
          "annual": "Jährlich",
          "monthly": "Monatlich",
          "quarterly": "Vierteljährlich",
          "two_years": "Zweijährlich",
          "three_years": "Dreijährlich"
        },
        "errors": {
          "unknown_error_try_again": "Unbekannter Fehler bei der Verarbeitung der Transaktion. Bitte versuchen Sie es später erneut."
        },
        "excluding_tax": {
          "vat_tip": "zzgl. MwSt.",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Eingeschränkte Funktionen",
        "pro_plus": {
          "host_meeting_up_to_participants": "Bis zu {0} Teilnehmer hosten",
          "gb_of_cloud_recording_storage": "{0} GB Speicher für Cloud-Aufzeichnungen (pro Lizenz)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion für die Erstellung und Übersetzung von Inhalten",
            "features_item2": "Freigabe unbegrenzt vieler Dokumente für Ihr Team",
            "features_item3": "Zugriff auf unbegrenzten Versionsverlauf",
            "comparison_table_tips": "Optimieren Sie kollaboratives Arbeiten mit KI-basierten Dokumenten, die Meeting-Inhalte in umsetzbare Dokumente, Wikis und Projekte umwandeln."
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatische Ableitung von Aufgaben aus Ihren Meetings, Anrufen, Chats und Dokumenten",
            "features_item2": "Unterstützung bei der Erledigung von Aufgaben, etwa bei der Planung von Folgemeetings und der Erstellung von Dokumenten",
            "features_item3": "Einfache Markierung von Aufgaben als „erledigt“, sodass Sie den Überblick über Ihr Vorankommen behalten und sich auf die nächsten Punkte konzentrieren können",
            "features_item4": "Aufgabenmanagement in der gesamten Zoom Workplace-Plattform möglich, einschließlich Zoom Docs",
            "features_item1_opc": "Ableitung und Erstellung von Aufgaben aus Ihren Chats, E-Mails, Dokumenten, Whiteboards und Meeting-Zusammenfassungen – ermöglicht durch die Leistungsfähigkeit von AI Companion",
            "features_item2_opc": "Einfaches Sortieren, Filtern, Gruppieren und Suchen, sodass Sie schnell auf Ihre Aufgaben zuzugreifen und sie im Kontext sehen können",
            "learn_more_header": "Behalten Sie mit AI Companion* den Überblick über Ihre Aktionspunkte, um im gesamten Zoom Workplace mehr zu erledigen.",
            "learn_more_footer": "\*AI Companion ist nur für Zoom Workplace Pro-, Business- und Enterprise-Abos verfügbar.",
            "features_prefix": "So hilft Ihnen AI Companion:",
            "comparison_table_tips": "Behalten Sie den Überblick über Aktionspunkte und erledigen Sie sie pünktlich – mit einer AI-First-Lösung, die Ihnen in Zoom Workplace auf der Grundlage von Gesprächen und Meeting-Zusammenfassungen Aufgaben vorschlägt.",
            "tasks_label_text": " AI-First-Aufgabenmanagement"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Kontaktieren Sie uns, um Preisinformationen und weitere Informationen zu erhalten",
          "contact_sales": "Vertrieb kontaktieren",
          "meetings": "Meetings",
          "phone": "Telefon",
          "phone_sub_title": "Unbegrenzte Anrufe",
          "use_only": "Nur für geschäftliche Zwecke",
          "team_chat": {
            "title": "Team-Chat",
            "title_desc": "Gruppenchat und Dateifreigabe"
          },
          "cloud_storage": {
            "title": "Cloud-Speicher"
          },
          "mail_calender": {
            "title": "Mail und Kalender"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client und Service"
          },
          "up_to_30_hours_per_meeting": "bis zu 30 Stunden pro Meeting",
          "300_attendees": "300 Teilnehmer",
          "per_meeting": "pro Meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "NEU",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Extra",
          "sso_managed_domains_more": "SSO, verwaltete Domänen",
          "scheduler": "Buchungskalender",
          "global_select": "Global Select",
          "unlimited_regional": "Unbegrenzte Ortsgespräche",
          "translated_captions": "Übersetzte Untertitel",
          "workspace_reservation": "Workspace-Reservierung",
          "auto_translated_captions": "Automatische und übersetzte Untertitel",
          "unlimited_editable_boards": "Unbegrenzte bearbeitbare Boards",
          "standard_features": "Standard-Funktionen",
          "advanced_docu_controls": "Erweiterte Bedienelemente für Dokumente",
          "chats_channels_for_collaboration": "Chats und Kanäle für kollaboratives Arbeiten, Dateifreigabe und mehr",
          "zoom_phone_is_biz_use_only": "Zoom Phone ist ausschließlich für den geschäftlichen Gebrauch",
          "unlimited_regional_calling": "Unbegrenzte Ortsgespr\u00E4che",
          "domestic_sms_mms": "SMS & MMS im Inland",
          "automatic_call_distribution_groups": "Automatische Anrufverteilungsgruppen (ACD) mit Anrufwarteschleife",
          "single_sign_on": "Einmaliges Anmelden",
          "managed_domains": "Verwaltete Dom\u00E4nen",
          "company_branding": "Unternehmens-Branding",
          "mail_calender_client_services_beta": "Mail- und Kalender-Client und -Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unbegrenzte Meetings von bis zu 30 Stunden pro Meeting",
          "mail_and_calendar_client_and_services_beta": "Mail- und Kalender-Client und -Services beta",
          "easily_record_edit_share_videos": "Kurzvideos einfach aufnehmen, schneiden und teilen",
          "unlimited_videos_advanced_features": "Unbegrenzte Videos und erweiterte Funktionen",
          "create_share_editabel_docu_within_zoom": "Editierbare Dokumente in Zoom erstellen und freigeben",
          "personal_collaborative_notes_rich_text_editing": "Dokumente eigenständig und kollaborativ mit Rich-Text-Formatierung bearbeiten",
          "effortlessly_share_meeting": "Intuitives Teilen von Zeitfenstern für einfache Meeting-Buchung",
          "works_with_zoom_meeting_mail_calender_google_ms": "Mit Zoom Meetings, Zoom Mail, Zoom Calendar, Google und Microsoft 365 kompatibel",
          "up_to_300_attendees": "Bis zu 300 Teilnehmer",
          "10_gb_of_storage": "10 GB Speicherplatz",
          "host_meeting_up_to_300_participants": "Durchf\u00FChrung von Meetings mit bis zu 300 Teilnehmern",
          "10_gb_of_cloud_recording_storage": "10 GB Cloud-Speicher für Aufzeichnungen (pro Lizenz)",
          "starting_at_licenses_year": "Ab {1} Lizenzen f\u00FCr {0} /Jahr",
          "starting_at_licenses_month": "Ab {1} Lizenzen f\u00FCr {0} /Monat",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Meetings schnell zusammenfassen lassen, Unterstützung beim Verfassen von Nachrichten erhalten und vieles mehr",
          "learn_more": "Weitere Informationen",
          "essential_apps": "Grundlegende Apps",
          "increase_team_collaboration": "Mehr kollaboratives Arbeiten und Produktivität im Team",
          "free_premium_apps": "Premium-Apps 1 Jahr lang kostenlos (es gelten die Angebotsbedingungen)",
          "visitor_management": "Besucherverwaltung",
          "visitor_management_custom_invites": "Anpassbare Einladungen",
          "visitor_management_visitor_check": "Einchecken am Kiosk",
          "visitor_management_receive_detailed": "Ausführliche Kennzahlen zur Arbeitsplatznutzung von Besuchern"
        },
        "custom_avatar": {
          "title": "Benutzerdefinierter Avatar",
          "label_text": "3 Minuten pro Monat",
          "basic_feature": "1 Minute pro Lebensdauer",
          "pricing_feature": "3 Minuten pro Monat",
          "learn_more_subtitle": "Mithilfe von KI entsteht eine lebensechte Version von Ihnen, die Ihre Stimme imitiert und in mehreren Sprachen kommuniziert.",
          "features_item1": "Bis zu drei lebensechte digitale Avatare pro Monat, die Ihr Aussehen und Ihre Stimme für Präsentationen und Demos imitieren",
          "features_item2": "Bis zu 3 Minuten lange Skripte – dank AI Companion und Ihres Avatars",
          "features_item3": "Wahl aus 18 vorgefertigten Avataren, mit denen Sie schnell hochwertige Videos aufnehmen können",
          "features_item4": "Unterstützung des virtuellen Hintergrunds",
          "features_item1_opc": "Bis zu drei lebensechte digitale Avatare pro Monat, die Ihr Aussehen und Ihre Stimme für Präsentationen und Demos imitieren",
          "features_item2_opc": "Bis zu 3 Minuten lange Skripte – dank AI Companion und Ihres Avatars",
          "comparison_table_tips": "Der benutzerdefinierte Avatar erstellt mithilfe von KI eine lebensechte Version von Ihnen, die Ihre Stimme imitiert und in mehreren Sprachen kommuniziert."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Meetings schnell zusammenfassen lassen, Unterstützung beim Verfassen von Nachrichten erhalten und vieles mehr",
        "learn_more_dialog": {
          "desc": "Erledigen Sie mehr mit AI Companion! Er kann Inhalte schreiben, Ihre Meetings planen, Ihre Projekte verwalten und vieles mehr.",
          "tip1": "Erhalten Sie die Agenda im Voraus, damit Sie ein effektiveres Meeting abhalten können.",
          "tip2": "Halten Sie Ihre Projekte mit automatisierter Aufgabenerstellung und zugehörigen Benachrichtigungen auf Kurs.",
          "tip3": "Lassen Sie sich bei der Organisation Ihres Kalenders und der Verwaltung Ihrer Zeit unterstützen.",
          "tip4": "Erstellen Sie schriftliche und visuelle Inhalte, die Ihrem Stil entsprechen, in Zoom Docs, Whiteboards oder in der Zoom Workplace-App."
        },
        "top_features": "Wichtigste Funktionen",
        "more_to_come": "Weitere nützliche Funktionen folgen!",
        "discover_more": "Entdecken Sie noch mehr Möglichkeiten, Ihre Arbeit mit AI Companion zu optimieren!",
        "detail_desc": "AI Companion ist ohne zusätzliche Kosten in den kostenpflichtigen Diensten in Zoom-Benutzerkonten enthalten. Einige Verticals und Regionen sind unter Umständen ausgenommen."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/Jahr/Lizenz",
        "month_licnese": "/Monat/Lizenz",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/Monat",
          "per_year": "/Jahr"
        },
        "unit": {
          "license": "{0}/Lizenz",
          "user": "{0}/Benutzer"
        },
        "learn_more": "Weitere Informationen",
        "required": "Erforderlich",
        "zoom_one_required": "Zoom Workplace erforderlich",
        "large": {
          "features_tip": "Steigern Sie Ihre Reichweite und erhöhen Sie Ihre Teilnehmerkapazität auf bis zu 1000 Teilnehmer.",
          "label_title1": "500 Teilnehmer",
          "label_title2": "1000 Teilnehmer"
        },
        "cmr": {
          "features_tip": "Videoaufzeichnungen direkt in der Zoom Cloud speichern, streamen und herunterladen.",
          "explain_desc": "Cloud-Speicher ist in ausgewählten Zoom One-Abos enthalten: Pro (5 GB), Business (5 GB), Business Plus (10 GB) und Enterprise (unbegrenzt)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 Stunden",
          "option_label2": "≈ 650 Stunden",
          "option_label3": "≈ 3,500 Stunden",
          "option_label4": "≈ 17,500 Stunden",
          "intro_label2": "Speicheroptionen umfassen bis zu 5 TB/Monat",
          "tooltip_content": "Der Aufzeichnungsspeicher variiert je nach Anzahl der videofähigen Teilnehmer, der Auflösung des Meetings und der Auflösung der freigegebenen Inhalte."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Während Meetings und darüber hinaus können Sie auf Whiteboards kollaborativ mit anderen arbeiten – und zwar in Echtzeit.",
          "explain_desc": "Enthalten in Zoom One Business, Zoom One Business Plus und Zoom One Enterprise",
          "explain_desc_plus": "Enthalten in Zoom One Enterprise Plus und allen Zoom Rooms-Abos",
          "option_label1": "Unbegrenzte Whiteboards inklusive 1 GB Cloud-Speicher",
          "option_label2": "Erweiterte Funktionen mit unbegrenzten Whiteboards und Cloud-Speicher",
          "intro_label1": "Unbegrenzte gleichzeitig bearbeitbare Whiteboards",
          "intro_label2": "Standard-Funktionen und erweiterte Bedienelemente für Dokumente",
          "intro_label3": "Erweiterte Whiteboard-Funktionen, einschließlich benutzerdefinierter Vorlagen und Unternehmensvorlagen sowie Integrationen von Drittanbietern"
        },
        "translated_captions": {
          "features_tip": "Mit automatischen Untertiteln in Ihrer Sprache vereinfachen Sie das kollaborative Arbeiten mit Menschen aus aller Welt.",
          "intro_label1": "Teilnehmer können Untertitel selbstständig ein- und ausschalten und die Sprache wechseln.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Unterstützte Sprachen ansehen"
        },
        "crc": {
          "features_tip": "Unterstützt für effektives hybrides Arbeiten jeden standardbasierten SIP/H.323-Videokonferenzendpunkt.",
          "intro_label1": "Funktioniert mit vielen Vorgängerendpunkten, darunter auch Polycom, Cisco, Lifesize und anderen",
          "intro_label2": "Cloudbasierter oder lokaler (VM) Raum-Connector"
        },
        "scheduler": {
          "simplify_bookings": "Vereinfachen Sie Buchungen mit flexibler Verfügbarkeit und anpassbaren Zeitfenstern.",
          "host_one_on_one": "Hosten Sie Einzel- oder Gruppenmeetings mit einem einzigen Link zum einfachen Teilen.",
          "customize_reminders": "Erstellen Sie benutzerdefinierte E-Mail-/SMS-Erinnerungen, um verpasste Termine zu reduzieren.",
          "sync_calendars": "Synchronisieren Sie Ihre Kalender nahtlos durch die Integration mit Google, Microsoft 365 und Zoom.",
          "features_tip": "Meetingtermine für Sprechzeiten, Vorstellungsgespräche und vieles mehr mühelos bekannt geben",
          "intro_label1": "Kalenderintegration",
          "intro_label2": "wiederkehrende Verfügbarkeit",
          "intro_label3": "skalierbare Meeting-Funktionen",
          "intro_label4": "personalisierbare Benachrichtigungen",
          "intro_sub_label1": "Google, Microsoft 365 und Zoom ",
          "intro_sub_label2": "Freigabe von buchbaren Terminen ",
          "intro_sub_label3": "einzelnes Meeting für einen oder mehrere Teilnehmer",
          "intro_sub_label4": "Automatisieren von E-Mail- und SMS-Erinnerungen und -Bestätigungen"
        },
        "zoom_clips_plus": {
          "features_tip": "Kurze Videobotschaften in hoher Qualität aufnehmen, bearbeiten und teilen.",
          "intro_label1": "Unbegrenzt Videos ohne Zeitbegrenzung erstellen",
          "intro_label2": "Nehmen Sie Ihren Bildschirm und Ihr Video zusammen oder separat auf.",
          "intro_label3": "Videos nach Bedarf schneiden und per Link freigeben",
          "intro_label4": "Erweiterte Funktionen nutzen, etwa Audiotranskripte und Statistiken",
          "explain_desc": "Clips Plus ist in Workplace Pro-, Business- und Enterprise-Abos enthalten. Die verschiedenen Merkmale der einzelnen Abos sehen Sie im Funktionsvergleich auf der Preisseite."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Erweiterte Event-Plattform mit robusten Registrierungs- und Networking-Funktionen. Hervorragend geeignet für virtuelle und hybride Erfahrungen.",
          "tooltip_content": "Unbegrenzte Webinare oder Events mit gewünschter Kapazität hosten",
          "intro_title": "Alles von Sessions",
          "intro_label1": "Stärkere Einbeziehung des Publikums durch Events mit mehreren Sitzungen",
          "intro_label2": "Einfaches Event-Hosting mit maßgeschneidertem Ticketing und mobiler App",
          "intro_label3": "Höherer Umsatz aus Events durch Messefläche und Sponsorenbereich",
          "intro_label4": "Mehr Networking von Teilnehmern durch anpassbare Profile",
          "intro_label5": "On-Demand-Video in der Event-Lobby für mehr Reichweite",
          "intro_label6": "Schnellere Eventeinrichtung dank Vorlagen",
          "events_feature_item1_20240827": "Organisieren Sie mehrtägige, mehrgleisige virtuelle Events",
          "events_feature_item2_20240827": "Über Teilnehmerprofile und Lobby-Chat das Netzwerken fördern",
          "events_feature_item3_20240827": "Teilnehmer über Sitzungsstreaming in der Lobby orientieren",
          "events_feature_item4_20240827": "Höherer Umsatz aus Events durch Messeflächen und Sponsorenbereich",
          "events_feature_item5_20240827": "Zukünftige Events durch Umfragen nach der Konferenz verbessern",
          "events_feature_item6_20240827": "Schnellere Eventeinrichtung dank Vorlagen",
          "attendees_start_at": "{0} Teilnehmer ab",
          "explain_desc": "Zoom Events entdecken",
          "contact_account_owner": "Wenn Sie Events kaufen möchten, <a href=\"/account\" target=\"_blank\">kontaktieren Sie Ihren Kontoinhaber</a>.",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Optimieren Sie Ihre interaktiven Einzelsitzungs-Events mit Funktionen wie Event-Branding, Zusammenarbeit mehrerer Hosts und Event-Verwaltung.",
          "tooltip_content": "Unbegrenzte Webinare oder Events mit gewünschter Kapazität hosten",
          "intro_title": "Beinhaltet Zoom Webinars",
          "intro_label1": "Event-Landing Page für effektives Branding personalisieren",
          "intro_label2": "Events mit Branding-E-Mails befördern",
          "intro_label3": "Performance mit einem interaktiven Dashboard messen",
          "intro_label4": "nahtlos kollaborativ mit Co-Hosts und Co-Editors arbeiten",
          "intro_label5": "Professionelle Event-Tools: Simulive",
          "sessions_feature_item1_20240827": "Bessere Webinare durch benutzerdefinierte Szenen und Branding",
          "sessions_feature_item2_20240827": "AI Companion generiert Nachrichten und Bilder und vereinfacht damit die Eventplanung",
          "sessions_feature_item3_20240827": "Vergangene und zukünftige Events in gebrandetem Content-Hub bewerben",
          "sessions_feature_item4_20240827": "Professionelle Events mit Backstage, Simulive und RTMP",
          "sessions_feature_item5_20240827": "Zukünftige Webinare durch eventübergreifenden Analysen verbessern",
          "explain_desc": "Zoom Sessions entdecken",
          "contact_account_owner": "Wenn Sie Sessions kaufen möchten, <a href=\"/account\" target=\"_blank\">kontaktieren Sie Ihren Kontoinhaber</a>.",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Videowebinar",
          "features_tip": "Übertragen Sie mühelos Informationen über eine benutzerfreundliche Webinarplattform.",
          "tooltip_content": "Unbegrenzte Webinare oder Events mit gewünschter Kapazität hosten",
          "intro_label1": "Einbindung des Publikums durch Video-Webcasting in hoher Qualität",
          "intro_label2": "Steigern Sie die Einbindung durch Fragen und Antworten, Umfragen und Reaktionen.",
          "intro_label3": "Bessere Webinar-Strategie mit Berichten nach dem Event",
          "intro_label4": "Unterstützen Sie bis zu 100.000 Teilnehmer und 100 Diskussionsteilnehmer.",
          "monthly_subscription": "Monatsabo",
          "annual_subscription": "Jahresabo",
          "one_million": "1 Million",
          "single_use": "Einzelevent",
          "one_month": "Ein Monat",
          "event_attendee": "Events/Sessions-Teilnehmer:",
          "event_attendee_desc": "Alle Personen, die beitreten, ohne ein lizenzierter Host auf dem Hub zu sein. Auch spezielle Rollen zählen zu den Teilnehmern und können mit Audio, Video und Bildschirmfreigabe teilnehmen (sofern aktiviert).",
          "webinar_attendee": "Webinars-Teilnehmer:",
          "webinar_attendee_desc": "Alle Personen, die beitreten, aber weder Host noch Diskussionsteilnehmer sind. Sie können das Webinar nur ansehen und werden vom Host gesteuert, der ihre Stummschaltung aufheben und die Interaktion per F&A und Chat ermöglichen kann.",
          "pay_per_attendee": "Bezahlung pro Teilnehmer",
          "attendees": "Zuschauer"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Mit unserer KI-gestützten Komplettlösung für kollaboratives Arbeiten auf einer Plattform können Sie Teamwork neu gestalten.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Hosten Sie unbegrenzt Meetings bis zu 30 Stunden mit bis zu 100 Teilnehmern.",
          "intro_label2": "Bis zu 3 gleichzeitig bearbeitbare Whiteboards mit Standardfunktionen nutzen",
          "intro_label3": "Nehmen Sie mit Clips Plus kurze Videobotschaften in hoher Qualität auf, die Sie bearbeiten und teilen können.",
          "intro_label4": "Erledigen Sie mit Zoom AI Companion Ihre Arbeit effizienter.",
          "intro_label5": "Zoom Phone USA & Kanada unbegrenzt (BYOC, PBX und externe PBX ausgenommen).",
          "intro_label6": "Hosten Sie unbegrenzt Meetings bis zu 30 Stunden mit bis zu 300 Teilnehmern.",
          "intro_label7": "mit Zoom Scheduler Meetingtermine für Sprechzeiten, Vorstellungsgespräche und vieles mehr bekannt geben",
          "intro_label8": "Zoom Phone USA und Kanada unbegrenzt",
          "intro_label8_UK": "Zoom Phone Vereinigtes Königreich & Irland unbegrenzt",
          "intro_label8_AU": "Zoom Phone Australien und Neuseeland unbegrenzt",
          "intro_label8_JP": "Zoom Phone Japan unbegrenzt",
          "intro_label9": "Besucherverwaltung",
          "intro_label10": "Zusätzliche Funktionen",
          "intro_label11": "Live-Chat-Support",
          "intro_title1": "Alles in Pro und außerdem:",
          "intro_title2": "Alles in Business und außerdem:",
          "intro_label_tip1": "Bei Zoom Phone in Pro Plus sind BYOC-, externe PBX- und VDI-Funktionen nicht enthalten. Weitere Informationen finden Sie auf der Preisseite von Zoom Phone.",
          "intro_label_tip2": "Beim Kaufabschluss können Sie eine Telefon-Inlandsflat für die USA und Kanada, Australien und Neuseeland, das Vereinigte Königreich und Irland oder Japan auswählen.",
          "intro_label_tip3": "Zu den zusätzlichen Funktionen zählen 10 GB Cloud-Speicher, übersetzte Untertitel und Arbeitsplatzreservierung.",
          "intro_label_tip4": "Bei Zoom Phone in Pro Plus sind BYOC-, externe PBX- und VDI-Funktionen nicht enthalten. Weitere Informationen finden Sie auf der Preisseite von Zoom Phone."
        },
        "power_pack": {
          "title": "Powerpack für Zoom Phone",
          "features_tip": "Erweiterte Analysen von Anrufwarteschleifen und Erkenntnisse über den Verlauf für Callcenter-Teams",
          "intro_label1": "Erweitertes Kontakte-Fenster zum besseren Umgang mit Anrufen",
          "intro_label2": "Telefonnummern für die automatische Rufannahme und die Anrufwarteschleife"
        },
        "international_calling": {
          "title": "Telefonflat international",
          "features_tip": "Unbegrenzte internationale Anrufe in über 15 Länder und Regionen.",
          "intro_label1": "Kann mit allen unbegrenzten Tarifen gekauft werden",
          "intro_label2": "Sehen Sie sich unsere Liste der Länder und Regionen an, in die Sie unbegrenzt international anrufen können.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "Liste ansehen"
        },
        "workspace_reservation": {
          "title": "Arbeitsplatzreservierung",
          "intro_title": "Mit Zoom-fähigen Geräten reservieren Sie problemlos flexible Arbeitsbereiche oder buchen Hotelzimmer im Voraus oder vor Ort.",
          "intro_label1": "Zugriff auf Arbeitsplatz- und Hotelreservierungen über Zoom Workplace-App, Desktopversion oder Browser",
          "intro_label2": "Personalisierte, KI-gestützte Empfehlungen für Arbeitsbereiche",
          "intro_label3": "Reservieren von Arbeitsplätzen direkt über Google Kalender oder Outlook, mit Erinnerungen und Warnhinweisen zum Einchecken",
          "intro_label4": "Wegbeschreibung zum reservierten Arbeitsplatz"
        },
        "visitor_management": {
          "title": "Besucherverwaltung",
          "intro_title": "Optimieren Sie das Einchecken von Besuchern mit personalisierten Einladungen, mühelosem Kiosk-Check-in, Berichten und Metriken.",
          "intro_label1": "Verwalten von Einladungen, Besucherstandorten und Besuchsverlauf im Zoom-Portal",
          "intro_label2": "Einladungen erstellen, verfolgen, erneut senden und löschen und gleichzeitig Benachrichtigungen über die Ankunft von Gästen erhalten",
          "intro_label3": "Ausfüllen von Formularen, Abrufen von Wegbeschreibungen und Einchecken über den Kiosk für einen reibungslosen Besuchsablauf",
          "intro_label4": "Zugriff auf alle Funktionen über das vertraute Zoom-Portal zur einfachen Verwaltung"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Erhöhen Sie die Meetingkapazität auf bis zu 1000 interaktive Live-Teilnehmer.",
          "description2": "Alle Teilnehmer können mit Audio, Video und die Bildschirmfreigabe nutzen."
        },
        "cloud_storage": {
          "title": "Cloud-Speicher",
          "description2": "MP4 oder M4A Dateiformate verfügbar"
        },
        "translated_captions": {
          "title": "Übersetzte Untertitel",
          "description1": "Werten Sie Meetings auf – durch automatische, mehrsprachige Untertitel, mit denen Teilnehmer eine unterstützte Sprache aktivieren und zu dieser wechseln können.",
          "description2": "Verfügbar bei Zoom Meetings und Webinars"
        },
        "tollfree": {
          "title": "Audiokonferenzen",
          "subcontent": "Einwahl in Meetings mit Telefonnummern aus aller Welt",
          "description1": "Erweiterte Anrufoptionen mit ausgehenden Anrufen, globaler gebührenfreier Einwahl sowie lokaler Einwahl für Premium-Länder",
          "description2": "Kostenfreie Anrufe für Teilnehmer auf jedem Gerät",
          "description3": "Mühelos ein oder mehrere Länder für gebührenfreie Anrufe auswählen"
        },
        "rc": {
          "title": "Konferenzraum-Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentinien",
        "Australia": "Australien",
        "Austria": "Österreich",
        "Belgium": "Belgien",
        "Brazil": "Brasilien",
        "Bulgaria": "Bulgarien",
        "Canada": "Kanada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Kolumbien",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Kroatien",
        "Cyprus": "Zypern",
        "Czech_Republic": "Tschechische Republik",
        "Denmark": "Dänemark",
        "Ecuador": "Ecuador",
        "Estonia": "Estland",
        "Finland": "Finnland",
        "France": "Frankreich",
        "Germany": "Deutschland",
        "Greece": "Griechenland",
        "Hong_Kong_SAR": "Sonderverwaltungszone Hongkong",
        "Hungary": "Ungarn",
        "Ireland": "Irland",
        "Israel": "Israel",
        "Italy": "Italien",
        "Japan": "Japan",
        "Latvia": "Lettland",
        "Lithuania": "Litauen",
        "Luxembourg": "Luxemburg",
        "Mexico": "Mexiko",
        "Netherlands": "Niederlande",
        "New_Zealand": "Neuseeland",
        "Norway": "Norwegen",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Polen",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Rumänien",
        "Singapore": "Singapur",
        "Slovakia": "Slowakei",
        "Slovenia": "Slowenien",
        "South_Africa": "Südafrika",
        "Spain": "Spanien",
        "Sweden": "Schweden",
        "Switzerland": "Schweiz",
        "UK": "Vereinigtes Königreich",
        "United_Kingdom": "Vereinigtes Königreich",
        "US": "USA",
        "United_States": "Vereinigte Staaten",
        "title": "Rufnummernanforderungen",
        "subtitle": "Bitte wählen Sie das Land aus, in dem Ihre Global Select-Rufnummer aktiviert werden soll.",
        "selector_tip": "Land auswählen",
        "local_and_toll_free": "Lokale und gebührenfreie Nummern sind in {0} verfügbar.",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "„Plan Global“ beinhaltet pro Lizenz eine Rufnummer und unbegrenzte Inlandsgespräche innerhalb des gewählten Landes.",
        "avail_title": "Verfügbare Länder/Gebiete"
      },
      "tax_exempt_ecm": {
        "title": "Status zur Umsatzsteuerbefreiung",
        "status_exempt": "Steuerbefreit",
        "status_exempt_question": "Steuerbefreiung?",
        "verify_now": "Jetzt verifizieren",
        "can_after_checkout": "Optional kann dieser Schritt nach dem Checkout abgeschlossen werden.",
        "status": {
          "exempt": "Befreit",
          "pending": "Ausstehend",
          "pendingTooltip": "Ihr Status zur Umsatzsteuerbefreiung wird gerade überprüft. Es kann sein, dass Ihnen bei der Bestellung Steuern in Rechnung gestellt werden. Sollte Ihre Umsatzsteuerbefreiung genehmigt werden, schreiben wir Ihrem Konto alle erstattungsfähigen Steuern/Gebühren gut.",
          "nonexempt": "Nicht befreit",
          "rejected": "Abgelehnt",
          "rejectedTooltip": "Das eingereichte Dokument erfüllt nicht die Anforderungen für Ihre Gerichtsbarkeit.",
          "approved": "Genehmigt",
          "default": "Standard"
        },
        "confirm_close": {
          "new_desc": "Wenn Sie die Verifizierung abbrechen, können Ihnen anfallende Steuern/Gebühren in Rechnung gestellt werden. Sie können den Nachweis der Steuerbefreiung nach dem Kauf weiterhin unter „Abrechnungsverwaltung“ zur Überprüfung und Genehmigung durch Zoom einreichen. Nach der Validierung wird eine Rückerstattung für alle erhobenen Steuern gewährt.",
          "desc": "Sind Sie sicher, dass Sie die Überprüfung der Steuerbefreiung abbrechen und als steuerpflichtig fortfahren möchten?",
          "title": "Sind Sie sicher?",
          "new_title": "Verifizierung der Steuerbefreiung abbrechen?",
          "yes": "Ja, aufgeben",
          "no": "Nein, fortfahren",
          "abandon": "Verifizierung abbrechen",
          "go_back": "Zurück"
        },
        "confirm_to_add": {
          "title": "Neue Standardbefreiung bestätigen",
          "message": "Wenn Sie eine neue Steuerbefreiung hinzufügen, wird diese automatisch als Standard festgelegt, sobald sie genehmigt oder abgelehnt wurde. Sie können nur eine Standardbefreiung haben, die für zukünftige Käufe gilt. Ihr Steuerbetrag kann beeinflusst werden, wenn Ihre Standardbefreiung nicht mit dem Bundesland / der Region „Verkauft an“ übereinstimmt.",
          "yes": "Neue Steuerbefreiung hinzufügen"
        },
        "confirm_set_default": {
          "title": "Angaben stimmen nicht überein",
          "message": "Ihre Adresse bei „Verkauft an Kontakt“ stimmt nicht mit dem Bundesland / der Region überein, die Sie für die Steuerbefreiung ausgewählt haben. Aktualisieren Sie Ihre „Verkauft an Kontakt“-Adresse, damit sie mit dem Ort der Steuerbefreiung übereinstimmt. Andernfalls ist Ihr Kauf möglicherweise nicht steuerfrei.",
          "yes": "Trotzdem als Standard festlegen",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Bundesland/Region",
          "exemption_type": "Art der Steuerbefreiung",
          "signed_date": "Datum der Unterzeichnung",
          "status": "Status",
          "add_exemption": "Steuerbefreiung hinzufügen",
          "view": "Anzeigen",
          "set_as_default": "Als Standard festlegen"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Ihr Abo von {planName} endet am {date} um 00:00 Uhr koordinierter Weltzeit. Wenn Sie nach dem Ablaufdatum weiterhin hosten möchten, reaktivieren Sie bitte Ihr Abo.",
        "pairPreDescTip": "Ihre Abos von {planName1} und {planName2} enden am {date} um 00:00 Uhr koordinierter Weltzeit. Wenn Sie nach dem Ablaufdatum weiterhin hosten möchten, reaktivieren Sie bitte Ihre Abos.",
        "pairDiffDatePreDescTip": "Ihr Abo von {planName1} endet am {date1} um 00:00 Uhr koordinierter Weltzeit, Ihr Abo von {planName2} am {date2} um 00:00 Uhr koordinierter Weltzeit. Wenn Sie nach dem Ablaufdatum weiterhin hosten möchten, reaktivieren Sie bitte Ihre Abos.",
        "title": "Abo reaktivieren, um fortzufahren",
        "titles": "Abos reaktivieren, um fortzufahren",
        "plan": "Abo",
        "licenses": "Lizenz(en)",
        "billingCycle": "Abrechnungszyklus",
        "effective_date": "Gültigkeitsdatum",
        "invoice_amount": "Rechnungsbetrag",
        "singleDescTip": "Durch die Reaktivierung erklären Sie sich damit einverstanden, dass Ihr Abo automatisch am {date} verlängert und Ihre hinterlegte Zahlungsmethode für jeden Verlängerungszeitraum belastet wird. Um zukünftige Abbuchungen zu vermeiden, <a target=\"_blank\" href=\"https://support.zoom.com/hc/de/article?id=zm_kb&sysparm_article=KB0066687\">kündigen</a> Sie Ihr Abo mindestens einen Tag vor dem Verlängerungsdatum.",
        "pairDescTip": "Durch die Reaktivierung erklären Sie sich damit einverstanden, dass Ihre Abos automatisch am {date} verlängert werden. Ihre hinterlegte Zahlungsmethode wird für jeden Verlängerungszeitraum belastet. Um zukünftige Abbuchungen zu vermeiden, <a target=\"_blank\" href=\"https://support.zoom.com/hc/de/article?id=zm_kb&sysparm_article=KB0066687\">kündigen</a> Sie Ihr Abo mindestens einen Tag vor dem Verlängerungsdatum.",
        "pairDiffDateDescTip": "Durch die Reaktivierung erklären Sie sich damit einverstanden, dass Ihre Abos automatisch am {date1} und {date2} verlängert werden. Ihre hinterlegte Zahlungsmethode wird für jeden Verlängerungszeitraum belastet. Um zukünftige Abbuchungen zu vermeiden, <a target=\"_blank\" href=\"https://support.zoom.com/hc/de/article?id=zm_kb&sysparm_article=KB0066687\">kündigen</a> Sie Ihr Abo mindestens einen Tag vor dem Verlängerungsdatum.",
        "totalLabel": "Gesamtbetrag",
        "totalContent": "{money} zzgl. Steuern",
        "taxDesc": "ohne MwSt., GST oder ähnliche Steuern",
        "reactivateBtn": "Fortfahren und reaktivieren",
        "switchTitle": "Abo aktualisieren, um fortzufahren",
        "successSingleTip": "Ihr Abo von {planName} wurde reaktiviert",
        "successPairTip": "Ihr Abo von {planName1} und {planName2} wurde reaktiviert",
        "switchTip": "Ihr einmonatiges Abo von Zoom Webinars endet am {date}. Wenn Sie nach diesem Zeitpunkt ein Webinar hosten möchten, müssen Sie auf ein Abonnement umsteigen.",
        "switchBtn": "Zum Abo wechseln"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Datenblatt herunterladen"
      },
      "one": {
        "new": "NEU"
      }
    },
    "webinarSetupInWebPortal": "Webinareinrichtung im Web-Portal",
    "concurrentEvents": "Gleichzeitig stattfindende Events",
    "coucurrentEventsToolTip": "<span>Mit einem <b>Abonnement</b> können Sie immer nur ein Live-Event veranstalten.",
    "overages": "Mehrnutzung",
    "eventsPlatformHubs": "Hubs auf der Events-Plattform",
    "eventsHubToolTip": "In den <b>Hubs</b> von Zoom Events lassen sich Events bequem organisieren.",
    "1HubPerLicense": "1 Hub pro Lizenz",
    "1000Hubs": "1000 Hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Hosts auf der Events-Plattform (ab 500 Teilnehmern)",
    "eventsHost500": "<span><b>Hub-Hosts</b> von Zoom Events können erstellen",
    "5HubHosts": "5 Hub-Hosts",
    "100HubHosts": "100 Hub-Hosts",
    "eventsPlatformHosts_100Attendees": "Hosts auf der Events-Plattform (100 Teilnehmer)",
    "eventsHost100": "<span><b>Hub-Hosts</b> von Zoom Events können erstellen",
    "2HubHosts": "2 Hub-Hosts",
    "howAreTheyDifferent": "Was unterscheidet sie?",
    "allPlansRequireAZoomOneLicense": "* Für alle Abos ist eine Zoom Workplace-Lizenz erforderlich.",
    "subscription": "Abonnement",
    "subscriptionToolTip": "<span>Mit einem <b>Abonnement</b> können Sie beliebig viele Events mit der von Ihnen gewählten Kapazität hosten.</span>",
    "payPerAttendee": "Bezahlung pro Teilnehmer",
    "ppaToolTips": "<span>Die <b>Pay-per-Attendee</b>-Lizenz bestimmt, wie viele Teilnehmer insgesamt an allen Events Ihres Kontos innerhalb eines Zeitraums von 12 Monaten nach dem Kauf teilnehmen können.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Umfragen",
    "meetings.fullPlanItem2": "Anzahl der Lizenzen",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Vereinfachte Videokonferenzen und Nachrichtenübermittlung über alle Geräte",
    "meetings.fullPlanItem5": "Meetingdauer",
    "meetings.fullPlanItem5Tip": "Die maximal erlaubte Dauer eines Gruppenmeetings (3 oder mehr Teilnehmer).",
    "meetings.fullPlanItem5_basic": "40 Minuten",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 Stunden",
    "meetings.fullPlanItem5_biz": "30 Stunden",
    "meetings.fullPlanItem5_ent": "30 Stunden",
    "meetings.fullPlanItem1": "Teilnehmerkapazit\u00E4t",
    "meetings.fullPlanItem1Tip": "Ein Teilnehmer ist eine Person, die zu einem Meeting eingeladen ist, das von jemandem mit einer Meeting-Lizenz geplant wurde. Teilnehmer k\u00F6nnen per Telefon, Desktop, Mobiltelefon und Tablet kostenfrei an Ihrem Meeting teilnehmen. Teilnehmer ben\u00F6tigen kein Zoom Konto, um an einem Meeting teilzunehmen. Jedes Abo hat eine Teilnehmerbegrenzung. Benutzer mit kostenpflichtigen Abos k\u00F6nnen diese Begrenzung durch den Kauf eines Add-ons erh\u00F6hen.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1.000 bei Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Aufzeichnung",
    "meetings.fullPlanItem7Tip": "Die lokale Aufzeichnung von Zoom speichert Ihre Meeting-Aufzeichnungen in den Formaten MP4 (Video), M4A (Audio) und txt (Chat).<br>Die Zoom Cloud-Aufzeichnung speichert Meetings in der Zoom Cloud, wo Sie die Dateien herunterladen und/oder von einem Browser aus streamen k\u00F6nnen.",
    "meetings.fullPlanItem7_basic": "Lokal",
    "meetings.fullPlanItem7_pro": "Lokal und 5\u00A0GB Cloud (pro Lizenz)",
    "meetings.fullPlanItem7_biz": "Lokal und 10\u00A0GB Cloud (pro Lizenz)",
    "meetings.fullPlanItem7_ent": "Lokaler und unbegrenzter Cloudspeicher",
    "one.messaging": "Nachrichten",
    "meetings.fullPlanItem16Tip": "Mit Chat k\u00F6nnen Sie m\u00FChelos Gruppentexte, Dateien, Bildschirmaufnahmen, Codeausschnitte, Sprachnachrichten und Bilder senden. Text kann formattiert werden und Benutzer k\u00F6nnen au\u00DFerdem GIFs und Emojis freigeben. Die Anwesenheitsanzeige gibt an, ob Chatteilnehmer am Desktop oder an Mobilger\u00E4ten aktiv oder in Meetings besch\u00E4ftigt sind.",
    "meetings.fullPlanItem51": "Zoom-Whiteboards",
    "meetings.unlimited": "Unbegrenzt",
    "meetings.fullPlanItem_EssentialApp": "Grundlegende Apps",
    "common.learnMore": "Weitere Informationen",
    "meetings.fullPlanItem_EssentialAppText": "Premium-Apps 1 Jahr lang kostenlos (es gelten die Angebotsbedingungen)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail und Calender in der Zoom App",
    "mailService": "E-Mail-Dienst",
    "emailServiceWithFullTimeEndToEnd": "E-Mail-Service mit Vollzeit-End-to-End-Verschlüsselung für verbesserten Datenschutz",
    "customMailDomain": "Benutzerdefinierte Mail-Domäne",
    "customMailDomainWithMailService": "Benutzerdefinierte Mail-Domäne mit E-Mail-Service",
    "calendarClient": "Kalender-Anwendung",
    "scheduleAndJoinMeetings": "In der Zoom App Meetings planen und beitreten",
    "aiCompanion": "AI Companion",
    "calendarService": "Kalenderdienst",
    "meetingSchedulingAndAppointment": "Meeting-Planung und Terminbuchung",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Kurzvideos können mühelos erstellt, bearbeitet und geteilt werden. Die gespeicherten Clips sind problemlos abrufbar und fördern dadurch die Einbindung.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes beinhaltet einen leistungsstarken Dokumenteneditor zum eigenständigen und kollaborativen Arbeiten. Er bietet umfangreiche Formatierungsoptionen und ist in Meetings und außerhalb davon nutzbar.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Übersetzte Untertitel",
    "workspaceReservation": "Workspace-Reservierung",
    "accessAcrossAnyDevice": "Zugriff auf jedem Gerät",
    "meetings.fullPlanItem4": "Unbegrenzte Meetings",
    "meetings.fullPlanItem9": "Telefoneinwahl",
    "meetings.fullPlanItem9Tip": "Nehmen Sie an einem Zoom Meeting via Telekonferenz/Audiokonferenz teil (mithilfe eines Festnetztelefons). Benutzern werden die Geb\u00FChren entsprechend ihrem Telefonabonnement in Rechnung gestellt. Testen Sie unser Audiokonferenz-Add-on f\u00FCr geb\u00FChrenfreie Einwahlnummern.",
    "meetings.fullPlanItem9_pro": "Geb\u00FChrenpflichtig",
    "meetings.fullPlanItem9_biz": "Geb\u00FChrenpflichtig",
    "meetings.fullPlanItem9_ent": "Geb\u00FChrenpflichtig",
    "meetings.fullPlanItem11": "Bildschirmfreigabe",
    "meetings.fullPlanItem11Tip": "Desktop- und Anwendungsfreigabe. Lizenzierte Meeting-Benutzer haben die M\u00F6glichkeit, w\u00E4hrend eines von ihnen veranstalteten Meetings mehreren Teilnehmern gleichzeitig die Bildschirmfreigabe zu erlauben.",
    "meetings.fullPlanItem12": "Breakout-R\u00E4ume",
    "meetings.fullPlanItem12Tip": "Mit Video-Breakout-R\u00E4umen k\u00F6nnen Sie Ihr Zoom Meeting f\u00FCr Diskussionen, Projekte usw. in bis zu 50 Einzelsitzungen aufsplitten.",
    "meetings.fullPlanItem14": "Virtueller Hintergrund",
    "meetings.fullPlanItem15": "Pers\u00F6nliche Meeting-ID",
    "meetings.fullPlanItem15Tip": "Erstellen Sie Ihren eigenen permanenten Meetingraum. Sie k\u00F6nnen dieses Meeting jederzeit starten oder einen zuk\u00FCnftigen Termin planen.",
    "meetings.fullPlanItem17": "Host-Bedienelemente",
    "meetings.fullPlanItem18": "Gemeinsame Anmerkungen in der Bildschirmfreigabe",
    "meetings.fullPlanItem19": "Fernbedienung per Tastatur oder Maus",
    "meetings.fullPlanItem21": "Mehrfachfreigabe",
    "meetings.fullPlanItem29": "Warteraum",
    "meetings.fullPlanItem29Tip": "Mit der Funktion \u201EWarteraum\u201C erh\u00E4lt der Host die Kontrolle dar\u00FCber, wann ein Teilnehmer dem Meeting beitritt. Als Host eines Meetings k\u00F6nnen Sie Teilnehmer nacheinander oder alle gleichzeitig einlassen. In den Einstellungen k\u00F6nnen Sie ausw\u00E4hlen, wer in den Warteraum geleitet oder automatisch eingelassen wird. Jedes Konto verf\u00FCgt \u00FCber die Funktion Warteraum. Hosts k\u00F6nnen Nachrichten an den Warteraum senden. Sie k\u00F6nnen den Warteraum anpassen, wenn Sie ein kostenpflichtiges Abo haben.",
    "meetings.fullPlanItem41": "Integriert in Zoom for Home Ger\u00E4te",
    "meetings.fullPlanItem61": "Mehrere Personen anheften",
    "meetings.fullPlanItem61Tip": "Der Host kann bis zu neun Personen die M\u00F6glichkeit gew\u00E4hren, durch das Anheften von Videos eine eigene, benutzerdefinierte Ansicht zu erstellen. Die angeheften Videos bleiben unabh\u00E4ngig davon, wer gerade spricht, [f\u00FCr den jeweiligen Benutzer] sichtbar.",
    "meetings.fullPlanItem62": "Mehrere Personen ins Spotlight stellen",
    "meetings.fullPlanItem62Tip": "Der Host kann die Videos von bis zu neun Teilnehmern ins Spotlight stellen, sodass die Spotlight-Videos unabh\u00E4ngig davon, wer gerade spricht, dem ganzen Meeting angezeigt werden.",
    "meetings.fullPlanNewItem1": "Filter",
    "meetings.fullPlanNewItem1Tip": "Bringen Sie Happy Hours, Parties und andere Gelegenheiten mit lustigen Farbfiltern oder dekorativen Tierstickern in Schwung.",
    "meetings.fullPlanNewItem2": "Umfragen",
    "meetings.fullPlanNewItem3": "Co-Host und alternativer Host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/de/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Erfahren Sie mehr \u00FCber unsere Bedienelemente des Co-Hosts in einem Meeting.</a>",
    "meetings.fullPlanItem24": "Meeting Scheduler zuweisen",
    "meetings.fullPlanItem24Tip": "Erm\u00F6glicht es Ihnen, einer anderen Person das Recht zuzuweisen, f\u00FCr Sie Meetings zu erstellen. Diese Person muss ebenfalls \u00FCber ein Pro-Abo verf\u00FCgen.",
    "meetings.fullPlanItem25": "REST-API",
    "meetings.fullPlanItem25Tip": "Gew\u00E4hrt Kontoinhabern, Admins und Ihren Entwicklern sicheren Zugriff auf Zoom REST API.API Ratenbegrenzungen werden auf der Kontoebene \u00FCbernommen je nach Kontotyp (Pro, Business, Enterprise usw. \u2026) und angefordertem API-Typ (leicht, mittel, schwer usw. \u2026) Bei manchen APIs ist der Zugriff auf bestimmte Kontotypen beschr\u00E4nkt. Ausf\u00FChrliche Informationen finden Sie in API Ratenbegrenzungen und der API-Referenzdokumentation.",
    "meetings.fullPlanItem25_pro": "Pro REST API Ratenbegrenzungen",
    "meetings.fullPlanItem25_biz": "REST API Ratenbegrenzungen",
    "meetings.fullPlanItem26": "Skype for Business (Lync) Interoperabilit\u00E4t",
    "meetings.fullPlanItem26Tip": "Erm\u00F6glicht Benutzern von Lync 2010, 2013 und Skype for Business, ein Zoom Meeting von der Lync-Kontaktliste aus zu initiieren.",
    "meetings.fullPlanItem27": "Streamen",
    "meetings.fullPlanItem27Tip": "Livestreamen Sie auf Facebook, YouTube oder einem Drittanbieterdienst.",
    "meetings.fullPlanItem28": "Berichterstellung",
    "meetings.fullPlanItem28Tip": "Whiteboard-Nutzung von Sitzungen speichern",
    "meetings.fullPlanItem30": "Benutzerverwaltung",
    "meetings.fullPlanItem30Tip": "Benutzer und Admins k\u00F6nnen Rollen und Add-on-Funktionen hinzuf\u00FCgen, l\u00F6schen und zuweisen.",
    "one.autoCaptions": "Automatische Untertitel",
    "meetings.fullPlanItem31": "Admin-Portal",
    "meetings.fullPlanItem31Tip": "Verwalten Sie alle Benutzer in Ihrem Unternehmen mit einem Konto f\u00FCr vereinfachte Abrechnungen, erweiterte Einstellungen zur Benutzerverwaltung und umfassende Einsicht in die Nutzung \u2013 all das im Zoom Admin-Portal.",
    "meetings.fullPlanItem32": "LTI-Integration",
    "meetings.fullPlanItem32Tip": "F\u00FCgen Sie einfach ein Meeting zu einer Kursaktivit\u00E4t hinzu und laden Sie die entsprechenden Lernenden aus Ihrem Lernmanagement-SDystem dazu ein (funktioniert mit Moodle, Canvas, Desire2Learn und Blackboard).",
    "meetings.fullPlanItem33": "Transkripte der Cloud-Aufzeichnung",
    "meetings.fullPlanItem33Tip": "Cloud-Aufzeichnungs--Transkripte sind Transkripte vom Audio eines Meetings oder Webinars, das Sie in der Cloud aufzeichnen. Bitte beachten Sie, dass diese Funktion zurzeit nur f\u00FCr die englische Sprache unterst\u00FCtzt wird. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Klicken Sie hier,</a> um mehr zu erfahren.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Versehen Sie Ihre personalisierte Seite, auf der Benutzer einem Meeting beitreten k\u00F6nnen, mit Ihrem Unternehmens-Branding. Erstellen Sie E-Mail-Vorlagen mit Ihrem Branding, um Einladungen an Teilnehmer zu verschicken.",
    "meetings.fullPlanItem35": "Verwaltete Dom\u00E4nen",
    "meetings.fullPlanItem35Tip": "Nutzen Sie die E-Mail-Dom\u00E4nen Ihres Unternehmens/Ihrer Universit\u00E4t, um automatisch Benutzer zu Ihrem Konto hinzuzuf\u00FCgen.",
    "meetings.fullPlanItem37": "Dolmetscher Funktion",
    "meetings.fullPlanItem37Tip": "Erm\u00F6glicht es dem Host, f\u00FCr Meetings und Webinare Dolmetscher zuzuweisen. Wenn das Meeting oder Webinar beginnt, kann der Host die Dolmetschfunktion starten, wodurch die Dolmetscher Zugriff auf ihre eigenen Audiokan\u00E4le erhalten. Teilnehmer k\u00F6nnen einen Audiokanal w\u00E4hlen, um die Sprache ihrer Wahl zu h\u00F6ren. Teilnehmer h\u00F6ren das verdolmetschte Audio und k\u00F6nnen entscheiden, ob sie den Originalton im Hintergrund h\u00F6ren m\u00F6chten.",
    "meetings.fullPlanItem39": "Gesch\u00E4ftsberichte f\u00FCr F\u00FChrungskr\u00E4fte",
    "meetings.fullPlanItem39Tip": "Detaillierte Trendeinf\u00FChrungsanalyse, ROI-Tracking, Produkt-Roadmap-Diskussionen.",
    "meetings.fullPlanNewItem4": "Beinhaltet Webinar 500",
    "one.translatedCations": "Übersetzte Untertitel",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direkt-, Kanal- oder Gruppen-Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Einfache Kommunikation über Nachrichten an eine Person, in kleinen Gruppen oder mit großen Teams",
    "messageAndFileHistory": "Nachrichten- und Dateiverlauf",
    "findPeopeChannelsAndFilesInSearch": "Nach Personen, Kanälen und Dateien suchen",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Finden Sie schnell Kontakte, Sofortnachrichten, Gruppenchats und Dateien und halten Sie das Wissen und die Informationen so immer griffbereit.",
    "applicationIntegrations": "Anwendungsintegrationen",
    "secureFileSharing": "Sichere Dateifreigabe",
    "enhanceCollaborationWithSeamlessFileSharing": "Verbesserte Zusammenarbeit durch nahtlose Dateiübertragung",
    "persistentMeetingChat": "Ständiger Meeting-Chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Sie behalten den Überblick in Meeting-internen Unterhaltungen. Sie können vor, während und nach einem Meeting im eigenen Gruppen-Chat im Zoom Team Chat mit allen Meeting-Teilnehmern kommunizieren.",
    "cloudStorage": "Cloud-Speicher",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Datensicherung der Kanäle in Zoom Cloud oder über einen dritten Speicheranbieter",
    "avatars": "Avatare",
    "inMeetingReactions": "Meetingreaktionen",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Nonverbale Interaktionen und schnelle Kommunikation mit anderen Teilnehmern",
    "virtualBackgrounds": "Virtuelle Hintergründe",
    "videoFilters": "Videofilter",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Mehr Spaß in Meetings durch verschiedene Filter für Ihr Video",
    "inMeetingPollsAndQuizzes": "Umfragen und Quiz für Meetings",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Sie können Single-Choice- oder Multiple-Choice-Fragen zu Ihren Meetings stellen.",
    "liveStreamingAcrossPlatforms": "Plattformübergreifendes Livestreaming",
    "appearanceTouchUp": "Erscheidungsbild überarbeiten",
    "originalSoundForMusicians": "Originalton für Musiker",
    "endToEndEncryptionForZoomMeetings": "End-to-End-Verschlüsselung für Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Wenn die End-to-End-Verschlüsselung (E2EE) für Zoom Meetings aktiviert ist, wird die Kommunikation zwischen allen Meeting-Teilnehmern mit Zoom-Clients eines bestimmten Meetings mit kryptografischen Schlüsseln verschlüsselt, die nur den Geräten dieser Teilnehmer bekannt sind. Das heißt, dass kein Dritter, auch nicht Zoom, Zugriff auf die privaten Schlüssel für das Meeting hat.",
    "zoomCustomerManagedKey": "Kundenseitig verwalteter Schlüssel von Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Schützen Sie ruhende Daten mit Ihren eigenen kryptografischen Schlüssel.",
    "enterpriseGradeSecurityFeatures": "Sicherheitsfunktionen auf Enterprise-Niveau",
    "256BitAesGcmEncryptionForRealTimeContent": "256-Bit-AES-GCM-Verschlüsselung für Echtzeitinhalte und -medien, TLS-Verschlüsselung während der SIP-Registrierung, Maskierung der Anrufer-ID, Peering in privaten Netzwerken, Erkennung von Gebührenbetrug und Anrufsperrlisten.",
    "phone.fullPlanItem40": "Einmaliges Anmelden via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unbegrenzte interne Anrufe",
    "phone.fullPlanItem2": "Geb\u00FChrenpflichtige ausgehende Anrufe",
    "phone.fullPlanItem3": "Unbegrenzte ausgehende Anrufe",
    "phone.fullPlanItem4": "Branchenf\u00FChrende HD-Anruf-Technologie",
    "phone.fullPlanItem4Tip": "Mit aktiver Rauschunterdr\u00FCckung, Echounterdr\u00FCckung und Tippger\u00E4uschunterdr\u00FCckung",
    "phone.fullPlanItem5": "Native Windows-, MacOS- und Linux-Desktop-Apps",
    "phone.fullPlanItem6": "Native Apps f\u00FCr Mobilger\u00E4te mit iOS und Android",
    "phone.fullPlanItem7": "Portierung bestehender Nummer oder Kauf neuer Nummern (DDI)",
    "phone.fullPlanItem8": "Geb\u00FChrenfreie Telefonnummern",
    "phone.fullPlanItem9": "Durchwahlnummer",
    "phone.fullPlanItem10": "Sprachnachrichten mit Transkription",
    "phone.fullPlanItem10Tip": "Zugang zu Sprachnachrichten-Transkription via Mobiltelefon-/Desktop-Apps und E-Mail",
    "phone.fullPlanItem11": "Unbegrenzte automatisierte Teilnehmer/IVR",
    "phone.fullPlanItem12": "Verzeichnis f\u00FCr W\u00E4hlen nach Namen",
    "phone.fullPlanItem13": "Automatische Anrufverteilungsgruppen (ACD) mit Anrufwarteschleife",
    "phone.fullPlanItem14": "Gespr\u00E4chseingriff/Mith\u00F6ren/Fl\u00FCstern/\u00DCbernahme",
    "phone.fullPlanItem15": "Feiertags- und Gesch\u00E4ftszeiten-Rufumleitung",
    "phone.fullPlanItem16": "3-Wege-Ad-hoc-Konferenzschaltungen",
    "phone.fullPlanItem17": "Gespr\u00E4chsaufzeichnung",
    "phone.fullPlanItem17Tip": "Automatische und manuelle Gespr\u00E4chsaufzeichnung sind verf\u00FCgbar.",
    "phone.fullPlanItem18": "Konfigurierbare Anrufsperre f\u00FCr anonyme oder spezifische Anrufe",
    "phone.fullPlanItem19": "Notrufe",
    "phone.fullPlanItem19Tip": "Rufen Sie lokale Notfalldienste an",
    "phone.fullPlanItem20": "Nomadischer Notfalldienst E911 (USA und Kanada) -",
    "phone.fullPlanItem20Tip": "Dynamische Erkennung des Benutzerstandorts und Mitteilung der entsprechenden Notfalladresse an die lokalen Notfalldienste (nur USA und Kanada) sowie an das interne Safety-Team",
    "phone.fullPlanItem21": "Notrufzentrale",
    "phone.fullPlanItem21Tip": "Aktivieren Sie die Benachrichtigung Ihres internen Safety-Teams bei Notrufen und helfen Sie bei der Beantwortung des Notrufs, indem Sie diesen aufzeichnen/mith\u00F6ren/aufnehmen.",
    "phone.fullPlanItem22": "Teamschaltung/Delegierung",
    "phone.fullPlanItem23": "Rufweiterleitung zwischen Ger\u00E4ten",
    "phone.fullPlanItem24": "Parken von Anrufen",
    "endToEndEncryptionForZoomPhone": "End-to-End-Verschlüsselung für Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Wenn die End-to-End-Verschlüsselung (E2EE) für Zoom Phone aktiviert ist, verschlüsselt sie den Anruf mithilfe von kryptografischen Schlüsseln, die nur den Geräten des Anrufers und des Empfängers bekannt sind. Zudem können Benutzer den E2EE-Status überprüfen, indem sie sich gegenseitig einen eindeutigen Sicherheitscode bereitstellen.",
    "phone.fullPlanItem43": "Zero Touch Provisioning von Telefonen",
    "phone.fullPlanItem44": "Verschiedene Abo-Typen innerhalb eines Kontos",
    "phone.fullPlanItem46": "Echtzeit-Berichte und Qualit\u00E4ts-Dashboards",
    "phone.fullPlanItem47": "Support f\u00FCr virtuelle Desktop-Umgebungen (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">Erfahren Sie mehr</a> \u00FCber VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Für alle Telefonie-Einzelkunden verfügbar Supporttarife variieren je nach Kombination mit einem Meeting-Abo",
    "phone.fullPlanItem49": "Unterst\u00FCtzung von \u201EBringen Sie Ihren eigenen Netzbetreiber\u201C (BYOC)",
    "phone.fullPlanItem49Tip": "Unterst\u00FCtzung f\u00FCr direktes und standortbasiertes Peering zu Ihrem bestehenden PSTN-Anbieter",
    "phone.fullPlanItem50": "Hybrid-Integration in bestehende PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online-Fax",
    "phone.fullPlanItem61Tip": "Senden und empfangen Sie unbegrenzt Faxe innerhalb der USA und Kanadas. Für internationale Faxe können Sie die jeweils geltenden <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF; \">Tarife anzeigen</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Nur verf\u00FCgbar f\u00FCr Nummern aus den USA und Kanada im Rahmen eines Telefonvertrags. Verf\u00FCgbar f\u00FCr die Nutzung mit Durchwahlnummern (nicht mit Firmennummern).",
    "meetings.fullPlanItem6": "Technischer Support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Nur Ticket",
    "meetings.fullPlanItem6_pro": "Ticket und Live-Chat",
    "meetings.fullPlanItem6_biz": "Ticket, Live-Chat und Telefon",
    "meetings.fullPlanItem6_ent": "Ticket, Live-Chat und Telefon",
    "knowledgeBase": "Wissensdatenbank",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Beheben Sie technische Probleme und greifen sie auf Support-Ressourcen zu, indem Sie unsere Wissensdatenbankartikel durchsuchen.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Ein Ort, um Lösungen zu finden, Fragen zu stellen und mit anderen Zoom Benutzern zusammenzuarbeiten.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Erhalten Sie Antworten auf Fragen und beheben Sie technische Probleme, indem Sie mit unserem Chatbot interagieren.",
    "submitWebTickets": "Webtickets übermitteln",
    "liveChatSupport": "Live-Chat-Support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Abo-Modelle über {amount} USD/Monat",
    "livePhoneSupport": "Live-Telefon-Support",
    "meetWithAgentOnVideo": "Video-Meeting mit Agent",
    "subscriptionPlansGreaterThan_200UsdMonth": "Abo-Modelle über 200 USD/Monat",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Mehr Produktivität durch Einsatz Ihrer Lieblings-App direkt in Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Selbstgestaltete Avatare für Spaß in Meetings und dynamische Präsentation, ohne dass Video aktiviert sein muss",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "E-Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Bis zu 30 Stunden pro Meeting",
    "common.statistics.participants": "{0} Teilnehmer",
    "common.per_meeting_unit": "pro Meeting",
    "common.participant_limit.increase_with_large_meetings": "Noch mehr mit Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unbegrenzt",
    "common.plans.team_chat.title": "Team-Chat",
    "common.plans.mail_calendar.title": "Mail und Kalender",
    "common.plans.cloud_storage.title": "Cloud-Speicher",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Übersetzte Untertitel bei Zoom",
    "common.plans.extras.title": "Extra",
    "common.plans.extras.desc": "Unternehmensdomänen verwalten und vieles mehr",
    "zoom_one_edu_bundle.school.title": "Zoom One für das Bildungswesen: Schule und Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One für das Bildungswesen: Schule und Campus Plus",
    "per_billing_cycle_license.monthly": "/Monat/Lizenz",
    "per_billing_cycle_license.yearly": "/Jahr/Lizenz",
    "per_billing_cycle_space.monthly": "/Monat/Bereich",
    "per_billing_cycle_space.yearly": "/Jahr/Bereich",
    "common.dialog.feature_list": "Siehe Liste aller Funktionen",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB Cloud pro Lizenz",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB pro Lizenz",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus beinhaltet Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (Verhältnis 1:25)",
    "plans.whiteboard.ent": "Enterprise Plus beinhaltet Unlimited Plus",
    "plans.zp.ent": "In Enterprise Plus enthalten",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Arbeitsplatzreservierung vor Ort und erweitert und vieles mehr",
    "plans.largeMeeting.intro_tip": "„Large Meeting“ ist ein optionales Add-on beim Kaufabschluss, mit dem Sie je nach erworbener Lizenz Meetings für bis zu 500 bzw. 1000 Teilnehmer hosten können.",
    "common.participant_limit.expandable_with_large_meetings": "Erweiterbar mit Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1.000 bei Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus beinhaltet Sessions 1000 (inklusive Webinars)",
    "per_billing_cycle_user.monthly": "/Monat/Benutzer",
    "per_billing_cycle_user.annually": "/Jahr/Benutzer",
    "closeComparisonChart": "Vergleichstabelle schließen",
    "archiving_api": "Archivierungs-API",
    "dlp_api": "DLP-API",
    "info_barriers": "Info-Barrieren",
    "chat_etiquette": "Chat-Etikette",
    "gdrp": "DSGVO",
    "regiona_data_centers": "Regionale Rechenzentren",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Standardmäßige Verschlüsselung",
    "end_to_end_encryption": "Ende-zu-Ende-Verschlüsselung",
    "cryptographic_boundary": "Kryptographische Grenze",
    "vdi": "Virtueller Desktop (VDI)",
    "customer_managed_key": "Von Kunden verwalteter Schlüssel",
    "gpo_msi_policies": "GPO/MSI-Richtlinien",
    "msi": "Massenbereitstellung (MSI)",
    "ntt": "Netzwerk-Testtool (NTT)",
    "dashboards": "Dashboard",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Ausfallsicherung von Zoom Phone",
    "zoom_meeting_survivability": "Ausfallsicherung von Zoom Meetings",
    "paid_option": "Kostenpflichtige Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Wichtigste Funktionen",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Schule und Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Schule und Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "es-ES": {
    "billing.essential_apps": "Aplicaciones Esenciales",
    "billing.essential_apps.dialog_desc": "Haga crecer y gestione su negocio con aplicaciones que toman notas en las reuniones, fomentan la participación de su equipo con actividades interactivas y ofrecen información para mejorar las conversaciones con los clientes. Aplicaciones premium gratuitas incluidas en su plan durante 1 año.",
    "billing.see_more_details": "Ver más detalles",
    "billing.essential_app.legal_copy": "Oferta válida solo para usuarios con una licencia actual, a partir del 4 de enero de 2023, con una suscripción a Zoom One Pro, Comercial o Empresarial Plus, que se compra a través del canal en línea de Zoom en zoom.us/buy. Los usuarios cuya suscripción esté asociada a una cuenta de Atención médica, Educación o Gobierno no pueden optar por esta oferta.  El acceso a cada aplicación, con la excepción de Coda, comienza en el momento en el que el usuario individual activa la aplicación y caduca 1 año después. El acceso a Coda para todos los usuarios en la misma cuenta de Zoom comienza cuando cualquier usuario de la misma cuenta de Zoom realiza la primera activación de Coda y caduca para todos los usuarios de esa cuenta de Zoom 1 año después, independientemente de la fecha inicial de activación de los usuarios posteriores en la misma cuenta de Zoom.Para todas las aplicaciones, la reasignación o la cancelación de la licencia o de la suscripción de un usuario finalizará el acceso para ese usuario, independientemente de si aún resta tiempo en el período de acceso de 1 año.Cada aplicación está sujeta a sus términos de uso y política de privacidad disponibles en el momento de la activación.Las aplicaciones incluidas solo están disponibles en inglés.No todas las aplicaciones funcionan en dispositivos móviles.La oferta no es reembolsable ni se puede canjear por dinero en efectivo.La oferta solo se aplica a las aplicaciones mencionadas como incluidas en las <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Aplicaciones esenciales de Zoom App Marketplace</a>. Los usuarios que ya estén suscritos a alguna de las aplicaciones no podrán optar por esta oferta con respecto a esas aplicaciones concretas.Zoom se reserva el derecho de modificar o cancelar esta oferta en cualquier momento sin previo aviso ni responsabilidad.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Administración de visitantes"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Asistencia por teléfono y chat en directo 24/7"
      },
      "learn_more": "M\u00E1s informaci\u00F3n",
      "new": "NOVEDAD",
      "plan_details": {
        "meeting": {
          "title": "Reuniones",
          "host_meeting_up_to_participants": "Alberga hasta {0} participantes",
          "meeting_hours": "Número ilimitado de reuniones de hasta 30 horas por reunión",
          "recording_storage": "{0} GB de almacenamiento de grabaciones en la nube (por licencia)",
          "auto_captions": "Subtítulos automatizados"
        },
        "whiteboard": {
          "title": "Pizarra",
          "boards_storage": "{0} pizarras editables",
          "standard_features": "Características estándar"
        },
        "team_chat": {
          "title": "Chat en equipo",
          "desc": "Chat de grupo y uso compartido de archivos"
        },
        "main_calendar": {
          "title": "Correo y Calendario",
          "desc": "Cliente y servicios de Correo y Calendario"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Cree y comparta documentos editables dentro de Zoom",
          "desc2": "Notas personales y colaborativas con edición de texto enriquecido"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Grabe, edite y comparta fácilmente vídeos cortos",
          "desc2": "Vídeos ilimitados y características avanzadas"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Acceda rápidamente a resúmenes de reuniones, ayuda para redactar mensajes y más"
        },
        "EssentialApp": {
          "title": "Aplicaciones Esenciales",
          "desc1": "Aplicaciones premium gratuitas durante 1 año (se aplican los términos)",
          "desc2": "Aumente la colaboración y la productividad del equipo"
        },
        "livechat": {
          "title": "Soporte para chat en directo"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "¿Desea cambiar a Zoom Workplace Pro?",
            "content": "Anteriormente seleccionó Zoom Workplace Comercial, que permite hasta 300 participantes por reunión, Zoom Scheduler y más. ¿Todavía quiere cambiarse a Pro?",
            "confirm": "Confirmar el cambio",
            "keep_current": "Mantener el plan actual"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} espectadores",
          "participants": "{0} Participantes",
          "user_range": "{0} a {1} usuarios",
          "items": "{num} artículos"
        },
        "button": {
          "ok": "OK",
          "add": "Agregar",
          "buy_now": "Comprar ahora",
          "try_for_days": "Pruebe durante {0} días",
          "contact_sales": "Contactarse con ventas",
          "close": "Cerrar",
          "cancel": "Cancelar",
          "edit": "Editar",
          "got_it": "Lo tengo"
        },
        "title": {
          "everything_in_and": "Todo en {0} y:"
        },
        "tag": {
          "new": "NOVEDAD",
          "free_trial": "Prueba gratuita"
        },
        "billing_cycle": {
          "annual": "Anual",
          "monthly": "Mensual",
          "quarterly": "Trimestral",
          "two_years": "Cada dos años",
          "three_years": "Cada tres años"
        },
        "errors": {
          "unknown_error_try_again": "Error desconocido al procesar la transacción. Inténtelo de nuevo más tarde."
        },
        "excluding_tax": {
          "vat_tip": "sin IVA",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Características ilimitadas",
        "pro_plus": {
          "host_meeting_up_to_participants": "Alberga hasta {0} participantes",
          "gb_of_cloud_recording_storage": "{0} GB de almacenamiento para grabación en la nube (por licencia)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion para la generación de contenidos y traducciones",
            "features_item2": "Cantidad ilimitada de documentos que puede compartir con su equipo",
            "features_item3": "Acceda a un historial de versiones ilimitado",
            "comparison_table_tips": "Potencie la colaboración con documentos centrados en la IA que transforman el contenido de las reuniones en documentos procesables, wikis y proyectos"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Básico",
            "features_item1": "Detectar automáticamente las tareas de todas sus reuniones, llamadas telefónicas, chats y documentos.",
            "features_item2": "Obtener ayuda para completar tareas, como programar reuniones de seguimiento y redactar documentos.",
            "features_item3": "Marcar las tareas como finalizadas sin esfuerzo una vez que se hayan completado para mantenerse al tanto de su progreso y concentrarse en lo que viene.",
            "features_item4": "Administrar tareas en toda la plataforma Zoom Workplace, incluido Zoom Docs.",
            "features_item1_opc": "Aproveche el poder de AI Companion para identificar y crear tareas a partir de sus chats, correos electrónicos, documentos, pizarras y resúmenes de reuniones.",
            "features_item2_opc": "Ordene, filtre, agrupe y busque fácilmente para acceder rápidamente a sus tareas y reunir contexto sobre ellas.",
            "learn_more_header": "Manténgase al tanto de los elementos de acción con AI Companion* para hacer más cosas en Zoom Workplace.",
            "learn_more_footer": "\* AI Companion solo está disponible para los planes Zoom Workplace Pro, Comercial y Empresarial.",
            "features_prefix": "Permita que AI Companion le ayude mediante las siguientes acciones:",
            "comparison_table_tips": "Manténgase al tanto de los elementos de acción y complételos a tiempo con una solución centrada en la IA que proporciona recomendaciones de tareas en función de conversaciones y resúmenes de reuniones en Zoom Workplace.",
            "tasks_label_text": " Administración de tareas centrada en la IA"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contáctenos para obtener información acerca de los precios y más",
          "contact_sales": "Contacto con ventas",
          "meetings": "Reuniones",
          "phone": "Tel\u00E9fono",
          "phone_sub_title": "Llamadas ilimitadas",
          "use_only": "Solo para uso empresarial",
          "team_chat": {
            "title": "Chat en equipo",
            "title_desc": "Chat de grupo y uso compartido de archivos"
          },
          "cloud_storage": {
            "title": "Almacenamiento en la nube"
          },
          "mail_calender": {
            "title": "Correo y Calendario"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Cliente y servicio"
          },
          "up_to_30_hours_per_meeting": "hasta 30 horas por reunión",
          "300_attendees": "300 asistentes",
          "per_meeting": "por reunión",
          "whiteboard": {
            "title": "Pizarra"
          },
          "new": "NOVEDAD",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Adicionales",
          "sso_managed_domains_more": "SSO, dominios administrados y más",
          "scheduler": "Programador de agenda",
          "global_select": "Global Select",
          "unlimited_regional": "Llamadas regionales ilimitadas",
          "translated_captions": "Subtítulos traducidos",
          "workspace_reservation": "Reserva de espacio de trabajo",
          "auto_translated_captions": "Subtítulos automatizados y traducidos",
          "unlimited_editable_boards": "Pizarras editables ilimitadas",
          "standard_features": "Características estándar",
          "advanced_docu_controls": "Controles avanzados de documentos",
          "chats_channels_for_collaboration": "Chats y canales para colaboración, intercambio de archivos y más",
          "zoom_phone_is_biz_use_only": "Zoom Phone es solo para uso empresarial",
          "unlimited_regional_calling": "Llamadas regionales ilimitadas",
          "domestic_sms_mms": "SMS y MMS nacionales",
          "automatic_call_distribution_groups": "Grupos de distribuci\u00F3n autom\u00E1tica de llamadas (ACD) con cola de llamadas",
          "single_sign_on": "Inicio de sesi\u00F3n \u00FAnico",
          "managed_domains": "Dominios administrados",
          "company_branding": "Imagen de marca de la empresa",
          "mail_calender_client_services_beta": "Cliente y servicios de Correo y Calendario (Beta)",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Número ilimitado de reuniones de hasta 30 horas por reunión",
          "mail_and_calendar_client_and_services_beta": "Cliente y servicios de Correo y Calendario (Beta)",
          "easily_record_edit_share_videos": "Grabe, edite y comparta fácilmente vídeos cortos",
          "unlimited_videos_advanced_features": "Vídeos ilimitados y características avanzadas",
          "create_share_editabel_docu_within_zoom": "Cree y comparta documentos editables dentro de Zoom",
          "personal_collaborative_notes_rich_text_editing": "Notas personales y colaborativas con edición de texto enriquecido",
          "effortlessly_share_meeting": "Comparta fácilmente las franjas horarias de las reuniones para facilitar las reservas",
          "works_with_zoom_meeting_mail_calender_google_ms": "Funciona con Zoom Meetings, Zoom Mail y Zoom Calendar, Google y Microsoft 365",
          "up_to_300_attendees": "Hasta 300 asistentes",
          "10_gb_of_storage": "10 GB de almacenamiento",
          "host_meeting_up_to_300_participants": "Celebrar reuniones de hasta 300\u00A0participantes",
          "10_gb_of_cloud_recording_storage": "10 GB de almacenamiento de grabaciones en la nube (por licencia)",
          "starting_at_licenses_year": "Desde {1} licencias por {0}/a\u00F1o",
          "starting_at_licenses_month": "Desde {1} licencias por {0}/mes",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Acceda rápidamente a resúmenes de reuniones, ayuda para redactar mensajes y más",
          "learn_more": "M\u00E1s informaci\u00F3n",
          "essential_apps": "Aplicaciones Esenciales",
          "increase_team_collaboration": "Aumente la colaboración y la productividad del equipo",
          "free_premium_apps": "Aplicaciones premium gratuitas durante 1 año (se aplican los términos)",
          "visitor_management": "Administración de visitantes",
          "visitor_management_custom_invites": "Personalice las invitaciones.",
          "visitor_management_visitor_check": "Regístrese en un quiosco.",
          "visitor_management_receive_detailed": "Reciba métricas detalladas sobre el uso del espacio por parte de los visitantes."
        },
        "custom_avatar": {
          "title": "Avatar personalizado",
          "label_text": "3 minutos al mes",
          "basic_feature": "1 minuto de por vida",
          "pricing_feature": "3 minutos al mes",
          "learn_more_subtitle": "Cree, gracias a la IA, una versión realista de su persona con replicación de voz y comunicación multilingüe.",
          "features_item1": "Cree hasta 3 avatares digitales y realistas por mes que reproduzcan su aspecto y voz para presentaciones y demostraciones",
          "features_item2": "Utilice su avatar para ejecutar guiones de hasta 3 minutes de duración con AI Companion",
          "features_item3": "Elija entre 18 avatares prediseñados para crear vídeos rápidos y de alta calidad",
          "features_item4": "Disfrute del soporte de fondo virtual",
          "features_item1_opc": "Cree hasta 3 avatares digitales y realistas por mes que reproduzcan su aspecto y voz para presentaciones y demostraciones",
          "features_item2_opc": "Utilice su avatar para ejecutar guiones de hasta 3 minutes de duración con AI Companion",
          "comparison_table_tips": "El avatar personalizado crea una versión realista de su persona con replicación de voz y comunicación multilingüe."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Acceda rápidamente a resúmenes de reuniones, ayuda para redactar mensajes y más",
        "learn_more_dialog": {
          "desc": "¡Logre más con AI Companion! Puede escribir contenido, programar reuniones, ayudar a administrar sus proyectos y más.",
          "tip1": "Reciba una agenda con anticipación para organizar reuniones más efectivas",
          "tip2": "Mantenga sus proyectos al día con la creación automatizada de tareas y notificaciones",
          "tip3": "Obtenga ayuda para organizar su calendario y administrar su tiempo",
          "tip4": "Genere contenido escrito y visual que coincida con su estilo en Zoom Docs, Whiteboard o en la aplicación Zoom Workplace"
        },
        "top_features": "Características principales",
        "more_to_come": "Próximamente, más características increíbles.",
        "discover_more": "Descubra aún más formas de hacer su mejor trabajo con AI Companion.",
        "detail_desc": "AI Companion está incluido sin costo adicional con los servicios de pago de las cuentas de usuario de Zoom. Algunos sectores y zonas geográficas pueden quedar excluidos."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/año/licencia",
        "month_licnese": "/mes/licencia",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/mes",
          "per_year": "/año"
        },
        "unit": {
          "license": "{0}/licencia",
          "user": "{0}/usuario"
        },
        "learn_more": "Más información",
        "required": "Obligatorios",
        "zoom_one_required": "Se requiere Zoom Workplace.",
        "large": {
          "features_tip": "Amplíe su alcance con una mayor capacidad de hasta 1000 participantes.",
          "label_title1": "500 asistentes",
          "label_title2": "1000 asistentes"
        },
        "cmr": {
          "features_tip": "Almacene, transmita y descargue sus grabaciones de vídeo directamente desde la nube de Zoom.",
          "explain_desc": "El almacenamiento en la nube se incluye en determinados planes de Zoom One: Pro (5 GB), Comercial (5 GB), Comercial Plus (10 GB) y Empresarial (ilimitado).",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 horas",
          "option_label2": "≈ 650 horas",
          "option_label3": "≈ 3,500 horas",
          "option_label4": "≈ 17,500 horas",
          "intro_label2": "Las opciones de almacenamiento incluyen hasta 5 TB/mes",
          "tooltip_content": "El almacenamiento de grabaciones varía en función del número de participantes habilitados para vídeo, la resolución de la reunión y la resolución del contenido compartido."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Colabore en tiempo real con otros en las pizarras, tanto durante las reuniones como fuera de ellas.",
          "explain_desc": "Se incluye en Zoom One Comercial, Zoom One Empresarial Plus y Zoom One Empresarial",
          "explain_desc_plus": "Se incluye en Zoom One Empresarial Plus y con cada suscripción de Zoom Rooms",
          "option_label1": "Pizarras ilimitadas con 1 GB de almacenamiento en la nube",
          "option_label2": "Características avanzadas con pizarras ilimitadas y almacenamiento en la nube",
          "intro_label1": "Pizarras editables simultáneamente ilimitadas",
          "intro_label2": "Características estándar y control avanzado de documentos",
          "intro_label3": "Características avanzadas de pizarra, incluidas plantillas personalizadas y organizativas, e integraciones de terceros"
        },
        "translated_captions": {
          "features_tip": "Favorezca la colaboración global con subtítulos automatizados en su idioma preferido.",
          "intro_label1": "Los participantes pueden habilitar por sí mismos los subtítulos y cambiar de idioma.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Ver los idiomas compatibles"
        },
        "crc": {
          "features_tip": "Habilita cualquier punto de conexión de videoconferencia SIP/H.323 basado en estándares para un trabajo híbrido eficaz.",
          "intro_label1": "Funciona con muchos puntos de conexión existentes, incluidos los de Polycom, Cisco, Lifesize y otros",
          "intro_label2": "Conector de sala en la nube o local (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Simplifique las reservas con disponibilidad flexible y franjas horarias configurables",
          "host_one_on_one": "Organice reuniones individuales o grupales con un solo enlace para compartir fácilmente",
          "customize_reminders": "Personalice los recordatorios por correo electrónico o SMS para reducir las citas perdidas",
          "sync_calendars": "Sincronice calendarios con Google, Microsoft 365 e integraciones de Zoom",
          "features_tip": "Comparta fácilmente las franjas horarias de las reuniones para hora de consulta, entrevistas y mucho más.",
          "intro_label1": "Integración en calendarios",
          "intro_label2": "Disponibilidad recurrente",
          "intro_label3": "Reunión escalable",
          "intro_label4": "Notificaciones personalizables",
          "intro_sub_label1": "Google, Microsoft 365 y Zoom ",
          "intro_sub_label2": "compartir franjas horarias reservables ",
          "intro_sub_label3": "reunión única para uno o varios participantes",
          "intro_sub_label4": "automatizar recordatorios y confirmaciones por correo electrónico o SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Grabe, edite y comparta mensajes de vídeo breves y de alta calidad.",
          "intro_label1": "Cree vídeos ilimitados sin límites de tiempo",
          "intro_label2": "Capture la pantalla y el vídeo juntos o por separado",
          "intro_label3": "Recorte su vídeo según sea necesario y comparta el enlace",
          "intro_label4": "Acceda a características avanzadas, como transcripciones de audio y estadísticas",
          "explain_desc": "Clips Plus se incluye en las suscripciones de Workplace Pro, Comercial y Empresarial. Puede explorar las diferentes características de cada plan en la sección de comparación de la página de precios."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Plataforma avanzada de eventos con sólidas características de registro y establecimiento de contactos. Ideal tanto para experiencias virtuales como híbridas.",
          "tooltip_content": "Organice seminarios web o eventos ilimitados con la capacidad que elija",
          "intro_title": "Todo en Zoom Sessions",
          "intro_label1": "Aumente la participación de la audiencia con eventos de varias sesiones",
          "intro_label2": "Organice eventos fácilmente con emisión de entradas y una aplicación móvil personalizadas",
          "intro_label3": "Aumente los ingresos del evento con la Sala de la Expo y el Área de patrocinadores",
          "intro_label4": "Favorezca el establecimiento de contactos de los asistentes con perfiles personalizables",
          "intro_label5": "Amplíe el alcance con la visualización a petición en el lobby del evento",
          "intro_label6": "Acelere la configuración de eventos con plantillas de eventos seleccionadas",
          "events_feature_item1_20240827": "Organice eventos virtuales de varios días con múltiples pistas",
          "events_feature_item2_20240827": "Promueva el establecimiento de contactos con los perfiles de los asistentes y el chat del lobby",
          "events_feature_item3_20240827": "Guíe a los asistentes con la transmisión de la sesión del lobby",
          "events_feature_item4_20240827": "Aumente los ingresos del evento con la sala de la expo y los patrocinios",
          "events_feature_item5_20240827": "Mejore los eventos futuros con encuestas posteriores a la conferencia",
          "events_feature_item6_20240827": "Acelere la configuración de eventos con plantillas de eventos seleccionadas",
          "attendees_start_at": "{0} asistentes a partir de",
          "explain_desc": "Obtenga más información sobre Zoom Events",
          "contact_account_owner": "Si desea comprar Events, <a href=\"/account\" target=\"_blank\">póngase en contacto con el propietario de su cuenta</a>.",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Optimice los eventos interactivos de una sola sesión con características como imagen de marca del evento, colaboración de varios anfitriones y gestión de eventos.",
          "tooltip_content": "Organice seminarios web o eventos ilimitados con la capacidad que elija",
          "intro_title": "Incluye Zoom Webinars",
          "intro_label1": "Personalice las páginas de destino del evento para una imagen de marca eficaz",
          "intro_label2": "Promocione eventos con correos electrónicos personalizados con la marca",
          "intro_label3": "Mida el rendimiento con un panel de control interactivo",
          "intro_label4": "Colaboración optimizada con coanfitriones y coeditores",
          "intro_label5": "Herramientas de eventos profesionales: directo simulado",
          "sessions_feature_item1_20240827": "Mejore los seminarios web con escenas personalizadas e imagen de marca",
          "sessions_feature_item2_20240827": "Simplifique la planificación de eventos con AI Companion para generar mensajes e imágenes",
          "sessions_feature_item3_20240827": "Promueva eventos pasados y futuros en un hub de contenido con marca",
          "sessions_feature_item4_20240827": "Organice eventos profesionales con Backstage, directo simulado y RTMP",
          "sessions_feature_item5_20240827": "Mejore los seminarios web futuros con información de diferentes eventos",
          "explain_desc": "Obtenga más información sobre Zoom Sessions",
          "contact_account_owner": "Si desea comprar Sessions, <a href=\"/account\" target=\"_blank\">póngase en contacto con el propietario de su cuenta</a>.",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Seminarios web con vídeo",
          "features_tip": "Transmita mensajes sin complicaciones con una plataforma de seminarios web fácil de usar.",
          "tooltip_content": "Organice seminarios web o eventos ilimitados con la capacidad que elija",
          "intro_label1": "Atraiga a la audiencia con transmisión por web de vídeo de alta calidad",
          "intro_label2": "Impulse la participación con preguntas y respuestas, votaciones y reacciones",
          "intro_label3": "Mejore la estrategia de seminario web con informes después del evento",
          "intro_label4": "Admita hasta 100 000 asistentes y 100 panelistas",
          "monthly_subscription": "Suscripción mensual",
          "annual_subscription": "Suscripción anual",
          "one_million": "1 millón",
          "single_use": "Un solo uso",
          "one_month": "Un mes",
          "event_attendee": "Asistentes a eventos y sesiones:",
          "event_attendee_desc": "cualquier persona que se une sin ser un anfitrión con licencia en el hub. Los roles especiales también se cuentan como asistentes y pueden participar con audio, vídeo y uso compartido de pantalla (si está habilitado).",
          "webinar_attendee": "Asistentes a seminarios web:",
          "webinar_attendee_desc": "cualquier persona que se une, pero que no es anfitrión ni panelista. Está en modo de solo visualización y bajo el control del anfitrión, que puede reactivar el audio y permitir la interacción mediante P y R y chat.",
          "pay_per_attendee": "Pago por asistente",
          "attendees": "espectadores"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reinvente la forma de trabajar de sus equipos con una plataforma de colaboración con IA.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Comercial",
          "label_title4": "Workplace Comercial Plus",
          "intro_label1": "Organice reuniones ilimitadas de hasta 30 horas con un máximo de 100 participantes",
          "intro_label2": "Acceda a un máximo de 3 pizarras editables al mismo tiempo con características estándar.",
          "intro_label3": "Grabe, edite y comparta mensajes de vídeo breves y de alta calidad con Clips Plus",
          "intro_label4": "Trabaje de forma más eficiente con Zoom AI Companion",
          "intro_label5": "Zoom Phone EE. UU. y Canadá ilimitado (se excluyen BYOC, PBX y PBX de terceros)",
          "intro_label6": "Organice reuniones ilimitadas de hasta 30 horas con un máximo de 300 participantes",
          "intro_label7": "Comparta franjas horarias de las reuniones para hora de consulta, entrevistas y mucho más con Zoom Scheduler.",
          "intro_label8": "Zoom Phone EE. UU. y Canadá ilimitado",
          "intro_label8_UK": "Zoom Phone Reino Unido e Irlanda ilimitado",
          "intro_label8_AU": "Zoom Phone Australia y Nueva Zelanda ilimitado",
          "intro_label8_JP": "Zoom Phone Japón ilimitado",
          "intro_label9": "Administración de visitantes",
          "intro_label10": "Características adicionales",
          "intro_label11": "Soporte para chat en directo",
          "intro_title1": "Todo en el plan Pro y:",
          "intro_title2": "Todo en el plan Comercial y:",
          "intro_label_tip1": "Zoom Phone en Pro Plus no incluye las características BYOC, PBX de terceros ni VDI. Para obtener más información, consulte la página de precios de Zoom Phone.",
          "intro_label_tip2": "Al finalizar la compra, puede seleccionar llamadas regionales ilimitadas para EE. UU. y Canadá, Australia y Nueva Zelanda, Reino Unido e Irlanda o Japón.",
          "intro_label_tip3": "Otras características incluyen 10 GB de almacenamiento en la nube, subtítulos traducidos y reservas de espacio de trabajo.",
          "intro_label_tip4": "Zoom Phone en Pro Plus no incluye las características BYOC, PBX de terceros ni VDI. Para obtener más información, consulte la página de precios de Zoom Phone."
        },
        "power_pack": {
          "title": "Paquete avanzado de Zoom Phone",
          "features_tip": "Análisis mejorados de la cola de llamadas e información histórica para los equipos de centros de llamadas.",
          "intro_label1": "Erweitertes Kontakte-Fenster zum besseren Umgang mit Anrufen",
          "intro_label2": "Ventana de contactos ampliada para agilizar la gestión de las llamadas"
        },
        "international_calling": {
          "title": "Llamadas internacionales",
          "features_tip": "Llamadas internacionales ilimitadas a más de 15 países y regiones.",
          "intro_label1": "Se puede comprar con cualquier plan de llamadas ilimitadas",
          "intro_label2": "Explore nuestra lista de países y regiones compatibles con llamadas internacionales ilimitadas.",
          "intro_labe2_tooltip": "EE. UU., Canadá, Reino Unido, Irlanda, Australia, Nueva Zelanda, Austria, Dinamarca, Francia, Alemania, Italia, Portugal, España, Suecia, Bélgica, Países Bajos, Suiza, Puerto Rico, Japón.",
          "intro_label2_view_list": "Ver la lista"
        },
        "workspace_reservation": {
          "title": "Reservas de espacio de trabajo",
          "intro_title": "Reserve fácilmente espacios de trabajo flexibles o habitaciones de hotel, con antelación o en el sitio, con los dispositivos integrados en Zoom.",
          "intro_label1": "Acceda a las reservas de espacios de trabajo y hoteles a través de la aplicación Zoom Workplace, el escritorio o el navegador",
          "intro_label2": "Reciba recomendaciones de escritorio personalizadas con ayuda de la IA",
          "intro_label3": "Reserve espacios de trabajo directamente desde Google Calendar u Outlook, con recordatorios y alertas de registros de entrada",
          "intro_label4": "Acceda a los espacios de trabajo reservados mediante señalizaciones"
        },
        "visitor_management": {
          "title": "Administración de visitantes",
          "intro_title": "Optimice los registros de entrada de visitantes con invitaciones personalizadas, registros de entrada a través de un quiosco, informes y métricas.",
          "intro_label1": "Administre las invitaciones, la ubicación de los visitantes y el historial de visitas en el portal de Zoom",
          "intro_label2": "Cree, reenvíe, elimine y realice un seguimiento de invitaciones mientras recibe notificaciones de llegada de los invitados",
          "intro_label3": "Complete formularios, obtenga direcciones y registre su entrada a través de un quiosco para una experiencia de visitante fluida",
          "intro_label4": "Acceda a todas las características desde el portal de Zoom para una administración sencilla y familiar"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Reuniones grandes",
          "description1": "Aumente la capacidad de la reunión para admitir hasta 1000 participantes interactivos en directo",
          "description2": "Todos los participantes pueden compartir el audio, el vídeo y la pantalla."
        },
        "cloud_storage": {
          "title": "Almacenamiento en la nube",
          "description2": "Disponibles formatos de archivo MP4 o M4A"
        },
        "translated_captions": {
          "title": "Subtítulos traducidos",
          "description1": "Mejore las reuniones con subtítulos multilingües automáticos que les permiten a los participantes habilitar y cambiar a un idioma compatible",
          "description2": "Disponible en Zoom Meetings y Webinars"
        },
        "tollfree": {
          "title": "Conferencias de audio",
          "subcontent": "Marque para unirse a reuniones con números de teléfono de todo el mundo",
          "description1": "Amplíe sus opciones de llamada con hacer llamada, número sin cargo global y llamada local para países premium",
          "description2": "Sin costo para los participantes que llamen desde cualquier dispositivo",
          "description3": "Seleccione uno o varios países para llamadas sin cargo"
        },
        "rc": {
          "title": "Conector de salas de conferencias"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Bélgica",
        "Brazil": "Brasil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canadá",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croacia",
        "Cyprus": "Chipre",
        "Czech_Republic": "República Checa",
        "Denmark": "Dinamarca",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finlandia",
        "France": "Francia",
        "Germany": "Alemania",
        "Greece": "Grecia",
        "Hong_Kong_SAR": "Región Administrativa Especial de Hong Kong",
        "Hungary": "Hungría",
        "Ireland": "Irlanda",
        "Israel": "Israel",
        "Italy": "Italia",
        "Japan": "Japón",
        "Latvia": "Letonia",
        "Lithuania": "Lituania",
        "Luxembourg": "Luxemburgo",
        "Mexico": "México",
        "Netherlands": "Países Bajos",
        "New_Zealand": "Nueva Zelanda",
        "Norway": "Noruega",
        "Panama": "Panamá",
        "Peru": "Perú",
        "Poland": "Polonia",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Rumania",
        "Singapore": "Singapur",
        "Slovakia": "Eslovaquia",
        "Slovenia": "Eslovenia",
        "South_Africa": "Sudáfrica",
        "Spain": "España",
        "Sweden": "Suecia",
        "Switzerland": "Suiza",
        "UK": "Reino Unido",
        "United_Kingdom": "Reino Unido",
        "US": "US",
        "United_States": "Estados Unidos",
        "title": "Requisitos del número de teléfono",
        "subtitle": "Seleccione el país en el que se activará su número de teléfono del Plan Global.",
        "selector_tip": "Seleccionar país",
        "local_and_toll_free": "Los números locales y sin cargo están disponibles en {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "El Plan Global incluye un número de teléfono y llamadas nacionales ilimitadas dentro del país seleccionado por licencia.",
        "avail_title": "Países/territorios disponibles"
      },
      "tax_exempt_ecm": {
        "title": "Situación de exención fiscal",
        "status_exempt": "Exento de impuestos",
        "status_exempt_question": "¿Exento de impuestos?",
        "verify_now": "Verificar ahora",
        "can_after_checkout": "Como opción, este paso se puede completar después del pago.",
        "status": {
          "exempt": "Exento",
          "pending": "Pendiente",
          "pendingTooltip": "Su situación de exención fiscal está actualmente en revisión. Es posible que se le cobren impuestos al realizar un pedido. En caso de que se apruebe su exención, acreditaremos todos los impuestos o tarifas reembolsables en su cuenta.",
          "nonexempt": "No exento",
          "rejected": "Rechazada",
          "rejectedTooltip": "Se ha determinado que el documento presentado no cumple con los requisitos de su jurisdicción.",
          "approved": "Aprobada",
          "default": "predeterminado"
        },
        "confirm_close": {
          "new_desc": "Si abandona la verificación, es posible que se le cobren los impuestos o tarifas aplicables. Puede enviar su documento de exención fiscal en la sección Administración de facturación después de la compra para que Zoom lo revise y apruebe. Una vez validado, se emitirá un reembolso por los impuestos cobrados.",
          "desc": "¿Está seguro que desea abandonar la verificación de exención de impuestos y proceder como apto para impuestos?",
          "title": "¿Está seguro?",
          "new_title": "¿Desea abandonar la verificación de exención de impuestos?",
          "yes": "Sí, abandonar",
          "no": "No, continuar",
          "abandon": "Abandonar la verificación",
          "go_back": "Regresar"
        },
        "confirm_to_add": {
          "title": "Confirmar la nueva exención de impuestos predeterminada",
          "message": "Al agregar una nueva exención, se establecerá automáticamente como predeterminada cuando se apruebe o rechace. Solo puede tener una exención predeterminada, que se aplicará a compras futuras. El importe de sus impuestos podría verse afectado si su exención predeterminada no coincide con su estado o región del «Destinatario de venta».",
          "yes": "Añadir nueva exención"
        },
        "confirm_set_default": {
          "title": "La dirección y las exenciones fiscales no coinciden",
          "message": "Su dirección de «Contacto de venta» no coincide con el estado o la región que seleccionó para la exención de impuestos. Actualice su dirección de «Contacto de venta» para que coincida con la ubicación de su exención de impuestos. De lo contrario, es posible que su compra no esté exenta de impuestos.",
          "yes": "Establecer como predeterminado de todos modos",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Estado/región",
          "exemption_type": "Tipo de exención",
          "signed_date": "Fecha de firma",
          "status": "estado",
          "add_exemption": "Añadir exención",
          "view": "Ver",
          "set_as_default": "Establecer como predeterminado"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Su plan {planName} se cancelará el {date} a las 00:00 hora universal coordinada. Si desea ser anfitrión después de la fecha de cancelación, vuelva a activar su plan.",
        "pairPreDescTip": "Su plan {planName1} y su plan {planName2} se cancelarán el {date} a las 00:00 hora universal coordinada. Si desea ser anfitrión después de la fecha de cancelación, vuelva a activar sus planes.",
        "pairDiffDatePreDescTip": "Su plan {planName1} y su plan {planName2} se cancelarán el {date1} a las 00:00 hora universal coordinada y el {date2} a las 00:00 hora universal coordinada, respectivamente. Si desea ser anfitrión después de la fecha de cancelación, vuelva a activar sus planes.",
        "title": "Reactive su plan para continuar",
        "titles": "Reactive sus planes para continuar",
        "plan": "Plan",
        "licenses": "Licencia(s)",
        "billingCycle": "Ciclo de facturación",
        "effective_date": "Fecha de inicio",
        "invoice_amount": "Monto de factura",
        "singleDescTip": "Al reactivarlo, acepta que su plan recurrente se renueve automáticamente el {date}, y que se cargue a su método de pago registrado cada periodo de renovación. Para evitar cargos futuros, <a target=\"_blank\" href=\"https://support.zoom.com/hc/es/article?id=zm_kb&sysparm_article=KB0066687\">puede cancelar</a> un día antes de la fecha de renovación.",
        "pairDescTip": "Al reactivarlos, acepta que sus planes recurrentes se renueven automáticamente el {date}. Cada periodo de renovación se cargará a su método de pago registrado. Para evitar cargos futuros, <a target=\"_blank\" href=\"https://support.zoom.com/hc/es/article?id=zm_kb&sysparm_article=KB0066687\">puede cancelar</a> un día antes de la fecha de renovación.",
        "pairDiffDateDescTip": "Al reactivarlos, acepta que sus planes recurrentes se renovarán automáticamente el {date1} y el {date2}. Cada periodo de renovación se cargará a su método de pago registrado. Para evitar cargos futuros, <a target=\"_blank\" href=\"https://support.zoom.com/hc/es/article?id=zm_kb&sysparm_article=KB0066687\">puede cancelar</a> un día antes de la fecha de renovación.",
        "totalLabel": "Total",
        "totalContent": "{money} más impuestos aplicables",
        "taxDesc": "sin IVA, GST o impuestos similares",
        "reactivateBtn": "Proceder y reactivar",
        "switchTitle": "Actualice su plan para continuar",
        "successSingleTip": "Su plan {planName} se ha reactivado",
        "successPairTip": "Su plan {planName1} y {planName2} se ha reactivado",
        "switchTip": "Su plan de Webinars de un mes de Zoom caduca el {date}. Para organizar un seminario web pasada esta fecha, deberá cambiar a una suscripción.",
        "switchBtn": "Cambiar a suscripción"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Comercial"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Descargar la hoja de datos"
      },
      "one": {
        "new": "NOVEDAD"
      }
    },
    "webinarSetupInWebPortal": "Configuración del seminario web en el portal web",
    "concurrentEvents": "Eventos simultáneos",
    "coucurrentEventsToolTip": "<span>Un plan de <b>suscripción</b> admite un evento en directo a la vez",
    "overages": "Cargos por exceso de uso",
    "eventsPlatformHubs": "Hubs de la plataforma de eventos",
    "eventsHubToolTip": "Los <b>hubs</b> de Zoom Events ofrecen una organización de eventos práctica",
    "1HubPerLicense": "1 hub por licencia",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Anfitriones de la plataforma de eventos (500 asistentes o más)",
    "eventsHost500": "<span>Los <b>anfitriones de hubs</b> de Zoom Events pueden crear",
    "5HubHosts": "5 anfitriones de hubs",
    "100HubHosts": "100 anfitriones de hubs",
    "eventsPlatformHosts_100Attendees": "Anfitriones de la plataforma de eventos (100 asistentes)",
    "eventsHost100": "<span>Los <b>anfitriones de hubs</b> de Zoom Events pueden crear",
    "2HubHosts": "2 anfitriones de hubs",
    "howAreTheyDifferent": "¿En qué se diferencian?",
    "allPlansRequireAZoomOneLicense": "*Todos los planes requieren una licencia Zoom Workplace",
    "subscription": "Suscripción",
    "subscriptionToolTip": "<span>Una <b>suscripción</b> le permite organizar un número ilimitado de eventos con la capacidad que elija.</span>",
    "payPerAttendee": "Pago por asistente",
    "ppaToolTips": "<span>La licencia de <b>pago por asistente</b> determina cuántos asistentes en total pueden asistir a todos sus eventos de su cuenta dentro de un período de 12 meses a partir de la compra.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Votaciones",
    "meetings.fullPlanItem2": "N\u00FAmero de licencias",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom One",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Videoconferencias y mensajería simplificadas con cualquier dispositivo",
    "meetings.fullPlanItem5": "Duraci\u00F3n de las reuniones",
    "meetings.fullPlanItem5Tip": "La duraci\u00F3n m\u00E1xima permitida por reuni\u00F3n de grupo (3 o m\u00E1s participantes).",
    "meetings.fullPlanItem5_basic": "40\u00A0min",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30\u00A0horas",
    "meetings.fullPlanItem5_biz": "30\u00A0horas",
    "meetings.fullPlanItem5_ent": "30\u00A0horas",
    "meetings.fullPlanItem1": "Capacidad de participantes",
    "meetings.fullPlanItem1Tip": "Un participante es un invitado en una reuni\u00F3n programada por alguien con una licencia de reuni\u00F3n. Los participantes pueden unirse a una reuni\u00F3n de forma gratuita desde sus tel\u00E9fonos, equipos de escritorio, dispositivos m\u00F3viles y tabletas. No es necesario que un participante tenga una cuenta de Zoom para unirse a una reuni\u00F3n. Cada plan tiene un l\u00EDmite de participantes, pero los usuarios pueden aumentar este l\u00EDmite en los planes de pago comprando un complemento.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1000 para Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Grabaci\u00F3n",
    "meetings.fullPlanItem7Tip": "La grabaci\u00F3n local de Zoom guarda las grabaciones de su reuni\u00F3n en los formatos MP4 (v\u00EDdeo), M4A (audio) y txt (chat). <br>La grabaci\u00F3n de la nube de Zoom almacena las reuniones en la nube de Zoom, donde el archivo puede descargarse y/o transmitirse desde un navegador.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local y nube de 5\u00A0GB (por licencia)",
    "meetings.fullPlanItem7_biz": "Local y nube de 10\u00A0GB (por licencia)",
    "meetings.fullPlanItem7_ent": "Local y nube ilimitada",
    "one.messaging": "Mensajería, mensajes",
    "meetings.fullPlanItem16Tip": "El Chat permite enviar f\u00E1cilmente texto de grupo, archivos, capturas de pantalla, fragmentos de c\u00F3digo, mensajes de voz e im\u00E1genes. El texto se puede formatear y los usuarios pueden compartir GIF y tambi\u00E9n emojis. Las pantallas de presencia muestran si los participantes del chat est\u00E1n activos desde dispositivos m\u00F3viles o de escritorio, o si est\u00E1n ocupados en reuniones.",
    "meetings.fullPlanItem51": "Pizarras de Zoom",
    "meetings.unlimited": "Ilimitado",
    "meetings.fullPlanItem_EssentialApp": "Aplicaciones Esenciales",
    "common.learnMore": "M\u00E1s informaci\u00F3n",
    "meetings.fullPlanItem_EssentialAppText": "Aplicaciones premium gratuitas durante 1 año (se aplican los términos)",
    "zoomMailAndCalendarInTheZoomApp": "Correo y Calendario de Zoom en la aplicación",
    "mailService": "Servicio de correo",
    "emailServiceWithFullTimeEndToEnd": "Servicio de correo electrónico con cifrado de extremo a extremo de tiempo completo para una mayor privacidad",
    "customMailDomain": "Dominio de correo personalizado",
    "customMailDomainWithMailService": "Dominio de correo personalizado con servicio de correo",
    "calendarClient": "Cliente de Calendario",
    "scheduleAndJoinMeetings": "Programar y unirse a reuniones en la aplicación Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Servicio de calendario",
    "meetingSchedulingAndAppointment": "Programación de reuniones y reserva de citas",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Cree, edite y comparta vídeos cortos fácilmente. Los clips almacenados se pueden descubrir fácilmente, lo que aumenta la participación.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes ofrece un sólido editor de documentos personales y colaborativos con amplias opciones de formato y accesibilidad tanto dentro como fuera de las reuniones.",
    "common.phoneTab": "Zoom\u00A0Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Subtítulos traducidos",
    "workspaceReservation": "Reserva de espacio de trabajo",
    "accessAcrossAnyDevice": "Acceda desde cualquier dispositivo",
    "meetings.fullPlanItem4": "Reuniones ilimitadas",
    "meetings.fullPlanItem9": "Marcaci\u00F3n telef\u00F3nica",
    "meetings.fullPlanItem9Tip": "\u00DAnase a una reuni\u00F3n de Zoom por teleconferencia/conferencia de audio (con un tel\u00E9fono tradicional). Se cobrar\u00E1 a los usuarios de acuerdo con su plan telef\u00F3nico. Pruebe nuestro complemento de conferencias de audio para tener n\u00FAmeros de marcaci\u00F3n sin cargo.",
    "meetings.fullPlanItem9_pro": "De pago",
    "meetings.fullPlanItem9_biz": "De pago",
    "meetings.fullPlanItem9_ent": "De pago",
    "meetings.fullPlanItem11": "Uso compartido de pantallas",
    "meetings.fullPlanItem11Tip": "Uso compartido de escritorio y aplicaciones. Los usuarios con licencia de reuni\u00F3n pueden elegir permitir que varios participantes compartan sus pantallas simult\u00E1neamente durante la celebraci\u00F3n de una reuni\u00F3n.",
    "meetings.fullPlanItem12": "Salas para grupos peque\u00F1os",
    "meetings.fullPlanItem12Tip": "Las salas de v\u00EDdeo para grupos peque\u00F1os le permiten dividir su reuni\u00F3n de Zoom en un m\u00E1ximo de 50\u00A0sesiones para hacer debates, proyectos y mucho m\u00E1s.",
    "meetings.fullPlanItem14": "Fondo virtual",
    "meetings.fullPlanItem15": "ID personal de la reuni\u00F3n",
    "meetings.fullPlanItem15Tip": "Cree su propia sala de reuniones permanente en l\u00EDnea. Puede comenzar una reuni\u00F3n en cualquier momento o programarla para su uso en el futuro.",
    "meetings.fullPlanItem17": "Controles de anfitri\u00F3n",
    "meetings.fullPlanItem18": "Anotaci\u00F3n conjunta en pantalla compartida",
    "meetings.fullPlanItem19": "Control remoto de teclado y rat\u00F3n",
    "meetings.fullPlanItem21": "Uso compartido",
    "meetings.fullPlanItem29": "Sala de espera",
    "meetings.fullPlanItem29Tip": "La funci\u00F3n de sala de espera permite al anfitri\u00F3n controlar el momento en que los participantes acceden a la reuni\u00F3n. Como anfitri\u00F3n de la reuni\u00F3n, puede admitir a los asistentes de uno en uno a los asistentes o todos a la vez. En la configuraci\u00F3n, puede elegir a qui\u00E9n se pone en la sala de espera o a qui\u00E9n se admite autom\u00E1ticamente. Todas las cuentas tienen la funci\u00F3n de sala de espera. Los anfitriones pueden enviar mensajes a la sala de espera. Puede personalizar la sala de espera si tiene un plan de pago.",
    "meetings.fullPlanItem41": "Integrado en dispositivos Zoom for Home",
    "meetings.fullPlanItem61": "Fijar a varias personas",
    "meetings.fullPlanItem61Tip": "El anfitri\u00F3n puede conceder a un m\u00E1ximo de 9\u00A0personas la capacidad de fijar v\u00EDdeos para crear su propia vista personalizada. De este modo, los v\u00EDdeos fijados permanecen visibles independientemente de qui\u00E9n hable.",
    "meetings.fullPlanItem62": "Destacar a varias personas",
    "meetings.fullPlanItem62Tip": "El anfitri\u00F3n puede destacar hasta 9\u00A0v\u00EDdeos de asistentes, de modo no importa\u00A0 quien hable, todos los asistentes ven los v\u00EDdeos destacados.",
    "meetings.fullPlanNewItem1": "Filtros",
    "meetings.fullPlanNewItem1Tip": "Aporte m\u00E1s diversi\u00F3n a las horas felices, fiestas y m\u00E1s con divertidos filtros de color o pegatinas decorativas de animales.",
    "meetings.fullPlanNewItem2": "Votaciones",
    "meetings.fullPlanNewItem3": "Coanfitri\u00F3n y anfitri\u00F3n alternativo",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/es/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">M\u00E1s informaci\u00F3n acerca de nuestros controles de coanfitri\u00F3n para reuniones.</a>",
    "meetings.fullPlanItem24": "Asignar programador de reuniones",
    "meetings.fullPlanItem24Tip": "Le permite asignar a otra persona para que organice sus reuniones por usted. La persona asignada tambi\u00E9n debe tener un plan Pro.",
    "meetings.fullPlanItem25": "API REST",
    "meetings.fullPlanItem25Tip": "Permite el acceso seguro a la API REST de Zoom a propietarios de cuentas, administradores y sus desarrolladores.Se aplican l\u00EDmites de tarifa de API en el nivel de cuenta seg\u00FAn el tipo de cuenta (Pro, Business, Enterprise, etc\u2026) y el tipo de solicitud de API (ligera, media, intensa, etc\u2026). Algunas API tienen acceso limitado para tipos de cuenta espec\u00EDficos. Utilice los l\u00EDmites de tarifa de API y la documentaci\u00F3n de referencia para API para ver los detalles al completo.",
    "meetings.fullPlanItem25_pro": "L\u00EDmites de tarifa de API REST Pro",
    "meetings.fullPlanItem25_biz": "L\u00EDmites de tarifa de API REST",
    "meetings.fullPlanItem26": "Interoperabilidad de Skype Empresarial (Lync)",
    "meetings.fullPlanItem26Tip": "Permite a los usuarios de Lync 2010, 2013 y usuarios de Skype Empresarial iniciar una reuni\u00F3n de Zoom desde la lista de contactos de Lync.",
    "meetings.fullPlanItem27": "Transmisi\u00F3n",
    "meetings.fullPlanItem27Tip": "Transmita en directo a Facebook, Youtube o a un servicio de terceros.",
    "meetings.fullPlanItem28": "Informes",
    "meetings.fullPlanItem28Tip": "Guarde las sesiones de pizarra",
    "meetings.fullPlanItem30": "Administraci\u00F3n de usuarios",
    "meetings.fullPlanItem30Tip": "Los propietarios pueden agregar, eliminar y asignar roles y caracter\u00EDsticas complementarias.",
    "one.autoCaptions": "Subtítulos automatizados",
    "meetings.fullPlanItem31": "Portal del administrador",
    "meetings.fullPlanItem31Tip": "Administre a todos los usuarios de su empresa en una \u00FAnica cuenta para tener una facturaci\u00F3n simplificada, configuraciones de administraci\u00F3n de usuarios avanzadas e informaci\u00F3n de uso general en el Portal del administrador de Zoom.",
    "meetings.fullPlanItem32": "Integraci\u00F3n con LTI",
    "meetings.fullPlanItem32Tip": "Agregue f\u00E1cilmente una reuni\u00F3n a cualquier actividad del curso e invite a los alumnos correspondientes desde el sistema de gesti\u00F3n de aprendizaje (funciona con Moodle, Canvas, Desire2Learn y Blackboard).",
    "meetings.fullPlanItem33": "Transcripciones de grabaciones en la nube",
    "meetings.fullPlanItem33Tip": "Las grabaciones en la nube son transcripciones del audio de una reuni\u00F3n o seminario web que ha grabado en la nube. Tenga en cuenta que actualmente esta funci\u00F3n solo est\u00E1 disponible en ingl\u00E9s. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Haga clic aqu\u00ED</a> para obtener m\u00E1s informaci\u00F3n.",
    "meetings.fullPlanItem34": "Imagen de marca",
    "meetings.fullPlanItem34Tip": "A\u00F1ada la marca de su empresa a su propia p\u00E1gina personalizada donde los usuarios podr\u00E1n unirse a una reuni\u00F3n. Cree una plantilla de correo electr\u00F3nico con su marca para enviar invitaciones a los asistentes.",
    "meetings.fullPlanItem35": "Dominios administrados",
    "meetings.fullPlanItem35Tip": "Use el dominio de la direcci\u00F3n de correo electr\u00F3nico de su empresa/universidad para a\u00F1adir usuarios a su cuenta autom\u00E1ticamente.",
    "meetings.fullPlanItem37": "Interpretaci\u00F3n de idiomas",
    "meetings.fullPlanItem37Tip": "Permite que el anfitri\u00F3n de la reuni\u00F3n designe int\u00E9rpretes en sus reuniones y seminarios web. Al iniciar la reuni\u00F3n o el seminario web, el anfitri\u00F3n puede iniciar la funci\u00F3n de interpretaci\u00F3n, que permite a los int\u00E9rpretes acceder a sus propios canales de audio. Los asistentes pueden seleccionar un canal de audio para escuchar su idioma. Los asistentes escuchar\u00E1n el audio traducido, y pueden elegir si desean o\u00EDr el audio original con un volumen menor.",
    "meetings.fullPlanItem39": "Revisiones de negocios ejecutivos",
    "meetings.fullPlanItem39Tip": "An\u00E1lisis detallado de la adopci\u00F3n de tendencias, seguimiento del ROI, debates de la hoja de ruta del producto.",
    "meetings.fullPlanNewItem4": "Incluye Webinar 500",
    "one.translatedCations": "Subtítulos traducidos",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Chat directo, de canal o grupo",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Comuníquese fácilmente a través de mensajes individuales, en grupos pequeños o con equipos grandes",
    "messageAndFileHistory": "Historial de mensajes y archivos",
    "findPeopeChannelsAndFilesInSearch": "Encuentre personas, canales y archivos en la opción de búsqueda",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Busque rápidamente contactos, mensajes instantáneos, chats de grupo y archivos para mantener el conocimiento y la información a su alcance.",
    "applicationIntegrations": "Integraciones de aplicaciones",
    "secureFileSharing": "Uso compartido de archivos seguro",
    "enhanceCollaborationWithSeamlessFileSharing": "Mejore la colaboración con un uso compartido de archivos optimizado",
    "persistentMeetingChat": "Chat continuo en reuniones",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "No pierda el rastro de las conversaciones de las reuniones. Comuníquese antes, en el transcurso y después de una reunión en un chat grupal exclusivo de Zoom Team Chat disponible para todos los participantes de la reunión.",
    "cloudStorage": "Almacenamiento en la nube",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Respalde los canales con la nube de Zoom o un proveedor de almacenamiento externo",
    "avatars": "Avatares",
    "inMeetingReactions": "Reacciones en las reuniones",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Muestre compromiso y comuníquese rápidamente con otros participantes de una manera no verbal",
    "virtualBackgrounds": "Fondos virtuales",
    "videoFilters": "Filtros de vídeo",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Aporte diversión a sus reuniones con distintos filtros superpuestos en su vídeo",
    "inMeetingPollsAndQuizzes": "Votaciones y cuestionarios en las reuniones",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Cree preguntas de votaciones con respuesta de opción única o múltiple para sus reuniones.",
    "liveStreamingAcrossPlatforms": "Transmisión en directo entre plataformas",
    "appearanceTouchUp": "Aspecto retocado",
    "originalSoundForMusicians": "Sonido original para músicos",
    "endToEndEncryptionForZoomMeetings": "Cifrado de extremo a extremo para Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Cuando se habilita, el cifrado de extremo a extremo (E2EE) de Zoom para Zoom Meetings significa que las comunicaciones entre todos los participantes de la reunión que utilizan clientes de Zoom en una reunión determinada se cifran utilizando claves criptográficas que solo conocen los dispositivos de esos participantes. Esto significa que ningún tercero —ni siquiera Zoom— tiene acceso a las claves privadas de la reunión.",
    "zoomCustomerManagedKey": "Clave administrada por el cliente de Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Aporte sus propias claves de cifrado para proteger los datos de Zoom",
    "enterpriseGradeSecurityFeatures": "Características de seguridad de nivel empresarial",
    "256BitAesGcmEncryptionForRealTimeContent": "Cifrado AES-GCM de 256 bits para contenidos y medios en tiempo real, cifrado TLS durante el registro SIP, enmascaramiento del ID de llamada, emparejamiento de redes privadas, detección de fraude de herramientas y listas de bloqueo de llamadas.",
    "phone.fullPlanItem40": "Inicio de sesi\u00F3n \u00FAnico mediante SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Llamadas internas ilimitadas",
    "phone.fullPlanItem2": "Llamadas salientes tarificadas",
    "phone.fullPlanItem3": "Llamadas salientes ilimitadas",
    "phone.fullPlanItem4": "Calidad de llamada HD l\u00EDder en el sector",
    "phone.fullPlanItem4Tip": "Con cancelaci\u00F3n activa de ruido, cancelaci\u00F3n de eco y supresi\u00F3n de escritura del teclado",
    "phone.fullPlanItem5": "Aplicaciones de escritorio nativas de Windows, MacOS y Linux",
    "phone.fullPlanItem6": "Aplicaciones m\u00F3viles nativas para iOS y Android",
    "phone.fullPlanItem7": "Portar n\u00FAmeros existentes o comprar nuevos (DID)",
    "phone.fullPlanItem8": "N\u00FAmeros sin cargo",
    "phone.fullPlanItem9": "N\u00FAmero de extensi\u00F3n telef\u00F3nica",
    "phone.fullPlanItem10": "Correo de voz con transcripci\u00F3n",
    "phone.fullPlanItem10Tip": "Acceso a la transcripci\u00F3n del correo de voz a trav\u00E9s de aplicaciones m\u00F3viles/de escritorio y correo electr\u00F3nico",
    "phone.fullPlanItem11": "Operadores autom\u00E1ticos/IVR ilimitados",
    "phone.fullPlanItem12": "Directorio de marcaci\u00F3n por nombre",
    "phone.fullPlanItem13": "Grupos de distribuci\u00F3n autom\u00E1tica de llamadas (ACD) con cola de llamadas",
    "phone.fullPlanItem14": "Entrar sin llamar/Supervisar/Llamar en privado/Tomar el control",
    "phone.fullPlanItem15": "Enrutamiento de llamadas en vacaciones y horario comercial",
    "phone.fullPlanItem16": "Llamadas de conferencia ad hoc a 3",
    "phone.fullPlanItem17": "Grabación de llamadas",
    "phone.fullPlanItem17Tip": "Est\u00E1 disponible tanto grabaci\u00F3n de llamadas autom\u00E1tica como manual.",
    "phone.fullPlanItem18": "Bloqueo configurable de llamadas an\u00F3nimas y espec\u00EDficas",
    "phone.fullPlanItem19": "Llamadas de emergencia",
    "phone.fullPlanItem19Tip": "Llame a los servicios locales de emergencia",
    "phone.fullPlanItem20": "Direccionamiento n\u00F3mada E911 (EE.\u00A0UU. y Canad\u00E1):",
    "phone.fullPlanItem20Tip": "Detecte din\u00E1micamente la ubicaci\u00F3n del usuario e informe la direcci\u00F3n de emergencia correspondiente a los servicios de emergencia locales (solo EE.\u00A0UU. y Canad\u00E1), as\u00ED como al equipo de seguridad interno",
    "phone.fullPlanItem21": "Centro de respuesta ante emergencias",
    "phone.fullPlanItem21Tip": "Permita que su equipo de seguridad interno reciba alertas de llamadas de emergencia y registrar/supervisar/llevar a cabo una intrusi\u00F3n en las llamadas de emergencia para ayudar a coordinar la respuesta.",
    "phone.fullPlanItem22": "Aspecto de la l\u00EDnea compartida/delegaci\u00F3n",
    "phone.fullPlanItem23": "Transferencia de llamadas entre dispositivos",
    "phone.fullPlanItem24": "Estacionamiento de llamadas",
    "endToEndEncryptionForZoomPhone": "Cifrado de extremo a extremo para Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Cuando se habilita para Zoom Phone, el cifrado de extremo a extremo (E2EE) establece que la llamada se cifre utilizando claves cifradas que solo conocen los dispositivos de la persona que llama y del receptor. Además, los usuarios tendrán la opción de verificar el estado del E2EE proporcionando un código de seguridad único entre ellos.",
    "phone.fullPlanItem43": "Aprovisionamiento de tel\u00E9fonos sin intervenci\u00F3n",
    "phone.fullPlanItem44": "Mezcle tipos de planes en una cuenta",
    "phone.fullPlanItem46": "Informes en tiempo real y paneles de control de calidad",
    "phone.fullPlanItem47": "Soporte para entorno de escritorio virtual (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">M\u00E1s informaci\u00F3n</a> sobre VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Disponible para todos los clientes de telefonía independiente. Los planes de soporte varían cuando se asocian con planes de reuniones.",
    "phone.fullPlanItem49": "Soporte de conserve su operador",
    "phone.fullPlanItem49Tip": "Soporte para el emparejamiento directo y local con su proveedor de servicios RTPC existente",
    "phone.fullPlanItem50": "Integraci\u00F3n h\u00EDbrida para PBX heredadas",
    "phone.fullPlanItem51": "Pulsar para hablar",
    "phone.fullPlanItem61": "Fax en línea",
    "phone.fullPlanItem61Tip": "Envíe y reciba faxes ilimitados dentro de EE. UU. y Canadá. Para faxes internacionales, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF; \">consulte las tarifas</a>",
    "phone.fullPlanSms": "SMS y MMS",
    "phone.fullPlanSmsTip": "Disponibles exclusivamente para EE. UU. y Canad\u00E1 con la adquisici\u00F3n de un plan de llamadas. Disponible para uso con n\u00FAmeros directos (n\u00FAmeros no pertenecientes a la empresa).",
    "meetings.fullPlanItem6": "Soporte t\u00E9cnico",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Solo incidencia",
    "meetings.fullPlanItem6_pro": "Incidencia y chat en vivo",
    "meetings.fullPlanItem6_biz": "Incidencia, chat en vivo y tel\u00E9fono",
    "meetings.fullPlanItem6_ent": "Incidencia, chat en vivo y tel\u00E9fono",
    "knowledgeBase": "Base de conocimiento",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Solucione problemas técnicos y acceda a los recursos de soporte buscando en nuestros artículos de la base de conocimientos.",
    "zoomCommunity": "Comunidad de Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Un lugar para encontrar soluciones, hacer preguntas y colaborar con otros usuarios de Zoom.",
    "chatbot": "Bot de chat",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Obtenga respuestas a preguntas y solucione problemas técnicos interactuando con nuestro bot de chat.",
    "submitWebTickets": "Enviar tickets web",
    "liveChatSupport": "Soporte para chat en directo",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Planes de suscripción superiores a {amount} $/mes",
    "livePhoneSupport": "Soporte para teléfono en directo",
    "meetWithAgentOnVideo": "Reúnase con un agente por vídeo",
    "subscriptionPlansGreaterThan_200UsdMonth": "Planes de suscripción superiores a 200 $/mes",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Aumente la productividad aprovechando las aplicaciones favoritas en Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Personalice su propio avatar para aportar un poco de diversión a las reuniones y presentarse de manera dinámica sin la necesidad de tener vídeo",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Correo",
    "common.plans.meeting.title": "Reuniones",
    "plans.basic_free.upgrade.item1": "Hasta 30 horas por reunión",
    "common.statistics.participants": "{0} Participantes",
    "common.per_meeting_unit": "por reunión",
    "common.participant_limit.increase_with_large_meetings": "Aumente la capacidad con Reuniones grandes",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Pizarra",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Ilimitado",
    "common.plans.team_chat.title": "Chat en equipo",
    "common.plans.mail_calendar.title": "Correo y Calendario",
    "common.plans.cloud_storage.title": "Almacenamiento en la nube",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Subtítulos traducidos de Zoom",
    "common.plans.extras.title": "Adicionales",
    "common.plans.extras.desc": "administre los dominios de la empresa, y más",
    "zoom_one_edu_bundle.school.title": "Zoom One para Educación Escuela y Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One para Educación Escuela y Campus Plus",
    "per_billing_cycle_license.monthly": "/mes/licencia",
    "per_billing_cycle_license.yearly": "/año/licencia",
    "per_billing_cycle_space.monthly": "/mes/espacio",
    "per_billing_cycle_space.yearly": "/año/espacio",
    "common.dialog.feature_list": "Ver la lista de funciones completa",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB por licencia",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB por licencia",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Empresarial Plus incluye Ilimitado",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conector de salas de conferencias (relación de 1:25)",
    "plans.whiteboard.ent": "Empresarial Plus incluye Ilimitado Plus",
    "plans.zp.ent": "Incluido en Empresarial Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Reserva de espacio de trabajo anticipada o en el lugar, y más",
    "plans.largeMeeting.intro_tip": "Reuniones grandes es un add-on opcional durante el proceso de finalización de compra, que le permite organizar una reunión de hasta 500 o 1000 participantes en función de la licencia adquirida.",
    "common.participant_limit.expandable_with_large_meetings": "Con posibilidad de ampliación con Reuniones grandes",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1000 para Enterprise Plus</span>",
    "plans.webinar": "Seminario web de Zoom",
    "plans.webinar.ent": "Empresarial Plus incluye Session 1000 (incluye seminario web)",
    "per_billing_cycle_user.monthly": "/mes/usuario",
    "per_billing_cycle_user.annually": "/año/usuario",
    "closeComparisonChart": "Cerrar tabla comparativa",
    "archiving_api": "API de archivado",
    "dlp_api": "API de DLP",
    "info_barriers": "Barreras de información",
    "chat_etiquette": "Etiqueta del chat",
    "gdrp": "RGPD",
    "regiona_data_centers": "Centros de datos regionales",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Cifrado de forma predeterminada",
    "end_to_end_encryption": "Cifrado de extremo a extremo",
    "cryptographic_boundary": "Límite criptográfico",
    "vdi": "Escritorio virtual (VDI)",
    "customer_managed_key": "Clave administrada por el cliente",
    "gpo_msi_policies": "Políticas de GPO/MSI",
    "msi": "Implementación masiva (MSI)",
    "ntt": "Herramienta de prueba de red (NTT)",
    "dashboards": "Paneles de control",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Supervivencia de Zoom Phone",
    "zoom_meeting_survivability": "Supervivencia de Zoom Meetings",
    "paid_option": "Opción de pago",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Características principales",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Escuela y Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Escuela y Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "fr-FR": {
    "billing.essential_apps": "Applications essentielles",
    "billing.essential_apps.dialog_desc": "Développez et gérez votre activité avec des applications qui vous permettent de prendre des notes de réunion, de motiver votre équipe grâce à des activités interactives, de générer des informations pour optimiser les conversations avec vos clients, et bien plus encore ! Applications Premium gratuites incluses dans votre forfait pendant 1 an.",
    "billing.see_more_details": "En savoir plus",
    "billing.essential_app.legal_copy": "Offre valable uniquement pour les utilisateurs disposant d’une licence active au 4 janvier 2023 ou après, dans le cadre d’un abonnement Zoom One Pro, Affaires ou Business Plus souscrit via le canal en ligne de Zoom sur zoom.us/buy. Cette offre ne s’applique pas aux utilisateurs dont l’abonnement est associé à un compte Santé, Éducation ou Gouvernement.  L’accès à chaque application (à l’exception de Coda) débute à l’activation de l’application par l’utilisateur individuel et expire au bout d’un an. L’accès à Coda pour tous les utilisateurs d’un même compte Zoom débute à la première activation de Coda par tout utilisateur du compte Zoom correspondant, et prend fin pour tous les utilisateurs de ce même compte Zoom au bout d’un an, quelle que soit la date d’activation initiale des autres utilisateurs du compte Zoom.Pour toutes les applications, la réaffectation ou l’annulation de la licence ou de l’abonnement éligible d’un utilisateur mettra fin à l’accès de cet utilisateur, que la période d’accès d’un an soit arrivée ou non à son terme.Chaque application est soumise à ses conditions générales d’utilisation et à sa politique de confidentialité en vigueur au moment de l’activation.Les applications incluses ne sont prises en charge qu’en anglais.Certaines applications ne fonctionnent pas sur mobile.L’offre ne s’applique qu’aux applis faisant partie des Applications essentielles dans <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>. Les utilisateurs déjà abonnés à l’une de ces applications ne peuvent pas bénéficier de cette offre.Zoom se réserve le droit de modifier ou d’annuler cette offre à tout moment sans préavis ni responsabilité.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Gestion des visiteurs"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Assistance téléphonique et par chat en direct 24 h/24, 7 j/7"
      },
      "learn_more": "En savoir plus",
      "new": "NOUVEAU",
      "plan_details": {
        "meeting": {
          "title": "R\u00E9unions",
          "host_meeting_up_to_participants": "Accueille jusqu’à {0} participants",
          "meeting_hours": "Nombre illimité de réunions et jusqu’à 30 heures par réunion",
          "recording_storage": "{0} Go de stockage d’enregistrement dans le cloud (par licence)",
          "auto_captions": "Sous-titres automatisés"
        },
        "whiteboard": {
          "title": "Tableau blanc",
          "boards_storage": "{0} tableaux modifiables",
          "standard_features": "Fonctionnalités standards"
        },
        "team_chat": {
          "title": "Chat de groupe",
          "desc": "Chat de groupe & partage de documents"
        },
        "main_calendar": {
          "title": "Messagerie et calendrier",
          "desc": "Client et services de messagerie et de calendrier"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Créez et partagez des documents modifiables dans Zoom",
          "desc2": "Des notes personnelles et collaboratives au texte enrichi"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Enregistrez, modifiez et partagez facilement des vidéos courtes",
          "desc2": "Vidéos illimitées et fonctionnalités avancées"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Accédez rapidement aux résumés de réunion, à l’assistance à la rédaction des messages, et bien plus"
        },
        "EssentialApp": {
          "title": "Applications essentielles",
          "desc1": "Applications Premium gratuites pendant 1 an (des conditions s’appliquent)",
          "desc2": "Gagnez en productivité et en collaboration"
        },
        "livechat": {
          "title": "Assistance par chat en direct"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Passer à Zoom Workplace Pro ?",
            "content": "Votre précédente sélection Zoom Workplace Affaires permet d'organiser des réunions pouvant compter jusqu'à 300 participants, propose Zoom Scheduler, et bien d'autres fonctionnalités. Voulez-vous quand même passer à Zoom Workplace Pro ?",
            "confirm": "Confirmer la modification",
            "keep_current": "Conserver le forfait actuel"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} spectateurs",
          "participants": "{0} Participants",
          "user_range": "{0} à {1} utilisateurs",
          "items": "{num} produits"
        },
        "button": {
          "ok": "OK",
          "add": "Ajouter",
          "buy_now": "Acheter maintenant",
          "try_for_days": "Faites un essai de {0} jours",
          "contact_sales": "Contacter les ventes",
          "close": "Fermer",
          "cancel": "Annuler",
          "edit": "Modifier",
          "got_it": "J’ai compris"
        },
        "title": {
          "everything_in_and": "Toutes les fonctionnalités de {0} et :"
        },
        "tag": {
          "new": "NOUVEAU",
          "free_trial": "Essai gratuit"
        },
        "billing_cycle": {
          "annual": "Annuel",
          "monthly": "Mensuel",
          "quarterly": "Trimestriel",
          "two_years": "Deux ans",
          "three_years": "Trois ans"
        },
        "errors": {
          "unknown_error_try_again": "Erreur inconnue dans le traitement de la transaction. Veuillez réessayer plus tard"
        },
        "excluding_tax": {
          "vat_tip": "hors TVA",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Fonctionnalités limitées",
        "pro_plus": {
          "host_meeting_up_to_participants": "Accueille jusqu’à {0} participants",
          "gb_of_cloud_recording_storage": "{0} Go de stockage d’enregistrement dans le cloud (par licence)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion pour la génération de contenu et les traductions",
            "features_item2": "Nombre illimité de documents partagés avec votre équipe",
            "features_item3": "Historique des versions illimité",
            "comparison_table_tips": "Optimisez la collaboration grâce à des documents basés sur l’IA qui transforment le contenu des réunions en documents, wikis et projets exploitables"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basique",
            "features_item1": "Détecter automatiquement les tâches mentionnées lors de vos réunions, appels et chats, ainsi que dans vos documents",
            "features_item2": "Fournir une assistance pour réaliser des tâches, par exemple en planifiant les réunions de suivi et en ébauchant des documents",
            "features_item3": "Marquer directement les tâches effectuées comme terminées pour vous permettre d’avancer et de vous concentrer sur la suite",
            "features_item4": "Gérer les tâches sur l’ensemble de la plateforme Zoom Workplace, y compris dans Zoom Docs",
            "features_item1_opc": "Identifiez et créez des tâches à partir de vos chats, e-mails, documents, tableaux blancs et synthèses de réunion, grâce aux performances d'AI Companion",
            "features_item2_opc": "Triez, filtrez, groupez et recherchez facilement les données pour accéder rapidement aux informations et rassembler du contexte sur vos tâches",
            "learn_more_header": "Maîtrisez vos tâches grâce à AI Companion* et gagnez en efficacité dans Zoom Workplace.",
            "learn_more_footer": "\* AI Companion est disponible uniquement pour les forfaits Zoom Workplace Pro, Affaires et Entreprise.",
            "features_prefix": "AI Companion peut :",
            "comparison_table_tips": "Maîtrisez vos tâches et terminez-les à temps avec une solution basée sur l’IA qui utilise la synthèse des conversations et réunions tenues dans Zoom Workplace pour vous recommander des tâches à ajouter.",
            "tasks_label_text": " Gestion des tâches optimisée par l’IA"
          },
          "title": "Affaires Plus",
          "contact_us_for_more_pricing": "Contactez-nous pour découvrir nos prix et bien plus",
          "contact_sales": "Contacter les ventes",
          "meetings": "R\u00E9unions",
          "phone": "T\u00E9l\u00E9phone",
          "phone_sub_title": "Appels illimit\u00E9s",
          "use_only": "Utilisation à des fins professionnelles uniquement",
          "team_chat": {
            "title": "Chat de groupe",
            "title_desc": "Chat de groupe & partage de documents"
          },
          "cloud_storage": {
            "title": "Stockage sur le cloud"
          },
          "mail_calender": {
            "title": "Messagerie et calendrier"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client et service"
          },
          "up_to_30_hours_per_meeting": "jusqu’à 30 heures par réunion",
          "300_attendees": "300 participants",
          "per_meeting": "par réunion",
          "whiteboard": {
            "title": "Tableau blanc"
          },
          "new": "NOUVEAU",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 Go",
          "extras": "Extra",
          "sso_managed_domains_more": "SSO, domaines gérés, etc.",
          "scheduler": "Planificateur",
          "global_select": "Global Select",
          "unlimited_regional": "Appels régionaux illimités",
          "translated_captions": "Sous-titres traduits",
          "workspace_reservation": "Réservation d’un espace de travail",
          "auto_translated_captions": "Sous-titres automatisés et traduits",
          "unlimited_editable_boards": "Nombre illimité de tableaux modifiables",
          "standard_features": "Fonctionnalités standards",
          "advanced_docu_controls": "Contrôles de document avancés",
          "chats_channels_for_collaboration": "Chat et canaux pour la collaboration, le partage de fichiers, et plus",
          "zoom_phone_is_biz_use_only": "Zoom Phone est réservé à un usage professionnel",
          "unlimited_regional_calling": "Appels r\u00E9gionaux illimit\u00E9s",
          "domestic_sms_mms": "SMS et MMS nationaux",
          "automatic_call_distribution_groups": "Groupes de distribution automatique des appels (ACD) avec file d\u2019attente des appels",
          "single_sign_on": "Authentification unique",
          "managed_domains": "Domaines g\u00E9r\u00E9s",
          "company_branding": "Valorisation de la marque de l'entreprise",
          "mail_calender_client_services_beta": "Client et services de messagerie et de calendrier en version bêta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Nombre illimité de réunions et jusqu’à 30 heures par réunion",
          "mail_and_calendar_client_and_services_beta": "Client et services de messagerie et de calendrier en version bêta",
          "easily_record_edit_share_videos": "Enregistrez, modifiez et partagez facilement des vidéos courtes",
          "unlimited_videos_advanced_features": "Vidéos illimitées et fonctionnalités avancées",
          "create_share_editabel_docu_within_zoom": "Créez et partagez des documents modifiables dans Zoom",
          "personal_collaborative_notes_rich_text_editing": "Des notes personnelles et collaboratives au texte enrichi",
          "effortlessly_share_meeting": "Partagez facilement des créneaux pour simplifier la réservation",
          "works_with_zoom_meeting_mail_calender_google_ms": "Compatible avec Zoom Meetings, Zoom Mail, Zoom Calendar, Google et Microsoft 365",
          "up_to_300_attendees": "Jusqu'à 300 participants",
          "10_gb_of_storage": "Capacité de stockage de 10 Go",
          "host_meeting_up_to_300_participants": "Organisez des r\u00E9unions avec 300 participants maximum",
          "10_gb_of_cloud_recording_storage": "10 Go de capacité de stockage des enregistrements sur le cloud (par licence)",
          "starting_at_licenses_year": "\u00C0 partir de {1} licences pour {0} /an",
          "starting_at_licenses_month": "\u00C0 partir de {1} licences pour {0} /mois",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Accédez rapidement aux résumés de réunion, à l’assistance à la rédaction des messages, et bien plus",
          "learn_more": "En savoir plus",
          "essential_apps": "Applications essentielles",
          "increase_team_collaboration": "Gagnez en productivité et en collaboration",
          "free_premium_apps": "Applications Premium gratuites pendant 1 an (des conditions s’appliquent)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Personnalisez vos invitations",
          "visitor_management_visitor_check": "Enregistrez les arrivées sur un kiosque",
          "visitor_management_receive_detailed": "Recevez des données détaillées sur l’utilisation de l’espace par les visiteurs"
        },
        "custom_avatar": {
          "title": "Avatar personnalisé",
          "label_text": "3 minutes par mois",
          "basic_feature": "1 minute par vie",
          "pricing_feature": "3 minutes par mois",
          "learn_more_subtitle": "Créez une version IA de vous-même plus vraie que nature, qui reproduira votre voix et pourra communiquer en plusieurs langues.",
          "features_item1": "Créez chaque mois jusqu’à 3 avatars numériques plus vrais que nature, qui reproduisent votre apparence et votre voix pour des présentations et des démonstrations.",
          "features_item2": "Utilisez votre avatar pour diffuser des scripts d’une durée maximale de 3 minutes avec AI Companion",
          "features_item3": "Choisissez parmi 18 avatars prédéfinis pour de rapides créations vidéo de haute qualité.",
          "features_item4": "Bénéficiez d’arrière-plans virtuels.",
          "features_item1_opc": "Créez chaque mois jusqu’à 3 avatars numériques plus vrais que nature, qui reproduisent votre apparence et votre voix pour des présentations et des démonstrations.",
          "features_item2_opc": "Utilisez votre avatar pour diffuser des scripts d’une durée maximale de 3 minutes avec AI Companion",
          "comparison_table_tips": "L’avatar personnalisé crée une version IA de vous-même plus vraie que nature, qui reproduit votre voix et peut communiquer en plusieurs langues."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Accédez rapidement aux résumés de réunion, à l’assistance à la rédaction des messages, et bien plus",
        "learn_more_dialog": {
          "desc": "Faites plus avec AI Companion ! Il peut rédiger du contenu, planifier vos réunions, vous aider à gérer vos projets, et bien plus encore.",
          "tip1": "Recevez un ordre du jour à l’avance afin d’organiser des réunions plus efficaces",
          "tip2": "Maintenez vos projets sur la bonne voie grâce à la création automatisée de tâches et aux notifications",
          "tip3": "Obtenez de l’aide pour organiser votre agenda et gérer votre temps",
          "tip4": "Générez du contenu écrit et visuel qui correspond à votre style dans Docs, Whiteboard ou dans l’application Zoom Workplace"
        },
        "top_features": "Principales fonctionnalités",
        "more_to_come": "D’autres fonctionnalités utiles seront prochainement ajoutées.",
        "discover_more": "Découvrez encore plus de façons de travailler au mieux avec AI Companion",
        "detail_desc": "AI Companion est inclus sans frais supplémentaires dans les services payants des comptes utilisateur Zoom. Sous réserve de disponibilité dans le secteur et la zone géographique concernés."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/an/licence",
        "month_licnese": "/mois/licence",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/mois",
          "per_year": "/an"
        },
        "unit": {
          "license": "{0}/licence",
          "user": "{0}/utilisateur"
        },
        "learn_more": "En savoir plus",
        "required": "Requis",
        "zoom_one_required": "Zoom Workplace requis",
        "large": {
          "features_tip": "Élargissez votre audience en augmentant la capacité des réunions à 1 000 participants.",
          "label_title1": "500 participants",
          "label_title2": "1000 participants"
        },
        "cmr": {
          "features_tip": "Stockez, diffusez et téléchargez vos enregistrements vidéo directement depuis le cloud Zoom.",
          "explain_desc": "L’option de stockage sur le cloud est incluse dans certains forfaits Zoom One : Pro (5 Go), Affaires (5 Go), Affaires Plus (10 Go) et Entreprise (illimité)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 heures",
          "option_label2": "≈ 650 heures",
          "option_label3": "≈ 3,500 heures",
          "option_label4": "≈ 17,500 heures",
          "intro_label2": "Options de stockage jusqu’à 5 To/mois",
          "tooltip_content": "L’espace de stockage d’enregistrement varie en fonction du nombre de participants aux vidéos ainsi que de la résolution des réunions et des contenus partagés."
        },
        "whiteboard": {
          "plus_title": "Tableau blanc Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborez en temps réel sur des tableaux blancs, pendant les réunions ou en dehors.",
          "explain_desc": "Inclus dans Zoom One Affaires, Zoom One Affaires Plus et Zoom One Entreprise",
          "explain_desc_plus": "Inclus dans Zoom One Entreprise Plus et avec tout abonnement Zoom Rooms",
          "option_label1": "Tableaux illimités avec 1 Go de stockage dans le cloud",
          "option_label2": "Fonctionnalités avancées avec tableaux illimités et stockage dans le cloud",
          "intro_label1": "Nombre illimité de tableaux blancs modifiables simultanément",
          "intro_label2": "Fonctionnalités standards et contrôle de document avancé",
          "intro_label3": "Fonctionnalités de tableau blanc avancées dont des modèles d’entreprise et personnalisés ainsi que des intégrations tierces"
        },
        "translated_captions": {
          "features_tip": "Collaborez à l’international grâce à des sous-titres automatiques dans la langue de votre choix.",
          "intro_label1": "Les participants peuvent activer les sous-titres et changer de langue.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Afficher les langues prises en charge"
        },
        "crc": {
          "features_tip": "Permet le travail hybride via un point de terminaison de visioconférence SIP/H.323 normalisé.",
          "intro_label1": "Compatible avec de nombreux points de terminaison existants, notamment Polycom, Cisco, Lifesize et d'autres",
          "intro_label2": "Connecteur de salles sur le cloud ou sur site (MV)"
        },
        "scheduler": {
          "simplify_bookings": "Simplifiez les réservations grâce à des disponibilités flexibles et des plages horaires personnalisables",
          "host_one_on_one": "Organisez des réunions individuelles ou de groupe à l’aide d’un seul lien pour un partage simplifié",
          "customize_reminders": "Personnalisez les rappels par e-mail et SMS pour réduire le nombre de rendez-vous manqués",
          "sync_calendars": "Synchronisez vos calendriers en toute facilité avec Google, Microsoft 365 et les intégrations Zoom",
          "features_tip": "Partagez facilement vos créneaux pour des permanences ou des entretiens, entre autres.",
          "intro_label1": "Intégration du calendrier",
          "intro_label2": "Disponibilité périodique",
          "intro_label3": "Réunion évolutive",
          "intro_label4": "Notifications personnalisables",
          "intro_sub_label1": "Google, Microsoft 365 et Zoom ",
          "intro_sub_label2": "Partage de créneaux réservables ",
          "intro_sub_label3": "Une seule réunion, quel que soit le nombre de participants",
          "intro_sub_label4": "Rappels et confirmations automatiques par e-mail ou par SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Enregistrez, modifiez et partagez des messages vidéo courts de haute qualité.",
          "intro_label1": "Créez autant de vidéos que vous le souhaitez sans limite de temps",
          "intro_label2": "Enregistrez votre écran et/ou votre vidéo",
          "intro_label3": "Coupez votre vidéo selon les besoins et partagez-en le lien",
          "intro_label4": "Accédez à des fonctionnalités avancées, telles que les transcriptions audio et les statistiques",
          "explain_desc": "Clips Plus est inclus dans les abonnements Workplace Pro, Affaires et Entreprise. Vous pouvez découvrir les différentes fonctionnalités de chaque forfait dans le comparatif de la page de tarification."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Plateforme avancée d’événements dotée de fonctionnalités d’inscription et de réseau performantes. Idéale pour les expériences virtuelles et hybrides.",
          "tooltip_content": "Organisez autant de webinaires ou d’événements que vous le souhaitez avec la capacité choisie",
          "intro_title": "Toutes les fonctionnalités de Zoom Sessions",
          "intro_label1": "Augmentez la participation avec des événements multi-sessions.",
          "intro_label2": "Organisez facilement des événements grâce à la billetterie sur mesure et l’application mobile.",
          "intro_label3": "Augmentez les revenus de vos événements avec le salon Expo et la zone Sponsors.",
          "intro_label4": "Favorisez la création de réseaux entre les participants à l’aide de profils personnalisables",
          "intro_label5": "Élargissez votre audience grâce à des visionnages sur demande dans le hall de l’événement",
          "intro_label6": "Accélérez l’organisation des événements grâce à une sélection de modèles",
          "events_feature_item1_20240827": "Organisez des événements virtuels de plusieurs jours avec plusieurs pistes",
          "events_feature_item2_20240827": "Encouragez le networking grâce aux profils des participants et au chat du hall.",
          "events_feature_item3_20240827": "Guidez les participants grâce aux sessions diffusées dans le hall.",
          "events_feature_item4_20240827": "Augmentez les revenus de vos événements avec le salon Expo et les parrainages.",
          "events_feature_item5_20240827": "Améliorez les événements futurs grâce à des enquêtes post-événement.",
          "events_feature_item6_20240827": "Accélérez l’organisation des événements grâce à une sélection de modèles",
          "attendees_start_at": "{0} participants à partir de",
          "explain_desc": "En savoir plus sur Zoom Events",
          "contact_account_owner": "Si vous souhaitez acheter Zoom Events, veuillez <a href=\"/account\" target=\"_blank\">contacter votre titulaire de compte</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Simplifiez vos événements à session unique interactifs grâce à des fonctionnalités telles que la personnalisation des événements, la collaboration multi-hôte et la gestion des événements.",
          "tooltip_content": "Organisez autant de webinaires ou d’événements que vous le souhaitez avec la capacité choisie",
          "intro_title": "Inclut Zoom Webinars",
          "intro_label1": "Soignez votre image de marque en personnalisant la page de destination de vos événements.",
          "intro_label2": "Faites la promotion de vos événements avec des e-mails personnalisés.",
          "intro_label3": "Mesurez les performances à l’aide d’un tableau de bord interactif.",
          "intro_label4": "Collaborez aisément avec les co-hôtes et les co-éditeurs.",
          "intro_label5": "Outils pour des événements professionnels : le direct simulé",
          "sessions_feature_item1_20240827": "Optimisez les webinaires grâce à des décors personnalisés et à l’utilisation de votre marque.",
          "sessions_feature_item2_20240827": "Simplifiez la planification d’événements avec AI Companion pour générer des messages et des images.",
          "sessions_feature_item3_20240827": "Mettez en avant des événements passés et futurs dans un centre de contenu à l’image de votre marque.",
          "sessions_feature_item4_20240827": "Organisez des événements professionnels avec Backstage, Simulive et RTMP.",
          "sessions_feature_item5_20240827": "Améliorez vos futurs webinaires grâce à des analyses inter-événements.",
          "explain_desc": "En savoir plus sur Zoom Sessions",
          "contact_account_owner": "Si vous souhaitez acheter Zoom Sessions, veuillez <a href=\"/account\" target=\"_blank\">contacter votre titulaire de compte</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Webinaire vidéo",
          "features_tip": "Diffusez des messages sans effort à l’aide d’une plateforme de webinaires conviviale.",
          "tooltip_content": "Organisez autant de webinaires ou d’événements que vous le souhaitez avec la capacité choisie",
          "intro_label1": "Suscitez l’intérêt de votre audience avec une webdiffusion vidéo de haute qualité",
          "intro_label2": "Dopez l’engagement grâce aux questions/réponses, aux sondages et aux réactions",
          "intro_label3": "Améliorez votre stratégie en matière de webinaires avec la création de rapports post-événement",
          "intro_label4": "Prenez en charge jusqu’à 100 000 participants et 100 panélistes",
          "monthly_subscription": "Abonnement mensuel",
          "annual_subscription": "Abonnement annuel",
          "one_million": "1 million",
          "single_use": "Webinaire unique",
          "one_month": "Un mois",
          "event_attendee": "Participants Zoom Events/Sessions :",
          "event_attendee_desc": "toute personne se connectant sans être un hôte détenteur de licence sur le hub. Les rôles spéciaux entrent aussi dans la catégorie des participants et peuvent, si l’option est activée, utiliser l’audio, la vidéo et le partage d’écran.",
          "webinar_attendee": "Participants Zoom Webinars :",
          "webinar_attendee_desc": "toute personne qui rejoint la session sans être l’hôte ou un panéliste. D’abord en écoute seule, l’hôte peut les inviter à s’exprimer et à interagir via les questions-réponses et le chat.",
          "pay_per_attendee": "Tarification par participant",
          "attendees": "spectateurs"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Réinventez les méthodes de travail de vos équipes grâce à une plateforme de collaboration optimisée par l’IA.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Affaires",
          "label_title4": "Workplace Affaires Plus",
          "intro_label1": "Organisez un nombre illimité de réunions pouvant durer jusqu’à 30 heures chacune et compter jusqu’à 100 participants.",
          "intro_label2": "Travaillez simultanément sur trois tableaux blancs modifiables dotés de fonctionnalités standards",
          "intro_label3": "Enregistrez, modifiez et partagez des messages vidéo courts de haute qualité avec Clips Plus.",
          "intro_label4": "Travaillez plus efficacement avec Zoom AI Companion",
          "intro_label5": "Forfait Zoom Phone États-Unis et Canada en illimité (hors BYOC, PBX et PBX tiers)",
          "intro_label6": "Organisez un nombre illimité de réunions pouvant durer jusqu’à 30 heures chacune et compter jusqu’à 300 participants.",
          "intro_label7": "Partagez vos créneaux avec Zoom Scheduler, pour des permanences ou des entretiens, par exemple",
          "intro_label8": "Zoom Phone illimité aux États-Unis et au Canada",
          "intro_label8_UK": "Zoom Phone illimité au Royaume-Uni et en Irlande",
          "intro_label8_AU": "Zoom Phone illimité en Australie et en Nouvelle-Zélande",
          "intro_label8_JP": "Zoom Phone illimité au Japon",
          "intro_label9": "Gestion des visiteurs",
          "intro_label10": "Fonctionnalités supplémentaires",
          "intro_label11": "Assistance par chat en direct",
          "intro_title1": "Toute l’offre Pro, plus :",
          "intro_title2": "Toute l’offre Affaires, plus :",
          "intro_label_tip1": "Dans le forfait Pro Plus, les fonctionnalités Zoom Phone BYOC, PBX tiers et VDI ne sont pas incluses. Pour plus d’informations, reportez-vous à la page de tarification Zoom Phone.",
          "intro_label_tip2": "Lors du paiement, vous pouvez sélectionner Appels nationaux illimités aux États-Unis et au Canada, en Australie et Nouvelle-Zélande, au Royaume-Uni et en Irlande ou au Japon.",
          "intro_label_tip3": "Vous pouvez également disposer de 10 Go de stockage sur le cloud, des sous-titres traduits et des réservations d’espaces de travail.",
          "intro_label_tip4": "Dans le forfait Pro Plus, les fonctionnalités Zoom Phone BYOC, PBX tiers et VDI ne sont pas incluses. Pour plus d’informations, reportez-vous à la page de tarification Zoom Phone."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Outil amélioré d’analyse de la file d’attente des appels générant des informations d’historique pour les équipes du centre d’appel.",
          "intro_label1": "Fenêtre de contacts élargie pour simplifier la gestion des appels",
          "intro_label2": "Réceptionniste automatique et numéros de téléphone de la file d'attente des appels"
        },
        "international_calling": {
          "title": "Appels internationaux",
          "features_tip": "Appels internationaux illimités vers plus de 15 pays et régions.",
          "intro_label1": "Souscription possible avec tous les forfaits d’appels illimités",
          "intro_label2": "Découvrez notre liste de pays et régions compatibles avec les appels internationaux illimités.",
          "intro_labe2_tooltip": "États-Unis, Canada, Royaume-Uni, Irlande, Australie, Nouvelle-Zélande, Autriche, Danemark, France, Allemagne, Italie, Portugal, Espagne, Suède, Belgique, Pays-Bas, Suisse, Porto Rico, Japon.",
          "intro_label2_view_list": "Afficher la liste"
        },
        "workspace_reservation": {
          "title": "Réservation d’un espace de travail",
          "intro_title": "Réservez facilement des espaces de travail flexibles ou des chambres d’hôtel à l’avance ou sur place, avec des appareils équipés de Zoom.",
          "intro_label1": "Accédez aux réservations d’espaces de travail et d’hôtels via l’application Zoom Workplace, le bureau ou le navigateur.",
          "intro_label2": "Recevez des recommandations de bureau personnalisées avec l’aide de l’IA",
          "intro_label3": "Réservez des espaces de travail directement à partir de Google Agenda ou d’Outlook, avec des rappels et des alertes d’enregistrement.",
          "intro_label4": "Accédez aux espaces de travail réservés grâce aux consignes d’orientation."
        },
        "visitor_management": {
          "title": "Gestion des visiteurs",
          "intro_title": "Simplifier l’enregistrement des personnes en visite grâce à des invitations personnalisées, un enregistrement au kiosque sans heurts, des rapports et des mesures.",
          "intro_label1": "Gérer les invitations, l’emplacement des visiteurs et visiteuses, et consulter l’historique sur le portail Zoom;",
          "intro_label2": "Créer, suivre, renvoyer et supprimer des invitations tout en recevant la notification d’arrivée des personnes invitées;",
          "intro_label3": "Remplir des formulaires, obtenir des indications sur l’adresse et s’enregistrer au kiosque pour une expérience fluide pour les personnes en visite.",
          "intro_label4": "Accéder à toutes les fonctionnalités depuis le portail Zoom que vous connaissez bien, pour une gestion facile."
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Grande réunion",
          "description1": "Augmentez la capacité maximale des réunions à 1 000 participants interactifs en direct",
          "description2": "Tous les participants peuvent partager leur son, leur flux vidéo et leur écran."
        },
        "cloud_storage": {
          "title": "Stockage dans le cloud",
          "description2": "Formats de fichiers MP4 ou M4A disponibles"
        },
        "translated_captions": {
          "title": "Sous-titres traduits",
          "description1": "Donnez la possibilité aux participants d’activer les sous-titres automatisés dans l’une des nombreuses langues prises en charge",
          "description2": "Disponible dans Zoom Meetings et Zoom Webinars"
        },
        "tollfree": {
          "title": "Conférence audio",
          "subcontent": "Connexion aux réunions par téléphone, où que vous vous trouviez dans le monde",
          "description1": "Extension des options téléphoniques avec les appels sortants, les appels gratuits partout dans le monde et les numéros locaux à composer pour les pays Premium",
          "description2": "Aucuns frais pour les participants qui utilisent l’appel entrant, quel que soit leur appareil",
          "description3": "Sélectionnez facilement un ou plusieurs pays qui pourront appeler gratuitement"
        },
        "rc": {
          "title": "Connecteur de salles de conférence"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentine",
        "Australia": "Australie",
        "Austria": "Autriche",
        "Belgium": "Belgique",
        "Brazil": "Brésil",
        "Bulgaria": "Bulgarie",
        "Canada": "Canada",
        "Chile": "Chili",
        "China": "Chine",
        "Colombia": "Colombie",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatie",
        "Cyprus": "Chypre",
        "Czech_Republic": "République tchèque",
        "Denmark": "Danemark",
        "Ecuador": "Équateur",
        "Estonia": "Estonie",
        "Finland": "Finlande",
        "France": "France",
        "Germany": "Allemagne",
        "Greece": "Grèce",
        "Hong_Kong_SAR": "Hong Kong (RAS)",
        "Hungary": "Hongrie",
        "Ireland": "Irlande",
        "Israel": "Israël",
        "Italy": "Italie",
        "Japan": "Japon",
        "Latvia": "Lettonie",
        "Lithuania": "Lituanie",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexique",
        "Netherlands": "Pays-Bas",
        "New_Zealand": "Nouvelle-Zélande",
        "Norway": "Norvège",
        "Panama": "Panama",
        "Peru": "Pérou",
        "Poland": "Pologne",
        "Portugal": "Portugal",
        "Puerto_Rico": "Porto Rico",
        "Romania": "Roumanie",
        "Singapore": "Singapour",
        "Slovakia": "Slovaquie",
        "Slovenia": "Slovénie",
        "South_Africa": "Afrique du Sud",
        "Spain": "Espagne",
        "Sweden": "Suède",
        "Switzerland": "Suisse",
        "UK": "Royaume-Uni",
        "United_Kingdom": "Royaume-Uni",
        "US": "US",
        "United_States": "États-Unis",
        "title": "Exigences en matière de numéro de téléphone",
        "subtitle": "Veuillez sélectionner le pays dans lequel votre numéro de téléphone International Sélection sera activé.",
        "selector_tip": "Sélectionner un pays",
        "local_and_toll_free": "Des numéros locaux et gratuits sont disponibles dans ce pays : {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Le forfait International Sélection inclut un numéro de téléphone et des appels nationaux illimités dans le pays sélectionné, par licence.",
        "avail_title": "Pays/territoires disponibles"
      },
      "tax_exempt_ecm": {
        "title": "Statut d’exonération fiscale",
        "status_exempt": "Exonération de taxe",
        "status_exempt_question": "Bénéficiez-vous d’une exonération fiscale ?",
        "verify_now": "Vérifier maintenant",
        "can_after_checkout": "En option, cette étape peut être complétée après le passage à la caisse.",
        "status": {
          "exempt": "Exonérer",
          "pending": "En attente",
          "pendingTooltip": "Votre statut d’exonération fiscale est en cours d’examen. Des taxes pourraient être appliquées à votre prochaine commande. En cas d’approbation de votre exonération, nous créditerons tous les taxes/frais remboursables sur votre compte.",
          "nonexempt": "Non exempt(e)",
          "rejected": "Rejeté",
          "rejectedTooltip": "Il a été déterminé que le document soumis ne répond pas aux exigences de votre juridiction.",
          "approved": "Approuvé",
          "default": "par défaut"
        },
        "confirm_close": {
          "new_desc": "En quittant le processus de vérification, vous vous exposez à l’application des taxes et frais en vigueur. Vous pourrez toujours soumettre votre document d’exonération fiscale après l’achat, dans la section Gestion de la facturation afin que Zoom l’examine et l’approuve. Après la validation, vous recevrez un remboursement correspondant aux taxes débitées.",
          "desc": "Voulez-vous vraiment abandonner la vérification de l’exonération fiscale et être assujetti aux taxes applicables ?",
          "title": "Êtes-vous sûr ?",
          "new_title": "Abandonner la vérification de l’exonération fiscale ?",
          "yes": "Oui, abandonner",
          "no": "Non, continuer",
          "abandon": "Abandonner la vérification",
          "go_back": "Retour"
        },
        "confirm_to_add": {
          "title": "Confirmer la nouvelle exonération fiscale par défaut",
          "message": "L’ajout d’une nouvelle exonération la définira automatiquement comme valeur par défaut après approbation ou refus. Vous ne pouvez avoir qu’une seule exonération par défaut, applicable aux achats futurs. Le montant de vos taxes pourrait varier si votre exonération par défaut ne correspond pas à l’État ou à la Région de votre adresse de facturation.",
          "yes": "Ajouter une exonération"
        },
        "confirm_set_default": {
          "title": "Incompatibilité entre l’adresse et l’exonération fiscale",
          "message": "L’adresse de facturation ne correspond pas à la valeur État/Région sélectionnée pour l’exonération fiscale. Nous vous invitons à actualiser votre adresse de facturation afin qu’elle concorde avec la zone géographique indiquée pour votre exonération fiscale. À défaut, votre achat risque de ne pas être éligible à l’exonération.",
          "yes": "Définir comme valeur par défaut",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "État/Région",
          "exemption_type": "Type d’exonération",
          "signed_date": "Date de signature",
          "status": "statut",
          "add_exemption": "Ajouter une exonération",
          "view": "Afficher",
          "set_as_default": "Définir par défaut"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Votre forfait {planName} sera résilié le {date} à minuit CET. Si vous souhaitez organiser un événement après la date de résiliation, veuillez réactiver votre forfait.",
        "pairPreDescTip": "Vos forfaits {planName1} et {planName2} seront résiliés le {date} à minuit CET. Si vous souhaitez organiser un événement après la date de résiliation, veuillez réactiver vos forfaits.",
        "pairDiffDatePreDescTip": "Vos forfaits {planName1} et {planName2} seront résiliés respectivement le {date1} à minuit CET et le {date2} à minuit CET. Si vous souhaitez organiser un événement après la date de résiliation, veuillez réactiver vos forfaits.",
        "title": "Réactivez votre forfait pour continuer à l’utiliser",
        "titles": "Réactivez vos forfaits pour continuer",
        "plan": "Forfait",
        "licenses": "Licence(s)",
        "billingCycle": "Cycle de facturation ",
        "effective_date": "Date d’effet",
        "invoice_amount": "Montant de la facture",
        "singleDescTip": "En réactivant votre forfait, vous acceptez qu’il soit automatiquement renouvelé en date du {date} et que le moyen de paiement enregistré dans votre compte soit utilisé pour le règlement à chaque période de renouvellement. Pour éviter des frais ultérieurs, <a target=\"_blank\" href=\"https://support.zoom.com/hc/fr/article?id=zm_kb&sysparm_article=KB0066687\"> annulez</a> au plus tard la veille de la date de renouvellement.",
        "pairDescTip": "En réactivant votre compte, vous acceptez que vos plans récurrents soient automatiquement renouvelés à la {date}. Le moyen de paiement enregistré dans votre compte sera utilisé pour le règlement à chaque période de renouvellement. Pour éviter des frais ultérieurs, <a target=\"_blank\" href=\"https://support.zoom.com/hc/fr/article?id=zm_kb&sysparm_article=KB0066687\"> annulez</a> au plus tard la veille de la date de renouvellement.",
        "pairDiffDateDescTip": "En réactivant, vous acceptez que vos forfaits renouvelables soient automatiquement renouvelés le {date1} et le {date2}. Votre méthode de paiement sera débitée à chaque période de renouvellement. Pour éviter des frais ultérieurs, <a target=\"_blank\" href=\"https://support.zoom.com/hc/fr/article?id=zm_kb&sysparm_article=KB0066687\"> annuler</a> au plus tard la veille de la date de renouvellement.",
        "totalLabel": "Total ",
        "totalContent": "{money} plus les taxes applicables",
        "taxDesc": "hors TVA, TPS ou taxes similaires",
        "reactivateBtn": "Continuer et réactiver",
        "switchTitle": "Mettez votre forfait à jour pour continuer à l’utiliser",
        "successSingleTip": "Votre forfait {planName} a été réactivé",
        "successPairTip": "Vos forfaits {planName1} and {planName2} ont été réactivés",
        "switchTip": "Votre forfait Zoom Webinars d’un mois arrive à expiration le {date}. Pour organiser un webinaire après cette date, vous devez souscrire un abonnement.",
        "switchBtn": "S’abonner"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Affaires Zoom Workplace"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Affaires Plus Zoom Workplace"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "T\u00E9l\u00E9charger la fiche technique"
      },
      "one": {
        "new": "NOUVEAU"
      }
    },
    "webinarSetupInWebPortal": "Configuration de webinaires sur le portail web",
    "concurrentEvents": "Événements concomitants",
    "coucurrentEventsToolTip": "<span>Un <b>abonnement</b> prend en charge un seul événement en direct à la fois",
    "overages": "Frais de dépassement",
    "eventsPlatformHubs": "Hubs de la plateforme Zoom Events",
    "eventsHubToolTip": "Les <b>hubs</b> Zoom Events facilitent l’organisation de vos événements",
    "1HubPerLicense": "1 hub par licence",
    "1000Hubs": "1 000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Hôtes de la plateforme Zoom Events (500 participants ou plus)",
    "eventsHost500": "<span>Nombre d’événements Zoom Events que les <b>hôtes de hub</b> peuvent créer",
    "5HubHosts": "5 hôtes de hub",
    "100HubHosts": "100 hôtes de hub",
    "eventsPlatformHosts_100Attendees": "Hôtes de la plateforme Zoom Events (100 participants)",
    "eventsHost100": "<span>Nombre d’événements Zoom Events que les <b>hôtes de hub</b> peuvent créer",
    "2HubHosts": "2 hôtes de hub",
    "howAreTheyDifferent": "En quoi sont-ils différents ?",
    "allPlansRequireAZoomOneLicense": "* Tous les forfaits nécessitent une licence Zoom Workplace",
    "subscription": "Abonnement",
    "subscriptionToolTip": "<span>Un <b>abonnement</b> vous permet d’organiser un nombre illimité d’événements avec la capacité choisie.</span>",
    "payPerAttendee": "Tarification par participant",
    "ppaToolTips": "<span>La licence <b>Tarification par participant</b> détermine le nombre total de participants  pouvant assister à l’ensemble des événements organisés par votre compte dans les 12 mois suivant son achat.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Sondage",
    "meetings.fullPlanItem2": "Nombre de licences",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "R\u00E9unions Zoom",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Solution simplifiée de visioconférence et de messagerie pour tous les appareils",
    "meetings.fullPlanItem5": "Dur\u00E9e des r\u00E9unions",
    "meetings.fullPlanItem5Tip": "La dur\u00E9e maximum autoris\u00E9e par r\u00E9union de groupe (3 participants ou plus).",
    "meetings.fullPlanItem5_basic": "40 minutes",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 heures",
    "meetings.fullPlanItem5_biz": "30 heures",
    "meetings.fullPlanItem5_ent": "30 heures",
    "meetings.fullPlanItem1": "Nombre maximum de participants",
    "meetings.fullPlanItem1Tip": "Un participant est un invit\u00E9 dans une r\u00E9union programm\u00E9e par quelqu\u2019un poss\u00E9dant une licence de r\u00E9union. Les participants peuvent rejoindre votre r\u00E9union gratuitement depuis leur t\u00E9l\u00E9phone, ordinateur de bureau, appareil mobile et tablette. Un participant n\u2019a pas besoin d\u2019avoir un compte Zoom pour rejoindre une r\u00E9union. Chaque forfait a un nombre maximum de participants, mais les utilisateurs peuvent augmenter cette limite sur les forfaits pay\u00E9s en achetant des extensions.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1 000 pour Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Enregistrement",
    "meetings.fullPlanItem7Tip": "L\u2019enregistrement local de Zoom sauvegarde vos enregistrements de r\u00E9union aux formats MP4 (vid\u00E9o), M4A (audio) et texte (chat).<br>L\u2019enregistrement sur le cloud Zoom stocke les r\u00E9unions sur le cloud Zoom, o\u00F9 le fichier peut \u00EAtre t\u00E9l\u00E9charg\u00E9 et/ou diffus\u00E9 en continu via un navigateur.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local et cloud de 5 Go (par licence)",
    "meetings.fullPlanItem7_biz": "Local et cloud de 10 Go (par licence)",
    "meetings.fullPlanItem7_ent": "Local et cloud illimit\u00E9",
    "one.messaging": "Messagerie",
    "meetings.fullPlanItem16Tip": "Avec la discussion, envoyez facilement du texte \u00E0 un groupe, des fichiers, des captures d\u2019\u00E9cran, des extraits de code, des messages vocaux et des images. Le texte peut \u00EAtre format\u00E9 et les utilisateurs peuvent aussi partager des GIF et des emojis. La pr\u00E9sence affiche si les participants aux discussions sont actifs sur leur ordinateur de bureau ou appareil mobile ou occup\u00E9s en r\u00E9union.",
    "meetings.fullPlanItem51": "Tableaux blancs Zoom",
    "meetings.unlimited": "Illimit\u00E9s",
    "meetings.fullPlanItem_EssentialApp": "Applications essentielles",
    "common.learnMore": "En savoir plus",
    "meetings.fullPlanItem_EssentialAppText": "Applications Premium gratuites pendant 1 an (des conditions s’appliquent)",
    "zoomMailAndCalendarInTheZoomApp": "Messagerie et calendrier Zoom dans l’application Zoom",
    "mailService": "Service de messagerie",
    "emailServiceWithFullTimeEndToEnd": "Service de messagerie avec chiffrement de bout en bout permanent pour une confidentialité avancée",
    "customMailDomain": "Domaine de messagerie personnalisé",
    "customMailDomainWithMailService": "Domaine de messagerie personnalisé avec service de messagerie",
    "calendarClient": "Client de calendrier",
    "scheduleAndJoinMeetings": "Programmez et rejoignez des réunions dans l’application Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Service de calendrier",
    "meetingSchedulingAndAppointment": "Programmation de réunions et planification de rendez-vous",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Créez, modifiez et partagez de courtes vidéos, sans effort. Les clips enregistrés sont aisément accessibles, ce qui favorise l’engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes est un éditeur de documents personnel et collaboratif efficace offrant de nombreuses options de mise en forme, qui est accessible aussi bien dans les réunions qu’en dehors.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Sous-titres traduits",
    "workspaceReservation": "Réservation d’un espace de travail",
    "accessAcrossAnyDevice": "Accessible sur n’importe quel appareil",
    "meetings.fullPlanItem4": "R\u00E9unions illimit\u00E9es",
    "meetings.fullPlanItem9": "Participation par t\u00E9l\u00E9phone",
    "meetings.fullPlanItem9Tip": "Rejoindre une r\u00E9union Zoom par t\u00E9l\u00E9conf\u00E9rence/audioconf\u00E9rence (\u00E0 l\u2019aide d\u2019un t\u00E9l\u00E9phone traditionnel). Les utilisateurs sont factur\u00E9s conform\u00E9ment \u00E0 leur forfait t\u00E9l\u00E9phonique. Essayez notre option Audioconf\u00E9rence pour les num\u00E9ros d\u2019acc\u00E8s gratuits.",
    "meetings.fullPlanItem9_pro": "Payant",
    "meetings.fullPlanItem9_biz": "Payant",
    "meetings.fullPlanItem9_ent": "Payant",
    "meetings.fullPlanItem11": "Partage d\u2019\u00E9cran",
    "meetings.fullPlanItem11Tip": "Partage du bureau et d\u2019applications. Les utilisateurs de r\u00E9unions d\u00E9tenteurs de licence peuvent choisir d\u2019autoriser plusieurs participants \u00E0 partager leurs \u00E9crans simultan\u00E9ment lors d\u2019une r\u00E9union qu\u2019ils organisent.",
    "meetings.fullPlanItem12": "Salles de r\u00E9partition",
    "meetings.fullPlanItem12Tip": "Des salles de r\u00E9partition vid\u00E9o vous permettent de r\u00E9partir votre r\u00E9union Zoom en plusieurs sessions distinctes (jusqu\u2019\u00E0 50 sessions) par discussion, projet, etc.",
    "meetings.fullPlanItem14": "Arri\u00E8re-plan virtuel",
    "meetings.fullPlanItem15": "N\u00BA personnel de r\u00E9union",
    "meetings.fullPlanItem15Tip": "Cr\u00E9ez votre propre salle de r\u00E9union en ligne permanente. Vous pouvez commencer cette r\u00E9union \u00E0 tout moment ou programmer son utilisation future.",
    "meetings.fullPlanItem17": "Contr\u00F4les de l\u2019h\u00F4te",
    "meetings.fullPlanItem18": "Co-annotation sur partage d\u2019\u00E9cran",
    "meetings.fullPlanItem19": "Contr\u00F4le de la souris et du clavier \u00E0 distance",
    "meetings.fullPlanItem21": "Partage multiple",
    "meetings.fullPlanItem29": "Salle d\u2019attente",
    "meetings.fullPlanItem29Tip": "La fonctionnalit\u00E9 Salle d\u2019attente permet \u00E0 l\u2019h\u00F4te de ma\u00EEtriser \u00E0 quel moment un participant rejoint la r\u00E9union. En tant qu\u2019h\u00F4te de la r\u00E9union, vous pouvez accueillir les participants un par un ou tous en m\u00EAme temps. Dans les param\u00E8tres, vous pouvez choisir qui est plac\u00E9 en salle d\u2019attente et qui est admis automatiquement. Tous les comptes disposent de la fonctionnalit\u00E9 Salle d\u2019attente. Les h\u00F4tes peuvent envoyer des messages \u00E0 la salle d\u2019attente. Vous pouvez personnaliser la salle d\u2019attente si vous disposez d\u2019un forfait pay\u00E9.",
    "meetings.fullPlanItem41": "Int\u00E9gr\u00E9 aux appareils Zoom for Home",
    "meetings.fullPlanItem61": "\u00C9pingler plusieurs personnes",
    "meetings.fullPlanItem61Tip": "L'h\u00F4te peut autoriser jusqu'\u00E0 9 personnes \u00E0 \u00E9pingler des vid\u00E9os pour qu'elles cr\u00E9ent leur propre vue personnalis\u00E9e. Peu importe la personne ayant la parole, les vid\u00E9os \u00E9pingl\u00E9es resteront visibles.",
    "meetings.fullPlanItem62": "Mettre en \u00E9vidence plusieurs personnes",
    "meetings.fullPlanItem62Tip": "L'h\u00F4te peut mettre en \u00E9vidence jusqu'\u00E0 9 vid\u00E9os de participant, afin que tous les participants puissent voir les vid\u00E9os mises en avant, peu importe la personne ayant la parole.",
    "meetings.fullPlanNewItem1": "Filtres",
    "meetings.fullPlanNewItem1Tip": "\u00C9gayez vos f\u00EAtes et vos Happy Hours avec nos filtres couleurs ou nos autocollants d\u00E9coratifs animaliers.",
    "meetings.fullPlanNewItem2": "Sondage",
    "meetings.fullPlanNewItem3": "Co-h\u00F4te et h\u00F4te suppl\u00E9ant",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/fr/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">En savoir plus sur les contr\u00F4les des co-h\u00F4tes pour les r\u00E9unions.</a>",
    "meetings.fullPlanItem24": "Attribuer le programmateur de r\u00E9unions",
    "meetings.fullPlanItem24Tip": "Vous permet de d\u00E9l\u00E9guer l\u2019organisation de vos r\u00E9unions. Le d\u00E9l\u00E9gataire doit aussi avoir un forfait Pro.",
    "meetings.fullPlanItem25": "API REST",
    "meetings.fullPlanItem25Tip": "Permet \u00E0 vos titulaires de comptes, administrateurs et d\u00E9veloppeurs d\u2019acc\u00E9der \u00E0 l\u2019API REST de Zoom en toute s\u00E9curit\u00E9. Des Limites de d\u00E9bit API s\u2019appliquent au niveau du compte selon le Type de compte (Pro, Affaires, Enterprise, etc.) et le Type de demande API (l\u00E9g\u00E8re, moyenne, lourde, etc.). L\u2019acc\u00E8s de certaines API est limit\u00E9 \u00E0 des types de comptes sp\u00E9cifiques. Pour toutes les pr\u00E9cisions, veuillez consulter Limites de d\u00E9bit API et la Documentation de r\u00E9f\u00E9rence API.",
    "meetings.fullPlanItem25_pro": "Limites de d\u00E9bit de l\u2019API REST Pro",
    "meetings.fullPlanItem25_biz": "Limites de d\u00E9bit de l\u2019API REST",
    "meetings.fullPlanItem26": "Compatibilit\u00E9 avec Skype Entreprise (Lync)",
    "meetings.fullPlanItem26Tip": "Permet aux utilisateurs de Lync 2010, 2013 et de Skype Entreprise de lancer une r\u00E9union Zoom \u00E0 partir de la liste de contacts de Lync.",
    "meetings.fullPlanItem27": "Diffusion en direct",
    "meetings.fullPlanItem27Tip": "Diffusez en direct sur Facebook, Youtube ou un autre service.",
    "meetings.fullPlanItem28": "Rapports",
    "meetings.fullPlanItem28Tip": "Enregistrez les sessions de tableau blanc",
    "meetings.fullPlanItem30": "Gestion des utilisateurs",
    "meetings.fullPlanItem30Tip": "Les titulaires et les administrateurs peuvent ajouter, supprimer et attribuer des r\u00F4les ou des fonctionnalit\u00E9s suppl\u00E9mentaires.",
    "one.autoCaptions": "Sous-titres automatisés",
    "meetings.fullPlanItem31": "Portail administrateur",
    "meetings.fullPlanItem31Tip": "G\u00E9rez les utilisateurs de votre entreprise dans un compte unique, pour simplifier la facturation, d\u00E9finir les param\u00E8tres de gestion des utilisateurs avanc\u00E9s et obtenir des statistiques d\u2019usage compl\u00E8tes : tout cela se trouve dans le Portail administrateur Zoom.",
    "meetings.fullPlanItem32": "Int\u00E9gration des technologies d\u2019apprentissage (IOA)",
    "meetings.fullPlanItem32Tip": "Greffez facilement une r\u00E9union sur une session de formation et invitez les \u00E9tudiants depuis votre syst\u00E8me de gestion de l\u2019apprentissage (compatible avec Moodle, Canvas, Desire2Learn et Blackboard).",
    "meetings.fullPlanItem33": "Transcriptions des enregistrements sur le cloud",
    "meetings.fullPlanItem33Tip": "Les transcriptions d\u2019enregistrement sur le cloud sont des transcriptions audio d\u2019une r\u00E9union ou d\u2019un webinaire que vous enregistrez sur le cloud. Veuillez noter que ceci n\u2019est actuellement pris en charge que pour l\u2019anglais. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> pour en savoir plus.",
    "meetings.fullPlanItem34": "Personnalisation",
    "meetings.fullPlanItem34Tip": "Ajoutez la marque de votre entreprise \u00E0 votre propre page personnalis\u00E9e \u00E0 partir de laquelle vos utilisateurs peuvent rejoindre une r\u00E9union. Cr\u00E9ez un mod\u00E8le d\u2019e-mail personnalis\u00E9 pour votre marque pour envoyer des invitations aux participants.",
    "meetings.fullPlanItem35": "Domaines g\u00E9r\u00E9s",
    "meetings.fullPlanItem35Tip": "Utilisez le domaine d\u2019adresse e-mail de votre entreprise/universit\u00E9 pour ajouter des utilisateurs \u00E0 votre compte automatiquement.",
    "meetings.fullPlanItem37": "Interpr\u00E9tation",
    "meetings.fullPlanItem37Tip": "Permet \u00E0 l\u2019organisateur d\u2019une r\u00E9union de d\u00E9signer des interpr\u00E8tes dans leurs r\u00E9unions et webinaires. Au moment du d\u00E9marrage de la r\u00E9union ou du webinaire, l\u2019organisateur peut activer la fonction d\u2019interpr\u00E9tation, qui permettra aux interpr\u00E8tes d\u2019acc\u00E9der \u00E0 leurs propres canaux audio. Les participants peuvent choisir un canal audio pour \u00E9couter la langue de leur choix. Les participants entendront la version traduite et peuvent choisir d\u2019entendre la version originale \u00E0 un volume plus bas.",
    "meetings.fullPlanItem39": "Revues de performance de la direction",
    "meetings.fullPlanItem39Tip": "Analyse d\u00E9taill\u00E9e des tendances d\u2019adoption, suivi du RSI, discussions des feuilles de route produits.",
    "meetings.fullPlanNewItem4": "Comprend Webinar 500",
    "one.translatedCations": "Sous-titres traduits",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, canal ou chat de groupe",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Communiquez facilement par messages individuels, en petits groupes ou avec de grandes équipes",
    "messageAndFileHistory": "Historique des messages et des fichiers",
    "findPeopeChannelsAndFilesInSearch": "Rechercher des personnes, des canaux et des fichiers",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Trouvez rapidement tous vos contacts, messages instantanés, chats de groupe et fichiers, et accédez facilement à vos informations.",
    "applicationIntegrations": "Intégrations aux applications",
    "secureFileSharing": "Partage de fichiers sécurisé",
    "enhanceCollaborationWithSeamlessFileSharing": "Améliorez la collaboration grâce au partage de fichiers transparent",
    "persistentMeetingChat": "Chat de réunion permanent",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Ne perdez jamais le fil des conversations de réunion. Échangez avant, pendant et après une réunion dans Zoom Team Chat par le biais d’un chat de groupe dédié intégrant tous les participants.",
    "cloudStorage": "Stockage sur le cloud",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Sauvegardez les canaux dans le cloud Zoom ou auprès d’un fournisseur de stockage tiers",
    "avatars": "Avatars",
    "inMeetingReactions": "Avis sur la réunion",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Montrez votre intérêt et communiquez rapidement avec les autres participants sans parler",
    "virtualBackgrounds": "Arrière-plans virtuels",
    "videoFilters": "Filtres vidéo",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Égayez vos réunions en superposant divers filtres à votre vidéo",
    "inMeetingPollsAndQuizzes": "Sondages et quiz pendant la réunion",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Créez des questions à choix unique ou à choix multiples concernant vos réunions.",
    "liveStreamingAcrossPlatforms": "Diffusion en direct sur toutes les plateformes",
    "appearanceTouchUp": "Retouches",
    "originalSoundForMusicians": "Son original pour les musiciens",
    "endToEndEncryptionForZoomMeetings": "Chiffrement de bout en bout pour Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Lorsqu'il est activé, le chiffrement de bout en bout (E2EE) de Zoom pour Zoom Meetings signifie que les communications entre tous les participants à une réunion utilisant Zoom desktop client dans une réunion donnée sont chiffrées à l'aide de clés cryptographiques connues uniquement par les appareils de ces participants. Ainsi, aucun tiers ne peut accéder aux clés privées de la réunion, Zoom y compris.",
    "zoomCustomerManagedKey": "Clé gérée du client de Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Utilisez vos propres clés de chiffrement pour protéger les données Zoom non utilisées",
    "enterpriseGradeSecurityFeatures": "Fonctionnalités de sécurité de qualité professionnelle",
    "256BitAesGcmEncryptionForRealTimeContent": "Le chiffrement AES-GCM 256 bits pour le contenu et les médias en temps réel, le chiffrement TLS lors de l’enregistrement SIP, le masquage du n° de l’appelant, l'appairage de réseaux privés, la détection de fraude d’outils et les listes de blocage d’appels.",
    "phone.fullPlanItem40": "Authentification unique via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Appels internes illimit\u00E9s",
    "phone.fullPlanItem2": "Appels sortants mesur\u00E9s",
    "phone.fullPlanItem3": "Appels sortants illimit\u00E9s",
    "phone.fullPlanItem4": "La meilleure qualit\u00E9 d\u2019appel HD du secteur",
    "phone.fullPlanItem4Tip": "Avec suppression de bruit active, \u00E9limination de l\u2019\u00E9cho et des bruits du clavier",
    "phone.fullPlanItem5": "Applis de bureau Windows, MacOS et Linux natives",
    "phone.fullPlanItem6": "Applis mobiles natives pour iOS et Android",
    "phone.fullPlanItem7": "Portez des num\u00E9ros existants ou achetez-en de nouveaux (DID)",
    "phone.fullPlanItem8": "Num\u00E9ros gratuits",
    "phone.fullPlanItem9": "Num\u00E9ro de poste",
    "phone.fullPlanItem10": "Message vocal avec transcription",
    "phone.fullPlanItem10Tip": "Acc\u00E8s aux transcriptions de messages vocaux via les applis mobiles/de bureau et par e-mail.",
    "phone.fullPlanItem11": "R\u00E9ceptionnistes automatiques illimit\u00E9es/RVI",
    "phone.fullPlanItem12": "R\u00E9pertoire avec recherche par nom",
    "phone.fullPlanItem13": "Groupes de distribution automatique des appels (ACD) avec file d\u2019attente des appels",
    "phone.fullPlanItem14": "Interruption/surveillance/murmure/prise de contr\u00F4le",
    "phone.fullPlanItem15": "Routage pendant les vacances et les heures de bureau",
    "phone.fullPlanItem16": "Conf\u00E9rences t\u00E9l\u00E9phoniques ad hoc \u00E0 3",
    "phone.fullPlanItem17": "Enregistrement d\u2019appel",
    "phone.fullPlanItem17Tip": "L\u2019enregistrement automatique et manuel des appels est possible.",
    "phone.fullPlanItem18": "Blocage des appels anonymes et sp\u00E9cifi\u00E9s configurable",
    "phone.fullPlanItem19": "Appels d\u2019urgence",
    "phone.fullPlanItem19Tip": "Appels aux services d\u2019urgence locaux",
    "phone.fullPlanItem20": "Adresse E911 nomade (\u00C9tats-Unis et Canada) -",
    "phone.fullPlanItem20Tip": "D\u00E9tecte de mani\u00E8re dynamique l\u2019emplacement de l\u2019utilisateur et signale l\u2019adresse d\u2019urgence correspondante aux services d\u2019urgence locaux (\u00C9tats-Unis et Canada uniquement) et \u00E0 l\u2019\u00E9quipe de s\u00E9curit\u00E9 interne.",
    "phone.fullPlanItem21": "Centre de r\u00E9ponse d\u2019urgence",
    "phone.fullPlanItem21Tip": "Permet \u00E0 votre \u00E9quipe en charge de la s\u00E9curit\u00E9 d\u2019\u00EAtre alert\u00E9e des appels aux urgences et d\u2019enregistrer/de surveiller/d\u2019intervenir dans les appels aux urgences pour aider \u00E0 coordonner la r\u00E9ponse.",
    "phone.fullPlanItem22": "Apparence des lignes partag\u00E9es/d\u00E9l\u00E9gation",
    "phone.fullPlanItem23": "Transfert d\u2019appels entre appareils",
    "phone.fullPlanItem24": "Parc d\u2019appels",
    "endToEndEncryptionForZoomPhone": "Chiffrement de bout en bout pour Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Lorsqu'il est activé pour Zoom Phone, le chiffrement de bout en bout (E2EE) permet de chiffrer l'appel à l'aide de clés cryptographiques connues uniquement par les appareils de l'appelant et du destinataire. Ces derniers auront également la possibilité de vérifier le statut E2EE en se fournissant mutuellement un code de sécurité unique.",
    "phone.fullPlanItem43": "Fourniture des t\u00E9l\u00E9phones sans intervention (ou \u00AB Zero Touch \u00BB)",
    "phone.fullPlanItem44": "M\u00E9lange de types de forfaits dans un compte",
    "phone.fullPlanItem46": "Rapports en temps r\u00E9el et tableaux de bord de qualit\u00E9",
    "phone.fullPlanItem47": "Prise en charge des infrastructures de bureau virtuel (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">En savoir plus</a> \u00E0 propos de la VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Disponible pour tous les clients téléphone autonomes. La prise en charge des forfaits varie lorsqu’ils sont associés à des forfaits réunions.",
    "phone.fullPlanItem49": "Prise en charge du service Apportez votre propre op\u00E9rateur (BYOC)",
    "phone.fullPlanItem49Tip": "Prise en charge du jumelage direct et bas\u00E9 sur le site vers votre prestataire de service RTC existant",
    "phone.fullPlanItem50": "Int\u00E9gration hybride aux PBX historiques",
    "phone.fullPlanItem51": "Messagerie instantanée vocale",
    "phone.fullPlanItem61": "Fax en ligne",
    "phone.fullPlanItem61Tip": "Envoyez et recevez des fax aux États-Unis et au Canada de façon illimitée. Pour les fax internationaux, <a href=\"{href}\" target=\"_blank\" style=\"color : #0B5CFF;\"> voir les prix</a>",
    "phone.fullPlanSms": "SMS et MMS",
    "phone.fullPlanSmsTip": "Disponibles uniquement pour les num\u00E9ros aux \u00C9tats-Unis et au Canada, avec l'achat d'un forfait d'appel. Disponible pour les num\u00E9ros directs (pas les num\u00E9ros d'entreprise).",
    "meetings.fullPlanItem6": "Assistance technique",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Ticket uniquement",
    "meetings.fullPlanItem6_pro": "Ticket et discussion en direct",
    "meetings.fullPlanItem6_biz": "Ticket, chat en direct et t\u00E9l\u00E9phone",
    "meetings.fullPlanItem6_ent": "Ticket, chat en direct et t\u00E9l\u00E9phone",
    "knowledgeBase": "Base de connaissances",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Résolvez les problèmes techniques et accédez à des ressources d’aide en consultant les articles de notre base de connaissances.",
    "zoomCommunity": "Communauté Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Un endroit pour trouver des solutions, poser des questions et collaborer avec d’autres utilisateurs de Zoom.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Obtenez des réponses à vos questions et résolvez les problèmes techniques en interagissant avec notre chatbot.",
    "submitWebTickets": "Soumettre des tickets en ligne",
    "liveChatSupport": "Assistance par chat en direct",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Abonnements supérieurs à {amount} USD/mois",
    "livePhoneSupport": "Assistance téléphonique en direct",
    "meetWithAgentOnVideo": "Rencontrer un agent en vidéo",
    "subscriptionPlansGreaterThan_200UsdMonth": "Abonnements supérieurs à 200 USD/mois",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Stimulez la productivité en utilisant vos applications préférées directement dans Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Personnalisez votre avatar pour vous présenter de manière plus conviviale et dynamique dans les réunions sans activer la caméra",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Messagerie",
    "common.plans.meeting.title": "Réunions",
    "plans.basic_free.upgrade.item1": "Jusqu’à 30 heures par réunion",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "par réunion",
    "common.participant_limit.increase_with_large_meetings": "Encore plus avec le forfait Grande réunion",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Tableau blanc",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Illimité",
    "common.plans.team_chat.title": "Chat de groupe",
    "common.plans.mail_calendar.title": "Messagerie et calendrier",
    "common.plans.cloud_storage.title": "Stockage dans le cloud",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Sous-titres traduits de Zoom",
    "common.plans.extras.title": "Extra",
    "common.plans.extras.desc": "gérer les domaines de l’entreprise, et plus encore",
    "zoom_one_edu_bundle.school.title": "Forfait Zoom One pour l’Éducation École et campus",
    "zoom_one_edu_bundle.school_plus.title": "Forfait Zoom One pour l’Éducation École et campus Plus",
    "per_billing_cycle_license.monthly": "/mois/licence",
    "per_billing_cycle_license.yearly": "/an/licence",
    "per_billing_cycle_space.monthly": "/mois/espace",
    "per_billing_cycle_space.yearly": "/année/espace",
    "common.dialog.feature_list": "Voir la liste complète des fonctionnalités",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 Go par licence",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 Go par licence",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Entreprise Plus comprend Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Connecteur de la salle de conférence (ratio 1:25)",
    "plans.whiteboard.ent": "Entreprise Plus comprend Unlimited Plus",
    "plans.zp.ent": "Inclus dans Entreprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Réservation d’un espace de travail sur site ou avancée, et plus encore",
    "plans.largeMeeting.intro_tip": "Grandes réunions est un module d’extension en option que vous pouvez ajouter lors du paiement pour porter le nombre maximum de participants à 500 ou à 1 000, en fonction de la licence achetée.",
    "common.participant_limit.expandable_with_large_meetings": "Extension possible avec l’option Grande réunion",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1 000 pour Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Entreprise Plus comprend Zoom Sessions 1000 (qui comprend Zoom Webinars)",
    "per_billing_cycle_user.monthly": "/mois/utilisateur",
    "per_billing_cycle_user.annually": "/an/utilisateur",
    "closeComparisonChart": "Fermer le tableau de comparaison",
    "archiving_api": "API d’archivage",
    "dlp_api": "API DLP",
    "info_barriers": "Cloisonnement des informations",
    "chat_etiquette": "Étiquette Chat",
    "gdrp": "RGPD",
    "regiona_data_centers": "Centres de données régionaux",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Chiffrement par défaut",
    "end_to_end_encryption": "Chiffrement de bout en bout",
    "cryptographic_boundary": "Frontière cryptographique",
    "vdi": "Bureau virtuel (VDI)",
    "customer_managed_key": "Clé gérée des clients",
    "gpo_msi_policies": "Politiques GPO/MSI",
    "msi": "Déploiement de masse (MSI)",
    "ntt": "Outil de test du réseau (NTT)",
    "dashboards": "Tableaux de bord",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Survivabilité de Zoom Phone",
    "zoom_meeting_survivability": "Survivabilité de Zoom Meetings",
    "paid_option": "Option payante",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Principales fonctionnalités",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "École et campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "École et campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "id-ID": {
    "billing.essential_apps": "Aplikasi Penting",
    "billing.essential_apps.dialog_desc": "Kembangkan dan kelola bisnis Anda dengan aplikasi yang membuat catatan rapat, melibatkan tim Anda dengan aktivitas interaktif, dan memberikan wawasan untuk meningkatkan percakapan pelanggan. Aplikasi premium gratis termasuk dalam paket Anda selama 1 tahun.",
    "billing.see_more_details": "Lihat detail selengkapnya",
    "billing.essential_app.legal_copy": "Penawaran hanya berlaku untuk pengguna dengan lisensi saat ini, mulai atau setelah 4 Januari 2023, di bawah langganan Zoom One Pro, Bisnis, atau Bisnis Plus yang dibeli melalui saluran online Zoom di zoom.us/buy. Pengguna yang langganannya terkait dengan akun Layanan Kesehatan, Pendidikan, atau Pemerintahan tidak memenuhi syarat untuk penawaran ini.  Akses ke setiap aplikasi, kecuali Coda, dimulai setelah aktivasi aplikasi oleh masing-masing pengguna dan berakhir 1 tahun setelahnya. Akses ke Coda untuk semua pengguna di akun Zoom yang sama dimulai saat aktivasi pertama Coda oleh pengguna mana pun di akun Zoom yang sama dan berakhir untuk semua pengguna di akun Zoom tersebut 1 tahun setelahnya, terlepas dari tanggal awal aktivasi oleh pengguna berikutnya pada akun Zoom yang sama.Untuk semua aplikasi, penugasan ulang atau pembatalan lisensi atau langganan yang memenuhi syarat milik pengguna akan mengakhiri akses untuk pengguna tersebut, terlepas dari apakah masih ada sisa waktu pada periode akses 1 tahun.Setiap aplikasi tunduk pada ketentuan penggunaan dan kebijakan privasi yang tersedia pada saat aktivasi.Aplikasi yang disertakan hanya didukung dalam bahasa Inggris.Tidak semua aplikasi berfungsi di ponsel.Penawaran tidak dapat ditukarkan atau dikembalikan dengan uang tunai.Penawaran hanya berlaku untuk aplikasi ini yang termasuk dalam <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Aplikasi Pening di Zoom App Marketplace</a>. Pengguna yang memiliki langganan sebelumnya ke salah satu aplikasi tidak memenuhi syarat untuk penawaran ini sehubungan dengan aplikasi tertentu.Zoom berhak mengubah atau membatalkan penawaran ini kapan saja tanpa pemberitahuan dan tanggung jawab sebelumnya.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Manajemen Pengunjung"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Obrolan Langsung & Dukungan Telepon 24x7"
      },
      "learn_more": "Pelajari Selengkapnya",
      "new": "Baru",
      "plan_details": {
        "meeting": {
          "title": "Rapat",
          "host_meeting_up_to_participants": "Adakan rapat dengan kapasitas hingga {0} peserta",
          "meeting_hours": "Toplantı başına 30 saate varan sınırsız toplantılar",
          "recording_storage": "Penyimpanan rekaman cloud sebesar {0} GB (per lisensi)",
          "auto_captions": "Teks otomatis"
        },
        "whiteboard": {
          "title": "Papan Tulis",
          "boards_storage": "{0} papan yang dapat diedit",
          "standard_features": "Fitur standar"
        },
        "team_chat": {
          "title": "Obrolan Tim",
          "desc": "Obrolan grup & berbagi file"
        },
        "main_calendar": {
          "title": "Email & Kalender",
          "desc": "Email dan Klien & Layanan Kalender"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Buat dan bagikan dokumen yang dapat diedit di dalam Zoom",
          "desc2": "Catatan pribadi dan kolaboratif dengan pengeditan teks yang kaya"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Rekam, edit, dan bagikan video pendek dengan mudah",
          "desc2": "Video tak terbatas dan fitur canggih"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Dapatkan akses cepat ke ringkasan rapat, bantuan dalam menyusun pesan, dan banyak lagi"
        },
        "EssentialApp": {
          "title": "Aplikasi Penting",
          "desc1": "Aplikasi premium gratis selama 1 tahun (syarat berlaku)",
          "desc2": "Meningkatkan kolaborasi dan produktivitas tim"
        },
        "livechat": {
          "title": "Dukungan obrolan langsung"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Beralih ke Zoom Workplace Pro?",
            "content": "Anda sebelumnya telah memilih Zoom Workplace Bisnis yang memungkinkan hingga 300 peserta per rapat, Zoom Scheduler, dan banyak lagi. Apakah Anda masih ingin beralih ke Pro?",
            "confirm": "Konfirmasi Perubahan",
            "keep_current": "Pertahankan Paket Saat Ini"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} peserta",
          "participants": "{0} Peserta",
          "user_range": "{0}-{1} pengguna",
          "items": "{num} item"
        },
        "button": {
          "ok": "OK",
          "add": "Tambah",
          "buy_now": "Beli Sekarang",
          "try_for_days": "Coba selama {0} hari",
          "contact_sales": "Hubungi Penjualan",
          "close": "Tutup",
          "cancel": "Batal",
          "edit": "Edit",
          "got_it": "Mengerti"
        },
        "title": {
          "everything_in_and": "Semuanya di {0}, dan:"
        },
        "tag": {
          "new": "Baru",
          "free_trial": "Uji Coba Gratis"
        },
        "billing_cycle": {
          "annual": "Tahunan",
          "monthly": "Bulanan",
          "quarterly": "Triwulanan",
          "two_years": "Dua Tahun",
          "three_years": "Tiga Tahun"
        },
        "errors": {
          "unknown_error_try_again": "Kesalahan yang tidak diketahui saat memproses transaksi. Coba lagi nanti."
        },
        "excluding_tax": {
          "vat_tip": "tidak termasuk PPN",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Fitur terbatas",
        "pro_plus": {
          "host_meeting_up_to_participants": "Adakan rapat dengan kapasitas hingga {0} peserta",
          "gb_of_cloud_recording_storage": "Penyimpanan rekaman cloud sebesar {0} GB (per lisensi)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion untuk pembuatan konten dan terjemahan",
            "features_item2": "Jumlah dokumen bersama yang tidak terbatas dengan tim Anda",
            "features_item3": "Akses riwayat versi tanpa batas",
            "comparison_table_tips": "Tingkatkan kolaborasi dengan dokumen yang mengutamakan AI yang mengubah konten rapat menjadi dokumen, wiki, dan proyek yang dapat ditindaklanjuti"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Dasar",
            "features_item1": "Secara otomatis mendeteksi tugas dari seluruh rapat, panggilan telepon, obrolan, dan dokumen Anda",
            "features_item2": "Mendapatkan bantuan dalam menyelesaikan tugas, seperti menjadwalkan rapat tindak lanjut dan membuat draf dokumen",
            "features_item3": "Menandai tugas sebagai selesai dengan mudah setelah selesai agar Anda dapat terus memantau kemajuan Anda dan fokus pada hal berikutnya",
            "features_item4": "Mengelola tugas di seluruh platform Zoom Workplace, termasuk Zoom Docs",
            "features_item1_opc": "Manfaatkan kecanggihan AI Companion untuk mengidentifikasi dan membuat tugas dari obrolan, email, dokumen, papan tulis, dan ringkasan rapat Anda",
            "features_item2_opc": "Mengurutkan, memfilter, mengelompokkan, dan mencari dengan mudah untuk mengakses dan mengumpulkan konteks dengan cepat pada tugas Anda",
            "learn_more_header": "Tetap mengikuti item tindakan dengan AI Companion untuk menyelesaikan lebih banyak hal di seluruh Zoom Workplace.",
            "learn_more_footer": "\*AI Companion hanya tersedia untuk paket Zoom Workplace Pro, Bisnis, dan Perusahaan.",
            "features_prefix": "Biarkan AI Companion membantu Anda:",
            "comparison_table_tips": "Tetap mengikuti item tindakan dan selesaikan item tersebut tepat waktu dengan solusi berbasis AI yang memberikan rekomendasi tugas berdasarkan percakapan dan ringkasan rapat di Zoom Workplace.",
            "tasks_label_text": " Manajemen tugas berbasis AI"
          },
          "title": "Bisnis Plus",
          "contact_us_for_more_pricing": "Hubungi kami untuk mengetahui informasi harga dan lainnya",
          "contact_sales": "Hubungi Penjualan",
          "meetings": "Rapat",
          "phone": "Telepon",
          "phone_sub_title": "Panggilan Tanpa Batas",
          "use_only": "Penggunaan bisnis saja",
          "team_chat": {
            "title": "Obrolan Tim",
            "title_desc": "Obrolan grup & berbagi file"
          },
          "cloud_storage": {
            "title": "Penyimpanan Cloud"
          },
          "mail_calender": {
            "title": "Email & Kalender"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Klien & layanan"
          },
          "up_to_30_hours_per_meeting": "toplantı başına 30 saate varan süre sınırı",
          "300_attendees": "300 peserta",
          "per_meeting": "per rapat",
          "whiteboard": {
            "title": "Papan Tulis"
          },
          "new": "Baru",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Tambahan",
          "sso_managed_domains_more": "SSO, domain terkelola & banyak lagi",
          "scheduler": "Penjadwalan",
          "global_select": "Global Select",
          "unlimited_regional": "Regional tanpa batas",
          "translated_captions": "Teks yang Diterjemahkan",
          "workspace_reservation": "Reservasi Ruang Kerja",
          "auto_translated_captions": "Teks Otomatis dan yang Diterjemahkan",
          "unlimited_editable_boards": "Papan yang dapat diedit tanpa batas",
          "standard_features": "Fitur standar",
          "advanced_docu_controls": "Kontrol dokumen lanjutan",
          "chats_channels_for_collaboration": "Obrolan dan saluran untuk kolaborasi, berbagi file, dan banyak lagi",
          "zoom_phone_is_biz_use_only": "Zoom Phone hanya untuk penggunaan bisnis",
          "unlimited_regional_calling": "Panggilan Regional Tanpa Batas",
          "domestic_sms_mms": "SMS & MMS Domestik",
          "automatic_call_distribution_groups": "Grup distribusi panggilan otomatis (ACD) dengan antrean panggilan",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Domain terkelola",
          "company_branding": "Branding perusahaan",
          "mail_calender_client_services_beta": "Email dan Klien & Layanan Kalender beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Toplantı başına 30 saate varan sınırsız toplantılar",
          "mail_and_calendar_client_and_services_beta": "Email dan Klien & Layanan Kalender beta",
          "easily_record_edit_share_videos": "Rekam, edit, dan bagikan video pendek dengan mudah",
          "unlimited_videos_advanced_features": "Video tak terbatas dan fitur canggih",
          "create_share_editabel_docu_within_zoom": "Buat dan bagikan dokumen yang dapat diedit di dalam Zoom",
          "personal_collaborative_notes_rich_text_editing": "Catatan pribadi dan kolaboratif dengan pengeditan teks yang kaya",
          "effortlessly_share_meeting": "Bagikan slot rapat dengan mudah untuk memudahkan pemesanan",
          "works_with_zoom_meeting_mail_calender_google_ms": "Bekerja dengan Zoom Meetings, Zoom Mail dan Zoom Calendar, Google dan Microsoft 365",
          "up_to_300_attendees": "Hingga 300 Peserta",
          "10_gb_of_storage": "Penyimpanan sebesar 10 GB",
          "host_meeting_up_to_300_participants": "Selenggarakan rapat hingga 300 peserta",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Mulai dari {1} lisensi seharga {0}/tahun",
          "starting_at_licenses_month": "Mulai dari {1} lisensi seharga {0}/bulan",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Dapatkan akses cepat ke ringkasan rapat, bantuan dalam menyusun pesan, dan banyak lagi",
          "learn_more": "Pelajari Selengkapnya",
          "essential_apps": "Aplikasi Penting",
          "increase_team_collaboration": "Meningkatkan kolaborasi dan produktivitas tim",
          "free_premium_apps": "Aplikasi premium gratis selama 1 tahun (syarat berlaku)",
          "visitor_management": "Manajemen Pengunjung",
          "visitor_management_custom_invites": "Sesuaikan undangan",
          "visitor_management_visitor_check": "Check-in di kios",
          "visitor_management_receive_detailed": "Dapatkan metrik terperinci tentang penggunaan ruang pengunjung"
        },
        "custom_avatar": {
          "title": "Avatar khusus",
          "label_text": "3 menit per bulan",
          "basic_feature": "1 menit per masa pakai",
          "pricing_feature": "3 menit per bulan",
          "learn_more_subtitle": "Buat versi AI yang menyerupai diri Anda dengan replikasi suara dan kemampuan komunikasi multibahasa.",
          "features_item1": "Buat hingga 3 avatar digital yang menyerupai diri Anda setiap bulan, yang mereplikasi penampilan dan suara Anda untuk presentasi dan demo",
          "features_item2": "Gunakan avatar Anda untuk menyampaikan skrip dengan durasi hingga 3 menit dengan AI Companion",
          "features_item3": "Pilih dari 18 avatar yang sudah dirancang sebelumnya untuk pembuatan video berkualitas tinggi secara cepat",
          "features_item4": "Nikmati dukungan latar belakang virtual",
          "features_item1_opc": "Buat hingga 3 avatar digital yang menyerupai diri Anda setiap bulan, yang mereplikasi penampilan dan suara Anda untuk presentasi dan demo",
          "features_item2_opc": "Gunakan avatar Anda untuk menyampaikan skrip dengan durasi hingga 3 menit dengan AI Companion",
          "comparison_table_tips": "Avatar khusus menciptakan versi AI yang menyerupai diri Anda dengan replikasi suara dan komunikasi multibahasa."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Dapatkan akses cepat ke ringkasan rapat, bantuan dalam menyusun pesan, dan banyak lagi",
        "learn_more_dialog": {
          "desc": "Selesaikan lebih banyak hal dengan AI Companion! Aplikasi ini dapat menulis konten, menjadwalkan rapat, membantu mengelola proyek, dan banyak lagi.",
          "tip1": "Dapatkan agenda sebelumnya sehingga Anda dapat menyelenggarakan rapat yang lebih efektif",
          "tip2": "Jaga proyek Anda tetap pada jalurnya dengan pembuatan tugas dan notifikasi otomatis",
          "tip3": "Dapatkan bantuan untuk mengatur kalender dan mengelola waktu Anda",
          "tip4": "Buat konten tertulis dan visual yang sesuai dengan gaya Anda di Docs, Whiteboard, atau di aplikasi Zoom Workplace"
        },
        "top_features": "Fitur Teratas",
        "more_to_come": "Banyak fitur menakjubkan lainnya yang akan datang!",
        "discover_more": "Temukan lebih banyak lagi cara untuk menghadirkan kinerja terbaik Anda dengan AI Companion!",
        "detail_desc": "AI Companion disertakan dalam layanan berbayar di akun pengguna Zoom tanpa biaya tambahan. Bidang industri dan wilayah geografis tertentu mungkin dikecualikan."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/tahun/lisensi",
        "month_licnese": "/bulan/lisensi",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/bulan",
          "per_year": "/tahun"
        },
        "unit": {
          "license": "{0}/lisensi",
          "user": "{0}/pengguna"
        },
        "learn_more": "Pelajari Selengkapnya",
        "required": "Wajib",
        "zoom_one_required": "Zoom Workplace Diperlukan",
        "large": {
          "features_tip": "Perluas jangkauan Anda dengan kapasitas peserta yang ditingkatkan hingga 1.000 peserta.",
          "label_title1": "500 Peserta",
          "label_title2": "1000 Peserta"
        },
        "cmr": {
          "features_tip": "Simpan, streaming, dan unduh rekaman video Anda langsung dari Cloud Zoom.",
          "explain_desc": "Penyimpanan cloud disertakan dalam paket Zoom One tertentu: Pro (5 GB), Bisnis (5 GB), Bisnis Plus (10 GB), dan Perusahaan (Tidak Terbatas)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 jam",
          "option_label2": "≈ 650 jam",
          "option_label3": "≈ 3,500 jam",
          "option_label4": "≈ 17,500 jam",
          "intro_label2": " Opsi penyimpanan mencakup hingga 5 TB/bulan",
          "tooltip_content": "Penyimpanan rekaman bervariasi menurut jumlah peserta yang mendukung video, resolusi rapat, dan resolusi konten bersama."
        },
        "whiteboard": {
          "plus_title": "Papan Tulis Plus",
          "title": "Whiteoard",
          "features_tip": "Berkolaborasi secara real-time dengan orang lain menggunakan papan tulis, selama dan di luar dapat.",
          "explain_desc": "Termasuk dalam Zoom One Bisnis, Zoom One Bisnis Plus, dan Zoom One Perusahaan",
          "explain_desc_plus": "Termasuk dalam Zoom One Perusahaan Plus dan dengan setiap langganan Zoom Rooms",
          "option_label1": " Papan tanpa batas dengan Penyimpanan Cloud sebesar 1 GB",
          "option_label2": "Fitur lanjutan dengan papan tanpa batas dan Penyimpanan Cloud",
          "intro_label1": "Papan tulis yang dapat diedit secara bersamaan tanpa batas",
          "intro_label2": "Fitur standar dan kontrol dokumen lanjutan",
          "intro_label3": "Fitur papan tulis lanjutan, termasuk template kustom dan organisasi, serta integrasi pihak ketiga"
        },
        "translated_captions": {
          "features_tip": "Manfaatkan kolaborasi global dengan teks otomatis dalam bahasa pilihan Anda.",
          "intro_label1": "Peserta dapat mengaktifkan teks sendiri dan mengganti bahasa.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Lihat bahasa yang didukung"
        },
        "crc": {
          "features_tip": "Memungkinkan titik akhir konferensi video SIP/H.323 berbasis standar apa pun untuk pekerjaan hibrida yang efektif.",
          "intro_label1": "Bekerja dengan banyak titik akhir lawas seperti Polycom, Cisco, Lifesize, dan lainnya",
          "intro_label2": "Konektor ruang berbasis cloud atau lokal (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Sederhanakan pemesanan dengan ketersediaan yang fleksibel dan slot waktu yang dapat disesuaikan",
          "host_one_on_one": "Selenggarakan pertemuan satu lawan satu atau kelompok dengan satu tautan untuk berbagi dengan mudah",
          "customize_reminders": "Sesuaikan pengingat melalui email / SMS untuk mengurangi janji temu yang terlewat",
          "sync_calendars": "Sinkronisasi kalender dengan lancar dengan integrasi Google, Microsoft 365, dan Zoom",
          "features_tip": "Bagikan slot rapat dengan mudah untuk jam kantor, wawancara, dan lainnya.",
          "intro_label1": "Integrasi Kalender",
          "intro_label2": "Ketersediaan Berulang",
          "intro_label3": "Rapat yang Dapat Diskalakan",
          "intro_label4": "Pemberitahuan yang Dapat Disesuaikan",
          "intro_sub_label1": "Google, Microsoft 365, dan Zoom ",
          "intro_sub_label2": "bagikan slot waktu yang dapat dipesan ",
          "intro_sub_label3": "rapat tunggal untuk satu atau banyak peserta",
          "intro_sub_label4": "otomatiskan pengingat dan konfirmasi email atau SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Rekam, edit, dan bagikan pesan video pendek berkualitas tinggi.",
          "intro_label1": "Buat video tanpa batas dan tanpa batas waktu",
          "intro_label2": "Rekam layar dan video Anda secara bersamaan atau terpisah",
          "intro_label3": "Pangkas video sesuai kebutuhan dan membagikan tautannya",
          "intro_label4": "Akses fitur lanjutan seperti statistik dan transkrip audio",
          "explain_desc": "Klip Plus disertakan dalam langganan Workplace Pro, Bisnis, dan Perusahaan. Anda dapat menjelajahi berbagai fitur dari setiap paket di bagian perbandingan di halaman harga."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Platform acara lanjutan dengan fitur pendaftaran dan jaringan yang canggih. Cocok untuk pengalaman virtual dan hibrida.",
          "tooltip_content": "Selenggarakan webinar atau acara tanpa batas dengan kapasitas pilihan",
          "intro_title": "Semuanya ada dalam Sesi",
          "intro_label1": "Tingkatkan interaksi audiens dengan acara multisesi",
          "intro_label2": "Selenggarakan acara dengan mudah menggunakan penjualan tiket yang disesuaikan dan aplikasi seluler",
          "intro_label3": "Tingkatkan pendapatan acara dengan Lantai Pameran dan area Sponsor",
          "intro_label4": "Kembangkan jaringan peserta dengan profil yang dapat dikustomisasi",
          "intro_label5": "Perluas jangkauan dengan penayangan sesuai permintaan di Lobi Acara",
          "intro_label6": "Percepat penyiapan acara dengan templat acara khusus",
          "events_feature_item1_20240827": "Atur acara virtual multi-hari dengan beberapa trek",
          "events_feature_item2_20240827": "Mempromosikan jaringan dengan profil peserta dan obrolan lobi",
          "events_feature_item3_20240827": "Memandu peserta dengan streaming sesi lobi",
          "events_feature_item4_20240827": "Meningkatkan pendapatan acara dengan lantai pameran dan sponsor",
          "events_feature_item5_20240827": "Meningkatkan acara mendatang dengan survei pascakonferensi",
          "events_feature_item6_20240827": "Percepat penyiapan acara dengan templat acara khusus",
          "attendees_start_at": "{0} peserta mulai dari",
          "explain_desc": "Temukan informasi lebih lanjut tentang Zoom Events",
          "contact_account_owner": "Jika Anda ingin membeli Events, <a href=\"/account\" target=\"_blank\">hubungi pemilik akun Anda</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Sederhanakan acara sesi tunggal interaktif dengan fitur seperti branding acara, kolaborasi beberapa host, dan manajemen acara.",
          "tooltip_content": "Selenggarakan webinar atau acara tanpa batas dengan kapasitas pilihan",
          "intro_title": "Termasuk Zoom Webinars",
          "intro_label1": "Kustomisasikan halaman arahan acara untuk branding yang efektif",
          "intro_label2": "Promosikan acara dengan email bermerek",
          "intro_label3": "Ukur kinerja dengan dasbor interaktif",
          "intro_label4": "Kolaborasi yang lancar dengan co-host dan co-editor",
          "intro_label5": "Alat acara profesional: Simulasi Langsung",
          "sessions_feature_item1_20240827": "Tingkatkan webinar dengan adegan khusus dan branding",
          "sessions_feature_item2_20240827": "Menyederhanakan perencanaan acara dengan AI Companion untuk membuat pesan dan gambar",
          "sessions_feature_item3_20240827": "Mempromosikan acara masa lalu dan masa depan di hub konten bermerek",
          "sessions_feature_item4_20240827": "Menjalankan acara profesional dengan fitur Belakang Panggung, Simulasi Langsung, dan RTMP",
          "sessions_feature_item5_20240827": "Meningkatkan webinar mendatang dengan wawasan lintas acara",
          "explain_desc": "Temukan informasi lebih lanjut tentang Zoom Sessions",
          "contact_account_owner": "Jika Anda ingin membeli Sessions, <a href=\"/account\" target=\"_blank\">hubungi pemilik akun Anda</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Webinar",
          "features_tip": "Siarkan pesan dengan platform webinar ramah pengguna dengan mudah.",
          "tooltip_content": "Selenggarakan webinar atau acara tanpa batas dengan kapasitas pilihan",
          "intro_label1": "Libatkan audiens dengan webcasting video berkualitas tinggi",
          "intro_label2": "Tingkatkan interaksi dengan T&J, polling, dan reaksi",
          "intro_label3": "Tingkatkan strategi webinar dengan pelaporan pascaacara",
          "intro_label4": "Mendukung hingga 100.000 peserta dan 100 panelis",
          "monthly_subscription": "Langganan Bulanan",
          "annual_subscription": "Langganan Tahunan",
          "one_million": "1 Juta",
          "single_use": "Sekali Pakai",
          "one_month": "Satu Bulan",
          "event_attendee": "Peserta Events/Sessions:",
          "event_attendee_desc": "Siapa pun yang bergabung tanpa menjadi host berlisensi di hub. Peran khusus juga dihitung sebagai peserta dan dapat berpartisipasi dengan audio, video, dan berbagi layar (jika diaktifkan).",
          "webinar_attendee": "Peserta webinar:",
          "webinar_attendee_desc": "Siapa saja yang bergabung, tetapi bukan host atau panelis. Mereka berada dalam mode lihat-saja dan dikontrol oleh host, yang dapat membunyikannya dan mengaktifkan interaksi melalui T&J dan obrolan.",
          "pay_per_attendee": "Bayar Per Peserta",
          "attendees": "peserta"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Tata ulang cara tim Anda bekerja dengan platform kolaborasi yang didukung AI.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Bisnis",
          "label_title4": "Workplace Bisnis Plus",
          "intro_label1": "Selenggarakan rapat tanpa batas hingga 30 jam dengan hingga 100 peserta",
          "intro_label2": "Akses hingga 3 papan tulis yang dapat diedit secara bersamaan dengan fitur standar",
          "intro_label3": "Rekam, edit, dan bagikan pesan video pendek berkualitas tinggi dengan Clips Plus",
          "intro_label4": "Selesaikan pekerjaan dengan lebih efisien menggunakan Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (tidak termasuk BYOC, PBX, dan 3rd Party PBX)",
          "intro_label6": "Selenggarakan rapat tanpa batas hingga 30 jam dengan hingga 300 peserta",
          "intro_label7": "Bagikan slot rapat untuk jam kerja, wawancara, dan lainnya menggunakan Zoom Scheduler",
          "intro_label8": "Zoom Phone AS & CA Tanpa Batas",
          "intro_label8_UK": "Zoom Phone Inggris Raya & Irlandia Tanpa Batas",
          "intro_label8_AU": "Zoom Phone Australia & Selandia Baru Tanpa Batas",
          "intro_label8_JP": "Zoom Phone Jepang Tanpa Batas",
          "intro_label9": "Manajemen Pengunjung",
          "intro_label10": "Fitur Tambahan",
          "intro_label11": "Dukungan obrolan langsung",
          "intro_title1": "Semuanya di Pro, dan:",
          "intro_title2": "Semuanya di Bisnis, dan:",
          "intro_label_tip1": "Zoom Phone di Pro Plus tidak menyertakan fitur BYOC, 3rd Party PBX, dan VDI. Untuk informasi selengkapnya, lihat halaman harga Zoom Phone.",
          "intro_label_tip2": "Saat checkout, Anda dapat memilih Panggilan Regional Tanpa Batas untuk AS & Kanada, Australia & Selandia Baru, Inggris Raya & Irlandia, atau Jepang.",
          "intro_label_tip3": "Fitur tambahan mencakup Penyimpanan Cloud sebesar 10 GB, Teks yang Diterjemahkan, dan Reservasi Ruang Kerja.",
          "intro_label_tip4": "Zoom Phone di Pro Plus tidak menyertakan fitur BYOC, 3rd Party PBX, dan VDI. Untuk informasi selengkapnya, lihat halaman harga Zoom Phone."
        },
        "power_pack": {
          "title": "Paket Power Zoom Phone",
          "features_tip": "Analitik antrean panggilan dan wawasan historis yang disempurnakan untuk tim pusat panggilan.",
          "intro_label1": "Jendela kontak yang diperbesar untuk merampingkan penanganan panggilan",
          "intro_label2": "Nomor telepon Penerima Panggilan Otomatis dan Antrean Panggilan"
        },
        "international_calling": {
          "title": "Panggilan Internasional",
          "features_tip": "Panggilan internasional tanpa batas ke 15+ negara dan wilayah.",
          "intro_label1": "Dapat dibeli dengan paket panggilan tanpa batas mana pun",
          "intro_label2": "Jelajahi daftar negara dan wilayah yang kami dukung untuk panggilan internasional tanpa batas.",
          "intro_labe2_tooltip": "AS, Kanada, Irlandia, Australia, Selandia Baru, Austria, Denmark, Prancis, Jerman, Italia, Portugal, Spanyol, Swedia, Belgia, Belanda, Swiss, Puerto Riko, Jepang.",
          "intro_label2_view_list": "Lihat Daftar"
        },
        "workspace_reservation": {
          "title": "Reservasi Ruang Kerja",
          "intro_title": "Pesan ruang kerja fleksibel atau kamar hotel dengan mudah, baik sebelumnya maupun langsung di lokasi, menggunakan perangkat terintegrasi Zoom.",
          "intro_label1": "Akses ruang kerja dan reservasi hotel melalui aplikasi Zoom Workplace, desktop, atau browser",
          "intro_label2": "Dapatkan rekomendasi meja yang dipersonalisasi dengan bantuan AI",
          "intro_label3": "Pesan ruang kerja langsung dari Google Kalender atau Outlook, dengan pengingat dan peringatan check-in",
          "intro_label4": "Navigasi ke ruang kerja yang dipesan dengan penunjuk arah"
        },
        "visitor_management": {
          "title": "Manajemen Pengunjung",
          "intro_title": "Sederhanakan check-in pengunjung dengan undangan khusus, check-in kios yang tidak merepotkan, pelaporan, dan metrik.",
          "intro_label1": "Kelola undangan, lokasi pengunjung, dan riwayat kunjungan di portal Zoom",
          "intro_label2": "Buat, lacak, kirim ulang, dan hapus undangan saat menerima pemberitahuan kedatangan tamu",
          "intro_label3": "Lengkapi formulir, dapatkan petunjuk arah, dan check-in melalui kios untuk pengalaman pengunjung yang lancar",
          "intro_label4": "Akses semua fitur dalam portal Zoom yang sudah dikenal untuk pengelolaan yang mudah"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Rapat Besar",
          "description1": "Tingkatkan kapasitas rapat untuk mendukung hingga 1.000 peserta langsung dan interaktif",
          "description2": "Semua peserta dapat membagikan audio, video, dan layar mereka"
        },
        "cloud_storage": {
          "title": "Penyimpanan cloud",
          "description2": "Format file MP4 atau M4A tersedia"
        },
        "translated_captions": {
          "title": "Teks yang Diterjemahkan",
          "description1": "Sempurnakan rapat dengan teks multibahasa otomatis yang memungkinkan peserta mengaktifkan dan beralih ke bahasa yang didukung",
          "description2": "Tersedia di Zoom Meetings dan Webinars"
        },
        "tollfree": {
          "title": "Opsi Konferensi Audio",
          "subcontent": "Hubungi rapat dengan nomor telepon dari seluruh dunia",
          "description1": "Perluas opsi panggilan Anda dengan panggilan keluar, bebas biaya global, dan panggilan masuk lokal untuk negara-negara premium",
          "description2": "Peserta tidak dikenakan biaya untuk menghubungi dari perangkat apa pun",
          "description3": "Pilih satu atau beberapa negara untuk panggilan masuk bebas biaya dengan mudah"
        },
        "rc": {
          "title": "Konektor Ruang Konferensi"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgia",
        "Brazil": "Brasil",
        "Bulgaria": "Bulgaria",
        "Canada": "Kanada",
        "Chile": "Chili",
        "China": "Tiongkok",
        "Colombia": "Kolombia",
        "Costa_Rica": "Kosta Rika",
        "Croatia": "Kroasia",
        "Cyprus": "Siprus",
        "Czech_Republic": "Republik Ceko",
        "Denmark": "Denmark",
        "Ecuador": "Ekuador",
        "Estonia": "Estonia",
        "Finland": "Finlandia",
        "France": "Prancis",
        "Germany": "Jerman",
        "Greece": "Yunani",
        "Hong_Kong_SAR": "Wilayah Administratif Khusus Hong Kong",
        "Hungary": "Hongaria",
        "Ireland": "Irlandia",
        "Israel": "Israel",
        "Italy": "Italia",
        "Japan": "Jepang",
        "Latvia": "Latvia",
        "Lithuania": "Lituania",
        "Luxembourg": "Luksemburg",
        "Mexico": "Meksiko",
        "Netherlands": "Belanda",
        "New_Zealand": "Selandia Baru",
        "Norway": "Norwegia",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Polandia",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Riko",
        "Romania": "Rumania",
        "Singapore": "Singapura",
        "Slovakia": "Slowakia",
        "Slovenia": "Slovenia",
        "South_Africa": "Afrika Selatan",
        "Spain": "Spanyol",
        "Sweden": "Swedia",
        "Switzerland": "Swiss",
        "UK": "Inggris Raya",
        "United_Kingdom": "Inggris",
        "US": "AS",
        "United_States": "Amerika Serikat",
        "title": "Persyaratan Nomor Telepon",
        "subtitle": "Pilih negara tempat nomor telepon Paket Global Wilayah Tertentu Anda akan diaktifkan.",
        "selector_tip": "Pilih Negara",
        "local_and_toll_free": "Nomor lokal dan bebas biaya tersedia di {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Paket Global Wilayah Tertentu termasuk satu nomor telepon dan panggilan domestik tanpa batas di negara yang dipilih per lisensi.",
        "avail_title": "Negara/wilayah yang tersedia"
      },
      "tax_exempt_ecm": {
        "title": "Status Pengecualian Pajak",
        "status_exempt": "Bebas Pajak",
        "status_exempt_question": "Dikecualikan Pajak?",
        "verify_now": "Verifikasi Sekarang",
        "can_after_checkout": "Sebagai opsi, langkah ini dapat diselesaikan setelah proses pembayaran.",
        "status": {
          "exempt": "Bebas",
          "pending": "Tertunda",
          "pendingTooltip": "Status pengecualian pajak Anda saat ini sedang ditinjau. Anda mungkin dikenakan pajak saat melakukan pemesanan. Jika pengecualian Anda disetujui, kami akan mengkreditkan semua pajak/biaya yang dapat dikembalikan ke akun Anda.",
          "nonexempt": "Tidak Bebas",
          "rejected": "Ditolak",
          "rejectedTooltip": "Dokumen yang diajukan telah ditentukan tidak memenuhi persyaratan untuk yurisdiksi Anda.",
          "approved": "Disetujui",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "Jika mengabaikan verifikasi, Anda mungkin dikenakan pajak/biaya yang berlaku. Anda masih dapat mengirimkan dokumen pembebasan pajak di bagian Manajemen Penagihan setelah pembelian untuk ditinjau dan disetujui oleh Zoom. Setelah divalidasi, pengembalian dana akan diberikan untuk setiap pajak yang dikenakan.",
          "desc": "Anda yakin ingin meninggalkan verifikasi pembebasan pajak dan melanjutkan dengan pajak yang sah?",
          "title": "Anda yakin?",
          "new_title": "Abaikan Verifikasi Pengecualian Pajak?",
          "yes": "Ya, Tinggalkan",
          "no": "Tidak, Lanjutkan",
          "abandon": "Abaikan Verifikasi",
          "go_back": "Kembali"
        },
        "confirm_to_add": {
          "title": "Konfirmasikan pengecualian pajak default baru",
          "message": "Menambahkan pengecualian baru akan otomatis menetapkannya sebagai default setelah disetujui atau ditolak. Anda hanya dapat memiliki satu pengecualian default yang akan berlaku untuk pembelian berikutnya. Jumlah pajak Anda dapat terpengaruh jika pengecualian default Anda tidak sesuai dengan negara bagian/wilayah “Dijual Kepada” Anda.",
          "yes": "Tambahkan pengecualian baru"
        },
        "confirm_set_default": {
          "title": "Ketidakcocokan alamat dan pengecualian pajak",
          "message": "Alamat \"Dijual Kepada Kontak\" Anda tidak sesuai dengan negara bagian/wilayah yang Anda pilih untuk pengecualian pajak. Harap perbarui alamat \"Dijual Kepada Kontak\" Anda agar sesuai dengan lokasi pengecualian pajak Anda. Jika tidak, pembelian Anda mungkin tidak mendapatkan pengecualian pajak.",
          "yes": "Tetapkan sebagai default omong",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Negara Bagian/Wilayah",
          "exemption_type": "Jenis Pengecualian",
          "signed_date": "Tanggal Ditandatangani",
          "status": "status",
          "add_exemption": "Tambahkan Pengecualian",
          "view": "Tampilkan",
          "set_as_default": "Tetapkan sebagai Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Paket {planName} Anda akan dibatalkan pada {date} pukul 12.00 WIB. Jika Anda ingin menyelenggarakan setelah tanggal pembatalan, silakan aktifkan kembali paket Anda.",
        "pairPreDescTip": "Paket {planName1} dan {planName2} Anda akan dibatalkan pada {date} pukul 12.00 WIB. Jika Anda ingin menyelenggarakan setelah tanggal pembatalan, silakan aktifkan kembali paket Anda.",
        "pairDiffDatePreDescTip": "Paket {planName1} dan {planName2} Anda akan dibatalkan pada {date1} pukul 12.00 WIB dan pada {date2} pukul 12.00 WIB. Jika Anda ingin menyelenggarakan setelah tanggal pembatalan, silakan aktifkan kembali paket Anda.",
        "title": "Aktifkan kembali paket Anda untuk melanjutkan",
        "titles": "Aktifkan kembali paket Anda untuk melanjutkan",
        "plan": "Paket",
        "licenses": "Lisensi",
        "billingCycle": "Siklus Penagihan",
        "effective_date": "Tanggal Berlaku",
        "invoice_amount": "Jumlah Faktur",
        "singleDescTip": "Dengan mengaktifkan kembali, Anda setuju bahwa paket berulang Anda akan diperpanjang secara otomatis pada {date}, dan metode pembayaran Anda yang tersimpan akan ditagih setiap periode perpanjangan. Untuk menghindari biaya di masa mendatang, <a target=\"_blank\" href=\"https://support.zoom.com/hc/id/article?id=zm_kb&sysparm_article=KB0066687\">batalkan</a> sehari sebelum tanggal perpanjangan.",
        "pairDescTip": "Dengan mengaktifkan kembali, Anda setuju bahwa paket berulang Anda akan diperpanjang secara otomatis pada {date}. Metode pembayaran Anda yang tersimpan akan ditagih setiap periode perpanjangan. Untuk menghindari biaya di masa mendatang, <a target=\"_blank\" href=\"https://support.zoom.com/hc/id/article?id=zm_kb&sysparm_article=KB0066687\">batalkan</a> sehari sebelum tanggal perpanjangan.",
        "pairDiffDateDescTip": "Dengan mengaktifkan kembali, Anda setuju bahwa paket berulang Anda akan diperpanjang secara otomatis pada {date1} dan {date2}. Metode pembayaran Anda yang tersimpan akan ditagih setiap periode perpanjangan. Untuk menghindari biaya di masa mendatang, <a target=\"_blank\" href=\"https://support.zoom.com/hc/id/article?id=zm_kb&sysparm_article=KB0066687\">batalkan</a> sehari sebelum tanggal perpanjangan.",
        "totalLabel": "Total",
        "totalContent": "{money} ditambah pajak yang berlaku",
        "taxDesc": "tidak termasuk PPN, GST, atau pajak serupa",
        "reactivateBtn": "Lanjutkan dan Aktifkan Kembali",
        "switchTitle": "Perbarui paket Anda untuk melanjutkan",
        "successSingleTip": "Paket {planName} Anda telah diaktifkan kembali",
        "successPairTip": "Paket {planName1} dan {planName2} Anda telah diaktifkan kembali",
        "switchTip": "Paket Zoom One Webinars Bulan Anda akan berakhir pada {date}. Untuk menyelenggarakan webinar setelah tanggal ini, Anda harus beralih ke langganan.",
        "switchBtn": "Beralih ke Langganan"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Bisnis"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Bisnis Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Unduh Lembar Data"
      },
      "one": {
        "new": "Baru"
      }
    },
    "webinarSetupInWebPortal": "Penyiapan Webinar di Portal Web",
    "concurrentEvents": "Acara Bersamaan",
    "coucurrentEventsToolTip": "<span>Paket <b>langganan</b> mendukung satu acara langsung sekaligus",
    "overages": "Kelebihan",
    "eventsPlatformHubs": "Hub Platform Acara",
    "eventsHubToolTip": "<b>Hub</b> Zoom Events menawarkan penyelenggaraan acara yang mudah",
    "1HubPerLicense": "1 hub per lisensi",
    "1000Hubs": "1.000 hub",
    "eventsPlatformHosts_500AttendeesOrMore": "Host Platform Acara (500 peserta atau lebih)",
    "eventsHost500": "<span><b>Host hub</b> Zoom Events dapat membuat",
    "5HubHosts": "5 host hub",
    "100HubHosts": "100 host hub",
    "eventsPlatformHosts_100Attendees": "Host Platform Acara (100 peserta)",
    "eventsHost100": "<span><b>Host hub</b> Zoom Events dapat membuat",
    "2HubHosts": "2 host hub",
    "howAreTheyDifferent": "Apa perbedaannya?",
    "allPlansRequireAZoomOneLicense": "*Semua paket memerlukan lisensi Zoom Workplace",
    "subscription": "Langganan",
    "subscriptionToolTip": "<span><b>Langganan</b> memungkinkan Anda menyelenggarakan acara tak terbatas dengan kapasitas pilihan Anda.</span>",
    "payPerAttendee": "Bayar Per Peserta",
    "ppaToolTips": "<span>Lisensi <b>bayar per peserta</b> menentukan jumlah total peserta yang dapat menghadiri semua acara akun Anda yang diadakan dalam periode 12 bulan sejak tanggal pembelian.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Polling",
    "meetings.fullPlanItem2": "Jumlah lisensi",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Konferensi video dan olah pesan yang disederhanakan di perangkat apa pun",
    "meetings.fullPlanItem5": "Durasi rapat grup",
    "meetings.fullPlanItem5Tip": "Durasi maksimum yang diperbolehkan per rapat grup (3 peserta atau lebih).",
    "meetings.fullPlanItem5_basic": "40 mnt",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 jam",
    "meetings.fullPlanItem5_biz": "30 jam",
    "meetings.fullPlanItem5_ent": "30 jam",
    "meetings.fullPlanItem1": "Kapasitas peserta",
    "meetings.fullPlanItem1Tip": "Peserta dapat bergabung ke rapat Anda secara gratis dari perangkat telepon, desktop, seluler, dan tablet mereka. Peserta tidak memerlukan akun Zoom untuk dapat bergabung ke rapat. Setiap paket memiliki batas peserta, tetapi pengguna dapat meningkatkan batas ini pada paket berbayar dengan membeli add-on.",
    "meetings.fullPlanItem1_ent": "500<br>*1.000 untuk Perusahaan Plus",
    "meetings.fullPlanItem7": "Rekaman",
    "meetings.fullPlanItem7Tip": "Rekaman lokal Zoom menyimpan rekaman rapat Anda dalam format MP4 (video), M4A (audio), dan txt (obrolan).<br>Rekaman Cloud Zoom menyimpan rapat di Zoom Cloud, di mana file tersebut kemudian dapat diunduh dan/atau di-streaming dari browser.",
    "meetings.fullPlanItem7_basic": "Lokal",
    "meetings.fullPlanItem7_pro": "Lokal & cloud 1 GB (per lisensi)",
    "meetings.fullPlanItem7_biz": "Lokal & cloud 1 GB (per lisensi)",
    "meetings.fullPlanItem7_ent": "Lokal & Cloud tanpa batas",
    "one.messaging": "Olah Pesan",
    "meetings.fullPlanItem16Tip": "Obrolan memungkinkan Anda mengirim teks grup, file, tangkapan layar, cuplikan kode, pesan suara, dan gambar dengan mudah. Teks dapat diformat dan pengguna juga dapat berbagi GIF serta emoji. Kehadiran menampilkan apakah peserta obrolan aktif di desktop atau perangkat seluler, atau sibuk dalam rapat.",
    "meetings.fullPlanItem51": "Papan Tulis Zoom",
    "meetings.unlimited": "Tanpa Batas",
    "meetings.fullPlanItem_EssentialApp": "Aplikasi Penting",
    "common.learnMore": "Pelajari Selengkapnya",
    "meetings.fullPlanItem_EssentialAppText": "Aplikasi premium gratis selama 1 tahun (syarat berlaku)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom uygulamasında Zoom Mail ve Calendar",
    "mailService": "E-posta Hizmeti",
    "emailServiceWithFullTimeEndToEnd": "Gelişmiş gizlilik için tam zamanlı uçtan uca şifrelemeli e-posta hizmeti",
    "customMailDomain": "Özel Posta Etki Alanı",
    "customMailDomainWithMailService": "Özel Posta Etki Alanı ve Posta Hizmeti",
    "calendarClient": "Takvim İstemcisi",
    "scheduleAndJoinMeetings": "Zoom uygulamasında toplantı planlayın ve toplantılara katılın",
    "aiCompanion": "AI Companion",
    "calendarService": "Takvim Hizmeti",
    "meetingSchedulingAndAppointment": "Toplantı planlama ve randevu oluşturma",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Buat, edit, dan bagikan video pendek dengan mudah. Klip yang disimpan sangat mudah ditemukan, meningkatkan keterlibatan.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Catatan menawarkan editor dokumen pribadi dan kolaboratif yang kuat dengan beragam opsi pemformatan, dapat diakses baik selama maupun di luar rapat.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Teks yang Diterjemahkan",
    "workspaceReservation": "Reservasi Ruang Kerja",
    "accessAcrossAnyDevice": "Akses di perangkat apa pun",
    "meetings.fullPlanItem4": "Rapat grup tanpa batas",
    "meetings.fullPlanItem9": "Panggilan masuk telepon",
    "meetings.fullPlanItem9Tip": "Bergabung ke rapat Zoom via telekonferensi/konferensi audio (menggunakan telepon biasa). Pengguna akan dikenakan biaya sesuai dengan paket telepon mereka. Coba add-on Konferensi Audio kami untuk nomor panggilan masuk bebas biaya.",
    "meetings.fullPlanItem9_pro": "Berbayar",
    "meetings.fullPlanItem9_biz": "Berbayar",
    "meetings.fullPlanItem9_ent": "Berbayar",
    "meetings.fullPlanItem11": "Berbagi layar",
    "meetings.fullPlanItem11Tip": "Berbagi desktop dan aplikasi. Pengguna rapat berlisensi dapat memilih untuk mengizinkan beberapa peserta berbagi layar mereka secara bersamaan selama rapat yang mereka adakan.",
    "meetings.fullPlanItem12": "Ruang diskusi",
    "meetings.fullPlanItem12Tip": "Ruang Diskusi Video memungkinkan Anda untuk membagi rapat Zoom Anda hingga 50 sesi terpisah untuk diskusi, proyek, dan lainnya.",
    "meetings.fullPlanItem14": "Latar belakang virtual",
    "meetings.fullPlanItem15": "ID Rapat Pribadi",
    "meetings.fullPlanItem15Tip": "Buat ruang rapat online permanen Anda sendiri. Anda dapat memulai rapat ini kapan saja atau menjadwalkannya untuk penggunaan di masa mendatang.",
    "meetings.fullPlanItem17": "Kontrol host",
    "meetings.fullPlanItem18": "Anotasi Bersama pada berbagi layar",
    "meetings.fullPlanItem19": "Kontrol keyboard & mouse jarak jauh",
    "meetings.fullPlanItem21": "Multiberbagi",
    "meetings.fullPlanItem29": "Ruang tunggu",
    "meetings.fullPlanItem29Tip": "Fitur Ruang Tunggu memungkinkan host untuk mengontrol kapan seorang peserta bergabung ke rapat. Sebagai host rapat, Anda dapat menerima peserta satu per satu atau sekaligus. Dalam pengaturan, Anda dapat memilih siapa yang dimasukkan ke Ruang Tunggu atau diterima secara otomatis. Setiap akun memiliki fitur Ruang Tunggu. Host dapat mengirim pesan ke Ruang Tunggu. Anda dapat menyesuaikan Ruang Tunggu, jika Anda menggunakan paket berbayar.",
    "meetings.fullPlanItem41": "Dirancang untuk perangkat Zoom for Home",
    "meetings.fullPlanItem61": "Sematkan banyak orang",
    "meetings.fullPlanItem61Tip": "Host dapat memberi izin pada hingga 9 orang, kemampuan untuk menyematkan video untuk membuat tampilan kustom mereka sendiri. Siapa pun yang berbicara, video yang disematkan akan tetap terlihat.",
    "meetings.fullPlanItem62": "Soroti beberapa orang",
    "meetings.fullPlanItem62Tip": "Host dapat menyorot hingga 9 video peserta, sehingga siapa pun yang berbicara, seluruh rapat dapat melihat video yang disorot.",
    "meetings.fullPlanNewItem1": "Filter",
    "meetings.fullPlanNewItem1Tip": "Hadirkan lebih banyak kesenangan ke dalam happy hour, pesta, dan lainnya dengan filter warna yang menyenangkan atau stiker hewan dekoratif.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & host alternatif",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Pelajari selengkapnya</a> tentang bagaimana co-host kami mengontrol rapat.",
    "meetings.fullPlanItem24": "Tetapkan penjadwal rapat",
    "meetings.fullPlanItem24Tip": "Memungkinkan Anda menugaskan orang lain untuk menyiapkan rapat untuk Anda. Penerima tugas juga harus memiliki paket Pro.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Memungkinkan pemilik akun, admin, dan pengembang Anda mengamankan akses ke Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">Batas Tingkat API</a> diterapkan di tingkat akun sesuai <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Jenis Akun</a> (Pro, Bisnis, Perusahaan…) dan <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">Jenis Permintaan API</a> (Ringan, Sedang, Berat, dll…). Beberapa API memiliki akses terbatas untuk jenis akun tertentu. Gunakan <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">Batas Tingkat API</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">Dokumentasi Refernsi API</a> untuk detail selengkapnya.",
    "meetings.fullPlanItem25_pro": "Batas Tingkat REST API Pro",
    "meetings.fullPlanItem25_biz": "Batas Tingkat REST API",
    "meetings.fullPlanItem26": "Interoperabilitas Skype for Business (Lync)",
    "meetings.fullPlanItem26Tip": "Memungkinkan pengguna Lync 2010, 2013, dan pengguna Skype for Business untuk memulai rapat Zoom dari daftar kontak Lync.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Streaming langsung ke Facebook, Youtube, atau layanan pihak ketiga.",
    "meetings.fullPlanItem28": "Pelaporan",
    "meetings.fullPlanItem28Tip": "Jalankan laporan penggunaan untuk mempelajari berapa banyak rapat yang berlangsung, hari rapat diselenggarakan, jumlah peserta, durasi rapat, dan lainnya.",
    "meetings.fullPlanItem30": "Manajemen pengguna",
    "meetings.fullPlanItem30Tip": "Pemilik dan Admin dapat menambah, menghapus, serta menetapkan peran dan fitur add-on.",
    "one.autoCaptions": "Teks otomatis",
    "meetings.fullPlanItem31": "Portal admin",
    "meetings.fullPlanItem31Tip": "Kelola pengguna di perusahaan Anda dalam satu akun untuk penagihan yang disederhanakan, pengaturan manajemen pengguna lanjutan, dan wawasan penggunaan yang komprehensif, semuanya di Portal Admin Zoom.",
    "meetings.fullPlanItem32": "Integrasi LTI",
    "meetings.fullPlanItem32Tip": "Tambahkan rapat dengan mudah ke aktivitas kursus apa pun dan undang siswa yang tepat dari sistem manajemen pembelajaran Anda (dapat berfungsi dengan Moodle, Canvas, Desire2Learn, dan Blackboard).",
    "meetings.fullPlanItem33": "Transkrip rekaman",
    "meetings.fullPlanItem33Tip": "Transkrip rekaman cloud adalah transkrip audio yang mentranskripsikan audio rapat atau webinar yang Anda rekam ke cloud. Harap dicatat bahwa saat ini hanya tersedia dalam bahasa Inggris. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Klik di sini</a> untuk mempelajari selengkapnya.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Tambahkan branding perusahaan Anda ke halaman kustom Anda sendiri di mana pengguna Anda dapat bergabung ke rapat. Buat templat email bermerek untuk mengirim undangan ke peserta.",
    "meetings.fullPlanItem35": "Domain terkelola",
    "meetings.fullPlanItem35Tip": "Gunakan domain alamat email perusahaan/universitas Anda untuk menambahkan pengguna ke akun Anda secara otomatis.",
    "meetings.fullPlanItem37": "Interpretasi bahasa",
    "meetings.fullPlanItem37Tip": "Mengizinkan host rapat untuk menunjuk juru bahasa dalam rapat dan webinar mereka. Ketika memulai rapat atau webinar, host rapat dapat memulai fitur interpretasi, yang akan memberi akses kepada penerjemah ke saluran audio mereka sendiri. Peserta dapat memilih saluran audio untuk mendengar pilihan bahasanya. Peserta akan mendengar audio yang diterjemahkan dan dapat memilih apakah mereka ingin mendengar audio asli dengan volume yang lebih rendah.",
    "meetings.fullPlanItem39": "Ulasan bisnis eksekutif",
    "meetings.fullPlanItem39Tip": "Analisis adopsi tren terperinci, pelacakan ROI, diskusi peta jalan produk.",
    "meetings.fullPlanNewItem4": "Termasuk Webinar 500",
    "one.translatedCations": "Teks yang Diterjemahkan",
    "one.entPlus": "Perusahaan Plus",
    "directChannelOrGroupChat": "Obrolan Langsung, Saluran, atau Grup",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Berkomunikasi dengan mudah dalam pesan 1:1 pribadi, grup kecil, atau dengan tim besar",
    "messageAndFileHistory": "Riwayat pesan dan file",
    "findPeopeChannelsAndFilesInSearch": "Temukan orang, saluran, dan file di pencarian",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Temukan kontak, pesan instan, obrolan grup, dan file dengan cepat, dengan menyimpan pengetahuan dan informasi di ujung jari Anda.",
    "applicationIntegrations": "Integrasi Aplikasi",
    "secureFileSharing": "Berbagi file yang aman",
    "enhanceCollaborationWithSeamlessFileSharing": "Tingkatkan kolaborasi dengan berbagi file yang lancar",
    "persistentMeetingChat": "Obrolan rapat persisten",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Jangan pernah kehilangan jejak percakapan rapat. Berkomunikasi sebelum, selama, dan sesudah rapat di obrolan grup khusus di Zoom Team Chat untuk semua peserta rapat.",
    "cloudStorage": "Penyimpanan Cloud",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Cadangkan saluran ke Cloud Zoom atau penyedia penyimpanan pihak ketiga",
    "avatars": "Avatar",
    "inMeetingReactions": "Reaksi dalam rapat",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Menampilkan keterlibatan dan komunikasikan dengan cepat dengan peserta lain secara non-verbal",
    "virtualBackgrounds": "Latar belakang virtual",
    "videoFilters": "Filter video",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Hadirkan keseruan ke dalam rapat Anda dengan berbagai filter di video Anda",
    "inMeetingPollsAndQuizzes": "Polling & kuis dalam rapat",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Buat pertanyaan polling pilihan tunggal atau pilihan ganda untuk rapat Anda.",
    "liveStreamingAcrossPlatforms": "Streaming langsung di seluruh platform",
    "appearanceTouchUp": "Perbaiki penampilan",
    "originalSoundForMusicians": "Suara asli untuk musisi",
    "endToEndEncryptionForZoomMeetings": "Enkripsi ujung-ke-ujung untuk Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Jika diaktifkan, enkripsi ujung-ke-ujung (E2EE) Zoom untuk Zoom Meetings berarti bahwa komunikasi di antara semua peserta rapat yang menggunakan Zoom client dalam rapat tertentu dienkripsi menggunakan kunci kriptografi yang hanya diketahui oleh perangkat peserta tersebut. Ini berarti tidak ada pihak ketiga — termasuk Zoom — yang memiliki akses ke kunci pribadi rapat.",
    "zoomCustomerManagedKey": "Kunci yang Dikelola Pelanggan Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Gunakan kunci enkripsi Anda sendiri untuk melindungi data Zoom saat tidak digunakan",
    "enterpriseGradeSecurityFeatures": "Fitur keamanan tingkat perusahaan",
    "256BitAesGcmEncryptionForRealTimeContent": "Enkripsi AES-GCM 256-bit untuk konten dan media real-time, enkripsi TLS selama pendaftaran SIP, masking ID pemanggil, peering jaringan pribadi, deteksi penipuan alat, dan daftar blokir panggilan.",
    "phone.fullPlanItem40": "Single sign-on melalui SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Panggilan internal tanpa batas",
    "phone.fullPlanItem2": "Panggilan keluar terukur",
    "phone.fullPlanItem3": "Panggilan keluar tanpa batas",
    "phone.fullPlanItem4": "Kualitas panggilan HD terdepan di industri",
    "phone.fullPlanItem4Tip": "Dengan peredam kebisingan aktif, peredam gema, dan peredam suara pengetikan keyboard",
    "phone.fullPlanItem5": "Aplikasi desktop Windows, MacOS, dan Linux native",
    "phone.fullPlanItem6": "Aplikasi seluler native untuk iOS dan Android",
    "phone.fullPlanItem7": "Port nomor yang ada atau beli yang baru (DID)",
    "phone.fullPlanItem8": "Nomor bebas biaya",
    "phone.fullPlanItem9": "Nomor ekstensi telepon",
    "phone.fullPlanItem10": "Pesan suara dengan transkripsi",
    "phone.fullPlanItem10Tip": "Akses transkrip pesan suara melalui aplikasi seluler/desktop dan email",
    "phone.fullPlanItem11": "Penjawab otomatis/IVR tanpa batas",
    "phone.fullPlanItem12": "Panggil berdasarkan direktori nama",
    "phone.fullPlanItem13": "Grup distribusi panggilan otomatis (ACD) dengan antrean panggilan",
    "phone.fullPlanItem14": "Sela/Pantau/Berbisik/Ambil Alih",
    "phone.fullPlanItem15": "Perutean liburan dan jam kerja",
    "phone.fullPlanItem16": "Panggilan konferensi ad hoc 3 arah",
    "phone.fullPlanItem17": "Rekaman panggilan",
    "phone.fullPlanItem17Tip": "Tersedia rekaman panggilan secara otomatis dan manual. Rekaman panggilan waktu penuh dan sesuai permintaan dengan transkripsi",
    "phone.fullPlanItem18": "Pemblokiran panggilan anonim dan tertentu yang dapat dikonfigurasi",
    "phone.fullPlanItem19": "Panggilan darurat",
    "phone.fullPlanItem19Tip": "Lakukan panggilan ke layanan darurat lokal",
    "phone.fullPlanItem20": "Pengalamatan Nomadik E911 (AS dan Kanada) -",
    "phone.fullPlanItem20Tip": "Deteksi lokasi pengguna secara dinamis dan laporkan alamat darurat yang sesuai ke layanan darurat lokal (khusus AS & Kanada) dan ke tim keamanan internal",
    "phone.fullPlanItem21": "Pusat tanggap darurat",
    "phone.fullPlanItem21Tip": "Aktifkan tim keselamatan internal Anda untuk diberi tahu tentang panggilan darurat dan rekam/pantau/ambil alih panggilan darurat untuk membantu mengoordinasikan respons.",
    "phone.fullPlanItem22": "Tampilan/delegasi sambungan bersama",
    "phone.fullPlanItem23": "Penyerahan panggilan antarperangkat",
    "phone.fullPlanItem24": "Parkir panggilan",
    "endToEndEncryptionForZoomPhone": "Enkripsi ujung-ke-ujung untuk Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Jika diaktifkan untuk Zoom Phone, enkripsi ujung-ke-ujung (E2EE) menetapkan bahwa panggilan dienkripsi menggunakan kunci kriptografik yang hanya diketahui oleh perangkat pemanggil dan penerima. Selain itu, pengguna akan memiliki opsi untuk memverifikasi status E2EE dengan memberikan kode keamanan unik satu sama lain.",
    "phone.fullPlanItem43": "Penyediaan telepon tanpa sentuhan",
    "phone.fullPlanItem44": "Campurkan jenis paket dalam satu akun",
    "phone.fullPlanItem46": "Pelaporan waktu nyata dan dasbor kualitas",
    "phone.fullPlanItem47": "Dukungan untuk lingkungan desktop virtual (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Pelajari Selengkapnya</a> tentang VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Tersedia untuk semua pelanggan telepon mandiri. Paket dukungan akan bervariasi saat dipasangkan dengan paket rapat.",
    "phone.fullPlanItem49": "Gunakan dukungan operator Anda sendiri",
    "phone.fullPlanItem49Tip": "Dukungan untuk peering langsung dan premise peering ke penyedia layanan PSTN Anda yang ada",
    "phone.fullPlanItem50": "Integrasi hibrida ke PBX lama",
    "phone.fullPlanItem51": "Tekan untuk Berbicara",
    "phone.fullPlanItem61": "Faks Online",
    "phone.fullPlanItem61Tip": "Mengirim dan menerima faks tanpa batas di AS dan Kanada. Untuk faks internasional, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">lihat tarif</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Tersedia untuk nomor AS & Kanada hanya dengan pembelian paket panggilan. Tersedia untuk digunakan oleh nomor langsung (bukan nomor perusahaan).",
    "meetings.fullPlanItem6": "Dukungan teknis",
    "meetings.fullPlanItem6Tip": "Paket premier support tersedia untuk membantu meminimalkan risiko dan mengurangi waktu henti.",
    "meetings.fullPlanItem6_basic": "Pusat bantuan",
    "meetings.fullPlanItem6_pro": "Tiket & obrolan langsung",
    "meetings.fullPlanItem6_biz": "Tiket, obrolan langsung, & telepon",
    "meetings.fullPlanItem6_ent": "Tiket, obrolan langsung, & telepon",
    "knowledgeBase": "Basis Pengetahuan",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Memecahkan masalah teknis dan mengakses sumber daya dukungan dengan mencari artikel basis pengetahuan kami.",
    "zoomCommunity": "Komunitas Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Tempat untuk menemukan solusi, mengajukan pertanyaan, dan berkolaborasi dengan pengguna Zoom lain.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Dapatkan jawaban atas pertanyaan dan pecahkan masalah teknis melalui interaksi dengan chatbot kami.",
    "submitWebTickets": "Kirim tiket web",
    "liveChatSupport": "Dukungan obrolan langsung",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Paket langganan lebih besar daripada ${amount} USD/bulan",
    "livePhoneSupport": "Dukungan telepon langsung",
    "meetWithAgentOnVideo": "Rapat dengan agen melalui video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Paket langganan lebih besar daripada $200 USD/bulan",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Tingkatkan produktivitas dengan memanfaatkan Aplikasi favorit Anda langsung dalam Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Sesuaikan avatar Anda sendiri untuk menghadirkan keseruan dalam rapat dan tampilkan diri Anda secara dinamis tanpa harus ada di video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "E-posta",
    "common.plans.meeting.title": "Rapat",
    "plans.basic_free.upgrade.item1": "Hingga 30 jam per rapat",
    "common.statistics.participants": "{0} Peserta",
    "common.per_meeting_unit": "per rapat",
    "common.participant_limit.increase_with_large_meetings": "Tingkatkan dengan Rapat Besar",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Papan Tulis",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Tanpa Batas",
    "common.plans.team_chat.title": "Obrolan Tim",
    "common.plans.mail_calendar.title": "Email & Kalender",
    "common.plans.cloud_storage.title": "Penyimpanan cloud",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Teks yang Diterjemahkan Zoom",
    "common.plans.extras.title": "Tambahan",
    "common.plans.extras.desc": "mengelola domain perusahaan, dan banyak lagi",
    "zoom_one_edu_bundle.school.title": "Zoom One untuk Pendidikan Sekolah dan Kampus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One untuk Pendidikan Sekolah dan Kampus Plus",
    "per_billing_cycle_license.monthly": "/bulan/lisensi",
    "per_billing_cycle_license.yearly": "/tahun/lisensi",
    "per_billing_cycle_space.monthly": "/bulan/ruang",
    "per_billing_cycle_space.yearly": "/tahun/ruang",
    "common.dialog.feature_list": "Lihat Daftar Fitur Lengkap",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per Lisensi",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per Lisensi",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus mencakup Tanpa Batas",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Konektor Ruang Konferensi (rasio 1:25)",
    "plans.whiteboard.ent": "Perusahaan Plus mencakup Tanpa Batas Plus",
    "plans.zp.ent": "Disertakan dalam paket Perusahaan Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Reservasi ruang kerja canggih atau di tempat, dan banyak lagi",
    "plans.largeMeeting.intro_tip": "Rapat Besar adalah add-on opsional saat checkout, sehingga memungkinkan Anda menyelenggarakan rapat hingga 500 atau 1.000 peserta, tergantung pada lisensi yang dibeli.",
    "common.participant_limit.expandable_with_large_meetings": "Dapat diperluas dengan Rapat Besar",
    "common.plans.meeting.enterprise": "500<br>1.000 untuk Perusahaan Plus",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Perusahaan Plus mencakup Sesi 1000 (termasuk Webinar)",
    "per_billing_cycle_user.monthly": "/bulan/pengguna",
    "per_billing_cycle_user.annually": "/tahun/pengguna",
    "closeComparisonChart": "Tutup Diagram Perbandingan",
    "archiving_api": "Mengarsipkan API",
    "dlp_api": "API DLP",
    "info_barriers": "Hambatan Informasi",
    "chat_etiquette": "Etiket Obrolan",
    "gdrp": "GDPR",
    "regiona_data_centers": "Pusat Data Regional",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Enkripsi secara Default",
    "end_to_end_encryption": "Enkripsi Ujung-ke-Ujung",
    "cryptographic_boundary": "Batasan Kriptografi",
    "vdi": "Desktop Virtual (VDI)",
    "customer_managed_key": "Kunci yang Dikelola Pelanggan",
    "gpo_msi_policies": "Kebijakan GPO/MSI",
    "msi": "Penyebaran Massal (MSI)",
    "ntt": "Alat Uji Jaringan (NTT)",
    "dashboards": "Dasbor",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Kemampuan Bertahan Zoom Phone",
    "zoom_meeting_survivability": "Kemampuan Bertahan Zoom Meeting",
    "paid_option": "Opsi Berbayar",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Fitur Inti",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Sekolah dan Kampus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Sekolah dan Kampus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "it-IT": {
    "billing.essential_apps": "Applicazioni Essenziali",
    "billing.essential_apps.dialog_desc": "Con le applicazioni per prendere appunti in riunione, che coinvolgono il team con attività interattive e forniscono analisi per migliorare le conversazioni con i clienti, fai crescere e gestisci la tua azienda. Applicazioni Premium gratuite per un anno, comprese nel tuo piano.",
    "billing.see_more_details": "Scopri ulteriori dettagli",
    "billing.essential_app.legal_copy": "L'offerta è disponibile solo per gli utenti con una licenza attiva a partire dal 4 gennaio 2023, con gli abbonamenti Zoom One Pro, Business o Business Plus acquistati sul canale online all'indirizzo di Zoom zoom.us/buy. Questa offerta non è disponibile per gli utenti con un abbonamento legato a un account del settore sanitario, del settore istruzione o della pubblica amministrazione.  L'accesso a ciascuna app, a eccezione di Coda, inizia con l'attivazione dell'app da parte del singolo utente e scade dopo un anno. L'accesso a Coda inizia, per tutti gli utenti dello stesso Account Zoom, quando un utente attiva per primo l'app Coda. Scadrà per tutti gli utenti dell'account Zoom un anno dopo, indipendentemente da quando l'hanno attivata gli altri utenti dello stesso Account Zoom.Per tutte le app: la riassegnazione o la cancellazione della licenza o dell'abbonamento idoneo da parte di un utente ne interromperà l'accesso, anche se il periodo di un anno è ancora in corso.Ogni app è soggetta alle condizioni d'uso e all'informativa sulla privacy disponibili al momento dell'attivazione.Le applicazioni incluse sono supportate solo in inglese.Non tutte le applicazioni funzionano sui dispositivi mobili.L'offerta non è riscattabile né rimborsabile in denaro contante.L'offerta è valida solo per le app incluse nell'elenco delle <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Applicazioni Essenziali su Zoom App Marketplace</a>. Gli utenti con abbonamenti preesistenti a una qualsiasi di queste applicazioni non possono avvalersi dell'offerta in riferimento a tali applicazioni specifiche.Zoom si riserva il diritto di modificare o annullare questa offerta in qualsiasi momento, senza preavviso né responsabilità.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Gestione visitatori"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Chat in diretta e assistenza telefonica 24 ore su 24 e 7 giorni su 7"
      },
      "learn_more": "Ulteriori informazioni",
      "new": "NUOVA",
      "plan_details": {
        "meeting": {
          "title": "Riunioni",
          "host_meeting_up_to_participants": "Organizza fino a {0} partecipanti",
          "meeting_hours": "Riunioni illimitate fino a 30 ore per riunione",
          "recording_storage": "{0} GB di archiviazione registrazioni su cloud (per licenza)",
          "auto_captions": "Sottotitoli automatici"
        },
        "whiteboard": {
          "title": "Lavagna",
          "boards_storage": "{0} lavagne modificabili",
          "standard_features": "Funzionalità standard"
        },
        "team_chat": {
          "title": "Chat di team",
          "desc": "Condivisione chat e file di gruppo"
        },
        "main_calendar": {
          "title": "Posta elettronica e calendario",
          "desc": "Posta elettronica e calendario client"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Crea e condividi documenti editabili all'interno di Zoom",
          "desc2": "Note personali e collaborative con modifiche in Rich Text Format"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Registra, modifica e condividi facilmente brevi video.",
          "desc2": "Video illimitati e funzionalità avanzate"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Ottieni accesso rapido a riepiloghi delle riunioni, assistenza nella stesura dei messaggi e altro ancora"
        },
        "EssentialApp": {
          "title": "Applicazioni Essenziali",
          "desc1": "Applicazioni Premium gratuite per un anno (si applicano le condizioni)",
          "desc2": "Aumenta la collaborazione e la produttività del team"
        },
        "livechat": {
          "title": "Assistenza tramite chat in diretta"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Desideri modificare in Zoom Workplace Pro?",
            "content": "In precedenza hai selezionato Zoom Workplace Business, che consente fino a 300 partecipanti per riunione, Zoom Scheduler e altro ancora. Desideri comunque modificare in Pro?",
            "confirm": "Conferma modifica",
            "keep_current": "Mantieni il piano attuale"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} spettatori",
          "participants": "{0} Partecipanti",
          "user_range": "{0}-{1} utenti",
          "items": "{num} articoli"
        },
        "button": {
          "ok": "OK",
          "add": "Aggiungi",
          "buy_now": "Acquista ora",
          "try_for_days": "Provalo per {0} giorni",
          "contact_sales": "Contatta il reparto vendite",
          "close": "Chiudi",
          "cancel": "Annulla",
          "edit": "Modifica",
          "got_it": "OK"
        },
        "title": {
          "everything_in_and": "Tutto in {0}, e:"
        },
        "tag": {
          "new": "NUOVA",
          "free_trial": "Prova gratuita"
        },
        "billing_cycle": {
          "annual": "Annuale",
          "monthly": "Mensile",
          "quarterly": "Trimestrale",
          "two_years": "Due anni",
          "three_years": "Tre anni"
        },
        "errors": {
          "unknown_error_try_again": "Errore sconosciuto durante l’elaborazione della transazione. Riprova più tardi."
        },
        "excluding_tax": {
          "vat_tip": "IVA esclusa",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Funzionalità limitate",
        "pro_plus": {
          "host_meeting_up_to_participants": "Organizza fino a {0} partecipanti",
          "gb_of_cloud_recording_storage": "{0} GB di archiviazione per registrazioni nel cloud (per licenza)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion per generazione e traduzioni di contenuti",
            "features_item2": "Numero illimitato di documenti condivisi con il team",
            "features_item3": "Accesso illimitato alla cronologia delle versioni",
            "comparison_table_tips": "Dai una marcia in più alla collaborazione con documenti basati sull'IA, che trasformano i contenuti delle riunioni in documenti, wiki e progetti fruibili"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Rilevare automaticamente le attività di riunioni, telefonate, chat e documenti",
            "features_item2": "Ottenere assistenza per il completamento delle attività, come la pianificazione di riunioni di follow-up e la stesura di documenti",
            "features_item3": "Contrassegnare facilmente le attività come completate quando sono finite per rimanere al passo con i tuoi progressi e concentrarti su ciò che verrà dopo",
            "features_item4": "Gestire le attività sulla piattaforma Zoom Workplace, incluso Zoom Docs",
            "features_item1_opc": "Sfruttare la potenza di AI Companion per identificare e creare attività da chat, e-mail, documenti, lavagne e riepiloghi delle riunioni",
            "features_item2_opc": "Ordinare, filtrare, raggruppare e cercare facilmente per accedere e raccogliere rapidamente il contesto sulle tue attività",
            "learn_more_header": "Monitora le tue azioni con AI Companion* per ottenere di più in Zoom Workplace.",
            "learn_more_footer": "\*AI Companion è disponibile solo per i piani Zoom Workplace Pro, Business ed Enterprise.",
            "features_prefix": "Lascia che AI Companion ti aiuti a:",
            "comparison_table_tips": "Rimani aggiornato sulle azioni e completale in tempo con una soluzione basata sull'IA che fornisce consigli sulle attività in base alle conversazioni e ai riepiloghi delle riunioni in Zoom Workplace.",
            "tasks_label_text": "Gestiione delle attività basata sull\'IA"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contattaci per avere informazioni sui prezzi e altro ancora",
          "contact_sales": "Contatta il reparto vendite",
          "meetings": "Riunioni",
          "phone": "Telefono",
          "phone_sub_title": "Chiamate illimitate",
          "use_only": "Esclusivamente per uso Business",
          "team_chat": {
            "title": "Chat di team",
            "title_desc": "Condivisione chat e file di gruppo"
          },
          "cloud_storage": {
            "title": "Archiviazione su cloud"
          },
          "mail_calender": {
            "title": "Posta elettronica e calendario"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client e assistenza"
          },
          "up_to_30_hours_per_meeting": "fino a 30 ore per riunione",
          "300_attendees": "300 partecipanti",
          "per_meeting": "per riunione",
          "whiteboard": {
            "title": "Lavagna"
          },
          "new": "NUOVA",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Extra",
          "sso_managed_domains_more": "SSO, domini gestiti e altro ancora",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Chiamate regionali illimitate",
          "translated_captions": "Sottotitoli tradotti",
          "workspace_reservation": "Prenotazione postazione",
          "auto_translated_captions": "Sottotitoli automatici e tradotti",
          "unlimited_editable_boards": "Lavagne modificabili illimitate",
          "standard_features": "Funzionalità standard",
          "advanced_docu_controls": "Controlli avanzati dei documenti",
          "chats_channels_for_collaboration": "Chat e canali per collaborazione, condivisione di file e molto altro",
          "zoom_phone_is_biz_use_only": "Zoom Phone è solo per uso aziendale",
          "unlimited_regional_calling": "Chiamate regionali illimitate",
          "domestic_sms_mms": "SMS e MMS nazionali",
          "automatic_call_distribution_groups": "Gruppi di distribuzione chiamata automatica (ACD) con coda chiamate",
          "single_sign_on": "Autenticazione unica",
          "managed_domains": "Domini gestiti",
          "company_branding": "Branding aziendale",
          "mail_calender_client_services_beta": "BETA Posta elettronica e calendario client e servizi",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Riunioni illimitate fino a 30 ore per riunione",
          "mail_and_calendar_client_and_services_beta": "BETA Posta elettronica e calendario client e servizi",
          "easily_record_edit_share_videos": "Registra, modifica e condividi facilmente brevi video.",
          "unlimited_videos_advanced_features": "Video illimitati e funzionalità avanzate",
          "create_share_editabel_docu_within_zoom": "Crea e condividi documenti editabili all'interno di Zoom",
          "personal_collaborative_notes_rich_text_editing": "Note personali e collaborative con modifiche in Rich Text Format",
          "effortlessly_share_meeting": "Condivisione senza problemi delle fasce orarie delle riunioni per prenotazioni semplici",
          "works_with_zoom_meeting_mail_calender_google_ms": "Operativo con Zoom Meetings, Zoom Mail, Zoom Calendar, Google e Microsoft 365",
          "up_to_300_attendees": "Fino a 300 partecipanti",
          "10_gb_of_storage": "10 GB di archiviazione",
          "host_meeting_up_to_300_participants": "Organizza riunioni con un massimo di 300 partecipanti",
          "10_gb_of_cloud_recording_storage": "10 GB di archiviazione registrazioni su cloud (per licenza)",
          "starting_at_licenses_year": "A partire da {1} licenze a {0}/anno",
          "starting_at_licenses_month": "A partire da {1} licenze a {0}/mese",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Ottieni accesso rapido a riepiloghi delle riunioni, assistenza nella stesura dei messaggi e altro ancora",
          "learn_more": "Ulteriori informazioni",
          "essential_apps": "Applicazioni Essenziali",
          "increase_team_collaboration": "Aumenta la collaborazione e la produttività del team",
          "free_premium_apps": "Applicazioni Premium gratuite per un anno (si applicano le condizioni)",
          "visitor_management": "Gestione visitatori",
          "visitor_management_custom_invites": "Personalizza gli inviti",
          "visitor_management_visitor_check": "Effettua il check-in a un kiosk",
          "visitor_management_receive_detailed": "Ricevi metriche dettagliate sull'utilizzo dell'area visitatori"
        },
        "custom_avatar": {
          "title": "Avatar personalizzato",
          "label_text": "Tre minuti al mese",
          "basic_feature": "1 minuto per ciclo di vita",
          "pricing_feature": "Tre minuti al mese",
          "learn_more_subtitle": "Crea una versione realistica di IA di te stesso con riproduzione vocale e comunicazione in diverse lingue.",
          "features_item1": "Ogni mese puoi creare fino a tre avatar digitali realistici che riproducono il tuo aspetto e la tua voce per presentazioni e dimostrazioni",
          "features_item2": "Usa il tuo avatar per inviare discorsi della durata massima di tre minuti con AI Companion",
          "features_item3": "Scegli tra 18 avatar predefiniti per una rapida creazione video in alta qualità",
          "features_item4": "Goditi il supporto dello sfondo virtuale",
          "features_item1_opc": "Ogni mese puoi creare fino a tre avatar digitali realistici che riproducono il tuo aspetto e la tua voce per presentazioni e dimostrazioni",
          "features_item2_opc": "Usa il tuo avatar per inviare discorsi della durata massima di tre minuti con AI Companion",
          "comparison_table_tips": "L'avatar personalizzato crea una versione realistica di IA di te stesso con riproduzione vocale e comunicazione multilingue."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Ottieni accesso rapido a riepiloghi delle riunioni, assistenza nella stesura dei messaggi e altro ancora",
        "learn_more_dialog": {
          "desc": "Aumenta la produttività con AI Companion! Può scrivere contenuti, programmarti le riunioni, aiutarti a gestire i progetti e molto altro ancora.",
          "tip1": "Ricevi l'ordine del giorno in anticipo, per tenere riunioni più efficaci",
          "tip2": "Tieni traccia dei tuoi progetti creando automaticamente i task e le notifiche",
          "tip3": "Fatti aiutare ad organizzare l'agenda e a gestire il tempo.",
          "tip4": "Genera contenuti nel tuo stile, scritti e grafici, in Docs, Whiteboard o nell'app Zoom Workplace."
        },
        "top_features": "Funzionalità principali",
        "more_to_come": "Altre incredibili funzionalità in arrivo.",
        "discover_more": "Scopri tutti i modi in cui AI Companion può migliorarti il lavoro!",
        "detail_desc": "AI Companion è incluso senza costi aggiuntivi con i servizi a pagamento degli account utente Zoom. Alcuni settori e aree geografiche potrebbero essere esclusi."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/anno/licenza",
        "month_licnese": "/mese/licenza",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/mese",
          "per_year": "/anno"
        },
        "unit": {
          "license": "{0}/licenza",
          "user": "{0}/utente"
        },
        "learn_more": "Ulteriori informazioni",
        "required": "Obbligatorio",
        "zoom_one_required": "È necessario Zoom Workplace",
        "large": {
          "features_tip": "Raggiungi più persone aumentando la capacità fino a 1000 partecipanti.",
          "label_title1": "500 partecipanti",
          "label_title2": "1000 partecipanti"
        },
        "cmr": {
          "features_tip": "Archivia, trasmetti in streaming e scarica le tue registrazioni video direttamente dal Cloud Zoom.",
          "explain_desc": "L'archiviazione su cloud è inclusa in piani Zoom One specifici: Pro (5 GB), Business (5 GB), Business Plus (10 GB) e Enterprise (illimitato)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 ore",
          "option_label2": "≈ 650 ore",
          "option_label3": "≈ 3,500 ore",
          "option_label4": "≈ 17,500 ore",
          "intro_label2": "Le opzioni di archiviazione includono fino a 5 TB/mese",
          "tooltip_content": "L'archiviazione delle registrazioni varia secondo il numero di partecipanti supportati dal video, la risoluzione della riunione e i contenuti condivisi."
        },
        "whiteboard": {
          "plus_title": "Lavagna Più",
          "title": "Whiteoard",
          "features_tip": "Collabora in tempo reale con i colleghi sulle lavagne, sia durante, sia al termine delle riunioni.",
          "explain_desc": "Inclusa in Zoom One Business, Zoom One Business Plus e Zoom One Enterprise",
          "explain_desc_plus": "Incluso in Zoom One Enterprise Plus e con ogni abbonamento Zoom Rooms",
          "option_label1": "Lavagne illimitate con 1 GB di archiviazione su cloud",
          "option_label2": "Funzionalità avanzata con lavagne illimitate e archiviazione su cloud",
          "intro_label1": "Lavagne illimitate, modificabili contemporaneamente",
          "intro_label2": "Funzionalità standard e controlli avanzati dei documenti",
          "intro_label3": "Funzionalità avanzate per la lavagna, tra cui modelli personalizzati e organizzativi, e integrazioni di terza parte"
        },
        "translated_captions": {
          "features_tip": "Rafforza la collaborazione globale con sottotitoli automatici nella lingua che preferisci.",
          "intro_label1": "I partecipanti possono abilitare i sottotitoli e cambiare lingua autonomamente.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Guarda le lingue supportate"
        },
        "crc": {
          "features_tip": "Abilita ogni endpoint per videoconferenza basato su standard SIP/H.323 per un lavoro ibrido efficace.",
          "intro_label1": "Funziona con diversi endpoint legacy, tra cui Polycom, Cisco, Lifesize e altri",
          "intro_label2": "Connettore sale in sede o basato su cloud (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Semplifica le prenotazioni con la disponibilità flessibile e le fasce orarie personalizzabili",
          "host_one_on_one": "Organizza riunioni individuali o di gruppo con un unico link per una facile condivisione.",
          "customize_reminders": "Personalizza i promemoria via e-mail/SMS e riduci gli appuntamenti persi",
          "sync_calendars": "Sincronizza i calendari senza problemi con le integrazioni di Google, Microsoft 365 e Zoom.",
          "features_tip": "Condividi senza problema gli slot delle riunioni per orari di ufficio, colloqui e altro ancora.",
          "intro_label1": "Integrazione calendario",
          "intro_label2": "Disponibilità ricorrente",
          "intro_label3": "Riunione scalabile",
          "intro_label4": "Avvisi personalizzabili",
          "intro_sub_label1": "Google, Microsoft 365 e Zoom ",
          "intro_sub_label2": "condivisione fasce orarie prenotabili ",
          "intro_sub_label3": "riunione singola per uno o più partecipanti",
          "intro_sub_label4": "promemoria e conferme automatizzate via e-mail o SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Registra, modifica e condividi messaggi video brevi e di alta qualità.",
          "intro_label1": "Crea tutti i video che desideri senza limiti di durata",
          "intro_label2": "Acquisisci schermo e video insieme o separatamente",
          "intro_label3": "Taglia il video secondo necessità e condivi il link",
          "intro_label4": "Accedi a funzionalità avanzate come trascrizioni audio e statistiche",
          "explain_desc": "Clips Plus è incluso negli abbonamenti Workplace Pro, Business ed Enterprise. Puoi esplorare le diverse funzionalità di ciascun piano nella sezione di confronto sulla pagina dei prezzi."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Piattaforma avanzata per eventi con solide funzioni di registrazione e networking. Ideale per esperienze sia virtuali che ibride.",
          "tooltip_content": "Organizza webinar o eventi illimitati con la capacità scelta",
          "intro_title": "Tutte le funzionalità di Zoom Sessions",
          "intro_label1": "Migliora il coinvolgimento del pubblico con eventi a sessioni multiple",
          "intro_label2": "Organizza eventi in modo semplice grazie all'app per dispositivi mobili e ai biglietti personalizzati",
          "intro_label3": "Aumenta i profitti dell'evento grazie all'Expo Floor e all'area sponsor",
          "intro_label4": "Networking dei partecipanti a Foster con profili personalizzabili",
          "intro_label5": "Amplia la portata con vista on-demand nella Hall dell'evento",
          "intro_label6": "Velocizza la configurazione dell'evento con modelli curati per gli eventi",
          "events_feature_item1_20240827": "Organizza eventi virtuali di più giorni con più tracce",
          "events_feature_item2_20240827": "Promuovi il networking con i profili dei partecipanti e la chat della hall",
          "events_feature_item3_20240827": "Fornisci indicazioni ai partecipanti grazie allo streaming della sessione della hall",
          "events_feature_item4_20240827": "Aumenta i profitti dell'evento grazie all'Expo Floor e all'area per gli sponsor",
          "events_feature_item5_20240827": "Migliora gli eventi futuri con i sondaggi successivi alla conferenza",
          "events_feature_item6_20240827": "Velocizza la configurazione dell'evento con modelli curati per gli eventi",
          "attendees_start_at": "{0} partecipanti a partire da",
          "explain_desc": "Scopri di più su Zoom Events",
          "contact_account_owner": "Se desideri acquistare Events, <a href=\"/account\" target=\"_blank\">contatta il titolare dell'account</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Semplifica gli eventi interattivi a sessione singola con funzioni come branding di eventi, collaborazione tra più organizzatori e gestione degli eventi.",
          "tooltip_content": "Organizza webinar o eventi illimitati con la capacità scelta",
          "intro_title": "Include Zoom Webinars",
          "intro_label1": "Personalizza le landing page degli eventi in modo da garantire un branding efficace",
          "intro_label2": "Promuovi gli eventi con e-mail brandizzate",
          "intro_label3": "Misura le prestazioni grazie a una dashboard interattiva",
          "intro_label4": "Collaborazione agevole con co-organizzatori e co-editori",
          "intro_label5": "Strumento per eventi professionali: Simulive",
          "sessions_feature_item1_20240827": "Migliora i webinar con ambienti e branding personalizzati",
          "sessions_feature_item2_20240827": "Semplifica la pianificazione degli eventi grazie alla generazione di messaggi e immagini da parte di AI Companion",
          "sessions_feature_item3_20240827": "Promuovi eventi passati e futuri in un hub di contenuti brandizzati",
          "sessions_feature_item4_20240827": "Gestisci eventi professionali con Backstage, Simulive e RTMP",
          "sessions_feature_item5_20240827": "Migliora i prossimi webinar con approfondimenti su più eventi",
          "explain_desc": "Scopri di più su Zoom Sessions",
          "contact_account_owner": "Se desideri acquistare Sessions, <a href=\"/account\" target=\"_blank\">contatta il titolare dell'account</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Video Webinars",
          "features_tip": "Grazie a una piattaforma webinar semplice da utilizzare, trasmetti i messaggi senza fatica.",
          "tooltip_content": "Organizza webinar o eventi illimitati con la capacità scelta",
          "intro_label1": "Coinvolgi il pubblico con webcasting video di alta qualità",
          "intro_label2": "Dai una marcia in più al coinvolgimento con domande e risposte, sondaggi e reazioni",
          "intro_label3": "Migliora la strategia dei webinar con la reportistica post-evento",
          "intro_label4": "Supporta fino a 100 000 partecipanti e 100 relatori",
          "monthly_subscription": "Abbonamento mensile",
          "annual_subscription": "Abbonamento annuale",
          "one_million": "1 milione",
          "single_use": "Utilizzo singolo",
          "one_month": "Un mese",
          "event_attendee": "Partecipanti a eventi/sessioni:",
          "event_attendee_desc": "chiunque partecipi senza essere un organizzatore autorizzato dell'hub. Anche chi ricopre un ruolo speciale è conteggiato come partecipante e può essere presente con audio, video e condivisione schermo (se abilitati).",
          "webinar_attendee": "Partecipanti dei webinar:",
          "webinar_attendee_desc": "chiunque partecipi ma non è un organizzatore né un relatore. È in modalità di sola visualizzazione e viene controllato dall'organizzatore, che può attivare il suo audio e abilitare l'interazione tramite Domande e risposte e chat.",
          "pay_per_attendee": "Paga per partecipante",
          "attendees": "spettatori"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Ridefinisci le modalità di lavoro in team con una piattaforma di collaborazione basata sull'IA.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Organizza riunioni illimitate fino a 30 ore con un massimo di 100 partecipanti",
          "intro_label2": "Grazie alle funzionalità standard, accedi fino a tre lavagne modificabili contemporaneamente",
          "intro_label3": "Registra, modifica e condividi messaggi video brevi e di alta qualità con Clips Plus",
          "intro_label4": "Porta a termine il lavoro in modo più efficiente con Zoom AI Companion",
          "intro_label5": "Zoom Phone chiamate illimitate USA e Canada (BYOC, PBX e PBX di terze parti escluse)",
          "intro_label6": "Organizza riunioni illimitate fino a 30 ore con un massimo di 300 partecipanti",
          "intro_label7": "Condividi gli slot delle riunioni per appuntamenti, colloqui e altro ancora con Zoom Scheduler",
          "intro_label8": "Zoom Phone chiamate illimitate USA e Canada",
          "intro_label8_UK": "Chiamate illimitate Zoom Phone in Regno Unito e Irlanda",
          "intro_label8_AU": "Chiamate illimitate Zoom Phone Australia e Nuova Zelanda",
          "intro_label8_JP": "Chiamate illimitate Zoom Phone Giappone",
          "intro_label9": "Gestione visitatori",
          "intro_label10": "Funzionalità aggiuntive",
          "intro_label11": "Assistenza tramite chat in diretta",
          "intro_title1": "Tutto in Pro, inoltre:",
          "intro_title2": "Tutto in Business, inoltre:",
          "intro_label_tip1": "Zoom Phone in Pro Plus non include le funzionalità BYOC, PBX di terza parte e VDI. Per maggiori informazioni, consulta la pagina dei prezzi di Zoom Phone.",
          "intro_label_tip2": "Quando finalizzi l'ordine, puoi selezionare Chiamate regionali illimitate per Stati Uniti e Canada, Australia e Nuova Zelanda o Regno Unito e Irlanda, o Giappone.",
          "intro_label_tip3": "Le funzionalità aggiuntive comprendono 10 GB di archiviazione su cloud, sottotitoli tradotti e Prenotazione Postazione.",
          "intro_label_tip4": "Zoom Phone in Pro Plus non include le funzionalità BYOC, PBX di terza parte e VDI. Per maggiori informazioni, consulta la pagina dei prezzi di Zoom Phone."
        },
        "power_pack": {
          "title": "Pacchetto Zoom Phone Power",
          "features_tip": "Analisi delle code chiamate e approfondimenti sulla cronologia migliorati per i team dei call center.",
          "intro_label1": "Finestra dei contatti ampliata per semplificare la gestione delle chiamate",
          "intro_label2": "Centralinista automatico e numeri telefonici della coda chiamate"
        },
        "international_calling": {
          "title": "Chiamate internazionali",
          "features_tip": "Chiamate internazionali illimitate verso oltre 15 Paesi e regioni.",
          "intro_label1": "Si può acquistare con tutti i piani di chiamate illimitati",
          "intro_label2": "Esplora il nostro elenco di Paesi e regioni supportati per chiamate internazionali illimitate.",
          "intro_labe2_tooltip": "Stati Uniti, Canada, Regno Unito, Irlanda, Australia, Nuova Zelanda, Austria, Danimarca, Francia, Germania, Italia, Portogallo, Spagna, Svezia, Belgio, Paesi Bassi, Svizzera, Portorico, Giappone.",
          "intro_label2_view_list": "Guarda l'elenco"
        },
        "workspace_reservation": {
          "title": "Prenotazioni aree di lavoro",
          "intro_title": "Prenota facilmente aree di lavoro flessibili o prenota camere d'albergo in anticipo o in loco, con i dispositivi integrati in Zoom.",
          "intro_label1": "Accedi alle prenotazioni aree di lavoro e hotel tramite l'app Zoom Workplace, desktop o browser",
          "intro_label2": "Ricevi consigli personalizzati con l'aiuto dell'IA",
          "intro_label3": "Prenota le aree di lavoro direttamente da Google Calendar o Outlook, con promemoria e avvisi di check-in",
          "intro_label4": "Muoviti verso aree di lavoro riservate con il wayfinding"
        },
        "visitor_management": {
          "title": "Gestione visitatori",
          "intro_title": "Semplifica il check in dei visitatori con inviti personalizzati, check in senza fastidi tramite i chioschi, report e metriche.",
          "intro_label1": "Gestisci gli inviti, le sedi dei visitatori e la cronologia delle visite nel portale Zoom",
          "intro_label2": "Crea, monitora, invia nuovamente ed elimina gli inviti mentre ricevi le notifiche di arrivo degli ospiti",
          "intro_label3": "Compila i moduli, ottieni indicazioni stradali ed effettua il check in tramite chiosco per offrire un'esperienza semplice ai visitatori",
          "intro_label4": "Accedi a tutte le funzionalità all'interno del portale Zoom, che conosci, e gestisci il tutto con facilità"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Grandi riunioni",
          "description1": "Aumenta la capacità della riunione per supportare fino a 1000 partecipanti interattivi dal vivo",
          "description2": "Tutti i partecipanti possono condividere audio, video e schermo"
        },
        "cloud_storage": {
          "title": "Archiviazione su cloud",
          "description2": "Formati file disponibili: MP4 o M4A"
        },
        "translated_captions": {
          "title": "Sottotitoli tradotti",
          "description1": "Migliora le riunioni con sottotitoli automatizzati multilingua. I partecipanti possono attivare la funzionalità e passare a una lingua supportata",
          "description2": "Servizio disponibile su Zoom Meeting e Webinars"
        },
        "tollfree": {
          "title": "Audioconferenza",
          "subcontent": "Chiama all'interno delle riunioni con numeri telefonici di tutto il mondo",
          "description1": "Amplia le tue opzioni di chiamata con chiamate in uscita, numeri verdi globali e chiamate in ingresso locali per Paesi premium",
          "description2": "Ai tuoi partecipanti non verranno addebitati costi per le chiamate di entrata da qualunque dispositivo",
          "description3": "Seleziona facilmente uno o più paesi per le chiamate in entrata a numeri verdi"
        },
        "rc": {
          "title": "Connettore sale conferenze"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgio",
        "Brazil": "Brasile",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Cile",
        "China": "Cina",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croazia",
        "Cyprus": "Cipro",
        "Czech_Republic": "Repubblica Ceca",
        "Denmark": "Danimarca",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finlandia",
        "France": "Francia",
        "Germany": "Germania",
        "Greece": "Grecia",
        "Hong_Kong_SAR": "Hong Kong R.A.S.",
        "Hungary": "Ungheria",
        "Ireland": "Irlanda",
        "Israel": "Israele",
        "Italy": "Italia",
        "Japan": "Giappone",
        "Latvia": "Lettonia",
        "Lithuania": "Lituania",
        "Luxembourg": "Lussemburgo",
        "Mexico": "Messico",
        "Netherlands": "Paesi Bassi",
        "New_Zealand": "Nuova Zelanda",
        "Norway": "Norvegia",
        "Panama": "Panama",
        "Peru": "Perù",
        "Poland": "Polonia",
        "Portugal": "Portogallo",
        "Puerto_Rico": "Porto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovacchia",
        "Slovenia": "Slovenia",
        "South_Africa": "Sud Africa",
        "Spain": "Spagna",
        "Sweden": "Svezia",
        "Switzerland": "Svizzera",
        "UK": "Regno Unito",
        "United_Kingdom": "Regno Unito",
        "US": "US",
        "United_States": "Stati Uniti",
        "title": "Requisiti del numero di telefono",
        "subtitle": "Seleziona il paese in cui sarà attivato il numero telefonico Global Select.",
        "selector_tip": "Seleziona Paese",
        "local_and_toll_free": "I numeri verdi e locali sono disponibili in {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select include un numero telefonico e chiamate nazionali illimitate all'interno del paese selezionato per licenza.",
        "avail_title": "Paesi/territori disponibili"
      },
      "tax_exempt_ecm": {
        "title": "Stato di esenzione fiscale",
        "status_exempt": "Esenzione fiscale",
        "status_exempt_question": "Hai un'esenzione fiscale?",
        "verify_now": "Verifica ora",
        "can_after_checkout": "Come opzione, questo passaggio può essere completato dopo il checkout.",
        "status": {
          "exempt": "Esenzione",
          "pending": "In sospeso",
          "pendingTooltip": "Il tuo stato di esenzione fiscale è attualmente in fase di revisione. Al momento dell'ordine potrebbero essere addebitate le imposte. Qualora l'esenzione venga approvata, accrediteremo tutte le tasse/commissioni rimborsabili sul tuo conto.",
          "nonexempt": "Non esente",
          "rejected": "Respinta",
          "rejectedTooltip": "È stato stabilito che il documento presentato non soddisfa i requisiti per la tua giurisdizione.",
          "approved": "Approvata",
          "default": "predefinito"
        },
        "confirm_close": {
          "new_desc": "Se interrompi la verifica, potrebbero essere addebitate le imposte/commissioni applicabili. Puoi comunque inviare il tuo documento di esenzione fiscale nella sezione Gestione fatturazione dopo l'acquisto in modo che ZOom lo revisioni e lo approvi. Una volta convalidato, verrà emesso un rimborso per le tasse addebitate.",
          "desc": "Vuoi abbandonare la verifica dell’esenzione fiscale e procedere come soggetto tassabile?",
          "title": "Confermi?",
          "new_title": "Vuoi interrompere la verifica dell'esenzione fiscale?",
          "yes": "Sì, abbandona",
          "no": "No, continua",
          "abandon": "Interrompi verifica",
          "go_back": "Torna indietro"
        },
        "confirm_to_add": {
          "title": "Conferma nuova esenzione fiscale predefinita",
          "message": "L'aggiunta di una nuova esenzione la imposterà automaticamente come predefinita una volta approvata o rifiutata. Puoi avere una sola esenzione predefinita, che si applicherà agli acquisti futuri. L'importo dell'imposta potrebbe essere influenzato se l'esenzione predefinita non corrisponde allo stato/alla regione dell'Acquirente.",
          "yes": "Aggiungi nuova esenzione"
        },
        "confirm_set_default": {
          "title": "Mancata corrispondenza tra indirizzo ed esenzione fiscale",
          "message": "L'indirizzo del \"Contatto dell'acquirente\" non corrisponde allo stato/regione che hai selezionato per l'esenzione fiscale. Aggiorna l'indirizzo del \"Contatto dell'acquirente\" affinché corrisponda al luogo in cui hai ottenuto l'esenzione fiscale. In caso contrario, il tuo acquisto potrebbe non essere esente da tasse.",
          "yes": "Imposta comunque come predefinito",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Stato/Regione",
          "exemption_type": "Tipo di esenzione",
          "signed_date": "Firmato in data",
          "status": "stato",
          "add_exemption": "Aggiungi esenzione",
          "view": "Visualizza",
          "set_as_default": "Imposta come predefinita"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Il tuo piano {planName} sarà annullato il giorno {date} alle ore 12:00 UTC. Se desideri restare organizzatore dopo aver annullato il piano, riattivalo.",
        "pairPreDescTip": "Il tuo piano {planName1} e il piano {planName2} verranno annullati il giorno {date} alle ore 12:00 UTC. Se desideri restare organizzatore dopo aver annullato i piani, riattivali.",
        "pairDiffDatePreDescTip": "Il tuo piano {planName1} e il piano {planName2} verranno annullati rispettivamente il giorno {date1} alle 12:00 UTC e il giorno {date2} alle 12:00 UTC. Se desideri restare organizzatore dopo aver annullato i piani, riattivali.",
        "title": "Riattiva il tuo piano per continuare",
        "titles": "Riattiva i tuoi piani per continuare",
        "plan": "Piano",
        "licenses": "Licenza/e",
        "billingCycle": "Ciclo di fatturazione",
        "effective_date": "Data fattura",
        "invoice_amount": "Importo della fattura",
        "singleDescTip": "Con la riattivazione, accetti che il tuo piano ricorrente si rinnovi automaticamente il giorno {date}, e di ricevere l'addebito sul tuo metodo di pagamento registrato a ogni periodo di rinnovo. Per evitare addebiti futuri, <a target=\"_blank\" href=\"https://support.zoom.com/hc/it/article?id=zm_kb&sysparm_article=KB0066687\">annulla</a> entro il giorno precedente alla data di rinnovo.",
        "pairDescTip": "Riattivandoli, accetti che i tuoi piani ricorrenti si rinnoveranno automaticamente il giorno {date}. Riceverai un addebito sul tuo metodo di pagamento registrato a ogni periodo di rinnovo. Per evitare addebiti futuri, <a target=\"_blank\" href=\"https://support.zoom.com/hc/it/article?id=zm_kb&sysparm_article=KB0066687\">annulla</a> entro il giorno precedente alla data di rinnovo.",
        "pairDiffDateDescTip": "Riattivandoli, accetti che i tuoi piani ricorrenti si rinnoveranno automaticamente il giorno {date1} e il giorno {date2}. Riceverai un addebito sul tuo metodo di pagamento registrato a ogni periodo di rinnovo. Per evitare addebiti futuri, <a target=\"_blank\" href=\"https://support.zoom.com/hc/it/article?id=zm_kb&sysparm_article=KB0066687\">annulla</a> entro il giorno precedente alla data di rinnovo.",
        "totalLabel": "Totale",
        "totalContent": "{money} più le tasse applicabili",
        "taxDesc": "escluse IVA, GST o imposte simili",
        "reactivateBtn": "Procedi e riattiva",
        "switchTitle": "Aggiorna il tuo piano per continuare",
        "successSingleTip": "Il tuo piano {planName} è stato riattivato",
        "successPairTip": "Il suo piano {planName1} e {planName2} sono stati riattivati.",
        "switchTip": "Il tuo piano Zoom Webinars di un mese scade {date}. Per organizzare un webinar dopo tale data, devi scegliere un piano di abbonamento.",
        "switchBtn": "Scegli un piano di abbonamento"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Scarica la Scheda Dati"
      },
      "one": {
        "new": "NUOVA"
      }
    },
    "webinarSetupInWebPortal": "Configurazione webinar nel web portal",
    "concurrentEvents": "Eventi in contemporanea",
    "coucurrentEventsToolTip": "<span>Un piano di <b>abbonamento</b> supporta un evento live alla volta",
    "overages": "Eccedenze",
    "eventsPlatformHubs": "Hub sulla piattaforma Zoom Events",
    "eventsHubToolTip": "Gli <b>hub</b> Zoom Events offrono una comoda organizzazione di eventi",
    "1HubPerLicense": "1 hub per licenza",
    "1000Hubs": "1000 hub",
    "eventsPlatformHosts_500AttendeesOrMore": "Organizzatori piattaforma eventi (500 partecipanti o più)",
    "eventsHost500": "<span>Gli organizzatori dell'hub <b>Zoom Events</b> possono creare",
    "5HubHosts": "5 organizzatori dell'hub",
    "100HubHosts": "100 organizzatori dell'hub",
    "eventsPlatformHosts_100Attendees": "Organizzatori della piattaforma eventi (100 partecipanti)",
    "eventsHost100": "<span>Gli organizzatori dell'hub <b>Zoom Events</b> possono creare",
    "2HubHosts": "2 organizzatori dell'hub",
    "howAreTheyDifferent": "Come differiscono?",
    "allPlansRequireAZoomOneLicense": "*Per tutti i piani è necessaria una licenza Zoom Workplace",
    "subscription": "Abbonamento",
    "subscriptionToolTip": "L'<span>A<b>abbonamento</b> ti consente di organizzare un numero illimitato di eventi alla capacità che hai scelto.</span>",
    "payPerAttendee": "Paga per partecipante",
    "ppaToolTips": "<span>La licenza <b>paga per partecipante</b> determina quanti partecipanti in totale possono prendere parte a tutti gli eventi dell'account che si tengono in un periodo di 12 mesi a partire dall'acquisto.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Sondaggi",
    "meetings.fullPlanItem2": "Numero licenze",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Videoconferenze e messaggistica semplificate su qualsiasi dispositivo",
    "meetings.fullPlanItem5": "Durata della riunione",
    "meetings.fullPlanItem5Tip": "La durata massima durata per riunione di gruppo (3 o pi\u00F9 partecipanti).",
    "meetings.fullPlanItem5_basic": "40 minuti",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 ore",
    "meetings.fullPlanItem5_biz": "30 ore",
    "meetings.fullPlanItem5_ent": "30 ore",
    "meetings.fullPlanItem1": "Capacit\u00E0 partecipanti",
    "meetings.fullPlanItem1Tip": "Un partecipante \u00E8 una persona invitata a una riunione da qualcuno con una licenza. I partecipanti possono unirsi a una riunione dal loro telefono, da desktop e da dispositivi mobili e tablet. Un partecipante non ha bisogno di un account Zoom per partecipare a una riunione. Ogni piano ha un numero massimo di partecipanti, ma gli utenti possono aumentare tale limite acquistando un piano a pagamento aggiuntivo.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1000 per Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Registrazione",
    "meetings.fullPlanItem7Tip": "La registrazione in locale di Zoom salva le registrazioni delle riunioni nei formati MP4 (video), M4A (audio) e txt (chat).<br>La registrazione nel Cloud Zoom archivia le riunioni nel Cloud Zoom, dove i file possono essere scaricati e/o trasmessi in streaming da un browser.",
    "meetings.fullPlanItem7_basic": "Locale",
    "meetings.fullPlanItem7_pro": "Locale e 5 GB su Cloud (per licenza)",
    "meetings.fullPlanItem7_biz": "Locale e 10 GB su Cloud (per licenza)",
    "meetings.fullPlanItem7_ent": "Locale e illimitata su Cloud",
    "one.messaging": "Messaggi",
    "meetings.fullPlanItem16Tip": "La chat consente di inviare in maniera semplice messaggi di gruppo, file, screenshot, frammenti di codice, messaggi vocali e immagini. \u00C8 possibile formattare il testo e usare GIF ed emoji. \u00C8 possibile visualizzare la presenza dei partecipanti alla chat per vedere se sono attivi su desktop o dispositivo mobile, oppure occupati durante le riunioni.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Senza limitazioni",
    "meetings.fullPlanItem_EssentialApp": "Applicazioni Essenziali",
    "common.learnMore": "Ulteriori informazioni",
    "meetings.fullPlanItem_EssentialAppText": "Applicazioni Premium gratuite per un anno (si applicano le condizioni)",
    "zoomMailAndCalendarInTheZoomApp": "Posta elettronica e calendario Zoom sull'app Zoom",
    "mailService": "Servizio di posta ordinaria",
    "emailServiceWithFullTimeEndToEnd": "Servizio di posta elettronica con crittografia end-to-end a tempo pieno, per una maggiore privacy",
    "customMailDomain": "Dominio di posta elettronica personalizzato",
    "customMailDomainWithMailService": "Dominio di posta elettronica con servizio di posta elettronica",
    "calendarClient": "Client calendario",
    "scheduleAndJoinMeetings": "Pianifica e partecipa alle riunioni sull'app Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Servizio Calendario",
    "meetingSchedulingAndAppointment": "Pianificazione riunioni e prenotazione appuntamenti",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Crea, modifica e condividi agevolmente brevi video. È possibile trovare facilmente i clip e questo migliora il coinvolgimento.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Le note offrono un solido editor per documenti, personale e collaborativo, con opzioni dettagliate di formattazione, accessibili sia all'interno che all'esterno delle riunioni.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Sottotitoli tradotti",
    "workspaceReservation": "Prenotazione postazione",
    "accessAcrossAnyDevice": "Accesso tramite qualsiasi dispositivo",
    "meetings.fullPlanItem4": "Riunioni illimitate",
    "meetings.fullPlanItem9": "Chiamata in ingresso",
    "meetings.fullPlanItem9Tip": "Partecipa a una riunione Zoom via tele/audioconferenza (utilizzando un telefono tradizionale). Gli utenti riceveranno un addebito in base al proprio piano telefonico. Prova le nostre audioconferenze aggiuntive per numeri gratuiti per chiamate in ingresso.",
    "meetings.fullPlanItem9_pro": "A pagamento",
    "meetings.fullPlanItem9_biz": "A pagamento",
    "meetings.fullPlanItem9_ent": "A pagamento",
    "meetings.fullPlanItem11": "Condivisione dello schermo",
    "meetings.fullPlanItem11Tip": "Condivisione desktop e applicazioni. Gli utenti di riunioni con licenza possono permettere a pi\u00F9 partecipanti di condividere i loro schermi simultaneamente durante una riunione di cui sono presentatori.",
    "meetings.fullPlanItem12": "Sessioni secondarie",
    "meetings.fullPlanItem12Tip": "Le sessioni secondarie video permettono di suddividere le riunioni Zoom in sessioni separate fino a 50 per dibattiti, progetti e altro.",
    "meetings.fullPlanItem14": "Sfondo virtuale",
    "meetings.fullPlanItem15": "ID Riunione personale",
    "meetings.fullPlanItem15Tip": "Crea la tua sala riunione online permanente. Puoi avviare questa riunione in qualsiasi momento o programmarla per un uso futuro.",
    "meetings.fullPlanItem17": "Comandi presentatore",
    "meetings.fullPlanItem18": "Annotazione congiunta su condivisione schermo",
    "meetings.fullPlanItem19": "Tastiera da remoto e controllo del mouse",
    "meetings.fullPlanItem21": "Condivisione multipla",
    "meetings.fullPlanItem29": "Sala d\u2019attesa",
    "meetings.fullPlanItem29Tip": "La funzionalit\u00E0 di sala d\u2019attesa consente al presentatore di controllare l\u2019accesso dei partecipanti a una riunione. Il presentatore pu\u00F2 ammettere i partecipanti uno a uno o tutti insieme. Nelle impostazioni puoi definire chi trasferire in sala d\u2019attesa e chi ammettere automaticamente. La funzionalit\u00E0 di sala d\u2019attesa \u00E8 disponibile su tutti gli account. I presentatori possono inviare messaggi alla sala d\u2019attesa. Gli utenti con piani a pagamento possono personalizzare la sala d\u2019attesa.",
    "meetings.fullPlanItem41": "Disponibile sui dispositivi Zoom for Home",
    "meetings.fullPlanItem61": "Fissa pi\u00F9 persone",
    "meetings.fullPlanItem61Tip": "L'organizzatore pu\u00F2 permettere di fissare i video di massimo 9 persone per creare la propria visualizzazione personalizzata. I video fissati rimangono quindi visibili indipendentemente da chi sta parlando.",
    "meetings.fullPlanItem62": "Metti in evidenza pi\u00F9 persone",
    "meetings.fullPlanItem62Tip": "L'organizzatore pu\u00F2 mettere in evidenza i video di fino a 9 partecipanti, in modo che chiunque partecipi alla riunione veda i video in evidenza, indipendentemente da chi sta parlando.",
    "meetings.fullPlanNewItem1": "Filtri",
    "meetings.fullPlanNewItem1Tip": "Ancora pi\u00F9 divertimento per i tuoi happy hour e per le tue feste con i filtri colorati e gli adesivi degli animali.",
    "meetings.fullPlanNewItem2": "Sondaggi",
    "meetings.fullPlanNewItem3": "Co-organizzatore o organizzatore alternativo",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Scopri di pi\u00F9 sui comandi per co-organizzatori di riunioni.</a>",
    "meetings.fullPlanItem24": "Assegna pianificazione riunione",
    "meetings.fullPlanItem24Tip": "Ti permette di assegnare a qualcun altro la pianificazione delle tue riunioni per tuo conto. Anche l\u2019assegnatario deve avere un piano Pro.",
    "meetings.fullPlanItem25": "API REST",
    "meetings.fullPlanItem25Tip": "Permette ai titolari dell\u2019account, agli admin e ai tuoi sviluppatori di avere un accesso sicuro all\u2019API REST di Zoom. I limiti di tasso API vengono applicati a livello dell\u2019account in base al Tipo di Account (Pro, Business, Enterprise, ecc\u2026) e al Tipo di richiesta API (basso, medio, ingente ecc\u2026). L\u2019accesso ad alcuni API \u00E8 limitato a determinati tipi di account. Usa i limiti di tasso APIdocumentazione di riferimento API per scoprire tutti i dettagli.",
    "meetings.fullPlanItem25_pro": "Limiti di richieste API REST Pro",
    "meetings.fullPlanItem25_biz": "Limiti di richieste API REST",
    "meetings.fullPlanItem26": "Interoperabilit\u00E0 di Skype for Business (Lync)",
    "meetings.fullPlanItem26Tip": "Permette agli utenti Lync 2010, 2013 e Skype for Business di avviare una riunione Zoom dalla lista di contatti Lync.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Trasmetti in diretta su Facebook, YouTube o un servizio di terze parti.",
    "meetings.fullPlanItem28": "Rapporti",
    "meetings.fullPlanItem28Tip": "Salva le sessioni delle lavagne",
    "meetings.fullPlanItem30": "Gestione degli utenti",
    "meetings.fullPlanItem30Tip": "I proprietari e gli amministratori possono aggiungere, eliminare o assegnare ruoli e funzionalit\u00E0 aggiuntive.",
    "one.autoCaptions": "Sottotitoli automatici",
    "meetings.fullPlanItem31": "Portale amministratori",
    "meetings.fullPlanItem31Tip": "Permette di gestire tutti gli utenti all\u2019interno della tua azienda in unico account per fatturazione semplificata, impostazioni per la gestione degli utenti avanzate e approfondimenti completi sull\u2019utilizzo, tutto questo nel Portale amministratori Zoom.",
    "meetings.fullPlanItem32": "Integrazione LTI",
    "meetings.fullPlanItem32Tip": "Aggiungi facilmente una riunione a qualunque attivit\u00E0 del corso e invita gli studenti giusti dal sistema di gestione dell\u2019apprendimento (funziona con Moodle, Canvas, Desire2Learn e Blackboard).",
    "meetings.fullPlanItem33": "Trascrizione delle registrazioni nel cloud",
    "meetings.fullPlanItem33Tip": "Le trascrizioni delle registrazioni nel cloud sono le trascrizioni dell\u2019audio delle riunioni o dei webinar che registri nel cloud. Attenzione: al momento questa funzionalit\u00E0 \u00E8 disponibile solo per l\u2019inglese. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Fai clic qui</a> per saperne di pi\u00F9.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Aggiungi il branding aziendale alla tua pagina personalizzata, da cui gli utenti possono partecipare a una riunione. Crea un modello e-mail brandizzato da inviare ai partecipanti.",
    "meetings.fullPlanItem35": "Domini gestiti",
    "meetings.fullPlanItem35Tip": "Usa il dominio del tuo indirizzo e-mail aziendale/universitario per aggiungere automaticamente utenti al tuo account.",
    "meetings.fullPlanItem37": "Interpreti linguistici",
    "meetings.fullPlanItem37Tip": "Permette al presentatore della riunione di nominare degli interpreti nelle riunioni e nei webinar. All\u2019avvio della riunione o del webinar, il presentatore pu\u00F2 attivare la funzione di interpretazione, che permetter\u00E0 agli interpreti di avere accesso a canali audio specifici. I partecipanti potranno poi selezionare il canale audio della lingua che preferiscono. I partecipanti potranno ascoltare l\u2019audio tradotto e decidere di ascoltare anche l\u2019originale a volume pi\u00F9 basso.",
    "meetings.fullPlanItem39": "Executive Business Review",
    "meetings.fullPlanItem39Tip": "Analisi dettagliate dei trend emergenti, tracciamento ROI, discussioni sulla roadmap di prodotto.",
    "meetings.fullPlanNewItem4": "Include Webinar 500",
    "one.translatedCations": "Sottotitoli tradotti",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Chat diretta, di canale o di gruppo",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Comunica facilmente con le persone individualmente, in piccoli gruppi o in grandi team",
    "messageAndFileHistory": "Cronologia dei messaggi e dei file",
    "findPeopeChannelsAndFilesInSearch": "Con la funzione Ricerca, trova persone, canali e file",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Trova rapidamente contatti, messaggi istantanei, chat di gruppo e file, per tenere tutte le informazioni sempre a portata di mano.",
    "applicationIntegrations": "Integrazioni con le applicazioni",
    "secureFileSharing": "Condivisone sicura dei file",
    "enhanceCollaborationWithSeamlessFileSharing": "Migliora la collaborazione grazie alla condivisone agevole dei file",
    "persistentMeetingChat": "Chat persistente durante la riunione",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Non perdere le conversazioni della riunione Comunica prima, durante e dopo la riunione in una chat di gruppo dedicata su Zoom Team Chat per tutti i partecipanti alla riunione.",
    "cloudStorage": "Archiviazione su cloud",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Archivia i canali sul cloud Zoom o presso un provider di archiviazione di terze parti",
    "avatars": "Avatar",
    "inMeetingReactions": "Reazioni durante la riunione",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Mostra coinvolgimento e comunica in modo rapido e non verbale con gli altri partecipanti",
    "virtualBackgrounds": "Sfondi virtuali",
    "videoFilters": "Filtri video",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Dai una svolta di allegria alle riunioni grazie ai filtri da sovrapporre al video",
    "inMeetingPollsAndQuizzes": "Sondaggi e quiz durante la riunione",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Crea domande per sondaggi a scelta singola o multipla per le riunioni.",
    "liveStreamingAcrossPlatforms": "Diretta streaming su diverse piattaforme",
    "appearanceTouchUp": "Ritocco dell'aspetto personale",
    "originalSoundForMusicians": "Audio originale per i musicisti",
    "endToEndEncryptionForZoomMeetings": "Crittografia end-to-end per Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Se abilitata, la crittografia end-to-end (E2EE) per Zoom Meetings fa sì che le comunicazioni tra i partecipanti delle riunioni che utilizzano il client di Zoom in una data riunione siano crittografate con chiavi di crittografia riconosciute solo dai dispositivi dei suddetti partecipanti. Ciò significa che è possibile evitare che terze parti (incluso Zoom) abbiano accesso alle chiavi private della riunione.",
    "zoomCustomerManagedKey": "Chiave gestita dal cliente Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Introduci le tue chiavi di crittografia per proteggere i dati di Zoom memorizzati",
    "enterpriseGradeSecurityFeatures": "Funzionalità di sicurezza di livello Enterprise",
    "256BitAesGcmEncryptionForRealTimeContent": "Crittografia AES-GCM a 256 bit per contenuti e contenuti multimediali in tempo reale, crittografia TLS durante la registrazione SIP, mascheramento dell'ID chiamante, peering di rete privata, rilevamento di frodi di strumenti ed elenchi di chiamate bloccate.",
    "phone.fullPlanItem40": "Autenticazione unica tramite SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Chiamate interne illimitate",
    "phone.fullPlanItem2": "Chiamate in uscita a pagamento",
    "phone.fullPlanItem3": "Chiamate in uscita illimitate",
    "phone.fullPlanItem4": "Alta qualit\u00E0 delle chiamate in HD",
    "phone.fullPlanItem4Tip": "Con eliminazione di rumore, eco e rumori da tastiera attiva",
    "phone.fullPlanItem5": "App native per desktop Windows, MacOS e Linux",
    "phone.fullPlanItem6": "App native per dispositivi mobili iOS e Android",
    "phone.fullPlanItem7": "Portabilit\u00E0 di numeri esistenti o acquisto di nuovi (DID)",
    "phone.fullPlanItem8": "Numeri gratuiti",
    "phone.fullPlanItem9": "Numero interno",
    "phone.fullPlanItem10": "Segreteria telefonica con trascrizione",
    "phone.fullPlanItem10Tip": "La segreteria telefonica trascrive l\u2019accesso tramite app per dispositivi mobili/desktop ed e-mail",
    "phone.fullPlanItem11": "Spettatori autonomi illimitati/IVR",
    "phone.fullPlanItem12": "Directory chiamata per nome",
    "phone.fullPlanItem13": "Gruppi di distribuzione chiamata automatica (ACD) con coda chiamate",
    "phone.fullPlanItem14": "Intervieni/Monitora/Sussurra/Controlla",
    "phone.fullPlanItem15": "Routing giorni feriali e festivi",
    "phone.fullPlanItem16": "3 modalit\u00E0 di conferenza ad hoc",
    "phone.fullPlanItem17": "Registrazione chiamate",
    "phone.fullPlanItem17Tip": "\u00C8 possibile registrare le chiamate automaticamente o manualmente.",
    "phone.fullPlanItem18": "Configurazione anonimo e blocco chiamate specifiche",
    "phone.fullPlanItem19": "Chiamate di emergenza",
    "phone.fullPlanItem19Tip": "Direziona le chiamate ai servizi di emergenza locali",
    "phone.fullPlanItem20": "Indirizzamento Nomadic E911 (Stati Uniti e Canada) -",
    "phone.fullPlanItem20Tip": "Rileva dinamicamente la posizione dell\u2019utente e avvisa il corrispondente indirizzo di emergenza dei servizi di emergenza locali (solo Stati Uniti e Canada) e un team per la sicurezza interno",
    "phone.fullPlanItem21": "Centro operativo per le emergenze",
    "phone.fullPlanItem21Tip": "Permette al tuo team per la sicurezza interna di essere allertato da chiamate di emergenza e di registrare/monitorare/intervenire nelle chiamate di emergenza per aiutare a coordinare la risposta.",
    "phone.fullPlanItem22": "Aspetto/delega della linea condivisa",
    "phone.fullPlanItem23": "Trasferimento chiamata tra i dispositivi",
    "phone.fullPlanItem24": "Parcheggio chiamata",
    "endToEndEncryptionForZoomPhone": "Crittografia end-to-end per Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Quando è abilitata per Zoom Phone, la crittografia end-to-end (E2EE) utilizza chiavi crittografiche note solo ai dispositivi del chiamante e del ricevente per crittografare la chiamata. Inoltre, gli utenti avranno l'opzione di verificare lo stato della E2EE fornendosi a vicenda un codice di sicurezza univoco.",
    "phone.fullPlanItem43": "Provisioning zero-touch dei telefoni",
    "phone.fullPlanItem44": "Diversi tipi di piani in un account",
    "phone.fullPlanItem46": "Rapporti in tempo reale e dashboard di qualit\u00E0",
    "phone.fullPlanItem47": "Assistenza ambiente desktop virtuale (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Scopri di pi\u00F9</a> su VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Disponibile per tutti i clienti di telefonia autonoma. I piani di assistenza variano se abbinati ai piani di riunioni.",
    "phone.fullPlanItem49": "Conserva il tuo operatore",
    "phone.fullPlanItem49Tip": "Assistenza per peering diretto e in locale con il tuo attuale fornitore di servizi PSTN",
    "phone.fullPlanItem50": "Integrazione ibrida con legacy PBX",
    "phone.fullPlanItem51": "Premi per parlare",
    "phone.fullPlanItem61": "Fax online",
    "phone.fullPlanItem61Tip": "Invia e ricevi fax illimitati negli Stati Uniti e in Canada. Per i fax internazionali, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\"> vedi tariffa</a>",
    "phone.fullPlanSms": "SMS e MMS",
    "phone.fullPlanSmsTip": "Disponibili per numeri di USA e Canada, solo acquistando un piano di chiamata. Disponibilit\u00E0 d'uso per numeri diretti (non per numeri aziendali).",
    "meetings.fullPlanItem6": "Assistenza tecnica",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Solo ticket",
    "meetings.fullPlanItem6_pro": "Ticket e chat in diretta",
    "meetings.fullPlanItem6_biz": "Ticket, chat in diretta e telefono",
    "meetings.fullPlanItem6_ent": "Ticket, chat in diretta e telefono",
    "knowledgeBase": "Base di conoscenze",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Risolvi i problemi tecnici e accedi alle risorse di assistenza eseguendo una ricerca fra gli articoli della base di conoscenze.",
    "zoomCommunity": "Comunità di Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Un luogo in cui trovare soluzioni, porre domande e collaborare con altri utenti di Zoom.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Ricevi risposte alle domande e risolvi i problemi tecnici interagendo con il nostro chatbot.",
    "submitWebTickets": "Invia ticket web",
    "liveChatSupport": "Assistenza tramite chat in diretta",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Piani di abbonamento superiori ai {amount} USD/mese",
    "livePhoneSupport": "Assistenza telefonica live",
    "meetWithAgentOnVideo": "Incontra l'agente in video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Piani di abbonamento superiori ai 200 USD/mese",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Aumenta la produttività usando le tue le app preferite direttamente all'interno di Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Personalizza il tuo avatar per rendere più divertenti le riunioni e presentarti dinamicamente senza dover apparire in video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Posta ordinaria",
    "common.plans.meeting.title": "Cuộc họp",
    "plans.basic_free.upgrade.item1": "Tối đa 30 tiếng mỗi cuộc họp",
    "common.statistics.participants": "{0} Người tham gia",
    "common.per_meeting_unit": "per riunione",
    "common.participant_limit.increase_with_large_meetings": "Aumenta con Grandi riunioni",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Bảng trắng",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Không giới hạn",
    "common.plans.team_chat.title": "Trò chuyện nhóm",
    "common.plans.mail_calendar.title": "Thư và lịch",
    "common.plans.cloud_storage.title": "Lưu trữ trên đám mây",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Chú thích đã dịch trên Zoom",
    "common.plans.extras.title": "Dịch vụ bổ sung",
    "common.plans.extras.desc": "gestisci i domini aziendali e altro ancora",
    "zoom_one_edu_bundle.school.title": "Zoom One per l'istruzione, Scuola e Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One per l'istruzione, Scuola e Campus Plus",
    "per_billing_cycle_license.monthly": "/tháng/giấy phép",
    "per_billing_cycle_license.yearly": "/năm/giấy phép",
    "per_billing_cycle_space.monthly": "/mese/spazio",
    "per_billing_cycle_space.yearly": "/anno/spazio",
    "common.dialog.feature_list": "Xem danh sách toàn bộ tính năng",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB mỗi giấy phép",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per licenza",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus include il piano illimitato",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (rapporto 1:25)",
    "plans.whiteboard.ent": "Enterprise Plus include il piano Unlimited Plus",
    "plans.zp.ent": "*Incluso con Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Prenotazione postazione avanzata o in loco e altro ancora",
    "plans.largeMeeting.intro_tip": "Grandi riunioni è un add-on facoltativo durante il checkout, che consente di organizzare una riunione fino a un massimo di 500 o 1 000 partecipanti, a seconda della licenza acquistata.",
    "common.participant_limit.expandable_with_large_meetings": "Espandibile con Grandi riunioni",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1000 per Enterprise Plus</span>",
    "plans.webinar": "Webinar Zoom",
    "plans.webinar.ent": "Enterprise Plus include Session 1000 (include Webinar)",
    "per_billing_cycle_user.monthly": "/tháng/người dùng",
    "per_billing_cycle_user.annually": "/năm/người dùng",
    "closeComparisonChart": "Tabella di confronto ravvicinato",
    "archiving_api": "API di archiviazione",
    "dlp_api": "API DLP",
    "info_barriers": "Ostacoli informativi",
    "chat_etiquette": "Netiquette della chat",
    "gdrp": "GDPR",
    "regiona_data_centers": "Data center regionali",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Crittografia per impostazione predefinita",
    "end_to_end_encryption": "Crittografia end-to-end",
    "cryptographic_boundary": "Limiti crittografici",
    "vdi": "Desktop virtuale (VDI)",
    "customer_managed_key": "Chiave gestita dal cliente",
    "gpo_msi_policies": "Termini GPO/MSI",
    "msi": "Implementazione in blocco (MSI)",
    "ntt": "Applicativo di test di rete (NTT)",
    "dashboards": "Dashboard",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Sopravvivenza Zoom Phone",
    "zoom_meeting_survivability": "Sopravvivenza Zoom Meetings",
    "paid_option": "Opzione a pagamento",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Funzionalità fondamentali",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Scuola e Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Scuola e Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "jp-JP": {
    "billing.essential_apps": "推奨アプリ",
    "billing.essential_apps.dialog_desc": "ミーティングのメモ、インタラクティブな作業に対するチームの適応、インサイトの提供による顧客とのやり取り改善に適したアプリを活用してビジネスを拡大、管理しましょう。 ご利用のプランに 1 年間無料のプレミアム アプリが含まれます。",
    "billing.see_more_details": "詳細を確認",
    "billing.essential_app.legal_copy": "こちらの特典は、2023 年 1 月 4 日以降に Zoom オンライン チャネル（zoom.us/buy）を介して購入された Zoom One プロ、ビジネス、またはビジネスプラス サブスクリプションの現行ライセンスを持つユーザーのみを対象としています。 サブスクリプションが、医療機関、教育機関、または政府アカウントに関連付けられているユーザーは、こちらの特典の対象外です。  各アプリ（Coda を除く）にアクセスすると、個々のユーザーによるアプリのアクティベーションが開始され、以後の有効期限は 1 年間となります。 同じ Zoom アカウント上の全ユーザーが Coda にアクセスできる場合、いずれかの Zoom アカウント ユーザーによって最初の Coda アクティベーションが開始されると、以後この Zoom アカウントの全ユーザーに対する有効期限は 1 年間となります。このケースでは、同一の Zoom アカウント上にいる別のユーザーが続けてアクティベーションを開始しても、その開始日は考慮されません。すべてのアプリについて、ユーザーの有効ライセンス / サブスクリプションの再割り当てまたはキャンセルが行われると、1 年間のアクセス権のうち、まだ利用できる残り期間があっても、そのユーザーに対するアクセス権は無効になります。各アプリでは、アクティベーション時に独自の利用規定およびプライバシー ポリシーが適用されます。対象アプリに対応する言語は英語のみです。モバイルの場合、すべてのアプリが動作するとは限りません。現金による特典の払い戻しは適用されません。特典は、<a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom アプリ マーケットプレイスの推奨アプリリスト</a>に含まれるアプリにのみ適用されます。 すでに各アプリのサブスクリプションをご利用中のユーザーには、これらの特定のアプリに関するこの特典は適用されません。Zoom は、事前の通知なしで責任を負うことなく随時この特典を変更またはキャンセルする権利を留保します。",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "訪問者管理"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24 時間年中無休のライブチャットおよび電話サポート"
      },
      "learn_more": "詳細",
      "new": "新規",
      "plan_details": {
        "meeting": {
          "title": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0",
          "host_meeting_up_to_participants": "{0}人の参加者までホスト可能",
          "meeting_hours": "ミーティング当たり最大 30 時間の無制限ミーティング",
          "recording_storage": "{0}GB のクラウド ストレージ レコーディング（1 ライセンスにつき）",
          "auto_captions": "自動字幕"
        },
        "whiteboard": {
          "title": "ホワイトボード",
          "boards_storage": "{0} つの編集可能なボード",
          "standard_features": "スタンダード機能"
        },
        "team_chat": {
          "title": "チームチャット",
          "desc": "グループ チャットとファイル共有"
        },
        "main_calendar": {
          "title": "メール＆カレンダー",
          "desc": "メール、カレンダー クライアントとカレンダー サービスのベ"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Zoom 内で編集可能なドキュメントを作成および共有",
          "desc2": "豊富なテキスト編集を備えた個人用メモとコラボレーション メモ"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "短編ビデオを簡単にレコーディング、編集、共有",
          "desc2": "無制限のビデオと高度な機能"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "ミーティング サマリーや、メッセージの下書きサポート機能などにすばやくアクセス"
        },
        "EssentialApp": {
          "title": "推奨アプリ",
          "desc1": "1 年間無料のプレミアム アプリ（規約の適用対象）",
          "desc2": "チームのコラボレーションと生産性を向上"
        },
        "livechat": {
          "title": "ライブチャットのサポート"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Zoom Workplace プロに変更しますか？",
            "content": "お客様は以前に、ミーティングごとに最大 300 名の参加が可能な Zoom Workplace Business や Zoom Scheduler などを選択しています。本当にプロに変更しますか？",
            "confirm": "変更を確認",
            "keep_current": "現在のプランを維持"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} 件"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "閉じる",
          "cancel": "キャンセル",
          "edit": "編集",
          "got_it": "了承"
        },
        "title": {
          "everything_in_and": "{0} で全機能を利用可能（以下の内容を含む）"
        },
        "tag": {
          "new": "新規",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "年間",
          "monthly": "月間",
          "quarterly": "四半期ごと",
          "two_years": "2年ごと",
          "three_years": "3年ごと"
        },
        "errors": {
          "unknown_error_try_again": "取引を処理中に不明のエラーが発生しました。後でもう一度お試しください。"
        },
        "excluding_tax": {
          "vat_tip": "（VAT を除く）",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "限定機能",
        "pro_plus": {
          "host_meeting_up_to_participants": "{0}人の参加者までホスト可能",
          "gb_of_cloud_recording_storage": "{0} GB のクラウド レコーディング ストレージ（ライセンスごと）",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "コンテンツの生成と翻訳に対応する AI Companion",
            "features_item2": "チームとの共有ドキュメントの数は無制限",
            "features_item3": "バージョン履歴へのアクセスは無制限",
            "comparison_table_tips": "ミーティングの内容を実利的なドキュメント、Wiki、プロジェクトに変換する AI ファーストのドキュメント機能で、コラボレーションをパワーアップしましょう"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks ベーシック",
            "features_item1": "ミーティング、通話、チャット、ドキュメントからタスクを自動的に検出",
            "features_item2": "フォローアップ ミーティングのスケジュール作成やドキュメントの下書きなど、タスクの完了をサポート",
            "features_item3": "タスク完了時に簡単に「完了」としてマークし、進捗状況を常に把握して次のタスクに集中",
            "features_item4": "Zoom Docs を含む Zoom Workplace プラットフォーム全体のタスクを管理",
            "features_item1_opc": "AI Companion の機能を活用して、チャット、メール、ドキュメント、ホワイトボード、ミーティング要約からタスクを特定して作成",
            "features_item2_opc": "並べ替え、フィルタリング、グループ化、検索を容易に行い、タスクにすばやくアクセスしてコンテキストを収集",
            "learn_more_header": "AI Companion* を使ってアクション項目を常に把握することで、Zoom Workplace 全体でより多くの成果を達成します。",
            "learn_more_footer": "\* AI Companion は、Zoom Workplace プロ、ビジネス、エンタープライズ プランでのみご利用いただけます。",
            "features_prefix": "AI Companion は以下を行うことができます。",
            "comparison_table_tips": "Zoom Workplace での会話やミーティング要約に基づいて推奨タスクを提示する AI ファースト ソリューションで、アクション項目を常に把握し、予定どおりに完了させましょう。",
            "tasks_label_text": " AI ファーストのタスク管理"
          },
          "title": "ビジネスプラス",
          "contact_us_for_more_pricing": "価格情報などの詳細については、お問い合わせください",
          "contact_sales": "営業担当へのお問い合わせ",
          "meetings": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0",
          "phone": "\u96FB\u8A71",
          "phone_sub_title": "\u7121\u5236\u9650\u901A\u8A71",
          "use_only": "ビジネス利用のみ",
          "team_chat": {
            "title": "チームチャット",
            "title_desc": "グループ チャットとファイル共有"
          },
          "cloud_storage": {
            "title": "\u30AF\u30E9\u30A6\u30C9\u30B9\u30C8\u30EC\u30FC\u30B8"
          },
          "mail_calender": {
            "title": "メール＆カレンダー"
          },
          "beta": "Beta",
          "client_service": {
            "title": "クライアント＆サービス"
          },
          "up_to_30_hours_per_meeting": "ミーティング当たり最大 30 時間",
          "300_attendees": "出席者 300 名",
          "per_meeting": "ミーティングあたり",
          "whiteboard": {
            "title": "ホワイトボード"
          },
          "new": "新規",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "追加",
          "sso_managed_domains_more": "SSO、管理対象ドメインなど",
          "scheduler": "スケジューラー",
          "global_select": "Global Select",
          "unlimited_regional": "地域内無制限",
          "translated_captions": "翻訳版字幕",
          "workspace_reservation": "ワークスペース予約",
          "auto_translated_captions": "自動字幕および翻訳された字幕",
          "unlimited_editable_boards": "編集可能なボード（ボード数に上限なし）",
          "standard_features": "スタンダード機能",
          "advanced_docu_controls": "高度なドキュメント コントロール",
          "chats_channels_for_collaboration": "コラボレーション、ファイル共有など、さまざまな事に利用できるチャットとチャンネル",
          "zoom_phone_is_biz_use_only": "Zoom Phone はビジネス専用のサービスです",
          "unlimited_regional_calling": "地域内通話無制限、日本の電話番号(050番号)",
          "domestic_sms_mms": "\u56FD\u5185 SMS & MMS",
          "automatic_call_distribution_groups": "自動応答(IVR)機能",
          "single_sign_on": "\u30B7\u30F3\u30B0\u30EB\u30B5\u30A4\u30F3\u30AA\u30F3\uFF08SSO\uFF09",
          "managed_domains": "\u7BA1\u7406\u5BFE\u8C61\u30C9\u30E1\u30A4\u30F3",
          "company_branding": "\u4F1A\u793E\u306E\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0",
          "mail_calender_client_services_beta": "メール、カレンダー クライアントとカレンダー サービスのベータ版",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "ミーティング当たり最大 30 時間の無制限ミーティング",
          "mail_and_calendar_client_and_services_beta": "メール、カレンダー クライアントとカレンダー サービスのベータ版",
          "easily_record_edit_share_videos": "短編ビデオを簡単にレコーディング、編集、共有",
          "unlimited_videos_advanced_features": "無制限のビデオと高度な機能",
          "create_share_editabel_docu_within_zoom": "Zoom 内で編集可能なドキュメントを作成および共有",
          "personal_collaborative_notes_rich_text_editing": "豊富なテキスト編集を備えた個人用メモとコラボレーション メモ",
          "effortlessly_share_meeting": "ミーティング枠を難なく共有して予約しやすい環境を実現",
          "works_with_zoom_meeting_mail_calender_google_ms": "Zoom Meetings、Zoom Mail、Zoom Calendar、Google、Microsoft 365 と連携可能",
          "up_to_300_attendees": "最大出席者 300 名",
          "10_gb_of_storage": "10GB のストレージ",
          "host_meeting_up_to_300_participants": "最大で出席者 300 名のミーティングをホスト",
          "10_gb_of_cloud_recording_storage": "10GB のクラウド ストレージ レコーディング（1 ライセンスにつき）",
          "starting_at_licenses_year": "{0}/\u5E74\u3067{1}\u30E9\u30A4\u30BB\u30F3\u30B9\u304B\u3089\u958B\u59CB",
          "starting_at_licenses_month": "{0}/\u6708\u3067{1}\u30E9\u30A4\u30BB\u30F3\u30B9\u304B\u3089\u958B\u59CB",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "ミーティング サマリーや、メッセージの下書きサポート機能などにすばやくアクセス",
          "learn_more": "詳細",
          "essential_apps": "推奨アプリ",
          "increase_team_collaboration": "チームのコラボレーションと生産性を向上",
          "free_premium_apps": "1 年間無料のプレミアム アプリ（規約の適用対象）",
          "visitor_management": "訪問者管理",
          "visitor_management_custom_invites": "招待状をカスタマイズ",
          "visitor_management_visitor_check": "キオスクでチェックイン",
          "visitor_management_receive_detailed": "来客のスペース使用状況に関する詳細な指標を取得"
        },
        "custom_avatar": {
          "title": "カスタム アバター",
          "label_text": "月当たり 3 分",
          "basic_feature": "ライフタイム当たり 1 分",
          "pricing_feature": "月当たり 3 分",
          "learn_more_subtitle": "音声の複製と多言語コミュニケーションで、あなたにそっくりな AI を作りましょう。",
          "features_item1": "プレゼンテーションやデモ用に、あなたの外見と声を再現した本物そっくりのデジタル アバターを毎月 3 つまで作成",
          "features_item2": "アバターを使用して、AI Companion で最大 3 分間のスクリプトを配信",
          "features_item3": "あらかじめデザインされた 18 種類のアバターから選択し、素早く高品質なビデオを作成",
          "features_item4": "バーチャル背景に対応",
          "features_item1_opc": "プレゼンテーションやデモ用に、あなたの外見と声を再現した本物そっくりのデジタル アバターを毎月 3 つまで作成",
          "features_item2_opc": "アバターを使用して、AI Companion で最大 3 分間のスクリプトを配信",
          "comparison_table_tips": "カスタム アバターでは、音声の複製と多言語コミュニケーションにより、あなたにそっくりな AI を作成できます。"
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "ミーティング サマリーや、メッセージの下書きサポート機能などにすばやくアクセス",
        "learn_more_dialog": {
          "desc": "AI Companion で業務効率化をサポートコンテンツの作成、ミーティングのスケジュール設定、プロジェクトの管理などを行うことができます。",
          "tip1": "事前に議題を受け取り、より効果的なミーティングを主催できます",
          "tip2": "タスク作成と通知の自動化でプロジェクトを予定通りに進行できます",
          "tip3": "カレンダーの整理と時間の管理をサポートします",
          "tip4": "Zoom Docs、Zoom Whiteboard、Zoom Workplaceアプリでのあなたのスタイルに合わせた文章およびビジュアルコンテンツを生成します"
        },
        "top_features": "トップ機能",
        "more_to_come": "今後多くの優れた機能をリリース予定です！",
        "discover_more": "AI Companion で仕事を効率化するための方法をもっと発見してください",
        "detail_desc": "AI Companion は、Zoom ユーザー アカウントの有料サービスからご利用いただけます（追加料金なし）。一部の業種および地域は対象外となる場合があります。"
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/年/ライセンス",
        "month_licnese": "/月/ライセンス",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/ 月",
          "per_year": "/ 年"
        },
        "unit": {
          "license": "{0}/ライセンス",
          "user": "{0}/ユーザー"
        },
        "learn_more": "詳細",
        "required": "必須",
        "zoom_one_required": "Zoom Workplace が必要です",
        "large": {
          "features_tip": "参加者定員を最大 1,000 名に増やしてリーチを拡大できます。",
          "label_title1": "参加者500名",
          "label_title2": "参加者1000名"
        },
        "cmr": {
          "features_tip": "Zoom クラウドから直接ビデオ レコーディングを保存、ストリーム、ダウンロードします。",
          "explain_desc": "クラウド ストレージは、一部の Zoom One プラン（プロ（5 GB）、ビジネス（5 GB）、ビジネスプラス（10 GB）、エンタープライズ（無制限））でご利用いただけます。",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "約 100 時間",
          "option_label2": "約 650 時間",
          "option_label3": "約 3,500 時間",
          "option_label4": "約 17,500 時間",
          "intro_label2": "最大 5 TB / 月が利用可能なストレージ オプション",
          "tooltip_content": "レコーディング ストレージは、ビデオ対応参加者の人数、ミーティングの解像度、共有コンテンツの解像度によって容量が増減します。"
        },
        "whiteboard": {
          "plus_title": "ホワイトボード プラス",
          "title": "Whiteoard",
          "features_tip": "ミーティング内外で、ホワイトボードから別のユーザーとリアルタイムでコラボレーションできます。",
          "explain_desc": "Zoom One ビジネス、Zoom One ビジネスプラス、Zoom One エンタープライズで利用可能",
          "explain_desc_plus": "Zoom One エンタープライズ プラスで利用可能、各 Zoom Rooms サブスクリプションに付属",
          "option_label1": "1 GB のクラウド ストレージを備えた無制限ボード",
          "option_label2": "無制限のボード数とクラウド ストレージを備えた高度な機能",
          "intro_label1": "同時編集ができるホワイトボード（ボード数に上限なし）",
          "intro_label2": "スタンダード機能と高度なドキュメント コントロール",
          "intro_label3": "高度なホワイトボード機能（カスタム テンプレートや組織テンプレート、サードパーティとの連携など）"
        },
        "translated_captions": {
          "features_tip": "任意の言語での自動字幕により、グローバル コラボレーションを強化できます。",
          "intro_label1": "参加者が自分で字幕を有効にし、言語を切り替えることができます。",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "サポート対象言語を表示"
        },
        "crc": {
          "features_tip": "標準ベースの SIP/H.323 ビデオ カンファレンス エンドポイントを有効にして、効果的なハイブリッド ワークを実現できます。",
          "intro_label1": "Polycom、Cisco、Lifesizeなど数多くのレガシーエンドポイントで機能",
          "intro_label2": "クラウドベースまたはオンプレミス（VM）ルームコネクター"
        },
        "scheduler": {
          "simplify_bookings": "柔軟な空室状況とカスタマイズ可能な時間枠で予約を簡素化",
          "host_one_on_one": "1対1またはグループミーティングを1つのリンクで開催し、簡単に共有できます",
          "customize_reminders": "メール / SMS経由のリマインダーをカスタマイズして、予約の見逃しを減らします",
          "sync_calendars": "Google、Microsoft 365、Zoom 連携でカレンダーをシームレスに同期します",
          "features_tip": "オフィスアワーや面接などのミーティング枠を難なく共有できます。",
          "intro_label1": "カレンダー連携",
          "intro_label2": "継続的に使用可能なもの",
          "intro_label3": "拡張可能なミーティング",
          "intro_label4": "カスタマイズ可能な通知",
          "intro_sub_label1": "Google、Microsoft 365、Zoom ",
          "intro_sub_label2": "予約可能な時間枠の共有 ",
          "intro_sub_label3": "1 名 / 複数の参加者向けの単一ミーティング",
          "intro_sub_label4": "メールまたは SMS リマインダーと確認連絡の自動送信"
        },
        "zoom_clips_plus": {
          "features_tip": "短時間の高品質なビデオ メッセージをレコーディング、編集、共有します。",
          "intro_label1": "本数と時間が無制限のビデオ作成",
          "intro_label2": "画面とビデオを同時 / 別々にキャプチャ",
          "intro_label3": "ビデオを適宜トリミングしてリンクを共有",
          "intro_label4": "オーディオ文字起こし、統計などの高度な機能にアクセス",
          "explain_desc": "Clips プラスは、Workplace プロ、ビジネスおよびエンタープライズ サブスクリプションに含まれています。各プランの機能については、[料金] ページの比較セクションをご覧ください。"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "堅牢な登録機能とネットワーク機能を備えた、高度なイベント プラットフォーム。バーチャル体験にもハイブリッド体験にも最適。",
          "tooltip_content": "選択した定員の範囲内において、回数無制限でウェビナーまたはイベントを主催",
          "intro_title": "Sessions の全機能",
          "intro_label1": "マルチセッション イベントで視聴者エンゲージメントを強化",
          "intro_label2": "カスタマイズしたチケット発行とモバイルアプリでスムーズにイベントを主催",
          "intro_label3": "EXPO 会場とスポンサー エリアでイベント収益を向上",
          "intro_label4": "カスタマイズ可能なプロフィールで出席者のネットワーキングを促進",
          "intro_label5": "イベントロビーのオンデマンド ビューイングでリーチを拡大",
          "intro_label6": "キュレーションされたイベント テンプレートでイベントのセットアップを推進",
          "events_feature_item1_20240827": "複数のトラックを含む複数日にわたるバーチャル イベントを企画する",
          "events_feature_item2_20240827": "出席者のプロフィールとロビーチャットでネットワーキングを促進",
          "events_feature_item3_20240827": "ロビー セッションでのストリーミングで出席者にガイドを提供",
          "events_feature_item4_20240827": "EXPO 会場とスポンサーを活用してイベント収益を増加",
          "events_feature_item5_20240827": "カンファレンス後のアンケートで今後のイベントを改善",
          "events_feature_item6_20240827": "キュレーションされたイベント テンプレートでイベントのセットアップを推進",
          "attendees_start_at": "出席者数 {0} 名の基本料金",
          "explain_desc": "Zoom Events の詳細を確認",
          "contact_account_owner": "Events の購入をご希望の場合は、<a href=\"/account\" target=\"_blank\">アカウント オーナーまでお問い合わせください</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "イベントのブランディング、複数名のホストによるコラボレーション、イベント管理などの機能を通し、インタラクティブなシングル セッション イベントを合理化しましょう。",
          "tooltip_content": "選択した定員の範囲内において、回数無制限でウェビナーまたはイベントを主催",
          "intro_title": "Zoom Webinars を利用可能",
          "intro_label1": "イベント ランディング ページをカスタマイズして効果的なブランディングを実現",
          "intro_label2": "ブランディング メールでイベントを促進",
          "intro_label3": "インタラクティブなダッシュボードでパフォーマンスを測定",
          "intro_label4": "共同ホストおよび共同編集者とのシームレスなコラボレーション",
          "intro_label5": "専門のイベントツール: 疑似ライブ",
          "sessions_feature_item1_20240827": "カスタムシーンとブランディング機能でウェビナーをレベルアップ",
          "sessions_feature_item2_20240827": "AI Companion でメッセージと画像を生成し、イベント計画を簡素化",
          "sessions_feature_item3_20240827": "ブランド コンテンツが盛り込まれたハブで、過去のイベントと今後のイベントをプロモート",
          "sessions_feature_item4_20240827": "バックステージ、疑似ライブ、RTMP でプロフェッショナルなイベントを運営",
          "sessions_feature_item5_20240827": "イベント全体にわたるインサイトを活用して今後のウェビナーを改善",
          "explain_desc": "Zoom Sessions の詳細を確認",
          "contact_account_owner": "Sessions の購入をご希望の場合は、<a href=\"/account\" target=\"_blank\">アカウント オーナーまでお問い合わせください</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "ビデオ ウェビナー",
          "features_tip": "使いやすいウェビナー プラットフォームで簡単にメッセージを配信できます。",
          "tooltip_content": "選択した定員の範囲内において、回数無制限でウェビナーまたはイベントを主催",
          "intro_label1": "高品質のビデオ ウェブキャスティングで、視聴者を魅了",
          "intro_label2": "Q＆A、投票、リアクションでエンゲージメントを促進",
          "intro_label3": "イベント後レポートでウェビナー戦略を改善",
          "intro_label4": "最大 100,000 名の出席者と最大 100 名のパネリストをサポート",
          "monthly_subscription": "月額サブスクリプション",
          "annual_subscription": "年額サブスクリプション",
          "one_million": "100 万名",
          "single_use": "シングルユース",
          "one_month": "1 か月",
          "event_attendee": "Events / Sessions 出席者:",
          "event_attendee_desc": "ハブのライセンス ユーザーであるホスト以外の参加者です。特別ロールも出席者としてカウントされ、オーディオ、ビデオ、画面共有（有効な場合）を利用して参加できます。",
          "webinar_attendee": "Webinars 出席者:",
          "webinar_attendee_desc": "ホスト / パネリスト以外の参加者です。視聴専用モードで参加し、ミュート解除や、Q&A、チャットでの対話の有効化などはホストがコントロールします。",
          "pay_per_attendee": "出席者数課金型",
          "attendees": "出席者"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "AI 搭載型コラボレーション プラットフォームを使用して、チームワークの概念を塗り替えましょう。",
          "label_title1": "Workplace プロ",
          "label_title2": "Workplace プロプラス",
          "label_title3": "Workplace ビジネス",
          "label_title4": "Workplace ビジネスプラス",
          "intro_label1": "最大参加者数 100 名のミーティングを最長 30 時間まで無制限に主催可能",
          "intro_label2": "標準機能を備え、かつ同時編集可能なホワイトボードに最大 3 つまでアクセス可能",
          "intro_label3": "Clips プラスで短時間の高品質なビデオ メッセージをレコーディング、編集、共有可能",
          "intro_label4": "Zoom AI Companion で、より効率的に多くの成果を達成",
          "intro_label5": "Zoom Phone 米国およびカナダ無制限（BYOC、PBX、サードパーティの PBX は除く）",
          "intro_label6": "最大参加者数 300 名のミーティングを最長 30 時間まで無制限に主催可能",
          "intro_label7": "Zoom Scheduler で、オフィスアワーや面接などのミーティング時間枠を共有可能",
          "intro_label8": "米国およびカナダ無制限の Zoom Phone",
          "intro_label8_UK": "Zoom Phone 無制限通話（英国およびアイルランド）",
          "intro_label8_AU": "Zoom Phone 無制限通話（オーストラリアおよびニュージーランド）",
          "intro_label8_JP": "Zoom Phone 無制限通話（日本）",
          "intro_label9": "来客管理",
          "intro_label10": "追加の機能",
          "intro_label11": "ライブチャットのサポート",
          "intro_title1": "プロの全機能に加え、以下の機能を利用可能:",
          "intro_title2": "ビジネスの全機能に加え、以下の機能を利用可能:",
          "intro_label_tip1": "Zoom Phone プロプラスでは、BYOC、サードパーティの PBX、VDI 機能をご利用いただけません。詳しくは、Zoom Phone の料金ページをご覧ください。",
          "intro_label_tip2": "チェックアウト中、米国およびカナダ、オーストラリアおよびニュージーランド、英国およびアイルランド、または日本の国内通話無制限を選択可能です。",
          "intro_label_tip3": "追加機能として、10 GB のクラウド ストレージ、翻訳版字幕、ワークスペース予約をご利用いただけます。",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone パワーパック",
          "features_tip": "コールセンター チームが、強化されたコールキュー分析と今までに取得したインサイトを利用できるようになります。",
          "intro_label1": "コール ハンドリングを合理化する拡張された連絡先ウィンドウ",
          "intro_label2": "自動受付とコールキュー電話番号"
        },
        "international_calling": {
          "title": "国際電話",
          "features_tip": "15 以上の国・地域への無制限国際通話を利用できます。",
          "intro_label1": "任意の無制限通話プランで購入可能",
          "intro_label2": "無制限国際通話がサポートされている国・地域のリストをご覧ください。",
          "intro_labe2_tooltip": "米国、カナダ、イギリス、アイルランド、オーストラリア、ニュージーランド、オーストリア、デンマーク、フランス、ドイツ、イタリア、ポルトガル、スペイン、スウェーデン、ベルギー、オランダ、スイス、プエルトリコ、日本。",
          "intro_label2_view_list": "リストを表示"
        },
        "workspace_reservation": {
          "title": "ワークスペース予約",
          "intro_title": "Zoom と連携したデバイスで、柔軟なワークスペースやホテルの部屋の事前予約・現地予約が簡単にできます。",
          "intro_label1": "Zoom Workplace アプリ、デスクトップ、ブラウザからワークスペースやホテルの予約が可能",
          "intro_label2": "AI サポートによりパーソナライズされた推奨デスクの受け取り",
          "intro_label3": "Google カレンダーや Outlook から直接ワークスペースを予約でき、リマインダーやチェックイン アラートも利用可能",
          "intro_label4": "案内表示を使用して、予約済みワークスペースへ移動"
        },
        "visitor_management": {
          "title": "来客管理",
          "intro_title": "カスタマイズされた招待状、手間のかからないキオスクチェックイン、レポート、およびメトリクスにより、訪問者のチェックインを合理化します。",
          "intro_label1": "Zoomポータルで招待、訪問者の位置情報、および訪問履歴を管理",
          "intro_label2": "外部参加者の到着通知の受信中に招待の新規作成、追跡、再送信、削除",
          "intro_label3": "フォームに記入し、道順を取得し、キオスクでチェックインという流れで、スムーズな訪問者体験を実現",
          "intro_label4": "使い慣れたZoomポータル内のすべての機能にアクセスでき、管理が容易に"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "大規模ミーティング",
          "description1": "ミーティング定員を増やして、インタラクティブなライブ参加者を最大 1,000 名サポート",
          "description2": "参加者は全員、オーディオ、ビデオ、画面を共有可能"
        },
        "cloud_storage": {
          "title": "クラウド ストレージ",
          "description2": "MP4 または M4A ファイル形式を利用可能"
        },
        "translated_captions": {
          "title": "翻訳された字幕",
          "description1": "参加者が有効にしてサポート対象言語に切り替えられる多言語自動字幕でミーティングを強化",
          "description2": "Zoom Meetings と Zoom Webinars で利用可能"
        },
        "tollfree": {
          "title": "オーディオ カンファレンス",
          "subcontent": "世界中から電話番号でミーティングにダイヤルイン",
          "description1": "コールアウト、グローバル トールフリー、プレミアム通話対象国でのローカル ダイヤルインで通話オプションを拡張します",
          "description2": "デバイスからのコールインによる参加は無料",
          "description3": "1 つまたは複数のトールフリー コールイン対象国を簡単に選択しま"
        },
        "rc": {
          "title": "カンファレンス ルーム コネクタ"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "アルゼンチン",
        "Australia": "オーストラリア",
        "Austria": "オーストリア",
        "Belgium": "ベルギー",
        "Brazil": "ブラジル",
        "Bulgaria": "ブルガリア",
        "Canada": "カナダ",
        "Chile": "チリ",
        "China": "中国",
        "Colombia": "コロンビア",
        "Costa_Rica": "コスタリカ",
        "Croatia": "クロアチア",
        "Cyprus": "キプロス",
        "Czech_Republic": "チェコ共和国",
        "Denmark": "デンマーク",
        "Ecuador": "エクアドル",
        "Estonia": "エストニア",
        "Finland": "フィンランド",
        "France": "フランス",
        "Germany": "ドイツ",
        "Greece": "ギリシャ",
        "Hong_Kong_SAR": "香港特別行政区",
        "Hungary": "ハンガリー",
        "Ireland": "アイルランド",
        "Israel": "イスラエル",
        "Italy": "イタリア",
        "Japan": "日本",
        "Latvia": "ラトビア",
        "Lithuania": "リトアニア",
        "Luxembourg": "ルクセンブルク",
        "Mexico": "メキシコ",
        "Netherlands": "オランダ",
        "New_Zealand": "ニュージーランド",
        "Norway": "ノルウェー",
        "Panama": "パナマ",
        "Peru": "ペルー",
        "Poland": "ポーランド",
        "Portugal": "ポルトガル",
        "Puerto_Rico": "プエルトリコ",
        "Romania": "ルーマニア",
        "Singapore": "シンガポール",
        "Slovakia": "スロバキア",
        "Slovenia": "スロベニア",
        "South_Africa": "南アフリカ",
        "Spain": "スペイン",
        "Sweden": "スウェーデン",
        "Switzerland": "スイス",
        "UK": "英国",
        "United_Kingdom": "英国",
        "US": "US",
        "United_States": "米国",
        "title": "電話番号の要件",
        "subtitle": "グローバル セレクトの電話番号を有効にする国を選択してください。",
        "selector_tip": "国を選択",
        "local_and_toll_free": "{0} ではローカル番号とトールフリー番号を利用できます",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "グローバル セレクトでは、ライセンス 1 件につき指定国内で 1 つの電話番号と無制限通話をご利用いただけます。",
        "avail_title": "対象の国 / 地域"
      },
      "tax_exempt_ecm": {
        "title": "免税ステータス",
        "status_exempt": "免税",
        "status_exempt_question": "免税が適用されていますか？",
        "verify_now": "今すぐ確認する",
        "can_after_checkout": "オプションとして、このステップはチェックアウト後に完了できます。",
        "status": {
          "exempt": "適用除外",
          "pending": "保留中",
          "pendingTooltip": "現在、お客様の税控除ステータスを審査中です。承認完了までの間、ご注文時に税金が追加される場合があります。税控除が承認された場合、返金可能なすべての税金 / 手数料がお客様の口座に入金されます。",
          "nonexempt": "非免除",
          "rejected": "却下",
          "rejectedTooltip": "提出された書類は、お客様の管轄区域の要件を満たしていないと判断されました。",
          "approved": "承認済み",
          "default": "デフォルト"
        },
        "confirm_close": {
          "new_desc": "審査をキャンセルすると、該当する税金 / 手数料が請求される場合があります。キャンセルした場合も、購入後に [請求管理] セクションで免税書類を提出して、Zoom のレビューと承認を受けることができます。検証が完了すると、請求された税金の払い戻しが行われます。",
          "desc": "免税の認証を中止して課税対象として処理を進めますか？",
          "title": "本当によろしいですか？",
          "new_title": "免税の審査をキャンセルしますか？",
          "yes": "はい、放棄します",
          "no": "いいえ、続行します",
          "abandon": "審査をキャンセル",
          "go_back": "戻る"
        },
        "confirm_to_add": {
          "title": "新しいデフォルトの免税を確認する",
          "message": "新しい免税を追加すると、承認 / 拒否の審査の際にデフォルトとして自動設定されます。設定可能なデフォルトの免税は 1 件のみであり、今後の購入に適用されます。デフォルトの免税が [購入者連絡先] の州 / 地域と一致しない場合、税額に影響を与える可能性があります。",
          "yes": "新しい免税を追加"
        },
        "confirm_set_default": {
          "title": "購入者連絡先の住所と、選択した免税対象地域の不一致",
          "message": "[購入者連絡先] の住所が、免税対象として選択した州 / 地域と一致しません。[購入者連絡先] の住所を、免税対象として選択した地域と一致するよう更新してください。そうしない場合、購入に対して免税が適用されない場合があります。",
          "yes": "デフォルトとして設定する",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "州 / 地域",
          "exemption_type": "税控除の種類",
          "signed_date": "署名日",
          "status": "ステータス",
          "add_exemption": "免税を追加",
          "view": "表示",
          "set_as_default": "デフォルトとして設定"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "ご利用中の {planName} プランは、{date} の午前 12 時 00 分（UTC、協定世界時）にキャンセルされます。キャンセル日を過ぎてからの主催をご希望の場合は、プランを再アクティベートしてください。",
        "pairPreDescTip": "ご利用中の {planName1} プランおよび {planName2} プランは、{date} の午前 12 時 00 分（UTC、協定世界時）にキャンセルされます。キャンセル日を過ぎてからの主催をご希望の場合は、プランを再アクティベートしてください。",
        "pairDiffDatePreDescTip": "ご利用中の {planName1} プランおよび {planName2} プランは、それぞれ {date1} の午前 12 時 00 分（UTC、協定世界時）と {date2} の午前 12 時 00 分（UTC、協定世界時）にキャンセルされます。キャンセル日を過ぎてからの主催をご希望の場合は、プランを再アクティベートしてください。",
        "title": "プランを再アクティベートして続行",
        "titles": "プランを再アクティベートして続行",
        "plan": "プラン",
        "licenses": "ライセンス",
        "billingCycle": "請求サイクル",
        "effective_date": "開始日",
        "invoice_amount": "請求額",
        "singleDescTip": "再アクティベートすることで、お客様は、ご利用中の定期プランが {date} に自動的に更新され、更新期間ごとに登録済みのお支払い方法で請求されることに同意するものとします。今後の請求を停止するには、更新日の 1 日前までにプランを<a target=\"_blank\" href=\"https://support.zoom.com/hc/ja/article?id=zm_kb&sysparm_article=KB0066687\">キャンセル</a>してください。",
        "pairDescTip": "再アクティベートすることで、お客様は、ご利用中の定期プランが {date} に自動的に更新されることに同意するものとします。更新期間ごとに登録済みのお支払い方法で請求されます。今後の請求を停止するには、更新日の 1 日前までにプランを<a target=\"_blank\" href=\"https://support.zoom.com/hc/ja/article?id=zm_kb&sysparm_article=KB0066687\">キャンセル</a>してください。",
        "pairDiffDateDescTip": "再アクティベートすることで、お客様は、ご利用中の定期プランが {date1} と {date2} に自動的に更新されることに同意するものとします。更新期間ごとに登録済みのお支払い方法で請求されます。今後の請求を停止するには、更新日の 1 日前までにプランを<a target=\"_blank\" href=\"https://support.zoom.com/hc/ja/article?id=zm_kb&sysparm_article=KB0066687\">キャンセル</a>してください。",
        "totalLabel": "合計",
        "totalContent": "{money}（税抜き）",
        "taxDesc": "VAT、GST、または類似の税金を除く",
        "reactivateBtn": "続行して再アクティベート",
        "switchTitle": "プランを更新して続行",
        "successSingleTip": "{planName} プランが再アクティベートされました",
        "successPairTip": "{planName1} および {planName2} プランが再アクティベートされました",
        "switchTip": "ご利用中の Zoom Webinars 1 か月プランは、{date} に有効期限が切れます。この期日を過ぎてウェビナーを主催するには、サブスクリプションに切り替える必要があります。",
        "switchBtn": "サブスクリプションに切り替える"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace プロ"
      },
      "biz": {
        "title": "Zoom Workplace ビジネス"
      },
      "proPlus": {
        "title": "Zoom Workplace プロプラス"
      },
      "bizPlus": {
        "title": "Zoom Workplace ビジネスプラス"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "\u30C7\u30FC\u30BF\u30B7\u30FC\u30C8\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
      },
      "one": {
        "new": "新規"
      }
    },
    "webinarSetupInWebPortal": "ウェブポータルでのウェビナー設定",
    "concurrentEvents": "同時開催イベント",
    "coucurrentEventsToolTip": "<span>1 件の<b>サブスクリプション</b> プランで、1 度に 1 つのライブイベントに対応します。",
    "overages": "超過料金",
    "eventsPlatformHubs": "イベント プラットフォーム ハブ",
    "eventsHubToolTip": "Zoom Events <b>ハブ</b>には便利なイベント編成機能が用意されています。",
    "1HubPerLicense": "1 件のハブ（ライセンスごと）",
    "1000Hubs": "1,000 件のハブ",
    "eventsPlatformHosts_500AttendeesOrMore": "イベント プラットフォーム ホスト（出席者 500 名以上）",
    "eventsHost500": "<span>Zoom Events <b>ハブホスト</b>は以下を作成できます。",
    "5HubHosts": "5 名のハブホスト",
    "100HubHosts": "100 名のハブホスト",
    "eventsPlatformHosts_100Attendees": "イベント プラットフォーム ホスト（出席者 100 名）",
    "eventsHost100": "<span>Zoom Events <b>ハブホスト</b>は以下を作成できます。",
    "2HubHosts": "2 名のハブホスト",
    "howAreTheyDifferent": "違いは何ですか？",
    "allPlansRequireAZoomOneLicense": "* すべてのプランに Zoom Workplace ライセンスが必要です",
    "subscription": "サブスクリプション",
    "subscriptionToolTip": "<span>1 件の<b>サブスクリプション</b>で、選択した定員の範囲内において、回数無制限でイベントを主催できます。</span>",
    "payPerAttendee": "出席者数課金型",
    "ppaToolTips": "<span><b>出席者数課金制</b>のライセンス次第で、購入から 12 か月以内に主催する全イベントに出席可能な総出席者数が決まります。",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "\u6295\u7968",
    "meetings.fullPlanItem2": "\u30E9\u30A4\u30BB\u30F3\u30B9\u6570",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "あらゆるデバイスでの簡単なビデオ会議とメッセージング",
    "meetings.fullPlanItem5": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u671F\u9593",
    "meetings.fullPlanItem5Tip": "\u30B0\u30EB\u30FC\u30D7\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\uFF083\u540D\u4EE5\u4E0A\u306E\u53C2\u52A0\u8005\uFF09\u3054\u3068\u306B\u8A31\u53EF\u3055\u308C\u3066\u3044\u308B\u6700\u5927\u6642\u9593\u6570\u3002",
    "meetings.fullPlanItem5_basic": "40\u5206",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30\u6642\u9593",
    "meetings.fullPlanItem5_biz": "30\u6642\u9593",
    "meetings.fullPlanItem5_ent": "30\u6642\u9593",
    "meetings.fullPlanItem1": "\u53C2\u52A0\u8005\u306E\u5B9A\u54E1",
    "meetings.fullPlanItem1Tip": "\u53C2\u52A0\u8005\u3068\u306F\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30E9\u30A4\u30BB\u30F3\u30B9\u3067\u4E88\u5B9A\u3055\u308C\u305F\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3078\u306E\u62DB\u5F85\u3092\u53D7\u3051\u305F\u4EBA\u3067\u3059\u3002\u5404\u81EA\u306E\u96FB\u8A71\u3001\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u6A5F\u5668\u3001\u643A\u5E2F\u6A5F\u5668\u3001\u30BF\u30D6\u30EC\u30C3\u30C8\u306A\u3069\u304B\u3089\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u7121\u6599\u3067\u53C2\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u53C2\u52A0\u8005\u306F\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u53C2\u52A0\u3059\u308B\u969B\u306BZoom\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5FC5\u8981\u3068\u3057\u307E\u305B\u3093\u3002\u5404\u30D7\u30E9\u30F3\u306B\u306F\u3001\u53C2\u52A0\u8005\u306E\u5236\u9650\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u30A2\u30C9\u30AA\u30F3\u3092\u8CFC\u5165\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u6709\u6599\u30D7\u30E9\u30F3\u3067\u3053\u306E\u4E0A\u9650\u3092\u9AD8\u304F\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*エンタープライズ プラスは 1000 名</span>",
    "meetings.fullPlanItem7": "レコーディング",
    "meetings.fullPlanItem7Tip": "Zoom ローカル レコーディングはミーティング レコーディングをMP4（ビデオ）、M4A（オーディオ）、txt（チャット）の形式で保存します。<br>Zoom クラウド レコーディングはミーティングを Zoom クラウドに保存し、ファイルをブラウザからダウンロードしたり、ストリーミングしたりできます。",
    "meetings.fullPlanItem7_basic": "\u30ED\u30FC\u30AB\u30EB",
    "meetings.fullPlanItem7_pro": "\u30ED\u30FC\u30AB\u30EB\u30685 GB\u30AF\u30E9\u30A6\u30C9\uFF08\u30E9\u30A4\u30BB\u30F3\u30B9\u3054\u3068\uFF09",
    "meetings.fullPlanItem7_biz": "\u30ED\u30FC\u30AB\u30EB\u306810 GB\u30AF\u30E9\u30A6\u30C9\uFF08\u30E9\u30A4\u30BB\u30F3\u30B9\u3054\u3068\uFF09",
    "meetings.fullPlanItem7_ent": "\u30ED\u30FC\u30AB\u30EB\u3068\u30AF\u30E9\u30A6\u30C9\u7121\u5236\u9650",
    "one.messaging": "メッセージ",
    "meetings.fullPlanItem16Tip": "チャットでは、グループ テキスト、ファイル、スクリーン キャプチャ、コード スニペット、ボイス メッセージ、画像を簡単に送信できます。テキストはフォーマット可能で、GIF や絵文字も共有できます。チャット参加者がデスクトップ PC やモバイル機器上でアクティブな状態なのか、またはミーティング中で忙しい状態なのかがプレゼンスに表示されます。",
    "meetings.fullPlanItem51": "Zoom Whiteboard",
    "meetings.unlimited": "\u7121\u5236\u9650",
    "meetings.fullPlanItem_EssentialApp": "推奨アプリ",
    "common.learnMore": "詳細",
    "meetings.fullPlanItem_EssentialAppText": "1 年間無料のプレミアム アプリ（規約の適用対象）",
    "zoomMailAndCalendarInTheZoomApp": "Zoom アプリの Zoom メールとカレンダー",
    "mailService": "メールサービス",
    "emailServiceWithFullTimeEndToEnd": "プライバシー保護を強化した常時エンドツーエンド暗号化のメールサービスです",
    "customMailDomain": "カスタム メールドメイン",
    "customMailDomainWithMailService": "メールサービス付きのカスタム メールドメインです",
    "calendarClient": "カレンダー クライアント",
    "scheduleAndJoinMeetings": "Zoom アプリでスケジューリングを行いミーティングに参加できます",
    "aiCompanion": "AI Companion",
    "calendarService": "カレンダー サービス",
    "meetingSchedulingAndAppointment": "ミーティングのスケジュールと予約の設定ができます",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "短編ビデオを容易に作成、編集、共有します。 保存済みクリップを簡単に見つけ、エンゲージメントを向上します。",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "メモには多彩な書式設定オプションを備えた堅牢な個人用ドキュメントおよびコラボレーション ドキュメントのエディタがあり、ミーティング内外からアクセスできます。",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "翻訳版字幕",
    "workspaceReservation": "ワークスペース予約",
    "accessAcrossAnyDevice": "あらゆるデバイスでアクセス可能",
    "meetings.fullPlanItem4": "\u7121\u5236\u9650\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0",
    "meetings.fullPlanItem9": "\u96FB\u8A71\u30C0\u30A4\u30E4\u30EB\u30A4\u30F3",
    "meetings.fullPlanItem9Tip": "テレカンファレンス / オーディオ カンファレンスで Zoom ミーティングに参加します（従来の電話を使用します）。電話プランに従ってユーザーは請求されます。トールフリー ダイヤルイン番号用のオーディオ カンファレンス アドオンをお試しください。",
    "meetings.fullPlanItem9_pro": "\u901A\u8A71\u6599\u30D9\u30FC\u30B9",
    "meetings.fullPlanItem9_biz": "\u901A\u8A71\u6599\u30D9\u30FC\u30B9",
    "meetings.fullPlanItem9_ent": "\u901A\u8A71\u6599\u30D9\u30FC\u30B9",
    "meetings.fullPlanItem11": "\u753B\u9762\u5171\u6709",
    "meetings.fullPlanItem11Tip": "\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u3068\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u5171\u6709\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u3042\u308B\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u30DB\u30B9\u30C8\u3057\u3066\u3044\u308B\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u4E2D\u306B\u3001\u8907\u6570\u306E\u53C2\u52A0\u8005\u306B\u753B\u9762\u3092\u540C\u6642\u306B\u5171\u6709\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem12": "ブレイクアウト ルーム",
    "meetings.fullPlanItem12Tip": "ビデオ ブレイクアウト ルームを利用すると、ディスカッション、プロジェクトなどのために、Zoomミーティングを 50 もの別々のセッションに分割できます。",
    "meetings.fullPlanItem14": "\u30D0\u30FC\u30C1\u30E3\u30EB\u80CC\u666F",
    "meetings.fullPlanItem15": "\u30D1\u30FC\u30BD\u30CA\u30EB\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0ID",
    "meetings.fullPlanItem15Tip": "\u81EA\u5206\u81EA\u8EAB\u306E\u6C38\u4E45\u306E\u30AA\u30F3\u30E9\u30A4\u30F3\u4F1A\u8B70\u5BA4\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u3053\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u3001\u3044\u3064\u3067\u3082\u958B\u59CB\u3057\u3001\u5C06\u6765\u306E\u5229\u7528\u306E\u305F\u3081\u306B\u30B9\u30B1\u30B8\u30E5\u30FC\u30EA\u30F3\u30B0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem17": "\u30DB\u30B9\u30C8\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB",
    "meetings.fullPlanItem18": "\u753B\u9762\u5171\u6709\u3067\u306E\u5171\u540C\u6CE8\u91C8",
    "meetings.fullPlanItem19": "\u30EA\u30E2\u30FC\u30C8\u306E\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB",
    "meetings.fullPlanItem21": "\u30DE\u30EB\u30C1\u30B7\u30A7\u30A2",
    "meetings.fullPlanItem29": "\u5F85\u6A5F\u5BA4",
    "meetings.fullPlanItem29Tip": "\u5F85\u6A5F\u5BA4\u306F\u3001\u53C2\u52A0\u8005\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30EB\u30FC\u30E0\u3078\u306E\u5165\u5BA4\u3092\u30DB\u30B9\u30C8\u304C\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u308B\u6A5F\u80FD\u3067\u3059\u3002 \u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30DB\u30B9\u30C8\u306F\u3001\u53C2\u52A0\u8005\u3092\u3072\u3068\u308A\u305A\u3064\u30C1\u30A7\u30C3\u30AF\u3059\u308B\u304B\u3001\u4E00\u62EC\u3057\u3066\u5165\u5BA4\u3092\u8A31\u53EF\u3059\u308B\u304B\u3001\u3044\u305A\u308C\u304B\u3092\u9078\u3079\u307E\u3059\u3002 \u8A2D\u5B9A\u3067\u306F\u3001\u5F85\u6A5F\u5BA4\u306B\u5165\u308B\u4EBA\u3001\u3042\u308B\u3044\u306F\u81EA\u52D5\u7684\u306B\u8A31\u53EF\u3059\u308B\u4EBA\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002 \u3042\u3089\u3086\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u5F85\u6A5F\u5BA4\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u3066\u3044\u307E\u3059\u3002 \u30DB\u30B9\u30C8\u306F\u3001\u5F85\u6A5F\u5BA4\u306B\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u9001\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002 \u6709\u6599\u30D7\u30E9\u30F3\u306E\u5834\u5408\u3001\u5F85\u6A5F\u5BA4\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem41": "Zoom for Home\u30C7\u30D0\u30A4\u30B9\u306B\u642D\u8F09",
    "meetings.fullPlanItem61": "\u8907\u6570\u306E\u4EBA\u3092\u30D4\u30F3\u3067\u56FA\u5B9A\u3059\u308B",
    "meetings.fullPlanItem61Tip": "ホストは最大 9 人にビデオをピン留めして、独自のカスタムビューを作成する権限を付与できます。したがって、誰が話していても、ピン留めされたビデオは表示されたままになります。",
    "meetings.fullPlanItem62": "\u8907\u6570\u306E\u4EBA\u306B\u30B9\u30DD\u30C3\u30C8\u30E9\u30A4\u30C8\u3092\u5F53\u3066\u308B",
    "meetings.fullPlanItem62Tip": "\u30DB\u30B9\u30C8\u306F\u6700\u59279\u4EBA\u306E\u53C2\u52A0\u8005\u306E\u30D3\u30C7\u30AA\u306B\u30B9\u30DD\u30C3\u30C8\u30E9\u30A4\u30C8\u3092\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u305F\u3081\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u5168\u4F53\u3067\u8A71\u3057\u3066\u3044\u308B\u4EBA\u306B\u95A2\u4FC2\u306A\u304F\u3001\u30B9\u30DD\u30C3\u30C8\u30E9\u30A4\u30C8\u304C\u5F53\u3066\u3089\u308C\u305F\u30D3\u30C7\u30AA\u3092\u898B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanNewItem1": "\u30D5\u30A3\u30EB\u30BF\u30FC",
    "meetings.fullPlanNewItem1Tip": "\u697D\u3057\u3044\u30AB\u30E9\u30FC\u30D5\u30A3\u30EB\u30BF\u30FC\u3084\u52D5\u7269\u306E\u30C7\u30B3\u30EC\u30FC\u30B7\u30E7\u30F3\u30B9\u30C6\u30C3\u30AB\u30FC\u3092\u4F7F\u3048\u3070\u3001\u30CF\u30C3\u30D4\u30FC\u30A2\u30EF\u30FC\u3084\u30D1\u30FC\u30C6\u30A3\u30FC\u306A\u3069\u3067\u697D\u3057\u3081\u307E\u3059\u3002",
    "meetings.fullPlanNewItem2": "\u6295\u7968",
    "meetings.fullPlanNewItem3": "\u5171\u540C\u30DB\u30B9\u30C8\u3068\u4EE3\u66FF\u30DB\u30B9\u30C8",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/ja/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306E\u5171\u540C\u30DB\u30B9\u30C8 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8A73\u7D30\u306F\u3053\u3061\u3089\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002</a>",
    "meetings.fullPlanItem24": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3059\u308B\u4EBA\u3092\u5272\u308A\u5F53\u3066\u308B",
    "meetings.fullPlanItem24Tip": "\u3042\u306A\u305F\u306E\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u4ED6\u306E\u4EBA\u304C\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3059\u308B\u3088\u3046\u306B\u5272\u308A\u5F53\u3066\u3092\u884C\u3048\u307E\u3059\u3002\u5272\u308A\u5F53\u3066\u3089\u308C\u308B\u4EBA\u3082\u30D7\u30ED\u30D7\u30E9\u30F3\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "\u30A2\u30AB\u30A6\u30F3\u30C8\u30AA\u30FC\u30CA\u30FC\u3001\u7BA1\u7406\u8005\u3001\u958B\u767A\u8005\u304CZoom REST API\u306B\u5B89\u5168\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002API\uFF08Application Program Interface\uFF09\u30EC\u30FC\u30C8\u5236\u9650\u304C\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u30BF\u30A4\u30D7\uFF08\u30D7\u30ED\u3001\u30D3\u30B8\u30CD\u30B9\u3001\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u306A\u3069...\uFF09\u3084API\uFF08Application Program Interface\uFF09\u30EA\u30AF\u30A8\u30B9\u30C8\u30BF\u30A4\u30D7 \uFF08\u30E9\u30A4\u30C8\u3001\u30DF\u30C7\u30A3\u30A2\u30E0\u3001\u30D8\u30D3\u30FC\u306A\u3069...\uFF09\u306B\u5F93\u3063\u3066\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u30EC\u30D9\u30EB\u3067\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u4E00\u90E8\u306EAPI\uFF08Application Program Interface\uFF09\u306F\u3001\u30A2\u30AF\u30BB\u30B9\u304C\u7279\u5B9A\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u30BF\u30A4\u30D7\u306B\u5236\u9650\u3055\u308C\u3066\u3044\u307E\u3059\u3002API\uFF08Application Program Interface\uFF09\u30EC\u30FC\u30C8\u5236\u9650\u3068API\uFF08Application Program Interface\uFF09\u30EA\u30D5\u30A1\u30EC\u30F3\u30B9\u6587\u66F8\u3092\u5229\u7528\u3057\u3066\u3001\u8A73\u7D30\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "meetings.fullPlanItem25_pro": "\u30D7\u30EDREST API\u306E\u30EC\u30FC\u30C8\u306E\u5236\u9650",
    "meetings.fullPlanItem25_biz": "REST API\u306E\u30EC\u30FC\u30C8\u306E\u5236\u9650",
    "meetings.fullPlanItem26": "Skype for Business\uFF08Lync\uFF09\u76F8\u4E92\u904B\u7528\u6027",
    "meetings.fullPlanItem26Tip": "Lync 2010\u30682013\u306E\u30E6\u30FC\u30B6\u30FC\u304A\u3088\u3073Skype for Business\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3001Lync\u9023\u7D61\u5148\u30EA\u30B9\u30C8\u304B\u3089Zoom\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u958B\u59CB\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem27": "\u30B9\u30C8\u30EA\u30FC\u30DF\u30F3\u30B0",
    "meetings.fullPlanItem27Tip": "Facebook\u30E9\u30A4\u30D6\u3001YouTube\u30E9\u30A4\u30D6\u3001\u307E\u305F\u306F\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u30B5\u30FC\u30D3\u30B9\u306B\u30E9\u30A4\u30D6\u30B9\u30C8\u30EA\u30FC\u30E0\u914D\u4FE1\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem28": "\u30EC\u30DD\u30FC\u30C8\u4F5C\u6210",
    "meetings.fullPlanItem28Tip": "\u30DB\u30EF\u30A4\u30C8\u30DC\u30FC\u30C9\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u4FDD\u5B58\u3067\u304D\u307E\u3059",
    "meetings.fullPlanItem30": "\u30E6\u30FC\u30B6\u30FC\u7BA1\u7406",
    "meetings.fullPlanItem30Tip": "\u30AA\u30FC\u30CA\u30FC\u3068\u7BA1\u7406\u8005\u306F\u3001\u5F79\u5272\u3068\u30A2\u30C9\u30AA\u30F3\u6A5F\u80FD\u306E\u8FFD\u52A0\u3001\u524A\u9664\u3001\u5272\u308A\u5F53\u3066\u3092\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002",
    "one.autoCaptions": "自動字幕",
    "meetings.fullPlanItem31": "\u7BA1\u7406\u30DD\u30FC\u30BF\u30EB",
    "meetings.fullPlanItem31Tip": "\u4F1A\u793E\u306E\u5168\u30E6\u30FC\u30B6\u30FC\u30921\u3064\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u7BA1\u7406\u3057\u307E\u3059\u3002\u8ACB\u6C42\u3001\u8A73\u7D30\u30E6\u30FC\u30B6\u30FC\u7BA1\u7406\u8A2D\u5B9A\u3001\u5305\u62EC\u7684\u306A\u5229\u7528\u306B\u95A2\u3059\u308B\u6D1E\u5BDF\u306E\u3059\u3079\u3066\u3092Zoom\u7BA1\u7406\u30DD\u30FC\u30BF\u30EB\u3067\u7C21\u5358\u306B\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem32": "LTI\u30A4\u30F3\u30C6\u30B0\u30EC\u30FC\u30B7\u30E7\u30F3",
    "meetings.fullPlanItem32Tip": "\u4EFB\u610F\u306E\u30B3\u30FC\u30B9\u30A2\u30AF\u30C6\u30A3\u30D3\u30C6\u30A3\u306B\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u7C21\u5358\u306B\u8FFD\u52A0\u3057\u3066\u3001\u5B66\u7FD2\u7BA1\u7406\u30B7\u30B9\u30C6\u30E0\uFF08Moodle\u3001Canvas\u3001Desire 2 Learn\u3001Blackboard\u306B\u5BFE\u5FDC\uFF09\u304B\u3089\u5B66\u751F\u3092\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem33": "\u30AF\u30E9\u30A6\u30C9\u9332\u753B\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8",
    "meetings.fullPlanItem33Tip": "\u30AF\u30E9\u30A6\u30C9\u9332\u753B\u306E\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8\u306F\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u9332\u753B\u3059\u308B\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u307E\u305F\u306F\u30A6\u30A7\u30D3\u30CA\u30FC\u306E\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u6587\u5B57\u3067\u8A18\u9332\u3057\u305F\u30AA\u30FC\u30C7\u30A3\u30AA\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8\u3067\u3059\u3002 \u73FE\u5728\u306F\u82F1\u8A9E\u3067\u306E\u30B5\u30DD\u30FC\u30C8\u306B\u306A\u308A\u307E\u3059\u3002 <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F</a>\u3053\u3061\u3089\u3002",
    "meetings.fullPlanItem34": "\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0",
    "meetings.fullPlanItem34Tip": "\u4F1A\u793E\u306E\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u8981\u7D20\u3092\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u53C2\u52A0\u3067\u304D\u308B\u81EA\u5206\u81EA\u8EAB\u306E\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3055\u308C\u305F\u30DA\u30FC\u30B8\u306B\u8FFD\u52A0\u3057\u307E\u3059\u3002\u30D6\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u8981\u7D20\u3092\u8FFD\u52A0\u3057\u305F\u30E1\u30FC\u30EB\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u3001\u53C2\u52A0\u8005\u306B\u62DB\u5F85\u72B6\u3092\u9001\u4FE1\u3057\u307E\u3059\u3002",
    "meetings.fullPlanItem35": "\u7BA1\u7406\u5BFE\u8C61\u30C9\u30E1\u30A4\u30F3",
    "meetings.fullPlanItem35Tip": "\u4F1A\u793E/\u5927\u5B66\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u30C9\u30E1\u30A4\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u3092\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u81EA\u52D5\u7684\u306B\u8FFD\u52A0\u3057\u307E\u3059\u3002",
    "meetings.fullPlanItem37": "\u8A00\u8A9E\u901A\u8A33",
    "meetings.fullPlanItem37Tip": "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30DB\u30B9\u30C8\u304C\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3084\u30A6\u30A7\u30D3\u30CA\u30FC\u306E\u901A\u8A33\u3092\u6307\u540D\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u307E\u305F\u306F\u30A6\u30A7\u30D3\u30CA\u30FC\u304C\u59CB\u307E\u308B\u3068\u3001\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u30DB\u30B9\u30C8\u304C\u901A\u8A33\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u3001\u901A\u8A33\u306F\u72EC\u81EA\u306E\u30AA\u30FC\u30C7\u30A3\u30AA\u30C1\u30E3\u30F3\u30CD\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002\u53C2\u52A0\u8005\u306F\u30AA\u30FC\u30C7\u30A3\u30AA\u30C1\u30E3\u30F3\u30CD\u30EB\u3092\u9078\u629E\u3057\u3066\u3001\u5E0C\u671B\u3059\u308B\u8A00\u8A9E\u3092\u805E\u304F\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u53C2\u52A0\u8005\u306F\u7FFB\u8A33\u3055\u308C\u305F\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u805E\u304D\u3001\u30AA\u30EA\u30B8\u30CA\u30EB\u306E\u97F3\u58F0\u3092\u4F4E\u3044\u97F3\u91CF\u3067\u805E\u304F\u304B\u3069\u3046\u304B\u3092\u9078\u629E\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002",
    "meetings.fullPlanItem39": "\u30A8\u30B0\u30BC\u30AF\u30C6\u30A3\u30D6\u4E8B\u696D\u30EC\u30D3\u30E5\u30FC",
    "meetings.fullPlanItem39Tip": "\u8A73\u7D30\u306A\u30C8\u30EC\u30F3\u30C9\u63A1\u7528\u5206\u6790\u3001\u6295\u8CC7\u5229\u76CA\u7387\u8FFD\u8DE1\u3001\u88FD\u54C1\u30ED\u30FC\u30C9\u30DE\u30C3\u30D7\u306E\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u3067\u3059\u3002",
    "meetings.fullPlanNewItem4": "Webinar 500\u8FBC\u307F",
    "one.translatedCations": "翻訳された字幕",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "直接チャット、チャネル チャット、グループ チャット",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "1 対 1 メッセージ、小規模グループ、大規模チームでのスムーズなコミュニケーション",
    "messageAndFileHistory": "メッセージとファイル履歴",
    "findPeopeChannelsAndFilesInSearch": "検索でユーザー、チャネル、ファイルを発見",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "連絡先、インスタント メッセージ、グループ チャット、ファイルを即座に検索でき、知識と情報を簡単に入手することができます。",
    "applicationIntegrations": "アプリケーション連携",
    "secureFileSharing": "安全なファイル共有",
    "enhanceCollaborationWithSeamlessFileSharing": "シームレスなファイル共有でコラボレーションを強化",
    "persistentMeetingChat": "持続的なミーティング チャット",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "ミーティング会話のトラッキングを維持します。 Zoom Team Chat 内の専用グループ チャットでミーティング前後および最中に参加者全員とコミュニケーションが可能です。",
    "cloudStorage": "クラウドストレージ",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "チャネルを Zoom クラウドまたはサードパーティ ストレージ プロバイダーでバックアップ",
    "avatars": "アバター",
    "inMeetingReactions": "ミーティング内リアクション",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "エンゲージメントを表示して、他の参加者と非言語的にすばやくコミュニケーション",
    "virtualBackgrounds": "バーチャル背景",
    "videoFilters": "ビデオフィルタ",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "ビデオに重ねる多様なフィルタでミーティングに楽しさを追加",
    "inMeetingPollsAndQuizzes": "ミーティング内投票とクイズ",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "ミーティングに単一選択または複数選択の投票質問を作成できます。",
    "liveStreamingAcrossPlatforms": "プラットフォーム間のライブ ストリーミング",
    "appearanceTouchUp": "外見補正",
    "originalSoundForMusicians": "ミュージシャン向けのオリジナル サウンド",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings 向けエンドツーエンド暗号化",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Zoom Meetings 向けエンドツーエンド暗号化（E2EE）が有効な場合、Zoom クライアントを使用している特定ミーティングの参加者全員のコミュニケーションは、参加当時者のデバイスにのみ開示される暗号鍵で暗号化されます。 つまり、Zoom を含むサードパーティは、ミーティングの秘密鍵にアクセスすることはできません。",
    "zoomCustomerManagedKey": "Zoom カスタマー マネージド キー（CMK）",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "自分・自組織の暗号化キーを使用し、安心して Zoom データを保護できます",
    "enterpriseGradeSecurityFeatures": "エンタープライズ クラスのセキュリティ機能",
    "256BitAesGcmEncryptionForRealTimeContent": "リアルタイム コンテンツとメディアに向けた 256 ビット AES-GCM 暗号化（SIP 登録時の TLS 暗号化、発信者 ID のマスキング、非公開ネットワークのピアリング、通話詐欺の検出、通話のブロックリスト）。",
    "phone.fullPlanItem40": "SAML 2.0\u306B\u3088\u308B\u30B7\u30F3\u30B0\u30EB\u30B5\u30A4\u30F3\u30AA\u30F3\uFF08SSO\uFF09",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "\u5185\u90E8\u901A\u8A71\u7121\u5236\u9650",
    "phone.fullPlanItem2": "\u5F93\u91CF\u5236\u767A\u4FE1\u30B3\u30FC\u30EB",
    "phone.fullPlanItem3": "\u767A\u4FE1\u30B3\u30FC\u30EB\u7121\u5236\u9650",
    "phone.fullPlanItem4": "\u696D\u754C\u3092\u30EA\u30FC\u30C9\u3059\u308BHD\u901A\u8A71\u54C1\u8CEA",
    "phone.fullPlanItem4Tip": "\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u96D1\u97F3\u6D88\u53BB\u3001\u30A8\u30B3\u30FC\u6D88\u53BB\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u5165\u529B\u6291\u5236",
    "phone.fullPlanItem5": "\u30CD\u30A4\u30C6\u30A3\u30D6\u306EWindows\u3001MacOS\u3001Linux\u306E\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A2\u30D7\u30EA",
    "phone.fullPlanItem6": "iOS\u5411\u3051\u3068Android\u5411\u3051\u306E\u30CD\u30A4\u30C6\u30A3\u30D6\u306E\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA",
    "phone.fullPlanItem7": "既存の電話番号をポートするか新しい番号（DID）を購入",
    "phone.fullPlanItem8": "トールフリー番号",
    "phone.fullPlanItem9": "\u5185\u7DDA\u756A\u53F7",
    "phone.fullPlanItem10": "\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u4ED8\u304D\u306E\u30DC\u30A4\u30B9\u30E1\u30FC\u30EB",
    "phone.fullPlanItem10Tip": "\u30E2\u30D0\u30A4\u30EB/\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A2\u30D7\u30EA\u3084\u30E1\u30FC\u30EB\u306B\u3088\u308B\u30DC\u30A4\u30B9\u30E1\u30FC\u30EB\u306E\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u3078\u306E\u30A2\u30AF\u30BB\u30B9",
    "phone.fullPlanItem11": "\u81EA\u52D5\u5FDC\u7B54/IVR\u7121\u5236\u9650",
    "phone.fullPlanItem12": "\u540D\u524D\u306B\u3088\u308B\u30C0\u30A4\u30E4\u30EB\u30C7\u30A3\u30EC\u30AF\u30C8\u30EA",
    "phone.fullPlanItem13": "自動応答(IVR)機能",
    "phone.fullPlanItem14": "\u30D0\u30FC\u30B8/\u30E2\u30CB\u30BF\u30FC/\u3055\u3055\u3084\u304D/\u5F15\u304D\u7D99\u304E",
    "phone.fullPlanItem15": "\u4F11\u65E5/\u5E73\u65E5\u306E\u55B6\u696D\u6642\u9593\u306E\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0",
    "phone.fullPlanItem16": "3\u30A6\u30A7\u30A4\u30A2\u30C9\u30DB\u30C3\u30AF\u4F1A\u8B70\u901A\u8A71",
    "phone.fullPlanItem17": "\u901A\u8A71\u8A18\u9332",
    "phone.fullPlanItem17Tip": "\u81EA\u52D5\u304A\u3088\u3073\u624B\u52D5\u901A\u8A71\u9332\u97F3\u304C\u5229\u7528\u3067\u304D\u307E\u3059\u3002",
    "phone.fullPlanItem18": "\u69CB\u6210\u53EF\u80FD\u306A\u533F\u540D\u3042\u308B\u3044\u306F\u6307\u5B9A\u306E\u901A\u8A71\u30D6\u30ED\u30C3\u30AF",
    "phone.fullPlanItem19": "\u7DCA\u6025\u6642\u306E\u901A\u8A71",
    "phone.fullPlanItem19Tip": "\u30ED\u30FC\u30AB\u30EB\u306E\u7DCA\u6025\u30B5\u30FC\u30D3\u30B9\u3078\u96FB\u8A71",
    "phone.fullPlanItem20": "\u30CE\u30DE\u30C9\u30EF\u30FC\u30AB\u30FC\u5411\u3051E911\u5BFE\u51E6\uFF08\u7C73\u56FD\u3068\u30AB\u30CA\u30C0\uFF09-",
    "phone.fullPlanItem20Tip": "\u30E6\u30FC\u30B6\u30FC\u30ED\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u52D5\u7684\u306B\u691C\u51FA\u3057\u3001\u5BFE\u5FDC\u3059\u308B\u7DCA\u6025\u9023\u7D61\u5148\u3092\u5730\u57DF\u306E\u7DCA\u6025\u30B5\u30FC\u30D3\u30B9\uFF08\u7C73\u56FD\u3068\u30AB\u30CA\u30C0\u306E\u307F\uFF09\u304A\u3088\u3073\u5185\u90E8\u306E\u5B89\u5168\u30C1\u30FC\u30E0\u306B\u30EC\u30DD\u30FC\u30C8\u3057\u307E\u3059",
    "phone.fullPlanItem21": "\u7DCA\u6025\u5BFE\u5FDC\u30BB\u30F3\u30BF\u30FC",
    "phone.fullPlanItem21Tip": "\u5185\u90E8\u306E\u5B89\u5168\u30C1\u30FC\u30E0\u306B\u7DCA\u6025\u96FB\u8A71\u306E\u30A2\u30E9\u30FC\u30C8\u3092\u9001\u4FE1\u3057\u3001\u7DCA\u6025\u96FB\u8A71\u306E\u9332\u753B/\u30E2\u30CB\u30BF\u30FC/\u30D0\u30FC\u30B8\u3092\u884C\u3044\u3001\u5FDC\u7B54\u306E\u8ABF\u6574\u3092\u652F\u63F4\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002",
    "phone.fullPlanItem22": "\u5171\u6709\u56DE\u7DDA\u5916\u89B3/\u59D4\u4EFB",
    "phone.fullPlanItem23": "\u30C7\u30D0\u30A4\u30B9\u9593\u306E\u30CF\u30F3\u30C9\u30AA\u30D5\u306E\u547C\u3073\u51FA\u3057",
    "phone.fullPlanItem24": "\u30B3\u30FC\u30EB\u30D1\u30FC\u30AF",
    "endToEndEncryptionForZoomPhone": "Zoom Phone 向けのエンドツーエンド暗号化",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Zoom Phone 向けにエンドツーエンド暗号化（E2EE）を有効にすると、発信者と受信者のデバイスのみに開示される暗号鍵を使用して、通話が暗号化されます。 加えてユーザーは、互いに独自のセキュリティ コードをやり取りすることで、E2EE ステータスを確認できるオプションも選択できるようになります。",
    "phone.fullPlanItem43": "\u96FB\u8A71\u306E\u30BC\u30ED\u30BF\u30C3\u30C1\u30D7\u30ED\u30D3\u30B8\u30E7\u30CB\u30F3\u30B0",
    "phone.fullPlanItem44": "1\u3064\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30D7\u30E9\u30F3\u306E\u6DF7\u5408\u30BF\u30A4\u30D7",
    "phone.fullPlanItem46": "\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u30EC\u30DD\u30FC\u30C8\u3068\u54C1\u8CEA\u306E\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9",
    "phone.fullPlanItem47": "\u30D0\u30FC\u30C1\u30E3\u30EB\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\uFF08VDI\uFF09\u74B0\u5883\u3092\u30B5\u30DD\u30FC\u30C8",
    "phone.fullPlanItem47Tip": "VDI\u306E\u6982\u8981<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">\u8A73\u7D30\u3092\u78BA\u8A8D</a>",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "個別で電話をご利用になるすべてのお客様が利用可能です。 サポートプランはミーティング プランの組み合わせによって異なります。",
    "phone.fullPlanItem49": "BYOC\uFF08Bring Your Own Carrier\uFF09\u306E\u30B5\u30DD\u30FC\u30C8",
    "phone.fullPlanItem49Tip": "\u65E2\u5B58\u306EPSTN\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u306B\u5BFE\u3059\u308B\u30C0\u30A4\u30EC\u30AF\u30C8\u304A\u3088\u3073\u30D7\u30EC\u30DF\u30B9\u30D9\u30FC\u30B9\u306E\u30D4\u30A2\u30EA\u30F3\u30B0\u306E\u30B5\u30DD\u30FC\u30C8",
    "phone.fullPlanItem50": "\u30EC\u30AC\u30B7\u30FCPBX\u3078\u306E\u30CF\u30A4\u30D6\u30EA\u30C3\u30C9\u30A4\u30F3\u30C6\u30B0\u30EC\u30FC\u30B7\u30E7\u30F3",
    "phone.fullPlanItem51": "プッシュ ツー トーク",
    "phone.fullPlanItem61": "オンラインFAX",
    "phone.fullPlanItem61Tip": "米国およびカナダ内でFAXを無制限に送受信できます。国際FAXの場合、<a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">料金はこちら</a>",
    "phone.fullPlanSms": "SMS と MMS",
    "phone.fullPlanSmsTip": "\u901A\u8A71\u30D7\u30E9\u30F3\u306E\u8CFC\u5165\u306B\u3088\u308A\u7C73\u56FD\u304A\u3088\u3073\u30AB\u30CA\u30C0\u306E\u756A\u53F7\u306B\u306E\u307F\u5229\u7528\u53EF\u80FD\u3002 \u76F4\u901A\u756A\u53F7\u306E\u4F7F\u7528\u304C\u5229\u7528\u53EF\u80FD\uFF08\u6CD5\u4EBA\u756A\u53F7\u3067\u306F\u306A\u3044\uFF09\u3002",
    "meetings.fullPlanItem6": "\u30C6\u30AF\u30CB\u30AB\u30EB\u30B5\u30DD\u30FC\u30C8",
    "meetings.fullPlanItem6Tip": "リスクを最小限に抑え、ダウンタイムを減らすためのプレミア サポート パッケージ。",
    "meetings.fullPlanItem6_basic": "\u30C1\u30B1\u30C3\u30C8\u306E\u307F",
    "meetings.fullPlanItem6_pro": "\u30C1\u30B1\u30C3\u30C8\u3068\u30E9\u30A4\u30D6\u30C1\u30E3\u30C3\u30C8",
    "meetings.fullPlanItem6_biz": "\u30C1\u30B1\u30C3\u30C8\u3001\u30E9\u30A4\u30D6\u30C1\u30E3\u30C3\u30C8\u3001\u96FB\u8A71",
    "meetings.fullPlanItem6_ent": "\u30C1\u30B1\u30C3\u30C8\u3001\u30E9\u30A4\u30D6\u30C1\u30E3\u30C3\u30C8\u3001\u96FB\u8A71",
    "knowledgeBase": "ナレッジベース",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "ナレッジベースの記事を検索して技術的な問題をトラブルシュートし、サポート リソースにアクセスしてください。",
    "zoomCommunity": "Zoom コミュニティ",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "ソリューションを検索し、質問を投げかけ、他の Zoom ユーザーとコラボレーションする場所。",
    "chatbot": "チャットボット",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "チャットボットとやり取りして質問に対する回答を見つけ、技術的な問題をトラブルシュートしてください。",
    "submitWebTickets": "ウェブチケットの送信",
    "liveChatSupport": "ライブチャットのサポート",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "月額 ${amount}（USD）を超えるサブスクリプション プラン",
    "livePhoneSupport": "ライブ電話のサポート",
    "meetWithAgentOnVideo": "エージェントとのビデオでのミーティング",
    "subscriptionPlansGreaterThan_200UsdMonth": "月額 $200（USD）を超えるサブスクリプション プラン",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "チームチャット内で直接お気に入りのアプリを活用して生産性を向上",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "お使いのアバターをカスタマイズしてミーティングに楽しさを追加し、ビデオを使用しなくてもご自身をダイナミックに表現",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "メール",
    "common.plans.meeting.title": "ミーティング",
    "plans.basic_free.upgrade.item1": "ミーティング当たり最大 30 時間",
    "common.statistics.participants": "参加者 {0} 名",
    "common.per_meeting_unit": "ミーティングごと",
    "common.participant_limit.increase_with_large_meetings": "大規模ミーティングでの参加者の追加",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "ホワイトボード",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "無制限",
    "common.plans.team_chat.title": "チームチャット",
    "common.plans.mail_calendar.title": "メール＆カレンダー",
    "common.plans.cloud_storage.title": "クラウド ストレージ",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Zoom 翻訳版字幕",
    "common.plans.extras.title": "追加",
    "common.plans.extras.desc": "会社ドメインの管理など",
    "zoom_one_edu_bundle.school.title": "教育機関向け Zoom One",
    "zoom_one_edu_bundle.school_plus.title": "教育機関向け Zoom One プラス",
    "per_billing_cycle_license.monthly": "/月/ライセンス",
    "per_billing_cycle_license.yearly": "/年/ライセンス",
    "per_billing_cycle_space.monthly": "月額（1 スペースあたり）",
    "per_billing_cycle_space.yearly": "年額（1 スペースあたり）",
    "common.dialog.feature_list": "全機能のリストを見る",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB（ライセンスごと）",
    "detail_dialog.meeting_feature.cloud_recording.10": "ライセンス当たり 10 GB",
    "detail_dialog.meeting_feature.cloud_recording.ent": "無制限はエンタープライズ プラス内に組み込み済み",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + カンファレンス ルームコネクタ（比率: 1:25）",
    "plans.whiteboard.ent": "無制限プラスはエンタープライズ プラス内に組み込み済み",
    "plans.zp.ent": "エンタープライズ プラス内に組み込み済み",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "事前 / オンサイトのワークスペース予約など",
    "plans.largeMeeting.intro_tip": "大規模ミーティングは、注文を確定するときに任意で追加できるアドオンです。購入したライセンスに応じ、参加者数が最大 500 名または 1,000 名のミーティングを主催できます。",
    "common.participant_limit.expandable_with_large_meetings": "大規模ミーティングで拡張可能",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">エンタープライズ プラスは 1000 名</span>",
    "plans.webinar": "Zoom ウェビナー",
    "plans.webinar.ent": "セッション 1000（ウェビナー込み）はエンタープライズ プラス内に組み込み済み",
    "per_billing_cycle_user.monthly": "/月/ユーザー",
    "per_billing_cycle_user.annually": "/年/ユーザー",
    "closeComparisonChart": "閉じる",
    "archiving_api": "アーカイブ API",
    "dlp_api": "DLP API",
    "info_barriers": "情報バリア",
    "chat_etiquette": "チャット エチケット",
    "gdrp": "GDPR",
    "regiona_data_centers": "地域のデータセンター",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "暗号化（デフォルト）",
    "end_to_end_encryption": "エンドツーエンド暗号化",
    "cryptographic_boundary": "暗号境界",
    "vdi": "バーチャル デスクトップ（VDI）",
    "customer_managed_key": "カスタマー マネージド キー",
    "gpo_msi_policies": "GPO / MSI ポリシー",
    "msi": "一括展開（MSI）",
    "ntt": "ネットワーク テストツール（NTT）",
    "dashboards": "ダッシュボード",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone サバイバビリティ",
    "zoom_meeting_survivability": "Zoom ミーティングのサバイバビリティ",
    "paid_option": "有料オプション",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "主な機能",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "教育機関およびキャンパス",
    "zoom_one_edu_bundle.school_plus.brief_title": "スクール＆キャンパス プラス",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "ko-KO": {
    "billing.essential_apps": "필수 앱",
    "billing.essential_apps.dialog_desc": "회의록을 기록하고, 대화형 활동으로 팀과 소통하며, 고객과의 상담을 개선하는 방법에 관한 인사이트를 얻을 수 있도록 지원해 주는 다양한 앱으로 비즈니스를 성장시키고 관리하세요. 1년 동안 이용 가능한 무료 프리미엄 앱이 요금제에 포함됩니다.",
    "billing.see_more_details": "자세히 살펴보기",
    "billing.essential_app.legal_copy": "Zoom 온라인 채널(zoom.us/buy)을 통해 구매한 Zoom One 프로, 비즈니스 또는 비즈니스 플러스를 구독 중이고, 현재 기준 또는 2023년 1월 4일 이후에 최신 라이선스를 보유한 사용자에게만 유효한 혜택입니다. 구독이 의료, 교육 또는 정부 계정과 연결된 사용자는 이 혜택을 받을 수 없습니다.  Coda를 제외하고 각 앱에 대한 액세스 권한은 개인 사용자가 앱을 활성화하면 시작되고 이후 1년이 되는 시점에 만료됩니다. 같은 Zoom 계정을 사용하는 모든 사용자의 Coda에 대한 액세스 권한은 같은 Zoom 계정을 사용하는 사용자 중 한 명이 Coda를 처음 활성화한 날짜에 시작되고 같은 Zoom 계정을 사용하는 다른 사용자가 처음 활성화한 날짜와 관계없이 이후 1년이 되는 시점에 모든 사용자의 액세스 권한이 만료됩니다.모든 앱에서 특정 사용자의 적격한 라이선스 또는 구독을 재할당하거나 취소하는 경우 아직 1년 액세스 기간이 남아 있다 하더라도 해당 사용자의 액세스 권한은 종료됩니다.각 앱에는 활성화 시점에 해당하는 사용약관 및 개인정보 처리방침이 적용됩니다.포함된 앱은 영어로만 지원됩니다.모바일에서 작동하지 않는 앱도 있습니다.혜택은 현금으로 교환하거나 환불받을 수 없습니다.이는 <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>의 필수 앱에 포함된 것으로 나열된 앱에만 적용됩니다. 이러한 앱을 이미 구독하고 있는 사용자는 해당 특정 앱과 관련하여 이 혜택을 받을 수 없습니다.Zoom은 사전 통지 및 책임 없이 언제든지 이 혜택을 수정하거나 취소할 권한을 보유하고 있습니다.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "방문자 관리"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "연중무휴 라이브 채팅 및 전화 지원"
      },
      "learn_more": "\uB354 \uC54C\uC544\uBCF4\uAE30",
      "new": "신규",
      "plan_details": {
        "meeting": {
          "title": "\uBBF8\uD305",
          "host_meeting_up_to_participants": "최대 {0}명의 참가자 호스트",
          "meeting_hours": "미팅당 최대 30시간으로 무제한 미팅",
          "recording_storage": "클라우드 스토리지 녹화 {0}GB(라이선스당)",
          "auto_captions": "자동 자막"
        },
        "whiteboard": {
          "title": "화이트보드",
          "boards_storage": "편집 가능한 보드 {0}개",
          "standard_features": "표준 기능"
        },
        "team_chat": {
          "title": "팀 채팅",
          "desc": "그룹 채팅 및 파일 공유"
        },
        "main_calendar": {
          "title": "메일 및 캘린더",
          "desc": "메일 및 캘린더 클라이언트"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Zoom 내에서 편집 가능한 문서 작성 및 공유",
          "desc2": "서식 있는 텍스트 편집 기능을 갖춘 개인 노트와 협업 노트"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "짧은 형식의 비디오를 간편하게 녹화, 편집 및 공유",
          "desc2": "무제한 비디오 및 고급 기능"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "미팅 요약, 메시지 초안 작성 지원 등의 기능에 빠르게 액세스하세요"
        },
        "EssentialApp": {
          "title": "필수 앱",
          "desc1": "프리미엄 앱 1년 무료 액세스(약관 적용)",
          "desc2": "팀 협업 및 생산성 증대"
        },
        "livechat": {
          "title": "라이브 채팅 지원"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Zoom Workplace 프로로 변경하시겠습니까?",
            "content": "이전에 회의당 최대 300명의 참가자를 하용하고 Zoom Scheduler 등을 지원하는 Zoom Workplace 비즈니스를 선택하셨습니다. 그래도 프로로 변경하시겠습니까?",
            "confirm": "변경 확인",
            "keep_current": "현재 요금제 유지"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "항목 {num}개"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "닫기",
          "cancel": "취소",
          "edit": "편집",
          "got_it": "확인"
        },
        "title": {
          "everything_in_and": "{0}에 모두 포함 및"
        },
        "tag": {
          "new": "신규",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "연간",
          "monthly": "월간",
          "quarterly": "분기별",
          "two_years": "2년",
          "three_years": "3년"
        },
        "errors": {
          "unknown_error_try_again": "트랜잭션 처리 중 알 수 없는 오류가 발생하였습니다. 나중에 다시 시도해 주십시오."
        },
        "excluding_tax": {
          "vat_tip": "VAT 제외",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "제한된 기능",
        "pro_plus": {
          "host_meeting_up_to_participants": "최대 {0}명의 참가자 호스트",
          "gb_of_cloud_recording_storage": "{0}GB 클라우드 녹화 스토리지(라이선스당)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "콘텐츠 생성 및 번역을 위한 AI Companion",
            "features_item2": "팀과 무제한으로 문서 공유",
            "features_item3": "무제한으로 버전 기록에 액세스",
            "comparison_table_tips": "회의 내용을 실행 가능한 문서, Wiki 및 프로젝트로 변환하는 AI 우선 문서로 협업 강화"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks 기본",
            "features_item1": "회의, 전화 통화, 채팅 및 문서에서 작업을 자동으로 감지합니다",
            "features_item2": "후속 회의 예약 및 문서 초안 작성 등의 작업을 완료할 수 있도록 지원을 받습니다",
            "features_item3": "작업이 완료되면 작업 상태를 손쉽게 완료로 표시하여 진행 상황을 파악하고 다음 작업에 집중합니다.",
            "features_item4": "Zoom Docs를 비롯한 Zoom Workplace 플랫폼 전반에서 작업을 관리합니다",
            "features_item1_opc": "AI Companion 기능을 활용하여 채팅, 이메일, 문서, 화이트보드 및 회의 요약에서 작업을 식별하여 생성",
            "features_item2_opc": "간편한 정렬, 필터링, 그룹화 및 검색을 통해 작업에 대한 컨텍스트를 빠르게 확인하고 수집",
            "learn_more_header": "AI Companion*으로 실행 항목을 항상 파악하여 Zoom Workplace 전반에서 생산성을 높이세요.",
            "learn_more_footer": "\*AI Companion은 Zoom Workplace 프로, 비즈니스 및 엔터프라이즈 요금제에서만 사용할 수 있습니다.",
            "features_prefix": "AI Companion은 다음을 할 수 있도록 지원합니다.",
            "comparison_table_tips": "Zoom Workplace에서 대화 및 회의 요약을 기반으로 작업을 추천하는 AI 기반 솔루션을 통해 실행 항목을 파악하고 제시간에 완료하세요.",
            "tasks_label_text": " AI 기반 작업 관리"
          },
          "title": "비즈니스 플러스",
          "contact_us_for_more_pricing": "가격 관련 자세한 내용은 Zoom에 문의해 주세요",
          "contact_sales": "영업 팀에 문의",
          "meetings": "\uBBF8\uD305",
          "phone": "\uC804\uD654",
          "phone_sub_title": "\uBB34\uC81C\uD55C \uD1B5\uD654",
          "use_only": "비즈니스 전용",
          "team_chat": {
            "title": "팀 채팅",
            "title_desc": "그룹 채팅 및 파일 공유"
          },
          "cloud_storage": {
            "title": "\uD074\uB77C\uC6B0\uB4DC \uC800\uC7A5\uC18C"
          },
          "mail_calender": {
            "title": "메일 및 캘린더"
          },
          "beta": "Beta",
          "client_service": {
            "title": "클라이언트 및 서비스"
          },
          "up_to_30_hours_per_meeting": "미팅당 최대 30시간",
          "300_attendees": "참석자 300명",
          "per_meeting": "미팅당",
          "whiteboard": {
            "title": "화이트보드"
          },
          "new": "신규",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "기타",
          "sso_managed_domains_more": "싱글 사인온, 관리형 도메인 등",
          "scheduler": "스케줄러",
          "global_select": "Global Select",
          "unlimited_regional": "무제한 지역",
          "translated_captions": "번역 자막",
          "workspace_reservation": "작업 공간 예약",
          "auto_translated_captions": "자동 및 번역 자막",
          "unlimited_editable_boards": "편집이 가능한 무제한 보드",
          "standard_features": "표준 기능",
          "advanced_docu_controls": "고급 문서 컨트롤",
          "chats_channels_for_collaboration": "협업, 파일 공유 등을 위한 채팅 및 채널",
          "zoom_phone_is_biz_use_only": "Zoom Phone은 비즈니스 전용입니다.",
          "unlimited_regional_calling": "\uBB34\uC81C\uD55C \uC9C0\uC5ED \uD1B5\uD654",
          "domestic_sms_mms": "\uAD6D\uB0B4 SMS & MMS",
          "automatic_call_distribution_groups": "\uC790\uB3D9 \uD1B5\uD654 \uBD84\uBC30 \uADF8\uB8F9(ACD) \uBC0F \uD1B5\uD654 \uB300\uAE30\uC5F4",
          "single_sign_on": "\uC2F1\uAE00 \uC0AC\uC778\uC628",
          "managed_domains": "\uAD00\uB9AC\uD558\uACE0 \uC788\uB294 \uB3C4\uBA54\uC778",
          "company_branding": "\uD68C\uC0AC \uBE0C\uB79C\uB529",
          "mail_calender_client_services_beta": "메일 및 캘린더 클라이언트 및 서비스 베타",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "미팅당 최대 30시간으로 무제한 미팅",
          "mail_and_calendar_client_and_services_beta": "메일 및 캘린더 클라이언트 및 서비스 베타",
          "easily_record_edit_share_videos": "짧은 형식의 비디오를 간편하게 녹화, 편집 및 공유",
          "unlimited_videos_advanced_features": "무제한 비디오 및 고급 기능",
          "create_share_editabel_docu_within_zoom": "Zoom 내에서 편집 가능한 문서 작성 및 공유",
          "personal_collaborative_notes_rich_text_editing": "서식 있는 텍스트 편집 기능을 갖춘 개인 노트와 협업 노트",
          "effortlessly_share_meeting": "간편 예약을 위한 손쉬운 미팅 시간대 공유",
          "works_with_zoom_meeting_mail_calender_google_ms": "Zoom Meetings, Zoom Mail 및 Calendar, Google 및 Microsoft 365에서 지원",
          "up_to_300_attendees": "최대 참석자 300명",
          "10_gb_of_storage": "10GB의 스토리지",
          "host_meeting_up_to_300_participants": "\uCD5C\uB300 300\uBA85\uC774 \uCC38\uAC00\uD560 \uC218 \uC788\uB294 \uBBF8\uD305 \uD638\uC2A4\uD2B8",
          "10_gb_of_cloud_recording_storage": "클라우드 스토리지 녹화 10GB(라이선스당)",
          "starting_at_licenses_year": "\uC5F0\uAC04 {0}\uC5D0 \uB77C\uC774\uC120\uC2A4 {1}\uAC1C\uBD80\uD130 \uC2DC\uC791",
          "starting_at_licenses_month": "\uC6D4\uAC04 {0}\uC5D0 \uB77C\uC774\uC120\uC2A4 {1}\uAC1C\uBD80\uD130 \uC2DC\uC791",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "미팅 요약, 메시지 초안 작성 지원 등의 기능에 빠르게 액세스하세요",
          "learn_more": "\uB354 \uC54C\uC544\uBCF4\uAE30",
          "essential_apps": "필수 앱",
          "increase_team_collaboration": "팀 협업 및 생산성 증대",
          "free_premium_apps": "프리미엄 앱 1년 무료 액세스(약관 적용)",
          "visitor_management": "방문자 관리",
          "visitor_management_custom_invites": "초대 사용자 지정",
          "visitor_management_visitor_check": "키오스크에서 체크-인",
          "visitor_management_receive_detailed": "방문자의 공간 사용에 대한 상세한 메트릭 받기"
        },
        "custom_avatar": {
          "title": "사용자 지정 아바타",
          "label_text": "1개월에 3분",
          "basic_feature": "수명당 1분",
          "pricing_feature": "1개월에 3분",
          "learn_more_subtitle": "자신의 외모와 목소리를 복제한 사실감 넘치는 AI 버전을 만들어 보세요. 이 아바타는 여러 언어로 소통아 가능합니다.",
          "features_item1": "매월 최대 3개의 사실감 넘치는 디지털 아바타를 만들 수 있습니다. 이 아바타는 사용자의 외모와 목소리를 복제하여 프레젠테이션이나 데모에 사용합니다.",
          "features_item2": "아바타를 활용하여 AI Companion와 함께 최대 3분 길이의 스크립트를 전달할 수 있습니다.",
          "features_item3": "미리 디자인된 18개의 아바타 중에서 선택하여 고품질의 영상을 빠르게 제작할 수 있습니다.",
          "features_item4": "가상 배경 지원을 이용할 수 있습니다.",
          "features_item1_opc": "매월 최대 3개의 사실감 넘치는 디지털 아바타를 만들 수 있습니다. 이 아바타는 사용자의 외모와 목소리를 복제하여 프레젠테이션이나 데모에 사용합니다.",
          "features_item2_opc": "아바타를 활용하여 AI Companion와 함께 최대 3분 길이의 스크립트를 전달할 수 있습니다.",
          "comparison_table_tips": "사용자 지정 아바타는 목소리를 복제한 사실감 넘치는 AI 버전을 만들며, 이 아바타는 여러 언어로 의사 소통이 가능합니다."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "미팅 요약, 메시지 초안 작성 지원 등의 기능에 빠르게 액세스하세요",
        "learn_more_dialog": {
          "desc": "AI Companion으로 생산성을 높여보세요. 콘텐츠 작성, 회의 일정 예약, 프로젝트 관리 등 다양한 작업을 간편하게 처리해 보세요.",
          "tip1": "안건을 미리 확인하여 원활하고 효율적으로 회의를 진행하세요.",
          "tip2": "자동화된 작업 생성 및 알림 기능을 통해 계획에 맞게 프로젝트를 진행하세요.",
          "tip3": "일정 및 시간을 효율적으로 관리하세요.",
          "tip4": "Docs, Whiteboard, Zoom Workplace 앱으로 자신의 스타일에 맞는 텍스트와 시각적 콘텐츠를 생성하세요."
        },
        "top_features": "주요 기능",
        "more_to_come": "향후 더 많은 놀라운 기능이 추가될 예정입니다!",
        "discover_more": "AI Companion으로 최고의 업무 성과를 내는 더 많은 방법을 알아보세요!",
        "detail_desc": "AI Companion은 Zoom 사용자 계정의 유료 서비스에 추가 비용 없이 포함되어 있습니다. 일부 업종과 지역은 이용 대상에서 제외될 수 있습니다."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/연/라이선스",
        "month_licnese": "/월/라이선스",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/월",
          "per_year": "/년도"
        },
        "unit": {
          "license": "{0}/라이선스",
          "user": "{0}/사용자"
        },
        "learn_more": "더 알아보기",
        "required": "필수",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "참가자 정원을 최대 1,000명으로 늘리고 더 많은 사람과 소통하세요.",
          "label_title1": "참석자 500명",
          "label_title2": "참석자 1000명"
        },
        "cmr": {
          "features_tip": "Zoom 클라우드에서 바로 영상 녹화본을 저장, 스트리밍, 다운로드하세요.",
          "explain_desc": "클라우드 스토리지는 일부 Zoom One 요금제에 포함(프로: 5GB, 비즈니스: 5GB, 비즈니스 플러스: 10GB, 기업: 무제한)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 시간",
          "option_label2": "≈ 650 시간",
          "option_label3": "≈ 3,500 시간",
          "option_label4": "≈ 17,500 시간",
          "intro_label2": "최대 5TB/월을 포함하는 스토리지 옵션",
          "tooltip_content": "녹화 스토리지는 비디오를 사용할 수 있는 참가자 수, 미팅 해상도, 공유 콘텐츠 해상도에 따라 달라집니다."
        },
        "whiteboard": {
          "plus_title": "Zoom Whiteboard 플러스",
          "title": "Whiteoard",
          "features_tip": "미팅 중 혹은 미팅 이후에도 언제나 이용가능한 화이트보드를 통해 다른 사람들과 실시간으로 협업하세요.",
          "explain_desc": "Zoom One 비즈니스, Zoom One 비즈니스 플러스 및 Zoom One 기업에 포함",
          "explain_desc_plus": "Zoom One 기업 플러스 및 각 Zoom Rooms 구독에 포함",
          "option_label1": "1GB 클라우드 스토리지가 제공되는 무제한 보드",
          "option_label2": "무제한 보드 및 클라우드 스토리지를 갖춘 고급 기능",
          "intro_label1": "동시 편집이 가능한 무제한 화이트보드",
          "intro_label2": "표준 기능 및 고급 문서 컨트롤",
          "intro_label3": "맞춤형 템플릿 및 조직 템플릿, 타사 통합을 포함한 고급 화이트보드 기능"
        },
        "translated_captions": {
          "features_tip": "원하는 언어로 자동 자막을 제공하여 글로벌 협업을 강화할 수 있습니다.",
          "intro_label1": "참가자는 자막을 직접 활성화하고 언어를 전환할 수 있습니다.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "지원되는 언어 보기"
        },
        "crc": {
          "features_tip": "효과적인 하이브리드 업무를 위해 모든 표준 기반 SIP/H.323 비디오 회의 엔드포인트를 지원합니다.",
          "intro_label1": "Polycom, Cisco, Lifesize 등과 같은 다수의 기존 엔드포인트에서 작업",
          "intro_label2": "클라우드 기반 온-프레미스(VM) 룸 커넥터"
        },
        "scheduler": {
          "simplify_bookings": "유연한 일정 설정과 맞춤형 시간대로 예약을 간편하게 관리할 수 있습니다.",
          "host_one_on_one": "링크 하나로 일대일 미팅, 그룹 회의를 주최하고 손쉽게 공유할 수 있습니다.",
          "customize_reminders": "이메일 또는 SMS 미리 알림 기능을 설정하여 일정을 놓치지 않도록 관리할 수 있습니다.",
          "sync_calendars": "Google, Microsoft 365, Zoom 통합으로 캘린더를 원활하게 동기화할 수 있습니다.",
          "features_tip": "근무 시간, 인터뷰 등을 위한 미팅 시간대를 손쉽게 공유하세요.",
          "intro_label1": "캘린더 통합",
          "intro_label2": "반복 사용 가능",
          "intro_label3": "확장 가능한 미팅",
          "intro_label4": "맞춤 가능한 알림",
          "intro_sub_label1": "Google, Microsoft 365 및 Zoom ",
          "intro_sub_label2": "s예약 가능한 시간대 공유 ",
          "intro_sub_label3": "한 명 또는 여러 명의 참가자를 위한 단일 미팅",
          "intro_sub_label4": "이메일 또는 SMS 미리 알림 및 확인 자동화"
        },
        "zoom_clips_plus": {
          "features_tip": "짧은 형식의 고품질 비디오 메시지를 녹화, 편집 및 공유하세요.",
          "intro_label1": "시간 제한 없이 비디오를 무제한으로 생성",
          "intro_label2": "화면과 동영상을 함께 또는 별도로 캡처",
          "intro_label3": "필요에 따라 비디오를 자르고 링크 공유",
          "intro_label4": "오디오 스크립트 및 통계와 같은 고급 기능에 액세스",
          "explain_desc": "Clips Plus is included in Workplace Pro, Business, and Enterprise subscriptions. You can explore the different features of each plan in the comparison section on the pricing page."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "여러 트랙으로 여러 날에 걸친 가상 이벤트 구성",
          "events_feature_item2_20240827": "참석자 프로필 및 로비 채팅을 통한 네트워킹 촉진",
          "events_feature_item3_20240827": "로비 세션 스트리밍으로 참석자에게 안내 제공",
          "events_feature_item4_20240827": "엑스포 플로어 및 스폰서십으로 이벤트 수익 증대",
          "events_feature_item5_20240827": "회의 후 설문조사를 통한 향후 이벤트 개선",
          "events_feature_item6_20240827": "엄선한 이벤트 템플릿으로 이벤트 설정 가속화",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "사용자 지정 배경 및 브랜딩 옵션으로 웨비나 수준 향상",
          "sessions_feature_item2_20240827": "AI Companion으로 생성한 메시징 및 이미지로 이벤트 계획 간소화",
          "sessions_feature_item3_20240827": "브랜딩된 콘텐츠 허브에서 이전 및 향후 이벤트 홍보",
          "sessions_feature_item4_20240827": "백스테이지, 시뮬라이브, 실시간 메시징 프로토콜(RTMP)로 전문적인 이벤트 운영",
          "sessions_feature_item5_20240827": "이벤트 전반의 인사이트를 통한 향후 웨비나 개선",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "월간 구독",
          "annual_subscription": "연간 구독",
          "one_million": "100만",
          "single_use": "일회성",
          "one_month": "1개월",
          "event_attendee": "Events/Sessions 참석자:",
          "event_attendee_desc": "허브에서 라이선스를 보유한 호스트가 아닌 상태로 참석하는 모든 사람을 의미합니다. 특수 역할도 참석자로 간주되며 오디오, 비디오, 화면 공유(활성화된 경우)를 통해 참여할 수 있습니다.",
          "webinar_attendee": "Webinars 참석자:",
          "webinar_attendee_desc": "호스트나 토론자를 제외한 모두를 의미합니다. 이들은 보기 전용 모드로 되어 있으며 호스트가 관리합니다. 호스트는 참석자의 음소거를 해제하고 Q&A와 채팅을 통해 상호작용을 활성화할 수 있습니다.",
          "pay_per_attendee": "참석자당 결제",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone 호주 및 뉴질랜드 무제한",
          "intro_label8_JP": "Zoom Phone 일본 무제한",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone 파워 팩",
          "features_tip": "콜센터 팀을 위한 향상된 통화 대기열 분석 및 기록 인사이트를 이용할 수 있습니다.",
          "intro_label1": "개선된 연락처 창으로 통화 처리 과정 간소화",
          "intro_label2": "자동 접수 교환원 및 통화 대기열 회선번호"
        },
        "international_calling": {
          "title": "국제 통화",
          "features_tip": "16개 이상의 국가 및 지역에서 무제한 국제 통화가 제공됩니다.",
          "intro_label1": "무제한 통화 요금제로 구매 가능",
          "intro_label2": "무제한 국제 전화가 지원되는 국가 및 지역 목록을 살펴보세요.",
          "intro_labe2_tooltip": "미국, 캐나다, 영국, 아일랜드, 호주, 뉴질랜드, 오스트리아, 덴마크, 프랑스, 독일, 이탈리아, 포르투갈, 스페인, 스웨덴, 벨기에, 네덜란드, 스위스, 푸에르토리코, 일본.",
          "intro_label2_view_list": "목록 보기"
        },
        "workspace_reservation": {
          "title": "작업 공간 예약",
          "intro_title": "Zoom 통합 장치로 유연한 작업 공간을 손쉽게 예약하고 호텔 객실을 사전에 또는 현장에서 예약하세요.",
          "intro_label1": "Zoom Workplace 앱, 데스크톱 또는 브라우저를 통해 작업 공간 및 호텔 예약",
          "intro_label2": "AI를 사용한 맞춤형 데스크 추천",
          "intro_label3": "Google 캘린더 또는 Outlook에서 바로 작업 공간을 예약하고 미리 알림과 체크인 알림 받기",
          "intro_label4": "길 찾기 기능을 사용하여 예약된 작업 공간으로 이동"
        },
        "visitor_management": {
          "title": "방문자 관리",
          "intro_title": "맞춤형 초대, 번거로움 없는 키오스크 체크인, 보고 및 지표를 통해 방문자 체크인 간소화",
          "intro_label1": "Zoom 포털에서 초대, 방문자 위치 및 방문 기록 관리",
          "intro_label2": "게스트 도착 알림을 받는 동안 초대 생성, 추적, 재전송 및 삭제",
          "intro_label3": "원활한 방문자 경험을 위해 키오스크를 통해 양식 작성, 길 찾기, 체크인",
          "intro_label4": "익숙한 Zoom 포털에서 모든 기능에 액세스하여 손쉽게 관리"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "대규모 회의",
          "description1": "미팅 허용 인원수를 늘려 실시간 대화형 참가자 수를 최대 1,000명까지 지원",
          "description2": "모든 참가자가 오디오, 비디오, 화면을 공유 가능"
        },
        "cloud_storage": {
          "title": "클라우드 저장소",
          "description2": "MP4 또는 M4A 파일 형식 사용 가능"
        },
        "translated_captions": {
          "title": "번역 자막",
          "description1": "참가자가 활성화하고 지원 언어로 전환할 수 있는 자동 다국어 자막을 통해 미팅의 질 향상",
          "description2": "참가자가 활성화하고 지원 언어로 전환할 수 있는 자동 다국어 자막을 통해 미팅의 질 향상"
        },
        "tollfree": {
          "title": "오디오 회의",
          "subcontent": "회선번호를 이용해 전 세계에서 미팅으로 전화 걸기",
          "description1": "통화 옵션을 콜아웃, 글로벌 수신자 부담, 프리미엄 국가 내 전화 걸기 기능으로 확장",
          "description2": "어떤 기기에서든 콜인한 참가자에게 요금 청구 안 함",
          "description3": "수신자 부담 전화 대상 국가를 한 개 이상 손쉽게 선택"
        },
        "rc": {
          "title": "회의실 커넥터"
        },
        "clips_plus": {
          "title": "클립 Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "아르헨티나",
        "Australia": "호주",
        "Austria": "오스트리아",
        "Belgium": "벨기에",
        "Brazil": "브라질",
        "Bulgaria": "불가리아",
        "Canada": "캐나다",
        "Chile": "칠레",
        "China": "중국",
        "Colombia": "콜롬비아",
        "Costa_Rica": "코스타리카",
        "Croatia": "크로아티아",
        "Cyprus": "키프로스",
        "Czech_Republic": "체코",
        "Denmark": "덴마크",
        "Ecuador": "에콰도르",
        "Estonia": "에스토니아",
        "Finland": "핀란드",
        "France": "프랑스",
        "Germany": "독일",
        "Greece": "그리스",
        "Hong_Kong_SAR": "홍콩 특별행정구",
        "Hungary": "헝가리",
        "Ireland": "아일랜드",
        "Israel": "이스라엘",
        "Italy": "이탈리아",
        "Japan": "일본",
        "Latvia": "라트비아",
        "Lithuania": "리투아니아",
        "Luxembourg": "룩셈부르크",
        "Mexico": "멕시코",
        "Netherlands": "네덜란드",
        "New_Zealand": "뉴질랜드",
        "Norway": "노르웨이",
        "Panama": "파나마",
        "Peru": "페루",
        "Poland": "폴란드",
        "Portugal": "포르투갈",
        "Puerto_Rico": "푸에르토리코",
        "Romania": "루마니아",
        "Singapore": "싱가포르",
        "Slovakia": "슬로바키아",
        "Slovenia": "슬로베니아",
        "South_Africa": "남아프리카공화국",
        "Spain": "스페인",
        "Sweden": "스웨덴",
        "Switzerland": "스위스",
        "UK": "영국",
        "United_Kingdom": "영국",
        "US": "미국",
        "United_States": "미국",
        "title": "전화번호 요구 사항",
        "subtitle": "글로벌 셀렉트 회선번호를 활성화할 국가를 선택하세요.",
        "selector_tip": "국가 선택",
        "local_and_toll_free": "{0}에서 지역 번호 및 수신자 부담 번호를 이용할 수 있습니다.",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "글로벌 셀렉트에는 하나의 회선번호와 무제한 국내 요금제 통화가 포함됩니다(라이선스당 선택한 국가 내).",
        "avail_title": "이용 가능한 국가/지역"
      },
      "tax_exempt_ecm": {
        "title": "면세 상태",
        "status_exempt": "면세",
        "status_exempt_question": "면세를 적용하시겠습니까?",
        "verify_now": "지금 확인하기",
        "can_after_checkout": "옵션으로 이 단계는 체크아웃 후에 완료할 수 있습니다.",
        "status": {
          "exempt": "제외",
          "pending": "보류 중",
          "pendingTooltip": "면세 상태를 현재 검토 중입니다. 주문 시 세금이 부과될 수 있습니다. 면제가 승인되면 환불 가능한 모든 세금 및 수수료가 계정으로 지급됩니다.",
          "nonexempt": "과세",
          "rejected": "거부됨",
          "rejectedTooltip": "제출된 문서는 귀하의 관할 구역 요구 사항을 충족하지 않는 것으로 확인되었습니다.",
          "approved": "승인됨",
          "default": "기본"
        },
        "confirm_close": {
          "new_desc": "확인을 취소하는 경우 관련 세금 및 수수료가 부과될 수 있습니다. 구매 후에도 청구 관리 섹션에서 면세 서류를 제출하면 Zoom의 검토 및 승인을 받을 수 있습니다. 확인이 완료되면 부과된 세금의 환불이 이루어집니다.",
          "desc": "면세 확인을 중단하고 과세 대상으로 진행하시겠습니까?",
          "title": "진행하시겠습니까?",
          "new_title": "면세 확인을 취소하시겠습니까?",
          "yes": "예, 중지합니다",
          "no": "아니요, 계속합니다",
          "abandon": "확인 취소",
          "go_back": "뒤로"
        },
        "confirm_to_add": {
          "title": "새로운 기본 면세 설정 확인",
          "message": "새 면제를 추가하면 승인 또는 거부 시 자동으로 기본값으로 설정됩니다. 기본 면제 혜택은 하나만 설정할 수 있으며, 이는 향후 구매에 적용됩니다. 기본 면제 설정이 '판매 대상' 주 또는 지역과 일치하지 않는 경우 세액이 영향을 받을 수 있습니다.",
          "yes": "새 면제 추가"
        },
        "confirm_set_default": {
          "title": "주소 및 면세 정보 불일치",
          "message": "판매 연락처' 주소가 면세를 위해 선택한 주 또는 지역과 일치하지 않습니다. 면세 위치와 일치하도록 '판매 연락처' 주소를 업데이트하세요. 업데이트하지 않으면 구매에 면세가 적용되지 않을 수 있습니다.",
          "yes": "계속 기본값으로 설정",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "주/지역",
          "exemption_type": "면제 유형",
          "signed_date": "서명일",
          "status": "상태",
          "add_exemption": "면제 추가",
          "view": "보기",
          "set_as_default": "기본값으로 설정"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "{planName} 요금제는 {date} 오전 12:00(협정 세계시 기준)에 취소됩니다. 취소 날짜가 지난 후에도 호스팅하려면 요금제를 다시 활성화하세요.",
        "pairPreDescTip": "{planName1} 요금제 및 {planName2} 요금제는 {date} 오전 12:00(협정 세계시 기준)에 취소됩니다. 취소 날짜가 지난 후에도 호스팅하려면 요금제를 다시 활성화하세요.",
        "pairDiffDatePreDescTip": "{planName1} 요금제와 {planName2} 요금제가 각각 협정 세계시 기준 {date1} 오전 12:00 및 {date2} 오전 12:00에 취소됩니다. 취소 날짜가 지난 후에도 호스팅하려면 요금제를 다시 활성화하세요.",
        "title": "계속하려면 요금제를 재활성화하세요.",
        "titles": "계속하려면 요금제를 다시 활성화하세요",
        "plan": "요금제",
        "licenses": "라이선스",
        "billingCycle": "청구 주기",
        "effective_date": "발효일",
        "invoice_amount": "청구 금액",
        "singleDescTip": "다시 활성화하면 정기결제 요금제가 {date}에 자동으로 갱신되며, 갱신 기간마다 등록된 결제 수단으로 요금이 청구된다는 데 동의하는 것입니다. 향후 요금이 청구되지 않도록 하려면 갱신일 전날까지 <a target=\"_blank\" href=\"https://support.zoom.com/hc/ko/article?id=zm_kb&sysparm_article=KB0066687\">취소</a>하세요.",
        "pairDescTip": "다시 활성화하면 정기결제 요금제가 {date}에 자동으로 갱신된다는 데 동의하는 것입니다. 갱신 기간마다 등록된 결제 수단으로 요금이 청구됩니다. 향후 요금이 청구되지 않도록 하려면 갱신일 전날까지 <a target=\"_blank\" href=\"https://support.zoom.com/hc/ko/article?id=zm_kb&sysparm_article=KB0066687\">취소</a>하세요.",
        "pairDiffDateDescTip": "다시 활성화하면 정기결제 요금제가 {date1} 및 {date2}에 자동으로 갱신된다는 데 동의하는 것입니다. 갱신 기간마다 등록된 결제 수단으로 요금이 청구됩니다. 향후 요금이 청구되지 않도록 하려면 갱신일 전날까지 <a target=\"_blank\" href=\"https://support.zoom.com/hc/ko/article?id=zm_kb&sysparm_article=KB0066687\">취소</a>하세요.",
        "totalLabel": "총계",
        "totalContent": "{money}, 관련 세금 추가",
        "taxDesc": "VAT, GST 또는 이와 유사한 성격의 세금 제외",
        "reactivateBtn": "계속 진행 및 재활성화",
        "switchTitle": "계속하려면 요금제를 업데이트하세요",
        "successSingleTip": "{planName} 요금제가 재활성화되었습니다.",
        "successPairTip": "{planName1} 및 {planName2} 요금제가 재활성화되었습니다.",
        "switchTip": "Zoom 1개월 Webinars 요금제가 {date}에 만료됩니다. 이 날짜 이후에 Webinars를 호스팅하려면 정기구독으로 전환해야 합니다.",
        "switchBtn": "구독으로 전환"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "비즈니스"
      },
      "proPlus": {
        "title": "Zoom Workplace 프로 플러스"
      },
      "bizPlus": {
        "title": "Zoom Workplace 비즈니스 플러스"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR 통제",
          "chat_etiquette": "채팅 에티켓",
          "enc_by_default": "기본 암호화"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "\uB370\uC774\uD130 \uC2DC\uD2B8 \uB2E4\uC6B4\uB85C\uB4DC"
      },
      "one": {
        "new": "신규"
      }
    },
    "webinarSetupInWebPortal": "웹 포털 내 웨비나 설정",
    "concurrentEvents": "동시 이벤트",
    "coucurrentEventsToolTip": "<span>한 번에 1개의 라이브 이벤트를 지원하는 <b>구독</b> 요금제",
    "overages": "초과 요금",
    "eventsPlatformHubs": "이벤트 플랫폼 허브",
    "eventsHubToolTip": "편리한 이벤트 정리 기능을 제공하는 Zoom Events <b>허브</b>",
    "1HubPerLicense": "라이선스당 1개 허브",
    "1000Hubs": "1,000개 허브",
    "eventsPlatformHosts_500AttendeesOrMore": "이벤트 플랫폼 호스트(참석자 500명 이상)",
    "eventsHost500": "<span>Zoom Events <b>허브 호스트</b>는 다음을 생성할 수 있습니다",
    "5HubHosts": "5명의 허브 호스트",
    "100HubHosts": "100명의 허브 호스트",
    "eventsPlatformHosts_100Attendees": "이벤트 플랫폼 호스트(참석자 100명)",
    "eventsHost100": "<span>Zoom Events <b>허브 호스트</b>는 다음을 생성할 수 있습니다",
    "2HubHosts": "2명의 허브 호스트",
    "howAreTheyDifferent": "차이점",
    "allPlansRequireAZoomOneLicense": "*모든 요금제에는 Zoom Workplace 라이선스가 필요합니다.",
    "subscription": "구독",
    "subscriptionToolTip": "<span><b>구독</b>을 이용하면 선택한 정원으로 무제한의 이벤트를 주최할 수 있습니다.</span>",
    "payPerAttendee": "참석자당 결제",
    "ppaToolTips": "<span><b>참석자당 결제</b> 라이선스에 따라 구매 후 12개월 동안 계정에서 개최되는 모든 이벤트에 참석할 수 있는 총 참석자 수가 결정됩니다.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "\uC124\uBB38\uC870\uC0AC",
    "meetings.fullPlanItem2": "\uB77C\uC774\uC120\uC2A4 \uAC1C\uC218",
    "meetings.fullPlanItem2Tip": "플랜에 따라 유료 라이선스나 기타 사용자 계정을 할당할 수 있는 사용자 수에 대한 특정 제한이 있습니다.",
    "phone.fullPlanItem30": "Zoom \uBBF8\uD305",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "어떠한 기기에서도 문제 없이 실행되는 간단한 비디오 회의 및 메시징",
    "meetings.fullPlanItem5": "\uBBF8\uD305 \uC9C4\uD589 \uC2DC\uAC04",
    "meetings.fullPlanItem5Tip": "\uADF8\uB8F9 \uBBF8\uD305\uBCC4(\uCC38\uAC00\uC790 3\uBA85 \uC774\uC0C1) \uD5C8\uC6A9\uB418\uB294 \uCD5C\uB300 \uAE30\uAC04.",
    "meetings.fullPlanItem5_basic": "40\uBD84",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30\uC2DC\uAC04",
    "meetings.fullPlanItem5_biz": "30\uC2DC\uAC04",
    "meetings.fullPlanItem5_ent": "30\uC2DC\uAC04",
    "meetings.fullPlanItem1": "\uCC38\uAC00\uC790 \uC218\uC6A9\uB825",
    "meetings.fullPlanItem1Tip": "\uCC38\uAC00\uC790\uB294 \uBBF8\uD305 \uB77C\uC774\uC120\uC2A4\uB97C \uAC00\uC9C4 \uB204\uAD70\uAC00\uAC00 \uC608\uC57D\uD55C \uBBF8\uD305\uC5D0 \uCD08\uB300\uBC1B\uC740 \uC0AC\uB78C\uC785\uB2C8\uB2E4. \uCC38\uAC00\uC790\uB294 \uC790\uC2E0\uC758 \uD734\uB300\uD3F0, \uB370\uC2A4\uD06C\uD1B1, \uBAA8\uBC14\uC77C \uAE30\uAE30 \uBC0F \uD0DC\uBE14\uB9BF \uAE30\uAE30\uC5D0\uC11C \uBB34\uB8CC\uB85C \uBBF8\uD305\uC5D0 \uCC38\uC5EC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uCC38\uAC00\uC790\uB294 Zoom \uACC4\uC815\uC774 \uC5C6\uC5B4\uB3C4 \uBBF8\uD305\uC5D0 \uCC38\uC5EC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uAC01 \uC694\uAE08\uC81C\uC5D0\uB294 \uCC38\uAC00\uC790 \uC81C\uD55C\uC774 \uC788\uC73C\uB098 \uC0AC\uC6A9\uC790\uB294 \uCD94\uAC00 \uAE30\uB2A5\uC744 \uAD6C\uB9E4\uD558\uC5EC \uC720\uB8CC \uC694\uAE08\uC81C\uC758 \uC81C\uD55C\uC744 \uD655\uB300\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*엔터프라이즈 플러스의 경우 1,000명</span>",
    "meetings.fullPlanItem7": "\uB179\uD654",
    "meetings.fullPlanItem7Tip": "Zoom \uB85C\uCEEC \uB179\uD654\uB294 MP4(\uBE44\uB514\uC624), M4A(\uC624\uB514\uC624), txt(\uCC44\uD305) \uD615\uC2DD\uC73C\uB85C \uBBF8\uD305 \uB179\uD654\uB97C \uC800\uC7A5\uD569\uB2C8\uB2E4.<br>Zoom \uD074\uB77C\uC6B0\uB4DC \uB179\uD654\uB294 Zoom \uD074\uB77C\uC6B0\uB4DC\uC5D0 \uBBF8\uD305\uC744 \uC800\uC7A5\uD558\uBA70 \uD074\uB77C\uC6B0\uB4DC\uC5D0\uC11C \uBE0C\uB77C\uC6B0\uC800\uB97C \uD1B5\uD574 \uD30C\uC77C\uC744 \uB2E4\uC6B4\uB85C\uB4DC \uBC0F/\uB610\uB294 \uC2A4\uD2B8\uB9AC\uBC0D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem7_basic": "\uB85C\uCEEC",
    "meetings.fullPlanItem7_pro": "\uB85C\uCEEC & 5 GB \uD074\uB77C\uC6B0\uB4DC(\uB77C\uC774\uC120\uC2A4\uB2F9)",
    "meetings.fullPlanItem7_biz": "\uB85C\uCEEC & 10 GB \uD074\uB77C\uC6B0\uB4DC(\uB77C\uC774\uC120\uC2A4\uB2F9)",
    "meetings.fullPlanItem7_ent": "\uB85C\uCEEC & \uBB34\uC81C\uD55C \uD074\uB77C\uC6B0\uB4DC",
    "one.messaging": "메시징",
    "meetings.fullPlanItem16Tip": "Chat\uB97C \uD1B5\uD574 \uADF8\uB8F9 \uD14D\uC2A4\uD2B8, \uD30C\uC77C, \uD654\uBA74 \uCEA1\uCC98, \uCF54\uB4DC \uC2A4\uB2C8\uD3AB, \uC74C\uC131 \uBA54\uC2DC\uC9C0, \uC774\uBBF8\uC9C0\uB97C \uAC04\uB2E8\uD558\uAC8C \uC804\uC1A1\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC0AC\uC6A9\uC790\uB294 \uD14D\uC2A4\uD2B8\uC5D0 \uC11C\uC2DD\uC744 \uC9C0\uC815\uD558\uAC70\uB098 GIF\uC640 \uC774\uBAA8\uD2F0\uCF58\uB3C4 \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uCC44\uD305 \uCC38\uAC00\uC790\uAC00 \uB370\uC2A4\uD06C\uD1B1 \uB610\uB294 \uBAA8\uBC14\uC77C \uAE30\uAE30\uC5D0\uC11C \uD65C\uC131 \uC0C1\uD0DC\uC778\uC9C0, \uBBF8\uD305 \uC911\uC778\uC9C0 \uBD80\uC7AC\uC911\uC778\uC9C0\uC758 \uC5EC\uBD80\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
    "meetings.fullPlanItem51": "Zoom \uD654\uC774\uD2B8\uBCF4\uB4DC",
    "meetings.unlimited": "\uBB34\uC81C\uD55C",
    "meetings.fullPlanItem_EssentialApp": "필수 앱",
    "common.learnMore": "\uB354 \uC54C\uC544\uBCF4\uAE30",
    "meetings.fullPlanItem_EssentialAppText": "프리미엄 앱 1년 무료 액세스(약관 적용)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom 앱의 Zoom 메일 및 캘린더",
    "mailService": "메일 서비스",
    "emailServiceWithFullTimeEndToEnd": "향상된 개인정보 보호를 위해 상시 엔드-투-엔드 암호화를 갖춘 이메일 서비스",
    "customMailDomain": "사용자 지정 메일 도메인",
    "customMailDomainWithMailService": "사용자 지정 메일 도메인 및 메일 서비스",
    "calendarClient": "캘린더 클라이언트",
    "scheduleAndJoinMeetings": "Zoom 앱에서 미팅을 예약하고 참여하세요.",
    "aiCompanion": "AI Companion",
    "calendarService": "캘린더 서비스",
    "meetingSchedulingAndAppointment": "미팅 예약 및 약속 잡기",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "짧은 형식의 비디오를 손쉽게 제작, 편집 및 공유할 수 있습니다. 저장된 클립을 쉽게 검색할 수 있어 참여도를 높일 수 있습니다.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "노트는 미팅 안팎에서 액세스할 수 있는 광범위한 서식 지정 옵션을 갖춘 강력한 개인 및 협업용 문서 편집기를 제공합니다.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "자동 회의 자막",
    "translatedCaptions-0": "번역 자막",
    "workspaceReservation": "작업 공간 예약",
    "accessAcrossAnyDevice": "어떤 기기에서나 액세스 가능",
    "meetings.fullPlanItem4": "\uBB34\uC81C\uD55C \uBBF8\uD305",
    "meetings.fullPlanItem9": "\uC804\uD654\uB85C \uCC38\uC5EC",
    "meetings.fullPlanItem9Tip": "\uC804\uD654 \uD68C\uC758/\uC624\uB514\uC624 \uD68C\uC758\uB97C \uD1B5\uD574 Zoom \uBBF8\uD305\uC5D0 \uCC38\uC5EC\uD569\uB2C8\uB2E4.(\uC804\uD1B5\uC801 \uC804\uD654 \uD65C\uC6A9) \uC0AC\uC6A9\uC790 \uC694\uAE08\uC740 \uC804\uD654 \uC694\uAE08\uC81C\uC5D0 \uB530\uB77C \uBD80\uACFC\uB429\uB2C8\uB2E4. \uC218\uC2E0\uC790 \uBD80\uB2F4 \uC804\uD654\uBC88\uD638\uC5D0 \uB300\uD55C \uC624\uB514\uC624 \uD68C\uC758 \uCD94\uAC00 \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD574 \uBCF4\uC2ED\uC2DC\uC624.",
    "meetings.fullPlanItem9_pro": "\uC694\uAE08 \uAE30\uBC18",
    "meetings.fullPlanItem9_biz": "\uC694\uAE08 \uAE30\uBC18",
    "meetings.fullPlanItem9_ent": "\uC694\uAE08 \uAE30\uBC18",
    "meetings.fullPlanItem11": "\uD654\uBA74 \uACF5\uC720",
    "meetings.fullPlanItem11Tip": "\uB370\uC2A4\uD06C\uD1B1 \uBC0F \uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uACF5\uC720. \uB77C\uC774\uC120\uC2A4 \uBCF4\uC720 \uBBF8\uD305 \uC0AC\uC6A9\uC790\uB294 \uD638\uC2A4\uD2B8\uD558\uB294 \uBBF8\uD305\uC5D0\uC11C \uC5EC\uB7EC \uCC38\uAC00\uC790\uAC00 \uD654\uBA74\uC744 \uB3D9\uC2DC\uC5D0 \uACF5\uC720\uD558\uB3C4\uB85D \uD5C8\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem12": "\uC18C\uD68C\uC758\uC2E4",
    "meetings.fullPlanItem12Tip": "\uBE44\uB514\uC624 \uC18C\uD68C\uC758\uC2E4\uC744 \uC0AC\uC6A9\uD558\uBA74 \uB17C\uC758 \uBC0F \uD504\uB85C\uC81D\uD2B8 \uB4F1\uC744 \uC704\uD574 Zoom \uBBF8\uD305\uC744 \uCD5C\uB300 50\uAC1C\uC758 \uBCC4\uB3C4 \uC138\uC158\uC73C\uB85C \uBD84\uB9AC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem14": "\uAC00\uC0C1 \uBC31\uADF8\uB77C\uC6B4\uB4DC",
    "meetings.fullPlanItem15": "\uAC1C\uC778 \uBBF8\uD305 ID",
    "meetings.fullPlanItem15Tip": "\uC790\uC2E0\uB9CC\uC758 \uC601\uAD6C\uC801 \uC628\uB77C\uC778 \uBBF8\uD305\uB8F8\uC744 \uB9CC\uB4E4\uC5B4 \uBCF4\uC2ED\uC2DC\uC624. \uC5B8\uC81C\uB4E0\uC9C0 \uBBF8\uD305\uC744 \uC2DC\uC791\uD558\uAC70\uB098 \uD5A5\uD6C4 \uC0AC\uC6A9\uC744 \uC704\uD574 \uC608\uC57D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem17": "\uD638\uC2A4\uD2B8 \uCEE8\uD2B8\uB864",
    "meetings.fullPlanItem18": "\uD654\uBA74 \uACF5\uC720\uC5D0\uC11C \uACF5\uB3D9 \uC8FC\uC11D \uB2EC\uAE30",
    "meetings.fullPlanItem19": "\uC6D0\uACA9 \uD0A4\uBCF4\uB4DC & \uB9C8\uC6B0\uC2A4 \uCEE8\uD2B8\uB864",
    "meetings.fullPlanItem21": "\uB2E4\uC911 \uACF5\uC720",
    "meetings.fullPlanItem29": "\uB300\uAE30\uC2E4",
    "meetings.fullPlanItem29Tip": "\uD638\uC2A4\uD2B8\uB294 \uB300\uAE30\uC2E4 \uAE30\uB2A5\uC744 \uD1B5\uD574 \uCC38\uAC00\uC790\uAC00 \uBBF8\uD305\uC5D0 \uCC38\uC5EC\uD560 \uB54C  \uC81C\uC5B4\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4. \uBBF8\uD305 \uD638\uC2A4\uD2B8\uB294 \uCC38\uC11D\uC790\uB97C \uAC1C\uC778\uBCC4\uB85C \uB610\uB294 \uC77C\uC2DC\uC5D0 \uBAA8\uB450 \uC785\uC7A5 \uC218\uB77D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC790\uB3D9\uC73C\uB85C \uC785\uC7A5\uC774 \uD5C8\uC6A9\uB418\uB294 \uC0AC\uB78C\uACFC \uB300\uAE30\uC2E4\uC744 \uAC70\uCCD0\uC57C \uD558\uB294 \uC0AC\uB78C\uC744 \uC124\uC815\uC5D0\uC11C \uC120\uD0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uBAA8\uB4E0 \uACC4\uC815\uC740 \uB300\uAE30\uC2E4 \uAE30\uB2A5\uC744 \uAC16\uCDAB\uACE0 \uC788\uC2B5\uB2C8\uB2E4. \uD638\uC2A4\uD2B8\uB294 \uB300\uAE30\uC2E4\uC5D0 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0BC \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC720\uB8CC \uC694\uAE08\uC81C\uB97C \uC0AC\uC6A9\uD558\uB294 \uACBD\uC6B0 \uB300\uAE30\uC2E4\uC744 \uC0AC\uC6A9\uC790 \uC9C0\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem41": "\uAE30\uBCF8 \uC81C\uACF5 Zoom for Home \uAE30\uAE30",
    "meetings.fullPlanItem61": "\uC5EC\uB7EC \uC0AC\uB78C \uACE0\uC815\uD558\uAE30",
    "meetings.fullPlanItem61Tip": "\uD638\uC2A4\uD2B8\uB294 \uCD5C\uB300 9\uBA85\uAE4C\uC9C0 \uBE44\uB514\uC624\uB97C \uACE0\uC815\uD558\uC5EC \uB9DE\uCDA4 \uBCF4\uAE30\uB97C \uC0DD\uC131\uD558\uB3C4\uB85D \uD5C8\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uADF8\uB807\uAC8C \uD558\uBA74 \uC5B4\uB5A4 \uC0AC\uB78C\uC774 \uB9D0\uC744 \uD558\uACE0 \uC788\uB354\uB77C\uB3C4 \uACE0\uC815\uB41C \uBE44\uB514\uC624\uAC00 \uACC4\uC18D \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
    "meetings.fullPlanItem62": "\uC5EC\uB7EC \uC0AC\uB78C\uC5D0\uAC8C \uC2A4\uD3EC\uD2B8\uB77C\uC774\uD2B8 \uC8FC\uAE30",
    "meetings.fullPlanItem62Tip": "\uD638\uC2A4\uD2B8\uB294 \uCD5C\uB300 9\uBA85\uC758 \uCC38\uC11D\uC790\uC5D0\uAC8C \uC2A4\uD3EC\uD2B8\uB77C\uC774\uD2B8\uB97C \uC904 \uC218 \uC788\uC73C\uBA70 \uD654\uC790\uAC00 \uB204\uAD6C\uC774\uB358\uC9C0 \uAC04\uC5D0 \uC804\uCCB4 \uBBF8\uD305\uC740 \uC2A4\uD3EC\uD2B8\uB77C\uC774\uD2B8\uB41C \uBE44\uB514\uC624\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanNewItem1": "\uD544\uD130",
    "meetings.fullPlanNewItem1Tip": "\uC7AC\uBBF8\uC788\uB294 \uCEEC\uB7EC \uD544\uD130\uB098 \uB3D9\uBB3C \uC2A4\uD2F0\uCEE4 \uC7A5\uC2DD\uC744 \uB354\uD574 \uD574\uD53C\uC544\uC6CC \uBC0F \uD30C\uD2F0 \uB4F1\uC5D0 \uC990\uAC70\uC6C0\uC744 \uB354\uD574\uBCF4\uC138\uC694.",
    "meetings.fullPlanNewItem2": "\uC124\uBB38\uC870\uC0AC",
    "meetings.fullPlanNewItem3": "\uACF5\uB3D9 \uD638\uC2A4\uD2B8 & \uB300\uCCB4 \uD638\uC2A4\uD2B8",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Zoom \uBBF8\uD305\uC758 \uACF5\uB3D9 \uD638\uC2A4\uD2B8 \uCEE8\uD2B8\uB864\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.</a>",
    "meetings.fullPlanItem24": "\uBBF8\uD305 \uC2A4\uCF00\uC904\uB7EC \uD560\uB2F9",
    "meetings.fullPlanItem24Tip": "\uB2E4\uB978 \uC0AC\uB78C\uC774 \uC5EC\uB7EC\uBD84\uC758 \uBBF8\uD305\uC744 \uB300\uC2E0 \uC124\uC815\uD558\uB3C4\uB85D \uD560\uB2F9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uD560\uB2F9\uB41C \uC0AC\uC6A9\uC790\uB3C4 \uD504\uB85C \uC694\uAE08\uC81C\uB97C \uBCF4\uC720\uD558\uACE0 \uC788\uC5B4\uC57C \uD569\uB2C8\uB2E4.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "\uACC4\uC815 \uC18C\uC720\uC790, \uAD00\uB9AC\uC790, \uADC0\uD558\uC758 \uAC1C\uBC1C\uC790\uAC00 Zoom REST API\uC5D0 \uC548\uC804\uD558\uAC8C \uC811\uADFC\uD558\uB3C4\uB85D \uD569\uB2C8\uB2E4. API \uC0AC\uC6A9\uBE48\uB3C4 \uC81C\uD55C\uC740 \uACC4\uC815 \uC720\uD615(\uD504\uB85C, \uBE44\uC988\uB2C8\uC2A4, \uC5D4\uD130\uD504\uB77C\uC774\uC988 \uB4F1) \uBC0F API \uC694\uCCAD \uC720\uD615(\uB77C\uC774\uD2B8, \uBBF8\uB514\uC5C4, \uD5E4\uBE44 \uB4F1)\uC5D0 \uB530\uB77C \uACC4\uC815 \uC218\uC900\uC5D0\uC11C \uC801\uC6A9\uB429\uB2C8\uB2E4. \uC77C\uBD80 API\uB294 \uD2B9\uC815 \uACC4\uC815 \uC720\uD615\uC5D0 \uB300\uD574 \uC561\uC138\uC2A4\uAC00 \uC81C\uD55C\uB429\uB2C8\uB2E4. API \uC0AC\uC6A9\uBE48\uB3C4 \uC81C\uD55C & API \uCC38\uC870 \uBB38\uC11C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0C1\uC138\uD55C \uC0AC\uD56D\uC744 \uD655\uC778\uD558\uC2ED\uC2DC\uC624.",
    "meetings.fullPlanItem25_pro": "\uD504\uB85C REST API \uC0AC\uC6A9\uBE48\uB3C4 \uC81C\uD55C",
    "meetings.fullPlanItem25_biz": "REST API \uC0AC\uC6A9\uBE48\uB3C4 \uC81C\uD55C",
    "meetings.fullPlanItem26": "Skype for Business(Lync) \uC0C1\uD638\uC6B4\uC6A9\uC131",
    "meetings.fullPlanItem26Tip": "Lync 2010, Lync 2013 \uC0AC\uC6A9\uC790\uC640 Skype for Business \uC0AC\uC6A9\uC790\uAC00 Lync \uC5F0\uB77D\uCC98 \uBAA9\uB85D\uC73C\uB85C Zoom \uBBF8\uD305\uC744 \uC2DC\uC791\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem27": "\uC2A4\uD2B8\uB9AC\uBC0D",
    "meetings.fullPlanItem27Tip": "Facebook, Youtube \uB610\uB294 \uC81C3\uC790 \uC11C\uBE44\uC2A4\uB85C \uB77C\uC774\uBE0C \uC2A4\uD2B8\uB9AC\uBC0D \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
    "meetings.fullPlanItem28": "\uBCF4\uACE0",
    "meetings.fullPlanItem28Tip": "\uD654\uC774\uD2B8\uBCF4\uB4DC \uC138\uC158 \uC800\uC7A5",
    "meetings.fullPlanItem30": "\uC0AC\uC6A9\uC790 \uAD00\uB9AC",
    "meetings.fullPlanItem30Tip": "\uC18C\uC720\uC790\uC640 \uAD00\uB9AC\uC790\uB294 \uC0AC\uC6A9\uC790 \uCD94\uAC00, \uC0AD\uC81C, \uC5ED\uD560 \uD560\uB2F9, \uCD94\uAC00 \uAE30\uB2A5 \uC0AC\uC6A9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
    "one.autoCaptions": "자동 자막",
    "meetings.fullPlanItem31": "\uAD00\uB9AC\uC790 \uD3EC\uD138",
    "meetings.fullPlanItem31Tip": "\uD558\uB098\uC758 \uACC4\uC815\uC73C\uB85C \uD68C\uC0AC\uC758 \uBAA8\uB4E0 \uC0AC\uC6A9\uC790\uB97C \uAD00\uB9AC\uD558\uACE0 \uCCAD\uAD6C \uAC04\uC18C\uD654, \uACE0\uAE09 \uC0AC\uC6A9\uC790 \uAD00\uB9AC \uC124\uC815, \uD3EC\uAD04\uC801\uC778 \uC0AC\uC6A9\uB7C9\uC5D0 \uB300\uD55C \uC778\uC0AC\uC774\uD2B8\uB97C \uBAA8\uB450 Zoom \uAD00\uB9AC\uC790 \uD3EC\uD138\uC5D0\uC11C \uB204\uB824\uBCF4\uC138\uC694.",
    "meetings.fullPlanItem32": "\uD559\uC2B5 \uB3C4\uAD6C \uC0C1\uD638\uC6B4\uC6A9\uC131 \uD1B5\uD569",
    "meetings.fullPlanItem32Tip": "\uBAA8\uB4E0 \uACFC\uC815 \uD65C\uB3D9\uC5D0 \uBBF8\uD305\uC744 \uC190\uC27D\uAC8C \uCD94\uAC00\uD558\uACE0 \uD559\uC2B5 \uAD00\uB9AC \uC2DC\uC2A4\uD15C(Moodle, Canvas, Desire2Learn, Blackboard\uC640 \uD638\uD658)\uC5D0 \uD574\uB2F9 \uD559\uC0DD\uC744 \uCD08\uB300\uD569\uB2C8\uB2E4.",
    "meetings.fullPlanItem33": "\uD074\uB77C\uC6B0\uB4DC \uB179\uD654 \uD2B8\uB79C\uC2A4\uD06C\uB9BD\uD2B8",
    "meetings.fullPlanItem33Tip": "\uD074\uB77C\uC6B0\uB4DC \uB179\uD654 \uD2B8\uB79C\uC2A4\uD06C\uB9BD\uD2B8\uB294 \uADC0\uD558\uAC00 \uD074\uB77C\uC6B0\uB4DC\uC5D0 \uB179\uD654\uD558\uB294 \uBBF8\uD305 \uB610\uB294 \uC6F9 \uC138\uBBF8\uB098\uC758 \uC624\uB514\uC624\uB97C \uC804\uC0AC\uD558\uB294 \uC624\uB514\uC624 \uD2B8\uB79C\uC2A4\uD06C\uB9BD\uD2B8\uC785\uB2C8\uB2E4. \uD604\uC7AC\uB294 \uC601\uC5B4\uB9CC \uC9C0\uC6D0\uD569\uB2C8\uB2E4. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\uC5EC\uAE30\uB97C \uD074\uB9AD</a>\uD558\uC5EC \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.",
    "meetings.fullPlanItem34": "\uBE0C\uB79C\uB529",
    "meetings.fullPlanItem34Tip": "\uD68C\uC0AC\uC758 \uBE0C\uB79C\uB529\uC744 \uC790\uC2E0\uB9CC\uC758 \uB9DE\uCDA4 \uD398\uC774\uC9C0\uC5D0 \uCD94\uAC00\uD558\uC138\uC694. \uC0AC\uC6A9\uC790\uB294 \uD574\uB2F9 \uD398\uC774\uC9C0\uC5D0\uC11C \uBBF8\uD305\uC5D0 \uCC38\uC5EC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uBE0C\uB79C\uB4DC \uC774\uBA54\uC77C \uD15C\uD50C\uB9BF\uC744 \uB9CC\uB4E4\uACE0 \uCC38\uC11D\uC790\uC5D0\uAC8C \uCD08\uB300\uB97C \uBCF4\uB0B4\uBCF4\uC138\uC694.",
    "meetings.fullPlanItem35": "\uAD00\uB9AC\uD558\uACE0 \uC788\uB294 \uB3C4\uBA54\uC778",
    "meetings.fullPlanItem35Tip": "\uD68C\uC0AC/\uB300\uD559 \uC774\uBA54\uC77C \uC8FC\uC18C \uB3C4\uBA54\uC778\uC744 \uC0AC\uC6A9\uD558\uC5EC \uACC4\uC815\uC5D0 \uC0AC\uC6A9\uC790\uB97C \uC790\uB3D9\uC73C\uB85C \uCD94\uAC00\uD558\uC2ED\uC2DC\uC624.",
    "meetings.fullPlanItem37": "\uC5B8\uC5B4 \uD1B5\uC5ED",
    "meetings.fullPlanItem37Tip": "\uBBF8\uD305 \uD638\uC2A4\uD2B8\uAC00 \uBBF8\uD305\uACFC \uC6F9 \uC138\uBBF8\uB098\uC5D0 \uD1B5\uC5ED\uAC00\uB97C \uC9C0\uC815\uD558\uB3C4\uB85D \uD5C8\uC6A9\uD569\uB2C8\uB2E4. \uBBF8\uD305\uC774\uB098 \uC6F9 \uC138\uBBF8\uB098\uAC00 \uC2DC\uC791\uB418\uBA74 \uBBF8\uD305 \uD638\uC2A4\uD2B8\uAC00 \uD1B5\uC5ED \uAE30\uB2A5\uC744 \uC2DC\uC791\uD560 \uC218 \uC788\uACE0, \uC774\uB54C \uD1B5\uC5ED\uAC00\uB294 \uBCF8\uC778\uC758 \uC624\uB514\uC624 \uCC44\uB110\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uCC38\uC11D\uC790\uB294 \uD558\uB098\uC758 \uC5B8\uC5B4 \uCC44\uB110\uC744 \uC120\uD0DD\uD558\uACE0 \uC6D0\uD558\uB294 \uC5B8\uC5B4\uB97C \uCCAD\uCDE8\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC120\uD0DD\uC5D0 \uB530\uB77C\uC11C \uD1B5\uC5ED \uC74C\uC131\uACFC \uD568\uAED8 \uB0AE\uC740 \uBCFC\uB968\uC73C\uB85C \uC6D0\uC74C\uC744 \uCCAD\uCDE8\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem39": "\uC784\uC6D0\uAE09 \uBE44\uC988\uB2C8\uC2A4 \uAC80\uD1A0",
    "meetings.fullPlanItem39Tip": "\uC0C1\uC138\uD55C \uD2B8\uB80C\uB4DC \uB3C4\uC785 \uBD84\uC11D, \uD22C\uC790 \uC218\uC775\uB960 \uCD94\uC801, \uC81C\uD488 \uB85C\uB4DC\uB9F5 \uB17C\uC758.",
    "meetings.fullPlanNewItem4": "Webinar 500\uD3EC\uD568",
    "one.translatedCations": "번역 자막",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "1:1 채팅, 채널 채팅 또는 그룹 채팅",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "1:1 메시지, 소규모 그룹 또는 대규모 팀과 쉽게 소통",
    "messageAndFileHistory": "메시지 및 파일 기록",
    "findPeopeChannelsAndFilesInSearch": "검색할 사용자, 채널, 파일 찾기",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "연락처, 인스턴트 메시지, 그룹 채팅 및 파일을 빠르게 찾을 수 있어 지식과 정보를 손쉽게 사용할 수 있습니다.",
    "applicationIntegrations": "애플리케이션 통합",
    "secureFileSharing": "안전한 파일 공유",
    "enhanceCollaborationWithSeamlessFileSharing": "원활하게 파일을 공유하여 협업 강화",
    "persistentMeetingChat": "영구 미팅 채팅",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "미팅 대화를 놓치지 마세요. 모든 미팅 참가자를 위한 Zoom Team Chat의 전용 그룹 채팅에서 미팅 전, 중, 후에 소통합니다.",
    "cloudStorage": "클라우드 저장소",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Zoom 클라우드 또는 타사 스토리지 공급자로 채널 백업",
    "avatars": "아바타",
    "inMeetingReactions": "미팅 중 반응",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "참여도를 표시하고 비언어적 방법으로 다른 참가자와 빠르게 소통하기",
    "virtualBackgrounds": "가상 배경",
    "videoFilters": "비디오 필터",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "비디오에 오버레이된 다양한 필터로 미팅에 재미를 더하기",
    "inMeetingPollsAndQuizzes": "미팅 중 설문조사 및 퀴즈",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "미팅에서 단일 선택 또는 다중 선택 설문조사 질문 만들기",
    "liveStreamingAcrossPlatforms": "플랫폼 간 라이브 스트리밍",
    "appearanceTouchUp": "모습 수정",
    "originalSoundForMusicians": "뮤지션을 위한 오리지널 사운드",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings에 대한 엔드-투-엔드 암호화",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Zoom Meetings의 엔드-투-엔드 암호화(E2EE)를 활성화하면 특정 미팅에서 Zoom Client를 사용하는 모든 참가자 간에 이루어지는 커뮤니케이션이 해당 참가자의 기기만 알고 있는 암호화 키를 사용하여 암호화됩니다. 즉, Zoom을 포함하여 그 어떤 제3자도 미팅의 비공개 키에 액세스할 수 없습니다.",
    "zoomCustomerManagedKey": "보안 키 직접 관리",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "자체 암호화 키를 가져와 미사용 Zoom 데이터를 보호하세요",
    "enterpriseGradeSecurityFeatures": "엔터프라이즈급 보안 기능",
    "256BitAesGcmEncryptionForRealTimeContent": "실시간 콘텐츠 및 미디어에 대해 256비트 AES-GCM 암호화, 세션 초기화 프로토콜 등록 중 전송 계층 보안 암호화, 발신자 ID 마스킹, 사설 네트워크 피어링, 도구 사기 탐지 및 통화 차단 목록",
    "phone.fullPlanItem40": "\uBCF4\uC548 \uBCF4\uC7A5 \uC0DD\uC131 \uC5B8\uC5B4 2.0\uC744 \uD1B5\uD55C \uC2F1\uAE00 \uC0AC\uC778\uC628",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "\uBB34\uC81C\uD55C \uB0B4\uBD80 \uD1B5\uD654",
    "phone.fullPlanItem2": "\uC720\uB8CC \uBC1C\uC2E0 \uD1B5\uD654",
    "phone.fullPlanItem3": "\uBB34\uC81C\uD55C \uBC1C\uC2E0 \uD1B5\uD654",
    "phone.fullPlanItem4": "\uC5C5\uACC4 \uCD5C\uACE0 \uC218\uC900\uC758 HD \uD1B5\uD654 \uD488\uC9C8",
    "phone.fullPlanItem4Tip": "\uC561\uD2F0\uBE0C \uB178\uC774\uC988 \uCE94\uC2AC, \uC5D0\uCF54 \uCE94\uC2AC, \uD0A4\uBCF4\uB4DC \uD0C0\uC774\uD551 \uC5B5\uC81C \uAE30\uB2A5",
    "phone.fullPlanItem5": "\uB124\uC774\uD2F0\uBE0C Windows, MacOS, Linux \uB370\uC2A4\uD06C\uD1B1 \uC571",
    "phone.fullPlanItem6": "iOS \uBC0F Android\uC758 \uB124\uC774\uD2F0\uBE0C \uBAA8\uBC14\uC77C \uC571",
    "phone.fullPlanItem7": "\uAE30\uC874 \uBC88\uD638\uB97C \uBCF5\uC0AC\uD558\uAC70\uB098 \uC2E0\uADDC \uBC88\uD638 \uAD6C\uB9E4(DID)",
    "phone.fullPlanItem8": "\uC218\uC2E0\uC790 \uBD80\uB2F4 \uBC88\uD638",
    "phone.fullPlanItem9": "\uB0B4\uC120\uBC88\uD638",
    "phone.fullPlanItem10": "\uC74C\uC131\uBA54\uC77C\uACFC \uD2B8\uB79C\uC2A4\uD06C\uB9BD\uC158",
    "phone.fullPlanItem10Tip": "\uBAA8\uBC14\uC77C/\uB370\uC2A4\uD06C\uD1B1 \uC571\uACFC \uC774\uBA54\uC77C\uC744 \uD1B5\uD55C \uC74C\uC131\uBA54\uC77C \uD2B8\uB79C\uC2A4\uD06C\uB9BD\uD2B8 \uC561\uC138\uC2A4",
    "phone.fullPlanItem11": "\uBB34\uC81C\uD55C \uC790\uB3D9 \uCC38\uC11D\uC790/IVR",
    "phone.fullPlanItem12": "\uC774\uB984 \uC804\uD654\uBC88\uD638\uBD80\uB97C \uC0AC\uC6A9\uD558\uC5EC \uBC1C\uC2E0",
    "phone.fullPlanItem13": "\uC790\uB3D9 \uD1B5\uD654 \uBD84\uBC30 \uADF8\uB8F9(ACD) \uBC0F \uD1B5\uD654 \uB300\uAE30\uC5F4",
    "phone.fullPlanItem14": "\uBC14\uC9C0\uCF5C/\uBAA8\uB2C8\uD130\uB9C1/\uC704\uC2A4\uD37C/\uC804\uD654\uBC1B\uAE30",
    "phone.fullPlanItem15": "\uC5F0\uD734 \uBC0F \uC5C5\uBB34 \uC2DC\uAC04 \uB77C\uC6B0\uD305",
    "phone.fullPlanItem16": "3\uC790\uAC04 \uC784\uC2DC \uD68C\uC758 \uD1B5\uD654",
    "phone.fullPlanItem17": "\uD1B5\uD654 \uB179\uC74C",
    "phone.fullPlanItem17Tip": "\uD1B5\uD654\uB97C \uC790\uB3D9 \uB610\uB294 \uC218\uB3D9\uC73C\uB85C \uB179\uC74C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "phone.fullPlanItem18": "\uC775\uBA85 \uD1B5\uD654 \uCC28\uB2E8 \uBC0F \uC9C0\uC815 \uD1B5\uD654 \uCC28\uB2E8 \uAD6C\uC131 \uAC00\uB2A5",
    "phone.fullPlanItem19": "\uAE34\uAE09 \uD1B5\uD654",
    "phone.fullPlanItem19Tip": "\uC9C0\uC5ED \uAE34\uAE09 \uC11C\uBE44\uC2A4\uC5D0 \uC804\uD654\uAC78\uAE30",
    "phone.fullPlanItem20": "\uC774\uB3D9\uC2DD E911 \uC9C0\uC815(\uBBF8\uAD6D \uBC0F \uCE90\uB098\uB2E4) -",
    "phone.fullPlanItem20Tip": "\uC0AC\uC6A9\uC790 \uC704\uCE58\uB97C \uB3D9\uC801\uC73C\uB85C \uD0D0\uC9C0\uD558\uACE0 \uC9C0\uC5ED \uAE34\uAE09 \uC11C\uBE44\uC2A4(\uBBF8\uAD6D \uBC0F \uCE90\uB098\uB2E4 \uC804\uC6A9)\uC640 \uB0B4\uBD80 \uC548\uC804\uD300\uC5D0 \uD574\uB2F9\uD558\uB294 \uAE34\uAE09 \uC8FC\uC18C\uB97C \uBCF4\uACE0\uD569\uB2C8\uB2E4.",
    "phone.fullPlanItem21": "\uBE44\uC0C1 \uB300\uC751 \uC13C\uD130",
    "phone.fullPlanItem21Tip": "\uB0B4\uBD80 \uC548\uC804\uD300\uC5D0 \uBE44\uC0C1 \uD1B5\uD654 \uACBD\uACE0\uAC00 \uC804\uB2EC\uB418\uB3C4\uB85D \uD65C\uC131\uD654\uD558\uACE0 \uB300\uC751\uC744 \uC9C0\uC6D0\uD558\uAE30 \uC704\uD574 \uBE44\uC0C1 \uD1B5\uD654\uB97C \uAE30\uB85D/\uBAA8\uB2C8\uD130\uB9C1/\uBC14\uC9C0\uCF5C\uD569\uB2C8\uB2E4.",
    "phone.fullPlanItem22": "\uACF5\uC720 \uB77C\uC778 \uD45C\uC2DC/\uC704\uC784",
    "phone.fullPlanItem23": "\uAE30\uAE30 \uAC04 \uD1B5\uD654 \uC804\uB2EC",
    "phone.fullPlanItem24": "\uD1B5\uD654 \uB300\uAE30",
    "endToEndEncryptionForZoomPhone": "Zoom Phone에 대한 엔드-투-엔드 암호화",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Zoom Phone의 엔드-투-엔드 암호화(E2EE)를 활성화하면 발신자와 수신자의 기기만 알고 있는 암호화 키를 사용하여 통화가 암호화됩니다. 또한 사용자는 고유한 보안 코드를 서로에게 제공하여 E2EE 상태를 확인하는 옵션을 이용할 수 있습니다.",
    "phone.fullPlanItem43": "\uC804\uD654\uC758 \uC81C\uB85C\uD130\uCE58 \uD504\uB85C\uBE44\uC800\uB2DD",
    "phone.fullPlanItem44": "\uD55C \uACC4\uC815\uC5D0 \uC5EC\uB7EC \uC720\uD615\uC758 \uC694\uAE08\uC81C \uD63C\uD569",
    "phone.fullPlanItem46": "\uC2E4\uC2DC\uAC04 \uBCF4\uACE0 \uBC0F \uD488\uC9C8 \uB300\uC2DC\uBCF4\uB4DC",
    "phone.fullPlanItem47": "\uAC00\uC0C1 \uB370\uC2A4\uD06C\uD1B1(VDI) \uD658\uACBD \uC9C0\uC6D0",
    "phone.fullPlanItem47Tip": "VDI\uC5D0 \uB300\uD574 <a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30</a>",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "모든 독립형 전화 고객이 사용 가능합니다. 지원 요금제는 연결되는 미팅 요금제에 따라 달라집니다.",
    "phone.fullPlanItem49": "\uAE30\uC874 \uD1B5\uC2E0\uC0AC \uC0AC\uC6A9 \uC9C0\uC6D0",
    "phone.fullPlanItem49Tip": "\uAE30\uC874 \uACF5\uC911 \uAD50\uD658 \uC804\uD654\uB9DD \uC11C\uBE44\uC2A4 \uACF5\uAE09\uC790\uC5D0 \uC9C1\uC811 \uBC0F \uD504\uB808\uBBF8\uC2A4 \uAE30\uBC18 \uD53C\uC5B4\uB9C1 \uC9C0\uC6D0",
    "phone.fullPlanItem50": "\uAE30\uC874 PBX\uC5D0 \uB300\uD55C \uD558\uC774\uBE0C\uB9AC\uB4DC \uD1B5\uD569",
    "phone.fullPlanItem51": "무전기",
    "phone.fullPlanItem61": "온라인 팩스",
    "phone.fullPlanItem61Tip": "미국 및 캐나다 내에서 무제한으로 팩스를 주고받을 수 있습니다. 국제 팩스의 경우 <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">요금제 보기</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "\uBBF8\uAD6D & \uCE90\uB098\uB2E4 \uC804\uD654\uBC88\uD638\uB294 \uD1B5\uD654 \uC694\uAE08\uC81C\uB97C \uAD6C\uC785\uD560 \uACBD\uC6B0\uC5D0\uB9CC \uC0AC\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4. \uD68C\uC0AC \uBC88\uD638\uAC00 \uC544\uB2CC \uC9C1\uD1B5 \uC804\uD654\uB85C \uD65C\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "meetings.fullPlanItem6": "\uAE30\uC220 \uC9C0\uC6D0",
    "meetings.fullPlanItem6Tip": "다운타임을 줄이고 리스크를 최소화할 수 있도록 지원하는 Premier Support 패키지 이용 가능",
    "meetings.fullPlanItem6_basic": "\uD2F0\uCF13 \uC804\uC6A9",
    "meetings.fullPlanItem6_pro": "\uD2F0\uCF13 & \uB77C\uC774\uBE0C \uCC44\uD305",
    "meetings.fullPlanItem6_biz": "\uD2F0\uCF13, \uB77C\uC774\uBE0C \uCC44\uD305 & \uC804\uD654",
    "meetings.fullPlanItem6_ent": "\uD2F0\uCF13, \uB77C\uC774\uBE0C \uCC44\uD305 & \uC804\uD654",
    "knowledgeBase": "기술 자료",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Zoom의 기술 자료 문서를 검색하여 기술 문제를 해결하고 지원 리소스에 액세스하세요.",
    "zoomCommunity": "Zoom 커뮤니티",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "솔루션을 찾고, 질문하고, 다른 Zoom 사용자와 협업할 수 있는 공간입니다.",
    "chatbot": "챗봇",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "챗봇과의 대화를 통해 질문에 대한 답변을 얻고 기술 문제를 해결하세요.",
    "submitWebTickets": "웹 티켓 제출",
    "liveChatSupport": "라이브 채팅 지원",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "월 ${amount}(USD)보다 더 높은 구독 요금제",
    "livePhoneSupport": "라이브 전화 지원",
    "meetWithAgentOnVideo": "상담원과 비디오로 만나기",
    "subscriptionPlansGreaterThan_200UsdMonth": "월 $200(USD)보다 더 높은 구독 요금제",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Zoom Team Chat 내에서 바로 즐겨찾는 앱을 활용하여 생산성 향상",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "나만의 아바타를 사용자 지정하여 미팅에 재미를 더하고 비디오에 나오지 않고도 자신을 역동적으로 표현하기",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "메일",
    "common.plans.meeting.title": "회의",
    "plans.basic_free.upgrade.item1": "미팅당 최대 30시간",
    "common.statistics.participants": "참가자 {0}명",
    "common.per_meeting_unit": "미팅당",
    "common.participant_limit.increase_with_large_meetings": "대규모 회의에서 증가",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "화이트보드",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "무제한",
    "common.plans.team_chat.title": "팀 채팅",
    "common.plans.mail_calendar.title": "메일 및 캘린더",
    "common.plans.cloud_storage.title": "클라우드 저장소",
    "plans.bundle_credit.storage": "{0}GB",
    "plans.translation.title": "Zoom 번역 자막",
    "common.plans.extras.title": "기타",
    "common.plans.extras.desc": "회사 도메인 관리 등",
    "zoom_one_edu_bundle.school.title": "교육용 Zoom One 학교 및 캠퍼스",
    "zoom_one_edu_bundle.school_plus.title": "교육용 Zoom One 학교 및 캠퍼스 플러스",
    "per_billing_cycle_license.monthly": "/월/라이선스",
    "per_billing_cycle_license.yearly": "/연/라이선스",
    "per_billing_cycle_space.monthly": "/월/공간",
    "per_billing_cycle_space.yearly": "/년/공간",
    "common.dialog.feature_list": "모든 기능 목록 살펴보기",
    "detail_dialog.meeting_feature.cloud_recording.pro": "라이선스당 5GB",
    "detail_dialog.meeting_feature.cloud_recording.10": "라이선스당 10GB",
    "detail_dialog.meeting_feature.cloud_recording.ent": "엔터프라이즈 플러스에 무제한 요금제 포함",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + 회의실 커넥터(1:25 비율)",
    "plans.whiteboard.ent": "엔터프라이즈 플러스에 무제한 플러스 요금제 포함",
    "plans.zp.ent": "엔터프라이즈 플러스에 포함",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "고급 및 현장 작업 공간 예약 등",
    "plans.largeMeeting.intro_tip": "대규모 회의는 결제 시 옵션으로 추가할 수 있는 부가 기능입니다. 이 기능을 사용하면 구매한 라이선스에 따라 최대 500명 또는 1,000명의 참가자가 참여할 수 있는 회의를 주최할 수 있습니다.",
    "common.participant_limit.expandable_with_large_meetings": "대규모 회의로 확장 가능",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">엔터프라이즈 플러스의 경우 1,000명</span>",
    "plans.webinar": "Zoom 웨비나",
    "plans.webinar.ent": "엔터프라이즈 플러스에 세션 1000(웨비나 포함) 포함",
    "per_billing_cycle_user.monthly": "/월/사용자",
    "per_billing_cycle_user.annually": "/년/사용자",
    "closeComparisonChart": "비교 차트 닫기",
    "archiving_api": "아카이빙 API",
    "dlp_api": "DLP API",
    "info_barriers": "정보 장벽",
    "chat_etiquette": "채팅 에티켓",
    "gdrp": "GDPR",
    "regiona_data_centers": "지역 데이터 센터",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "암호화 기본 제공",
    "end_to_end_encryption": "엔드-투-엔드 암호화",
    "cryptographic_boundary": "암호화 경계",
    "vdi": "가상 데스크톱(VDI)",
    "customer_managed_key": "고객 관리형 키",
    "gpo_msi_policies": "GPO/MSI 정책",
    "msi": "대량 배포(MSI)",
    "ntt": "네트워크 테스트 도구(NTT)",
    "dashboards": "대시보드",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone 생존성",
    "zoom_meeting_survivability": "Zoom Meeting 생존성",
    "paid_option": "유료 옵션",
    "marketing.meet_with_agent_on_video_tooltip": "본 기능은 관리자만 사용 가능합니다",
    "marketing.live_phone_support_tooltip": "본 기능은 관리자만 사용 가능합니다",
    "fbc.common.core_features": "핵심 기능",
    "fbc.common.support": "기술 지원",
    "zoom_one_edu_bundle.school.brief_title": "학교 및 캠퍼스",
    "zoom_one_edu_bundle.school_plus.brief_title": "학교 및 캠퍼스 Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "nl-NL": {
    "billing.essential_apps": "Essentiële Apps",
    "billing.essential_apps.dialog_desc": "Beheer uw bedrijf en laat het groeien met apps die notities maken tijdens vergaderingen, uw team boeien met interactieve activiteiten en inzichten genereren om gesprekken met klanten te verbeteren. Gratis apps van topklasse gedurende 1 jaar inbegrepen bij uw abonnement.",
    "billing.see_more_details": "Bekijk meer informatie",
    "billing.essential_app.legal_copy": "Aanbieding alleen van toepassing voor gebruikers met een geldige licentie, op of na 4 januari 2023, voor een Zoom One Pro-, Zakelijk- of Zakelijk Plus-abonnement dat is gekocht via het online kanaal van Zoom op zoom.us/buy. Gebruikers van wie het abonnement is gekoppeld aan een Gezondheidszorg-, Onderwijs- of Overheidsaccount komen niet in aanmerking voor deze aanbieding.  Elke app, met uitzondering van Coda, is toegankelijk vanaf het moment dat de individuele gebruiker de app activeert. De toegang vervalt 1 jaar daarna. Coda is voor alle gebruikers van hetzelfde Zoom-account toegankelijk vanaf de eerste activering van Coda door een van de gebruikers van hetzelfde Zoom-account. De toegang tot Coda vervalt 1 jaar daarna voor alle gebruikers van dat Zoom-account, ongeacht de eerste datum van activering door andere gebruikers van hetzelfde Zoom-account.Voor alle apps geldt dat de hertoewijzing of annulering van een in aanmerking komende licentie of in aanmerking komend abonnement van een gebruiker tot gevolg heeft dat de toegang voor die gebruiker eindigt, ongeacht of de toegangsperiode van 1 jaar verstreken is.Voor elke app gelden eigen gebruiksvoorwaarden en een eigen privacybeleid, die beschikbaar zijn op het moment van activering.De inbegrepen apps zijn alleen in het Engels beschikbaar.Niet alle apps werken op mobiele apparaten.Aanbieding niet inwisselbaar of restitueerbaar voor contant geld.Aanbieding alleen geldig voor de apps die als Essentiële Apps zijn opgenomen in de <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>. Gebruikers met een bestaand abonnement op een of meer van de apps komen niet in aanmerking voor deze aanbieding wat betreft deze specifieke apps.Zoom behoudt zich het recht voor om deze aanbieding op elk moment te wijzigen of te annuleren, zonder voorafgaande kennisgeving en aansprakelijkheid.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Bezoekersbeheer"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24/7 live ondersteuning via chat en telefoon"
      },
      "learn_more": "Meer informatie",
      "new": "Nieuw",
      "plan_details": {
        "meeting": {
          "title": "Vergaderingen",
          "host_meeting_up_to_participants": "Host tot {0} deelnemers",
          "meeting_hours": "Rapat tanpa batas selama hingga 30 jam per rapat",
          "recording_storage": "{0} GB opslag voor cloudopnames (per licentie)",
          "auto_captions": "Automatische ondertitels"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} bewerkbare whiteboards",
          "standard_features": "Standaardfuncties"
        },
        "team_chat": {
          "title": "Teamchat",
          "desc": "Groepschat en bestanden delen"
        },
        "main_calendar": {
          "title": "Mail en Agenda",
          "desc": "Mail- en Agenda-client"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Creëer en deel bewerkbare documenten binnen Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Bewerk, deel en sla korte video's moeiteloos op",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Krijg snel toegang tot samenvattingen van vergaderingen, hulp bij het opstellen van berichten en meer"
        },
        "EssentialApp": {
          "title": "Essentiële Apps",
          "desc1": "Gratis apps van topklasse voor 1 jaar (er gelden voorwaarden)",
          "desc2": "Verbeter de samenwerking en productiviteit van uw team"
        },
        "livechat": {
          "title": "Ondersteuning via livechat"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Overstappen naar Zoom Workplace Pro?",
            "content": "Je hebt eerder Zoom Workplace Zakelijk geselecteerd, waarmee je met maximaal 300 personen kunt vergaderen, beschikt over Zoom Scheduler en meer. Wil je toch overstappen naar Pro?",
            "confirm": "Wijziging bevestigen",
            "keep_current": "Huidig abonnement behouden"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} deelnemers",
          "participants": "{0} Deelnemers",
          "user_range": "{0}-{1} gebruikers",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Toevoegen",
          "buy_now": "Nu kopen",
          "try_for_days": "Probeer {0} dagen lang",
          "contact_sales": "Neem contact op met verkoop",
          "close": "Sluiten",
          "cancel": "Annuleren",
          "edit": "Bewerken",
          "got_it": "Begrepen"
        },
        "title": {
          "everything_in_and": "Inbegrepen bij {0} en:"
        },
        "tag": {
          "new": "Nieuw",
          "free_trial": "Gratis proefversie"
        },
        "billing_cycle": {
          "annual": "Jaarlijks",
          "monthly": "Maandelijks",
          "quarterly": "Per kwartaal",
          "two_years": "Twee jaar",
          "three_years": "Drie jaar"
        },
        "errors": {
          "unknown_error_try_again": "Onbekende fout bij het verwerken van de transactie. Probeer het later opnieuw."
        },
        "excluding_tax": {
          "vat_tip": "exclusief btw",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Beperkte functies",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host tot {0} deelnemers",
          "gb_of_cloud_recording_storage": "{0} GB cloudopslag voor opnames (per licentie)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion voor het genereren en vertalen van inhoud",
            "features_item2": "Onbeperkt aantal gedeelde documenten met je team",
            "features_item3": "Krijg toegang tot een onbeperkte versiegeschiedenis",
            "comparison_table_tips": "Geef je samenwerking een boost met AI-first-documenten die de inhoud van vergaderingen omzetten in bruikbare documenten, wiki's en projecten"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basis",
            "features_item1": "Taken automatisch detecteren in al je vergaderingen, telefoongesprekken, chatgesprekken en documenten",
            "features_item2": "Hulp krijgen bij het afronden van taken, zoals het plannen van vervolgvergaderingen en het opstellen van documenten",
            "features_item3": "Taken moeiteloos als voltooid markeren wanneer ze klaar zijn om je voortgang bij te houden en je aandacht te richten op toekomstige taken",
            "features_item4": "Taken beheren op het Zoom Workplace-platform, inclusief Zoom Docs",
            "features_item1_opc": "AI Companion gebruiken om taken te identificeren en te creëren op basis van je chatgesprekken, e-mails, documenten, whiteboards en samenvattingen van vergaderingen",
            "features_item2_opc": "Eenvoudig sorteren, filteren, groeperen en zoeken om je taken snel te raadplegen en context te verzamelen",
            "learn_more_header": "Houd grip op je actiepunten met AI Companion* om meer voor elkaar te krijgen in Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is alleen beschikbaar voor Zoom Workplace Pro-, Zakelijk- en Onderneming-abonnementen.",
            "features_prefix": "Laat AI Companion je helpen bij het volgende:",
            "comparison_table_tips": "Houd grip op je actiepunten en voltooi ze tijdig met een AI-first-oplossing die taaksuggesties doet op basis van gesprekken en samenvattingen van vergaderingen in Zoom Workplace.",
            "tasks_label_text": " AI-first-taakbeheer"
          },
          "title": "Zakelijk Plus",
          "contact_us_for_more_pricing": "Neem contact met ons op voor prijsinformatie en meer",
          "contact_sales": "Neem contact op met verkoop",
          "meetings": "Vergaderingen",
          "phone": "Telefoon",
          "phone_sub_title": "Onbeperkt bellen",
          "use_only": "Alleen voor zakelijk gebruik",
          "team_chat": {
            "title": "Teamchat",
            "title_desc": "Groepschat en bestanden delen"
          },
          "cloud_storage": {
            "title": "Cloudopslag"
          },
          "mail_calender": {
            "title": "Mail en Agenda"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client en service"
          },
          "up_to_30_hours_per_meeting": "hingga 30 jam per rapat",
          "300_attendees": "300 deelnemers",
          "per_meeting": "per vergadering",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "Nieuw",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Extra's",
          "sso_managed_domains_more": "SSO, beheerde domeinen en meer",
          "scheduler": "Planner",
          "global_select": "Global Select",
          "unlimited_regional": "Onbeperkt regionaal",
          "translated_captions": "Vertaalde ondertiteling",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automatische en vertaalde ondertitels",
          "unlimited_editable_boards": "Onbeperkt aantal bewerkbare borden",
          "standard_features": "Standaardfuncties",
          "advanced_docu_controls": "Geavanceerd documentbeheer",
          "chats_channels_for_collaboration": "Chats en kanalen voor samenwerking, delen van bestanden en meer",
          "zoom_phone_is_biz_use_only": "Zoom Phone is alleen bestemd voor zakelijk gebruik",
          "unlimited_regional_calling": "Onbeperkt regionaal bellen",
          "domestic_sms_mms": "Nationale sms en mms",
          "automatic_call_distribution_groups": "Automatisch verdeling van de oproepgroepen (ACD) met oproepwachtrij",
          "single_sign_on": "Single Sign-On",
          "managed_domains": "Beheerde domeinen",
          "company_branding": "Bedrijfsbranding",
          "mail_calender_client_services_beta": "Mail- en Agenda-client en -services bèta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Rapat tanpa batas selama hingga 30 jam per rapat",
          "mail_and_calendar_client_and_services_beta": "Mail- en Agenda-client en -services bèta",
          "easily_record_edit_share_videos": "Bewerk, deel en sla korte video's moeiteloos op",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Creëer en deel bewerkbare documenten binnen Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Deel moeiteloos vergaderslots om reserveren gemakkelijk te maken",
          "works_with_zoom_meeting_mail_calender_google_ms": "Werkt met Zoom Meetings, Zoom Mail en Calendar, Google en Microsoft 365",
          "up_to_300_attendees": "Tot <b>300</b> deelnemers",
          "10_gb_of_storage": "10 <b>GB</b> opslag",
          "host_meeting_up_to_300_participants": "Host vergaderingen tot 300 deelnemers",
          "10_gb_of_cloud_recording_storage": "10 GB opslag voor cloudopnames (per licentie)",
          "starting_at_licenses_year": "Begint bij {1} licenties voor {0}/jaar",
          "starting_at_licenses_month": "Begint bij {1} licenties voor {0}/maand",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Krijg snel toegang tot samenvattingen van vergaderingen, hulp bij het opstellen van berichten en meer",
          "learn_more": "Meer informatie",
          "essential_apps": "Essentiële Apps",
          "increase_team_collaboration": "Verbeter de samenwerking en productiviteit van uw team",
          "free_premium_apps": "Gratis apps van topklasse voor 1 jaar (er gelden voorwaarden)",
          "visitor_management": "Bezoekersbeheer",
          "visitor_management_custom_invites": "Pas uitnodigingen aan",
          "visitor_management_visitor_check": "Check in bij een kiosk",
          "visitor_management_receive_detailed": "Krijg gedetailleerde statistieken over het gebruik van ruimtes door bezoekers"
        },
        "custom_avatar": {
          "title": "Aangepaste avatar",
          "label_text": "3 minuten per maand",
          "basic_feature": "1 minuut per levensduur",
          "pricing_feature": "3 minuten per maand",
          "learn_more_subtitle": "Creëer een levensechte AI-versie van jezelf met stemreplicatie en meertalige communicatie.",
          "features_item1": "Maak elke maand tot 3 levensechte digitale avatars die je uiterlijk en stem nabootsen voor presentaties en demo's",
          "features_item2": "Gebruik je avatar om scripts tot 3 minuten lang af te leveren met AI Companion",
          "features_item3": "Kies uit 18 vooraf ontworpen avatars om snel video's van hoge kwaliteit te maken",
          "features_item4": "Profiteer van virtuele achtergrondondersteuning",
          "features_item1_opc": "Maak elke maand tot 3 levensechte digitale avatars die je uiterlijk en stem nabootsen voor presentaties en demo's",
          "features_item2_opc": "Gebruik je avatar om scripts tot 3 minuten lang af te leveren met AI Companion",
          "comparison_table_tips": "Met de Aangepaste avatar creëer je een levensechte AI-versie van jezelf met stemreplicatie en meertalige communicatie."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Krijg snel toegang tot samenvattingen van vergaderingen, hulp bij het opstellen van berichten en meer",
        "learn_more_dialog": {
          "desc": "Krijg meer gedaan met AI Companion! Hiermee kun je inhoud schrijven, je vergaderingen plannen, projecten beheren en nog veel meer.",
          "tip1": "Vooraf een agenda ontvangen zodat je effectievere vergaderingen kunt houden",
          "tip2": "Je projecten op schema houden met automatisch taken maken en meldingen",
          "tip3": "Hulp krijgen bij het organiseren van je agenda en het beheren van je tijd",
          "tip4": "Schriftelijke en visuele content genereren die overeenkomt met je stijl in Docs, Whiteboard of in de Zoom Workplace-app"
        },
        "top_features": "Topfuncties",
        "more_to_come": "Binnenkort nog meer fantastische functies!",
        "discover_more": "Ontdek nog meer manieren om je beste werk te leveren met AI Companion!",
        "detail_desc": "AI Companion is zonder extra kosten inbegrepen bij de betaalde services in Zoom-gebruikersaccounts. Bepaalde sectorsegmenten en geografische gebieden zijn mogelijk uitgesloten."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/jaar/licentie",
        "month_licnese": "/maand/licentie",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/maand",
          "per_year": "/jaar"
        },
        "unit": {
          "license": "{0}/licentie",
          "user": "{0}/gebruiker"
        },
        "learn_more": "Meer informatie",
        "required": "Verplicht",
        "zoom_one_required": "Zoom Workplace vereist",
        "large": {
          "features_tip": "Vergroot je bereik met een uitgebreide deelnemerscapaciteit tot wel 1000 deelnemers.",
          "label_title1": "500 deelnemers",
          "label_title2": "1000 deelnemers"
        },
        "cmr": {
          "features_tip": "Bewaar, stream en download je video-opnames direct vanuit de Zoom-cloud.",
          "explain_desc": "Cloudopslag is inbegrepen bij bepaalde Zoom One-abonnementen: Pro (5 GB), Zakelijk (5 GB), Zakelijk Plus (10 GB) en Onderneming (onbeperkt).",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 uur",
          "option_label2": "≈ 650 uur",
          "option_label3": "≈ 3,500 uur",
          "option_label4": "≈ 17,500 uur",
          "intro_label2": "Bij opslagopties is tot 5 TB per maand inbegrepen",
          "tooltip_content": "De opslagruimte voor opnames varieert naargelang het aantal deelnemers die video hebben ingeschakeld, de vergaderresolutie en de resolutie van gedeelde inhoud."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Werk in real time samen met anderen op whiteboards, zowel tijdens als buiten vergaderingen.",
          "explain_desc": "Inbegrepen in Zoom One Zakelijk-, Zoom One Zakelijk Plus- en Zoom One Onderneming",
          "explain_desc_plus": "Inbegrepen bij Zoom One Onderneming Plus en bij elk Zoom Rooms-abonnement",
          "option_label1": "Onbeperkt aantal whiteboards met 1 GB cloudopslag",
          "option_label2": "Geavanceerde functies met onbeperkt aantal whiteboards en cloudopslag",
          "intro_label1": "Onbeperkt aantal gelijktijdig bewerkbare whiteboards",
          "intro_label2": "Standaardfuncties en geavanceerd documentbeheer",
          "intro_label3": "Geavanceerde whiteboardfuncties, waaronder sjablonen op maat, organisatiesjablonen en integraties van derden"
        },
        "translated_captions": {
          "features_tip": "Maak wereldwijde samenwerking mogelijk met automatische ondertiteling in je voorkeurstaal.",
          "intro_label1": "Deelnemers kunnen ondertiteling zelf inschakelen en de taal wijzigen.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Ondersteunde talen weergeven"
        },
        "crc": {
          "features_tip": "Zorgt voor een eindpunt voor videovergaderingen op basis van SIP-/H.323-standaarden voor effectief hybride werk.",
          "intro_label1": "Werkt met vele verouderde eindpunten, waaronder Polycom, Cisco, Lifesize, enzovoort",
          "intro_label2": "Ruimteconnector in de cloud of op locatie (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Boekingen vereenvoudigen met flexibele beschikbaarheid en aanpasbare tijdsloten",
          "host_one_on_one": "Eén-op-één- of groepsvergaderingen hosten met één enkele link voor eenvoudig delen",
          "customize_reminders": "Herinneringen via e-mail/sms aanpassen om gemiste afspraken te verminderen",
          "sync_calendars": "Agenda's naadloos synchroniseren met Google, Microsoft 365 en Zoom-integraties",
          "features_tip": "Deel moeiteloos vergaderslots voor kantoortijden, sollicitatiegesprekken en meer.",
          "intro_label1": "Agenda-integratie",
          "intro_label2": "Terugkerende beschikbaarheid",
          "intro_label3": "Schaalbare vergadering",
          "intro_label4": "Aanpasbare meldingen",
          "intro_sub_label1": "Google, Microsoft 365 en Zoom ",
          "intro_sub_label2": "delen van reserveerbare tijdslots ",
          "intro_sub_label3": "enkele vergadering voor een of meer deelnemers",
          "intro_sub_label4": "automatiseren van herinneringen en bevestigingen per e-mail of sms"
        },
        "zoom_clips_plus": {
          "features_tip": "Neem korte videoberichten van hoge kwaliteit op, bewerk ze en deel ze.",
          "intro_label1": "Maak een onbeperkt aantal video's zonder tijdslimiet",
          "intro_label2": "Neem je scherm en video samen of apart op",
          "intro_label3": "Snijd je video zo nodig bij en deel de link",
          "intro_label4": "Raadpleeg geavanceerde functies zoals audiotranscripten en statistieken",
          "explain_desc": "Clips Plus is inbegrepen bij Workplace Pro-, Zakelijk- en Onderneming-abonnementen. Ontdek de verschillende functies van elk abonnement in het vergelijkingsgedeelte op de pagina met prijzen."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Geavanceerd evenementenplatform met krachtige registratie- en netwerkfuncties. Ideaal voor virtuele en hybride ervaringen.",
          "tooltip_content": "Organiseer een onbeperkt aantal webinars of evenementen met de gekozen capaciteit",
          "intro_title": "Alles in Sessions",
          "intro_label1": "Vergroot de betrokkenheid van je publiek met evenementen die uit meerdere sessies bestaan",
          "intro_label2": "Organiseer moeiteloos evenementen met ticketverkoop op maat en een mobiele app",
          "intro_label3": "Verhoog de inkomsten van je evenement met Expo Floor en een gedeelte voor sponsors",
          "intro_label4": "Help je deelnemers om te netwerken met aanpasbare profielen",
          "intro_label5": "Vergroot je bereik met on-demand weergave in de evenementenlobby",
          "intro_label6": "Versnel het opzetten van je evenement met geselecteerde evenementsjablonen",
          "events_feature_item1_20240827": "Meerdaagse virtuele evenementen organiseren met meerdere tracks",
          "events_feature_item2_20240827": "Bevorder netwerken met profielen van deelnemers en lobbychat",
          "events_feature_item3_20240827": "Begeleid deelnemers met streaming van lobbysessies",
          "events_feature_item4_20240827": "Verhoog de inkomsten van je evenement met Expo Floor en sponsoring",
          "events_feature_item5_20240827": "Verbeter toekomstige evenementen met enquêtes na conferenties",
          "events_feature_item6_20240827": "Versnel het opzetten van je evenement met geselecteerde evenementsjablonen",
          "attendees_start_at": "{0} deelnemers vanaf",
          "explain_desc": "Kom meer te weten over Zoom Events",
          "contact_account_owner": "Wil je Events kopen, <a href=\"/account\" target=\"_blank\">neem dan contact op met je accounteigenaar</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Stroomlijn interactieve, eenmalige evenementen met functies zoals branding, samenwerking tussen meerdere hosts en evenementenbeheer.",
          "tooltip_content": "Organiseer een onbeperkt aantal webinars of evenementen met de gekozen capaciteit",
          "intro_title": "Inclusief Zoom Webinars",
          "intro_label1": "Pas de landingspagina's van je evenementen aan voor effectieve branding",
          "intro_label2": "Promoot evenementen met branded e-mails",
          "intro_label3": "Meet de prestaties met een interactief dashboard",
          "intro_label4": "Naadloze samenwerking met co-hosts en co-editors",
          "intro_label5": "Professionele evenemententools: simulive",
          "sessions_feature_item1_20240827": "Til webinars naar een hoger niveau met scènes op maat en branding",
          "sessions_feature_item2_20240827": "Vereenvoudig het plannen van evenementen met AI Companion om berichten en afbeeldingen te genereren",
          "sessions_feature_item3_20240827": "Promoot afgelopen en toekomstige evenementen in een hub voor branded inhoud",
          "sessions_feature_item4_20240827": "Organiseer professionele evenementen met Backstage, Simulive en RTMP",
          "sessions_feature_item5_20240827": "Verbeter toekomstige webinars met inzichten in meerdere evenementen",
          "explain_desc": "Kom meer te weten over Zoom Sessions",
          "contact_account_owner": "Wil je Sessions kopen, <a href=\"/account\" target=\"_blank\">neem dan contact op met je accounteigenaar</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Webinar",
          "features_tip": "Zend moeiteloos berichten uit met een gebruiksvriendelijk webinarplatform.",
          "tooltip_content": "Organiseer een onbeperkt aantal webinars of evenementen met de gekozen capaciteit",
          "intro_label1": "Boei je publiek met videowebcasting van hoge kwaliteit",
          "intro_label2": "Geef de betrokkenheid een boost met V&A, peilingen en reacties",
          "intro_label3": "Verbeter je webinarstrategie met rapporten na het evenement",
          "intro_label4": "Ondersteuning voor max. 100.000 deelnemers en 100 panelleden",
          "monthly_subscription": "Maandabonnement",
          "annual_subscription": "Jaarabonnement",
          "one_million": "1 miljoen",
          "single_use": "Eenmalig gebruik",
          "one_month": "Eén maand",
          "event_attendee": "Deelnemers aan Events/Sessions:",
          "event_attendee_desc": "Iedereen die deelneemt, maar geen gelicentieerde host op de hub is. Speciale rollen worden ook als deelnemers geteld en kunnen deelnemen met audio, video en scherm delen (indien ingeschakeld).",
          "webinar_attendee": "Webinardeelnemers:",
          "webinar_attendee_desc": "Iedereen die deelneemt, maar geen host of panellid is. Ze staan in de 'alleen bekijken'-modus en worden gecontroleerd door de host, die het dempen kan opheffen en interactie via V&A en chat kan inschakelen.",
          "pay_per_attendee": "Betalen per deelnemer",
          "attendees": "deelnemers"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Geef de manier waarop je teams werken opnieuw vorm met je AI-gestuurde samenwerkingsplatform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Zakelijk",
          "label_title4": "Workplace Zakelijk Plus",
          "intro_label1": "Organiseer een onbeperkt aantal vergaderingen van max. 30 uur per vergadering en tot 100 deelnemers",
          "intro_label2": "Krijg toegang tot 3 gelijktijdig bewerkbare whiteboards met standaardfuncties",
          "intro_label3": "Neem korte videoberichten van hoge kwaliteit op, bewerk ze en deel ze met Clips Plus",
          "intro_label4": "Werk efficiënter met Zoom AI Companion",
          "intro_label5": "Zoom Phone VS & CA Onbeperkt (exclusief BYOC- en PBX-functies en PBX van derden)",
          "intro_label6": "Organiseer een onbeperkt aantal vergaderingen van max. 30 uur per vergadering en tot 300 deelnemers",
          "intro_label7": "Deel vergaderslots voor kantoortijden, sollicitatiegesprekken en meer met Zoom Scheduler",
          "intro_label8": "Zoom Phone VS & CA Onbeperkt",
          "intro_label8_UK": "Zoom Phone VK en Ierland Onbeperkt",
          "intro_label8_AU": "Zoom Phone Australië en NZ Onbeperkt",
          "intro_label8_JP": "Zoom Phone Japan Onbeperkt",
          "intro_label9": "Bezoekersbeheer",
          "intro_label10": "Aanvullende functies",
          "intro_label11": "Ondersteuning via livechat",
          "intro_title1": "Alles in Pro, plus:",
          "intro_title2": "Alles in Zakelijk, plus:",
          "intro_label_tip1": "Zoom Phone in Pro Plus bevat geen BYOC- of VDI-functies of PBX-functies van derden. Raadpleeg voor meer informatie de pagina met tarieven van Zoom Phone.",
          "intro_label_tip2": "Tijdens het afrekenen kun je Onbeperkt regionaal bellen selecteren voor de VS en Canada, Australië en Nieuw-Zeeland, het VK en Ierland of Japan.",
          "intro_label_tip3": "Aanvullende functies zijn onder meer 10 GB aan cloudopslagruimte, Vertaalde ondertitels en Reservering werkruimte.",
          "intro_label_tip4": "Zoom Phone in Pro Plus bevat geen BYOC- of VDI-functies of PBX-functies van derden. Raadpleeg voor meer informatie de pagina met tarieven van Zoom Phone."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Verbeterde analyses van oproepwachtrijen voor realtime- en historische inzichten voor callcenterteams.",
          "intro_label1": "Een ruimer venster met contactpersonen om de afhandeling van oproepen te stroomlijnen",
          "intro_label2": "Een automatische receptionist en telefoonnummers voor wachtrijen"
        },
        "international_calling": {
          "title": "Internationaal bellen",
          "features_tip": "Onbeperkt internationaal bellen naar meer dan 15 landen en regio's.",
          "intro_label1": "Kan worden aangeschaft met alle onbeperkte belabonnementen",
          "intro_label2": "Verken onze lijst van ondersteunde landen en regio's voor onbeperkt internationaal bellen.",
          "intro_labe2_tooltip": "VS, Canada, VK, Ierland, Australië, Nieuw-Zeeland, Oostenrijk, Denemarken, Frankrijk, Duitsland, Italië, Portugal, Spanje, Zweden, België, Nederland, Zwitserland, Puerto Rico en Japan.",
          "intro_label2_view_list": "Lijst weergeven"
        },
        "workspace_reservation": {
          "title": "Reservering werkruimte",
          "intro_title": "Reserveer gemakkelijk flexibele werkruimten of boek hotelkamers vooraf of ter plaatse met apparaten geïntegreerd met Zoom.",
          "intro_label1": "Toegang tot werkruimte en hotelreserveringen via de Zoom Workplace-app, desktop of browser",
          "intro_label2": "Krijg gepersonaliseerde bureau-aanbevelingen met behulp van AI",
          "intro_label3": "Reserveer werkplekken rechtstreeks vanuit Google Agenda of Outlook, met herinneringen en check-in-waarschuwingen",
          "intro_label4": "Ga naar gereserveerde werkplekken met bewegwijzering"
        },
        "visitor_management": {
          "title": "Bezoekersbeheer",
          "intro_title": "Stroomlijn het inchecken van bezoekers met aangepaste uitnodigingen, probleemloos inchecken via de kiosk, rapportage en statistieken.",
          "intro_label1": "Uitnodigingen, bezoekerslocaties en bezoekgeschiedenis beheren in de Zoom-portal",
          "intro_label2": "Uitnodigingen maken, bijhouden, opnieuw versturen en verwijderen terwijl je aankomstmeldingen van gasten ontvangt",
          "intro_label3": "Formulieren invullen, routebeschrijving opvragen en inchecken via kiosk voor een soepele bezoekerservaring",
          "intro_label4": "Toegang tot alle functies binnen de vertrouwde Zoom-portal voor eenvoudig beheer"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Grote vergadering",
          "description1": "Vergroot de vergaderingscapaciteit en bied plaats aan tot wel 1000 live, interactieve deelnemers",
          "description2": "Alle deelnemers kunnen hun audio, video en scherm delen."
        },
        "cloud_storage": {
          "title": "Cloudopslag",
          "description2": "MP4- of M4A-bestandsformaten beschikbaar"
        },
        "translated_captions": {
          "title": "Vertaalde ondertitels",
          "description1": "Breid vergaderingen uit met automatische ondertiteling in meerdere talen zodat deelnemers een ondersteunde taal kunnen kiezen en wijzigen.",
          "description2": "Beschikbaar in Zoom Meetings en Webinars"
        },
        "tollfree": {
          "title": "Opties voor audiovergaderingen",
          "subcontent": "Inbellen bij vergaderingen met telefoonnummers van over de hele wereld",
          "description1": "Breid je belopties uit met uitbellen, wereldwijd gratis bellen en lokaal inbellen voor premium-landen",
          "description2": "Gratis voor deelnemers om in te bellen vanaf elk apparaat",
          "description3": "Selecteer eenvoudig een of meer landen voor gratis inbellen"
        },
        "rc": {
          "title": "Vergaderruimteconnector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentinië",
        "Australia": "Australië",
        "Austria": "Oostenrijk",
        "Belgium": "België",
        "Brazil": "Brazilië",
        "Bulgaria": "Bulgarije",
        "Canada": "Canada",
        "Chile": "Chili",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Kroatië",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Tsjechië",
        "Denmark": "Denemarken",
        "Ecuador": "Ecuador",
        "Estonia": "Estland",
        "Finland": "Finland",
        "France": "Frankrijk",
        "Germany": "Duitsland",
        "Greece": "Griekenland",
        "Hong_Kong_SAR": "Hongkong SAR",
        "Hungary": "Hongarije",
        "Ireland": "Ierland",
        "Israel": "Israël",
        "Italy": "Italië",
        "Japan": "Japan",
        "Latvia": "Letland",
        "Lithuania": "Litouwen",
        "Luxembourg": "Luxemburg",
        "Mexico": "Mexico",
        "Netherlands": "Nederland",
        "New_Zealand": "Nieuw-Zeeland",
        "Norway": "Noorwegen",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Polen",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Roemenië",
        "Singapore": "Singapore",
        "Slovakia": "Slowakije",
        "Slovenia": "Slovenië",
        "South_Africa": "Zuid-Afrika",
        "Spain": "Spanje",
        "Sweden": "Zweden",
        "Switzerland": "Zwitserland",
        "UK": "Verenigd Koninkrijk",
        "United_Kingdom": "Verenigd Koninkrijk",
        "US": "VS",
        "United_States": "Verenigde Staten",
        "title": "Vereisten telefoonnummer",
        "subtitle": "Selecteer het land waar je Wereldwijde keuze-telefoonnummer zal worden geactiveerd.",
        "selector_tip": "Land selecteren",
        "local_and_toll_free": "Lokale en gratis nummers zijn beschikbaar in {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Wereldwijde keuze biedt één telefoonnummer en onbeperkt binnenlands bellen in het geselecteerde land per licentie.",
        "avail_title": "Beschikbare landen/gebieden"
      },
      "tax_exempt_ecm": {
        "title": "Belastingvrijstellingsstatus",
        "status_exempt": "Vrijgesteld van belasting",
        "status_exempt_question": "Vrijgesteld van belasting?",
        "verify_now": "Nu verifiëren",
        "can_after_checkout": "Als optie kan deze stap na het afrekenen worden voltooid.",
        "status": {
          "exempt": "Vrijstelling",
          "pending": "In behandeling",
          "pendingTooltip": "Je belastingvrijstellingsstatus wordt momenteel geëvalueerd. Er kan belasting in rekening worden gebracht bij het plaatsen van een bestelling. Als je vrijstelling wordt goedgekeurd, zullen wij alle terug te betalen belastingen/heffingen op je rekening bijschrijven.",
          "nonexempt": "Geen vrijstelling",
          "rejected": "Afgewezen",
          "rejectedTooltip": "Het ingediende document voldoet niet aan de vereisten voor jouw jurisdictie.",
          "approved": "Goedgekeurd",
          "default": "standaard"
        },
        "confirm_close": {
          "new_desc": "Als je de verificatie verlaat, kunnen er toepasselijke belastingen/heffingen bij je in rekening worden gebracht. Je kunt je belastingvrijstellingsdocument na aankoop nog steeds indienen in het gedeelte Factureringsbeheer, zodat Zoom het kan beoordelen en goedkeuren. Zodra het is goedgekeurd, worden alle in rekening gebrachte belastingen terugbetaald.",
          "desc": "Weet u zeker dat u de verificatie van uw belastingvrijstelling wilt stoppen en dat u verder wilt gaan als belastingplichtig?",
          "title": "Weet u het zeker?",
          "new_title": "Belastingvrijstellingsverificatie verlaten?",
          "yes": "Ja, stoppen",
          "no": "Nee, doorgaan",
          "abandon": "Verificatie verlaten",
          "go_back": "Terug"
        },
        "confirm_to_add": {
          "title": "Nieuwe standaardbelastingvrijstelling bevestigen",
          "message": "Bij toevoeging van een nieuwe vrijstelling wordt deze automatisch ingesteld als de standaard zodra deze is goedgekeurd of afgewezen. Je kunt slechts één standaardvrijstelling hebben, die zal worden toegepast op je toekomstige aankopen. Dit kan van invloed zijn op je belastingbedrag als je standaardvrijstelling niet overeenkomt met je 'Verkocht aan'-staat of -regio.",
          "yes": "Nieuwe vrijstelling toevoegen"
        },
        "confirm_set_default": {
          "title": "Adres en belastingvrijstelling komen niet overeen",
          "message": "Je 'Contactpersoon voor verkoop'-adres komt niet overeen met de staat/regio die je hebt geselecteerd voor belastingvrijstelling. Werk je 'Contactpersoon voor verkoop'-adres bij, zodat het overeenkomt met de locatie van je belastingvrijstelling. Anders is je aankoop mogelijk niet vrijgesteld van belasting.",
          "yes": "Toch als standaard instellen",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Staat/regio",
          "exemption_type": "Type vrijstelling",
          "signed_date": "Datum van ondertekening",
          "status": "status",
          "add_exemption": "Vrijstelling toevoegen",
          "view": "Weergeven",
          "set_as_default": "Instellen als standaard"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Je {planName}-abonnement wordt geannuleerd op {date} om 00.00 uur Coordinated Universal Time. Heractiveer je abonnement als je na je annuleringsdatum wilt blijven hosten.",
        "pairPreDescTip": "Je {planName1}- en {planName2}-abonnement worden geannuleerd op {date} om 00.00 uur Coordinated Universal Time. Heractiveer je abonnementen als je na je annuleringsdatum wilt blijven hosten.",
        "pairDiffDatePreDescTip": "Je {planName1}- en {planName2}-abonnement worden geannuleerd op {date1} om 00.00 uur Coordinated Universal Time en op {date2} om 00.00 uur Coordinated Universal Time. Heractiveer je abonnementen als je na je annuleringsdatum wilt blijven hosten.",
        "title": "Je abonnement heractiveren om door te gaan",
        "titles": "Je abonnementen heractiveren om door te gaan",
        "plan": "Abonnement",
        "licenses": "Licentie(s)",
        "billingCycle": "Factureringscyclus",
        "effective_date": "Ingangsdatum",
        "invoice_amount": "Factuurbedrag",
        "singleDescTip": "Door te heractiveren, ga je ermee akkoord dat je terugkerende abonnement automatisch wordt verlengd op {date} en dat de kosten elke verlengingsperiode in rekening worden gebracht via je opgeslagen betalingsmethode. Je dient je abonnement de dag vóór de verlengingsdatum te <a target=\"_blank\" href=“https://support.zoom.com/hc/nl/article?id=zm_kb&sysparm_article=KB0066687\">annuleren</a> om te voorkomen dat er later opnieuw kosten in rekening worden gebracht.",
        "pairDescTip": "Door te heractiveren, ga je ermee akkoord dat je terugkerende abonnementen automatisch worden verlengd op {date}. De kosten worden elke verlengingsperiode in rekening gebracht via je opgeslagen betalingsmethode. Je dient je abonnement de dag vóór de verlengingsdatum te <a target=\"_blank\" href=\"https://support.zoom.com/hc/nl/article?id=zm_kb&sysparm_article=KB0066687\">annuleren</a> om te voorkomen dat er later opnieuw kosten in rekening worden gebracht.",
        "pairDiffDateDescTip": "Door te heractiveren, ga je ermee akkoord dat je terugkerende abonnementen automatisch worden verlengd worden op {date1} en {date2}. De kosten worden elke verlengingsperiode in rekening gebracht via je opgeslagen betalingsmethode. Je dient je abonnement de dag vóór de verlengingsdatum te <a target=\"_blank\" href=\"https://support.zoom.com/hc/nl/article?id=zm_kb&sysparm_article=KB0066687\">annuleren</a> om te voorkomen dat er later opnieuw kosten in rekening worden gebracht.",
        "totalLabel": "Totaal",
        "totalContent": "{money} plus toepasselijke belastingen",
        "taxDesc": "exclusief btw, GST of soortgelijke belastingen",
        "reactivateBtn": "Doorgaan en heractiveren",
        "switchTitle": "Je abonnement bijwerken om door te gaan",
        "successSingleTip": "Je {planName}-abonnement is opnieuw geactiveerd",
        "successPairTip": "Je {planName1}- en {planName2}-abonnement zijn opnieuw geactiveerd",
        "switchTip": "Je Zoom Webinars-abonnement voor één maand verloopt op {date}. Als je na deze datum een webinar wilt hosten, moet je overstappen op een abonnement.",
        "switchBtn": "Overstappen op abonnement"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Zakelijk"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download het informatieblad"
      },
      "one": {
        "new": "Nieuw"
      }
    },
    "webinarSetupInWebPortal": "Opzetten van webinar in webportal",
    "concurrentEvents": "Gelijktijdige evenementen",
    "coucurrentEventsToolTip": "<span>Een <b>subscription</b>-abonnement ondersteunt één live-evenement tegelijk",
    "overages": "Overschrijdingskosten",
    "eventsPlatformHubs": "Hubs op het Zoom Events-platform",
    "eventsHubToolTip": "Zoom Events-<b>hubs</b> maken het gemakkelijk om je evenement te organiseren",
    "1HubPerLicense": "1 hub per licentie",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Hosts op Events-platform (500 of meer deelnemers)",
    "eventsHost500": "<span>Zoom Events-<b>hubhosts</b> kunnen het volgende aanmaken:",
    "5HubHosts": "5 hubhosts",
    "100HubHosts": "100 hubhosts",
    "eventsPlatformHosts_100Attendees": "Hosts op Events-platform (100 deelnemers)",
    "eventsHost100": "<span>Zoom Events-<b>hubhosts</b> kunnen het volgende aanmaken:",
    "2HubHosts": "2 hubhosts",
    "howAreTheyDifferent": "Wat zijn de verschillen?",
    "allPlansRequireAZoomOneLicense": "*Voor alle abonnementen is een Zoom Workplace-licentie nodig",
    "subscription": "Abonnement",
    "subscriptionToolTip": "<span> Met een <b>subscription</b> kun je een onbeperkt aantal evenementen hosten met de door jou gekozen capaciteit.</span>",
    "payPerAttendee": "Betalen per deelnemer",
    "ppaToolTips": "<span>De <b>pay per attendee</b>-licentie bepaalt het totale aantal deelnemers dat alle evenementen van je account kan bijwonen binnen een periode van 12 maanden na aankoop.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Peilingen",
    "meetings.fullPlanItem2": "Aantal licenties",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Vergaderduur",
    "meetings.fullPlanItem5Tip": "De maximum toegestane duur per groepsvergadering (3 of meer deelnemers).",
    "meetings.fullPlanItem5_basic": "40 min",
    "one.basicPlusFullPlanItem1": "60 minuten",
    "meetings.fullPlanItem5_pro": "30 uur",
    "meetings.fullPlanItem5_biz": "30 uur",
    "meetings.fullPlanItem5_ent": "30 uur",
    "meetings.fullPlanItem1": "Deelnemerscapaciteit",
    "meetings.fullPlanItem1Tip": "Deelnemers kunnen deelnemen aan uw vergadering via hun telefoon, desktop, mobiele telefoons en tablets. Een deelnemer hoeft geen Zoom-account te hebben om deel te kunenn nemen aan een vergadering. Ieder abonnement heeft een deelnemerlimiet, maar gebruikers kunnen deze limiet verhogen door een add-on te kopen.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1000 voor Onderneming Plus</span>",
    "meetings.fullPlanItem7": "Opnemen",
    "meetings.fullPlanItem7Tip": "Zoom lokaal opnemen slaat uw vergaderopnames op in MP4- (video) MP4A- (audio) en txt- (chat) formaten.<br>Zoom-cloudopname slaat vergaderingen op in de Zoom Cloud, waar het bestand gedownload en/of gestreamd kan worden vanuit een browser.",
    "meetings.fullPlanItem7_basic": "Lokaal",
    "meetings.fullPlanItem7_pro": "Lokaal + 1 GB cloudopname (per licentie)",
    "meetings.fullPlanItem7_biz": "Lokaal + 1 GB cloudopname (per licentie)",
    "meetings.fullPlanItem7_ent": "Lokaal en onbeperkt cloudopname",
    "one.messaging": "Teamchat",
    "meetings.fullPlanItem16Tip": "Met chat kunt u eenvoudig groepsberichten, bestanden, schermafbeeldingen, stukjes code, spraakberichten en afbeeldingen versturen. Tekst kan geformatteerd worden en gebruikers kunnen GIF's en emoji's. Aanwezigheidsweergava laat zien of chatdeelnemers actief zijn op desktop of op mobiele apparaten, of bezig zijn in vergadering.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Onbeperkt",
    "meetings.fullPlanItem_EssentialApp": "Essentiële Apps",
    "common.learnMore": "Meer informatie",
    "meetings.fullPlanItem_EssentialAppText": "Gratis Essentiële Apps van topklasse voor 1 jaar (er gelden voorwaarden)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail dan Zoom Calendar di Zoom App",
    "mailService": "Layanan Email",
    "emailServiceWithFullTimeEndToEnd": "Layanan email dengan enkripsi ujung-ke-ujung penuh waktu untuk privasi yang ditingkatkan",
    "customMailDomain": "Domain Email Kustom",
    "customMailDomainWithMailService": "Domain Email Kustom dengan Layanan Email",
    "calendarClient": "Klien Kalender",
    "scheduleAndJoinMeetings": "Jadwalkan dan bergabung ke rapat di Zoom App",
    "aiCompanion": "AI Companion",
    "calendarService": "Layanan Kalender",
    "meetingSchedulingAndAppointment": "Penjadwalan rapat dan pemesanan janji temu",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Onbeperkt aantal vergaderingen",
    "meetings.fullPlanItem9": "Telefonisch inbellen",
    "meetings.fullPlanItem9Tip": "Neem deel aan een Zoom-vergadering via televergaderen/audiovergaderen (met een traditionele telefoon). Gebruikers worden kosten in rekening gebracht volgens hun telefoonabonnement. Probeer onze add on audiovergaderen voor gratis inbelnummers.",
    "meetings.fullPlanItem9_pro": "Betalend",
    "meetings.fullPlanItem9_biz": "Betalend",
    "meetings.fullPlanItem9_ent": "Betalend",
    "meetings.fullPlanItem11": "Scherm delen",
    "meetings.fullPlanItem11Tip": "Delen van desktop en toepassingen. Vergaderingsgebruikers kunnen kiezen om meerdere deelnemers gelijktijdig het scherm te laten delen tijdens een vergadering die ze hosten.",
    "meetings.fullPlanItem12": "Aparte vergaderruimtes",
    "meetings.fullPlanItem12Tip": "Aparte videovergaderruimtes laten u uw Zoom-vergaderingen opsplitsen in tot wel 50 afzonderlijke sessies voor discussies, projecten en meer.",
    "meetings.fullPlanItem14": "Virtuele achtergrond",
    "meetings.fullPlanItem15": "Persoonlijke vergadering-ID",
    "meetings.fullPlanItem15Tip": "Creëer uw eigen permanente online vergaderruimte. U kunt deze vergadering op ieder moment beginnen of plannen voor toekomstig gebruik.",
    "meetings.fullPlanItem17": "Besturingselementen van de host",
    "meetings.fullPlanItem18": "Co-annotatie op gedeeld scherm",
    "meetings.fullPlanItem19": "Toetsenbord-/muisbediening op afstand",
    "meetings.fullPlanItem21": "Meervoudig delen",
    "meetings.fullPlanItem29": "Wachtruimte",
    "meetings.fullPlanItem29Tip": "Met de Wachtruimte-functie kan de host bepalen wanneer een deelnemer zich kan aansluiten bij de vergadering. Als host van de vergadering kunt u deelnemers één voor één toelaten of allemaal tegelijk. Bij instellingen kunt u kiezen wie er in de Wachtruimte wordt geplaatst of wie er automatisch toegang krijgen. Ieder account heeft de Wachtruimte-functie. De host kan de Wachtruimte een bericht sturen. U kunt de Wachtruimte personaliseren als u een betaald abonnement hebt.",
    "meetings.fullPlanItem41": "Ingebouwd in apparaten met Zoom for Home.",
    "meetings.fullPlanItem61": "Meerdere mensen vastmaken",
    "meetings.fullPlanItem61Tip": "De host kan tot 9 mensen toestaan video's vast te maken om hun eigen gepersonaliseerde weergave te maken. Dus ongeacht wie er aan het woord is, de vastgemaakte video's blijven zichtbaar.",
    "meetings.fullPlanItem62": "Meerdere mensen spotlighten",
    "meetings.fullPlanItem62Tip": "De host kan tot 9 video's van deelnemers spotlighten, zodat ongeacht wie er aan het woord is, de hele vergadering de gespotlighte video's ziet.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Maak happy hours, partijen en meer leuker met leuke kleurenfilters of decoratieve dierenstickers.",
    "meetings.fullPlanNewItem2": "Peilingen",
    "meetings.fullPlanNewItem3": "Co-host en plaatsvervangende host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Meer informatie</a> over de besturingselementen voor de co-host voor vergaderingen.",
    "meetings.fullPlanItem24": "Toewijzingsplanner vergaderingen",
    "meetings.fullPlanItem24Tip": "Laat u iemand anders toewijzen om de vergaderingen voor u op te zetten. De toegewezen persoon moet ook een Pro-abonnement hebben.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Biedt accounteigenaren, beheerders en uw ontwikkelaars beveiligde toegang tot Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API-tarielimieten</a> worden toegepast op accountniveau volgens <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">accounttype</a> (Pro, Zakelijk, Onderneming, etc.) en het <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">Type API-aanvraag</a> (Licht, Medium, Zwaar etc.). Sommige API's hebben beperkte toegang tot specifieke accounttypes. Gebruik de<a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API-tarieflimieten</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API-referentiedocumentatie</a> voor volledige details.",
    "meetings.fullPlanItem25_pro": "Pro REST API-tarieflimieten",
    "meetings.fullPlanItem25_biz": "REST API-tarieflimieten",
    "meetings.fullPlanItem26": "Skype for Business (Lync)-interoperabiliteit",
    "meetings.fullPlanItem26Tip": "Laat Lync-gebruikers 2010, 2013 en Skype for Business-gebruikers een Zoom-vergadering beginnen vanuit de Lync-contactpersonenlijst.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live naar Facebook, Youtube of een dienst van een externe partij.",
    "meetings.fullPlanItem28": "Rapportage",
    "meetings.fullPlanItem28Tip": "Draai gebruiksrapporten om te leren hoeveel vergaderingen er plaatsvinden, welke dagen, aantal deelnemers, aantal vergaderminuten en meer.",
    "meetings.fullPlanItem30": "Gebruikersbeheer",
    "meetings.fullPlanItem30Tip": "Accounteigenaren en beheerders kunnen rollen en add-ons toevoegen, verwijderen en toewijzen.",
    "one.autoCaptions": "Automatische ondertitels",
    "meetings.fullPlanItem31": "Beheerportal",
    "meetings.fullPlanItem31Tip": "Beheer gebruikers in uw bedrijf op een account voor vereenvoudigde facturering, geavanceerde beheerinsellingen en uitgebreid gebruiksinzicht, allemaal in het Zoom Beheerportal.",
    "meetings.fullPlanItem32": "LTI-integratie",
    "meetings.fullPlanItem32Tip": "Eenvoudig toevoegen van een vergadering met alle cursusactiviteit en nodig de juiste studenten uit via uw leerbeheersysteem (werkt met Moodle, Canvas, Desire2Learn en Blackboard).",
    "meetings.fullPlanItem33": "Opname van transscripten",
    "meetings.fullPlanItem33Tip": "Transcripten van cloudopnames zijn audiotransscripten van audio of een vergadering of webinar die u naar de cloud opneemt. Merk op dat dit op dit moment alleen voor de Engelse taal ondersteund wordt. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Klik hier</a> voor meer informatie.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Voeg uw bedrijfsbranding toe aan uw gepersonaliseerde pagina waar gebruikers deel kunnen nemen aan een vergadering. Creëer een e-mailsjabloon met branding om uitnodigingen naar deelnemers te versturen.",
    "meetings.fullPlanItem35": "Beheerde domeinen",
    "meetings.fullPlanItem35Tip": "Gebruik het e-mailadresdomein van uw bedrijf/universiteit om automatisch gebruikers aan uw account toe te voegen.",
    "meetings.fullPlanItem37": "Taal tolken",
    "meetings.fullPlanItem37Tip": "Laat de host van de vergadering de tolken aanwijzen in hun vergaderingen en webinars. Na het starten van de vergadering of webinar kan de host van de vergadering de tolkfunctie starten, die de tolken toegang tot hun eigen audiokanalen geeft. Aanwezigen kunnen een audiokanaal selecteren om de taal naar keuze te horen. Deelnemers horen de vertaalde audio en kunnen kiezen of ze de originele taal op een lager volume willen horen.",
    "meetings.fullPlanItem39": "Executive Business-beoordelingen",
    "meetings.fullPlanItem39Tip": "Gedetailleerde trending acceptatieanalyse, volgen van de ROI, discussies over de routekaart van product.",
    "meetings.fullPlanNewItem4": "Inclusief Webinar 500",
    "one.translatedCations": "Vertaalde ondertitels",
    "one.entPlus": "Onderneming Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtuele achtergronden",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Maak enkelvoudige of meerkeuzevragen voor je vergaderingen.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-endversleuteling voor Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Indien ingeschakeld, zorgt de end-to-endversleuteling (E2EE) van Zoom voor Zoom Meetings ervoor dat de communicatie tussen alle deelnemers die Zoom clients gebruiken in een vergadering wordt versleuteld met behulp van cryptografische sleutels die alleen bekend zijn bij de apparaten van die deelnemers. Dit betekent dat geen enkele derde partij - inclusief Zoom - toegang heeft tot de privésleutels van de vergadering.",
    "zoomCustomerManagedKey": "Door de klant beheerde sleutel voor Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Gebruik je eigen versleutelingscodes om Zoom-gegevens 'at rest' te beveiligen",
    "enterpriseGradeSecurityFeatures": "Beveiligingsfuncties op bedrijfsniveau",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM versleuteling voor realtime inhoud en media, TLS-versleuteling tijdens SIP-registratie, caller ID-masking, privénetwerk-peering, tools voor fraudedetectie, en lijsten voor het blokkeren van oproepen.",
    "phone.fullPlanItem40": "Single Sign-On via SAML 2.0",
    "phone.fullPlanItem40Tip": "Ondersteunt Microsoft Active Directory, Google, Ping, Okta, Centrify. Vereist een Zakelijk, Onderwijs- of Ondernemingsaccount.",
    "phone.fullPlanItem1": "Onbeperkt internationaal bellen",
    "phone.fullPlanItem2": "Getelde uitgaande gesprekken",
    "phone.fullPlanItem3": "Onbeperkte uitgaande gesprekken",
    "phone.fullPlanItem4": "Industrie-leidende HD-spraakkwaliteit",
    "phone.fullPlanItem4Tip": "Met actieve echo- en ruisonderdrukking en onderdrukking van toetsenaanslagen",
    "phone.fullPlanItem5": "Ingebouwde Windows, MacOS, iOS, en Linux-desktopapps",
    "phone.fullPlanItem6": "Ingebouwde mobiele apps voor iOS en Android",
    "phone.fullPlanItem7": "Poort bestaande nummers of koop nieuwe (DID)",
    "phone.fullPlanItem8": "Gratis nummers",
    "phone.fullPlanItem9": "Toestelnummer",
    "phone.fullPlanItem10": "Voicemail met transscriptie",
    "phone.fullPlanItem10Tip": "Toegang tot voicemail-transscript via mobiele/desktopapps en e-mail",
    "phone.fullPlanItem11": "Onbeperkt automatische deelnemers/IVR",
    "phone.fullPlanItem12": "Bellen op naam in directory",
    "phone.fullPlanItem13": "Automatisch verdeling van de oproepgroepen (ACD) met oproepwachtrij",
    "phone.fullPlanItem14": "Stommelen/Monitoren/Fluisteren/Overnemen",
    "phone.fullPlanItem15": "Routering vakantie- en kantooruren",
    "phone.fullPlanItem16": "3-wegs ad-hoc vergadergesprekken",
    "phone.fullPlanItem17": "Opname van oproepen",
    "phone.fullPlanItem17Tip": "Automatische en handmatige gespreksopname zijn beschikbaaar. Full-time en on-demand gespreksopname met transcripties",
    "phone.fullPlanItem18": "Configureerbare anonieme en specifiek gespreksblokkering",
    "phone.fullPlanItem19": "Noodoproepen",
    "phone.fullPlanItem19Tip": "Bel naar de lokale noodhulpdiensten",
    "phone.fullPlanItem20": "Nomadic E911 adressering (VS en Canada) -",
    "phone.fullPlanItem20Tip": "Dynamische detectie gebruikerslocatie en rapportage van corresponderende adressen voor noodgevallen aan de lokale hulpdiensten(allees VS en Canada) en aan intern veiligheidsteam",
    "phone.fullPlanItem21": "Centrum voor noodoproepen",
    "phone.fullPlanItem21Tip": "Stel uw interne veiligheidsteam in staat om gewaarschuwd te worden voor noodoproepen en het opnemen/monitoren/invallen in noodoproepen om te helpen de respons te coördineren.",
    "phone.fullPlanItem22": "Voorkomen van gedeelde lijn/delegatie",
    "phone.fullPlanItem23": "Gespreksoverdracht tussen apparaten",
    "phone.fullPlanItem24": "Gesprek parkeren",
    "endToEndEncryptionForZoomPhone": "End-to-endversleuteling voor Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Indien ingeschakeld voor Zoom Phone, zorgt end-to-endversleuteling (E2EE) ervoor dat het gesprek wordt versleuteld met cryptografische sleutels die alleen bekend zijn bij de apparaten van de beller en de ontvanger. Bovendien hebben gebruikers de mogelijkheid om de E2EE-status te verifiëren door elkaar een unieke beveiligingscode te verstrekken.",
    "phone.fullPlanItem43": "Zero-touch levering van telefoons",
    "phone.fullPlanItem44": "Gemengde abonnementstypes in een account",
    "phone.fullPlanItem46": "Realtime rapportage en kwaliteitsdashboards",
    "phone.fullPlanItem47": "Ondersteuning voor virtuele desktopomgeving (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Meer informatie</a> over VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Beschikbaar voor alle klanten met alleen telefonie. Ondersteuningsabonnementen variëren wanneer ze zijn gekoppeld aan vergaderabonnementen.",
    "phone.fullPlanItem49": "Ondersteuning Bring your own carrier",
    "phone.fullPlanItem49Tip": "Ondersteuning voor directe en lokatie-gebaseerde koppeling aan uw bestaande PSTN-leverancier",
    "phone.fullPlanItem50": "Hybride integratie van legacy PBX's",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online fax",
    "phone.fullPlanItem61Tip": "Verstuur en ontvang onbeperkt faxen binnen de VS en CA. <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">Zie tarieven</a> voor internationale faxen",
    "phone.fullPlanSms": "Sms en mms",
    "phone.fullPlanSmsTip": "Alleen beschikbaar voor Amerikaanse en Canadese nummers bij aankoop van een belabonnement. Beschikbaar voor gebruik met rechtstreekse nummers (geen bedrijfsnummers).",
    "meetings.fullPlanItem6": "Technische ondersteuning",
    "meetings.fullPlanItem6Tip": "Premier Support-pakketten beschikbaar om risico's te minimaliseren en uitvaltijd te verminderen",
    "meetings.fullPlanItem6_basic": "Helpcentrum",
    "meetings.fullPlanItem6_pro": "Ticket en live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat en telefoon",
    "meetings.fullPlanItem6_ent": "Ticket, live chat en telefoon",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom-gemeenschap",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Email",
    "common.plans.meeting.title": "Vergaderingen",
    "plans.basic_free.upgrade.item1": "Tot 30 uur per vergadering",
    "common.statistics.participants": "{0} Deelnemers",
    "common.per_meeting_unit": "per vergadering",
    "common.participant_limit.increase_with_large_meetings": "Breid uit met Grote vergadering",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Onbeperkt",
    "common.plans.team_chat.title": "Teamchat",
    "common.plans.mail_calendar.title": "Mail en Agenda",
    "common.plans.cloud_storage.title": "Cloudopslag",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Zoom Translated Captions",
    "common.plans.extras.title": "Extra's",
    "common.plans.extras.desc": "beheer bedrijfsdomeinen en meer",
    "zoom_one_edu_bundle.school.title": "Zoom One voor het onderwijs School en Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One voor het onderwijs School en Campus Plus",
    "per_billing_cycle_license.monthly": "/maand/licentie",
    "per_billing_cycle_license.yearly": "/jaar/licentie",
    "per_billing_cycle_space.monthly": "/maand/ruimte",
    "per_billing_cycle_space.yearly": "/jaar/ruimte",
    "common.dialog.feature_list": "Bekijk de lijst met alle functies",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per licentie",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per licentie",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Onderneming Plus omvat Onbeperkt",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Rooms + Vergaderruimteconnector (ratio 1:25)",
    "plans.whiteboard.ent": "Onderneming Plus omvat Onbeperkt Plus",
    "plans.zp.ent": "Inbegrepen bij Onderneming Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Geavanceerde of lokale reservering van werkruimtes en meer",
    "plans.largeMeeting.intro_tip": "Grote vergaderingen is een optionele add-on tijdens de betaling, waarmee je een vergadering voor 500 of 1000 deelnemers kunt houden, naargelang de gekochte licentie.",
    "common.participant_limit.expandable_with_large_meetings": "Uitbreidbaar met Grote vergadering",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1000 voor Onderneming Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Onderneming Plus omvat Sessie 1000 (inclusief Webinar)",
    "per_billing_cycle_user.monthly": "/maand/gebruiker",
    "per_billing_cycle_user.annually": "/jaar/gebruiker",
    "closeComparisonChart": "Vergelijkingstabel sluiten",
    "archiving_api": "API voor archivering",
    "dlp_api": "API voor DLP",
    "info_barriers": "Informatiebarrières",
    "chat_etiquette": "Chatetiquette",
    "gdrp": "AVG",
    "regiona_data_centers": "Regionale datacenters",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Standaardversleuteling",
    "end_to_end_encryption": "End-to-end-encryptie",
    "cryptographic_boundary": "Cryptografische grens",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Door de klant beheerde sleutel",
    "gpo_msi_policies": "GPO-/MSI-beleid",
    "msi": "Massa-implementatie (MSI)",
    "ntt": "Netwerk Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Survivability van Zoom Phone",
    "zoom_meeting_survivability": "Survivability van Zoom Meetings",
    "paid_option": "Betaalde optie",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Belangrijkste functies",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School en Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School en Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "pl-PL": {
    "billing.essential_apps": "Niezbędne aplikacje",
    "billing.essential_apps.dialog_desc": "Rozwijaj swoją firmę i zarządzaj nią dzięki aplikacjom, które umożliwiają robienie notatek ze spotkań, angażowanie zespołu podczas interaktywnych aktywności i dostarczanie informacji usprawniających rozmowy z klientami. Bezpłatne aplikacje premium dołączone do planu na 1 rok.",
    "billing.see_more_details": "Zobacz więcej szczegółów",
    "billing.essential_app.legal_copy": "Oferta ważna tylko dla użytkowników z aktualną licencją, z dniem lub po 4 stycznia 2023, w ramach subskrypcji Zoom One Pro, Dla firm lub Biznesowy Plus, która została zakupiona poprzez kanał internetowy Zoom pod adresem zoom.us/buy. Ta oferta nie obowiązuje w przypadku użytkowników, których subskrypcja jest związana z kontem opieki zdrowotnej, sektora edukacji czy rządu.  Dostęp do każdej aplikacji, z wyjątkiem aplikacji Coda, rozpoczyna się w momencie aktywacji aplikacji przez indywidualnego użytkownika i wygasa po upływie 1 roku. Dostęp do aplikacji Coda dla wszystkich użytkowników na tym samym koncie Zoom rozpoczyna się po pierwszej aktywacji aplikacji Coda przez dowolnego użytkownika na tym samym koncie Zoom i wygasa dla wszystkich użytkowników na tym koncie Zoom po upływie 1 roku, niezależnie od początkowej daty aktywacji przez kolejnych użytkowników na tym samym koncie Zoom.W przypadku wszystkich aplikacji zmiana przypisania lub anulowanie kwalifikującej się licencji lub subskrypcji użytkownika spowoduje zakończenie dostępu dla tego użytkownika, niezależnie od tego, czy pozostał czas do końca rocznego okresu dostępu.Każda aplikacja podlega warunkom użytkowania i polityce prywatności dostępnej w momencie aktywacji.Dołączone aplikacje są dostępne tylko w języku angielskim.Nie wszystkie aplikacje działają na urządzeniach mobilnych.Oferta nie podlega wymianie ani zwrotowi na gotówkę.Oferta ma zastosowanie tylko do aplikacji wymienionych jako Niezbędne aplikacje w <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>. Użytkownicy z istniejącymi subskrypcjami którejkolwiek z aplikacji nie kwalifikują się do tej oferty w odniesieniu do tych konkretnych aplikacji.Zoom zastrzega sobie prawo do zmiany lub anulowania tej oferty w dowolnym momencie bez wcześniejszego powiadomienia i odpowiedzialności.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Zarządzanie gośćmi"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Czat na żywo 24 godziny na dobę, 7 dni w tygodniu i wsparcie telefoniczne"
      },
      "learn_more": "Dowiedz si\u0119 wi\u0119cej",
      "new": "NOWY",
      "plan_details": {
        "meeting": {
          "title": "Spotkania",
          "host_meeting_up_to_participants": "Gość do {0} uczestników",
          "meeting_hours": "Onbeperkte vergaderingen voor maximaal 30 uur per vergadering",
          "recording_storage": "{0} GB pamięci do nagrywania w chmurze (na licencję)",
          "auto_captions": "Napisy automatyczne"
        },
        "whiteboard": {
          "title": "Tablica",
          "boards_storage": "{0} edytowalne tablice",
          "standard_features": "Standardowe funkcje"
        },
        "team_chat": {
          "title": "Czat zespołowy",
          "desc": "Czat grupowy i udostępnianie plików"
        },
        "main_calendar": {
          "title": "Poczta i kalendarz",
          "desc": "klienta pocztowego i kalendarza oraz usług"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Twórz i udostępniaj edytowalne dokumenty w Zoom",
          "desc2": "Notatki osobiste i zespołowe ze wzbogaconym formatowaniem tekstu"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Z łatwością nagrywaj, edytuj i udostępniaj krótkie filmy",
          "desc2": "Nieograniczona liczba filmów i zaawansowane funkcje"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Zdobądź szybki dostęp do podsumowań spotkań, wsparcia w pisaniu wiadomości i innych funkcji"
        },
        "EssentialApp": {
          "title": "Niezbędne aplikacje",
          "desc1": "Bezpłatne aplikacje premium przez 1 rok (obowiązują warunki)",
          "desc2": "Zwiększ współpracę i produktywność zespołu"
        },
        "livechat": {
          "title": "Wsparcie w postaci czatu na żywo"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Przejść na Zoom Workplace Dla profesjonalistów?",
            "content": "Twój wcześniejszy wybór to Zoom Workplace Dla firm, który pozwala na organizację spotkań z nawet 300 uczestnikami, obejmuje Zoom Scheduler i więcej. Czy nadal chcesz przejść na wersję Dla profesjonalistów?",
            "confirm": "Potwierdź zmianę",
            "keep_current": "Zatrzymaj bieżący plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} uczestnicy",
          "participants": "{0} Uczestnicy",
          "user_range": "{0}–{1} użytkowników",
          "items": "{num} pozycje"
        },
        "button": {
          "ok": "OK",
          "add": "Dodaj",
          "buy_now": "Kup teraz",
          "try_for_days": "Wypróbuj przez {0} dni",
          "contact_sales": "Kontakt w sprawie sprzedaży",
          "close": "Zamknij",
          "cancel": "Anuluj",
          "edit": "Edytuj",
          "got_it": "Rozumiem"
        },
        "title": {
          "everything_in_and": "Wszystko to, co w {0} oraz:"
        },
        "tag": {
          "new": "NOWY",
          "free_trial": "Bezpłatna wersja testowa"
        },
        "billing_cycle": {
          "annual": "Rocznie",
          "monthly": "Raz w miesiącu",
          "quarterly": "Kwartalnik",
          "two_years": "Dwa lata",
          "three_years": "Trzy lata"
        },
        "errors": {
          "unknown_error_try_again": "Nieznany błąd podczas przetwarzania transakcji. Spróbuj ponownie później."
        },
        "excluding_tax": {
          "vat_tip": "bez VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Ograniczone funkcje",
        "pro_plus": {
          "host_meeting_up_to_participants": "Gość do {0} uczestników",
          "gb_of_cloud_recording_storage": "{0} GB pamięci na nagrywanie w chmurze (na licencję)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "Asystent AI Companion do generowania treści i tłumaczeń",
            "features_item2": "Nieograniczona liczba dokumentów udostępnionych zespołowi",
            "features_item3": "Uzyskaj dostęp do nieograniczonej historii wersji",
            "comparison_table_tips": "Usprawnij współpracę dzięki dokumentom opartym na sztucznej inteligencji, które przekształcają treść spotkania w przydatne dokumenty, strony wiki i projekty"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Podstawowy",
            "features_item1": "automatycznie wykrywać zadania ze spotkań, rozmów telefonicznych, czatów i dokumentów;",
            "features_item2": "uzyskać pomoc w realizacji zadań, takich jak planowanie kolejnych spotkań i sporządzanie dokumentów;",
            "features_item3": "bez wysiłku oznaczać zadania jako ukończone, aby być na bieżąco z postępami i skupiać się na tym, co będzie dalej;",
            "features_item4": "zarządzać zadaniami na platformie Zoom Workplace, w tym Zoom Docs.",
            "features_item1_opc": "wykorzystać moc asystenta AI Companion, aby identyfikować i tworzyć zadania na podstawie czatów, wiadomości e-mail, dokumentów, tablic i podsumowań spotkań;",
            "features_item2_opc": "łatwo sortować, filtrować, grupować i wyszukiwać w celu szybkiego gromadzenia i dostępu do kontekstu zadań;",
            "learn_more_header": "Nie przeocz żadnego zalecanego działania dzięki asystentowi AI Companion*, aby zrobić więcej w Zoom Workplace.",
            "learn_more_footer": "\* Asystent AI Companion jest dostępny tylko dla planów Zoom Workplace Dla profesjonalistów, Dla firm i Dla przedsiębiorstw.",
            "features_prefix": "Pozwól asystentowi AI Companion pomóc Ci:",
            "comparison_table_tips": "Nie przeocz żadnego zalecanego działania i wykonuj je na czas dzięki rozwiązaniu opartemu na sztucznej inteligencji, które zapewnia rekomendacje zadań na podstawie rozmów i podsumowań spotkań w Zoom Workplace.",
            "tasks_label_text": " Zarządzanie zadaniami wspomagane przez AI"
          },
          "title": "Dla firm Plus",
          "contact_us_for_more_pricing": "Aby uzyskać więcej informacji o cenach i nie tylko, skontaktuj się z nami",
          "contact_sales": "Kontakt w\u00A0sprawie sprzeda\u017Cy",
          "meetings": "Spotkania",
          "phone": "Telefon",
          "phone_sub_title": "Nielimitowane po\u0142\u0105czenia",
          "use_only": "Tylko do użytku służbowego",
          "team_chat": {
            "title": "Czat zespołowy",
            "title_desc": "Czat grupowy i udostępnianie plików"
          },
          "cloud_storage": {
            "title": "Przestrze\u0144 w chmurze"
          },
          "mail_calender": {
            "title": "Poczta i kalendarz"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Klient i usługa"
          },
          "up_to_30_hours_per_meeting": "tot 30 uur per vergadering",
          "300_attendees": "300 uczestników",
          "per_meeting": "na spotkanie",
          "whiteboard": {
            "title": "Tablica"
          },
          "new": "NOWY",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Dodatki",
          "sso_managed_domains_more": "SSO, domeny zarządzane i więcej",
          "scheduler": "Planer",
          "global_select": "Global Select",
          "unlimited_regional": "Nielimitowane połączenia regionalne",
          "translated_captions": "Przetłumaczone napisy",
          "workspace_reservation": "Rezerwacja obszaru roboczego",
          "auto_translated_captions": "Napisy automatyczne i przetłumaczone",
          "unlimited_editable_boards": "Nieograniczona liczba edytowalnych tablic",
          "standard_features": "Standardowe funkcje",
          "advanced_docu_controls": "Zaawansowane sterowanie dokumentem",
          "chats_channels_for_collaboration": "Czaty i kanały umożliwiające współpracę, udostępnianie plików i nie tylko",
          "zoom_phone_is_biz_use_only": "Zoom Phone służy wyłącznie do użytku biznesowego",
          "unlimited_regional_calling": "Nielimitowane po\u0142\u0105czenia regionalne",
          "domestic_sms_mms": "Krajowe wiadomo\u015Bci SMS i MMS",
          "automatic_call_distribution_groups": "Automatyczne grupy dystrybucji po\u0142\u0105cze\u0144 (ACD) z kolejk\u0105 po\u0142\u0105cze\u0144",
          "single_sign_on": "Jednokrotne logowanie",
          "managed_domains": "Domeny zarz\u0105dzane",
          "company_branding": "Branding firmowy",
          "mail_calender_client_services_beta": "Wersja beta klienta pocztowego i kalendarza oraz usług",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Onbeperkte vergaderingen voor maximaal 30 uur per vergadering",
          "mail_and_calendar_client_and_services_beta": "Wersja beta klienta pocztowego i kalendarza oraz usług",
          "easily_record_edit_share_videos": "Z łatwością nagrywaj, edytuj i udostępniaj krótkie filmy",
          "unlimited_videos_advanced_features": "Nieograniczona liczba filmów i zaawansowane funkcje",
          "create_share_editabel_docu_within_zoom": "Twórz i udostępniaj edytowalne dokumenty w Zoom",
          "personal_collaborative_notes_rich_text_editing": "Notatki osobiste i zespołowe ze wzbogaconym formatowaniem tekstu",
          "effortlessly_share_meeting": "Łatwe rezerwacje dzięki udostępnianiu przedziałów czasowych na spotkanie",
          "works_with_zoom_meeting_mail_calender_google_ms": "Współpraca z Zoom Meetings, Zoom Mail i Zoom Calendar, Google i Microsoft 365",
          "up_to_300_attendees": "Do 300 uczestników",
          "10_gb_of_storage": "10 GB pamięci",
          "host_meeting_up_to_300_participants": "Hostuj spotkania do 300 uczestnik\u00F3w",
          "10_gb_of_cloud_recording_storage": "10 GB pamięci do nagrywania w chmurze (na licencję)",
          "starting_at_licenses_year": "Ju\u017C od {1} licencji za {0}/rok",
          "starting_at_licenses_month": "Ju\u017C od {1} licencji za {0}/miesi\u0105c",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Zdobądź szybki dostęp do podsumowań spotkań, wsparcia w pisaniu wiadomości i innych funkcji",
          "learn_more": "Dowiedz si\u0119 wi\u0119cej",
          "essential_apps": "Niezbędne aplikacje",
          "increase_team_collaboration": "Zwiększ współpracę i produktywność zespołu",
          "free_premium_apps": "Bezpłatne aplikacje premium przez 1 rok (obowiązują warunki)",
          "visitor_management": "Zarządzanie gośćmi",
          "visitor_management_custom_invites": "Personalizuj zaproszenia",
          "visitor_management_visitor_check": "Rejestruj się w kiosku",
          "visitor_management_receive_detailed": "Uzyskaj szczegółowe dane dotyczące wykorzystania miejsc przez gości"
        },
        "custom_avatar": {
          "title": "Awatar niestandardowy",
          "label_text": "3 minuty miesięcznie",
          "basic_feature": "1 minuta na cały okres użytkowania",
          "pricing_feature": "3 minuty miesięcznie",
          "learn_more_subtitle": "Stwórz realistyczną wersję siebie dzięki replikacji głosu i komunikacji wielojęzycznej.",
          "features_item1": "Stwórz do 3 realistycznych cyfrowych awatarów każdego miesiąca, które odtworzą Twój wygląd i głos na potrzeby prezentacji i demonstracji",
          "features_item2": "Użyj swojego awatara do odtwarzania skryptów o długości do 3 minut z AI Companion",
          "features_item3": "Wybierz spośród 18 wstępnie zaprojektowanych awatarów do szybkiego tworzenia wysokiej kwaliteit wideo",
          "features_item4": "Obsługa wirtualnego tła",
          "features_item1_opc": "Stwórz do 3 realistycznych cyfrowych awatarów każdego miesiąca, które odtworzą Twój wygląd i głos na potrzeby prezentacji i demonstracji",
          "features_item2_opc": "Użyj swojego awatara do odtwarzania skryptów o długości do 3 minut z AI Companion",
          "comparison_table_tips": "Funkcja awatara niestandardowego stworzy Twoją realistyczną wersję za pomocą AI, korzystając z replikacji głosu i komunikacji wielojęzycznej."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Zdobądź szybki dostęp do podsumowań spotkań, wsparcia w pisaniu wiadomości i innych funkcji",
        "learn_more_dialog": {
          "desc": "Osiągaj więcej z asystentem AI Companion! Może pisać treści, planować spotkania, pomagać w zarządzaniu projektami i nie tylko.",
          "tip1": "Otrzymuj agendy z wyprzedzeniem, aby spotkania były bardziej efektywne",
          "tip2": "Realizuj projekty na bieżąco dzięki zautomatyzowanemu tworzeniu zadań i powiadomieniom",
          "tip3": "Korzystaj z pomocy w prowadzeniu kalendarza i zarządzaniu czasem",
          "tip4": "Generuj pisemne i wizualne treści, które pasują do Twojego stylu w Docs, Whiteboard lub aplikacji Zoom Workplace"
        },
        "top_features": "Główne cechy",
        "more_to_come": "Jeszcze więcej niesamowitych funkcji już wkrótce!",
        "discover_more": "Odkryj jeszcze więcej sposobów na wydajną pracę dzięki AI Companion!",
        "detail_desc": "Asystenta AI Companion dołączamy bezpłatnie do płatnych usług Zoom dostępnych w ramach konta użytkownika. Wybrane sektory i lokalizacje mogą być wykluczone."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/rok/licencja",
        "month_licnese": "/miesiąc za licencję",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/miesiąc",
          "per_year": "/rok"
        },
        "unit": {
          "license": "{0}/licencja",
          "user": "{0}/użytkownik"
        },
        "learn_more": "Dowiedz się więcej",
        "required": "Wymagane",
        "zoom_one_required": "Wymagana licencja Zoom Workplace",
        "large": {
          "features_tip": "Rozszerz swój zasięg, zwiększając liczbę uczestników nawet do 1000.",
          "label_title1": "500 uczestników",
          "label_title2": "1000 uczestników"
        },
        "cmr": {
          "features_tip": "Przechowuj, przesyłaj strumieniowo i pobieraj nagrania wideo bezpośrednio z chmury Zoom.",
          "explain_desc": "Pamięć w chmurze jest zawarta w wybranych planach Zoom One: Dla profesjonalistów (5 GB), Dla firm (5 GB), Dla firm Plus (10 GB) i Dla przedsiębiorstw (nieograniczona)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "ok. 100 godz.",
          "option_label2": "ok. 650 godz.",
          "option_label3": "ok. 3,500 godz.",
          "option_label4": "ok. 17,500 godz.",
          "intro_label2": "Opcje przechowywania danych obejmują do 5 TB/miesiąc",
          "tooltip_content": "Możliwości przechowywania nagrań różnią się w zależności od liczby uczestników transmisji wideo, rozdzielczości spotkania oraz rozdzielczości udostępnianych treści."
        },
        "whiteboard": {
          "plus_title": "Tablica Plus",
          "title": "Whiteoard",
          "features_tip": "Pracuj z innymi osobami nad tablicami w czasie rzeczywistym, zarówno podczas spotkań, jak i poza nimi.",
          "explain_desc": "Produkt dostępny w ramach planów Zoom One Dla firm, Zoom One Dla firm Plus oraz Zoom One Dla przedsiębiorstw",
          "explain_desc_plus": "Usługa dostępna w ramach planu Zoom One Dla przedsiębiorstw Plus i każdej subskrypcji Zoom Rooms",
          "option_label1": "Nieograniczona liczba tablic o pojemności 1 GB w chmurze",
          "option_label2": "Zaawansowane funkcje z nieograniczoną liczbą tablic i przechowywaniem w chmurze",
          "intro_label1": "Nieograniczona liczba jednocześnie edytowalnych tablic",
          "intro_label2": "Standardowe funkcje i zaawansowane sterowanie dokumentem",
          "intro_label3": "Zaawansowane funkcje tablicy, w tym niestandardowe i organizacyjne szablony oraz integracje stron trzecich"
        },
        "translated_captions": {
          "features_tip": "Wspieraj globalną współpracę dzięki możliwości wyświetlania automatycznych napisów w preferowanym języku.",
          "intro_label1": "Uczestnicy mogą sami włączać napisy oraz zmieniać języki.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Wyświetl obsługiwane języki"
        },
        "crc": {
          "features_tip": "Umożliwia udział dowolnego punktu końcowego wideokonferencji opartego na standardach SIP/H.323 na potrzeby efektywnej pracy hybrydowej.",
          "intro_label1": "Współpraca z wieloma starszymi punktami końcowymi, w tym Polycom, Cisco, Lifesize i innymi",
          "intro_label2": "Oparty na chmurze lub lokalny (VM) dodatek pokoju"
        },
        "scheduler": {
          "simplify_bookings": "Uproszczenie rezerwacji dzięki elastycznej dostępności i konfigurowalnym przedziałom czasowym",
          "host_one_on_one": "Organizowanie spotkań indywidualnych lub grupowych za pomocą jednego linku do łatwego udostępniania",
          "customize_reminders": "Dostosowywanie przypomnień e-mail/SMS-owych, aby nikogo nie zabrakło na spotkaniu",
          "sync_calendars": "Płynna synchronizacja kalendarzy z integracjami Google, Microsoft 365 i Zoom",
          "features_tip": "Łatwe ustalanie godzin pracy, rozmów kwalifikacyjnych i innych wydarzeń dzięki udostępnianiu przedziałów czasowych na spotkanie.",
          "intro_label1": "Integracja kalendarza",
          "intro_label2": "Cykliczna dostępność",
          "intro_label3": "Skalowalne spotkania",
          "intro_label4": "Personalizowane powiadomienia",
          "intro_sub_label1": "Google, Microsoft 365 i Zoom ",
          "intro_sub_label2": "Udostępnianie przedziałów czasowych z możliwością rezerwowania ",
          "intro_sub_label3": "Pojedyncze spotkanie dla co najmniej jednego uczestnika",
          "intro_sub_label4": "Automatyczne powiadomienia i potwierdzenia e-mail lub SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Nagrywaj, edytuj i udostępniaj wysokiej jakości krótkie wiadomości wideo.",
          "intro_label1": "Twórz nieograniczoną liczbę filmów bez limitów czasowych",
          "intro_label2": "Przechwytuj ekran i wideo razem lub osobno",
          "intro_label3": "Przycinaj swoje filmy do woli i udostępniaj linki",
          "intro_label4": "Korzystaj z zaawansowanych funkcji, takich jak transkrypcje audio i statystyki",
          "explain_desc": "Usługa Zoom Clips Plus jest dostępna w ramach planów Zoom Workplace Dla profesjonalistów, Zoom Workplace Dla firm i Zoom Workplace Dla przedsiębiorstw. Możesz zapoznać się z różnymi funkcjami każdego planu w sekcji porównania na stronie z cennikiem."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Zaawansowana platforma do prowadzenia wydarzeń z niezawodnymi funkcjami rejestracji i networkingu. Idealne rozwiązanie do środowisk wirtualnych i hybrydowych.",
          "tooltip_content": "Organizuj nieograniczoną liczbę webinarów lub wydarzeń dla wybranej przez Ciebie liczby uczestników",
          "intro_title": "Wszystko, co w Zoom Sessions",
          "intro_label1": "Zwiększ zaangażowanie publiczności dzięki wydarzeniom wielosesyjnym",
          "intro_label2": "Z łatwością organizuj wydarzenia dzięki konfigurowalnemu biletowaniu i aplikacji mobilnej",
          "intro_label3": "Zwiększ przychody wydarzeń dzięki funkcji Expo Floor i obszarowi sponsorów",
          "intro_label4": "Wspieraj nawiązywanie kontaktów między uczestnikami dzięki personalizowanym profilom",
          "intro_label5": "Zwiększ zasięg dzięki odtwarzaniu na żądanie w lobby wydarzenia",
          "intro_label6": "Przyspiesz przygotowanie wydarzenia dzięki dopracowanym szablonom wydarzeń",
          "events_feature_item1_20240827": "Organizuj wielodniowe wydarzenia wirtualne z wieloma ścieżkami",
          "events_feature_item2_20240827": "Promuj nawiązywanie kontaktów dzięki profilom uczestników i czatowi w holu",
          "events_feature_item3_20240827": "Przekaż uczestnikom wskazówki poprzez transmisję w holu",
          "events_feature_item4_20240827": "Zwiększ przychody z wydarzenia dzięki wirtualnej wystawie i sponsorom",
          "events_feature_item5_20240827": "Ulepszaj przyszłe wydarzenia za pomocą ankiet pokonferencyjnych",
          "events_feature_item6_20240827": "Przyspiesz przygotowanie wydarzenia dzięki dopracowanym szablonom wydarzeń",
          "attendees_start_at": "{0} uczestników już od",
          "explain_desc": "Dowiedz się więcej o Zoom Events",
          "contact_account_owner": "Jeśli chcesz kupić plan Zoom Events, <a href=\"/account\" target=\"_blank\">skontaktuj się z właścicielem konta</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Upraszczaj interaktywne wydarzenia jednosesyjne z funkcjami takimi jak branding wydarzenia, współpraca wielu prowadzących i zarządzanie wydarzeniem.",
          "tooltip_content": "Organizuj nieograniczoną liczbę webinarów lub wydarzeń dla wybranej przez Ciebie liczby uczestników",
          "intro_title": "Obejmuje Zoom Webinars",
          "intro_label1": "Dostosuj strony docelowe wydarzeń, dodając branding",
          "intro_label2": "Promuj wydarzenia za pomocą e-maili z wizerunkiem Twojej marki",
          "intro_label3": "Mierz wydajność za pomocą interaktywnego pulpitu nawigacyjnego",
          "intro_label4": "Bezproblemowa współpraca ze współprowadzącymi i współedytorami",
          "intro_label5": "Profesjonalne narzędzia do organizacji wydarzeń: Simulive",
          "sessions_feature_item1_20240827": "Podnieś jakość webinarów dzięki niestandardowym tłom i brandingowi",
          "sessions_feature_item2_20240827": "Uprość planowanie wydarzeń dzięki rozwiązaniu AI Companion do generowania wiadomości i obrazów",
          "sessions_feature_item3_20240827": "Promuj przeszłe i przyszłe wydarzenia w hubie treści marki",
          "sessions_feature_item4_20240827": "Prowadź profesjonalne wydarzenia za pomocą narzędzi Backstage, Simulive i RTMP",
          "sessions_feature_item5_20240827": "Ulepszaj przyszłe webinary dzięki analizom z różnych wydarzeń",
          "explain_desc": "Dowiedz się więcej o Zoom Sessions",
          "contact_account_owner": "Jeśli chcesz kupić plan Zoom Sessions, <a href=\"/account\" target=\"_blank\">skontaktuj się z właścicielem konta</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Webinar",
          "features_tip": "Z łatwością transmituj wiadomości dzięki przyjaznej w obsłudze platformie webinarowej.",
          "tooltip_content": "Organizuj nieograniczoną liczbę webinarów lub wydarzeń dla wybranej przez Ciebie liczby uczestników",
          "intro_label1": "Angażuj odbiorców dzięki webcastom wideo wysokiej jakości",
          "intro_label2": "Zwiększ zaangażowanie dzięki sesjom pytań i odpowiedzi, ankietom i reakcjom",
          "intro_label3": "Popraw strategię organizacji webinarów dzięki raportowaniu po wydarzeniu",
          "intro_label4": "Obsługuje do 100 000 uczestników i 100 panelistów",
          "monthly_subscription": "Miesięczna subskrypcja",
          "annual_subscription": "Roczna subskrypcja",
          "one_million": "Milion",
          "single_use": "Jednorazowo",
          "one_month": "Jeden miesiąc",
          "event_attendee": "Uczestnicy wydarzeń/sesji:",
          "event_attendee_desc": "każdy, kto dołącza, nie będąc prowadzącym z licencją w hubie. Role specjalne są również liczone jako uczestnicy i mogą brać udział za pomocą audio, wideo i udostępniania ekranu (jeśli jest włączone).",
          "webinar_attendee": "Uczestnicy webinarów:",
          "webinar_attendee_desc": "każdy, kto dołącza, ale nie jest prowadzącym ani panelistą. Ma dostępny tylko tryb oglądania i podlega kontroli przez prowadzącego, który może wyłączyć mu wyciszenie i umożliwić interakcję za pośrednictwem sesji pytań i odpowiedzi oraz czatu.",
          "pay_per_attendee": "Opłata za uczestnika",
          "attendees": "uczestnicy"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Zmień sposób pracy swoich zespołów dzięki platformie do współpracy opartej na sztucznej inteligencji.",
          "label_title1": "Workplace Dla profesjonalistów",
          "label_title2": "Workplace Dla profesjonalistów Plus",
          "label_title3": "Workplace Dla firm",
          "label_title4": "Workplace Dla firm Plus",
          "intro_label1": "Organizuj nielimitowane spotkania trwające do 30 godzin z nawet 100 uczestnikami",
          "intro_label2": "Uzyskaj dostęp do 3 jednocześnie edytowalnych tablic ze standardowymi funkcjami",
          "intro_label3": "Nagrywaj, edytuj i udostępniaj wysokiej jakości krótkie wiadomości wideo z Clips Plus",
          "intro_label4": "Pracuj wydajniej dzięki Zoom AI Companion",
          "intro_label5": "Nielimitowany plan Zoom Phone w USA i Kanadzie (z wyłączeniem BYOC, PBX i PBX innych firm)",
          "intro_label6": "Organizuj nielimitowane spotkania trwające do 30 godzin z nawet 100 uczestnikami",
          "intro_label7": "Udostępniaj przedziały czasowe na konsultacje, rozmowy kwalifikacyjne i nie tylko za pomocą Zoom Scheduler",
          "intro_label8": "Zoom Phone USA i Kanada — nielimitowane",
          "intro_label8_UK": "Zoom Phone Wielka Brytania i Irlandia — nielimitowane",
          "intro_label8_AU": "Zoom Phone Australia i Nowa Zelandia — nielimitowane",
          "intro_label8_JP": "Zoom Phone Japonia — nielimitowane",
          "intro_label9": "Zarządzanie gośćmi",
          "intro_label10": "Funkcje dodatkowe",
          "intro_label11": "Wsparcie w postaci czatu na żywo",
          "intro_title1": "Wszystko to, co w planie Dla profesjonalistów oraz:",
          "intro_title2": "Wszystko, co w planie Dla firm oraz:",
          "intro_label_tip1": "Zoom Phone w ramach planu Dla profesjonalistów Plus nie obejmuje funkcji BYOC, PBX innej firmy ani VDI. Aby uzyskać więcej informacji, sprawdź stronę z cennikiem Zoom Phone.",
          "intro_label_tip2": "Przy kasie możesz wybrać Nielimitowane połączenia krajowe w Stanach Zjednoczonych i Kanadzie, Australii i Nowej Zelandii, Wielkiej Brytanii i Irlandii lub w Japonii.",
          "intro_label_tip3": "Dodatkowe funkcje obejmują 10 GB pamięci do nagrywania w chmurze, przetłumaczone napisy i rezerwację miejsc do pracy.",
          "intro_label_tip4": "Zoom Phone w ramach planu Dla profesjonalistów Plus nie obejmuje funkcji BYOC, PBX innej firmy ani VDI. Aby uzyskać więcej informacji, sprawdź stronę z cennikiem Zoom Phone."
        },
        "power_pack": {
          "title": "Pakiet Zoom Phone Power Pack",
          "features_tip": "Ulepszone analizy kolejek połączeń i dane historyczne dla zespołów w call center.",
          "intro_label1": "Rozszerzone okno kontaktów usprawniające obsługę połączeń",
          "intro_label2": "Numery telefonów automatycznej recepcjonistki i kolejki połączeń"
        },
        "international_calling": {
          "title": "Połączenia międzynarodowe",
          "features_tip": "Nielimitowane połączenia międzynarodowe do ponad 15 krajów i regionów.",
          "intro_label1": "Opcję tę można nabyć wraz z dowolnym nieograniczonym planem połączeń",
          "intro_label2": "Poznaj listę obsługiwanych krajów i regionów z nielimitowanymi połączeniami międzynarodowymi.",
          "intro_labe2_tooltip": "Stany Zjednoczone, Kanada, Wielka Brytania, Irlandia, Australia, Nowa Zelandia, Austria, Dania, Francja, Niemcy, Włochy, Portugalia, Hiszpania, Szwecja, Belgia, Holandia, Szwajcaria, Portoryko i Japonia.",
          "intro_label2_view_list": "Wyświetl listę"
        },
        "workspace_reservation": {
          "title": "Rezerwacja miejsca do pracy",
          "intro_title": "Łatwo rezerwować elastyczne miejsca pracy lub pokoje hotelowe z wyprzedzeniem lub na miejscu, za pomocą urządzeń zintegrowanych z Zoom.",
          "intro_label1": "Dostęp do przestrzeni roboczej i rezerwacji hoteli za pośrednictwem aplikacji Zoom Workplace, komputera lub przeglądarki.",
          "intro_label2": "Otrzymywanie spersonalizowanych rekomendacji dotyczących biurka dzięki pomocy sztucznej inteligencji",
          "intro_label3": "Rezerwacja miejsc pracy bezpośrednio z Kalendarza Google lub Outlooka, z przypomnieniami i powiadomieniami o zameldowaniu",
          "intro_label4": "Nawigacja do zarezerwowanych obszarów roboczych za pomocą funkcji odnajdywania drogi"
        },
        "visitor_management": {
          "title": "Zarządzanie gośćmi",
          "intro_title": "Usprawniona rejestracja gości dzięki niestandardowym zaproszeniom, łatwej rejestracji w kiosku, raportowaniu i wskaźnikom.",
          "intro_label1": "Zarządzanie zaproszeniami, lokalizacjami gości i historią wizyt w portalu Zoom",
          "intro_label2": "Tworzenie, śledzenie, ponowne wysyłanie i usuwanie zaproszeń w momencie otrzymywania powiadomień o przybyciu gości",
          "intro_label3": "Sprawna obsługa gości dzięki wypełnianiu formularzy, wskazywaniu drogi i rejestracji za pośrednictwem kiosku",
          "intro_label4": "Łatwe zarządzanie dzięki dostępowi do wszystkich funkcji w znanym portalu Zoom"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Duże spotkanie",
          "description1": "Zwiększ pojemność spotkana, aby obsłużyć nawet 1000 interaktywnych uczestników na żywo",
          "description2": "Wszyscy uczestnicy mogą udostępniać głos, wideo i ekran"
        },
        "cloud_storage": {
          "title": "Przestrzeń w chmurze",
          "description2": "Dostępne formaty plików MP4 lub M4A"
        },
        "translated_captions": {
          "title": "Przetłumaczone napisy",
          "description1": "Popraw obsługę spotkania dzięki zautomatyzowanym, wielojęzykowym napisom; uczestnicy będą mogli włączyć i przejść na obsługiwaną wersję językową",
          "description2": "Funkcja dostępna w ramach Zoom Meetings i Zoom Webinars"
        },
        "tollfree": {
          "title": "Opcje konferencji głosowej",
          "subcontent": "Dołączaj do spotkań za pomocą numerów telefonu z całego świata",
          "description1": "Rozszerz swoje opcje połączeń głosowych dzięki funkcji Wywołaj, globalnym numerom bezpłatnym i lokalnemu wybieraniu w krajach o podwyższonej opłacie",
          "description2": "Brak opłat dla uczestników dołączających z dowolnego urządzenia",
          "description3": "Wybieraj z łatwością spośród wielu krajów umożliwiających bezpłatne dołączanie do połączenia"
        },
        "rc": {
          "title": "Dodatek sali konferencyjnej"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentyna",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgia",
        "Brazil": "Brazylia",
        "Bulgaria": "Bułgaria",
        "Canada": "Kanada",
        "Chile": "Chile",
        "China": "Chiny",
        "Colombia": "Kolumbia",
        "Costa_Rica": "Kostaryka",
        "Croatia": "Chorwacja",
        "Cyprus": "Cypr",
        "Czech_Republic": "Czechy",
        "Denmark": "Dania",
        "Ecuador": "Ekwador",
        "Estonia": "Estonia",
        "Finland": "Finlandia",
        "France": "Francja",
        "Germany": "Niemcy",
        "Greece": "Grecja",
        "Hong_Kong_SAR": "Hongkong (Specjalny Region Administracyjny)",
        "Hungary": "Węgry",
        "Ireland": "Irlandia",
        "Israel": "Izrael",
        "Italy": "Włochy",
        "Japan": "Japonia",
        "Latvia": "Łotwa",
        "Lithuania": "Litwa",
        "Luxembourg": "Luksemburg",
        "Mexico": "Meksyk",
        "Netherlands": "Holandia",
        "New_Zealand": "Nowa Zelandia",
        "Norway": "Norwegia",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Polska",
        "Portugal": "Portugalia",
        "Puerto_Rico": "Portoryko",
        "Romania": "Rumunia",
        "Singapore": "Singapur",
        "Slovakia": "Słowacja",
        "Slovenia": "Słowenia",
        "South_Africa": "Republika Południowej Afryki",
        "Spain": "Hiszpania",
        "Sweden": "Szwecja",
        "Switzerland": "Szwajcaria",
        "UK": "Uk",
        "United_Kingdom": "Zjednoczone Królestwo",
        "US": "US",
        "United_States": "Stany Zjednoczone",
        "title": "Wymagania dotyczące numeru telefonu",
        "subtitle": "Wybierz kraj, w którym ma zostać aktywowany Twój numer telefonu Global Select.",
        "selector_tip": "Wybierz kraj",
        "local_and_toll_free": "Numery lokalne i bezpłatne są dostępne w wybranym kraju ({0})",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Plan Global Select obejmuje jeden numer telefonu i nielimitowane połączenia krajowe w wybranym kraju w ramach jednej licencji.",
        "avail_title": "Dostępne kraje/terytoria"
      },
      "tax_exempt_ecm": {
        "title": "Status zwolnienia z podatku",
        "status_exempt": "Zwolnienie z podatku",
        "status_exempt_question": "Zwolnienie z podatku?",
        "verify_now": "Zweryfikuj teraz",
        "can_after_checkout": "Opcjonalnie ten krok można zakończyć po dokonaniu zakupu.",
        "status": {
          "exempt": "Zwolnienie",
          "pending": "W oczekiwaniu",
          "pendingTooltip": "Twój status zwolnienia z podatku jest obecnie w trakcie weryfikacji. Przy składaniu zamówienia może zostać naliczony podatek. Jeśli zwolnienie zostanie zatwierdzone, wszystkie podlegające zwrotowi podatki/opłaty zostaną przelane na konto użytkownika.",
          "nonexempt": "Brak zwolnienia",
          "rejected": "Odrzucono",
          "rejectedTooltip": "Ustalono, że złożony dokument nie spełnia wymagań obowiązujących w twojej jurysdykcji.",
          "approved": "Zatwierdzono",
          "default": "domyślne"
        },
        "confirm_close": {
          "new_desc": "Jeśli zrezygnujesz z weryfikacji, możemy obciążyć Cię stosownymi podatkami/opłatami. Dokument zwolnienia z podatku możesz też przesłać w sekcji Zarządzanie rozliczeniami po zakupie w celu sprawdzenia i zatwierdzenia przez Zoom. Po zatwierdzeniu zostanie wydany zwrot wszelkich naliczonych podatków.",
          "desc": "Czy na pewno chcesz zrezygnować z weryfikacji zwolnienia podatkowego i kontynuować jako podmiot podlegający opodatkowaniu?",
          "title": "Czy na pewno tego chcesz?",
          "new_title": "Zrezygnować z weryfikacji zwolnienia podatkowego?",
          "yes": "Tak, zrezygnuj",
          "no": "Nie, kontynuuj",
          "abandon": "Porzuć weryfikację",
          "go_back": "Przejdź wstecz"
        },
        "confirm_to_add": {
          "title": "Potwierdź nowe domyślne zwolnienie z podatku",
          "message": "Dodanie nowego zwolnienia spowoduje automatyczne ustawienie go jako domyślnego po zatwierdzeniu lub odrzuceniu. Możesz mieć tylko jedno domyślne zwolnienie, które będzie miało zastosowanie do przyszłych zakupów. Kwota podatku może ulec zmianie, jeśli domyślne zwolnienie nie jest zgodne ze stanem/regionem nabywcy.",
          "yes": "Dodaj nowe zwolnienie"
        },
        "confirm_set_default": {
          "title": "Niezgodność adresu i zwolnienia podatkowego",
          "message": "Adres w polu „Osoba kontaktowa nabywcy” nie pasuje do stanu/regionu wybranego na potrzeby zwolnienia z podatku. Zaktualizuj adres w polu „Osoba kontaktowa nabywcy”, aby odpowiadał lokalizacji na potrzeby zwolnienia podatkowego. W przeciwnym razie zakup może nie być zwolniony z podatku.",
          "yes": "Ustaw jako domyślne mimo to",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Stan/region",
          "exemption_type": "Typ zwolnienia",
          "signed_date": "Data podpisania",
          "status": "stan obecności",
          "add_exemption": "Dodaj zwolnienie",
          "view": "Widok",
          "set_as_default": "Ustaw jako domyślne"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Twój plan {planName} zostanie anulowany w dniu {date} o godzinie 12:00 czasu uniwersalnego koordynowanego (UTC). Jeśli chcesz zorganizować wydarzenie po dacie anulowania, aktywuj ponownie swój plan.",
        "pairPreDescTip": "Twoje plany {planName1} i {planName2} zostaną anulowane w dniu {date} o godzinie 12:00 czasu uniwersalnego koordynowanego (UTC). Jeśli chcesz zorganizować wydarzenie po dacie anulowania, aktywuj ponownie swoje plany.",
        "pairDiffDatePreDescTip": "Twoje plany {planName1} i {planName2} zostaną anulowane odpowiednio {date1} o godzinie 12:00 UTC i {date2} o godzinie 12:00 UTC. Jeśli chcesz zorganizować wydarzenie po dacie anulowania, aktywuj ponownie swoje plany.",
        "title": "Aktywuj ponownie swój plan, aby kontynuować",
        "titles": "Aktywuj ponownie swoje plany, aby kontynuować",
        "plan": "Plan",
        "licenses": "Liczba licencji",
        "billingCycle": "Cykl rozliczeniowy",
        "effective_date": "Data wejścia w życie",
        "invoice_amount": "Kwota na fakturze",
        "singleDescTip": "Dokonując ponownej aktywacji, wyrażasz zgodę na automatyczne odnowienie planu cyklicznego w dniu {date}, a wybrana metoda płatności zostanie obciążona za każdy okres odnowienia. Aby uniknąć przyszłych opłat, <a target=\"_blank\" href=\"https://support.zoom.com/hc/pl/article?id=zm_kb&sysparm_article=KB0066687\">anuluj</a> do dnia poprzedzającego datę odnowienia.",
        "pairDescTip": "Dokonując ponownej aktywacji, wyrażasz zgodę na automatyczne odnowienie planów cyklicznych w dniu {date}. Wybrana metoda płatności zostanie obciążona za każdy okres odnowienia. Aby uniknąć przyszłych opłat, <a target=\"_blank\" href=\"https://support.zoom.com/hc/pl/article?id=zm_kb&sysparm_article=KB0066687\">anuluj</a> do dnia poprzedzającego datę odnowienia.",
        "pairDiffDateDescTip": "Dokonując ponownej aktywacji, wyrażasz zgodę na automatyczne odnawianie planów cyklicznych w dniu {date1} i {date2}. Wybrana metoda płatności zostanie obciążona za każdy okres odnowienia. Aby uniknąć przyszłych opłat, <a target=\"_blank\" href=\"https://support.zoom.com/hc/pl/article?id=zm_kb&sysparm_article=KB0066687\">anuluj</a> do dnia poprzedzającego datę odnowienia.",
        "totalLabel": "Łącznie",
        "totalContent": "{money} plus obowiązujące podatki",
        "taxDesc": "bez VAT, GST lub podobnych podatków",
        "reactivateBtn": "Kontynuuj i aktywuj ponownie",
        "switchTitle": "Zaktualizuj swój plan, aby kontynuować",
        "successSingleTip": "Twój plan {planName} został aktywowany ponownie",
        "successPairTip": "Twoje plany {planName1} i {planName2} zostały aktywowane ponownie",
        "switchTip": "Twój jednomiesięczny plan Zoom Webinars wygasa w dniu {date}. Aby zorganizować webinar po tej dacie, musisz przejść na plan subskrypcyjny.",
        "switchBtn": "Przejdź na subskrypcję"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace dla firm"
      },
      "proPlus": {
        "title": "Zoom Workplace dla profesjonalistów Plus"
      },
      "bizPlus": {
        "title": "Plan Zoom Workplace Dla firm Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Pobierz arkusz danych"
      },
      "one": {
        "new": "NOWY"
      }
    },
    "webinarSetupInWebPortal": "Konfiguracja webinaru w portalu internetowym",
    "concurrentEvents": "Jednoczesne wydarzenia",
    "coucurrentEventsToolTip": "<span>Plan <b>subskrypcji</b> umożliwia organizację jednego wydarzenia na żywo naraz",
    "overages": "Opłaty za przekroczenie limitów",
    "eventsPlatformHubs": "Huby na platformie Zoom Events",
    "eventsHubToolTip": "<b>Huby</b> Zoom Events oferują wygodną organizację wydarzeń",
    "1HubPerLicense": "1 hub na licencję",
    "1000Hubs": "1000 hubów",
    "eventsPlatformHosts_500AttendeesOrMore": "Prowadzący na platformie Zoom Events (500 uczestników lub więcej)",
    "eventsHost500": "<span><b>Prowadzący w hubie</b> Zoom Events mogą utworzyć",
    "5HubHosts": "5 prowadzących w hubie",
    "100HubHosts": "100 prowadzących w hubie",
    "eventsPlatformHosts_100Attendees": "Prowadzący na platformie Zoom Events (100 uczestników)",
    "eventsHost100": "<span><b>Prowadzący w hubie</b> Zoom Events mogą utworzyć",
    "2HubHosts": "2 prowadzących w hubie",
    "howAreTheyDifferent": "Czym się różnią?",
    "allPlansRequireAZoomOneLicense": "* Wszystkie plany wymagają licencji Zoom Workplace",
    "subscription": "Subskrypcja",
    "subscriptionToolTip": "<span><b>Subskrypcja</b> umożliwia organizację nieograniczonej liczby wydarzeń dla wybranej przez Ciebie liczby uczestników.</span>",
    "payPerAttendee": "Opłata za uczestnika",
    "ppaToolTips": "<span>Licencje typu <b>opłata za uczestnika</b> określają maksymalną liczbę uczestników wydarzeń wszystkich kont zorganizowanych w okresie 12 miesięcy od zakupu.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Przeprowadzanie ankiety",
    "meetings.fullPlanItem2": "Liczba licencji",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Uproszczone prowadzenie konferencji wideo i przesyłanie wiadomości poprzez dowolne urządzenia",
    "meetings.fullPlanItem5": "Czas trwania spotkania",
    "meetings.fullPlanItem5Tip": "Maksymalny czas trwania dozwolony na spotkanie grupowe (3 lub wi\u0119cej uczestnik\u00F3w).",
    "meetings.fullPlanItem5_basic": "40 min",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 godz.",
    "meetings.fullPlanItem5_biz": "30 godz.",
    "meetings.fullPlanItem5_ent": "30 godz.",
    "meetings.fullPlanItem1": "Liczba uczestnik\u00F3w",
    "meetings.fullPlanItem1Tip": "Uczestnicy mog\u0105 do\u0142\u0105czy\u0107 do Twojego spotkania bezp\u0142atnie z\u00A0telefonu, komputera stacjonarnego, urz\u0105dze\u0144 mobilnych i\u00A0tablet\u00F3w. Uczestnik nie potrzebuje konta Zoom, aby do\u0142\u0105czy\u0107 do spotkania. Ka\u017Cdy plan ma limit uczestnik\u00F3w, ale u\u017Cytkownicy mog\u0105 zwi\u0119kszy\u0107 ten limit w planach p\u0142atnych poprzez zakup rozszerze\u0144.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1000 w przypadku planu Dla przedsiębiorstw Plus</span>",
    "meetings.fullPlanItem7": "Nagranie",
    "meetings.fullPlanItem7Tip": "Aplikacja Zoom zapisuje lokalnie nagrania spotka\u0144 w formacie MP4 (wideo), M4A (g\u0142os) i txt (czat).<br>Nagrywanie w chmurze Zoom przechowuje spotkania w chmurze Zoom, sk\u0105d pliki mo\u017Cna pobra\u0107 i/lub przes\u0142a\u0107 strumieniowo z przegl\u0105darki.",
    "meetings.fullPlanItem7_basic": "Lokalne",
    "meetings.fullPlanItem7_pro": "Lokalne i 5 GB w chmurze (na licencj\u0119)",
    "meetings.fullPlanItem7_biz": "Lokalne i 10 GB w chmurze (na licencj\u0119)",
    "meetings.fullPlanItem7_ent": "Lokalne i nielimitowane w chmurze",
    "one.messaging": "Wiadomości",
    "meetings.fullPlanItem16Tip": "Czat umo\u017Cliwia \u0142atwe wysy\u0142anie grupowych wiadomo\u015Bci tekstowych, plik\u00F3w, zrzut\u00F3w ekranu, kawa\u0142k\u00F3w kodu, wiadomo\u015Bci g\u0142osowych oraz obraz\u00F3w. Tekst mo\u017Ce by\u0107 sformatowany, a u\u017Cytkownicy mog\u0105 r\u00F3wnie\u017C udost\u0119pnia\u0107 pliki GIF i emotikony. \u201EObecno\u015B\u0107\u201D wy\u015Bwietla, czy uczestnicy czatu s\u0105 aktywni na urz\u0105dzeniach stacjonarnych lub mobilnych, czy te\u017C zaj\u0119ci spotkaniami.",
    "meetings.fullPlanItem51": "Tablice Zoom",
    "meetings.unlimited": "Bez ogranicze\u0144",
    "meetings.fullPlanItem_EssentialApp": "Niezbędne aplikacje",
    "common.learnMore": "Dowiedz si\u0119 wi\u0119cej",
    "meetings.fullPlanItem_EssentialAppText": "Bezpłatne aplikacje premium przez 1 rok (obowiązują warunki)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail en Agenda in de Zoom-app",
    "mailService": "Mail-service",
    "emailServiceWithFullTimeEndToEnd": "E-mailservice met voltijdse end-to-endversleuteling voor meer privacy",
    "customMailDomain": "E-maildomein op maat",
    "customMailDomainWithMailService": "E-maildomein op maat met e-mailservice",
    "calendarClient": "Agenda-client",
    "scheduleAndJoinMeetings": "Plan vergaderingen en neem eraan deel in de Zoom-app",
    "aiCompanion": "Asystent AI Companion",
    "calendarService": "Agenda-service",
    "meetingSchedulingAndAppointment": "Plannen van vergaderingen en reserveren van afspraken",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Bezproblemowo twórz, edytuj i udostępniaj krótkie filmy. Zachowane wideoklipy są łatwe do znalezienia, przez co zwiększają zaangażowanie.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes oferuje solidny edytor dokumentów osobistych i zespołowych z rozbudowanymi opcjami formatowania, dostępnymi zarówno podczas spotkań, jak i poza nimi.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Przetłumaczone napisy",
    "workspaceReservation": "Rezerwacja obszaru roboczego",
    "accessAcrossAnyDevice": "Dostęp na każdym urządzeniu",
    "meetings.fullPlanItem4": "Nielimitowane spotkania",
    "meetings.fullPlanItem9": "Po\u0142\u0105czenia telefoniczne",
    "meetings.fullPlanItem9Tip": "Do\u0142\u0105cz do spotkania Zoom za po\u015Brednictwem telekonferencji / konferencji g\u0142osowej (u\u017Cywaj\u0105c tradycyjnego telefonu). U\u017Cytkownicy zostan\u0105 obci\u0105\u017Ceni op\u0142atami zgodnie z planem telefonicznym. Wypr\u00F3buj rozszerzenie do prowadzenia konferencji g\u0142osowych dla bezp\u0142atnych numer\u00F3w po\u0142\u0105cze\u0144.",
    "meetings.fullPlanItem9_pro": "P\u0142atne",
    "meetings.fullPlanItem9_biz": "P\u0142atne",
    "meetings.fullPlanItem9_ent": "P\u0142atne",
    "meetings.fullPlanItem11": "Udost\u0119pnianie ekranu",
    "meetings.fullPlanItem11Tip": "Udost\u0119pnianie pulpitu i aplikacji Licencjonowani u\u017Cytkownicy spotka\u0144 mog\u0105 zezwoli\u0107 wielu uczestnikom na jednoczesne udost\u0119pnianie ekran\u00F3w podczas hostowanego spotkania.",
    "meetings.fullPlanItem12": "Oddzielne pokoje",
    "meetings.fullPlanItem12Tip": "Oddzielne pokoje wideo pozwalaj\u0105 podzieli\u0107 spotkanie Zoom nawet na 50 oddzielnych sesji do dyskusji, projekt\u00F3w i\u00A0innych.",
    "meetings.fullPlanItem14": "Wirtualne t\u0142o",
    "meetings.fullPlanItem15": "Identyfikator osobistego spotkania",
    "meetings.fullPlanItem15Tip": "Utw\u00F3rz sw\u00F3j w\u0142asny sta\u0142y pok\u00F3j spotka\u0144 online. Mo\u017Cesz rozpocz\u0105\u0107 to spotkanie w dowolnym momencie lub zaplanowa\u0107 je na przysz\u0142o\u015B\u0107.",
    "meetings.fullPlanItem17": "Sterowanie przez prowadz\u0105cego",
    "meetings.fullPlanItem18": "Wsp\u00F3lne tworzenie notatek na udost\u0119pnionych ekranach",
    "meetings.fullPlanItem19": "Zdalne sterowanie klawiatur\u0105 i mysz\u0105",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Poczekalnia",
    "meetings.fullPlanItem29Tip": "Funkcja poczekalni umo\u017Cliwia hostowi kontrolowanie momentu do\u0142\u0105czenia uczestnika do spotkania. Jako host spotkania mo\u017Cesz wpu\u015Bci\u0107 uczestnik\u00F3w po kolei lub wszystkich naraz. W ustawieniach mo\u017Cesz wybra\u0107, kto zostaje wpuszczony do poczekalni, a kto zostanie automatycznie do\u0142\u0105czony do spotkania. Ka\u017Cde konto ma funkcj\u0119 poczekalni. Prowadz\u0105cy spotkania mog\u0105 wysy\u0142a\u0107 wiadomo\u015Bci do poczekalni. Mo\u017Cna dostosowa\u0107 poczekalni\u0119, je\u015Bli korzystasz z p\u0142atnego planu.",
    "meetings.fullPlanItem41": "Wbudowane w urz\u0105dzenia Zoom for Home",
    "meetings.fullPlanItem61": "Przypinanie wielu os\u00F3b",
    "meetings.fullPlanItem61Tip": "Host mo\u017Ce udzieli\u0107 9 osobom uprawnie\u0144 do przypinania wideo, aby umo\u017Cliwi\u0107 tworzenie w\u0142asnych, niestandardowych widok\u00F3w. Nie wa\u017Cne kto m\u00F3wi \u2013 przypi\u0119te obrazy wideo zostaj\u0105 widoczne.",
    "meetings.fullPlanItem62": "Wyr\u00F3\u017Cnianie wielu os\u00F3b",
    "meetings.fullPlanItem62Tip": "Host mo\u017Ce wyr\u00F3\u017Cni\u0107 do 9 obraz\u00F3w wideo uczestnik\u00F3w. W takim przypadku wyr\u00F3\u017Cnione obrazy wideo b\u0119d\u0105 widoczne dla wszystkich os\u00F3b na spotkaniu, niezale\u017Cnie od tego, kto m\u00F3wi.",
    "meetings.fullPlanNewItem1": "Filtry",
    "meetings.fullPlanNewItem1Tip": "Baw si\u0119 doskonale podczas radosnych spotka\u0144, imprez i innych wydarze\u0144, korzystaj\u0105c z zabawnych kolorowych filtr\u00F3w lub dekoracyjnych naklejek ze zwierz\u0119tami.",
    "meetings.fullPlanNewItem2": "Przeprowadzanie ankiety",
    "meetings.fullPlanNewItem3": "Wsp\u00F3\u0142prowadz\u0105cy i zast\u0119pca prowadz\u0105cego",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Dowiedz si\u0119 wi\u0119cej</a> o elementach sterowania dla wsp\u00F3\u0142prowadz\u0105cych spotkania.",
    "meetings.fullPlanItem24": "Przypisywanie osoby planuj\u0105cej spotkania",
    "meetings.fullPlanItem24Tip": "Umo\u017Cliwia przypisanie innej osoby do umawiania spotka\u0144 za Ciebie. Osoba przypisana musi r\u00F3wnie\u017C mie\u0107 plan Pro.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Zapewnia w\u0142a\u015Bcicielom kont, administratorom i deweloperom bezpieczny dost\u0119p do interfejsu REST API Zoom.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">Limity przepustowo\u015Bci API</a> s\u0105 stosowane na poziomie konta zgodnie z <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">typem konta</a> (Pro, Dla firm, Dla przedsi\u0119biorstw itp.) oraz <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">typem \u017C\u0105dania interfejsu API</a> (lekkie, umiarkowane, ci\u0119\u017Ckie itp.). Niekt\u00F3re interfejsy API maj\u0105 ograniczony dost\u0119p do wybranych typ\u00F3w konta. U\u017Cyj <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">limit\u00F3w przepustowo\u015Bci API</a> i <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">dokumentacji referencyjnej interfejsu API</a>, aby uzyska\u0107 wszystkie szczeg\u00F3\u0142owe informacje.",
    "meetings.fullPlanItem25_pro": "Limity przepustowo\u015Bci Pro REST API",
    "meetings.fullPlanItem25_biz": "Limity przepustowo\u015Bci REST API",
    "meetings.fullPlanItem26": "Interoperacyjno\u015B\u0107 ze Skype for Business (Lync)",
    "meetings.fullPlanItem26Tip": "Umo\u017Cliwia u\u017Cytkownikom Lync 2010, 2013 i\u00A0Skype for Business inicjowanie spotka\u0144 Zoom z\u00A0listy kontakt\u00F3w Lync.",
    "meetings.fullPlanItem27": "Transmisje strumieniowe",
    "meetings.fullPlanItem27Tip": "Korzystaj z transmisji strumieniowych do serwis\u00F3w Facebook, Youtube lub innych us\u0142ug stron trzecich.",
    "meetings.fullPlanItem28": "Raportowanie",
    "meetings.fullPlanItem28Tip": "Generuj raporty u\u017Cycia, aby dowiedzie\u0107 si\u0119, jak wiele spotka\u0144 ma miejsce, w kt\u00F3rych dniach si\u0119 odbywaj\u0105, ilu uczestnik\u00F3w bierze udzia\u0142, jak d\u0142ugo trwaj\u0105 itp.",
    "meetings.fullPlanItem30": "Zarz\u0105dzanie u\u017Cytkownikami",
    "meetings.fullPlanItem30Tip": "W\u0142a\u015Bciciele i administratorzy mog\u0105 dodawa\u0107, usuwa\u0107 i przypisywa\u0107 role i funkcje rozszerze\u0144.",
    "one.autoCaptions": "Napisy automatyczne",
    "meetings.fullPlanItem31": "Portal administratora",
    "meetings.fullPlanItem31Tip": "Zarz\u0105dzaj u\u017Cytkownikami w firmie na jednym koncie, aby cieszy\u0107 si\u0119 uproszczonymi rozliczeniami, zaawansowanymi ustawieniami zarz\u0105dzania u\u017Cytkownikami oraz kompleksow\u0105 analiz\u0105 u\u017Cycia \u2013 wszystko to w portalu administratora Zoom.",
    "meetings.fullPlanItem32": "Integracja LTI",
    "meetings.fullPlanItem32Tip": "Dodawa\u0107 z \u0142atwo\u015Bci\u0105 spotkania do dowolnych dzia\u0142a\u0144 edukacyjnych i zapraszaj odpowiednich student\u00F3w z systemu zarz\u0105dzania nauk\u0105 (rozwi\u0105zanie wsp\u00F3\u0142pracuje z Moodle, Canvas, Desire2Learn i Blackboard).",
    "meetings.fullPlanItem33": "Transkrypcje z nagra\u0144",
    "meetings.fullPlanItem33Tip": "Transkrypcje z nagra\u0144 w chmurze to transkrypcje wypowiedzi ze spotkania lub webinarium, kt\u00F3re zosta\u0142y zarejestrowane w chmurze. Nale\u017Cy pami\u0119ta\u0107, \u017Ce ta funkcja jest obecnie obs\u0142ugiwana wy\u0142\u0105cznie dla j\u0119zyka angielskiego. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Kliknij tutaj</a>, aby dowiedzie\u0107 si\u0119 wi\u0119cej.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Dodaj branding firmy do w\u0142asnej, spersonalizowanej strony, na kt\u00F3rej u\u017Cytkownicy mog\u0105 do\u0142\u0105cza\u0107 do spotka\u0144. Utw\u00F3rz obrandowany szablon wiadomo\u015Bci e-mail, aby wys\u0142a\u0107 zaproszenia do uczestnik\u00F3w.",
    "meetings.fullPlanItem35": "Domeny zarz\u0105dzane",
    "meetings.fullPlanItem35Tip": "U\u017Cyj domeny firmowego/uniwersyteckiego adresu e-mail, aby automatycznie doda\u0107 u\u017Cytkownik\u00F3w do swojego konta.",
    "meetings.fullPlanItem37": "T\u0142umaczenia j\u0119zykowe",
    "meetings.fullPlanItem37Tip": "Umo\u017Cliwia prowadz\u0105cym spotkania wyznaczenie t\u0142umaczy na spotkaniach i webinariach. Po rozpocz\u0119cia spotkania lub webinarium prowadz\u0105cy spotkanie mo\u017Ce w\u0142\u0105czy\u0107 funkcj\u0119 t\u0142umaczenia, dzi\u0119ki czemu t\u0142umacze zyskaj\u0105 dost\u0119p do w\u0142asnych kana\u0142\u00F3w g\u0142osowych. Uczestnicy mog\u0105 wybra\u0107 kana\u0142 g\u0142osowy, aby us\u0142ysze\u0107 wybrany j\u0119zyk. Uczestnicy b\u0119d\u0105 s\u0142ysze\u0107 t\u0142umaczenie i mog\u0105 wybra\u0107, czy chc\u0105 r\u00F3wnie\u017C s\u0142ysze\u0107 oryginalny g\u0142os z mniejsz\u0105 g\u0142o\u015Bno\u015Bci\u0105.",
    "meetings.fullPlanItem39": "Oceny zarz\u0105du",
    "meetings.fullPlanItem39Tip": "Szczeg\u00F3\u0142owa analiza trend\u00F3w przyj\u0119cia, \u015Bledzenie ROI, dyskusje nad planem produktu.",
    "meetings.fullPlanNewItem4": "Zawiera Webinar 500",
    "one.translatedCations": "Przetłumaczone napisy",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Czat bezpośredni, kanałowy lub grupowy",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Łatwa komunikacja w wiadomościach 1 na 1, w małych grupach lub z dużymi zespołami",
    "messageAndFileHistory": "Historia wiadomości i plików",
    "findPeopeChannelsAndFilesInSearch": "Znajdź osoby, kanały i pliki w ramach wyszukiwania",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Szybko wyszukuj kontakty, wiadomości i pliki, mając wiedzę i informacje na wyciągnięcie ręki.",
    "applicationIntegrations": "Integracje aplikacji",
    "secureFileSharing": "Bezpieczne udostępnianie plików",
    "enhanceCollaborationWithSeamlessFileSharing": "Usprawnij współpracę dzięki bezproblemowemu udostępnianiu plików",
    "persistentMeetingChat": "Stały czat podczas spotkania",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Zyskaj możliwość śledzenia rozmów w ramach spotkań na bieżąco. Komunikuj się przed, w trakcie i po spotkaniu na dedykowanym czacie zespołowym w Zoom Team Chat dla wszystkich uczestników spotkania.",
    "cloudStorage": "Pamięć w chmurze",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Kanały zwrotne do chmury Zoom Cloud lub innego dostawcy pamięci",
    "avatars": "Awatary",
    "inMeetingReactions": "Reakcje w trakcie spotkania",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Pokaż zaangażowanie i szybko porozumiewaj się z innymi uczestnikami w sposób niewerbalny",
    "virtualBackgrounds": "Wirtualne tła",
    "videoFilters": "Filtry wideo",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Wprowadź trochę zabawy na swoje spotkania dzięki różnym filtrom nakładanym na wideo",
    "inMeetingPollsAndQuizzes": "Ankiety i quizy podczas spotkania",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Twórz pytania jednokrotnego lub wielokrotnego wyboru w ramach swoich spotkań.",
    "liveStreamingAcrossPlatforms": "Transmisje na żywo na różnych platformach",
    "appearanceTouchUp": "Poprawa wyglądu",
    "originalSoundForMusicians": "Opcja korzystania z oryginalnego dźwięku dla muzyków",
    "endToEndEncryptionForZoomMeetings": "Szyfrowanie end-to-end Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Po włączeniu szyfrowanie end-to-end (E2EE) w Zoom dla Zoom Meetings zapewnia, że komunikacja pomiędzy wszystkimi uczestnikami spotkania korzystającymi z klientów Zoom podczas danego spotkania jest szyfrowana przy użyciu kluczy kryptograficznych znanych tylko urządzeniom tych uczestników. Gwarantuje to, że żadna strona trzecia — w tym Zoom — nie ma dostępu do prywatnych kluczy spotkania.",
    "zoomCustomerManagedKey": "Klucz Zoom zarządzany przez klienta",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Stosuj własne klucze szyfrowania, aby chronić dane Zoom",
    "enterpriseGradeSecurityFeatures": "Funkcje bezpieczeństwa dla przedsiębiorstw",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bitowe szyfrowanie AES-GCM dla treści w czasie rzeczywistym i mediów, szyfrowanie TLS podczas rejestracji SIP, maskowanie identyfikatora dzwoniącego, prywatny peering sieci, wykrywanie nadużyć narzędzia oraz lista zablokowanych",
    "phone.fullPlanItem40": "Logowanie jednokrotne przez SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Nielimitowane po\u0142\u0105czenia wewn\u0119trzne",
    "phone.fullPlanItem2": "Po\u0142\u0105czenia wychodz\u0105ce taryfowe",
    "phone.fullPlanItem3": "Nielimitowane po\u0142\u0105czenia wychodz\u0105ce",
    "phone.fullPlanItem4": "Wiod\u0105ca w bran\u017Cy jako\u015B\u0107 po\u0142\u0105cze\u0144 HD",
    "phone.fullPlanItem4Tip": "Z aktywnym t\u0142umieniem szum\u00F3w, echa i odg\u0142os\u00F3w klawiatury",
    "phone.fullPlanItem5": "Natywne aplikacje dla system\u00F3w Windows, MacOS i Linux",
    "phone.fullPlanItem6": "Natywne aplikacje mobilne dla system\u00F3w iOS i Android",
    "phone.fullPlanItem7": "Przenoszenie istniej\u0105cych numer\u00F3w lub kupno nowych (DID)",
    "phone.fullPlanItem8": "Numery bezp\u0142atne",
    "phone.fullPlanItem9": "Numery wewn\u0119trzne",
    "phone.fullPlanItem10": "Poczta g\u0142osowa z transkrypcj\u0105",
    "phone.fullPlanItem10Tip": "Dost\u0119p do transkrypcji poczty g\u0142osowej przez aplikacj\u0119 mobiln\u0105/komputerow\u0105 i e-mail",
    "phone.fullPlanItem11": "Nielimitowana liczba automatycznych uczestnik\u00F3w/IVR",
    "phone.fullPlanItem12": "Katalog wybierania wed\u0142ug nazwy",
    "phone.fullPlanItem13": "Automatyczne grupy dystrybucji po\u0142\u0105cze\u0144 (ACD) z kolejk\u0105 po\u0142\u0105cze\u0144",
    "phone.fullPlanItem14": "Do\u0142\u0105czanie w trakcie po\u0142\u0105czenia/monitorowanie/szeptanie/przej\u0119cie",
    "phone.fullPlanItem15": "Routing w przypadku urlop\u00F3w i godzin pracy",
    "phone.fullPlanItem16": "3-kierunkowe po\u0142\u0105czenia konferencyjne ad hoc",
    "phone.fullPlanItem17": "Nagrywanie po\u0142\u0105cze\u0144",
    "phone.fullPlanItem17Tip": "Dost\u0119pne s\u0105 funkcje automatycznego i r\u0119cznego nagrywania po\u0142\u0105cze\u0144. Nagrywanie przez ca\u0142y czas i na \u017C\u0105danie z transkrypcjami",
    "phone.fullPlanItem18": "Konfigurowalne blokowanie po\u0142\u0105cze\u0144 anonimowych i okre\u015Blonych",
    "phone.fullPlanItem19": "Po\u0142\u0105czenia w nag\u0142ych wypadkach",
    "phone.fullPlanItem19Tip": "Po\u0142\u0105czenia do lokalnych s\u0142u\u017Cb ratunkowych",
    "phone.fullPlanItem20": "Adresowanie Nomadic E911 (USA i Kanada) \u2013",
    "phone.fullPlanItem20Tip": "Dynamiczne wykrywanie lokalizacji u\u017Cytkownika i przekazywanie odpowiedniego adresu do kontaktu w nag\u0142ym wypadku do lokalnych s\u0142u\u017Cb ratunkowych (tylko USA i Kanada) oraz do wewn\u0119trznego zespo\u0142u bezpiecze\u0144stwa",
    "phone.fullPlanItem21": "Centrum reagowania w nag\u0142ych wypadkach",
    "phone.fullPlanItem21Tip": "Zapewnij swoim wewn\u0119trznym zespo\u0142om bezpiecze\u0144stwa powiadomienia w przypadku wezwa\u0144 w nag\u0142ych wypadkach oraz rejestruj/monitoruj/do\u0142\u0105czaj do po\u0142\u0105cze\u0144 w nag\u0142ych wypadkach, aby pomaga\u0107 w koordynowaniu pomocy.",
    "phone.fullPlanItem22": "Wygl\u0105d/delegowanie dzielonej linii",
    "phone.fullPlanItem23": "Przekazywanie po\u0142\u0105cze\u0144 pomi\u0119dzy urz\u0105dzeniami",
    "phone.fullPlanItem24": "Parkowanie po\u0142\u0105cze\u0144",
    "endToEndEncryptionForZoomPhone": "Szyfrowanie end-to-end w Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Po włączeniu w przypadku funkcji Zoom Phone szyfrowanie end-to-end (E2EE) upewnia się, że połączenie jest szyfrowane przy użyciu kluczy kryptograficznych znanych tylko urządzeniom osoby dzwoniącej i odbierającej. Dodatkowo użytkownicy będą mieli możliwość weryfikacji statusu E2EE poprzez podanie sobie nawzajem unikalnego kodu bezpieczeństwa.",
    "phone.fullPlanItem43": "Aprowizacja telefon\u00F3w \u201Ebez dotkni\u0119cia\u201D",
    "phone.fullPlanItem44": "Mieszanie typ\u00F3w plan\u00F3w na koncie",
    "phone.fullPlanItem46": "Raportowanie w czasie rzeczywistym i pulpity nawigacyjne opisuj\u0105ce jako\u015B\u0107",
    "phone.fullPlanItem47": "Wsparcie dla \u015Brodowisk pulpitu wirtualnego (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Dowiedz si\u0119 wi\u0119cej</a> o VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Dostępne dla wszystkich telefonów klientów indywidualnych. Plany wsparcia będą różne po sparowaniu z planami spotkań.",
    "phone.fullPlanItem49": "Obs\u0142uga opcji Bring Your Own Carrier",
    "phone.fullPlanItem49Tip": "Wsparcia dla bezpo\u015Bredniego i lokalnego \u0142\u0105czenia r\u00F3wnoleg\u0142ego z istniej\u0105cym dostawc\u0105 us\u0142ug PSTN",
    "phone.fullPlanItem50": "Integracja hybrydowa starszych system\u00F3w PBX",
    "phone.fullPlanItem51": "Naciśnij, aby mówić",
    "phone.fullPlanItem61": "Faks internetowy",
    "phone.fullPlanItem61Tip": "Wysyłaj i odbieraj nieograniczoną liczbę faksów w USA i Kanadzie. W przypadku faksów międzynarodowych <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">zobacz stawki</a>",
    "phone.fullPlanSms": "Wiadomo\u015Bci SMS i MMS",
    "phone.fullPlanSmsTip": "Dost\u0119pne tylko dla numer\u00F3w w USA i Kanadzie, tylko po zakupieniu planu po\u0142\u0105cze\u0144. Dost\u0119pne do u\u017Cycia dla numer\u00F3w bezpo\u015Brednich (nie numer\u00F3w firmowych).",
    "meetings.fullPlanItem6": "Wsparcie techniczne",
    "meetings.fullPlanItem6Tip": "Dost\u0119pne pakiety wsparcia Premier umo\u017Cliwiaj\u0105ce zminimalizowanie ryzyka i zredukowanie przestoj\u00F3w",
    "meetings.fullPlanItem6_basic": "Centrum pomocy",
    "meetings.fullPlanItem6_pro": "Formularz kontaktowy lub czat na \u017Cywo",
    "meetings.fullPlanItem6_biz": "Bilety, czat na \u017Cywo i telefon",
    "meetings.fullPlanItem6_ent": "Bilety, czat na \u017Cywo i telefon",
    "knowledgeBase": "Baza wiedzy",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Rozwiązuj problemy techniczne i zyskaj dostęp do zasobów pomocy, wyszukując artykuły z bazy wiedzy.",
    "zoomCommunity": "Społeczność Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Miejsce, w którym znajdziesz rozwiązania, zadasz pytania i nawiążesz współpracę z innymi użytkownikami Zoom.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Otrzymuj odpowiedzi na pytania i stawiaj czoła wyzwaniom technicznym – wsparciem posłuży Ci przy tym nasz chatbot.",
    "submitWebTickets": "Wysyłaj zgłoszenia sieciowe",
    "liveChatSupport": "Wsparcie w postaci czatu na żywo",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Plany z subskrypcją droższe niż {amount} USD/miesiąc.",
    "livePhoneSupport": "Wsparcie w postaci połączenia telefonicznego na żywo",
    "meetWithAgentOnVideo": "Spotkaj się z agentem podczas wideokonferencji",
    "subscriptionPlansGreaterThan_200UsdMonth": "Plany z subskrypcją droższe niż 200 USD/miesiąc.",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Zwiększ produktywność, korzystając z ulubionych aplikacji bezpośrednio na Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Dostosuj swój awatar, aby spotkania były trochę zabawniejsze i by zaprezentować się w dynamiczny sposób bez konieczności korzystania z kamery",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Spotkania",
    "plans.basic_free.upgrade.item1": "Do 30 godzin na spotkanie",
    "common.statistics.participants": "{0} Uczestnicy",
    "common.per_meeting_unit": "na spotkanie",
    "common.participant_limit.increase_with_large_meetings": "Zwiększ, wybierając Duże spotkanie",
    "plans.ai_companion.title": "Asystent AI Companion",
    "common.plans.whiteboard.title": "Tablica",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Nieograniczone",
    "common.plans.team_chat.title": "Zespołowy czat",
    "common.plans.mail_calendar.title": "Poczta i kalendarz",
    "common.plans.cloud_storage.title": "Przestrzeń w chmurze",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Przetłumaczone napisy Zoom",
    "common.plans.extras.title": "Dodatki",
    "common.plans.extras.desc": "zarządzanie domenami firmowymi i nie tylko",
    "zoom_one_edu_bundle.school.title": "Zoom One dla edukacji, szkoły i kampusów",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One dla edukacji, szkoły i kampusu Plus",
    "per_billing_cycle_license.monthly": "/miesiąc za licencję",
    "per_billing_cycle_license.yearly": "/rok za licencję",
    "per_billing_cycle_space.monthly": "/miesiąc/przestrzeń",
    "per_billing_cycle_space.yearly": "/rok/przestrzeń",
    "common.dialog.feature_list": "Zobacz pełną listę funkcji",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB na licencję",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB na licencję",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Plan Dla przedsiębiorstw Plus obejmuje plan Nielimitowany",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Dodatek sali konferencyjnej (stosunek 1:25)",
    "plans.whiteboard.ent": "Plan Dla przedsiębiorstw Plus obejmuje plan Nielimitowany Plus",
    "plans.zp.ent": "Wchodzi w skład planu Dla przedsiębiorstw Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Zaawansowana rezerwacja miejsc do pracy na miejscu i nie tylko",
    "plans.largeMeeting.intro_tip": "Duże spotkania to opcjonalny dodatek podczas realizacji transakcji, który umożliwia prowadzenie spotkania dla maksymalnie 500 lub 1000 uczestników, w zależności od zakupionej licencji.",
    "common.participant_limit.expandable_with_large_meetings": "Możliwość rozszerzenia za pomocą dodatku Duże spotkanie",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1000 w przypadku planu Dla przedsiębiorstw Plus</span>",
    "plans.webinar": "Webinar Zoom",
    "plans.webinar.ent": "Plan Dla przedsiębiorstw Plus obejmuje Sessions 1000 (w tym Webinar)",
    "per_billing_cycle_user.monthly": "/miesiąc za użytkownika",
    "per_billing_cycle_user.annually": "/rok za użytkownika",
    "closeComparisonChart": "Zamknij wykres porównawczy",
    "archiving_api": "API archiwizacji",
    "dlp_api": "API DLP",
    "info_barriers": "Bariery informacyjne",
    "chat_etiquette": "Etykieta czatu",
    "gdrp": "RODO",
    "regiona_data_centers": "Regionalne centra danych",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Domyślne szyfrowanie",
    "end_to_end_encryption": "szyfrowanie end-to-end",
    "cryptographic_boundary": "Granica kryptograficzna",
    "vdi": "Wirtualny pulpit (VDI)",
    "customer_managed_key": "Klucz zarządzany przez klienta",
    "gpo_msi_policies": "Zasady GPO/MSI",
    "msi": "Masowe wdrożenie (MSI)",
    "ntt": "Narzędzie do testowania sieci (NTT)",
    "dashboards": "Pulpit nawigacyjny",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Podtrzymywanie Zoom Phone",
    "zoom_meeting_survivability": "Podtrzymywanie Zoom Meeting",
    "paid_option": "Opcja płatna",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Główne funkcje",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Szkoła i kampus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Szkoła i kampus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "pt-PT": {
    "billing.essential_apps": "Principais aplicativos",
    "billing.essential_apps.dialog_desc": "Aumente e gerencie seu negócio com aplicativos para tomar notas em reuniões, engajar com sua equipe através de atividades interativas e entregar insights para aprimorar as conversas com clientes. Aplicativos premium gratuitos incluídos no seu plano por 1 ano.",
    "billing.see_more_details": "Veja mais detalhes",
    "billing.essential_app.legal_copy": "Oferta válida apenas para usuários com uma licença atual, a partir de 4 de janeiro de 2023, com uma assinatura Zoom One Pro, Business ou Business Plus, comprada no canal online da Zoom em zoom.us/buy. Usuários cujas assinaturas estiverem associadas com uma conta de Saúde, Educação ou Governo não estão elegíveis para essa oferta.  O acesso a cada aplicativo, com a exceção do Coda, começa a partir da ativação do aplicativo pelo usuário individual e expira após 1 ano. O acesso ao Coda para todos os usuários na mesma conta Zoom começa a partir da primeira ativação do Coda por qualquer usuário na conta e expira após 1 ano para todos os usuários na conta Zoom, independente da data inicial de ativação pelos usuários subsequentes na mesma conta Zoom.Em relação a todos os aplicativos, a reatribuição ou o cancelamento da licença ou assinatura elegível de um usuário encerrará o acesso deste usuário, mesmo se houver tempo restante no período de acesso de 1 ano.Cada aplicativo está sujeito a seus termos de uso e política de privacidade disponível no momento da ativação.Os aplicativos incluídos são compatíveis apenas com o idioma Inglês.Nem todos os aplicativos funcionam em dispositivos móveis.Oferta não resgatável ou reembolsável por dinheiro.A oferta é aplicável apenas a estes aplicativos listados como incluídos em Aplicativos Essenciais, no <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>. Os usuários com assinaturas pré-existentes a qualquer um dos aplicativos não se qualificam para esta oferta no que diz a respeito a esses aplicativos específicos.A Zoom reserva-se ao direito de modificar ou cancelar essa oferta a qualquer momento sem aviso prévio e responsabilidade.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Gerenciamento de visitantes"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Chat ao vivo e suporte por telefone 24/7"
      },
      "learn_more": "Saiba mais",
      "new": "NOVO",
      "plan_details": {
        "meeting": {
          "title": "Reuni\u00F5es",
          "host_meeting_up_to_participants": "Receba até {0} participantes",
          "meeting_hours": "Reuniões ilimitadas por até 30 horas por reunião",
          "recording_storage": "Gravação de armazenamento em nuvem de {0} GB (por licença)",
          "auto_captions": "Legendas automáticas"
        },
        "whiteboard": {
          "title": "Quadro de compartilhamento",
          "boards_storage": "{0} quadros editáveis",
          "standard_features": "Recursos padrão"
        },
        "team_chat": {
          "title": "Chat em equipe",
          "desc": "Chat e compartilhamento de arquivos em grupo"
        },
        "main_calendar": {
          "title": "E-mail e Calendário",
          "desc": "Cliente e serviços de email e calendário"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Crie e compartilhe documentos editáveis dentro do Zoom",
          "desc2": "Anotações pessoais e colaborativas com edição de rich-text"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Grave, edite e compartilhe vídeos curtos com facilidade",
          "desc2": "Vídeos ilimitados e recursos avançados"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Ganhe acesso rápido a resumos de reunião, assistência com a criação de rascunhos de mensagens e mais"
        },
        "EssentialApp": {
          "title": "Principais aplicativos",
          "desc1": "Aplicativos premium gratuitos por 1 ano (termos se aplicam)",
          "desc2": "Aumente a colaboração e a produtividade em equipe"
        },
        "livechat": {
          "title": "Suporte de chat ao vivo"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Mudar para o Zoom Workplace Pro?",
            "content": "O plano selecionado anteriormente é o Zoom Workplace Corporativo, que permite até 300 participantes por reunião, inclui o Zoom Scheduler e muito mais. Tem certeza de que deseja mudar para o Pro?",
            "confirm": "Confirmar mudança",
            "keep_current": "Manter o plano atual"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} participantes",
          "participants": "{0} Participantes",
          "user_range": "{0} a {1} usuários",
          "items": "{num} itens"
        },
        "button": {
          "ok": "OK",
          "add": "Adicionar",
          "buy_now": "Comprar Agora",
          "try_for_days": "Experimente gratuitamente por {0} dias",
          "contact_sales": "Entrar em contato com a equipe de vendas",
          "close": "Fechar",
          "cancel": "Cancelar",
          "edit": "Editar",
          "got_it": "Entendi"
        },
        "title": {
          "everything_in_and": "Tudo em {0} e:"
        },
        "tag": {
          "new": "NOVO",
          "free_trial": "Teste grátis"
        },
        "billing_cycle": {
          "annual": "Anual",
          "monthly": "Mensal",
          "quarterly": "Trimestral",
          "two_years": "Dois anos",
          "three_years": "Três anos"
        },
        "errors": {
          "unknown_error_try_again": "Erro desconhecido ao processar a transação. Tente novamente mais tarde."
        },
        "excluding_tax": {
          "vat_tip": "excluindo IVA",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Recursos limitados",
        "pro_plus": {
          "host_meeting_up_to_participants": "Receba até {0} participantes",
          "gb_of_cloud_recording_storage": "{0} GB de armazenamento de gravação na nuvem (por licença)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion para geração de conteúdo e traduções",
            "features_item2": "Número ilimitado de documentos compartilhados com sua equipe",
            "features_item3": "Acesso ilimitado ao histórico de versões",
            "comparison_table_tips": "Aumente a colaboração com documentos baseados em IA que transformam o conteúdo da reunião em documentos, wikis e projetos acionáveis"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks plano Básico",
            "features_item1": "Detecte automaticamente tarefas em suas reuniões, telefonemas, chats e documentos",
            "features_item2": "Tenha ajuda para concluir tarefas, como agendar reuniões de acompanhamento e redigir documentos",
            "features_item3": "Marque facilmente as tarefas como concluídas quando elas tiverem sido terminadas para atualizar o progresso e focar nas próximas tarefas",
            "features_item4": "Gerencie tarefas em toda a plataforma Zoom Workplace, incluindo o Zoom Docs",
            "features_item1_opc": "Aproveite o poder do AI Companion para identificar e criar tarefas a partir de seus chats, e-mails, documentos, quadros de compartilhamento e resumos da reunião",
            "features_item2_opc": "Ordene, filtre, agrupe e pesquise com facilidade para acessar e reunir rapidamente contexto para as suas tarefas",
            "learn_more_header": "Fique por dentro dos seus itens de ação usando o AI Companion* para fazer mais no Zoom Workplace.",
            "learn_more_footer": "\*O AI Companion está disponível somente para os planos Zoom Workplace Pro, Corporativo e Empresarial.",
            "features_prefix": "Deixe o AI Companion ajudar você a:",
            "comparison_table_tips": "Fique por dentro dos itens de ação e conclua-os no prazo usando uma solução centrada em IA que fornece recomendações de tarefas de acordo com o resumo da reunião e de conversas no Zoom Workplace.",
            "tasks_label_text": " Gerenciamento de tarefa centrado em IA"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Fale conosco para informações sobre preços e mais",
          "contact_sales": "Entrar em Contato com a Equipe de Vendas",
          "meetings": "Reuni\u00F5es",
          "phone": "Telefone",
          "phone_sub_title": "Chamadas ilimitadas",
          "use_only": "Somente para uso corporativo",
          "team_chat": {
            "title": "Chat em equipe",
            "title_desc": "Chat e compartilhamento de arquivos em grupo"
          },
          "cloud_storage": {
            "title": "Armazenamento em nuvem"
          },
          "mail_calender": {
            "title": "E-mail e Calendário"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Cliente e serviço"
          },
          "up_to_30_hours_per_meeting": "até 30 horas por reunião",
          "300_attendees": "300 participantes",
          "per_meeting": "por reunião",
          "whiteboard": {
            "title": "Quadro de compartilhamento"
          },
          "new": "NOVO",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Extra",
          "sso_managed_domains_more": "SSO, domínios gerenciados e muito mais",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Regional ilimitado",
          "translated_captions": "Legendas traduzidas",
          "workspace_reservation": "Reserva de local de trabalho",
          "auto_translated_captions": "Legendas automáticas e traduzidas",
          "unlimited_editable_boards": "Quadros editáveis ilimitados",
          "standard_features": "Recursos padrão",
          "advanced_docu_controls": "Controles de documento avançados",
          "chats_channels_for_collaboration": "Chats e canais para colaboração, compartilhamento de arquivos e mais",
          "zoom_phone_is_biz_use_only": "O Zoom Phone é apenas para uso corporativo",
          "unlimited_regional_calling": "Chamadas regionais ilimitadas",
          "domestic_sms_mms": "SMS e MMS locais",
          "automatic_call_distribution_groups": "Grupos de distribui\u00E7\u00E3o autom\u00E1tica de chamadas (ACD) com fila de chamadas",
          "single_sign_on": "Conex\u00E3o \u00FAnica (Single Sign-On)",
          "managed_domains": "Dom\u00EDnios gerenciados",
          "company_branding": "Branding da empresa",
          "mail_calender_client_services_beta": "Cliente e serviços de email e calendário beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Reuniões ilimitadas por até 30 horas por reunião",
          "mail_and_calendar_client_and_services_beta": "Cliente e serviços de email e calendário beta",
          "easily_record_edit_share_videos": "Grave, edite e compartilhe vídeos curtos com facilidade",
          "unlimited_videos_advanced_features": "Vídeos ilimitados e recursos avançados",
          "create_share_editabel_docu_within_zoom": "Crie e compartilhe documentos editáveis dentro do Zoom",
          "personal_collaborative_notes_rich_text_editing": "Anotações pessoais e colaborativas com edição de rich-text",
          "effortlessly_share_meeting": "Compartilhe facilmente horários de reunião para uma reserva mais fácil",
          "works_with_zoom_meeting_mail_calender_google_ms": "Funciona com o Zoom Meetings, Zoom Mail e Zoom Calendar, Google e Microsoft 365",
          "up_to_300_attendees": "Até 300 participantes",
          "10_gb_of_storage": "10 GB de armazenamento",
          "host_meeting_up_to_300_participants": "Organize reuni\u00F5es com at\u00E9 300 participantes",
          "10_gb_of_cloud_recording_storage": "Gravação de armazenamento em nuvem de 10 GB (por licença)",
          "starting_at_licenses_year": "A partir de {1} licen\u00E7as por {0}/ano",
          "starting_at_licenses_month": "A partir de {1} licen\u00E7as por {0}/m\u00EAs",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Ganhe acesso rápido a resumos de reunião, assistência com a criação de rascunhos de mensagens e mais",
          "learn_more": "Saiba mais",
          "essential_apps": "Principais aplicativos",
          "increase_team_collaboration": "Aumente a colaboração e a produtividade em equipe",
          "free_premium_apps": "Aplicativos premium gratuitos por 1 ano (termos se aplicam)",
          "visitor_management": "Gerenciamento de visitantes",
          "visitor_management_custom_invites": "Personalize convites",
          "visitor_management_visitor_check": "Faça check-in em um quiosque",
          "visitor_management_receive_detailed": "Receba métricas detalhadas sobre a utilização que os visitantes fazem do espaço"
        },
        "custom_avatar": {
          "title": "Avatar personalizado",
          "label_text": "3 minutos por mês",
          "basic_feature": "1 minuto por vida útil",
          "pricing_feature": "3 minutos por mês",
          "learn_more_subtitle": "Crie uma versão de IA realista de você mesmo com replicação de voz e comunicação em vários idiomas.",
          "features_item1": "Crie até 3 avatares digitais realistas a cada mês reproduzindo sua aparência e voz para apresentações e demonstrações",
          "features_item2": "Use seu avatar para apresentar roteiros com duração de até 3 minutes com o AI Companion",
          "features_item3": "Escolha entre 18 avatares prontos para criar vídeos rápidos e de alta qualidade",
          "features_item4": "Aproveite o suporte ao plano de fundo virtual",
          "features_item1_opc": "Crie até 3 avatares digitais realistas a cada mês reproduzindo sua aparência e voz para apresentações e demonstrações",
          "features_item2_opc": "Use seu avatar para apresentar roteiros com duração de até 3 minutes com o AI Companion",
          "comparison_table_tips": "O Avatar personalizado cria uma versão de IA realista de você mesmo com replicação de voz e comunicação em vários idiomas."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Ganhe acesso rápido a resumos de reunião, assistência com a criação de rascunhos de mensagens e mais",
        "learn_more_dialog": {
          "desc": "Faça mais com o AI Companion! Ele pode escrever conteúdo, agendar suas reuniões, ajudar a gerenciar seus projetos e muito mais.",
          "tip1": "Receba uma agenda com antecedência para organizar reuniões mais eficazes",
          "tip2": "Mantenha seus projetos em dia com a criação automática de tarefas e notificações",
          "tip3": "Obtenha ajuda para organizar seu calendário e administrar seu tempo",
          "tip4": "Gere conteúdo escrito e visual que corresponda ao seu estilo no Docs, Whiteboard ou no aplicativo Zoom Workplace"
        },
        "top_features": "Principais recursos",
        "more_to_come": "Mais recursos incríveis estão vindo!",
        "discover_more": "Descubra ainda mais maneiras de fazer seu melhor trabalho com o AI Companion!",
        "detail_desc": "AI Companion está incluído sem custo adicional nos serviços pagos das contas de usuário Zoom. Pode não estar disponível para alguns segmentos e em algumas regiões."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/ano/licença",
        "month_licnese": "/mês/licença",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/mês",
          "per_year": "/ano"
        },
        "unit": {
          "license": "{0}/licença",
          "user": "{0}/usuário"
        },
        "learn_more": "Saiba mais",
        "required": "Necessário",
        "zoom_one_required": "É necessário o Zoom Workplace",
        "large": {
          "features_tip": "Amplie o seu alcance com uma maior capacidade para até 1.000 participantes.",
          "label_title1": "500 participantes",
          "label_title2": "1000 participantes"
        },
        "cmr": {
          "features_tip": "Armazene, transmita e baixe suas gravações de vídeo diretamente do Zoom Cloud.",
          "explain_desc": "O armazenamento em nuvem está incluído em planos Zoom Workplace selecionados: Pro (5 GB), Corporativo (5 GB), Corporativo Plus (10 GB) e Empresarial (ilimitado)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 horas",
          "option_label2": "≈ 650 horas",
          "option_label3": "≈ 3,500 horas",
          "option_label4": "≈ 17,500 horas",
          "intro_label2": "As opções de armazenamento incluem até 5 TB/mês",
          "tooltip_content": "O armazenamento de gravação varia com o número de participantes com vídeo habilitado, resolução de reunião e resolução de conteúdo compartilhado."
        },
        "whiteboard": {
          "plus_title": "Quadro de compartilhamento Plus",
          "title": "Whiteoard",
          "features_tip": "Colabore em tempo real com outras pessoas em quadros de compartilhamento, antes, durante e após as reuniões.",
          "explain_desc": "Incluído no Zoom One Corporativo, Zoom One Corporativo Plus e Zoom One Empresarial",
          "explain_desc_plus": "Incluído no Zoom Workplace Empresarial Plus e com todas as assinaturas do Zoom Rooms",
          "option_label1": " Quadros ilimitados com 1GB de armazenamento em nuvem",
          "option_label2": "Recursos avançados com quadros ilimitados e armazenamento em nuvem",
          "intro_label1": "Quadros de compartilhamento com edição simultânea ilimitados",
          "intro_label2": "Recursos padrão e controle de documento avançado",
          "intro_label3": "Recursos avançados de quadro de compartilhamento, incluindo modelos personalizados e organizacionais, e integrações com terceiros"
        },
        "translated_captions": {
          "features_tip": "Possibilite a colaboração global com legendas automáticas no idioma da sua preferência.",
          "intro_label1": "Os participantes podem habilitar as legendas e trocar o idioma.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Exibir idiomas compatíveis"
        },
        "crc": {
          "features_tip": "Habilita qualquer padrão baseado em ponto de extremidade de videoconferência SIP/H.323 para um trabalho híbrido efetivo.",
          "intro_label1": "Funciona com terminais legacy, incluindo Polycom, Cisco, Lifesize e outros",
          "intro_label2": "Conector de sala baseado na nuvem ou no local (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Simplifique as reservas com disponibilidade flexível e intervalos de tempo personalizáveis",
          "host_one_on_one": "Organize reuniões individuais ou em grupo com um único link para facilitar o compartilhamento",
          "customize_reminders": "Personalize lembretes por e-mail/SMS para não perder compromissos",
          "sync_calendars": "Sincronize calendários com facilidade usando as integrações do Google, Microsoft 365 e Zoom",
          "features_tip": "Compartilhe facilmente horários de reunião para horários comerciais, entrevistas e mais.",
          "intro_label1": "Integração de calendário",
          "intro_label2": "Disponibilidade de recorrência",
          "intro_label3": "Reunião dimensionável",
          "intro_label4": "Notificações personalizáveis",
          "intro_sub_label1": "Google, Microsoft 365 e Zoom ",
          "intro_sub_label2": "compartilhar horários reserváveis ",
          "intro_sub_label3": "reunião única para um ou vários participantes",
          "intro_sub_label4": "lembretes e confirmações automatizadas por e-mail e SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Grave, edite e compartilhe mensagens curtas de vídeo em alta resolução.",
          "intro_label1": "Crie quantos vídeos quiser, sem limite de duração",
          "intro_label2": "Capture sua tela e vídeo juntos ou separadamente",
          "intro_label3": "Corte o vídeo conforme necessário e compartilhe o link",
          "intro_label4": "Acesse recursos avançados com transcrições de áudio e estatísticas",
          "explain_desc": "O Clips Plus está incluído nas assinaturas dos planos Workplace Pro, Corporativo e Empresarial. Você pode conhecer os diferentes recursos de cada plano na seção de comparação, na página de preços."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Plataforma de eventos avançada com recursos robustos de inscrição e networking. Ideal tanto para experiências virtuais quanto híbridas.",
          "tooltip_content": "Organize webinars e eventos ilimitados na capacidade escolhida",
          "intro_title": "Tudo no Sessions",
          "intro_label1": "Aumente a participação do público com eventos de várias sessões",
          "intro_label2": "Organize eventos facilmente com venda de ingressos personalizada e aplicativo móvel",
          "intro_label3": "Aumente a receita do evento com piso de exposição e área para o patrocinador",
          "intro_label4": "Estimule o networking entre participantes com perfis personalizáveis",
          "intro_label5": "Amplie o alcance com visualização sob demanda no saguão do evento",
          "intro_label6": "Acelere os preparativos do evento usando modelos com curadoria",
          "events_feature_item1_20240827": "Organize eventos virtuais de vários dias com várias faixas",
          "events_feature_item2_20240827": "Promova o networking com perfis de participantes e chat no saguão",
          "events_feature_item3_20240827": "Oriente os participantes com a transmissão da sessão no saguão",
          "events_feature_item4_20240827": "Aumente a receita do evento com piso de exposição e patrocínios",
          "events_feature_item5_20240827": "Melhore os próximos eventos com pesquisas feitas após a conferência",
          "events_feature_item6_20240827": "Acelere os preparativos do evento usando modelos com curadoria",
          "attendees_start_at": "{0} participantes a partir de",
          "explain_desc": "Saiba mais sobre o Zoom Events",
          "contact_account_owner": "Se quiser comprar o Events <a href=\"/account\" target=\"_blank\"> fale com o proprietário da conta</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Simplifique eventos interativos de sessão única com recursos como branding de evento, colaboração entre vários anfitriões e gerenciamento de eventos.",
          "tooltip_content": "Organize webinars e eventos ilimitados na capacidade escolhida",
          "intro_title": "Inclui Zoom Webinars",
          "intro_label1": "Personalize páginas de destino do evento para criar um branding eficaz",
          "intro_label2": "Promova os eventos com e-mails contendo a sua marca",
          "intro_label3": "Mensure o desempenho com um painel interativo",
          "intro_label4": "Colaboração simplificada com co-organizadores e coeditores",
          "intro_label5": "Ferramentas de eventos profissionais: Simulive",
          "sessions_feature_item1_20240827": "Aprimore os webinars com cenários e branding personalizados",
          "sessions_feature_item2_20240827": "Simplifique o planejamento de eventos com o AI Companion para gerar mensagens e imagens",
          "sessions_feature_item3_20240827": "Promova eventos passados e futuros em um hub com conteúdo da marca",
          "sessions_feature_item4_20240827": "Realize eventos profissionais com bastidores, conteúdo pré-gravado e RTMP",
          "sessions_feature_item5_20240827": "Aprimore os próximos webinars com insights sobre vários eventos",
          "explain_desc": "Saiba mais sobre o Zoom Sessions",
          "contact_account_owner": "Se quiser comprar o Sessions, <a href=\"/account\" target=\"_blank\"> fale com o proprietário da conta</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Webinars de vídeo",
          "features_tip": "Transmita com facilidade mensagens usando uma plataforma webinar intuitiva.",
          "tooltip_content": "Organize webinars e eventos ilimitados na capacidade escolhida",
          "intro_label1": "Engaje o público com a transmissão pela web de vídeos de alta qualidade",
          "intro_label2": "Aumente a participação usando recursos de perguntas e respostas",
          "intro_label3": "Melhore a estratégia de webinar com relatórios pós-evento",
          "intro_label4": "Suporta a´te 100.000 participantes e 100 palestrantes",
          "monthly_subscription": "Assinatura mensal",
          "annual_subscription": "Assinatura anual",
          "one_million": "1 milhão",
          "single_use": "Uso único",
          "one_month": "Um mês",
          "event_attendee": "Participantes do Events e do Sessions:",
          "event_attendee_desc": "Qualquer pessoa que entra sem ser um anfitrião licenciado no hub. Aqueles com funções especiais também são contados como participantes e podem usar o áudio, vídeo e o compartilhamento de tela (se habilitado).",
          "webinar_attendee": "Participantes do Webinars:",
          "webinar_attendee_desc": "Qualquer pessoa que entra, mas não é um anfitrião ou um palestrante. Eles ficam no modo apenas leitura e são controlados pelo anfitrião que pode ativar o áudio deles e habilitar a interação por meio do perguntas e respostas e do chat.",
          "pay_per_attendee": "Pague por participante",
          "attendees": "participantes"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine a forma como suas equipes trabalham usando uma plataforma de colaboração com tecnologia de IA.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Corporativo",
          "label_title4": "Workplace Corporativo Plus",
          "intro_label1": "Organize reuniões ilimitadas de até 30 horas com até 100 participantes",
          "intro_label2": "Acesse até três quadros de compartilhamento editáveis simultaneamente com recursos padrão",
          "intro_label3": "Grave, edite e compartilhe mensagens curtas de vídeo de alta qualidade usando o Clips Plus",
          "intro_label4": "Faça o trabalho de forma mais eficiente com o Zoom AI Companion",
          "intro_label5": "Zoom Phone EUA e Canadá ilimitado (Não inclui os recursos de BYOC, PBX, PBX de terceiros)",
          "intro_label6": "Organize reuniões ilimitadas de até 30 horas com até 300 participantes",
          "intro_label7": "Compartilhe horários de reunião para horário comercial, entrevistas e muito mais usando Zoom Scheduler",
          "intro_label8": "Zoom Phone EUA e CA Ilimitado",
          "intro_label8_UK": "Zoom Phone ilimitado para Reino Unido e Irlanda",
          "intro_label8_AU": "Zoom Phone ilimitado para Austrália e Nova Zelândia",
          "intro_label8_JP": "Zoom Phone ilimitado para Japão",
          "intro_label9": "Gerenciamento de visitantes",
          "intro_label10": "Recursos adicionais",
          "intro_label11": "Suporte de chat ao vivo",
          "intro_title1": "Tudo no Pro e:",
          "intro_title2": "Tudo no Corporativo e:",
          "intro_label_tip1": "O Zoom Phone no plano Pro Plus não inclui recursos de BYOC, PBX de terceiros e VDI. Para mais informações, consulte a página de preços do Zoom Phone.",
          "intro_label_tip2": "Durante o pagamento é possível selecionar ligações regionais ilimitadas para os EUA e Canada, Austrália e Nova Zelândia ou Reino Unido e Irlanda.",
          "intro_label_tip3": "Recursos adicionais incluem 10GB de armazenamento em nuvem, legendas traduzidas e reservas de local de trabalho.",
          "intro_label_tip4": "O Zoom Phone no plano Pro Plus não inclui recursos de BYOC, PBX de terceiros e VDI. Para mais informações, consulte a página de preços do Zoom Phone."
        },
        "power_pack": {
          "title": "Pacote avançado do Zoom Phone",
          "features_tip": "Análise aprimorada da fila de chamadas e insights históricos para equipes de call center.",
          "intro_label1": "Janela de contatos ampliada para simplificar o tratamento de chamadas",
          "intro_label2": "Recepcionista automático e números de telefone de fila de chamadas"
        },
        "international_calling": {
          "title": "Chamadas internacionais",
          "features_tip": "Chamadas internacionais ilimitadas para mais de 15 países e regiões.",
          "intro_label1": "Pode ser adquirido com qualquer um dos planos de chamadas ilimitadas",
          "intro_label2": "Conheça nossa lista de países e regiões suportados para chamada internacional ilimitada.",
          "intro_labe2_tooltip": "EUA, Canadá, Reino Unido, Irlanda, Austrália, Nova Zelândia, Áustria, Dinamarca, França, Alemanha, Itália, Portugal, Espanha, Suécia, Bélgica, Holanda, Suíça, Porto Rico e Japão.",
          "intro_label2_view_list": "Visualizar lista"
        },
        "workspace_reservation": {
          "title": "Reserva de local de trabalho",
          "intro_title": "Reserve facilmente locais de trabalho flexíveis ou reserve quartos de hotel com antecedência ou no próprio local, com dispositivos integrados ao Zoom.",
          "intro_label1": "Acesse o local de trabalho e as reservas pelo aplicativo Zoom Workplace, pelo computador ou pelo navegador",
          "intro_label2": "Receba recomendações personalizadas de mesas com a ajuda da IA",
          "intro_label3": "Reserve locais de trabalho diretamente pelo Google Agenda ou pelo Outlook, com lembretes e alertas de check-in",
          "intro_label4": "Chegue até os locais de trabalho reservados usando o wayfinding"
        },
        "visitor_management": {
          "title": "Gerenciamento de visitantes",
          "intro_title": "Simplifique o check-in dos visitantes com convites personalizados, check-in sem complicações no quiosque, relatórios e métricas.",
          "intro_label1": "Gerencie os convites, os locais de visitantes e o histórico de visitas no portal Zoom",
          "intro_label2": "Crie, rastreie, reenvie e exclua convites, além de receber notificações sobre a chegada do convidado",
          "intro_label3": "Preencha formulários, instruções sobre caminhos e faça o check-in pelo quiosque para oferecer uma experiência tranquila ao visitante",
          "intro_label4": "Acesse todos os recursos no já familiar portal Zoom para facilitar o gerenciamento"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Grande reunião",
          "description1": "Aumente a capacidade da reunião para abarcar até 1.000 participantes interativos ao vivo",
          "description2": "Todos os participantes podem compartilhar áudio, vídeo e tela"
        },
        "cloud_storage": {
          "title": "Armazenamento em nuvem",
          "description2": "Formatos MP4 ou M4A disponíveis"
        },
        "translated_captions": {
          "title": "Legendas traduzidas",
          "description1": "Aprimore seus reuniões com legendas multilíngue automáticas que permitem que os participantes habilitem e troquem para um idioma disponível.",
          "description2": "Disponível no Zoom Meetings e no Webinars"
        },
        "tollfree": {
          "title": "Audioconferência",
          "subcontent": "Disque para entrar em reuniões com números de telefone do mundo todo",
          "description1": "Expanda suas opções realizando chamada globais gratuitas e discagens locais para países premium",
          "description2": "Não há cobrança para os participantes receberem chamadas de qualquer dispositivo",
          "description3": "Selecione facilmente um ou vários países para o recebimento de chamadas gratuitas"
        },
        "rc": {
          "title": "Conector de Sala de Conferência"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Austrália",
        "Austria": "Áustria",
        "Belgium": "Bélgica",
        "Brazil": "Brasil",
        "Bulgaria": "Bulgária",
        "Canada": "Canadá",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colômbia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croácia",
        "Cyprus": "Chipre",
        "Czech_Republic": "República Tcheca",
        "Denmark": "Dinamarca",
        "Ecuador": "Equador",
        "Estonia": "Estônia",
        "Finland": "Finlândia",
        "France": "França",
        "Germany": "Alemanha",
        "Greece": "Grécia",
        "Hong_Kong_SAR": "Hong Kong RAE",
        "Hungary": "Hungria",
        "Ireland": "Irlanda",
        "Israel": "Israel",
        "Italy": "Itália",
        "Japan": "Japão",
        "Latvia": "Letônia",
        "Lithuania": "Lituânia",
        "Luxembourg": "Luxemburgo",
        "Mexico": "México",
        "Netherlands": "Holanda",
        "New_Zealand": "Nova Zelândia",
        "Norway": "Noruega",
        "Panama": "Panamá",
        "Peru": "Peru",
        "Poland": "Polônia",
        "Portugal": "Portugal",
        "Puerto_Rico": "Porto Rico",
        "Romania": "Romênia",
        "Singapore": "Singapura",
        "Slovakia": "Eslováquia",
        "Slovenia": "Eslovênia",
        "South_Africa": "África do Sul",
        "Spain": "Espanha",
        "Sweden": "Suécia",
        "Switzerland": "Suíça",
        "UK": "RU",
        "United_Kingdom": "Reino Unido",
        "US": "EUA",
        "United_States": "Estados Unidos",
        "title": "Requisitos de número de telefone",
        "subtitle": "Selecione o país onde o número de telefone do Plano global será ativado.",
        "selector_tip": "Selecione País",
        "local_and_toll_free": "Números locais e de chamada gratuita estão disponíveis no(a) {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "O Plano global inclui um número de telefone e chamadas domésticas ilimitadas no país selecionado, por licença.",
        "avail_title": "Países/territórios disponíveis"
      },
      "tax_exempt_ecm": {
        "title": "Status de isenção fiscal",
        "status_exempt": "Isento de impostos",
        "status_exempt_question": "Isenção fiscal?",
        "verify_now": "Verificar agora",
        "can_after_checkout": "Como opção, este passo pode ser concluído após o checkout.",
        "status": {
          "exempt": "Isento",
          "pending": "Pendente",
          "pendingTooltip": "No momento, o status de isenção fiscal está em análise. Impostos podem ser cobrados quando você fizer um pedido. Caso a isenção seja aprovada, faremos um crédito de todos os impostos e taxas reembolsáveis na sua conta.",
          "nonexempt": "Não isento",
          "rejected": "Rejeitada",
          "rejectedTooltip": "Foi determinado que o documento enviado não atende aos requisitos da sua jurisdição.",
          "approved": "Aprovada",
          "default": "padrão"
        },
        "confirm_close": {
          "new_desc": "Se você abandonar a verificação, impostos e taxas podem ser cobrados. Ainda é possível enviar seu documento de isenção fiscal pela seção Gerenciamento de faturamento após a compra para que a Zoom faça a análise e aprovação. Após o documento ser validado, um reembolso será emitido em relação a quaisquer impostos que tenham sido cobrados.",
          "desc": "Tem certeza que gostaria de abandonar a verificação de isenção de impostos e prosseguir como qualificado para impostos?",
          "title": "Você tem certeza?",
          "new_title": "Abandonar verificação de isenção?",
          "yes": "Sim, abandonar",
          "no": "Não, continuar",
          "abandon": "Abandonar verificação",
          "go_back": "Voltar"
        },
        "confirm_to_add": {
          "title": "Confirmar nova isenção fiscal padrão",
          "message": "Incluir uma nova isenção a definirá automaticamente como padrão após ela ser aprovada ou rejeitada. Só é possível ter uma isenção padrão, que será aplicada às próximas compras. O valor do imposto pode ser afetado se a isenção fiscal não corresponder ao estado/região no campo \"Vendido para\".",
          "yes": "Incluir nova isenção"
        },
        "confirm_set_default": {
          "title": "Incompatibilidade entre endereço e isenção fiscal",
          "message": "O endereço do campo \"Contato vendido para\" não corresponde ao estado/região que você selecionou para isenção fiscal. Atualize o endereço do campo \"Contato vendido para\" para que ele corresponda ao local da isenção fiscal. Caso contrário, sua compra pode não ter isenção fiscal.",
          "yes": "Definir como padrão de qualquer jeito",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Estado/Região",
          "exemption_type": "Tipo de isenção",
          "signed_date": "Data da assinatura",
          "status": "status",
          "add_exemption": "Incluir isenção",
          "view": "Visualizar",
          "set_as_default": "Definir como padrão"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "O seu plano {planName} será cancelado no dia {date} à meia-noite, no fuso horário UTC. Se você quiser organizar reuniões após a data de cancelamento, reative seu plano.",
        "pairPreDescTip": "Os seus planos {planName1} e {planName2} serão cancelados no dia {date} à meia-noite, no fuso horário UTC. Se você quiser organizar reuniões ou webinars após a data de cancelamento, reative seus planos.",
        "pairDiffDatePreDescTip": "Os seus planos {planName1} e {planName2} serão cancelados no dia {date1} à meia-noite, no fuso horário UTC e no dia {date2} à meia-noite, no fuso horário UTC., respectivamente. Se você quiser organizar reuniões ou webinars após a data de cancelamento, reative seus planos.",
        "title": "Reativar seu plano para continuar",
        "titles": "Reativar seus planos para continuar",
        "plan": "Plano",
        "licenses": "Licença(s)",
        "billingCycle": "Ciclo de faturamento",
        "effective_date": "Data de vigência",
        "invoice_amount": "Valor da fatura",
        "singleDescTip": "Ao reativar, você concorda que seu plano recorrente será renovado automaticamente no dia {date}, e o método de pagamento cadastrado será cobrado a cada período de renovação. Para evitar cobranças futuras, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancele</a> até o dia anterior à data de renovação.",
        "pairDescTip": "Ao reativar, você concorda que seus planos recorrentes serão renovados automaticamente no dia {date}. O método de pagamento cadastrado será cobrado a cada período de renovação. Para evitar cobranças futuras, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancele</a> até o dia anterior à data de renovação.",
        "pairDiffDateDescTip": "Ao reativar, você concorda que seus planos recorrentes serão renovados automaticamente nos dias {date1} e {date2}. O método de pagamento cadastrado será cobrado a cada período de renovação. Para evitar cobranças futuras, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancele</a> até o dia anterior à data de renovação.",
        "totalLabel": "Total",
        "totalContent": "{money} mais impostos devidos",
        "taxDesc": "excluindo IVA, GST ou impostos similares",
        "reactivateBtn": "Continuar e reativar",
        "switchTitle": "Atualize seu plano para continuar",
        "successSingleTip": "O plano {planName} foi reativado",
        "successPairTip": "Os planos {planName1} e {planName2} foram reativados",
        "switchTip": "Seu plano de um mês do Zoom Webinars expira no dia {date}. Para hospedar um webinar após essa data, você deve mudar para uma assinatura.",
        "switchBtn": "Mude para assinatura"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Corporativo"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Corporativo Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Baixe a folha de dados"
      },
      "one": {
        "new": "NOVO"
      }
    },
    "webinarSetupInWebPortal": "Configuração de webinar no portal da web",
    "concurrentEvents": "Eventos simultâneos",
    "coucurrentEventsToolTip": "<span>Um plano de <b>assinatura</b> dá suporte a um evento ao vivo por vez",
    "overages": "Excedentes",
    "eventsPlatformHubs": "Hubs da plataforma Events",
    "eventsHubToolTip": "Os <b>hubs</b> do Zoom Events proporcionam praticidade na organização de eventos",
    "1HubPerLicense": "1 hub por licença",
    "1000Hubs": "1.000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Anfitriões da plataforma Events (500 participantes ou mais)",
    "eventsHost500": "<span>Os <b>anfitriões de hubs</b> do Zoom Events podem criar",
    "5HubHosts": "5 anfitriões de hub",
    "100HubHosts": "100 anfitriões de hub",
    "eventsPlatformHosts_100Attendees": "Anfitriões da plataforma Events (100 participantes)",
    "eventsHost100": "<span>Os <b>anfitriões de hubs</b> do Zoom Events podem criar",
    "2HubHosts": "2 anfitriões de hub",
    "howAreTheyDifferent": "Quais são as diferenças?",
    "allPlansRequireAZoomOneLicense": "*Todos os planos exigem uma licença do Zoom Workplace",
    "subscription": "Inscrição",
    "subscriptionToolTip": "<span>Uma <b>assinatura</b> permite que você organize uma quantidade ilimitada de eventos da capacidade de sua escolha.</span>",
    "payPerAttendee": "Pague por participante",
    "ppaToolTips": "<span>As licenças <b>pague por participante</b> determinam quantas pessoas no total podem participar de todos os seus eventos realizados em um período de 12 meses a partir da compra.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Enquete",
    "meetings.fullPlanItem2": "N\u00FAmero de licen\u00E7as",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Reuni\u00F5es Zoom",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Videoconferência e troca de mensagens simplificadas entre qualquer dispositivo",
    "meetings.fullPlanItem5": "Dura\u00E7\u00E3o da reuni\u00E3o",
    "meetings.fullPlanItem5Tip": "A dura\u00E7\u00E3o m\u00E1xima permitida por reuni\u00E3o em grupo (3 ou mais participantes).",
    "meetings.fullPlanItem5_basic": "40 minutos",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 horas",
    "meetings.fullPlanItem5_biz": "30 horas",
    "meetings.fullPlanItem5_ent": "30 horas",
    "meetings.fullPlanItem1": "Capacidade de participantes",
    "meetings.fullPlanItem1Tip": "Um participante \u00E9 um convidado para uma reuni\u00E3o agendada por outra pessoa que tem uma licen\u00E7a. Os participantes podem ingressar em sua reuni\u00E3o gratuitamente a partir dos seus telefones, desktops, celulares e tablets. Um participante n\u00E3o precisa de uma conta Zoom para ingressar em uma reuni\u00E3o. Cada plano possui um limite de participantes, mas os usu\u00E1rios podem aumentar esse limite nos planos pagos adquirindo um complemento.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1.000 para Empresarial Plus</span>",
    "meetings.fullPlanItem7": "Grava\u00E7\u00E3o",
    "meetings.fullPlanItem7Tip": "A grava\u00E7\u00E3o local Zoom salva suas grava\u00E7\u00F5es de reuni\u00E3o nos formatos MP4 (v\u00EDdeo), M4A (\u00E1udio) e txt (chat).<br> As grava\u00E7\u00F5es na nuvem Zoom armazenam reuni\u00F5es na nuvem Zoom, onde o arquivo pode ser baixado e/ou transmitido a partir de um navegador.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local e nuvem de 5 GB (por licen\u00E7a)",
    "meetings.fullPlanItem7_biz": "Local e nuvem de 10 GB (por licen\u00E7a)",
    "meetings.fullPlanItem7_ent": "Nuvem local e ilimitada",
    "one.messaging": "Mensagem",
    "meetings.fullPlanItem16Tip": "O Chat permite que voc\u00EA envie facilmente textos, arquivos, capturas de tela, trechos de c\u00F3digo, mensagens de voz e imagens para grupos. O texto pode ser formatado e os usu\u00E1rios tamb\u00E9m podem compartilhar GIFs e emojis. Presen\u00E7a mostra se os participantes do bate-papo est\u00E3o ativos no desktop ou em dispositivos m\u00F3veis, ou ocupados em reuni\u00F5es.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Ilimitado",
    "meetings.fullPlanItem_EssentialApp": "Principais aplicativos",
    "common.learnMore": "Saiba mais",
    "meetings.fullPlanItem_EssentialAppText": "Aplicativos premium gratuitos por 1 ano (termos se aplicam)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom e-mail e calendário no aplicativo do Zoom",
    "mailService": "Serviço de e-mail",
    "emailServiceWithFullTimeEndToEnd": "Serviço de e-mail com criptografia ponta a ponta em tempo integral para maior privacidade",
    "customMailDomain": "Domínio de e-mail personalizado",
    "customMailDomainWithMailService": "Domínio de e-mail personalizado com serviço de e-mail",
    "calendarClient": "Cliente de Calendário",
    "scheduleAndJoinMeetings": "Agende e ingresse nas reuniões no aplicativo Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Serviço de Calendário",
    "meetingSchedulingAndAppointment": "Agendando reuniões e agendamento de compromissos",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Crie, edite e compartilhe vídeos curtos sem nenhum esforço. Os clipes armazenados são fáceis de descobrir, aumentando o engajamento.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "O Notes oferece um editor de documentos pessoais e colaborativos robusto, com muitas opções de formatação, acessível tanto dentro quanto fora de reuniões.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Legendas traduzidas",
    "workspaceReservation": "Reserva de local de trabalho",
    "accessAcrossAnyDevice": "Acesse em qualquer dispositivo",
    "meetings.fullPlanItem4": "Reuni\u00F5es ilimitadas",
    "meetings.fullPlanItem9": "Discagem telef\u00F4nica",
    "meetings.fullPlanItem9Tip": "Participe de uma reuni\u00E3o Zoom via teleconfer\u00EAncia/audioconfer\u00EAncia (usando um telefone tradicional). Os usu\u00E1rios ser\u00E3o cobrados de acordo com seu plano telef\u00F4nico. Experimente nosso complemento de audioconfer\u00EAncia para obter n\u00FAmeros de discagem gratuita.",
    "meetings.fullPlanItem9_pro": "Chamada cobrada",
    "meetings.fullPlanItem9_biz": "Chamada cobrada",
    "meetings.fullPlanItem9_ent": "Chamada cobrada",
    "meetings.fullPlanItem11": "Compartilhamento de tela",
    "meetings.fullPlanItem11Tip": "Compartilhamento de desktop e aplicativo. Os usu\u00E1rios licenciados podem optar por permitir que v\u00E1rios participantes compartilhem suas telas simultaneamente durante uma reuni\u00E3o.",
    "meetings.fullPlanItem12": "Salas simult\u00E2neas",
    "meetings.fullPlanItem12Tip": "As salas simult\u00E2neas de v\u00EDdeo permitem dividir sua reuni\u00E3o Zoom em at\u00E9 50 sess\u00F5es separadas para discuss\u00E3o, projetos e muito mais.",
    "meetings.fullPlanItem14": "Plano de fundo virtual",
    "meetings.fullPlanItem15": "ID pessoal de reuni\u00E3o",
    "meetings.fullPlanItem15Tip": "Crie sua pr\u00F3pria sala de reuni\u00E3o on-line permanente. Voc\u00EA pode iniciar esta reuni\u00E3o a qualquer momento ou agend\u00E1-la para uso futuro.",
    "meetings.fullPlanItem17": "Controles do anfitri\u00E3o",
    "meetings.fullPlanItem18": "Coanota\u00E7\u00E3o em compartilhamento de tela",
    "meetings.fullPlanItem19": "Controle remoto por teclado/mouse",
    "meetings.fullPlanItem21": "Compartilhamento m\u00FAltiplo",
    "meetings.fullPlanItem29": "Sala de espera",
    "meetings.fullPlanItem29Tip": "O recurso Sala de espera permite que o anfitri\u00E3o controle quando um participante pode entrar na reuni\u00E3o. Como anfitri\u00E3o da reuni\u00E3o, voc\u00EA pode admitir os participantes um por um ou todos de uma s\u00F3 vez. Nas configura\u00E7\u00F5es, voc\u00EA pode escolher quem ser\u00E1 colocado na sala de espera ou admitido automaticamente. Todas as contas possuem o recurso de sala de espera. Os anfitri\u00F5es podem enviar mensagens para a sala de espera. Voc\u00EA pode personalizar a sala de espera, se estiver inscrito em um plano pago.",
    "meetings.fullPlanItem41": "Integrado em dispositivos Zoom for Home",
    "meetings.fullPlanItem61": "Fixar v\u00E1rias pessoas",
    "meetings.fullPlanItem61Tip": "O anfitri\u00E3o pode conceder a at\u00E9 9 pessoas a capacidade de fixar v\u00EDdeos para criar sua pr\u00F3pria exibi\u00E7\u00E3o personalizada. Assim, os v\u00EDdeos fixados permanecem vis\u00EDveis, independentemente de quem estiver falando.",
    "meetings.fullPlanItem62": "Destacar v\u00E1rias pessoas",
    "meetings.fullPlanItem62Tip": "O anfitri\u00E3o pode destacar at\u00E9 9 v\u00EDdeos de participantes de forma que todas as pessoas na reuni\u00E3o ver\u00E3o os v\u00EDdeos destacados, independentemente de quem estiver falando.",
    "meetings.fullPlanNewItem1": "Filtros",
    "meetings.fullPlanNewItem1Tip": "Traga mais divers\u00E3o aos seus momentos de lazer, festas e muito mais com filtros de cores divertidos ou adesivos decorativos de animais.",
    "meetings.fullPlanNewItem2": "Enquete",
    "meetings.fullPlanNewItem3": "Anfitri\u00E3o alternativo e coanfitri\u00E3o",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/pt-br/articles/201362603-Host-and-Co-Host-Controls-in-a-Meeting\" target=\"_blank\">Saiba mais sobre nossos controles de coanfitri\u00E3o para reuni\u00F5es.</a>",
    "meetings.fullPlanItem24": "Atribuir agendador de reuni\u00E3o",
    "meetings.fullPlanItem24Tip": "Permite atribuir outra pessoa para agendar suas reuni\u00F5es para voc\u00EA. O usu\u00E1rio que receber essa fun\u00E7\u00E3o tamb\u00E9m dever\u00E1 ter um plano Pro.",
    "meetings.fullPlanItem25": "API REST",
    "meetings.fullPlanItem25Tip": "Permite que os propriet\u00E1rios e administradores da conta, assim como seus desenvolvedores, tenham acesso seguro \u00E0 API REST da Zoom. Os Limites de taxa da API s\u00E3o aplicados no n\u00EDvel da conta, de acordo com o Tipo de conta (Pro, comercial, empresarial, etc.) e o Tipo de solicita\u00E7\u00E3o da API (Leve, m\u00E9dio, pesado, etc.). Algumas APIs t\u00EAm acesso limitado a tipos de conta espec\u00EDficos. Use os Limites de taxa da API e a Documenta\u00E7\u00E3o de refer\u00EAncia da API para obter detalhes completos.",
    "meetings.fullPlanItem25_pro": "Limites da taxa da API REST Pro",
    "meetings.fullPlanItem25_biz": "Limites da taxa da API REST",
    "meetings.fullPlanItem26": "Interoperabilidade com o Skype for Business (Lync)",
    "meetings.fullPlanItem26Tip": "Permite que usu\u00E1rios do Lync 2010 e 2013 e do Skype for Business iniciem uma reuni\u00E3o Zoom a partir da lista de contatos do Lync.",
    "meetings.fullPlanItem27": "Transmiss\u00F5es",
    "meetings.fullPlanItem27Tip": "Transmita ao vivo no Facebook, Youtube ou em um servi\u00E7o de terceiros.",
    "meetings.fullPlanItem28": "Relat\u00F3rios",
    "meetings.fullPlanItem28Tip": "Salve as sess\u00F5es de quadro branco",
    "meetings.fullPlanItem30": "Gerenciamento do usu\u00E1rio",
    "meetings.fullPlanItem30Tip": "Propriet\u00E1rios e administradores de contas podem adicionar, excluir e atribuir fun\u00E7\u00F5es e recursos complementares.",
    "one.autoCaptions": "Legendas automáticas",
    "meetings.fullPlanItem31": "Portal de administra\u00E7\u00E3o",
    "meetings.fullPlanItem31Tip": "Gerencie todos os usu\u00E1rios da sua empresa em uma conta para cobran\u00E7a simplificada, configura\u00E7\u00F5es avan\u00E7adas de gerenciamento de usu\u00E1rio e informa\u00E7\u00F5es abrangentes sobre o uso \u2013 tudo direto no portal de administra\u00E7\u00E3o Zoom.",
    "meetings.fullPlanItem32": "Integra\u00E7\u00E3o LTI",
    "meetings.fullPlanItem32Tip": "Adicione facilmente uma reuni\u00E3o a qualquer atividade do curso e convide os alunos certos a partir do seu sistema de gerenciamento de aprendizagem (funciona com Moodle, Canvas, Desire2Learn e Blackboard).",
    "meetings.fullPlanItem33": "Transcri\u00E7\u00F5es de grava\u00E7\u00E3o na nuvem",
    "meetings.fullPlanItem33Tip": "As transcri\u00E7\u00F5es de grava\u00E7\u00F5es na nuvem s\u00E3o transcri\u00E7\u00F5es de \u00E1udio de uma reuni\u00E3o ou webinar que voc\u00EA grava na nuvem. Observe que atualmente este recurso \u00E9 suportado apenas para o idioma ingl\u00EAs. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Clique aqui</a> para saber mais.",
    "meetings.fullPlanItem34": "Marca",
    "meetings.fullPlanItem34Tip": "Adicione o branding da sua empresa \u00E0 sua pr\u00F3pria p\u00E1gina personalizada, onde os usu\u00E1rios poder\u00E3o ingressar em uma reuni\u00E3o. Crie um modelo de e-mail com marca para enviar convites aos participantes.",
    "meetings.fullPlanItem35": "Dom\u00EDnios gerenciados",
    "meetings.fullPlanItem35Tip": "Use o dom\u00EDnio do endere\u00E7o de e-mail da sua empresa/universidade para adicionar usu\u00E1rios \u00E0 sua conta automaticamente.",
    "meetings.fullPlanItem37": "Interpreta\u00E7\u00E3o de idiomas",
    "meetings.fullPlanItem37Tip": "Permite que o organizador da reuni\u00E3o atribua int\u00E9rpretes em reuni\u00F5es e webinars. Ao iniciar a reuni\u00E3o ou o webinar, o anfitri\u00E3o pode iniciar o recurso de interpreta\u00E7\u00E3o, que dar\u00E1 aos int\u00E9rpretes acesso aos seus pr\u00F3prios canais de \u00E1udio. Os participantes podem selecionar um canal de \u00E1udio para ouvir o idioma de sua escolha. Assim, eles ouvir\u00E3o o \u00E1udio traduzido e poder\u00E3o escolher se desejam ouvir o \u00E1udio original em um volume mais baixo.",
    "meetings.fullPlanItem39": "Revis\u00F5es executivas de neg\u00F3cios",
    "meetings.fullPlanItem39Tip": "An\u00E1lise detalhada de ado\u00E7\u00E3o de tend\u00EAncias, rastreamento de ROI, discuss\u00F5es de roteiro de produtos.",
    "meetings.fullPlanNewItem4": "Incluindo o Webinar 500",
    "one.translatedCations": "Legendas traduzidas",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direto, canal ou chat em grupo",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Comunique-se facilmente com mensagens individuais, para pequenos grupos ou com grandes equipes",
    "messageAndFileHistory": "Histórico de mensagem e arquivos",
    "findPeopeChannelsAndFilesInSearch": "Pesquise pessoas, canais e arquivos",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Encontre rapidamente contatos, mensagens instantâneas, chats em equipe e arquivos, mantendo o conhecimento e a informação ao seu alcance.",
    "applicationIntegrations": "Integrações com aplicativos",
    "secureFileSharing": "Compartilhamento seguro",
    "enhanceCollaborationWithSeamlessFileSharing": "Aprimore a colaboração com o compartilhamento simplificado de arquivos",
    "persistentMeetingChat": "Chat de reunião persistente",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Esteja sempre por dentro das conversas da reunião. Comunique-se antes, durante e após uma reunião em um chat em grupo dedicado, no Zoom Team Chat, para todos os participantes da reunião.",
    "cloudStorage": "Armazenamento em nuvem",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Faça backup de canais para o Zoom Cloud ou para um provedor de armazenamento terceirizado",
    "avatars": "Avatares",
    "inMeetingReactions": "Reações na reunião",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Demonstre engajamento e comunique-se rapidamente com outros participantes de uma forma não verbal",
    "virtualBackgrounds": "Planos de fundo virtuais",
    "videoFilters": "Filtros de vídeo",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Coloque um pouco de diversão nas suas reuniões com uma variedade de filtros sobrepostos ao seu vídeo",
    "inMeetingPollsAndQuizzes": "Enquetes e quiz na reunião",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Crie perguntas de escolha única ou de múltipla escolha para a enquete do webinar.",
    "liveStreamingAcrossPlatforms": "Transmissão ao vivo em várias plataformas",
    "appearanceTouchUp": "Melhoria da aparência",
    "originalSoundForMusicians": "Áudio original para músicos",
    "endToEndEncryptionForZoomMeetings": "Criptografia ponta a ponta para Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Quando habilitada, a criptografia ponta a ponta da Zoom (E2EE) para Zoom Meetings permite que as comunicações entre todos os participantes da reunião usando Zoom clients em determinada reunião sejam criptografadas com chaves criptográficas conhecidas apenas pelos dispositivos desses participantes. Isso significa que nenhum terceiro, incluindo o Zoom, tem acesso às chaves privadas da reunião.",
    "zoomCustomerManagedKey": "Chave gerenciada pelo cliente Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Traga suas próprias chaves de criptografia para proteger os dados em repouso do Zoom",
    "enterpriseGradeSecurityFeatures": "Recursos de segurança de nível empresarial",
    "256BitAesGcmEncryptionForRealTimeContent": "Criptografia AES 256 bits no modo GCM para conteúdo e mídia em tempo real, criptografia TLS durante inscrição SIP, máscara de ID do chamador, peering de rede privado, detecção de fraude em ferramenta e listas de bloqueio de chamadas.",
    "phone.fullPlanItem40": "Logon \u00FAnico por meio do SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Chamadas internas ilimitadas",
    "phone.fullPlanItem2": "Chamadas efetuadas tarifadas",
    "phone.fullPlanItem3": "Chamadas efetuadas ilimitadas",
    "phone.fullPlanItem4": "Qualidade de chamada HD l\u00EDder do setor",
    "phone.fullPlanItem4Tip": "Com cancelamento de ru\u00EDdo ativo, cancelamento de eco e supress\u00E3o sons de digita\u00E7\u00E3o",
    "phone.fullPlanItem5": "Aplicativos de desktop nativos para Windows, MacOS e Linux",
    "phone.fullPlanItem6": "Aplicativos m\u00F3veis nativos para iOS e Android",
    "phone.fullPlanItem7": "N\u00FAmeros existentes de porta ou compra de novos (DID)",
    "phone.fullPlanItem8": "N\u00FAmeros de chamada gratuita",
    "phone.fullPlanItem9": "N\u00FAmero do ramal telef\u00F4nico",
    "phone.fullPlanItem10": "Correio de voz com transcri\u00E7\u00E3o",
    "phone.fullPlanItem10Tip": "Acesso \u00E0 transcri\u00E7\u00E3o do correio de voz por aplicativos m\u00F3veis/desktop e e-mail",
    "phone.fullPlanItem11": "Atendimento autom\u00E1tico e IVR ilimitados",
    "phone.fullPlanItem12": "Diret\u00F3rio de discagem por nome",
    "phone.fullPlanItem13": "Grupos de distribui\u00E7\u00E3o autom\u00E1tica de chamadas (ACD) com fila de chamadas",
    "phone.fullPlanItem14": "Intercepta\u00E7\u00E3o/monitoramento/sussurro/tomada de fala",
    "phone.fullPlanItem15": "Roteamento de feriados e hor\u00E1rio comercial",
    "phone.fullPlanItem16": "Chamadas de confer\u00EAncia de 3 vias para fins espec\u00EDficos",
    "phone.fullPlanItem17": "Grava\u00E7\u00E3o de chamadas",
    "phone.fullPlanItem17Tip": "As grava\u00E7\u00F5es autom\u00E1ticas e manuais de chamadas est\u00E3o dispon\u00EDveis.",
    "phone.fullPlanItem18": "Bloqueio de chamadas an\u00F4nimas e especificadas configur\u00E1vel",
    "phone.fullPlanItem19": "Chamada de emerg\u00EAncia",
    "phone.fullPlanItem19Tip": "Fa\u00E7a chamadas para servi\u00E7os de emerg\u00EAncia locais",
    "phone.fullPlanItem20": "Endere\u00E7amento Nomadic E911 (EUA e Canad\u00E1) -",
    "phone.fullPlanItem20Tip": "Detecte dinamicamente a localiza\u00E7\u00E3o do usu\u00E1rio e informe o endere\u00E7o de emerg\u00EAncia correspondente aos servi\u00E7os de emerg\u00EAncia locais (somente EUA e Canad\u00E1) e \u00E0 equipe de seguran\u00E7a interna",
    "phone.fullPlanItem21": "Central de resposta de emerg\u00EAncia",
    "phone.fullPlanItem21Tip": "Permite que sua equipe de seguran\u00E7a interna seja alertada sobre chamadas de emerg\u00EAncia e registre/monitore/intercepte chamadas de emerg\u00EAncia para ajudar a coordenar a resposta.",
    "phone.fullPlanItem22": "Exibi\u00E7\u00E3o/delega\u00E7\u00E3o de linha compartilhada",
    "phone.fullPlanItem23": "Transfer\u00EAncia de chamada entre dispositivos",
    "phone.fullPlanItem24": "Estacionamento de chamadas",
    "endToEndEncryptionForZoomPhone": "Criptografia ponta a ponta para o Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Quando habilitada para Zoom Phone, a criptografia ponta a ponta (E2EE) faz com que a chamada seja criptografada usando chaves de criptografia que só são conhecidas pelos dispositivos de quem faz a chamada e de quem a recebe. Os usuários também poderão conferir o status da criptografia ponta a ponta. Para isso, bastará que enviem um para o outro um código de segurança exclusivo.",
    "phone.fullPlanItem43": "Provisionamento de toque zero de telefones",
    "phone.fullPlanItem44": "Combine tipos de plano em uma conta",
    "phone.fullPlanItem46": "Relat\u00F3rios em tempo real e pain\u00E9is de qualidade",
    "phone.fullPlanItem47": "Suporte para ambiente de \u00E1rea de trabalho virtual (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">Saiba mais</a> sobre VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Disponível para todos os clientes independentes de telefone. Os planos de suporte variam quando combinados com os planos de reunião.",
    "phone.fullPlanItem49": "Suporte para Traga sua Pr\u00F3pria Operadora",
    "phone.fullPlanItem49Tip": "Suporte para emparelhamento direto e baseado no local para seu provedor de servi\u00E7os PSTN existente",
    "phone.fullPlanItem50": "Integra\u00E7\u00E3o h\u00EDbrida com PBXs herdados",
    "phone.fullPlanItem51": "Pressione para falar",
    "phone.fullPlanItem61": "Fax on-line",
    "phone.fullPlanItem61Tip": "Envie e receba faxes ilimitados nos EUA e Canadá. Para faxes internacionais, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\"> consulte as tarifas</a>",
    "phone.fullPlanSms": "SMS e MMS",
    "phone.fullPlanSmsTip": "Dispon\u00EDvel para n\u00FAmeros dos EUA e Canad\u00E1 apenas com a compra de um plano de chamadas. Dispon\u00EDvel para uso com n\u00FAmeros diretos (n\u00E3o n\u00FAmeros de empresas).",
    "meetings.fullPlanItem6": "Suporte t\u00E9cnico",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Somente t\u00EDquete",
    "meetings.fullPlanItem6_pro": "T\u00EDquete e chat ao vivo",
    "meetings.fullPlanItem6_biz": "T\u00EDquete, chat ao vivo e telefone",
    "meetings.fullPlanItem6_ent": "T\u00EDquete, chat ao vivo e telefone",
    "knowledgeBase": "Base de Conhecimentos",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Solucione problemas técnicos e acesse nossos recursos de suporte nos artigos da nossa base de conhecimento.",
    "zoomCommunity": "Comunidade Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Um lugar para encontrar soluções, tirar dúvidas e colaborar com outros usuários Zoom.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Receba respostas para suas perguntas e solucione problemas técnicos através do nosso chatbot.",
    "submitWebTickets": "Envie tickets pela web",
    "liveChatSupport": "Suporte de chat ao vivo",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Planos de assinatura superiores a US$ {amount}/mês",
    "livePhoneSupport": "Suporte por telefone ao vivo",
    "meetWithAgentOnVideo": "Fale com um agente por vídeo",
    "subscriptionPlansGreaterThan_200UsdMonth": "Planos de assinatura superiores a US$ 200/mês",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Aumente a produtividade ao usar seus aplicativos favoritos direto no Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Personalize seu próprio avatar para se divertir um pouco nas reuniões e se apresentar de forma dinâmica, sem a necessidade de estar com o vídeo ativado",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "E-mail",
    "common.plans.meeting.title": "Reuniões",
    "plans.basic_free.upgrade.item1": "Até 30 horas por reunião",
    "common.statistics.participants": "{0} Participantes",
    "common.per_meeting_unit": "por reunião",
    "common.participant_limit.increase_with_large_meetings": "Aumente com o Grande reunião",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Quadro de compartilhamento",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Ilimitado",
    "common.plans.team_chat.title": "Chat em equipe",
    "common.plans.mail_calendar.title": "E-mail e Calendário",
    "common.plans.cloud_storage.title": "Armazenamento em nuvem",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Legendas traduzidas do Zoom",
    "common.plans.extras.title": "Extra",
    "common.plans.extras.desc": "gerencie domínios da empresa e muito mais",
    "zoom_one_edu_bundle.school.title": "Zoom One para Educação Escola e Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One para Educação Escola e Campus Plus",
    "per_billing_cycle_license.monthly": "/mês/licença",
    "per_billing_cycle_license.yearly": "/ano/licença",
    "per_billing_cycle_space.monthly": "/mês/espaço",
    "per_billing_cycle_space.yearly": "/ano/espaço",
    "common.dialog.feature_list": "Veja a lista completa de recursos",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5GB por licença",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB por licença",
    "detail_dialog.meeting_feature.cloud_recording.ent": "O plano Empresarial Plus inclui o plano Ilimitado",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Rooms + Conector de sala de conferência (proporção 1:25)",
    "plans.whiteboard.ent": "O plano Empresarial Plus inclui o Ilimitado Plus",
    "plans.zp.ent": "Incluso no Empresarial Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Reserva de local de trabalho antecipada ou no local e muito mais",
    "plans.largeMeeting.intro_tip": "O Grande reuniões é um add-on opcional que pode ser feito durante a finalização da compra, permitindo que você organize uma reunião para até 500 ou 1000 participantes, dependendo da licença adquirida.",
    "common.participant_limit.expandable_with_large_meetings": "Expansível com o add-on para Grande reunião",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1.000 para Empresarial Plus</span>",
    "plans.webinar": "Webinar Zoom",
    "plans.webinar.ent": "O plano Empresarial Plus inclui o Session 1000 (inclui Webinar)",
    "per_billing_cycle_user.monthly": "/mês/usuário",
    "per_billing_cycle_user.annually": "/ano/usuário",
    "closeComparisonChart": "Fechar quadro de comparação",
    "archiving_api": "API de arquivamento",
    "dlp_api": "API de prevenção contra perda de dados (DLP)",
    "info_barriers": "Barreiras de informação",
    "chat_etiquette": "Etiqueta de chat",
    "gdrp": "Regulamento Geral sobre Proteção de Dados (GDPR)",
    "regiona_data_centers": "Datacenters regionais",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Criptografia por padrão",
    "end_to_end_encryption": "Criptografia de ponta a ponta",
    "cryptographic_boundary": "Limite criptográfico",
    "vdi": "Desktop virtual (VDI)",
    "customer_managed_key": "Chave gerenciada pelo cliente",
    "gpo_msi_policies": "Políticas de GPO/MSI",
    "msi": "Implementação em massa (MSI)",
    "ntt": "Ferramenta de teste de rede (NTT)",
    "dashboards": "Painéis",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Capacidade de sobrevivência do Zoom Phone",
    "zoom_meeting_survivability": "Capacidade de sobrevivência do Zoom Meeting",
    "paid_option": "Opção paga",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Principais recursos",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Escola e campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Escola e campus plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "ru-RU": {
    "billing.essential_apps": "Основные приложения",
    "billing.essential_apps.dialog_desc": "Развивайте свой бизнес и управляйте им с помощью приложений для ведения протоколов конференций, вовлечения участников команды в выполнение согласованных действий и получения аналитической информации, способствующей улучшению качества разговоров с клиентами. Бесплатные приложения премиум-класса включены в план сроком на 1 год.",
    "billing.see_more_details": "См. подробности",
    "billing.essential_app.legal_copy": "Предложение действительно только для пользователей с текущей лицензией на подписку Zoom One «Профессиональный», «Бизнес» или «Бизнес Плюс», приобретенной на онлайн-канале Zoom по адресу zoom.us/buy, по состоянию на 4 января 2023 г. или позже. Это предложение не распространяется на пользователей с подпиской в учетной записи для учреждений здравоохранения, образовательных учреждений или государственных органов.  Доступ к каждому приложению, за исключением Coda, предоставляется с момента, когда индивидуальный пользователь активирует приложение, и действует в течение 1 года после этого. Доступ к Coda для всех пользователей одной и той же учетной записи Zoom предоставляется с момента первой активации Coda, выполненной любым пользователем этой учетной записи Zoom, и действует для всех пользователей этой учетной записи Zoom в течение 1 года после этого, независимо от даты начала активации, выполненной другими пользователями той же учетной записи Zoom после первого пользователя.Переназначение или отмена соответствующей лицензии или подписки пользователя приведет к прекращению доступа этого пользователя ко всем приложениям, независимо от того, осталось ли время в годичном периоде доступа.На каждое приложение распространяются собственные условия использования и политика конфиденциальности, доступные во время активации.Имеющиеся приложения доступны только на английском языке.Предложение распространяется только на список основных приложений в <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>. Предложение в отношении этих конкретных приложений не распространяется на пользователей с уже существующими подписками на любое из этих приложений.Компания Zoom оставляет за собой право на изменение или отмену этого предложения в любое время и без предварительного уведомления и не несет за это ответственности.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Управление посетителями"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Чат в реальном времени и поддержка по телефону круглосуточно и без выходных"
      },
      "learn_more": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
      "new": "Новое",
      "plan_details": {
        "meeting": {
          "title": "\u041A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
          "host_meeting_up_to_participants": "Организация до {0} участников",
          "meeting_hours": "Неограниченные конференции, продолжительность каждой конференции до 30 часов",
          "recording_storage": "{0} ГБ облачного хранилища записей (на лицензию)",
          "auto_captions": "Автоматические субтитры"
        },
        "whiteboard": {
          "title": "Доска сообщений",
          "boards_storage": "{0} редактируемых доски",
          "standard_features": "Стандартные функции"
        },
        "team_chat": {
          "title": "Коллективный чат",
          "desc": "Групповой чат и совместное использование файлов"
        },
        "main_calendar": {
          "title": "Почта и календарь",
          "desc": "Клиент и службы почты и календаря"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Создавайте и совместно используйте редактируемые документы в Zoom",
          "desc2": "Личные и совместные заметки с возможностью редактирования форматированного текста"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "С легкостью записывайте, редактируйте и совместно используйте короткие видеоролики",
          "desc2": "Неограниченное количество видеороликов и расширенные функции"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Быстро получайте доступ к сводкам конференций, помощь в составлении сообщений и многое другое"
        },
        "EssentialApp": {
          "title": "Основные приложения",
          "desc1": "Бесплатные приложения премиум-класса сроком на 1 год (применяются условия использования)",
          "desc2": "Повышение уровня коллективной работы и производительности в команде"
        },
        "livechat": {
          "title": "Поддержка в чате в реальном времени"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Изменить на план Zoom Workplace Профессиональный?",
            "content": "Ранее вы выбрали план Zoom Workplace Бизнес, который позволяет проводить конференции с участием до 300 посетителей и предусматривает функцию Zoom Scheduler и многие другие возможности. Все равно изменить план на «Профессиональный»?",
            "confirm": "Подтвердите изменение",
            "keep_current": "Оставить текущий план"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} присутствующие",
          "participants": "{0} Участники",
          "user_range": "{0}–{1} пользователей",
          "items": "{num} позиции"
        },
        "button": {
          "ok": "OK",
          "add": "Добавить",
          "buy_now": "Купить сейчас",
          "try_for_days": "Пробуйте в течение {0} дн.",
          "contact_sales": "Обратиться в отдел продаж",
          "close": "Закрыть",
          "cancel": "Отмена",
          "edit": "Редактировать",
          "got_it": "Понятно"
        },
        "title": {
          "everything_in_and": "Все возможности плана {0}, а также перечисленное далее."
        },
        "tag": {
          "new": "Новое",
          "free_trial": "Бесплатная пробная версия"
        },
        "billing_cycle": {
          "annual": "Годовой",
          "monthly": "На месяц",
          "quarterly": "Квартальный",
          "two_years": "Два года",
          "three_years": "Три года"
        },
        "errors": {
          "unknown_error_try_again": "Неизвестная ошибка обработки транзакции. Попытайтесь еще раз позже."
        },
        "excluding_tax": {
          "vat_tip": "без НДС",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Ограниченный функции",
        "pro_plus": {
          "host_meeting_up_to_participants": "Организация до {0} участников",
          "gb_of_cloud_recording_storage": "{0} ГБ памяти хранилища для записи в облако (на лицензию)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion для генерирования содержимого и переводов",
            "features_item2": "Совместное использование неограниченного количества документов с командой",
            "features_item3": "Доступ к неограниченному журналу версий",
            "comparison_table_tips": "Повысьте эффективность коллективной работы с помощью документов с приоритетом ИИ, которые превращают содержимое конференции в практически полезные документы, вики-страницы и проекты."
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Базовый",
            "features_item1": "автоматически выявлять задачи в рамках конференций, телефонных вызовов, чатов и документов;",
            "features_item2": "выполнять такие задачи, как планирование контрольных конференций и составление черновиков документов;",
            "features_item3": "легко помечать задачи как выполненные по мере их закрытия, чтобы отслеживать прогресс и сосредоточить внимание на следующей задаче;",
            "features_item4": "управлять задачами на платформе Zoom Workplace, в том числе в Zoom Docs.",
            "features_item1_opc": "Используйте потенциал AI Companion для выявления и создания задач на основе данных чатов, сообщений электронной почты, документов, досок и сводок конференций",
            "features_item2_opc": "Легко сортируйте, фильтруйте, группируйте и ищите информацию, чтобы быстро узнавать контекст для задач",
            "learn_more_header": "Отслеживайте выполнение списка задач с помощью AI Companion*, чтобы достигать лучших результатов в Zoom Workplace.",
            "learn_more_footer": "\* Решение AI Companion доступно только для планов Zoom Workplace «Профессиональный», «Бизнес» и «Предприятие».",
            "features_prefix": "Решение AI Companion поможет вам:",
            "comparison_table_tips": "Отслеживайте выполнение списка задач и закрывайте их вовремя с помощью решения с приоритетом ИИ, которое предоставляет рекомендации относительно задач на основе сводок бесед и конференций в Zoom Workplace.",
            "tasks_label_text": " Управление задачами с приоритетом ИИ"
          },
          "title": "Бизнес «Плюс»",
          "contact_us_for_more_pricing": "Контактные данные для получения информации о ценах и прочих сведений",
          "contact_sales": "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u0432 \u043E\u0442\u0434\u0435\u043B \u043F\u0440\u043E\u0434\u0430\u0436",
          "meetings": "\u041A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
          "phone": "\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u044F",
          "phone_sub_title": "\u0411\u0435\u0437\u043B\u0438\u043C\u0438\u0442\u043D\u044B\u0435 \u0432\u044B\u0437\u043E\u0432\u044B",
          "use_only": "Использование только в деловых целях",
          "team_chat": {
            "title": "Коллективный чат",
            "title_desc": "Групповой чат и совместное использование файлов"
          },
          "cloud_storage": {
            "title": "\u041E\u0431\u043B\u0430\u0447\u043D\u043E\u0435 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435"
          },
          "mail_calender": {
            "title": "Почта и календарь"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Клиент и обслуживание"
          },
          "up_to_30_hours_per_meeting": "продолжительность каждой конференции до 30 часов",
          "300_attendees": "300 присутствующих",
          "per_meeting": "на конференцию",
          "whiteboard": {
            "title": "Доска сообщений"
          },
          "new": "Новое",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 ГБ",
          "extras": "Дополнения",
          "sso_managed_domains_more": "SSO, управляемые домены и другое",
          "scheduler": "Планировщик",
          "global_select": "Global Select",
          "unlimited_regional": "Неограниченные региональные вызовы",
          "translated_captions": "Переведенные субтитры",
          "workspace_reservation": "Резервирование рабочего места.",
          "auto_translated_captions": "Автоматические и переведенные субтитры",
          "unlimited_editable_boards": "Неограниченное количество редактируемых досок",
          "standard_features": "Стандартные функции",
          "advanced_docu_controls": "Расширенные элементы управления документами",
          "chats_channels_for_collaboration": "Чаты и каналы для коллективной работы, общего доступа к файлам и другое",
          "zoom_phone_is_biz_use_only": "Решение Zoom Phone предназначено только для бизнеса.",
          "unlimited_regional_calling": "\u0411\u0435\u0437\u043B\u0438\u043C\u0438\u0442\u043D\u044B\u0435 \u0440\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u044B\u0437\u043E\u0432\u044B",
          "domestic_sms_mms": "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 SMS \u0438 MMS",
          "automatic_call_distribution_groups": "\u0413\u0440\u0443\u043F\u043F\u044B \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0432\u044B\u0437\u043E\u0432\u043E\u0432 (ACD) \u0441 \u043E\u0447\u0435\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u044C\u044E \u0432\u044B\u0437\u043E\u0432\u043E\u0432",
          "single_sign_on": "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0435\u0434\u0438\u043D\u043E\u0433\u043E \u0432\u0445\u043E\u0434\u0430",
          "managed_domains": "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u0434\u043E\u043C\u0435\u043D\u044B",
          "company_branding": "\u0424\u0438\u0440\u043C\u0435\u043D\u043D\u0430\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u0438\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
          "mail_calender_client_services_beta": "Клиент и службы почты и календаря (бета-версия)",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Неограниченные конференции, продолжительность каждой конференции до 30 часов",
          "mail_and_calendar_client_and_services_beta": "Клиент и службы почты и календаря (бета-версия)",
          "easily_record_edit_share_videos": "С легкостью записывайте, редактируйте и совместно используйте короткие видеоролики",
          "unlimited_videos_advanced_features": "Неограниченное количество видеороликов и расширенные функции",
          "create_share_editabel_docu_within_zoom": "Создавайте и совместно используйте редактируемые документы в Zoom",
          "personal_collaborative_notes_rich_text_editing": "Личные и совместные заметки с возможностью редактирования форматированного текста",
          "effortlessly_share_meeting": "Простая публикация информации о временных интервалах для конференций, облегчающая бронирование",
          "works_with_zoom_meeting_mail_calender_google_ms": "Работает с Zoom Meetings, Zoom Mail и Zoom Calendar, Google и Microsoft 365",
          "up_to_300_attendees": "До 300 присутствующих",
          "10_gb_of_storage": "10 ГБ хранилища",
          "host_meeting_up_to_300_participants": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439 \u0441 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0434\u043E 300 \u0447\u0435\u043B\u043E\u0432\u0435\u043A",
          "10_gb_of_cloud_recording_storage": "10 ГБ облачного хранилища записей (на лицензию)",
          "starting_at_licenses_year": "\u041E\u0442 {1}\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0439 \u0437\u0430 {0}\u0434\u043E\u043B\u043B. /\u0433\u043E\u0434",
          "starting_at_licenses_month": "\u041E\u0442 {1}\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0439 \u0437\u0430 {0} \u0434\u043E\u043B\u043B. /\u043C\u0435\u0441\u044F\u0446",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Быстро получайте доступ к сводкам конференций, помощь в составлении сообщений и многое другое",
          "learn_more": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
          "essential_apps": "Основные приложения",
          "increase_team_collaboration": "Повышение уровня коллективной работы и производительности в команде",
          "free_premium_apps": "Бесплатные приложения премиум-класса сроком на 1 год (применяются условия использования)",
          "visitor_management": "Управление посетителями",
          "visitor_management_custom_invites": "Персонализация приглашений",
          "visitor_management_visitor_check": "Регистрация у терминала",
          "visitor_management_receive_detailed": "Подробные показатели использования рабочих мест посетителями"
        },
        "custom_avatar": {
          "title": "Пользовательский аватар",
          "label_text": "3 минуты в месяц",
          "basic_feature": "всего 1 минута",
          "pricing_feature": "3 минуты в месяц",
          "learn_more_subtitle": "Создайте с помощью ИИ реалистичную версию себя, которая имеет такой же, как у вас, голос, и может общаться на нескольких языках.",
          "features_item1": "Ежемесячно создавайте до 3 реалистичных цифровых аватаров, которые имеют такую же внешность и голос, как у вас, для презентаций и демонстраций.",
          "features_item2": "Снимайте видео со своим аватаром продолжительностью до 3 minutes с помощью AI Companion.",
          "features_item3": "На выбор есть 18 предварительно разработанных аватаров, с которыми можно быстро снимать высококачественные видео.",
          "features_item4": "Предусмотрена поддержка виртуального фона.",
          "features_item1_opc": "Ежемесячно создавайте до 3 реалистичных цифровых аватаров, которые имеют такую же внешность и голос, как у вас, для презентаций и демонстраций.",
          "features_item2_opc": "Снимайте видео со своим аватаром продолжительностью до 3 minutes с помощью AI Companion.",
          "comparison_table_tips": "Функция «Пользовательский аватар» создает с помощью ИИ реалистичную версию вас, которая имеет такой же, как у вас, голос, и может общаться на нескольких языках."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Быстро получайте доступ к сводкам конференций, помощь в составлении сообщений и многое другое",
        "learn_more_dialog": {
          "desc": "Добивайтесь большего с помощью AI Companion! Он может писать контент, планировать конференции, помогать управлять проектами и выполнять множество других действий.",
          "tip1": "Получайте план встречи заранее, чтобы проводить более эффективные конференции.",
          "tip2": "Следите за ходом проектов с помощью уведомлений и автоматического создания задач.",
          "tip3": "Эффективно организуйте календарь и управляйте своим временем.",
          "tip4": "Создавайте письменный и визуальный контент, соответствующий вашему стилю, в Docs, Whiteboard и Zoom Workplace."
        },
        "top_features": "Лучшие функции",
        "more_to_come": "В будущем ожидается еще больше невероятных функций!",
        "discover_more": "Откройте еще больше способов улучшить свою работу с помощью AI Companion!",
        "detail_desc": "Решение AI Companion предоставляется с оплаченными службами в учетных записях пользователей Zoom без дополнительных затрат. Может быть недоступно для определенных отраслей и регионов."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/г./лиц.",
        "month_licnese": "/месяц за лицензию",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/мес.",
          "per_year": "/лицензий"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/пользователь"
        },
        "learn_more": "Подробнее",
        "required": "Обязательное",
        "zoom_one_required": "Требуется Zoom Workplace",
        "large": {
          "features_tip": "Расширьте свой охват, увеличив количество участников до 1000 человек.",
          "label_title1": "500 участников",
          "label_title2": "1000 участников"
        },
        "cmr": {
          "features_tip": "Храните, транслируйте и загружайте ваши видеозаписи непосредственно из облака Zoom.",
          "explain_desc": "Облачное хранилище входит в определенные тарифные планы Zoom One: «Профессиональный» (5 ГБ), «Бизнес» (5 ГБ), «Бизнес Плюс» (10 ГБ) и «Предприятие» (неограниченный объем)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 часов",
          "option_label2": "≈ 650 часов",
          "option_label3": "≈ 3,500 часов",
          "option_label4": "≈ 17,500 часов",
          "intro_label2": "Доступное пространство для хранения до 5 ТБ/мес.",
          "tooltip_content": "Объем хранилища записей зависит от количества участников с включенным видео, разрешения конференции и разрешения совместно используемого содержимого."
        },
        "whiteboard": {
          "plus_title": "План доски сообщений Плюс",
          "title": "Whiteoard",
          "features_tip": "Ведите коллективную работу с другими пользователями на досках сообщений как во время, так и вне конференций.",
          "explain_desc": "Предусмотрена в планах Zoom One Бизнес, Zoom One Бизнес Плюс и Zoom One Предприятие.",
          "explain_desc_plus": "Входит в план Zoom One Предприятие Плюс и в каждую подписку на Zoom Rooms",
          "option_label1": "Неограниченное количество досок с облачным хранилищем объемом 1 ГБ",
          "option_label2": "Расширенные функции с неограниченным количеством досок и облачным хранилищем",
          "intro_label1": "Неограниченное количество одновременно редактируемых досок сообщений",
          "intro_label2": "Стандартные функции и расширенное управление документами",
          "intro_label3": "Расширенные функции доски сообщений, в том числе пользовательские и организационные шаблоны, а также сторонние интеграции"
        },
        "translated_captions": {
          "features_tip": "Создайте условия для международной коллективной работы, используя автоматические субтитры на предпочитаемом языке.",
          "intro_label1": "Участники могут самостоятельно включать субтитры и переключать языки.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Просмотреть поддерживаемые языки"
        },
        "crc": {
          "features_tip": "Возможность использования любых конечных точек для видео-конференц-связи, соответствующих стандарту SIP/H.323, что способствует эффективной гибридной работе.",
          "intro_label1": "Взаимодействие с рабочими станциями предыдущих поколений производства Polycom, Cisco, Lifesize и других компаний",
          "intro_label2": "Облачный или локальный коннектор залов (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Простое планирование благодаря гибким возможностям и настраиваемым временным интервалам",
          "host_one_on_one": "Индивидуальные и групповые конференции с использованием всего одной ссылки",
          "customize_reminders": "Настройка напоминаний по электронной почте/SMS для сокращения пропущенных встреч",
          "sync_calendars": "Синхронизация календарей с помощью интеграций с Google, Microsoft 365 и Zoom",
          "features_tip": "С легкостью публикуйте информацию о временных интервалах для конференций в течение рабочего дня, собеседований и многого другого.",
          "intro_label1": "Интеграция календаря",
          "intro_label2": "Доступность повторений",
          "intro_label3": "Масштабируемая конференция",
          "intro_label4": "Настраиваемые уведомления",
          "intro_sub_label1": "Google, Microsoft 365 и Zoom ",
          "intro_sub_label2": "публикация информации о временных интервалах, доступных для бронирования ",
          "intro_sub_label3": "одна конференция для одного или нескольких участников",
          "intro_sub_label4": "автоматизированная отправка напоминаний и подтверждений по электронной почте или в SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Записывайте и редактируйте короткие качественные видеосообщения и делитесь ими.",
          "intro_label1": "Создавайте неограниченное количество видео без ограничений по времени",
          "intro_label2": "Записывайте свой экран и видео вместе или отдельно",
          "intro_label3": "Обрезайте видео при необходимости и делитесь ссылкой",
          "intro_label4": "Получите доступ к расширенным функциям, таким как расшифровки аудиосвязи и статистика",
          "explain_desc": "Лицензия Clips Плюс входит в подписки Workplace «Профессиональный», «Бизнес» и «Предприятие». Разные функции каждого тарифного плана можно изучить в разделе сравнения на странице цен."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Платформа для мероприятий с расширенными возможностями, надежной регистрацией и функциями налаживания связей. Идеально подходит для проведения виртуальных и гибридных мероприятий.",
          "tooltip_content": "Организация неограниченных вебинаров и мероприятий с самостоятельным выбором количества участников",
          "intro_title": "Все возможности собраны в Sessions",
          "intro_label1": "Повышение вовлеченности аудитории благодаря многосеансовым мероприятиям",
          "intro_label2": "Простая организация мероприятий благодаря индивидуально настраиваемому оформлению билетов и мобильному приложению",
          "intro_label3": "Повышение дохода от мероприятий благодаря выставочной площадке и спонсорской области",
          "intro_label4": "Поощрение взаимодействия присутствующих с помощью настраиваемых профилей",
          "intro_label5": "Расширение охвата благодаря просмотру по требованию в лобби мероприятия",
          "intro_label6": "Ускорение настройки мероприятия с помощью специально подобранных шаблонов мероприятий",
          "events_feature_item1_20240827": "Используйте несколько потоков, чтобы организовывать виртуальные мероприятия на несколько дней",
          "events_feature_item2_20240827": "Способствование налаживанию связей благодаря профилям посетителей и чату в лобби",
          "events_feature_item3_20240827": "Ориентирование посетителей благодаря потоковой трансляции сеансов в лобби",
          "events_feature_item4_20240827": "Повышение дохода от мероприятий благодаря выставочной площадке и спонсорству",
          "events_feature_item5_20240827": "Улучшение будущих мероприятий благодаря опросам после конференций",
          "events_feature_item6_20240827": "Ускорение настройки мероприятия с помощью специально подобранных шаблонов мероприятий",
          "attendees_start_at": "{0} участников по цене от",
          "explain_desc": "Подробнее о Zoom Events",
          "contact_account_owner": "Для того чтобы приобрести Events, <a href=\"/account\" target=\"_blank\">свяжитесь с владельцем своей учетной записи</a>.",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Усовершенствуйте интерактивные односеансовые мероприятия с помощью таких функций, как применение фирменной символики, коллективная работа с участием нескольких организаторов и управление мероприятиями.",
          "tooltip_content": "Организация неограниченных вебинаров и мероприятий с самостоятельным выбором количества участников",
          "intro_title": "Включает Zoom Webinars",
          "intro_label1": "Настройка целевых страниц мероприятий для эффективного применения фирменной символики",
          "intro_label2": "Продвижение мероприятий с помощью брендированных сообщений электронной почты",
          "intro_label3": "Измерение показателей эффективности благодаря интерактивной панели управления",
          "intro_label4": "Беспрепятственная коллективная работа с соорганизаторами и соредакторами",
          "intro_label5": "Инструменты для проведения профессиональных мероприятий: мероприятия с предварительной записью",
          "sessions_feature_item1_20240827": "Выведение вебинаров на новый уровень с помощью настраиваемых сцен и фирменной символики",
          "sessions_feature_item2_20240827": "Упрощение планирования мероприятий с помощью решения AI Companion, которое генерирует сообщения и изображения",
          "sessions_feature_item3_20240827": "Рекламирование прошедших и будущих мероприятий в центре содержимого с фирменной символикой",
          "sessions_feature_item4_20240827": "Проведение профессиональных мероприятий с функциями закулисного сеанса, имитации вебинаров в реальном времени и протокола RTMP",
          "sessions_feature_item5_20240827": "Улучшение будущих вебинаров благодаря аналитическим данным по всем мероприятиям",
          "explain_desc": "Подробнее о Zoom Sessions",
          "contact_account_owner": "Для того чтобы приобрести Sessions, <a href=\"/account\" target=\"_blank\">свяжитесь с владельцем своей учетной записи</a>.",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Видеовебинары",
          "features_tip": "С легкостью транслируйте сообщения с помощью удобной в использовании платформы для вебинаров.",
          "tooltip_content": "Организация неограниченных вебинаров и мероприятий с самостоятельным выбором количества участников",
          "intro_label1": "Вовлечение аудитории с помощью веб-трансляции с высоким качеством видео",
          "intro_label2": "Повышайте вовлеченность с помощью функции вопросов и ответов, опросов и реакций",
          "intro_label3": "Улучшение стратегии проведения вебинара на основании отчетов по итогам мероприятия",
          "intro_label4": "Поддержка до 100 000 присутствующих и 100 участников группы",
          "monthly_subscription": "Месячная подписка",
          "annual_subscription": "Годовая подписка",
          "one_million": "1 млн",
          "single_use": "Одноразовый",
          "one_month": "Одномесячный",
          "event_attendee": "Посетители Zoom Events или Zoom Sessions —",
          "event_attendee_desc": "любые присоединившиеся пользователи, которые не являются лицензированными организаторами центра. Пользователи со специальными ролями также считаются посетителями и могут участвовать с использованием аудио, видео и демонстрации экрана (если включено).",
          "webinar_attendee": "Посетители Zoom Webinars —",
          "webinar_attendee_desc": "любые присоединившиеся пользователи, которые не являются организаторами или докладчиками. Они находятся в режиме только для просмотра, и ими управляет организатор, который может включить их звук, а также функции «Вопросы и ответы» и чат для взаимодействия.",
          "pay_per_attendee": "Оплата из расчета на присутствующего",
          "attendees": "присутствующие"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Переосмыслите работу в команде благодаря платформе для коллективной работы на базе ИИ.",
          "label_title1": "Workplace Профессиональный",
          "label_title2": "Workplace Профессиональный Плюс",
          "label_title3": "Workplace Бизнес",
          "label_title4": "Workplace Бизнес Плюс",
          "intro_label1": "Организуйте неограниченные конференции продолжительностью до 30 часов с участием до 100 пользователей.",
          "intro_label2": "Получите доступ к трем доскам сообщений с возможностью одновременного редактирования и стандартными функциями",
          "intro_label3": "Записывайте и редактируйте короткие качественные видеосообщения и делитесь ими с помощью Clips Плюс.",
          "intro_label4": "Выполняйте задачи более эффективно с помощью Zoom AI Companion.",
          "intro_label5": "Неограниченный тарифный план Zoom Phone для США и Канады [не включает самостоятельный выбор оператора (BYOC), УАТС и сторонние УАТС]",
          "intro_label6": "Организуйте неограниченные конференции продолжительностью до 30 часов с участием до 300 пользователей.",
          "intro_label7": "Публикуйте информацию о временных интервалах для конференций, собеседований и многого другого с помощью Zoom Scheduler",
          "intro_label8": "Неограниченный тарифный план Zoom Phone для США и Канады",
          "intro_label8_UK": "Безлимитный план Zoom Phone для Великобритании и Ирландии",
          "intro_label8_AU": "Безлимитный план Zoom Phone для Австралии и Новой Зеландии",
          "intro_label8_JP": "Безлимитный план Zoom Phone для Японии",
          "intro_label9": "Управление посетителями",
          "intro_label10": "Дополнительные функции",
          "intro_label11": "Поддержка в чате в реальном времени",
          "intro_title1": "Все возможности плана «Профессиональный», а также перечисленное далее.",
          "intro_title2": "Все возможности плана «Бизнес», а также перечисленное далее.",
          "intro_label_tip1": "Zoom Phone в тарифном плане «Профессиональный Плюс» не включает функции самостоятельного выбора оператора (BYOC), сторонних УАТС и VDI. Дополнительную информацию см. на странице цен на Zoom Phone.",
          "intro_label_tip2": "При оформлении заказа можно выбрать безлимитные региональные вызовы для США и Канады, Австралии и Новой Зеландии, Великобритании и Ирландии или Японии.",
          "intro_label_tip3": "Дополнительные функции включают 10 ГБ облачного хранилища, переведенные субтитры и резервирование рабочего места.",
          "intro_label_tip4": "Zoom Phone в тарифном плане «Профессиональный Плюс» не включает функции самостоятельного выбора оператора (BYOC), сторонних УАТС и VDI. Дополнительную информацию см. на странице цен на Zoom Phone."
        },
        "power_pack": {
          "title": "Пакет для опытных пользователей Zoom Phone",
          "features_tip": "Улучшенная аналитика очереди звонков и анализ данных за прошлые периоды для команд контактных центров.",
          "intro_label1": "Расширенное окно контактов для оптимизации управления вызовами",
          "intro_label2": "Номера телефона автоматического оператора и очереди звонков"
        },
        "international_calling": {
          "title": "Международные вызовы",
          "features_tip": "Неограниченные международные вызовы в более чем 15 странах и регионах.",
          "intro_label1": "Можно приобрести с любым из безлимитных тарифных планов",
          "intro_label2": "Ознакомьтесь с нашим списком поддерживаемых стран и регионов для безлимитных международных вызовов.",
          "intro_labe2_tooltip": "США, Канада, Великобритания, Ирландия, Австралия, Новая Зеландия, Австрия, Дания, Франция, Германия, Италия, Португалия, Испания, Швеция, Бельгия, Нидерланды, Швейцария, Пуэрто-Рико, Япония.",
          "intro_label2_view_list": "Просмотреть список"
        },
        "workspace_reservation": {
          "title": "Резервирование рабочего места",
          "intro_title": "Легко резервируйте гибкие рабочие места либо бронируйте гостиничные номера заранее или на месте с помощью устройств, интегрированных с Zoom.",
          "intro_label1": "Доступ к зарезервированным рабочим местам и гостиничным номерам через приложение Zoom Workplace, настольный ПК или браузер.",
          "intro_label2": "Персонализированные рекомендации в отношении стола на базе ИИ.",
          "intro_label3": "Резервирование рабочих мест прямо в Google Календаре или Outlook с напоминаниями и оповещениями о регистрации.",
          "intro_label4": "Навигация к зарезервированным рабочим местам с помощью функции поиска пути."
        },
        "visitor_management": {
          "title": "Управление посетителями",
          "intro_title": "Оптимизируйте регистрацию посетителей с помощью пользовательских приглашений, удобной регистрации в терминале, отчетов и метрик.",
          "intro_label1": "Управляйте приглашениями, местоположением посетителей и историей посещений на портале Zoom.",
          "intro_label2": "Создавайте, отслеживайте, повторно отправляйте и удаляйте приглашения и получайте уведомления о прибытии гостей.",
          "intro_label3": "Заполняйте формы, получайте указания о том, как добраться, и пользуйтесь как посетитель удобной возможностью регистрироваться через терминал.",
          "intro_label4": "Получите доступ ко всем функциям на привычном портале Zoom для удобного управления."
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Большая конференция",
          "description1": "Увеличьте количество поддерживаемых интерактивных участников конференции в реальном времени до 1000",
          "description2": "Все участники могут транслировать собственное видео и звук, а также демонстрировать свой экран"
        },
        "cloud_storage": {
          "title": "Облачное хранилище",
          "description2": "Доступны форматы файлов MP4 или M4A"
        },
        "translated_captions": {
          "title": "Переведенные субтитры",
          "description1": "Улучшите конференцию с помощью автоматизированных многоязычных субтитров, позволяющих участникам включить поддерживаемый язык и переключаться на него",
          "description2": "Доступно в Zoom Meetings и Zoom Webinars"
        },
        "tollfree": {
          "title": "Аудиоконференции",
          "subcontent": "Звонки на номера телефона конференций по всему миру",
          "description1": "Расширенные возможности вызовов: ответный вызов, международные вызовы на бесплатный номер и набор местного номера для стран категории «премиум»",
          "description2": "Бесплатные вызовы для участников с любого устройства",
          "description3": "Простой выбор одной или нескольких стран для вызова бесплатного номера"
        },
        "rc": {
          "title": "Коннектор конференц-залов"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Аргентина",
        "Australia": "Австралия",
        "Austria": "Австрия",
        "Belgium": "Бельгия",
        "Brazil": "Бразилия",
        "Bulgaria": "Болгария",
        "Canada": "Канада",
        "Chile": "Чили",
        "China": "Китай",
        "Colombia": "Колумбия",
        "Costa_Rica": "Коста-Рика",
        "Croatia": "Хорватия",
        "Cyprus": "Кипр",
        "Czech_Republic": "Чехия",
        "Denmark": "Дания",
        "Ecuador": "Эквадор",
        "Estonia": "Эстония",
        "Finland": "Финляндия",
        "France": "Франция",
        "Germany": "Германия",
        "Greece": "Греция",
        "Hong_Kong_SAR": "Специальный административный район Гонконг",
        "Hungary": "Венгрия",
        "Ireland": "Ирландия",
        "Israel": "Израиль",
        "Italy": "Италия",
        "Japan": "Япония",
        "Latvia": "Латвия",
        "Lithuania": "Литва",
        "Luxembourg": "Люксембург",
        "Mexico": "Мексика",
        "Netherlands": "Нидерланды",
        "New_Zealand": "Новая Зеландия",
        "Norway": "Норвегия",
        "Panama": "Панама",
        "Peru": "Перу",
        "Poland": "Польша",
        "Portugal": "Португалия",
        "Puerto_Rico": "Пуэрто-Рико",
        "Romania": "Румыния",
        "Singapore": "Сингапур",
        "Slovakia": "Словакия",
        "Slovenia": "Словения",
        "South_Africa": "ЮАР",
        "Spain": "Испания",
        "Sweden": "Швеция",
        "Switzerland": "Швейцария",
        "UK": "Великобритания",
        "United_Kingdom": "Великобритания",
        "US": "США",
        "United_States": "Соединенные Штаты Америки",
        "title": "Требования к номеру телефона",
        "subtitle": "Укажите страну, в которой будет активирован номер телефона плана с международными вызовами на выбор.",
        "selector_tip": "Выберите страну",
        "local_and_toll_free": "Местные и бесплатные номера доступны в следующей стране: {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "План с международными вызовами на выбор включает один номер телефона и безлимитные внутренние вызовы в рамках выбранной страны на лицензию.",
        "avail_title": "Доступные страны и регионы"
      },
      "tax_exempt_ecm": {
        "title": "Состояние освобождения от уплаты налогов",
        "status_exempt": "Не подлежит налогообложению",
        "status_exempt_question": "Освобождены от уплаты налогов?",
        "verify_now": "Проверить сейчас",
        "can_after_checkout": "В качестве варианта этот шаг можно выполнить после оформления заказа.",
        "status": {
          "exempt": "Освобождение от уплаты налога",
          "pending": "Ожидание",
          "pendingTooltip": "В настоящее время состояние освобождения от уплаты налогов находится на рассмотрении. При размещении заказа с вас может взиматься налог. Если ваше освобождение от уплаты налогов будет одобрено, мы зачислим все налоги и сборы, подлежащие возмещению, на ваш счет.",
          "nonexempt": "Не освобождаемый от уплаты налогов",
          "rejected": "Отклонено",
          "rejectedTooltip": "Было установлено, что представленный документ не соответствует требованиям вашей юрисдикции.",
          "approved": "Утверждено",
          "default": "по умолчанию"
        },
        "confirm_close": {
          "new_desc": "Если вы откажетесь от проверки, с вас могут взиматься применимые налоги и сборы. После приобретения вы по-прежнему можете отправить компании Zoom для рассмотрения и одобрения документ, освобождающий вас от уплаты налогов, в разделе «Управление оплатой услуг». После прохождения проверки вам будут возмещены все уплаченные налоги.",
          "desc": "Пропустить проверку статуса на освобождение от уплаты налога и продолжить оплату с налогом?",
          "title": "Вы уверены?",
          "new_title": "Отказаться от проверки освобождения от уплаты налогов?",
          "yes": "Да, пропустить",
          "no": "Нет, продолжить",
          "abandon": "Отказаться от проверки",
          "go_back": "Назад"
        },
        "confirm_to_add": {
          "title": "Подтвердите новое освобождение от уплаты налогов по умолчанию",
          "message": "При добавлении нового освобождения оно будет автоматически настроено как освобождение по умолчанию после одобрения или отклонения. У вас может быть только одно освобождение по умолчанию, которое будет применяться к будущим покупкам. Сумма налога может меняться, если освобождение по умолчанию не соответствует штату или региону, указанному в поле Sold To (Местонахождение покупателя).",
          "yes": "Добавить новое освобождение"
        },
        "confirm_set_default": {
          "title": "Несоответствие адреса и освобождения от уплаты налогов",
          "message": "Адрес, указанный в поле «Контактные данные покупателя», не соответствует штату или региону, который вы выбрали для освобождения от уплаты налогов. Измените адрес в поле «Контактные данные покупателя» в соответствии с местонахождением, для которого выдано освобождение от уплаты налогов. В противном случае при покупке может не применяться освобождение от уплаты налогов.",
          "yes": "Все равно настроить по умолчанию",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Штат или регион",
          "exemption_type": "Тип освобождения",
          "signed_date": "Дата подписания",
          "status": "состояние",
          "add_exemption": "Добавить освобождение",
          "view": "Показать",
          "set_as_default": "Настроить по умолчанию"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Ваш план {planName} будет отменен {date} в 00:00 по всемирному координированному времени. Если вы хотите организовывать мероприятия после даты отмены, активируйте свой план повторно.",
        "pairPreDescTip": "Ваши планы {planName1} и {planName2} будут отменены {date} в 00:00 по всемирному координированному времени. Если вы хотите организовывать мероприятия после даты отмены, активируйте свои планы повторно.",
        "pairDiffDatePreDescTip": "Ваши планы {planName1} и {planName2} будут отменены {date1} в 00:00 по всемирному координированному времени и {date2} в 00:00 по всемирному координированному времени соответственно. Если вы хотите организовывать мероприятия после даты отмены, активируйте свои планы повторно.",
        "title": "Повторно активируйте свой план, чтобы продолжить им пользоваться",
        "titles": "Повторно активируйте свои планы, чтобы продолжить ими пользоваться",
        "plan": "План",
        "licenses": "Лицензий",
        "billingCycle": "Цикл выставления счетов",
        "effective_date": "Дата вступления в силу",
        "invoice_amount": "Сумма счета-фактуры",
        "singleDescTip": "Выполняя повторную активацию, вы соглашаетесь с тем, что повторяющийся план будет автоматически продлен {date} и за каждый период продления с вас будет списываться сумма указанным способом оплаты. Чтобы избежать будущих списаний, <a target=\"_blank\" href=\"https://support.zoom.com/hc/ru/article?id=zm_kb&sysparm_article=KB0066687\">отмените</a> подписку за день до даты продления.",
        "pairDescTip": "Выполняя повторную активацию, вы соглашаетесь с тем, что повторяющиеся планы будут автоматически продлены {date}. За каждый период продления с вас будет списываться сумма указанным способом оплаты. Чтобы избежать будущих списаний, <a target=\"_blank\" href=\"https://support.zoom.com/hc/ru/article?id=zm_kb&sysparm_article=KB0066687\">отмените</a> подписку за день до даты продления.",
        "pairDiffDateDescTip": "Выполняя повторную активацию, вы соглашаетесь с тем, что повторяющиеся планы будут автоматически продлены {date1} и {date2} соответственно. За каждый период продления с вас будет списываться сумма указанным способом оплаты. Чтобы избежать будущих списаний, <a target=\"_blank\" href=\"https://support.zoom.com/hc/ru/article?id=zm_kb&sysparm_article=KB0066687\">отмените</a> подписку за день до даты продления.",
        "totalLabel": "Итого",
        "totalContent": "{money} плюс применимые налоги",
        "taxDesc": "без учета НДС, GST или аналогичных налогов",
        "reactivateBtn": "Продолжить и активировать повторно",
        "switchTitle": "Обновите свой план, чтобы продолжить им пользоваться",
        "successSingleTip": "Ваш план {planName} активирован повторно",
        "successPairTip": "Ваши планы {planName1} и {planName2} активированы повторно",
        "switchTip": "Срок действия вашего одномесячного плана Zoom Webinars истекает {date}. Чтобы проводить вебинары после этой даты, вам необходимо перейти на подписку.",
        "switchBtn": "Перейти на подписку"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace для бизнеса"
      },
      "proPlus": {
        "title": "Zoom Workplace Профессиональный Плюс"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043B\u0438\u0441\u0442 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
      },
      "one": {
        "new": "Новое"
      }
    },
    "webinarSetupInWebPortal": "Настройка вебинаров на веб-портале",
    "concurrentEvents": "Параллельные мероприятия",
    "coucurrentEventsToolTip": "<span>План <b>подписки</b> позволяет одновременно проводить только одно мероприятие в реальном времени",
    "overages": "Плата за превышение лимита",
    "eventsPlatformHubs": "Центры платформы Zoom Events",
    "eventsHubToolTip": "<b>Центры</b> Zoom Events обеспечивают удобство организации мероприятий",
    "1HubPerLicense": "1 центр на лицензию",
    "1000Hubs": "1000 центров",
    "eventsPlatformHosts_500AttendeesOrMore": "Организаторы платформы Events (500 присутствующих и более)",
    "eventsHost500": "<span><b>Организаторы платформы</b> Zoom Events могут создавать",
    "5HubHosts": "5 организаторов центра",
    "100HubHosts": "100 организаторов центра",
    "eventsPlatformHosts_100Attendees": "Организаторы платформы Events (100 присутствующих)",
    "eventsHost100": "<span><b>Организаторы платформы</b> Zoom Events могут создавать",
    "2HubHosts": "2 организатора центра",
    "howAreTheyDifferent": "В чем отличия?",
    "allPlansRequireAZoomOneLicense": "* Для всех планов необходима лицензия Zoom Workplace",
    "subscription": "Подписка",
    "subscriptionToolTip": "<span><b>Подписка</b> позволяет организовывать неограниченное количество мероприятий и самостоятельно выбирать количество присутствующих.</span>",
    "payPerAttendee": "Оплата из расчета на присутствующего",
    "ppaToolTips": "<span>Лицензия, <b>оплачиваемая из расчета на присутствующего</b>, определяет общее количество присутствующих, которые могут посетить все мероприятия, проводимые в вашей учетной записи в течение 12 месяцев с момента приобретения.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "\u041E\u043F\u0440\u043E\u0441\u044B",
    "meetings.fullPlanItem2": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0439",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "\u041A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 Zoom",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Упрощенная видеоконференцсвязь и обмен сообщениями на любых устройствах",
    "meetings.fullPlanItem5": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
    "meetings.fullPlanItem5Tip": "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u0430\u044F \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u043E\u0432\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 (\u043E\u0442 3 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432)",
    "meetings.fullPlanItem5_basic": "40 \u043C\u0438\u043D\u0443\u0442",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 \u0447\u0430\u0441\u0430",
    "meetings.fullPlanItem5_biz": "30 \u0447\u0430\u0441\u0430",
    "meetings.fullPlanItem5_ent": "30 \u0447\u0430\u0441\u0430",
    "meetings.fullPlanItem1": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432",
    "meetings.fullPlanItem1Tip": "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A \u2014 \u044D\u0442\u043E \u043B\u0438\u0446\u043E, \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043D\u043E\u0435 \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u043E\u0439 \u043B\u0438\u0446\u043E\u043C \u0441 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0435\u0439 \u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439. \u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E \u0432\u0445\u043E\u0434\u0438\u0442\u044C \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u0441 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430, \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u0438 \u043F\u043B\u0430\u043D\u0448\u0435\u0442\u0430. \u0414\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0443 \u043D\u0435 \u043D\u0443\u0436\u043D\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C Zoom. \u0423 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0442\u0430\u0440\u0438\u0444\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0430 \u0435\u0441\u0442\u044C \u043F\u0440\u0435\u0434\u0435\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432, \u043E\u0434\u043D\u0430\u043A\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043C\u043E\u0433\u0443\u0442 \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u044D\u0442\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0430 \u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u0442\u0430\u0440\u0438\u0444\u043D\u044B\u0445 \u043F\u043B\u0430\u043D\u0430\u0445 \u0437\u0430 \u0441\u0447\u0435\u0442 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0439.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">* 1000 для Enterprise Plus.</span>",
    "meetings.fullPlanItem7": "\u0417\u0430\u043F\u0438\u0441\u044C",
    "meetings.fullPlanItem7Tip": "\u0424\u0443\u043D\u043A\u0446\u0438\u044F \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 Zoom \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0438 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0430\u0445 MP4 (\u0432\u0438\u0434\u0435\u043E), M4A (\u0437\u0432\u0443\u043A) \u0438 txt (\u0447\u0430\u0442).<br>\u0424\u0443\u043D\u043A\u0446\u0438\u044F \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u043E\u0431\u043B\u0430\u043A\u043E Zoom \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0432 \u043E\u0431\u043B\u0430\u043A\u0435 Zoom, \u043E\u0442\u043A\u0443\u0434\u0430 \u0444\u0430\u0439\u043B \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438/\u0438\u043B\u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435.",
    "meetings.fullPlanItem7_basic": "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0430\u044F",
    "meetings.fullPlanItem7_pro": "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0438 \u043E\u0431\u043B\u0430\u0447\u043D\u0430\u044F 5 \u0413\u0411 (\u043D\u0430 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044E)",
    "meetings.fullPlanItem7_biz": "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0438 \u043E\u0431\u043B\u0430\u0447\u043D\u0430\u044F 10 \u0413\u0411 (\u043D\u0430 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044E)",
    "meetings.fullPlanItem7_ent": "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0438 \u043E\u0431\u043B\u0430\u0447\u043D\u0430\u044F (\u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E)",
    "one.messaging": "Обмен сообщениями",
    "meetings.fullPlanItem16Tip": "\u0421 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0441\u0435\u0440\u0432\u0438\u0441\u0430 Chat \u043C\u043E\u0436\u043D\u043E \u0431\u044B\u0441\u0442\u0440\u043E \u0438 \u0443\u0434\u043E\u0431\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0433\u0440\u0443\u043F\u043F\u044B, \u0444\u0430\u0439\u043B\u044B, \u0441\u043D\u0438\u043C\u043A\u0438 \u044D\u043A\u0440\u0430\u043D\u043E\u0432, \u043F\u0440\u0438\u043C\u0435\u0440\u044B \u043A\u043E\u0434\u0430, \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u044B\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0431\u043C\u0435\u043D GIF-\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u044D\u043C\u043E\u0434\u0437\u0438. \u0412 \u043D\u0435\u043C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0447\u0430\u0442\u0430 \u043D\u0430 \u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u044B\u0445 \u0438\u043B\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445 \u043B\u0438\u0431\u043E \u0437\u0430\u043D\u044F\u0442\u043E\u0441\u0442\u044C \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438.",
    "meetings.fullPlanItem51": "\u0414\u043E\u0441\u043A\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 Zoom",
    "meetings.unlimited": "\u0411\u0435\u0437\u043B\u0438\u043C\u0438\u0442\u043D\u044B\u0439",
    "meetings.fullPlanItem_EssentialApp": "Основные приложения",
    "common.learnMore": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    "meetings.fullPlanItem_EssentialAppText": "Бесплатные приложения премиум-класса сроком на 1 год (применяются условия использования)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail и Zoom Calendar в приложении Zoom",
    "mailService": "Почтовая служба",
    "emailServiceWithFullTimeEndToEnd": "Служба электронной почты с постоянным сквозным шифрованием для более высокого уровня конфиденциальности",
    "customMailDomain": "Пользовательский домен почты",
    "customMailDomainWithMailService": "Пользовательский домен почты с почтовой службой",
    "calendarClient": "Клиент календаря",
    "scheduleAndJoinMeetings": "Планирование и присоединение к конференциям в приложении Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Служба календаря",
    "meetingSchedulingAndAppointment": "Планирование конференций и бронирование встреч",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "С легкостью создавайте, редактируйте и совместно используйте короткие видеоролики. Сохраненные ролики легко найти, что способствует активизации взаимодействия.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Заметки — это надежный редактор личных и совместных документов с широкими возможностями форматирования, к которому можно осуществлять доступ во время и вне конференций.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Переведенные субтитры",
    "workspaceReservation": "Резервирование рабочего места.",
    "accessAcrossAnyDevice": "Доступ с любого устройства",
    "meetings.fullPlanItem4": "\u041D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439",
    "meetings.fullPlanItem9": "\u0412\u0445\u043E\u0434 \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "meetings.fullPlanItem9Tip": "\u0412\u0445\u043E\u0434\u0438\u0442\u0435 \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 Zoom \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0442\u0435\u043B\u0435\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0441\u0432\u044F\u0437\u0438/\u0430\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0441\u0432\u044F\u0437\u0438 (\u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430). \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0431\u0443\u0434\u0443\u0442 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u0441\u0435\u0440\u0432\u0438\u0441 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0442\u0430\u0440\u0438\u0444\u043D\u043E\u043C\u0443 \u043F\u043B\u0430\u043D\u0443 \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u0443\u044E \u0441\u0432\u044F\u0437\u044C. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u00AB\u0410\u0443\u0434\u0438\u043E\u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0441\u0432\u044F\u0437\u044C\u00BB \u0434\u043B\u044F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043D\u043E\u043C\u0435\u0440\u043E\u0432 \u0434\u043B\u044F \u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0439.",
    "meetings.fullPlanItem9_pro": "\u0422\u0430\u0440\u0438\u0444\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440",
    "meetings.fullPlanItem9_biz": "\u0422\u0430\u0440\u0438\u0444\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440",
    "meetings.fullPlanItem9_ent": "\u0422\u0430\u0440\u0438\u0444\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440",
    "meetings.fullPlanItem11": "\u0414\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u044D\u043A\u0440\u0430\u043D\u0430",
    "meetings.fullPlanItem11Tip": "\u0414\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0441\u0442\u043E\u043B\u0430 \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F. \u041B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439 \u043C\u043E\u0433\u0443\u0442 \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u0441\u0432\u043E\u0438\u0445 \u044D\u043A\u0440\u0430\u043D\u043E\u0432 \u0432 \u0445\u043E\u0434\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0438\u043C\u0438 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438.",
    "meetings.fullPlanItem12": "\u0421\u0435\u0441\u0441\u0438\u043E\u043D\u043D\u044B\u0435 \u0437\u0430\u043B\u044B",
    "meetings.fullPlanItem12Tip": "\u0421\u0435\u0441\u0441\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u0438\u0434\u0435\u043E\u0437\u0430\u043B\u044B \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E Zoom \u043D\u0430 50 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0434\u043B\u044F \u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u044F, \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u043C\u043D\u043E\u0433\u043E\u0433\u043E \u0434\u0440\u0443\u0433\u043E\u0433\u043E.",
    "meetings.fullPlanItem14": "\u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u043D",
    "meetings.fullPlanItem15": "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
    "meetings.fullPlanItem15Tip": "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0431\u0435\u0441\u0441\u0440\u043E\u0447\u043D\u044B\u0439 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446-\u0437\u0430\u043B. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0447\u0430\u0442\u044C \u044D\u0442\u0443 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0438\u043B\u0438 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0435\u0435 \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C.",
    "meetings.fullPlanItem17": "\u042D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430",
    "meetings.fullPlanItem18": "\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u044B\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u043D\u0430 \u043E\u0431\u0449\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435",
    "meetings.fullPlanItem19": "\u0423\u0434\u0430\u043B\u0435\u043D\u043D\u043E\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u043E\u0439/\u043C\u044B\u0448\u044C\u044E",
    "meetings.fullPlanItem21": "\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435",
    "meetings.fullPlanItem29": "\u0417\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
    "meetings.fullPlanItem29Tip": "\u0424\u0443\u043D\u043A\u0446\u0438\u044F \u00AB\u0417\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u00BB \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0443 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0442\u0435\u043C, \u043A\u043E\u0433\u0434\u0430 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u0432\u043E\u0439\u0442\u0438 \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043B\u0438\u0431\u043E \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430 \u043F\u043E \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u043B\u0438\u0431\u043E \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u0441\u0435\u0445 \u0432 \u043E\u0434\u0438\u043D \u043C\u043E\u043C\u0435\u043D\u0442. \u0412 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F, \u043A\u043E\u0433\u043E \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432 \u0437\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F, \u0430 \u043A\u0442\u043E \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438. \u0424\u0443\u043D\u043A\u0446\u0438\u044F \u00AB\u0417\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u00BB \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438. \u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u044B \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u0432 \u0437\u0430\u043B\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u0442\u0430\u0440\u0438\u0444\u043D\u044B\u0445 \u043F\u043B\u0430\u043D\u043E\u0432 \u043C\u043E\u0433\u0443\u0442 \u043D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C \u0437\u0430\u043B \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E.",
    "meetings.fullPlanItem41": "\u0412\u0441\u0442\u0440\u043E\u0435\u043D\u043E \u0432 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 Zoom for Home",
    "meetings.fullPlanItem61": "\u0417\u0430\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u0438\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439",
    "meetings.fullPlanItem61Tip": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C 9 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u043A\u0440\u0435\u043F\u043B\u044F\u0442\u044C \u0432\u0438\u0434\u0435\u043E \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F. \u0417\u0430\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u0438\u0434\u0435\u043E \u0431\u0443\u0434\u0443\u0442 \u0432\u0441\u0435\u0433\u0434\u0430 \u043E\u0441\u0442\u0430\u0432\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u0432\u0438\u0434\u0443, \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E \u043E\u0442 \u0433\u043E\u0432\u043E\u0440\u044F\u0449\u0435\u0433\u043E.",
    "meetings.fullPlanItem62": "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0447\u0435\u043B\u043E\u0432\u0435\u043A",
    "meetings.fullPlanItem62Tip": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043C\u043E\u0436\u0435\u0442 \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C \u0434\u043E 9 \u0432\u0438\u0434\u0435\u043E \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u0432\u0438\u0434\u0435\u043E \u0431\u0443\u0434\u0443\u0442 \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0441\u0435 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438, \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E \u043E\u0442 \u0433\u043E\u0432\u043E\u0440\u044F\u0449\u0435\u0433\u043E.",
    "meetings.fullPlanNewItem1": "\u0424\u0438\u043B\u044C\u0442\u0440\u044B",
    "meetings.fullPlanNewItem1Tip": "\u0420\u0430\u0437\u0431\u0430\u0432\u044C\u0442\u0435 \u043D\u0435\u0444\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u0441\u0442\u0440\u0435\u0447\u0438, \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F \u0438\u0433\u0440\u0438\u0432\u044B\u043C\u0438 \u0446\u0432\u0435\u0442\u043D\u044B\u043C\u0438 \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u043C\u0438 \u0438\u043B\u0438 \u0441\u0442\u0438\u043A\u0435\u0440\u0430\u043C\u0438 \u0432 \u0432\u0438\u0434\u0435 \u0436\u0438\u0432\u043E\u0442\u043D\u044B\u0445, \u0447\u0442\u043E\u0431\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0438\u0445 \u0435\u0449\u0435 \u0443\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u0435\u0435.",
    "meetings.fullPlanNewItem2": "\u041E\u043F\u0440\u043E\u0441\u044B",
    "meetings.fullPlanNewItem3": "\u0421\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0438 \u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/ru/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E\u0431 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0445 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0441\u043E\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438.</a>",
    "meetings.fullPlanItem24": "\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438",
    "meetings.fullPlanItem24Tip": "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043D\u0430\u0437\u043D\u0430\u0447\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439 \u043E\u0442 \u0432\u0430\u0448\u0435\u0433\u043E \u0438\u043C\u0435\u043D\u0438. \u0423 \u043D\u0430\u0437\u043D\u0430\u0447\u0430\u0435\u043C\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0442\u0430\u043A\u0436\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u0430\u0440\u0438\u0444\u043D\u044B\u0439 \u043F\u043B\u0430\u043D.",
    "meetings.fullPlanItem25": "API REST",
    "meetings.fullPlanItem25Tip": "\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439, \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430\u043C \u0438 \u0432\u0430\u0448\u0438\u043C \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A REST API Zoom. \u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u043A\u0430\u043D\u0430\u043B\u0430 API \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043F\u043E \u0442\u0438\u043F\u0443 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 (\u00AB\u041F\u0440\u043E\u00BB, \u00AB\u0411\u0438\u0437\u043D\u0435\u0441\u00BB, \u00AB\u041F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435\u00BB \u0438 \u0442. \u0434.) \u0438 \u0442\u0438\u043F\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043A API (\u043B\u0435\u0433\u043A\u0438\u0439, \u0441\u0440\u0435\u0434\u043D\u0438\u0439, \u0442\u044F\u0436\u0435\u043B\u044B\u0439 \u0438 \u0442. \u0434.). \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u043C API \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0434\u043B\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0432 \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439. \u0411\u043E\u043B\u0435\u0435 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u0432 \u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0445 \u043A\u0430\u043D\u0430\u043B\u0430 API \u0438 \u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u043E\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438 \u043A API.",
    "meetings.fullPlanItem25_pro": "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u0438 API REST Pro",
    "meetings.fullPlanItem25_biz": "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u0438 API REST",
    "meetings.fullPlanItem26": "\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u043E Skype \u0434\u043B\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430 (Lync)",
    "meetings.fullPlanItem26Tip": "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C Lync 2010, 2013 \u0438 Skype \u0434\u043B\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430 \u0437\u0430\u043F\u0443\u0441\u043A\u0430\u0442\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E Zoom \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 Lync.",
    "meetings.fullPlanItem27": "\u041F\u043E\u0442\u043E\u043A\u043E\u0432\u043E\u0435 \u0432\u0435\u0449\u0430\u043D\u0438\u0435",
    "meetings.fullPlanItem27Tip": "\u0422\u0440\u0430\u043D\u0441\u043B\u0438\u0440\u0443\u0439\u0442\u0435 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043D\u0430 Facebook, Youtube \u0438\u043B\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u0445 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0445 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u043E\u0432.",
    "meetings.fullPlanItem28": "\u041E\u0442\u0447\u0435\u0442\u043D\u043E\u0441\u0442\u044C",
    "meetings.fullPlanItem28Tip": "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0435 \u0441\u0435\u0430\u043D\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u0434\u043E\u0441\u043A\u043E\u0439 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439",
    "meetings.fullPlanItem30": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438",
    "meetings.fullPlanItem30Tip": "\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0438 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u044B \u043C\u043E\u0433\u0443\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C, \u0443\u0434\u0430\u043B\u044F\u0442\u044C \u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0430\u0442\u044C \u0440\u043E\u043B\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u0438.",
    "one.autoCaptions": "Автоматические субтитры",
    "meetings.fullPlanItem31": "\u041F\u043E\u0440\u0442\u0430\u043B \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
    "meetings.fullPlanItem31Tip": "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u0432\u0441\u0435\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043E\u0434\u043D\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0434\u043B\u044F \u0443\u043F\u0440\u043E\u0449\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0443\u0441\u043B\u0443\u0433, \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0431 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u044F \u043F\u043E\u0440\u0442\u0430\u043B\u0443 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 Zoom.",
    "meetings.fullPlanItem32": "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044F LTI",
    "meetings.fullPlanItem32Tip": "\u0414\u043E\u0431\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u0434\u043B\u044F \u043B\u044E\u0431\u043E\u0433\u043E \u0437\u0430\u043D\u044F\u0442\u0438\u044F \u0438\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u044F \u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0430\u0439\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0441\u0442\u0443\u0434\u0435\u043D\u0442\u043E\u0432 \u0438\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u043E\u0439 (\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E \u0441 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u043C\u0438 Moodle, Canvas, Desire2Learn \u0438 Blackboard).",
    "meetings.fullPlanItem33": "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438 \u043E\u0431\u043B\u0430\u0447\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439",
    "meetings.fullPlanItem33Tip": "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438 \u043E\u0431\u043B\u0430\u0447\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u2014 \u044D\u0442\u043E \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0437\u0432\u0443\u043A\u043E\u0432\u044B\u0445 \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043E\u043A, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0442\u0440\u0430\u043D\u0441\u043A\u0440\u0438\u0431\u0438\u0440\u0443\u0435\u0442 \u0437\u0432\u0443\u043A \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439 \u0438\u043B\u0438 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u043E\u0432, \u0437\u0430\u043F\u0438\u0441\u044B\u0432\u0430\u0435\u043C\u044B\u0445 \u0432 \u043E\u0431\u043B\u0430\u043A\u043E. \u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0447\u0442\u043E \u0441\u0435\u0439\u0447\u0430\u0441 \u0434\u0430\u043D\u043D\u0430\u044F \u043E\u043F\u0446\u0438\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C</a>, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435.",
    "meetings.fullPlanItem34": "\u0424\u0438\u0440\u043C\u0435\u043D\u043D\u0430\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u0438\u043A\u0430",
    "meetings.fullPlanItem34Tip": "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u0438\u0440\u043C\u0435\u043D\u043D\u0443\u044E \u0441\u0438\u043C\u0432\u043E\u043B\u0438\u043A\u0443 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u043D\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u0441 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0431\u0443\u0434\u0443\u0442 \u0432\u0445\u043E\u0434\u0438\u0442\u044C \u0432 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044E. \u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0444\u0438\u0440\u043C\u0435\u043D\u043D\u044B\u0439 \u0448\u0430\u0431\u043B\u043E\u043D \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u043F\u0438\u0441\u044C\u043C\u0430 \u0434\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439 \u0443\u0447\u0430\u0449\u0438\u043C\u0441\u044F.",
    "meetings.fullPlanItem35": "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u0434\u043E\u043C\u0435\u043D\u044B",
    "meetings.fullPlanItem35Tip": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u043E\u043C\u0435\u043D \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438/\u0443\u043D\u0438\u0432\u0435\u0441\u0442\u0438\u0442\u0435\u0442\u0430, \u0447\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0432 \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438.",
    "meetings.fullPlanItem37": "\u0423\u0441\u0442\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434",
    "meetings.fullPlanItem37Tip": "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0443 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0447\u0438\u043A\u043E\u0432 \u0434\u043B\u044F \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0439 \u0438\u043B\u0438 \u0432\u0435\u0431\u0438\u043D\u0430\u0440\u043E\u0432. \u041A\u043E\u0433\u0434\u0430 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F \u0438\u043B\u0438 \u0432\u0435\u0431\u0438\u043D\u0430\u0440 \u043D\u0430\u0447\u043D\u0435\u0442\u0441\u044F, \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u044E \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0434\u0430\u0441\u0442 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0447\u0438\u043A\u0430\u043C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C \u0430\u0443\u0434\u0438\u043E\u043A\u0430\u043D\u0430\u043B\u0430\u043C. \u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0430\u0443\u0434\u0438\u043E\u043A\u0430\u043D\u0430\u043B \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043B\u0443\u0448\u0438\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u043B\u044F \u043D\u0438\u0445 \u044F\u0437\u044B\u043A\u0435. \u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0431\u0443\u0434\u0443\u0442 \u0441\u043B\u044B\u0448\u0430\u0442\u044C \u0437\u0432\u0443\u043A\u043E\u0432\u043E\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434 \u0438 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0443\u0431\u0430\u0432\u0438\u0442\u044C \u0433\u0440\u043E\u043C\u043A\u043E\u0441\u0442\u044C \u0438\u0441\u0445\u043E\u0434\u043D\u043E\u0433\u043E \u0437\u0432\u0443\u043A\u0430.",
    "meetings.fullPlanItem39": "\u041E\u0431\u0437\u043E\u0440\u044B \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432",
    "meetings.fullPlanItem39Tip": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u044B\u0439 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0430\u043D\u0430\u043B\u0438\u0437 \u0432\u043D\u0435\u0434\u0440\u0435\u043D\u0438\u044F, \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u043D\u0430 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0438 (ROI), \u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043B\u0430\u043D\u0430 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u0438.",
    "meetings.fullPlanNewItem4": "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442 Webinar 500",
    "one.translatedCations": "Переведенные субтитры",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Канал либо личный или групповой чат",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Легко общайтесь с помощью личных сообщений, в небольших группах или с большими командами",
    "messageAndFileHistory": "История сообщений и файлов",
    "findPeopeChannelsAndFilesInSearch": "Находите пользователей, каналы и файлы с помощью функции поиска",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Быстро находите контакты, мгновенные сообщения, групповые чаты и файлы, получая доступ к нужным знаниям и информации за секунды.",
    "applicationIntegrations": "Интеграции приложений",
    "secureFileSharing": "Безопасное совместное использование файлов",
    "enhanceCollaborationWithSeamlessFileSharing": "Совершенствуйте коллективную работу с помощью беспрепятственного совместного использования файлов",
    "persistentMeetingChat": "Непрерывный чат на конференции",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Вы больше не потеряете нить разговора на конференциях! Общайтесь до, во время и после конференции в отдельном групповом чате в Zoom Team Chat со всеми участниками конференции.",
    "cloudStorage": "Облачное хранилище",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Размещайте каналы в облаке Zoom или в хранилище стороннего поставщика",
    "avatars": "Аватары",
    "inMeetingReactions": "Реакции на конференции",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Демонстрируйте вовлеченность и быстро взаимодействуйте с другими участниками невербальными способами",
    "virtualBackgrounds": "Виртуальные фоны",
    "videoFilters": "Фильтры для видео",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Привнесите разнообразие в конференции, применяя к своему видео различные фильтры",
    "inMeetingPollsAndQuizzes": "Опросы и тесты на конференции",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Создавайте вопросы для опроса на конференциях с возможностью выбора одного или нескольких вариантов ответа.",
    "liveStreamingAcrossPlatforms": "Потоковое вещание в реальном времени на разных платформах",
    "appearanceTouchUp": "Коррекция внешнего вида",
    "originalSoundForMusicians": "Оригинальное звучание музыки",
    "endToEndEncryptionForZoomMeetings": "Сквозное шифрование для Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "При включении сквозное шифрование (E2EE) от компании Zoom для Zoom Meetings обеспечивает всем участникам конференции, использующим Zoom desktop client или Zoom mobile app, защиту коммуникаций с помощью криптографических ключей, которые известны только устройствам участников конференции. Это значит, что третьи стороны, включая Zoom, не имеют доступа к ключам шифрования конференции.",
    "zoomCustomerManagedKey": "Управляемый клиентом ключ Zoom",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Самостоятельно выбирайте ключи шифрования для защиты сохраненных данных Zoom",
    "enterpriseGradeSecurityFeatures": "Функции безопасности корпоративного уровня",
    "256BitAesGcmEncryptionForRealTimeContent": "256-разрядное шифрование AES-GCM для содержимого и мультимедиа, передаваемых в реальном времени, шифрование TLS во время регистрации SIP, маскирование идентификатора вызывающего абонента, равноправное сетевое взаимодействие в частных сетях, выявление случаев мошенничества, связанного со взломом системы телефонной связи, и списки блокировки вызовов.",
    "phone.fullPlanItem40": "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0435\u0434\u0438\u043D\u043E\u0433\u043E \u0432\u0445\u043E\u0434\u0430 \u043D\u0430 \u0431\u0430\u0437\u0435 SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "\u0411\u0435\u0437\u043B\u0438\u043C\u0438\u0442\u043D\u044B\u0435 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u0432\u044B\u0437\u043E\u0432\u044B",
    "phone.fullPlanItem2": "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0432\u044B\u0437\u043E\u0432\u044B \u0441 \u043F\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u043E\u0439",
    "phone.fullPlanItem3": "\u0411\u0435\u0437\u043B\u0438\u043C\u0438\u0442\u043D\u044B\u0435 \u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0432\u044B\u0437\u043E\u0432\u044B",
    "phone.fullPlanItem4": "\u041F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0435 HD-\u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u044B\u0437\u043E\u0432\u043E\u0432",
    "phone.fullPlanItem4Tip": "\u0421 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C \u0448\u0443\u043C\u043E\u043F\u043E\u0434\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C, \u044D\u0445\u043E\u043F\u043E\u0434\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0438 \u043F\u043E\u0434\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0437\u0432\u0443\u043A\u0430 \u043A\u043B\u0430\u0432\u0438\u0448",
    "phone.fullPlanItem5": "\u041D\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0434\u043B\u044F Windows, MacOS \u0438 Linux",
    "phone.fullPlanItem6": "\u041D\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0434\u043B\u044F iOS \u0438 Android",
    "phone.fullPlanItem7": "\u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043D\u043E\u043C\u0435\u0440\u0430 \u0438\u043B\u0438 \u043A\u0443\u043F\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0435 (DID)",
    "phone.fullPlanItem8": "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430",
    "phone.fullPlanItem9": "\u0414\u043E\u0431\u0430\u0432\u043E\u0447\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "phone.fullPlanItem10": "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u0441 \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u043E\u0439",
    "phone.fullPlanItem10Tip": "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0435 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0445/\u043D\u0430\u0441\u0442\u043E\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    "phone.fullPlanItem11": "\u041D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0430\u0432\u0442\u043E\u0441\u0435\u043A\u0440\u0435\u0442\u0430\u0440\u0435\u0439",
    "phone.fullPlanItem12": "\u041D\u0430\u0431\u043E\u0440 \u043F\u043E \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0443 \u0438\u043C\u0435\u043D",
    "phone.fullPlanItem13": "\u0413\u0440\u0443\u043F\u043F\u044B \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0432\u044B\u0437\u043E\u0432\u043E\u0432 (ACD) \u0441 \u043E\u0447\u0435\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u044C\u044E \u0432\u044B\u0437\u043E\u0432\u043E\u0432",
    "phone.fullPlanItem14": "\u0424\u0443\u043D\u043A\u0446\u0438\u0438 \u00AB\u0412\u043C\u0435\u0448\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u00BB/\u00AB\u041C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433\u00BB/\u00AB\u0428\u0435\u043F\u043E\u0442\u00BB/\u00AB\u0417\u0430\u0445\u0432\u0430\u0442\u00BB",
    "phone.fullPlanItem15": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0438\u044F \u0432 \u0432\u044B\u0445\u043E\u0434\u043D\u043E\u0435 \u0438 \u0440\u0430\u0431\u043E\u0447\u0435\u0435 \u0432\u0440\u0435\u043C\u044F",
    "phone.fullPlanItem16": "3-\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u044F\u044F \u0441\u0438\u0442\u0443\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0441\u0432\u044F\u0437\u044C",
    "phone.fullPlanItem17": "\u0417\u0430\u043F\u0438\u0441\u044C \u0432\u044B\u0437\u043E\u0432\u0430",
    "phone.fullPlanItem17Tip": "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0437\u0430\u043F\u0438\u0441\u0438 \u0432\u044B\u0437\u043E\u0432\u043E\u0432 \u0432 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u043C \u0438 \u0440\u0443\u0447\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435.",
    "phone.fullPlanItem18": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0435\u043C\u0430\u044F \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u0430\u043D\u043E\u043D\u0438\u043C\u043D\u044B\u0445 \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0432\u044B\u0437\u043E\u0432\u043E\u0432",
    "phone.fullPlanItem19": "\u042D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0435 \u0432\u044B\u0437\u043E\u0432\u044B",
    "phone.fullPlanItem19Tip": "\u0421\u043E\u0432\u0435\u0440\u0448\u0430\u0439\u0442\u0435 \u0432\u044B\u0437\u043E\u0432\u044B \u043D\u0430 \u043D\u043E\u043C\u0435\u0440\u0430 \u043C\u0435\u0441\u0442\u043D\u044B\u0445 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043B\u0443\u0436\u0431",
    "phone.fullPlanItem20": "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u0430\u0434\u0440\u0435\u0441\u0430\u0446\u0438\u044F E911 (\u0421\u0428\u0410 \u0438 \u041A\u0430\u043D\u0430\u0434\u0430) -",
    "phone.fullPlanItem20Tip": "\u0414\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u043C\u0435\u0441\u0442\u043E\u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0430\u0434\u0440\u0435\u0441\u0430 \u0434\u043B\u044F \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u043C\u0435\u0441\u0442\u043D\u044B\u043C \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u043C \u0441\u043B\u0443\u0436\u0431\u0430\u043C (\u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0421\u0428\u0410 \u0438 \u041A\u0430\u043D\u0430\u0434\u044B) \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u0433\u0440\u0443\u043F\u043F\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438",
    "phone.fullPlanItem21": "\u0426\u0435\u043D\u0442\u0440 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0430\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
    "phone.fullPlanItem21Tip": "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u0433\u0440\u0443\u043F\u043F\u0430 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0431 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0432\u044B\u0437\u043E\u0432\u0430\u0445 \u0438 \u0432\u0435\u0441\u0442\u0438 \u0437\u0430\u043F\u0438\u0441\u044C/\u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433/\u0432\u043C\u0435\u0448\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u0432 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0435 \u0432\u044B\u0437\u043E\u0432\u044B, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043C\u043E\u0447\u044C \u0441 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0446\u0438\u0435\u0439 \u043E\u0442\u0432\u0435\u0442\u043D\u044B\u0445 \u043C\u0435\u0440.",
    "phone.fullPlanItem22": "\u041F\u043E\u044F\u0432\u043B\u0435\u043D\u0438\u0435/\u0434\u0435\u043B\u0435\u0433\u0430\u0446\u0438\u044F \u043E\u0431\u0449\u0438\u0445 \u043B\u0438\u043D\u0438\u0439",
    "phone.fullPlanItem23": "\u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u0432\u044B\u0437\u043E\u0432\u043E\u0432 \u043C\u0435\u0436\u0434\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u043C\u0438",
    "phone.fullPlanItem24": "\u041F\u0430\u0440\u043A\u043E\u0432\u043A\u0430 \u0432\u044B\u0437\u043E\u0432\u043E\u0432",
    "endToEndEncryptionForZoomPhone": "Сквозное шифрование для Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "При включении сквозное шифрование (E2EE) от компании Zoom для Zoom Phone обеспечивает шифрование вызова с помощью криптографических ключей, которые известны только устройствам вызывающего и принимающего абонента. Кроме того, пользователям будет доступен параметр для проверки состояния функции E2EE путем предоставления друг другу уникального кода безопасности.",
    "phone.fullPlanItem43": "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0440\u0430\u0437\u0432\u0435\u0440\u0442\u044B\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432",
    "phone.fullPlanItem44": "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043A\u043E\u043C\u0431\u0438\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0438\u043F\u044B \u0442\u0430\u0440\u0438\u0444\u043D\u044B\u0445 \u043F\u043B\u0430\u043D\u043E\u0432 \u0432 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438",
    "phone.fullPlanItem46": "\u041E\u0442\u0447\u0435\u0442\u043D\u043E\u0441\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0438 \u043F\u0430\u043D\u0435\u043B\u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E\u043C",
    "phone.fullPlanItem47": "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u0441\u0440\u0435\u0434\u044B \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0441\u0442\u043E\u043B\u043E\u0432 (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435</a> \u043E VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Доступно всем клиентам стационарной телефонии. При использовании совместно с планами конференций планы поддержки отличаются.",
    "phone.fullPlanItem49": "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u044B\u0431\u043E\u0440\u0430 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430",
    "phone.fullPlanItem49Tip": "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u043F\u0440\u044F\u043C\u043E\u0433\u043E \u0438 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0438\u0440\u0438\u043D\u0433\u0430 \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0443 \u0443\u0441\u043B\u0443\u0433 \u0422\u0421\u041E\u041F",
    "phone.fullPlanItem50": "\u0413\u0438\u0431\u0440\u0438\u0434\u043D\u0430\u044F \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044F \u0441 \u0423\u0410\u0422\u0421 \u043F\u0440\u0435\u0436\u043D\u0438\u0445 \u0432\u0435\u0440\u0441\u0438\u0439",
    "phone.fullPlanItem51": "Функция «Нажать для разговора»",
    "phone.fullPlanItem61": "Онлайн-факс",
    "phone.fullPlanItem61Tip": "Отправляйте и получайте неограниченное количество факсов в пределах США и Канады. <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">Смотрите тарифы</a> для международных факсов",
    "phone.fullPlanSms": "SMS \u0438 MMS",
    "phone.fullPlanSmsTip": "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u043E\u0432 \u0432 \u0421\u0428\u0410 \u0438 \u041A\u0430\u043D\u0430\u0434\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0442\u0430\u0440\u0438\u0444\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0430. \u0414\u043B\u044F \u043F\u0440\u044F\u043C\u044B\u0445 (\u043D\u0435 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0445) \u043D\u043E\u043C\u0435\u0440\u043E\u0432.",
    "meetings.fullPlanItem6": "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "\u0422\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u0437\u0430\u044F\u0432\u043A\u0430\u043C",
    "meetings.fullPlanItem6_pro": "\u0417\u0430\u044F\u0432\u043A\u0438 \u0438 \u0447\u0430\u0442 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438",
    "meetings.fullPlanItem6_biz": "\u0417\u0430\u044F\u0432\u043A\u0438, \u0447\u0430\u0442 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
    "meetings.fullPlanItem6_ent": "\u0417\u0430\u044F\u0432\u043A\u0438, \u0447\u0430\u0442 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
    "knowledgeBase": "База знаний",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Для поиска и устранения технических проблем, а также доступа к ресурсам поддержки воспользуйтесь статьями нашей базы знаний.",
    "zoomCommunity": "Сообщество Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Здесь можно искать решения, задавать вопросы и совместно работать с другими пользователями Zoom.",
    "chatbot": "Чат-бот",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Получайте ответы на вопросы и устраняйте технические проблемы, взаимодействуя с нашим чат-ботом.",
    "submitWebTickets": "Отправка интернет-заявок",
    "liveChatSupport": "Поддержка в чате в реальном времени",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Планы подписки стоимостью выше {amount} долл. США/месяц",
    "livePhoneSupport": "Поддержка по телефону в реальном времени",
    "meetWithAgentOnVideo": "Видеоконференция с агентом",
    "subscriptionPlansGreaterThan_200UsdMonth": "Планы подписки стоимостью выше 200 долл. США/месяц",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Улучшайте продуктивность, используя любимые приложения непосредственно в Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Настройте собственный аватар, чтобы привнести разнообразие в конференции и показать себя в динамичном виде, не включая при этом видео",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Почта",
    "common.plans.meeting.title": "Конференции",
    "plans.basic_free.upgrade.item1": "Продолжительность каждой конференции: до 30 часов",
    "common.statistics.participants": "{0} Участники",
    "common.per_meeting_unit": "на конференцию",
    "common.participant_limit.increase_with_large_meetings": "Увеличьте охват с помощью дополнения «Большая конференция»",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Доска сообщений",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Неограниченные",
    "common.plans.team_chat.title": "Коллективный чат",
    "common.plans.mail_calendar.title": "Почта и календарь",
    "common.plans.cloud_storage.title": "Облачное хранилище",
    "plans.bundle_credit.storage": "{0} ГБ",
    "plans.translation.title": "Переведенные субтитры Zoom",
    "common.plans.extras.title": "Дополнения",
    "common.plans.extras.desc": "управление доменами компании и многое другое",
    "zoom_one_edu_bundle.school.title": "Zoom One для образования «Школа и кампус»",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One для образования «Школа и кампус Плюс»",
    "per_billing_cycle_license.monthly": "/месяц за лицензию",
    "per_billing_cycle_license.yearly": "/год за лицензию",
    "per_billing_cycle_space.monthly": "в месяц за место",
    "per_billing_cycle_space.yearly": "в год за место",
    "common.dialog.feature_list": "Смотреть полный список функций",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 ГБ на лицензию",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 ГБ на лицензию",
    "detail_dialog.meeting_feature.cloud_recording.ent": "План «Предприятие Плюс» включает неограниченный объем хранилища",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Зал Zoom Room + коннектор конференц-залов (соотношение 1:25)",
    "plans.whiteboard.ent": "План «Предприятие Плюс» включает неограниченное количество досок и дополнительные возможности",
    "plans.zp.ent": "Возможность включена в план «Предприятие Плюс»",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Расширенное резервирование или резервирование рабочего места в офисе и многое другое",
    "plans.largeMeeting.intro_tip": "«Большие конференции» — это необязательное дополнение, которое можно добавить при оформлении заказа. Оно позволяет проводить конференции максимум для 500 или 1000 участников, в зависимости от приобретенной лицензии.",
    "common.participant_limit.expandable_with_large_meetings": "Можно увеличить с помощью дополнения «Большая конференция»",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1000 для Enterprise Plus.</span>",
    "plans.webinar": "Вебинар Zoom",
    "plans.webinar.ent": "План «Предприятие Плюс» включает лицензию Sessions 1000 (в том числе Webinars)",
    "per_billing_cycle_user.monthly": "/мес./польз.",
    "per_billing_cycle_user.annually": "/г./польз.",
    "closeComparisonChart": "Закрыть сравнительную таблицу",
    "archiving_api": "API архивирования",
    "dlp_api": "API DLP",
    "info_barriers": "Информационные барьеры",
    "chat_etiquette": "Правила поведения в чате",
    "gdrp": "GDPR",
    "regiona_data_centers": "Региональные центры обработки данных",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Шифрование по умолчанию",
    "end_to_end_encryption": "Сквозное шифрование",
    "cryptographic_boundary": "Криптографическая граница",
    "vdi": "Виртуальный рабочий стол (VDI)",
    "customer_managed_key": "Управляемый клиентом ключ",
    "gpo_msi_policies": "Политики GPO и MSI",
    "msi": "Пакетное развертывание (MSI)",
    "ntt": "Инструмент для тестирования сети (NTT)",
    "dashboards": "Панели управления",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Сохранение работоспособности Zoom Phone",
    "zoom_meeting_survivability": "Сохранение работоспособности Zoom Meetings",
    "paid_option": "Платный параметр",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Основные функции",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Школа и кампус",
    "zoom_one_edu_bundle.school_plus.brief_title": "Школа и кампус Плюс",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "sv-SE": {
    "billing.essential_apps": "Grundläggande appar",
    "billing.essential_apps.dialog_desc": "Utöka och hantera ditt företag med appar som för mötesanteckningar, engagera ditt team med interaktiva aktiviteter och leverera insikter för att förbättra kundsamtalen. Gratis premiumappar ingår i din plan i ett år.",
    "billing.see_more_details": "Visa fler uppgifter",
    "billing.essential_app.legal_copy": "Erbjudandet gäller enbart för användare som köpt en befintlig licens i ett Zoom One Pro-, Business- eller Business Plus-abonnemang den 4 januari 2023 eller senare via Zooms onlinekanal på zoom.us/buy. Användare vars abonnemang är kopplat till ett hälso- och sjukvårdskonto (förutom om den köpts på zoom.us/buy) eller ett utbildnings- eller myndighetskonto är inte berättigade till erbjudandet. Åtkomsten till samtliga appar, med undantag för Coda, påbörjas när den enskilda användaren aktiverar appen och går ut ett år efter detta. Åtkomsten till Coda för samtliga användare i samma Zoom-konto påbörjas när en av användarna i kontot aktiverar Coda för första gången och går ut för samtliga användare i det Zoom-kontot ett år efter det, oavsett när efterföljande användare i samma Zoom-konto aktiverar den. För samtliga appar gäller att omtilldelningen eller upphävandet av en användares berättigande licens eller prenumeration avslutar åtkomsten för den användaren, oavsett om tid återstår i åtkomstperioden på ett år. Varje app har sina egna användarvillkor och sin egen integritetspolicy som tillgängliggörs vid aktiveringen. De appar som ingår har enbart stöd för engelska. Alla appar fungerar inte på mobilen. Erbjudandet kan inte lösas in mot eller återbetalas i kontanter. Erbjudet gäller enbart dessa appar, vilka anges som inkluderade under <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">grundläggande appar i Zoom App Marketplace</a>. Användare med befintliga abonnemang för någon av apparna kvalificerar sig inte för detta erbjudande vad gäller de specifika apparna. Vilka appar som ingår kan ändras. Zoom förbehåller sig rätten att när som helst ändra eller avbryta detta erbjudande utan föregående meddelande eller ansvar.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Besökshantering"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "L\u00e4s mer",
      "new": "Nyhet",
      "plan_details": {
        "meeting": {
          "title": "M\u00f6ten",
          "host_meeting_up_to_participants": "Var värd för upp till {0} deltagare",
          "meeting_hours": "Obegr\u00e4nsade m\u00f6ten p\u00e5 upp till 30 timmar per m\u00f6te",
          "recording_storage": "{0} GB lagring av molninspelningar (per licens)",
          "auto_captions": "Automatiska undertexter"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} redigerbara tavlor",
          "standard_features": "Standardfunktioner"
        },
        "team_chat": {
          "title": "Teamchatt",
          "desc": "Gruppchatt och fildelning"
        },
        "main_calendar": {
          "title": "E-post och kalender",
          "desc": "Klient och tjänster för e-post och kalender"
        },
        "notes": {
          "title": "Anteckningar",
          "desc1": "Skapa och dela redigerbara dokument i Zoom",
          "desc2": "Personliga och samarbetsbaserade anteckningar med RTF-redigering"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Spela enkelt in, redigera och dela korta videor",
          "desc2": "Obegr\u00e4nsade videor och avancerade funktioner"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automatisera viktiga uppgifter p\u00e5 hela Zoom-plattformen med en AI-assistent",
          "desc2": "F\u00e5 snabb \u00e5tkomst till m\u00f6tessammanfattningar, hj\u00e4lp med att skriva meddelanden och mer"
        },
        "EssentialApp": {
          "title": "Grundl\u00e4ggande appar",
          "desc1": "Gratis premiumappar i ett \u00e5r (villkor g\u00e4ller)",
          "desc2": "\u00d6ka teamets samarbete och produktivitet"
        },
        "livechat": {
          "title": "Support via livechatt"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Vill du ändra till Zoom Workplace Pro?",
            "content": "Du har tidigare valt Zoom Workplace Business, som tillåter upp till 300 deltagare per möte, innehåller Zoom Scheduler och mycket mer. Vill du fortfarande ändra till Pro?",
            "confirm": "Bekräfta ändring",
            "keep_current": "Behåll nuvarande plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Deltagare",
          "participants": "{0} Deltagare",
          "user_range": "{0}–{1} användare",
          "items": "{num} artiklar"
        },
        "button": {
          "ok": "OK",
          "add": "Lägg till",
          "buy_now": "Köp nu",
          "try_for_days": "Testa i {0} dagar",
          "contact_sales": "Kontakta säljavdelningen",
          "close": "Stäng",
          "cancel": "Avbryt",
          "edit": "Redigera",
          "got_it": "Jag förstår"
        },
        "title": {
          "everything_in_and": "Allt i {0} och:"
        },
        "tag": {
          "new": "Nyhet",
          "free_trial": "Gratis provperiod"
        },
        "billing_cycle": {
          "annual": "Årlig",
          "monthly": "Månadsvis",
          "quarterly": "Kvartalsvis",
          "two_years": "Två år",
          "three_years": "Tre år"
        },
        "errors": {
          "unknown_error_try_again": "Okänt fel vid behandling av transaktion. Försök igen senare."
        },
        "excluding_tax": {
          "vat_tip": "exklusive moms",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Begränsade funktioner",
        "pro_plus": {
          "host_meeting_up_to_participants": "Var värd för upp till {0} deltagare",
          "gb_of_cloud_recording_storage": "{0} GB lagring av molninspelningar (per licens)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion för att skapa och översätta innehåll",
            "features_item2": "Obegränsat antal delade dokument med ditt team",
            "features_item3": "Få åtkomst till obegränsad versionshistorik",
            "comparison_table_tips": "Ta samarbetet till nästa nivå med AI-prioriterade dokument som omvandlar mötesinnehåll till användbara dokument, wikis och projekt"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatiskt identifiera uppgifter från dina möten, telefonsamtal, chattar och dokument",
            "features_item2": "Slutföra uppgifter, som att schemalägga uppföljningsmöten och skapa utkast till dokument",
            "features_item3": "Enkelt markera uppgifter som slutförda när de är klara för att hålla koll på dina framsteg och fokusera på vad som händer härnäst",
            "features_item4": "Hantera uppgifter på Zoom Workplace-plattformen, inklusive Zoom Docs",
            "features_item1_opc": "Använda kraften i AI Companion för att identifiera och skapa uppgifter från dina chatt- och e-postmeddelanden, dokument, whiteboardtavlor och mötessammanfattningar",
            "features_item2_opc": "Enkelt sortera, filtrera, gruppera och söka för att snabbt komma åt och få sammanhang för dina uppgifter",
            "learn_more_header": "Ha koll på dina åtgärdspunkter med AI Companion* för att få mer gjort i Zoom Workplace.",
            "learn_more_footer": "\* AI Companion är endast tillgängligt för Zoom Workplace Pro-, Business- och Enterprise-planer.",
            "features_prefix": "Låt AI Companion hjälpa dig att:",
            "comparison_table_tips": "Håll koll på åtgärdspunkterna och slutför dem i tid med en AI-driven lösning som ger uppgiftsrekommendationer baserade på konversationer och mötessammanfattningar i Zoom Workplace.",
            "tasks_label_text": " AI-driven uppgiftshantering"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Kontakta oss f\u00f6r prisinformation med mera",
          "contact_sales": "Kontakta s\u00e4ljavdelningen",
          "meetings": "M\u00f6ten",
          "phone": "Telefon",
          "phone_sub_title": "Obegr\u00e4nsade samtal",
          "use_only": "Enbart f\u00f6retagsanv\u00e4ndning",
          "team_chat": {
            "title": "Teamchatt",
            "title_desc": "Gruppchatt och fildelning"
          },
          "cloud_storage": {
            "title": "Molnlagring"
          },
          "mail_calender": {
            "title": "E-post och kalender"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Klient och tj\u00e4nst"
          },
          "up_to_30_hours_per_meeting": "upp till 30 timmar per m\u00f6te",
          "300_attendees": "300 deltagare",
          "per_meeting": "per m\u00f6te",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "Nyhet",
          "clips_plus": "Clips Plus",
          "notes": "Anteckningar",
          "10GB": "10 GB",
          "extras": "Extra f\u00f6rdelar",
          "sso_managed_domains_more": "SSO, hanterade dom\u00e4ner och mer",
          "scheduler": "Schemal\u00e4ggare",
          "global_select": "Globalt val",
          "unlimited_regional": "Obegr\u00e4nsat regionalt",
          "translated_captions": "\u00d6versatta undertexter",
          "workspace_reservation": "Reservering av arbetsplats",
          "auto_translated_captions": "Automatiska och \u00f6versatta undertexter",
          "unlimited_editable_boards": "Obegr\u00e4nsade redigerbara tavlor",
          "standard_features": "Standardfunktioner",
          "advanced_docu_controls": "Avancerade dokumentkontroller",
          "chats_channels_for_collaboration": "Chattar och kanaler f\u00f6r samarbete, fildelning och mer d\u00e4rtill",
          "zoom_phone_is_biz_use_only": "Zoom Phone \u00e4r enbart avsett f\u00f6r f\u00f6retagsanv\u00e4ndning",
          "unlimited_regional_calling": "Obegr\u00e4nsade regionala samtal",
          "domestic_sms_mms": "Inrikes sms och mms",
          "automatic_call_distribution_groups": "Automatisk samtalsdistribuering (ACD) med samtalsk\u00f6",
          "single_sign_on": "Enkel inloggning",
          "managed_domains": "Hanterade dom\u00e4ner",
          "company_branding": "Varum\u00e4rkesanpassning f\u00f6r f\u00f6retag",
          "mail_calender_client_services_beta": "Klient och tj\u00e4nster f\u00f6r e-post och kalender i betaversion",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Obegr\u00e4nsade m\u00f6ten p\u00e5 upp till 30 timmar per m\u00f6te",
          "mail_and_calendar_client_and_services_beta": "Klient och tj\u00e4nster f\u00f6r e-post och kalender",
          "easily_record_edit_share_videos": "Spela enkelt in, redigera och dela korta videor",
          "unlimited_videos_advanced_features": "Obegr\u00e4nsade videor och avancerade funktioner",
          "create_share_editabel_docu_within_zoom": "Skapa och dela redigerbara dokument i Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personliga och samarbetsbaserade anteckningar med RTF-redigering",
          "effortlessly_share_meeting": "Dela m\u00f6testider enkelt f\u00f6r smidig bokning",
          "works_with_zoom_meeting_mail_calender_google_ms": "Fungerar med Zoom Meetings, Zoom Mail och Calendar, Google och Microsoft 365",
          "up_to_300_attendees": "Upp till <b>300</b> deltagare",
          "10_gb_of_storage": "10 <b>GB</b> lagring",
          "host_meeting_up_to_300_participants": "Var v\u00e4rd f\u00f6r m\u00f6ten med upp till 300 deltagare",
          "10_gb_of_cloud_recording_storage": "10 GB lagring av molninspelningar (per licens)",
          "starting_at_licenses_year": "Fr\u00e5n {1} licenser f\u00f6r {0}/\u00e5r",
          "starting_at_licenses_month": "Fr\u00e5n {1} licenser f\u00f6r {0}/m\u00e5nad",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automatisera viktiga uppgifter p\u00e5 hela Zoom-plattformen med en AI-assistent",
          "gain_quick_access_to_meeting_summaries": "F\u00e5 snabb \u00e5tkomst till m\u00f6tessammanfattningar, hj\u00e4lp med att skriva meddelanden och mer",
          "learn_more": "L\u00e4s mer",
          "essential_apps": "Grundl\u00e4ggande appar",
          "increase_team_collaboration": "\u00d6ka teamets samarbete och produktivitet",
          "free_premium_apps": "Gratis premiumappar i ett \u00e5r (villkor g\u00e4ller)",
          "visitor_management": "Besökshantering",
          "visitor_management_custom_invites": "Anpassa inbjudningar",
          "visitor_management_visitor_check": "Checka in i en kiosk",
          "visitor_management_receive_detailed": "Få detaljerad statistik om besökarnas utrymmesanvändning"
        },
        "custom_avatar": {
          "title": "Anpassad avatar",
          "label_text": "Tre minuter per månad",
          "basic_feature": "1 minut per livstid",
          "pricing_feature": "Tre minuter per månad",
          "learn_more_subtitle": "Skapa en verklighetstrogen AI-version av dig själv med röstreplikering och flerspråkig kommunikation.",
          "features_item1": "Skapa upp till tre verklighetstrogna digitala avatarer varje månad som replikerar ditt utseende och din röst för presentationer och demos",
          "features_item2": "Använd din avatar för att leverera manus som är upp till tre minutes långa, med AI Companion",
          "features_item3": "Välj bland 18 fördesignade avatarer för snabbt och högkvalitativt videoskapande",
          "features_item4": "Få stöd för virtuell bakgrund",
          "features_item1_opc": "Skapa upp till tre verklighetstrogna digitala avatarer varje månad som replikerar ditt utseende och din röst för presentationer och demos",
          "features_item2_opc": "Använd din avatar för att leverera manus som är upp till tre minutes långa, med AI Companion",
          "comparison_table_tips": "Anpassad avatar skapar en verklighetstrogen AI-version av dig själv med röstreplikering och flerspråkig kommunikation."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automatisera viktiga uppgifter p\u00e5 hela Zoom-plattformen med en AI-assistent",
        "desc2": "F\u00e5 snabb \u00e5tkomst till m\u00f6tessammanfattningar, hj\u00e4lp med att skriva meddelanden och mer",
        "learn_more_dialog": {
          "desc": "Få mer gjort med AI Companion! Den kan skriva innehåll, schemalägga dina möten, hjälpa dig att hantera dina projekt och mycket mer.",
          "tip1": "Få en agenda i förväg så att du kan hålla mer effektiva möten",
          "tip2": "Håll dina projekt på rätt spår med automatiserat uppgiftsskapande och aviseringar",
          "tip3": "Få hjälp med att organisera din kalender och hantera din tid",
          "tip4": "Skapa skriftligt och visuellt innehåll som matchar din stil i Docs, Whiteboard eller i Zoom Workplace-appen"
        },
        "top_features": "Populära funktioner",
        "more_to_come": "Fler fantastiska funktioner kommer snart!",
        "discover_more": "Upptäck ännu fler sätt att göra ditt bästa arbete med AI Companion!",
        "detail_desc": "AI Companion ingår utan extra kostnad i de betalda tjänsterna på Zoom-användarkonton. Vissa vertikaler eller regioner kanske inte omfattas."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/år/licens",
        "month_licnese": "/månad/licens",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/månad",
          "per_year": "/år"
        },
        "unit": {
          "license": "{0}/licens",
          "user": "{0}/användare"
        },
        "learn_more": "Läs mer",
        "required": "Krävs",
        "zoom_one_required": "Zoom Workplace krävs",
        "large": {
          "features_tip": "Nå ut till fler med en ökad deltagarkapacitet på upp till 1 000 deltagare.",
          "label_title1": "500 deltagare",
          "label_title2": "1000 deltagare"
        },
        "cmr": {
          "features_tip": "Lagra, streama och ladda ner dina videoinspelningar direkt från Zoom-molnet.",
          "explain_desc": "Molnlagring ingår i utvalda Zoom One-planer: Pro (5 GB), Business (5 GB), Business Plus (10 GB) och Enterprise (obegränsat)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 timmar",
          "option_label2": "≈ 650 timmar",
          "option_label3": "≈ 3,500 timmar",
          "option_label4": "≈ 17,500 timmar",
          "intro_label2": "Lagringsalternativen omfattar upp till 5 TB/månad",
          "tooltip_content": "Lagringsutrymmet för inspelningar varierar beroende på antalet deltagare med video, mötesupplösningen och upplösningen för delat innehåll."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Samarbeta i realtid med andra på whiteboardtavlor, både under och utanför möten.",
          "explain_desc": "Ingår i Zoom One Business, Zoom One Business Plus och Zoom One Enterprise",
          "explain_desc_plus": "Ingår i Zoom One Enterprise Plus och i samtliga Zoom Rooms-abonnemang",
          "option_label1": "Obegränsade tavlor med 1 GB molnlagring",
          "option_label2": "Avancerade funktioner med obegränsade tavlor och molnlagring",
          "intro_label1": "Obegränsade whiteboardtavlor som kan redigeras samtidigt",
          "intro_label2": "Standardfunktioner och avancerad dokumentkontroll",
          "intro_label3": "Avancerade whiteboardfunktioner som anpassade mallar, organisationsmallar och tredjepartsintegreringar"
        },
        "translated_captions": {
          "features_tip": "Främja globalt samarbete med automatiska undertexter på ditt föredragna språk.",
          "intro_label1": "Deltagare kan själva aktivera undertexter och växla språk.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Visa språk som stöds"
        },
        "crc": {
          "features_tip": "Möjliggör alla standardbaserade SIP/H.323-ändpunkter för videokonferenser, för effektivt hybridarbete.",
          "intro_label1": "Kan användas med flera äldre ändpunkter som Polycom, Cisco, Lifesize med flera",
          "intro_label2": "Molnbaserade eller lokala (VM) anslutningsprogram för rum"
        },
        "scheduler": {
          "simplify_bookings": "Förenkla bokningar med flexibel tillgänglighet och anpassningsbara tidsluckor",
          "host_one_on_one": "Håll enskilda möten eller gruppmöten med en enda länk för enkel delning",
          "customize_reminders": "Anpassa påminnelser via e-post eller sms för att minska antalet missade möten",
          "sync_calendars": "Synkronisera kalendrar sömlöst med Google-, Microsoft 365- och Zoom-integreringar",
          "features_tip": "Dela mötestider enkelt för kontorstider, intervjuer och mer.",
          "intro_label1": "Kalenderintegrering",
          "intro_label2": "Återkommande tillgänglighet",
          "intro_label3": "Skalbart möte",
          "intro_label4": "Anpassningsbara aviseringar",
          "intro_sub_label1": "Google, Microsoft 365 och Zoom ",
          "intro_sub_label2": "dela bokningsbara tider ",
          "intro_sub_label3": "ett enstaka möte för en eller flera deltagare",
          "intro_sub_label4": "automatisera påminnelser och bekräftelser för e-post och sms"
        },
        "zoom_clips_plus": {
          "features_tip": "Spela in, redigera och dela korta videomeddelanden av hög kvalitet.",
          "intro_label1": "Skapa obegränsade videor utan tidsbegränsningar",
          "intro_label2": "Spela in din skärm och video tillsammans eller separat",
          "intro_label3": "Klipp din video enligt behov och dela länken",
          "intro_label4": "Få avancerade funktioner såsom ljudtranskriptioner och statistik",
          "explain_desc": "Clips Plus ingår i Workplace Pro-, Business- och Enterprise-prenumerationer. Du kan utforska alla funktioner i varje plan i jämförelseavsnittet på prissidan."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Avancerad evenemangsplattform med robusta funktioner för registrering och nätverkande. Perfekt för både virtuella och hybrida upplevelser.",
          "tooltip_content": "Var värd för obegränsade webbinarier eller evenemang med den valda kapaciteten",
          "intro_title": "Allt i Sessions",
          "intro_label1": "Öka publikens engagemang med evenemang med flera sessioner",
          "intro_label2": "Anordna evenemang enkelt med anpassad biljettfunktion och mobilappen",
          "intro_label3": "Öka evenemangsintäkter med Mässgolv och sponsorområde",
          "intro_label4": "Främja nätverkande mellan deltagare med anpassningsbara profiler",
          "intro_label5": "Utöka räckvidden med visning på begäran i evenemangslobbyn",
          "intro_label6": "Snabbare konfiguration av evenemang med utvalda evenemangsmallar",
          "events_feature_item1_20240827": "Organisera virtuella flerdagarsevenemang med flera spår",
          "events_feature_item2_20240827": "Främja nätverkande med deltagarprofiler och lobbychatt.",
          "events_feature_item3_20240827": "Vägled deltagarna med streamade lobbysessioner.",
          "events_feature_item4_20240827": "Öka evenemangsintäkterna med mässgolv och sponsring.",
          "events_feature_item5_20240827": "Förbättra framtida evenemang med undersökningar efter konferensen.",
          "events_feature_item6_20240827": "Snabbare konfiguration av evenemang med utvalda evenemangsmallar",
          "attendees_start_at": "{0} deltagare med start kl.",
          "explain_desc": "Upptäck mer om Zoom Events",
          "contact_account_owner": "<a href=\"/account\" target=\"_blank\">Kontakta din kontoägare</a> om du vill köpa Events",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Effektivisera interaktiva enstaka sessioner med funktioner som event branding, samarbete med flera värdar och eventhantering.",
          "tooltip_content": "Var värd för obegränsade webbinarier eller evenemang med den valda kapaciteten",
          "intro_title": "Omfattar Zoom Webinars",
          "intro_label1": "Anpassa landningssidor för evenemang för effektiv varumärkesanpassning",
          "intro_label2": "Marknadsför evenemang med varumärkta e-postmeddelanden",
          "intro_label3": "Mät prestanda med en interaktiv kontrollpanel",
          "intro_label4": "Smidigt samarbete med medvärdar och medredigerare",
          "intro_label5": "Professionella verktyg för evenemang: Simulive",
          "sessions_feature_item1_20240827": "Ta webbinarierna till nästa nivå med anpassade scener och varumärkesanpassning",
          "sessions_feature_item2_20240827": "Förenkla evenemangsplaneringen genom att låta AI Companion generera meddelanden och bilder.",
          "sessions_feature_item3_20240827": "Marknadsför tidigare och framtida evenemang i en varumärkesanpassad hubb för innehåll.",
          "sessions_feature_item4_20240827": "Anordna professionella evenemang med backstage, simulive och RTMP.",
          "sessions_feature_item5_20240827": "Förbättra framtida webbinarier med insikter från olika evenemang.",
          "explain_desc": "Upptäck mer om Zoom Sessions",
          "contact_account_owner": "<a href=\"/account\" target=\"_blank\">Kontakta din kontoägare</a> om du vill köpa Sessions",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Sänd ut ditt budskap utan problem med en användarvänlig webbinarieplattform.",
          "tooltip_content": "Var värd för obegränsade webbinarier eller evenemang med den valda kapaciteten",
          "intro_label1": "Engagera publiken med högkvalitativ videowebbsändning",
          "intro_label2": "Öka engagemanget med frågor och svar, genomföra en omröstning och reaktioner",
          "intro_label3": "Förbättra strategin för webbinarier med rapportering efter evenemanget",
          "intro_label4": "Stöd för upp till 100 000 deltagare och 100 paneldeltagare",
          "monthly_subscription": "Månadsprenumeration",
          "annual_subscription": "Årsprenumeration",
          "one_million": "En miljon",
          "single_use": "En gång",
          "one_month": "En månad",
          "event_attendee": "Deltagare på evenemang/sessioner:",
          "event_attendee_desc": "Alla som går med utan att vara en licensierad värd på hubben. Specialroller räknas också som deltagare och kan delta med ljud, video och skärmdelning (om det är aktiverat).",
          "webinar_attendee": "Deltagare i webbinarier:",
          "webinar_attendee_desc": "Någon som går med men som inte är värd eller paneldeltagare. De har enbart visningsåtkomst och styrs av värden, som kan aktivera deras mikrofon och aktivera interaktion via frågor och svar och chatten.",
          "pay_per_attendee": "Betala per deltagare",
          "attendees": "Deltagare"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Förnya sättet som ditt team arbetar med din AI-drivna plattform för samarbete.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Var värd för ett obegränsat antal möten på upp till 30 timmar med upp till 100 deltagare",
          "intro_label2": "Få åtkomst till 3 whiteboardtavlor som kan redigeras samtidigt med standardfunktioner",
          "intro_label3": "Spela in, redigera och dela korta videomeddelanden av hög kvalitet med Clips Plus",
          "intro_label4": "Arbeta effektivare med Zoom AI Companion",
          "intro_label5": "Zoom Phone USA och Kanada obegränsade samtal (BYOC, PBX och PBX från tredje part ingår inte)",
          "intro_label6": "Var värd för ett obegränsat antal möten på upp till 30 timmar med upp till 300 deltagare",
          "intro_label7": "Dela mötesplatser för kontorstider, intervjuer och mycket mer med Zoom Scheduler",
          "intro_label8": "Zoom Phone obegränsade samtal USA och Kanada",
          "intro_label8_UK": "Zoom Phone obegränsade samtal för Storbritannien och Irland",
          "intro_label8_AU": "Zoom Phone obegränsade samtal för Australien och Nya Zeeland",
          "intro_label8_JP": "Zoom Phone obegränsade samtal för Japan",
          "intro_label9": "Besökshantering",
          "intro_label10": "Ytterligare funktioner",
          "intro_label11": "Support via livechatt",
          "intro_title1": "Allt i Pro och:",
          "intro_title2": "Allt i Business och:",
          "intro_label_tip1": "För Zoom Phone i Pro Plus ingår inte BYOC, PBX från tredjepart och VDI-funktioner. Mer information finns på prissidan för Zoom Phone.",
          "intro_label_tip2": "I kassan kan du välja obegränsade regionala samtal i USA och Kanada, Australien och Nya Zeeland, Storbritannien och Irland samt Japan.",
          "intro_label_tip3": "Andra funktioner som ingår är 10 GB molnlagring, översatta undertexter och reservering av arbetsplats.",
          "intro_label_tip4": "För Zoom Phone i Pro Plus ingår inte BYOC, PBX från tredjepart och VDI-funktioner. Mer information finns på prissidan för Zoom Phone."
        },
        "power_pack": {
          "title": "Kraftpaket för Zoom Phone",
          "features_tip": "Utökade samtalsköanalyser och historiska insikter för callcenterteam.",
          "intro_label1": "Utökat kontaktfönster för att effektivisera samtalshantering",
          "intro_label2": "Telefonnummer till automatisk receptionist och samtalskö"
        },
        "international_calling": {
          "title": "Internationella samtal",
          "features_tip": "Obegränsade internationella samtal till mer än 15 länder och regioner.",
          "intro_label1": "Kan köpas med valfri obegränsad samtalsplan",
          "intro_label2": "Utforska vår lista över länder och regioner som stöds för obegränsade internationella samtal.",
          "intro_labe2_tooltip": "USA, Kanada, Storbritannien, Irland, Australien, Nya Zeeland, Österrike, Danmark, Frankrike, Tyskland, Italien, Portugal, Spanien, Sverige, Belgien, Nederländerna, Schweiz, Puerto Rico och Japan.",
          "intro_label2_view_list": "Visa lista"
        },
        "workspace_reservation": {
          "title": "Reservering av arbetsplats",
          "intro_title": "Reservera enkelt flexibla arbetsplatser eller hotellrum i förväg eller på plats med Zoom-integrerade enheter.",
          "intro_label1": "Få tillgång till arbetsplats- och hotellbokning via Zoom Workplace-appen, skrivbordet eller webbläsaren",
          "intro_label2": "Få personliga skrivbordsrekommendationer med hjälp av AI",
          "intro_label3": "Reservera arbetsplatser direkt från Google Kalender eller Outlook, med påminnelser och incheckningsnotiser",
          "intro_label4": "Navigera till reserverade arbetsplatser med vägbeskrivning"
        },
        "visitor_management": {
          "title": "Besökshantering",
          "intro_title": "Effektivisera besökarnas incheckning med anpassade inbjudningar, problemfri incheckning i kiosken, rapportering och mätvärden.",
          "intro_label1": "Hantera inbjudningar, besöksplatser och besökshistorik i Zoom-portalen",
          "intro_label2": "Skapa, spåra, skicka om och ta bort inbjudningar samtidigt som du får aviseringar när gäster anländer",
          "intro_label3": "Fyll i formulär, få vägbeskrivningar och checka in via kiosken för en smidig besöksupplevelse",
          "intro_label4": "Få tillgång till alla funktioner i den välbekanta Zoom-portalen för enkel hantering"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Öka möteskapaciteten till upp till 1 000 interaktiva live-deltagare",
          "description2": "Alla deltagare kan dela sitt ljud, sin video och sin skärm"
        },
        "cloud_storage": {
          "title": "Molnlagring",
          "description2": "Filformaten MP4 och M4A är tillgängliga"
        },
        "translated_captions": {
          "title": "Översatta undertexter",
          "description1": "Förbättra möten med automatisk, flerspråklig textning så att deltagare kan aktivera och byta till ett språk som stöds",
          "description2": "Tillgängligt i Zoom Meetings och Zoom Webinars"
        },
        "tollfree": {
          "title": "Ljudkonferenser",
          "subcontent": "Dial into meetings with phones numbers from around the world ",
          "description1": "Utöka samtalsalternativen med uppringning, globala avgiftsfria samtal och lokal inringning för Premium-länder",
          "description2": "Det kostar ingenting för deltagare att ringa in från valfri enhet",
          "description3": "Välj enkelt ett eller flera länder för avgiftsfri inringning"
        },
        "rc": {
          "title": "Anslutningsprogram för konferensrum"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australien",
        "Austria": "Österrike",
        "Belgium": "Belgien",
        "Brazil": "Brasilien",
        "Bulgaria": "Bulgarien",
        "Canada": "Kanada",
        "Chile": "Chile",
        "China": "Kina",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Kroatien",
        "Cyprus": "Cypern",
        "Czech_Republic": "Tjeckien",
        "Denmark": "Danmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estland",
        "Finland": "Finland",
        "France": "Frankrike",
        "Germany": "Tyskland",
        "Greece": "Grekland",
        "Hong_Kong_SAR": "Hongkong",
        "Hungary": "Ungern",
        "Ireland": "Irland",
        "Israel": "Israel",
        "Italy": "Italien",
        "Japan": "Japan",
        "Latvia": "Lettland",
        "Lithuania": "Litauen",
        "Luxembourg": "Luxemburg",
        "Mexico": "Mexiko",
        "Netherlands": "Nederländerna",
        "New_Zealand": "Nya Zeeland",
        "Norway": "Norge",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Polen",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Rumänien",
        "Singapore": "Singapore",
        "Slovakia": "Slovakien",
        "Slovenia": "Slovenien",
        "South_Africa": "Sydafrika",
        "Spain": "Spanien",
        "Sweden": "Sverige",
        "Switzerland": "Schweiz",
        "UK": "Storbritannien",
        "United_Kingdom": "Storbritannien",
        "US": "USA",
        "United_States": "USA",
        "title": "Krav för telefonnummer",
        "subtitle": "Välj det land där ditt Globalt val-telefonnummer ska aktiveras.",
        "selector_tip": "Välj land",
        "local_and_toll_free": "Lokala och avgiftsfria nummer är tillgängliga i {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Globalt val omfattar ett telefonnummer och obegränsade inrikessamtal inom det valda landet per licens.",
        "avail_title": "Tillgängliga länder/territorier"
      },
      "tax_exempt_ecm": {
        "title": "Skattebefrielsestatus",
        "status_exempt": "Skattefri",
        "status_exempt_question": "Skattebefriad?",
        "verify_now": "Verifiera nu",
        "can_after_checkout": "Som ett alternativ kan detta steg slutföras efter kassan.",
        "status": {
          "exempt": "Undantagen",
          "pending": "Väntande",
          "pendingTooltip": "Din skattebefrielsestatus granskas för närvarande. Du kan debiteras skatt när du gör en beställning. Om ditt undantag bekräftas kommer vi att kreditera alla återbetalningsbara skatter/avgifter på ditt konto.",
          "nonexempt": "Ej befriad",
          "rejected": "Avvisad",
          "rejectedTooltip": "Det inlämnade dokumentet har fastställts inte uppfylla kraven för din jurisdiktion.",
          "approved": "Godkänd",
          "default": "standard"
        },
        "confirm_close": {
          "new_desc": "Om du överger verifieringen kan du komma att debiteras tillämpliga skatter/avgifter. Du kan fortfarande skicka in dokumentet för skattebefrielse i avsnittet Faktureringshantering efter köpet så kommer Zoom att granska och bedöma det. När det har godkänts utfärdas en återbetalning av eventuell inbetalad skatt.",
          "desc": "Är du säker på att du vill avstå från kontroll av skattebefrielse och fortsätta som skatteberättigad?",
          "title": "Are you sure?",
          "new_title": "Vill du överge verifiering av skattebefrielse?",
          "yes": "Ja, avbryt",
          "no": "Nej, fortsätt",
          "abandon": "Överge verifiering",
          "go_back": "Gå tillbaka"
        },
        "confirm_to_add": {
          "title": "Bekräfta ny standardskattebefrielse",
          "message": "Om du lägger till ett nytt undantag kommer det automatiskt att ställas in som standard när det godkänts eller avvisats. Du kan bara ha en standardbefrielse, som kommer att tillämpas på framtida köp. Din skattemängd kan påverkas om din standardbefrielse inte stämmer överens med din \"Såld till\"-stat/region.",
          "yes": "Lägg till nytt undantag"
        },
        "confirm_set_default": {
          "title": "Adress och skattebefrielse stämmer inte överens",
          "message": "Din \"Såld till kontakt\"-adress stämmer inte överens med staten/regionen som du har valt för skattebefrielse. Uppdatera din \"Såld till kontakt\"-adress så att den stämmer överens med platsen för din skattebefrielse. Annars kommer ditt köp inte att vara skattebefriat.",
          "yes": "Ställ in som standard ändå",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Stat/Region",
          "exemption_type": "Befrielsetyp",
          "signed_date": "Datum för signering",
          "status": "Status",
          "add_exemption": "Skattebefrielse",
          "view": "Visa",
          "set_as_default": "Ställ in som standard"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Din {planName}-plan kommer att avbrytas {date} kl. 12:00 koordinerad universell tid. Om du vill vara värd efter ditt avbokningsdatum, vänligen återaktivera ditt abonnemang.",
        "pairPreDescTip": "Din {planName1}-plan och {planName2}-plan kommer att sägas upp {date} kl. 12:00 koordinerad universell tid. Om du vill vara värd efter ditt avbokningsdatum, vänligen återaktivera dina planer.",
        "pairDiffDatePreDescTip": "Din {planName1}-plan och {planName2}-plan kommer att sägas upp {date1} kl. 12:00 koordinerad universell tid respektive {date2} kl. 12:00 koordinerad universell tid. Om du vill vara värd efter ditt avbokningsdatum, vänligen återaktivera dina planer.",
        "title": "Återaktivera din plan för att fortsätta",
        "titles": "Återaktivera dina planer för att fortsätta",
        "plan": "Plan",
        "licenses": "Licens(er)",
        "billingCycle": "Faktureringscykel",
        "effective_date": "Datum för ikraftträdande",
        "invoice_amount": "Fakturabelopp",
        "singleDescTip": "Genom att återaktivera godkänner du att din återkommande plan automatiskt kommer att förnyas {date} och att din betalningsmetod på filen kommer att debiteras varje förnyelseperiod. För att undvika framtida avgifter måste du <a target=\"_blank\" href=\"https://support.zoom.com/hc/sv/article?id=zm_kb&sysparm_article=KB0066687\">avbryta</a> senast dagen före förnyelsedatumet.",
        "pairDescTip": "Genom att återaktivera godkänner du att dina återkommande planer automatiskt kommer att förnyas {date}. Din betalningsmetod på filen debiteras varje förnyelseperiod. För att undvika framtida avgifter måste du <a target=\"_blank\" href=\"https://support.zoom.com/hc/sv/article?id=zm_kb&sysparm_article=KB0066687\">avbryta</a> senast dagen före förnyelsedatumet.",
        "pairDiffDateDescTip": "Genom att återaktivera godkänner du att dina återkommande planer automatiskt kommer att förnyas {date1} och {date2}. Din betalningsmetod på filen debiteras varje förnyelseperiod. För att undvika framtida avgifter måste du <a target=\"_blank\" href=\"https://support.zoom.com/hc/sv/article?id=zm_kb&sysparm_article=KB0066687\">avbryta</a> senast dagen före förnyelsedatumet.",
        "totalLabel": "Totalt",
        "totalContent": "{money} plus tillämpliga skatter",
        "taxDesc": "exklusive moms, GST eller liknande skatter",
        "reactivateBtn": "Fortsätt och återaktivera",
        "switchTitle": "Uppdatera din plan för att fortsätta",
        "successSingleTip": "Din {planName}-plan har återaktiverats",
        "successPairTip": "Din {planName1}- och {planName2}-plan har återaktiverats",
        "switchTip": "Din Zoom One-Month Webinars-plan löper ut {date}. För att kunna hålla ett webbseminarium efter detta datum måste du byta till en prenumeration.",
        "switchBtn": "Byt till prenumeration"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Företag"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Ladda ner databladet"
      },
      "one": {
        "new": "Nyhet"
      }
    },
    "webinarSetupInWebPortal": "Konfiguration av webbinarium i webbportalen",
    "concurrentEvents": "Samtidiga evenemang",
    "coucurrentEventsToolTip": "<span>Med en <b>abonnemangsplan</b> får du stöd för ett live-evenemang i taget",
    "overages": "Överskottsavgifter",
    "eventsPlatformHubs": "Hubbar på evenemangsplattform",
    "eventsHubToolTip": "Zoom Events-<b>hubbar</b> erbjuder smidig organisering av evenemang",
    "1HubPerLicense": "1 hubb per licens",
    "1000Hubs": "1 000 hubbar",
    "eventsPlatformHosts_500AttendeesOrMore": "Värdar på evenemangsplattform (över 500 deltagare)",
    "eventsHost500": "<span>Zoom Events-<b>hubbvärdar</b> kan skapa",
    "5HubHosts": "5 hubbvärdar",
    "100HubHosts": "100 hubbvärdar",
    "eventsPlatformHosts_100Attendees": "Värdar på evenemangsplattform (100 deltagare)",
    "eventsHost100": "<span>Zoom Events-<b>hubbvärdar</b> kan skapa",
    "2HubHosts": "2 hubbvärdar",
    "howAreTheyDifferent": "Hur skiljer de sig åt?",
    "allPlansRequireAZoomOneLicense": "*Alla planer kräver en Zoom Workplace-licens",
    "subscription": "Prenumeration",
    "subscriptionToolTip": "<span>Med ett <b>abonnemang</b> kan du vara värd för ett obegränsat antal evenemang med din valda kapacitet.</span>",
    "payPerAttendee": "Betala per deltagare",
    "ppaToolTips": "<span><b>Betala per deltagare-licenser</b> avgör hur många sammanlagda deltagare som kan delta i alla ditt kontos evenemang under en period på tolv månader från köpet.</span>",
    "included": "Ingår",
    "notIncluded": "Ingår inte",
    "multiLanguage": "Genomf\u00f6ra en omr\u00f6stning",
    "meetings.fullPlanItem2": "Antal licenser",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "F\u00f6renklade videokonferenser och meddelanden p\u00e5 valfri enhet",
    "meetings.fullPlanItem5": "M\u00f6tesl\u00e4ngd",
    "meetings.fullPlanItem5Tip": "Den maximala l\u00e4ngden per gruppm\u00f6te (tre eller fler deltagare).",
    "meetings.fullPlanItem5_basic": "40 minuter",
    "one.basicPlusFullPlanItem1": "60 minuter",
    "meetings.fullPlanItem5_pro": "30 timmar",
    "meetings.fullPlanItem5_biz": "30 timmar",
    "meetings.fullPlanItem5_ent": "30 timmar",
    "meetings.fullPlanItem1": "Deltagarkapacitet",
    "meetings.fullPlanItem1Tip": "Deltagarna kan g\u00e5 med i ditt m\u00f6te gratis fr\u00e5n sin telefon, dator, mobil eller surfplatta. En deltagare beh\u00f6ver inte ha ett Zoom-konto f\u00f6r att delta i ett m\u00f6te. Varje plan har en gr\u00e4ns f\u00f6r antalet deltagare, men anv\u00e4ndarna kan h\u00f6ja gr\u00e4nsen f\u00f6r betalda planer genom att k\u00f6pa ett till\u00e4gg.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">* 1\u00a0000 f\u00f6r Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Inspelning",
    "meetings.fullPlanItem7Tip": "Zooms lokala inspelning sparar dina m\u00f6tesinspelningar i MP4- (video), M4A- (ljud) och txt-format (chatt).<br>Zoom-molninspelning lagrar m\u00f6ten i Zoom-molnet, varifr\u00e5n filen sedan kan laddas ner och/eller streamas fr\u00e5n en webbl\u00e4sare.",
    "meetings.fullPlanItem7_basic": "Lokalt",
    "meetings.fullPlanItem7_pro": "Lokalt och 5 GB i molnet (per licens)",
    "meetings.fullPlanItem7_biz": "Lokalt och 10 GB i molnet (per licens)",
    "meetings.fullPlanItem7_ent": "Lokalt och obegr\u00e4nsat i molnet",
    "one.messaging": "Teamchatt",
    "meetings.fullPlanItem16Tip": "Med chattar kan du enkelt skicka texter, filer, sk\u00e4rmbilder, kodavsnitt, r\u00f6stmeddelanden och bilder till en grupp. Texten kan formateras och anv\u00e4ndarna kan \u00e4ven dela GIF:ar och emojier. N\u00e4rvaron anger om chattdeltagarna \u00e4r aktiva p\u00e5 sina station\u00e4ra eller mobila enheter eller \u00e4r upptagna med m\u00f6ten.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Obegr\u00e4nsad",
    "meetings.fullPlanItem_EssentialApp": "Grundl\u00e4ggande appar",
    "common.learnMore": "L\u00e4s mer",
    "meetings.fullPlanItem_EssentialAppText": "Gratis Zoom-premiumappar i ett \u00e5r (villkor g\u00e4ller)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail och Calendar i Zoom-appen",
    "mailService": "E-posttj\u00e4nst",
    "emailServiceWithFullTimeEndToEnd": "E-posttj\u00e4nst med totalstr\u00e4ckskryptering f\u00f6r ut\u00f6kad integritet",
    "customMailDomain": "Anpassad e-postdom\u00e4n",
    "customMailDomainWithMailService": "Anpassad e-postdom\u00e4n med e-posttj\u00e4nst",
    "calendarClient": "Kalenderklient",
    "scheduleAndJoinMeetings": "Schemal\u00e4gg och g\u00e5 med i m\u00f6ten i Zoom-appen",
    "aiCompanion": "AI Companion",
    "calendarService": "Kalendertj\u00e4nst",
    "meetingSchedulingAndAppointment": "Schemal\u00e4ggning av m\u00f6ten och bokning av samtal",
    "marketing.new_pricing.clips": "Zoom Clips",
    "allPlansClipsCoreFeatureToolTip": "Skapa, redigera och dela enkelt korta videor. Lagrade klipp \u00e4r enkla att hitta och \u00f6kar engagemanget.",
    "marketing.new_pricing.notes": "Anteckningar",
    "allPlansNotesCoreFeatureToolTip": "Anteckningar \u00e4r en tillf\u00f6rlitlig dokumentredigerare f\u00f6r enskilt bruk eller samarbete med omfattande formateringsalternativ som \u00e4r tillg\u00e4nglig b\u00e5de i och utanf\u00f6r m\u00f6ten.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automatiska m\u00f6tesundertexter",
    "translatedCaptions-0": "\u00d6versatta undertexter",
    "workspaceReservation": "Reservering av arbetsplats",
    "accessAcrossAnyDevice": "\u00c5tkomst fr\u00e5n valfri enhet",
    "meetings.fullPlanItem4": "Obegr\u00e4nsade m\u00f6ten",
    "meetings.fullPlanItem9": "Inringning via telefon",
    "meetings.fullPlanItem9Tip": "G\u00e5 med i ett Zoom-m\u00f6te via telekonferens/ljudkonferens (med en traditionell telefon). Anv\u00e4ndarna debiteras enligt sina telefonplaner. Testa v\u00e5rt till\u00e4gg f\u00f6r ljudkonferenser f\u00f6r avgiftsfria inringningsnummer.",
    "meetings.fullPlanItem9_pro": "Avgiftsbaserat",
    "meetings.fullPlanItem9_biz": "Avgiftsbaserat",
    "meetings.fullPlanItem9_ent": "Avgiftsbaserat",
    "meetings.fullPlanItem11": "Sk\u00e4rmdelning",
    "meetings.fullPlanItem11Tip": "Delning av skrivbord och applikationer. Licensierade m\u00f6tesanv\u00e4ndare kan v\u00e4lja att till\u00e5ta flera deltagare att dela sina sk\u00e4rmar samtidigt under ett m\u00f6te de \u00e4r v\u00e4rd f\u00f6r.",
    "meetings.fullPlanItem12": "Grupprum",
    "meetings.fullPlanItem12Tip": "Med videogrupprum kan du dela upp ditt Zoom-m\u00f6te i s\u00e5 m\u00e5nga som 50 separata sessioner f\u00f6r diskussioner, projekt och mer d\u00e4rtill.",
    "meetings.fullPlanItem14": "Virtuell bakgrund",
    "meetings.fullPlanItem15": "Personligt m\u00f6tes-ID",
    "meetings.fullPlanItem15Tip": "Skapa ett eget permanent m\u00f6tesrum online. Du kan starta m\u00f6tet n\u00e4r som helst eller schemal\u00e4gga det till senare.",
    "meetings.fullPlanItem17": "V\u00e4rdkontroller",
    "meetings.fullPlanItem18": "Medanteckning vid sk\u00e4rmdelning",
    "meetings.fullPlanItem19": "Fj\u00e4rrstyrning av tangentbord och mus",
    "meetings.fullPlanItem21": "Multidelning",
    "meetings.fullPlanItem29": "V\u00e4ntrum",
    "meetings.fullPlanItem29Tip": "V\u00e4ntrumsfunktionen ger v\u00e4rden m\u00f6jlighet att kontrollera n\u00e4r deltagare ansluter till m\u00f6tet. Som m\u00f6tesv\u00e4rd kan du sl\u00e4ppa in deltagare en \u00e5t g\u00e5ngen eller alla samtidigt. I inst\u00e4llningarna kan du v\u00e4lja vem som placeras i v\u00e4ntrummet och vem som f\u00e5r \u00e5tkomst automatiskt. V\u00e4ntrumsfunktionen finns i alla konton. V\u00e4rdar kan skicka meddelanden till v\u00e4ntrummet. Om du har en betald plan kan du anpassa v\u00e4ntrummet.",
    "meetings.fullPlanItem41": "Inbyggt i Zoom for Home-enheter",
    "meetings.fullPlanItem61": "F\u00e4stfunktion f\u00f6r flera personer",
    "meetings.fullPlanItem61Tip": "V\u00e4rden kan ge upp till nio personer m\u00f6jlighet att f\u00e4sta videor f\u00f6r att skapa sin egen anpassade vy. S\u00e5 oavsett vem som talar f\u00f6rblir den f\u00e4sta videon synlig.",
    "meetings.fullPlanItem62": "Framh\u00e4v flera personer",
    "meetings.fullPlanItem62Tip": "V\u00e4rden kan framh\u00e4va upp till nio deltagares videor, s\u00e5 att alla i m\u00f6tet ser de framh\u00e4vda videorna oavsett vem som talar.",
    "meetings.fullPlanNewItem1": "Filter",
    "meetings.fullPlanNewItem1Tip": "Ta afterworken, festerna och andra sammankomster till n\u00e4sta niv\u00e5 med roliga f\u00e4rgfilter eller dekorativa djurdekaler.",
    "meetings.fullPlanNewItem2": "Genomf\u00f6ra en omr\u00f6stning",
    "meetings.fullPlanNewItem3": "Medv\u00e4rd och alternerande v\u00e4rd",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">L\u00e4s mer</a> om v\u00e5ra medv\u00e4rdskontroller f\u00f6r m\u00f6ten.",
    "meetings.fullPlanItem24": "Tilldela m\u00f6tesschemal\u00e4ggare",
    "meetings.fullPlanItem24Tip": "Ger dig m\u00f6jlighet att tilldela uppgiften att schemal\u00e4gga m\u00f6ten \u00e5t dig till n\u00e5gon annan. Den tilldelade personen m\u00e5ste ocks\u00e5 ha en Pro-plan.",
    "meetings.fullPlanItem25": "REST-API",
    "meetings.fullPlanItem25Tip": "Ger konto\u00e4gare, administrat\u00f6rer och dina utvecklare s\u00e4ker \u00e5tkomst till Zooms REST-API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">Gr\u00e4nsv\u00e4rden f\u00f6r API</a> till\u00e4mpas p\u00e5 kontoniv\u00e5 enligt <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">kontotyp</a> (Pro, F\u00f6retag, Enterprise osv.) och <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">typen av API-beg\u00e4ran</a> (l\u00e4tt, mellan, tung osv.). \u00c5tkomsten till vissa API:er \u00e4r begr\u00e4nsad till vissa kontotyper. Anv\u00e4nd <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">gr\u00e4nsv\u00e4rdena f\u00f6r API</a> och <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">referensdokumentationen f\u00f6r API</a> f\u00f6r fullst\u00e4ndig information.",
    "meetings.fullPlanItem25_pro": "Gr\u00e4nsv\u00e4rden f\u00f6r Pro REST-API",
    "meetings.fullPlanItem25_biz": "Gr\u00e4nsv\u00e4rden f\u00f6r REST-API",
    "meetings.fullPlanItem26": "Kompatibilitet med Skype f\u00f6r f\u00f6retag (Lync)",
    "meetings.fullPlanItem26Tip": "Ger anv\u00e4ndare av Lync 2010 och 2013 samt Skype f\u00f6r f\u00f6retag m\u00f6jlighet att initiera ett Zoom-m\u00f6te fr\u00e5n kontaktlistan i Lync.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Streama live till Facebook, Youtube eller en tredjepartstj\u00e4nst.",
    "meetings.fullPlanItem28": "Rapporter",
    "meetings.fullPlanItem28Tip": "Generera anv\u00e4ndningsrapporter f\u00f6r att ta reda p\u00e5 hur m\u00e5nga m\u00f6ten som h\u00e5lls, vilka dagar, antalet deltagare, antalet m\u00f6tesminuter och mer d\u00e4rtill.",
    "meetings.fullPlanItem30": "Anv\u00e4ndarhantering",
    "meetings.fullPlanItem30Tip": "\u00c4gare och administrat\u00f6rer kan l\u00e4gga till, radera och tilldela roller och till\u00e4ggsfunktioner.",
    "one.autoCaptions": "Automatiska undertexter",
    "meetings.fullPlanItem31": "Adminportal",
    "meetings.fullPlanItem31Tip": "Hantera anv\u00e4ndare i ditt f\u00f6retag med ett konto f\u00f6r f\u00f6renklad fakturering, avancerade inst\u00e4llningar f\u00f6r anv\u00e4ndarhantering och omfattande anv\u00e4ndningsinsikter, samlat i Zoom-adminportalen.",
    "meetings.fullPlanItem32": "LTI-integrering",
    "meetings.fullPlanItem32Tip": "Du kan enkelt l\u00e4gga till ett m\u00f6te till valfri kursaktivitet och bjuda in r\u00e4tt elever fr\u00e5n ditt utbildningshanteringssystem (kan anv\u00e4ndas med Moodle, Canvas, Desire2Learn och Blackboard).",
    "meetings.fullPlanItem33": "Avskrifter av inspelningar",
    "meetings.fullPlanItem33Tip": "Transkriptioner av molninspelningar \u00e4r ljudtranskriptioner d\u00e4r ljudet fr\u00e5n ett m\u00f6te eller webbinarium som du spelar in i molnet transkriberas. Observera att detta f\u00f6r n\u00e4rvarande enbart st\u00f6ds f\u00f6r engelska. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Klicka h\u00e4r</a> f\u00f6r att l\u00e4sa mer.",
    "meetings.fullPlanItem34": "Varum\u00e4rkesanpassning",
    "meetings.fullPlanItem34Tip": "L\u00e4gg till ditt f\u00f6retags logotyp till din egen anpassade sida d\u00e4r anv\u00e4ndarna kan g\u00e5 med i ett m\u00f6te. Skapa en varum\u00e4rkesanpassad e-postmall f\u00f6r att skicka inbjudningar till deltagare.",
    "meetings.fullPlanItem35": "Hanterade dom\u00e4ner",
    "meetings.fullPlanItem35Tip": "Anv\u00e4nd e-postadressdom\u00e4nen f\u00f6r ditt f\u00f6retag/universitet f\u00f6r att automatiskt l\u00e4gga till anv\u00e4ndare till ditt konto.",
    "meetings.fullPlanItem37": "Spr\u00e5ktolkning",
    "meetings.fullPlanItem37Tip": "Ger m\u00f6tesv\u00e4rdarna m\u00f6jlighet att utse tolkar under sina m\u00f6ten och webbinarier. N\u00e4r m\u00f6tesv\u00e4rden startar m\u00f6tet eller webbinariet kan hen aktivera tolkningsfunktionen, vilken ger tolkarna \u00e5tkomst till sina egna ljudkanaler. Deltagarna kan v\u00e4lja en ljudkanal f\u00f6r att h\u00f6ra det spr\u00e5k de f\u00f6redrar. Deltagarna h\u00f6r det \u00f6versatta spr\u00e5ket och kan v\u00e4lja om de vill h\u00f6ra ursprungsljudet p\u00e5 l\u00e4gre volym.",
    "meetings.fullPlanItem39": "Strategiska f\u00f6retagsm\u00f6ten",
    "meetings.fullPlanItem39Tip": "Detaljerade trendimplementeringsanalyser, ROI-sp\u00e5rning och diskussioner om produktf\u00e4rdplaner.",
    "meetings.fullPlanNewItem4": "Inkluderar Webinar 500",
    "one.translatedCations": "\u00d6versatta undertexter",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direkt-, kanal- eller gruppchatt",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Kommunicera enkelt med privata meddelanden, sm\u00e5 grupper eller stora team",
    "messageAndFileHistory": "Meddelande- och filhistorik",
    "findPeopeChannelsAndFilesInSearch": "Hitta personer, kanaler och filer i s\u00f6kningen",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Hitta snabbt kontakter, direktmeddelanden, gruppchattar och filer, och ha direkttillg\u00e5ng till kunskap och information",
    "applicationIntegrations": "Applikationsintegreringar",
    "secureFileSharing": "S\u00e4ker fildelning",
    "enhanceCollaborationWithSeamlessFileSharing": "F\u00f6rb\u00e4ttra samarbetet med smidig fildelning",
    "persistentMeetingChat": "Permanent m\u00f6teschatt",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Ha koll p\u00e5 alla samtal fr\u00e5n m\u00f6ten. Kommunicera f\u00f6re, under och efter ett m\u00f6te i en dedikerad gruppchatt i Zoom Team Chat f\u00f6r alla m\u00f6tesdeltagare.",
    "cloudStorage": "Molnlagring",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Bakkanaler till Zoom-molnet eller en lagringsleverant\u00f6r fr\u00e5n tredje part",
    "avatars": "Avatarer",
    "inMeetingReactions": "Reaktioner under m\u00f6ten",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Visa engagemang och kommunicera snabbt med andra deltagare utan att beh\u00f6va anv\u00e4nda ord",
    "virtualBackgrounds": "Virtuella bakgrunder",
    "videoFilters": "Videofilter",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "G\u00f6r m\u00f6tena roligare med ett brett utbud filter som l\u00e4ggs till i din video",
    "inMeetingPollsAndQuizzes": "Omr\u00f6stningar och quiz under m\u00f6ten",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Skapa omr\u00f6stningsfr\u00e5gor med valfritt antal svarsalternativ f\u00f6r dina m\u00f6ten.",
    "liveStreamingAcrossPlatforms": "Livestreaming p\u00e5 olika plattformar",
    "appearanceTouchUp": "Retuschering av utseende",
    "originalSoundForMusicians": "Originalljud f\u00f6r musiker",
    "endToEndEncryptionForZoomMeetings": "Totalstr\u00e4ckskryptering f\u00f6r Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "N\u00e4r Zooms totalstr\u00e4ckskryptering f\u00f6r Zoom Meetings \u00e4r aktiverad inneb\u00e4r det att kommunikationen mellan alla m\u00f6tesdeltagare som anv\u00e4nder Zoom-klienter i ett visst m\u00f6te krypteras med kryptografiska nycklar som enbart \u00e4r k\u00e4nda f\u00f6r dessa deltagares enheter. Det inneb\u00e4r att inga tredjeparter \u2013 inte heller Zoom \u2013 har tillg\u00e5ng till m\u00f6tets privata nycklar.",
    "zoomCustomerManagedKey": "Zoom-kundhanterad nyckel",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Anv\u00e4nd dina egna krypteringsnycklar f\u00f6r att skydda vilande Zoom-data",
    "enterpriseGradeSecurityFeatures": "S\u00e4kerhetsfunktioner i f\u00f6retagsklass",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bitars AES-GCM-kryptering f\u00f6r inneh\u00e5ll och media i realtid, TLS-kryptering under SIP-registrering, maskering av uppringar-ID, privat n\u00e4tverkspeering, verktyg f\u00f6r bedr\u00e4geriuppt\u00e4ckt och listor f\u00f6r samtalsblockering.",
    "phone.fullPlanItem40": "Enkel inloggning via SAML 2.0",
    "phone.fullPlanItem40Tip": "Med st\u00f6d f\u00f6r Microsoft Active Directory, Google, Ping, Okta och Centrify. Business-, Utbildning- eller Enterprise-konto kr\u00e4vs.",
    "phone.fullPlanItem1": "Obegr\u00e4nsade internationella samtal",
    "phone.fullPlanItem2": "Utg\u00e5ende samtal med m\u00e4tare",
    "phone.fullPlanItem3": "Obegr\u00e4nsade utg\u00e5ende samtal",
    "phone.fullPlanItem4": "Branschledande HD-samtalskvalitet",
    "phone.fullPlanItem4Tip": "Med aktiv brusreducering, ekoreducering och eliminering av tangentbordstryck",
    "phone.fullPlanItem5": "Nativa Windows-, MacOS- och Linux-skrivbordsappar",
    "phone.fullPlanItem6": "Nativa mobilappar f\u00f6r iOS och Android",
    "phone.fullPlanItem7": "Portera befintliga telefonnummer eller k\u00f6p nya (DID)",
    "phone.fullPlanItem8": "Avgiftsfria nummer",
    "phone.fullPlanItem9": "Telefonanknytningsnummer",
    "phone.fullPlanItem10": "R\u00f6stbrevl\u00e5da med transkription",
    "phone.fullPlanItem10Tip": "\u00c5tkomst till transkription fr\u00e5n r\u00f6stbrevl\u00e5da via mobil-/skrivbordsappar och e-post",
    "phone.fullPlanItem11": "Obgr\u00e4nsat antal automatiska deltagare/IVR",
    "phone.fullPlanItem12": "Uppringning via namnkatalog",
    "phone.fullPlanItem13": "Automatisk samtalsdistribuering (ACD) med samtalsk\u00f6",
    "phone.fullPlanItem14": "Intervenera/\u00f6vervaka/viska/ta \u00f6ver",
    "phone.fullPlanItem15": "Routning f\u00f6r helger och kontorstider",
    "phone.fullPlanItem16": "Ad hoc-konferenssamtal med trev\u00e4gsfunktion",
    "phone.fullPlanItem17": "Samtalsinspelning",
    "phone.fullPlanItem17Tip": "Automatisk och manuell samtalsinspelning \u00e4r tillg\u00e4nglig. Samtalsinspelning p\u00e5 heltid eller vid behov med transkriptioner",
    "phone.fullPlanItem18": "Konfigurerbar anonym och specifik samtalsblockering",
    "phone.fullPlanItem19": "N\u00f6dsamtal",
    "phone.fullPlanItem19Tip": "Ring lokala r\u00e4ddningstj\u00e4nster",
    "phone.fullPlanItem20": "Nomadic E911-adresser (USA och Kanada) \u2013",
    "phone.fullPlanItem20Tip": "Dynamisk funktion f\u00f6r identifiering av anv\u00e4ndarens plats och rapportering av motsvarande n\u00f6dadress till lokala r\u00e4ddningstj\u00e4nster (enbart USA och Kanada) och det interna s\u00e4kerhetsteamet",
    "phone.fullPlanItem21": "N\u00f6dinsatscenter",
    "phone.fullPlanItem21Tip": "Se till att ditt interna s\u00e4kerhetsteam meddelas vid n\u00f6dsamtal och kan spela in/\u00f6vervaka/intervenera i dem f\u00f6r att bidra till att samordna insatsen.",
    "phone.fullPlanItem22": "L\u00e4ge med delade linjer/delegering",
    "phone.fullPlanItem23": "Samtals\u00f6verf\u00f6ring mellan enheter",
    "phone.fullPlanItem24": "Samtalsparkering",
    "endToEndEncryptionForZoomPhone": "Totalstr\u00e4ckskryptering f\u00f6r Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "N\u00e4r Zooms totalstr\u00e4ckskryptering f\u00f6r Zoom Phone \u00e4r aktiverad inneb\u00e4r det att samtalet krypteras med kryptografiska nycklar som enbart \u00e4r k\u00e4nda f\u00f6r enheterna hos den som ringer och den som tar emot samtalet. Dessutom har anv\u00e4ndare m\u00f6jlighet att verifiera statusen f\u00f6r totalstr\u00e4ckskryptering genom att uppge en unik s\u00e4kerhetskod f\u00f6r varandra.",
    "phone.fullPlanItem43": "Automatisk etablering av telefoner",
    "phone.fullPlanItem44": "Kombinera olika typer av planer i ett konto",
    "phone.fullPlanItem46": "Kontrollpaneler i realtid f\u00f6r rapportering och kvalitet",
    "phone.fullPlanItem47": "St\u00f6d f\u00f6r milj\u00f6 med virtuellt skrivbord (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">L\u00e4s mer</a> om VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Tillg\u00e4ngligt f\u00f6r alla frist\u00e5ende telefonanv\u00e4ndare. Supportplanerna varierar n\u00e4r de kombineras med m\u00f6tesplaner.",
    "phone.fullPlanItem49": "St\u00f6d f\u00f6r Bring Your Own Carrier",
    "phone.fullPlanItem49Tip": "St\u00f6d f\u00f6r direkt och anl\u00e4ggningsbaserad peering till din befintliga PSTN-tj\u00e4nsteleverant\u00f6r",
    "phone.fullPlanItem50": "Hybridintegrering till \u00e4ldre PBX:er",
    "phone.fullPlanItem51": "Tryck för att tala",
    "phone.fullPlanItem61": "Fax online",
    "phone.fullPlanItem61Tip": "Skicka och ta emot obegränsat med fax inom USA och Kanada. <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">Se priser</a> för internationella fax",
    "phone.fullPlanSms": "Sms och mms",
    "phone.fullPlanSmsTip": "Tillg\u00e4ngligt f\u00f6r amerikanska, kanadensiska och australiensiska nummer enbart vid k\u00f6p av en samtalsplan. Tillg\u00e4ngligt f\u00f6r anv\u00e4ndning med direktnummer (inte f\u00f6retagsnummer).",
    "meetings.fullPlanItem6": "Teknisk support",
    "meetings.fullPlanItem6Tip": "Premier Support-paket finns tillg\u00e4ngliga f\u00f6r att bidra till att minimera risken och minska avbrott",
    "meetings.fullPlanItem6_basic": "Hj\u00e4lpcenter",
    "meetings.fullPlanItem6_pro": "\u00c4renden och livechatt",
    "meetings.fullPlanItem6_biz": "\u00c4renden, livechatt och telefon",
    "meetings.fullPlanItem6_ent": "\u00c4renden, livechatt och telefon",
    "knowledgeBase": "Kunskapsbas",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Fels\u00f6k tekniska problem och f\u00e5 \u00e5tkomst till supportresurser genom att s\u00f6ka i v\u00e5ra kunskapsbasartiklar.",
    "zoomCommunity": "Zoom-community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "En plats d\u00e4r du hittar l\u00f6sningar, st\u00e4ller fr\u00e5gor och samarbetar med andra Zoom-anv\u00e4ndare.",
    "chatbot": "Chattbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "F\u00e5 svar p\u00e5 fr\u00e5gor och fels\u00f6k tekniska problem genom att interagera med v\u00e5r chattbot.",
    "submitWebTickets": "Skicka webb\u00e4renden",
    "liveChatSupport": "Livesupport via chatt",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Abonnemang som \u00f6verstiger {amount}\u00a0USD per m\u00e5nad",
    "livePhoneSupport": "Livesupport via telefon",
    "meetWithAgentOnVideo": "Tr\u00e4ffa en agent via video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Abonnemang som \u00f6verstiger 200\u00a0USD per m\u00e5nad",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boosta produktiviteten genom att utnyttja dina favoritappar direkt i teamchatten",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Utforma din egen avatar f\u00f6r att g\u00f6ra m\u00f6tena roligare och leverera dynamiska presentationer utan att beh\u00f6va vara med p\u00e5 video",
    "enterprisePlusIncludesZoomSessions_1000": "Zoom Sessions 1\u00a0000 ing\u00e5r i Enterprise Plus*",
    "mail": "E-post",
    "common.plans.meeting.title": "Möten",
    "plans.basic_free.upgrade.item1": "Upp till 30 timmar per möte",
    "common.statistics.participants": "{0} Deltagare",
    "common.per_meeting_unit": "per möte",
    "common.participant_limit.increase_with_large_meetings": "Öka med Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Obegränsat antal",
    "common.plans.team_chat.title": "Teamchatt",
    "common.plans.mail_calendar.title": "E-post och kalender",
    "common.plans.cloud_storage.title": "Molnlagring",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Översatta undertexter",
    "common.plans.extras.title": "Extra fördelar",
    "common.plans.extras.desc": "hantera företagsdomäner med mera",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education, skolor och campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education Plus, skolor och campus",
    "per_billing_cycle_license.monthly": "/månad/licens",
    "per_billing_cycle_license.yearly": "/år/licens",
    "per_billing_cycle_space.monthly": "/månad/plats",
    "per_billing_cycle_space.yearly": "/år/plats",
    "common.dialog.feature_list": "Se lista över alla funktioner",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per licens",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per licens",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus inkluderar Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Rooms + anslutningsprogram för konferensrum (bildförhållande på 1:25)",
    "plans.whiteboard.ent": "Enterprise Plus inkluderar Unlimited Plus",
    "plans.zp.ent": "Ingår i Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Avancerad eller lokal reservering av arbetsplats med mera",
    "plans.largeMeeting.intro_tip": "Large Meeting kan läggas till valfritt i kassan och ger dig möjlighet att hålla i möten med upp till 500 eller 1 000 deltagare, beroende på vilken licens som köps.",
    "common.participant_limit.expandable_with_large_meetings": "Kan utökas med Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1\u00a0000 f\u00f6r Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus inkluderar Session 1000 (inkluderar Webinar)",
    "per_billing_cycle_user.monthly": "/månad/användare",
    "per_billing_cycle_user.annually": "/år/användare",
    "closeComparisonChart": "Stäng jämförelsetabell",
    "archiving_api": "Arkiverings-API",
    "dlp_api": "Dataskydds-API (DLP-API)",
    "info_barriers": "Informationshinder",
    "chat_etiquette": "Chattetikett",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regionala datacentraler",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Kryptering som standard",
    "end_to_end_encryption": "totalsträckskryptering",
    "cryptographic_boundary": "Kryptografisk gräns",
    "vdi": "Virtuellt skrivbord (VDI)",
    "customer_managed_key": "Kundhanterad nyckel",
    "gpo_msi_policies": "GPO/MSI-policyer",
    "msi": "Massdriftsättning (MSI)",
    "ntt": "Nätverkstestverktyg (NTT)",
    "dashboards": "Kontrollpaneler",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone-överlevnad",
    "zoom_meeting_survivability": "Zoom Meetings-överlevnad",
    "paid_option": "Betalt alternativ",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Skola och campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "Skola och campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "tr-TR": {
    "billing.essential_apps": "Temel Uygulamalar",
    "billing.essential_apps.dialog_desc": "Toplantı notları almanızı, interaktif aktiviteler sayesinde ekibinizle etkileşim kurmanızı ve müşteri konuşmalarına yönelik analizler elde etmenizi sağlayacak uygulamalarla işinizi büyütün ve yönetin. Ücretsiz premium uygulamalar, 1 yıl süreyle planınıza eklenir.",
    "billing.see_more_details": "Daha fazla bilgi edinin",
    "billing.essential_app.legal_copy": "Teklif yalnızca, 4 Ocak 2023 tarihi itibariyle veya sonrasında, Zoom'un zoom.us/buy sayfasındaki çevrim içi kanalı üzerinden alınmış bir Zoom One Pro, İşletme veya İşletme Plus lisansına sahip kullanıcılar için geçerlidir. Abonelikleri Sağlık, Eğitim veya Devlet hesaplarıyla ilişkilendirilmiş kullanıcılar bu tekliften yararlanamaz.  Coda dışındaki tüm uygulamalar, bireysel kullanıcının uygulamayı etkinleştirmesiyle erişime açılır. Erişimin süresi aktivasyon tarihinden 1 yıl sonra sona erer. Coda uygulaması, aynı Zoom hesabındaki bir kullanıcının Coda'yı ilk kez etkinleştirmesiyle birlikte aynı Zoom hesabındaki tüm kullanıcılar için erişime açılır. Aynı Zoom hesabında olup uygulamayı sonradan etkinleştiren diğer kullanıcıların hangi tarihte etkinleştirdiğine bakılmaksızın, erişiminin süresi ilk etkinleştirme tarihinden 1 yıl sonra tüm kullanıcılar için sona erer.Tüm uygulamalar için geçerli olmak üzere bir kullanıcının uygun lisansının veya aboneliğinin yeniden atanması ya da iptal edilmesi, 1 yıllık erişim süresinin sona erip ermediğine bakılmaksızın, bu kullanıcının erişimini sonlandırır.Tüm uygulamalar, etkinleştirildikleri dönemde geçerli olan kendi kullanım şartlarına ve gizlilik politikalarına tabidir.Temel uygulama kapsamındaki uygulamalar yalnızca İngilizce için desteklenir.Tüm uygulamalar mobil cihazlarda çalışmaz.Teklif, nakde çevrilmek üzere geri ödenemez veya iadesi yapılamaz.Teklif yalnızca <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace'teki</a> Temel Uygulamalarda listelenen bu uygulamalar için geçerlidir.Zoom, önceden haber vermeden ve herhangi bir yükümlülüğü olmadan, istediği zaman bu teklifi değiştirme veya iptal etme hakkını saklı tutar.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Ziyaretçi Yönetimi"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "7/24 Canlı Sohbet ve Telefon Desteği"
      },
      "learn_more": "Daha Fazla Bilgi",
      "new": "YENİ",
      "plan_details": {
        "meeting": {
          "title": "Toplant\u0131lar",
          "host_meeting_up_to_participants": "{0} katılımcıya kadar toplantı düzenleme",
          "meeting_hours": "Nieograniczona liczba spotkań do 30 godzin na spotkanie",
          "recording_storage": "Kayıt için {0} GB bulut depolama alanı (lisans başına)",
          "auto_captions": "Otomatik alt yazılar"
        },
        "whiteboard": {
          "title": "Beyaz Tahta",
          "boards_storage": "{0} adet düzenlenebilir tahta",
          "standard_features": "Standart özellikler"
        },
        "team_chat": {
          "title": "Ekip Sohbeti",
          "desc": "Grup sohbeti ve dosya paylaşımı"
        },
        "main_calendar": {
          "title": "E-posta ve Takvim",
          "desc": "E-posta ve Takvim İstemcisi ve Hizmetleri"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Zoom'da düzenlenebilir belgeler oluşturun ve paylaşın",
          "desc2": "Zengin metin düzenleme özellikli, kişisel ve iş birliğine uygun notlar"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Kolaylıkla kısa formlu videolar kaydedin, düzenleyin ve paylaşın",
          "desc2": "Sınırsız videolar ve gelişmiş özellikler"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Toplantı özetleri ve mesaj yazma yardımı gibi çok sayıda özelliğe hızlı erişim elde edin"
        },
        "EssentialApp": {
          "title": "Temel Uygulamalar",
          "desc1": "1 yıl boyunca ücretsiz kullanabileceğiniz premium uygulamalar (şartlar geçerlidir)",
          "desc2": "Ekip iş birliğinizi ve üretkenliğinizi artırın"
        },
        "livechat": {
          "title": "Canlı sohbet desteği"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Zoom Workplace Pro'ya mı geçiyorsunuz?",
            "content": "Daha önce toplantı başına 300 katılımcıya kadar izin veren Zoom Workplace İşletme'yi, Zoom Scheduler'ı ve daha fazlasını seçtiniz. Yine de Pro'ya geçmek istiyor musunuz?",
            "confirm": "Değişikliği Onayla",
            "keep_current": "Mevcut Planı Koru"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} rolsüz katılımcı",
          "participants": "{0} Katılımcılar",
          "user_range": "{0}-{1} kullanıcı",
          "items": "{num} öge"
        },
        "button": {
          "ok": "OK",
          "add": "Ekle",
          "buy_now": "Hemen Satın Al",
          "try_for_days": "{0} gün deneyin",
          "contact_sales": "Satış Birimine Ulaşın",
          "close": "Kapat",
          "cancel": "İptal",
          "edit": "Düzenle",
          "got_it": "Anladım"
        },
        "title": {
          "everything_in_and": "{0} planındaki her şeyin yanı sıra şunları içerir:"
        },
        "tag": {
          "new": "YENİ",
          "free_trial": "Ücretsiz Deneme"
        },
        "billing_cycle": {
          "annual": "Yıllık",
          "monthly": "Aylık",
          "quarterly": "Üç Aylık",
          "two_years": "İki Yıl",
          "three_years": "Üç Yıl"
        },
        "errors": {
          "unknown_error_try_again": "İşlemin gerçekleştirilmesi sırasında bilinmeyen hata. Lütfen daha sonra yeniden deneyin."
        },
        "excluding_tax": {
          "vat_tip": "KDV hariç",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Sınırlı özellikler",
        "pro_plus": {
          "host_meeting_up_to_participants": "{0} katılımcıya kadar toplantı düzenleme",
          "gb_of_cloud_recording_storage": "Lisans başına {0} GB'lik buluta kayıt depolama alanı",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "İçerik üretimi ve çevirisi için AI Companion",
            "features_item2": "Ekibinizle sınırsız sayıda ortak doküman",
            "features_item3": "Sürüm geçmişine sınırsız erişim",
            "comparison_table_tips": "Toplantı içeriğini eyleme dönüştürülebilir belgelere, wiki'lere ve projelere dönüştüren yapay zeka odaklı dokümanlarla iş birliğini güçlendirin"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Temel",
            "features_item1": "Toplantılarınız, çağrılarınız, sohbetleriniz ve dokümanlarınızdaki görevleri otomatik olarak tespit edin",
            "features_item2": "Takip toplantıları planlamak ve belge hazırlamak gibi görevlerin tamamlanması konusunda yardım alın",
            "features_item3": "Kaydettiğiniz ilerlemeyi takip etmek ve sıradaki işlere odaklanmak için görevlerinizi tamamlandı olarak işaretleyin",
            "features_item4": "Zoom Docs da dahil olmak üzere Zoom Workplace platformundaki görevleri yönetin",
            "features_item1_opc": "Sohbetlerinizden, e-postalarınızdan, dokümanlarınızdan, beyaz tahtalarınızdan ve toplantı özetlerinizden görevleri belirlemek ve oluşturmak için AI Companion'ın gücünden yararlanın",
            "features_item2_opc": "Kolayca sıralama, filtreleme, gruplama ve arama yaparak görevlerinize hızlıca erişip bağlam toplayın",
            "learn_more_header": "Zoom Workplace'te daha fazlasını yapmak için AI Companion* ile eylem öğeleriniz hakkında bilgi sahibi olun.",
            "learn_more_footer": "\*AI Companion yalnızca Zoom Workplace Pro, İşletme ve Kurumsal planları için kullanılabilir.",
            "features_prefix": "AI Companion size aşağıdakileri yapmak için yardım eder:",
            "comparison_table_tips": "Zoom Workplace'teki görüşmelere ve toplantı özetlerine dayanan görev önerileri sağlayan yapay zeka odaklı bir çözüm aracılığıyla eylem öğelerini takip edin ve zamanında tamamlayın.",
            "tasks_label_text": " Yapay zeka odaklı görev yönetimi"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Fiyatlandırma bilgisi ve daha fazlası için bize ulaşın",
          "contact_sales": "Sat\u0131\u015F Birimine Ula\u015F\u0131n",
          "meetings": "Toplant\u0131lar",
          "phone": "Telefon",
          "phone_sub_title": "S\u0131n\u0131rs\u0131z \u00C7a\u011Fr\u0131",
          "use_only": "Yalnızca işletme kullanımı içindir",
          "team_chat": {
            "title": "Ekip Sohbeti",
            "title_desc": "Grup sohbeti ve dosya paylaşımı"
          },
          "cloud_storage": {
            "title": "Bulut Depolaması"
          },
          "mail_calender": {
            "title": "E-posta ve Takvim"
          },
          "beta": "Beta",
          "client_service": {
            "title": "İstemci ve hizmet"
          },
          "up_to_30_hours_per_meeting": "do 30 godzin na spotkanie",
          "300_attendees": "300 katılımcı",
          "per_meeting": "toplantı başına",
          "whiteboard": {
            "title": "Beyaz Tahta"
          },
          "new": "YENİ",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Ek özellikler",
          "sso_managed_domains_more": "SSO, yönetilen alanlar ve daha fazlası",
          "scheduler": "Takvim planlayıcısı",
          "global_select": "Global Select",
          "unlimited_regional": "Sınırsız bölgesel",
          "translated_captions": "Çevrilen Alt Yazılar",
          "workspace_reservation": "Çalışma Alanı Rezervasyonu",
          "auto_translated_captions": "Otomatik ve Çevrilen Alt Yazılar",
          "unlimited_editable_boards": "Sınırsız sayıda düzenlenebilir tahta",
          "standard_features": "Standart özellikler",
          "advanced_docu_controls": "Gelişmiş belge kontrolleri",
          "chats_channels_for_collaboration": "İş birliği için sohbet ve kanallar, dosya paylaşımı ve daha fazlası",
          "zoom_phone_is_biz_use_only": "Zoom Phone yalnızca iş amaçlı kullanım içindir",
          "unlimited_regional_calling": "S\u0131n\u0131rs\u0131z B\u00F6lgesel \u00C7a\u011Fr\u0131",
          "domestic_sms_mms": "Yurt i\u00E7i SMS ve MMS",
          "automatic_call_distribution_groups": "\u00C7a\u011Fr\u0131 kuyru\u011Fa alma \u00F6zellikli otomatik \u00E7a\u011Fr\u0131 da\u011F\u0131t\u0131m gruplar\u0131 (ACD)",
          "single_sign_on": "\u00C7oklu oturum a\u00E7ma",
          "managed_domains": "Y\u00F6netilen etki alanlar\u0131",
          "company_branding": "\u015Eirket markalama",
          "mail_calender_client_services_beta": "E-posta ve Takvim İstemcisi ve Hizmetleri beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Nieograniczona liczba spotkań do 30 godzin na spotkanie",
          "mail_and_calendar_client_and_services_beta": "E-posta ve Takvim İstemcisi ve Hizmetleri beta",
          "easily_record_edit_share_videos": "Kolaylıkla kısa formlu videolar kaydedin, düzenleyin ve paylaşın",
          "unlimited_videos_advanced_features": "Sınırsız videolar ve gelişmiş özellikler",
          "create_share_editabel_docu_within_zoom": "Zoom'da düzenlenebilir belgeler oluşturun ve paylaşın",
          "personal_collaborative_notes_rich_text_editing": "Zengin metin düzenleme özellikli, kişisel ve iş birliğine uygun notlar",
          "effortlessly_share_meeting": "Kolay rezerve için toplantı alanlarını zahmetsizce paylaşın",
          "works_with_zoom_meeting_mail_calender_google_ms": "Zoom Meetings, Zoom Mail ve Calendar, Google ve Microsoft 365 ile çalışır",
          "up_to_300_attendees": "En fazla 300 katılımcı",
          "10_gb_of_storage": "10 GB Depolama Alanı",
          "host_meeting_up_to_300_participants": "300\u2019e kadar kat\u0131l\u0131mc\u0131 ile toplant\u0131 d\u00FCzenleyin",
          "10_gb_of_cloud_recording_storage": "Kayıt için 10 GB bulut depolama alanı (lisans başına)",
          "starting_at_licenses_year": "{0}/y\u0131l kar\u015F\u0131l\u0131\u011F\u0131nda {1} lisanstan ba\u015Flar",
          "starting_at_licenses_month": "{0}/ay kar\u015F\u0131l\u0131\u011F\u0131nda {1} lisanstan ba\u015Flar",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Toplantı özetleri ve mesaj yazma yardımı gibi çok sayıda özelliğe hızlı erişim elde edin",
          "learn_more": "Daha Fazla Bilgi",
          "essential_apps": "Temel Uygulamalar",
          "increase_team_collaboration": "Ekip iş birliğinizi ve üretkenliğinizi artırın",
          "free_premium_apps": "1 yıl boyunca ücretsiz kullanabileceğiniz premium uygulamalar (şartlar geçerlidir)",
          "visitor_management": "Ziyaretçi Yönetimi",
          "visitor_management_custom_invites": "Davetleri özelleştirin",
          "visitor_management_visitor_check": "Kiosktan giriş yapın",
          "visitor_management_receive_detailed": "Ziyaretçilerin alan kullanımıyla ilgili ayrıntılı ölçümleri alın"
        },
        "custom_avatar": {
          "title": "Özel Avatar",
          "label_text": "3 dakika / ay",
          "basic_feature": "Ömür başına 1 dakika",
          "pricing_feature": "3 dakika / ay",
          "learn_more_subtitle": "Ses kopyalama ve çok dilli iletişim ile kendinizin gerçekçi bir yapay zeka versiyonunu oluşturun.",
          "features_item1": "Her ay sunumlar ve demolar için görünüşünüzü ve sesinizi taklit eden 3 adede kadar gerçekçi dijital avatar oluşturun",
          "features_item2": "Avatarınızı kullanarak AI Companion ile 3 dakikaya kadar uzunlukta metinler sunun",
          "features_item3": "Hızlı ve yüksek kaliteli video oluşturmak için önceden tasarlanmış 18 avatar arasından seçim yapın",
          "features_item4": "Sanal arka plan desteğinin keyfini çıkarın",
          "features_item1_opc": "Her ay sunumlar ve demolar için görünüşünüzü ve sesinizi taklit eden 3 adede kadar gerçekçi dijital avatar oluşturun",
          "features_item2_opc": "Avatarınızı kullanarak AI Companion ile 3 dakikaya kadar uzunlukta metinler sunun",
          "comparison_table_tips": "Özel Avatar; ses kopyalama ve çok dilli iletişim ile yapay zeka ile üretilmiş gerçekçi bir versiyonunuzu oluşturur."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Toplantı özetleri ve mesaj yazma yardımı gibi çok sayıda özelliğe hızlı erişim elde edin",
        "learn_more_dialog": {
          "desc": "AI Companion ile daha fazlasını yapın! İçerik yazabilir, toplantılarınızı planlayabilir, projelerinizi yönetmeye yardımcı olabilir ve daha fazlasını yapabilir.",
          "tip1": "Daha etkili toplantılar düzenleyebilmeniz için önceden gündem alın",
          "tip2": "Otomatik görev oluşturma ve bildirimlerle projelerinizi takip edin",
          "tip3": "Takviminizi düzenleme ve zamanınızı yönetme konusunda yardım alın",
          "tip4": "Docs, Whiteboard veya Zoom Workplace uygulamasında tarzınıza uygun yazılı ve görsel içerikler oluşturun"
        },
        "top_features": "En Popüler Özellikler",
        "more_to_come": "Daha fazla inanılmaz özellik eklenecek!",
        "discover_more": "AI Companion ile en iyi işinizi yapmanın daha da fazla yolunu keşfedin!",
        "detail_desc": "AI Companion hiçbir ek ücret olmaksızın Zoom kullanıcı hesaplarındaki ücretli hizmetlere dahildir. Belirli dikey pazarlar ve ülkelerde hariç tutulabilir."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/yıl/lisans",
        "month_licnese": "/ay/lisans",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/ay",
          "per_year": "/yıl"
        },
        "unit": {
          "license": "{0}/lisans",
          "user": "{0}/kullanıcı"
        },
        "learn_more": "Daha Fazla Bilgi",
        "required": "Zorunlu",
        "zoom_one_required": "Zoom Workplace Gereklidir",
        "large": {
          "features_tip": "Katılımcı kapasitenizi 1.000 katılımcıya kadar artırarak erişim alanınızı genişletin.",
          "label_title1": "500 Rolsüz Katılımcı",
          "label_title2": "1000 Rolsüz Katılımcı"
        },
        "cmr": {
          "features_tip": "Video kayıtlarınızı doğrudan Zoom Bulut'ta depolayın, buluttan indirin ve yayınlayın.",
          "explain_desc": "Bulut depolama, belirli Zoom One planlarına dahildir: Pro (5 GB), İşletme (5 GB), İşletme Plus (10 GB) ve Kurumsal (Sınırsız)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 saat",
          "option_label2": "≈ 650 saat",
          "option_label3": "≈ 3,500 saat",
          "option_label4": "≈ 17,500 saat",
          "intro_label2": "Depolama seçeneklerine aylık 5 TB'ye varan depolama alanı dahildir",
          "tooltip_content": "Kayıt depolama alanı video özellikli katılımcıların sayısına, toplantının çözünürlüğüne ve paylaşılan içerik çözünürlüğüne göre değişir."
        },
        "whiteboard": {
          "plus_title": "Beyaz Tahta Artı",
          "title": "Whiteoard",
          "features_tip": "Beyaz tahtalar sayesinde hem toplantılar sırasında hem de toplantı dışı zamanlarda başkalarıyla gerçek zamanlı olarak iş birliği yapın.",
          "explain_desc": "Zoom One İşletme, Zoom One İşletme Plus ve Zoom One Kurumsal kullanıcıları için dahildir",
          "explain_desc_plus": "Zoom One Kurumsal Plus paketine ve her bir Zoom Rooms aboneliğine dahildir",
          "option_label1": "1 GB Bulut Depolama Alanına sahip sınırsız sayıda tahta",
          "option_label2": "Sınırsız sayıda tahtaya ve Bulut Depolama Alanına sahip gelişmiş özellikler",
          "intro_label1": "Aynı anda düzenlenebilen sınırsız sayıda beyaz tahta",
          "intro_label2": "Standart özellikler ve gelişmiş belge kontrolü",
          "intro_label3": "Özel veya organizasyonel şablonlar ve üçüncü taraf entegrasyonları gibi gelişmiş beyaz tahta özellikleri"
        },
        "translated_captions": {
          "features_tip": "Tercih ettiğiniz dildeki otomatik alt yazılar sayesinde global iş birliğini mümkün kılın.",
          "intro_label1": "Katılımcılar, alt yazıları kendileri etkinleştirebilir ve dili kendileri değiştirebilir.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Desteklenen dilleri görüntüle"
        },
        "crc": {
          "features_tip": "Etkin bir hibrit çalışma için standart tabanlı herhangi bir SIP/H.323 video konferans uç noktasını etkinleştirir.",
          "intro_label1": "Polycom, Cisco ve Lifesize gibi birçok eski uç noktayla çalışabilir",
          "intro_label2": "Bulut tabanlı veya yerinde (VM) oda bağlayıcısı"
        },
        "scheduler": {
          "simplify_bookings": "Esnek uygunluk ve özelleştirilebilir zaman dilimleri ile rezervasyonları basitleştirin",
          "host_one_on_one": "Kolay paylaşım için tek bir bağlantı ile bire bir veya grup toplantıları düzenleyin",
          "customize_reminders": "Kaçırılan randevuları azaltmak için e-posta/SMS yoluyla hatırlatmaları özelleştirin",
          "sync_calendars": "Takvimleri Google, Microsoft 365 ve Zoom entegrasyonları ile sorunsuz bir şekilde eşitleyin",
          "features_tip": "Çalışma saatleri, görüşmeler ve daha fazlası için toplantı alanlarını zahmetsizce paylaşın.",
          "intro_label1": "Takvim Entegrasyonu",
          "intro_label2": "Yinelenen Uygunluk",
          "intro_label3": "Ölçeklenebilir Toplantı",
          "intro_label4": "Özelleştirilebilir Bildirimler",
          "intro_sub_label1": "Google, Microsoft 365 ve Zoom ",
          "intro_sub_label2": "rezerve edilebilir zaman dilimlerini paylaşın ",
          "intro_sub_label3": "bir veya birden fazla katılımcı için tek toplantı",
          "intro_sub_label4": "e-posta veya SMS hatırlatıcılarını ve onaylarını otomatikleştirin"
        },
        "zoom_clips_plus": {
          "features_tip": "Yüksek kalitede, kısa video mesajları kaydedin, düzenleyin ve paylaşın.",
          "intro_label1": "Zaman kısıtlaması olmayan sınırsız videolar hazırlayın",
          "intro_label2": "Ekranınızın ve videonuzun görüntüsünü birlikte veya ayrı olarak yakalayın",
          "intro_label3": "Videonuzu istediğiniz gibi kırpın ve bağlantısını paylaşın",
          "intro_label4": "Sesli dökümler ve istatistikler gibi gelişmiş özelliklere erişin",
          "explain_desc": "Clips Plus, Workplace Pro, İşletme ve Kurumsal aboneliklerine dahildir. Fiyatlandırma sayfasındaki karşılaştırma bölümünden her planın farklı özelliklerini keşfedebilirsiniz."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Güçlü kayıt ve ağ oluşturma özelliklerine sahip gelişmiş bir etkinlik platformudur. Hem sanal hem hibrit deneyimler için idealdir.",
          "tooltip_content": "Seçilen kapasitede sınırsız sayıda web semineri veya etkinliğe ev sahipliği yapın",
          "intro_title": "Sessions'daki Her Şey",
          "intro_label1": "Çoklu oturum etkinlikleriyle kitle etkileşimini güçlendirin",
          "intro_label2": "Özel bilet ve mobil uygulama ile etkinliklere kolayca ev sahipliği yapın",
          "intro_label3": "Expo Floor ve Sponsor alanıyla etkinlik gelirini artırın",
          "intro_label4": "Özelleştirilebilir profillerle katılımcı ağı oluşturmayı destekleyin",
          "intro_label5": "Etkinlik Lobisinde isteğe bağlı görüntülemeyle erişimi genişletin",
          "intro_label6": "Özel olarak hazırlanmış etkinlik şablonlarıyla etkinlik kurulumunu hızlandırın",
          "events_feature_item1_20240827": "Birden fazla parça içeren çok günlük sanal etkinlikler düzenleyin",
          "events_feature_item2_20240827": "Katılımcı profilleri ve lobi sohbeti ile ağ oluşturmayı teşvik edin",
          "events_feature_item3_20240827": "Lobi oturumu akışı ile katılımcılara rehberlik edin",
          "events_feature_item4_20240827": "Expo floor ve sponsorlarla etkinlik gelirini artırın",
          "events_feature_item5_20240827": "Konferans sonrası anketlerle ileride düzenlenecek etkinlikleri iyileştirin",
          "events_feature_item6_20240827": "Özel olarak hazırlanmış etkinlik şablonlarıyla etkinlik kurulumunu hızlandırın",
          "attendees_start_at": "{0} katılımcı için:",
          "explain_desc": "Zoom Events hakkında daha fazlasını keşfedin",
          "contact_account_owner": "Events satın almak istiyorsanız lütfen <a href=\"/account\" target=\"_blank\">hesap sahibi ile iletişime geçin</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Etkinlik markalama, çoklu oturum sahibi iş birliği ve etkinlik yönetimi gibi özelliklerle interaktif tek oturumlu etkinlikleri kolaylaştırın.",
          "tooltip_content": "Seçilen kapasitede sınırsız sayıda web semineri veya etkinliğe ev sahipliği yapın",
          "intro_title": "Zoom Webinars dahildir",
          "intro_label1": "Etkileyici bir marka algısı oluşturmak için açılış sayfalarını özelleştirin",
          "intro_label2": "Markalı e-postalarla etkinlikleri öne çıkarın",
          "intro_label3": "İnteraktif panoyla performans ölçümü yapın",
          "intro_label4": "Ortak oturum sahipleriyle ve yardımcı editörlerle sorunsuz iş birliği yapın",
          "intro_label5": "Profesyonel etkinlik araçları: Simulive",
          "sessions_feature_item1_20240827": "Özel sahneler ve markalama ile web seminerlerini geliştirin",
          "sessions_feature_item2_20240827": "Mesaj ve görsel oluşturmak için AI Companion ile etkinlik planlamasını kolaylaştırın",
          "sessions_feature_item3_20240827": "Markalanmış içerik merkezi ile geçmiş ve gelecek etkinlikleri tanıtın",
          "sessions_feature_item4_20240827": "Sahne arkası, Simüle-canlı ve RTMP ile profesyonel etkinlikler düzenleyin",
          "sessions_feature_item5_20240827": "Etkinlikler arası iç görülerle ileride düzenlenecek web seminerlerini iyileştirin",
          "explain_desc": "Zoom Sessions hakkında daha fazlasını keşfedin",
          "contact_account_owner": "Sessions satın almak istiyorsanız lütfen <a href=\"/account\" target=\"_blank\">hesap sahibi ile iletişime geçin</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Web Semineri",
          "features_tip": "Kullanıcı dostu bir web semineri platformu üzerinden mesajlarınızı zahmetsizce yayımlayın.",
          "tooltip_content": "Seçilen kapasitede sınırsız sayıda web semineri veya etkinliğe ev sahipliği yapın",
          "intro_label1": "Yüksek kaliteli video web yayınlarıyla izleyicinin ilgisini çekin",
          "intro_label2": "Soru-Cevap, anket yapma ve reaksiyonlarla etkileşimi artırın",
          "intro_label3": "Etkinlik sonrası raporlama ile web semineri stratejinizi geliştirin",
          "intro_label4": "100.000 katılımcı ve 100 panelisti destekler",
          "monthly_subscription": "Aylık Abonelik",
          "annual_subscription": "Yıllık Abonelik",
          "one_million": "1 Milyon",
          "single_use": "Tek Kullanımlık",
          "one_month": "Bir Ay",
          "event_attendee": "Etkinlik/Oturum rolsüz katılımcıları:",
          "event_attendee_desc": "Merkezde lisanslı bir oturum sahibi olmadan katılan herkes. Özel roller de rolsüz katılımcı olarak sayılır ve ses, video ve ekran paylaşımı (etkinleştirilmişse) ile katılabilir.",
          "webinar_attendee": "Web semineri katılımcıları:",
          "webinar_attendee_desc": "Katılım sağlayan ancak sunucu veya panelist olmayan herkes. Bu kişiler yalnızca görüntüleme modundadır. Seslerini açabilen, Soru-Cevap ve sohbet yoluyla etkileşimi etkinleştirebilen oturum sahibi tarafından kontrol edilirler.",
          "pay_per_attendee": "Rolsüz Katılımcı Başına Ödeme",
          "attendees": "rolsüz katılımcı"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Yapay zekâ destekli iş birliği platformunuz sayesinde ekiplerinizin çalışma biçimini yeniden tasarlayın.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace İşletme",
          "label_title4": "Workplace İşletme Plus",
          "intro_label1": "En fazla 100 katılımcı ile 30 saate kadar sınırsız toplantı düzenleyin",
          "intro_label2": "Standart özelliklere sahip 3 adet düzenlenebilir beyaz tahtaya aynı anda erişin",
          "intro_label3": "Clips Plus ile yüksek kalitede kısa video mesajları kaydedin, düzenleyin ve paylaşın.",
          "intro_label4": "Zoom AI Companion ile işlerinizi daha verimli bir şekilde tamamlayın",
          "intro_label5": "Zoom Phone Amerika ve Kanada Sınırsız (BYOC, PBX ve üçüncü taraf PBX dahil değildir)",
          "intro_label6": "300'e kadar katılımcı ile 30 saate kadar sınırsız toplantı düzenleyin",
          "intro_label7": "Zoom Scheduler'ı kullanarak ofis çalışma saatleri, görüşmeler ve daha fazlası için toplantı zaman dilimlerini paylaşın",
          "intro_label8": "Zoom Phone Amerika ve Kanada Sınırsız",
          "intro_label8_UK": "Zoom Phone Birleşik Krallık ve İrlanda Sınırsız",
          "intro_label8_AU": "Zoom Phone Avustralya ve Yeni Zelanda Sınırsız",
          "intro_label8_JP": "Zoom Phone Japonya Sınırsız",
          "intro_label9": "Ziyaretçi Yönetimi",
          "intro_label10": "Ek Özellikler",
          "intro_label11": "Canlı sohbet desteği",
          "intro_title1": "Pro planındaki her şeyin yanı sıra şunları içerir:",
          "intro_title2": "İşletme planındaki her şeyin yanı sıra şunları içerir:",
          "intro_label_tip1": "Pro Plus planındaki Zoom Phone, BYOC, üçüncü taraf PBX ve VDI özelliklerine sahip değildir. Daha fazla bilgi için lütfen Zoom Phone fiyatlandırma sayfasına bakın.",
          "intro_label_tip2": "Ödeme sırasında ABD ve Kanada, Avustralya ve Yeni Zelanda, İngiltere ve İrlanda veya Japonya için Sınırsız Bölgesel Çağrı özelliğini seçebilirsiniz.",
          "intro_label_tip3": "Ek özellikler arasında 10 GB Bulut Depolama Alanı, Çevrilmiş Alt Yazılar ve Çalışma Alanı Rezervasyonları bulunur.",
          "intro_label_tip4": "Pro Plus planındaki Zoom Phone, BYOC, üçüncü taraf PBX ve VDI özelliklerine sahip değildir. Daha fazla bilgi için lütfen Zoom Phone fiyatlandırma sayfasına bakın."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Çağrı merkezi ekipleri için gelişmiş çağrı kuyruğu analizi ve geçmiş hakkında içgörüler.",
          "intro_label1": "Çağrı işlemeyi kolaylaştırmak için genişletilmiş kişi penceresi",
          "intro_label2": "Otomatik Resepsiyonist ve Çağrı Kuyruğu telefon numaraları"
        },
        "international_calling": {
          "title": "Uluslararası Arama",
          "features_tip": "15’ten fazla ülke ve bölge için sınırsız uluslararası çağrı.",
          "intro_label1": "Sınırsız çağrı planlarından herhangi biriyle birlikte satın alınabilir",
          "intro_label2": "Sınırsız uluslararası arama için desteklediğimiz ülke ve bölgelerin listesini inceleyin.",
          "intro_labe2_tooltip": "ABD, Kanada, İngiltere, İrlanda, Avustralya, Yeni Zelanda, Avusturya, Danimarka, Fransa, Almanya, İtalya, Portekiz, İspanya, İsveç, Belçika, Hollanda, İsviçre, Porto Riko, Japonya.",
          "intro_label2_view_list": "Listeyi Görüntüle"
        },
        "workspace_reservation": {
          "title": "Çalışma Alanı Rezervasyonları",
          "intro_title": "Zoom'a entegre cihazlarla esnek çalışma alanlarını kolayca rezerve edin veya otel odalarını önceden veya yerinde ayırtın.",
          "intro_label1": "Masaüstündeki veya tarayıcıdaki Zoom Workplace uygulaması üzerinden çalışma alanı ve otel rezervasyonlarına erişin",
          "intro_label2": "Yapay zeka yardımıyla kişiselleştirilmiş masa önerileri alın",
          "intro_label3": "Çalışma alanlarını hatırlatıcılar ve giriş uyarıları ile doğrudan Google Takvim veya Outlook'tan rezerve edin",
          "intro_label4": "Yön bulma ile ayrılmış çalışma alanlarına gidin"
        },
        "visitor_management": {
          "title": "Ziyaretçi Yönetimi",
          "intro_title": "Özel davetler, sorunsuz kiosk girişleri, raporlama ve ölçümlerle ziyaretçi girişlerini kolaylaştırın.",
          "intro_label1": "Zoom portalında davetiyeleri, ziyaretçi konumlarını ve ziyaret geçmişini yönetin",
          "intro_label2": "Misafir varış bildirimlerini alırken davetiyeleri oluşturun, takip edin, yeniden gönderin ve silin",
          "intro_label3": "Sorunsuz bir ziyaretçi deneyimi için formları doldurun, yol tarifi alın ve kiosk üzerinden check-in yapın",
          "intro_label4": "Kolay yönetim için tanıdık Zoom portalındaki tüm özelliklere erişin"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Büyük Toplantı",
          "description1": "1000'e kadar canlı ve etkileşimli katılımcıyı desteklemek için toplantı kapasitesini artırın",
          "description2": "Tüm katılımcılar seslerini, videolarını ve ekranlarını paylaşabilir"
        },
        "cloud_storage": {
          "title": "Bulut depolama",
          "description2": "MP4 veya M4A dosya biçimleri kullanılabilir"
        },
        "translated_captions": {
          "title": "Çevrilen Alt Yazılar",
          "description1": "Katılımcıların desteklenen bir dili etkinleştirmesine ve bu dile geçmesine olanak tanıyan otomatik, çok dilli alt yazılarla toplantıları geliştirin",
          "description2": "Zoom Meetings ve Webinars'a Uygun"
        },
        "tollfree": {
          "title": "Sesli Konferans Seçenekleri",
          "subcontent": "Dünyanın dört bir yanından telefon numaralarıyla arayarak toplantılara katılın",
          "description1": "Arayarak davet, global ücretsiz telefon numaraları ve yerel arama özellikleriyle premium ülkeler için çağrı seçeneklerinizi artırın",
          "description2": "Katılımcılar için herhangi bir cihazdan arayarak katılmak için hiçbir ücret söz konusu değildir",
          "description3": "Ücretsiz arayarak katılmak için bir veya çok sayıda ülkeyi kolayca seçin"
        },
        "rc": {
          "title": "Konferans Odası Bağlayıcısı"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Arjantin",
        "Australia": "Avustralya",
        "Austria": "Avusturya",
        "Belgium": "Belçika",
        "Brazil": "Brezilya",
        "Bulgaria": "Bulgaristan",
        "Canada": "Kanada",
        "Chile": "Şili",
        "China": "Çin",
        "Colombia": "Kolombiya",
        "Costa_Rica": "Kosta Rika",
        "Croatia": "Hırvatistan",
        "Cyprus": "Kıbrıs",
        "Czech_Republic": "Çek Cumhuriyeti",
        "Denmark": "Danimarka",
        "Ecuador": "Ekvator",
        "Estonia": "Estonya",
        "Finland": "Finlandiya",
        "France": "Fransa",
        "Germany": "Almanya",
        "Greece": "Yunanistan",
        "Hong_Kong_SAR": "Hong Kong ÖİB",
        "Hungary": "Macaristan",
        "Ireland": "İrlanda",
        "Israel": "İsrail",
        "Italy": "İtalya",
        "Japan": "Japonya",
        "Latvia": "Letonya",
        "Lithuania": "Litvanya",
        "Luxembourg": "Lüksemburg",
        "Mexico": "Meksika",
        "Netherlands": "Hollanda",
        "New_Zealand": "Yeni Zelanda",
        "Norway": "Norveç",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Polonya",
        "Portugal": "Portekiz",
        "Puerto_Rico": "Porto Riko",
        "Romania": "Romanya",
        "Singapore": "Singapur",
        "Slovakia": "Slovakya",
        "Slovenia": "Slovenya",
        "South_Africa": "Güney Afrika",
        "Spain": "İspanya",
        "Sweden": "İsveç",
        "Switzerland": "İsviçre",
        "UK": "İngiltere (Birleşik Krallık)",
        "United_Kingdom": "Birleşik Krallık",
        "US": "ABD",
        "United_States": "Birleşik Devletler",
        "title": "Telefon Numarası Gereklilikleri",
        "subtitle": "Lütfen Global Select telefon numaranızın etkinleştirileceği ülkeyi seçin.",
        "selector_tip": "Ülke Seç",
        "local_and_toll_free": "Yerel ve ücretsiz numaralar {0} konumunda mevcuttur",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select, lisans başına bir telefon numarası ve seçilen ülke içinde sınırsız yurt içi çağrı içermektedir.",
        "avail_title": "Uygun ülkeler/bölgeler"
      },
      "tax_exempt_ecm": {
        "title": "Vergi Muafiyeti Durumu",
        "status_exempt": "Vergiden Muaf",
        "status_exempt_question": "Vergiden Muaf mı?",
        "verify_now": "Şimdi Doğrula",
        "can_after_checkout": "İsteğe bağlı olarak, bu adım ödeme işleminden sonra tamamlanabilir.",
        "status": {
          "exempt": "Muaf",
          "pending": "Beklemede",
          "pendingTooltip": "Vergi muafiyeti durumunuz şu anda incelenmektedir. Sipariş verdiğinizde vergi alınabilir. Muafiyetinizin onaylanması durumunda iade edilebilir tüm vergileri/ücretleri hesabınıza aktaracağız.",
          "nonexempt": "Muaf Değil",
          "rejected": "Reddedildi",
          "rejectedTooltip": "Gönderilen belgenin, yetki alanınızdaki gereksinimleri karşılamadığı belirlenmiştir.",
          "approved": "Onaylandı",
          "default": "varsayılan"
        },
        "confirm_close": {
          "new_desc": "Doğrulamadan vazgeçmeniz durumunda geçerli vergiler/ücretler sizden tahsil edilebilir. Vergi muafiyeti belgenizi satın alma işleminden sonra Zoom'un incelemesi ve onayı için Faturalama Yönetimi bölümünden gönderebilirsiniz. Onaylandıktan sonra, tahsil edilen tüm vergiler için para iadesi yapılacaktır.",
          "desc": "Vergi muafiyeti doğrulamasından vazgeçip vergiye uygun olarak devam etmek istediğinizden emin misiniz?",
          "title": "Emin misiniz?",
          "new_title": "Vergi Muafiyeti Doğrulamasından Vazgeçmek mi İstiyorsunuz?",
          "yes": "Evet, vazgeç",
          "no": "Hayır, devam et",
          "abandon": "Doğrulamadan Vazgeç",
          "go_back": "Önceki Sayfa"
        },
        "confirm_to_add": {
          "title": "Yeni varsayılan vergi muafiyetini onaylayın",
          "message": "Eklenen yeni muafiyet, onaylandığında veya reddedildiğinde otomatik olarak varsayılan olarak ayarlanacaktır. Gelecekteki satın alımlar için geçerli olacak yalnızca bir varsayılan muafiyetiniz olabilir. Varsayılan muafiyetiniz \"Satış Yapılan\" eyalet/bölgenizle eşleşmiyorsa vergi tutarınız etkilenebilir.",
          "yes": "Yeni muafiyet ekleyin"
        },
        "confirm_set_default": {
          "title": "Adres ve vergi muafiyeti uyuşmazlığı",
          "message": "\"Satın Alan Kişi\" adresiniz vergi muafiyeti için seçtiğiniz eyalet/bölge ile eşleşmiyor. Lütfen \"Satın Alan Kişi\" adresinizi vergi muafiyetinizin konumuyla eşleşecek şekilde güncelleyin. Aksi takdirde satın alma işleminiz vergiden muaf olmayabilir.",
          "yes": "Yine de varsayılan olarak ayarlayın",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Ülke/Bölge",
          "exemption_type": "Muafiyet Türü",
          "signed_date": "İmzalama Tarihi",
          "status": "durum",
          "add_exemption": "Muafiyet Ekle",
          "view": "Görüntüle",
          "set_as_default": "Varsayılan Olarak Ayarla"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "{planName} planınız {date} tarihinde Koordineli Evrensel Saat ile 00:00'da iptal edilecektir. İptal tarihinizden sonra toplantı düzenlemek isterseniz lütfen planınızı yeniden etkinleştirin.",
        "pairPreDescTip": "{planName1} ve {planName2} planlarınız {date} tarihinde Koordineli Evrensel Saat ile 00:00'da iptal edilecektir. İptal tarihinizden sonra toplantı düzenlemek isterseniz lütfen planlarınızı yeniden etkinleştirin.",
        "pairDiffDatePreDescTip": "{planName1} planınız ve {planName2} planınız sırasıyla {date1} tarihinde Koordineli Evrensel Saat ile 00:00'da ve {date2} tarihinde Koordineli Evrensel Saat ile 00:00'da iptal edilecektir. İptal tarihinizden sonra toplantı düzenlemek isterseniz lütfen planlarınızı yeniden etkinleştirin.",
        "title": "Devam etmek için planınızı yeniden etkinleştirin",
        "titles": "Devam etmek için planınızı yeniden etkinleştirin",
        "plan": "Plan",
        "licenses": "Lisans(lar)",
        "billingCycle": "Faturalandırma Döngüsü",
        "effective_date": "yürürlük tarihi",
        "invoice_amount": "Fatura Toplamı",
        "singleDescTip": "Yeniden etkinleştirerek, yinelenen planınızın {date} tarihinde otomatik olarak yenileneceğini ve dosyadaki ödeme yönteminizden her yenileme döneminde ücret alınacağını kabul edersiniz. Gelecekteki ücretlerden kaçınmak için yenileme tarihinizden bir gün öncesine kadar <a target=\"_blank\" href=\"https://support.zoom.com/hc/tr/article?id=zm_kb&sysparm_article=KB0066687\">iptal edin</a>.",
        "pairDescTip": "Yeniden etkinleştirdiğinzde, yinelenen planlarınızın {date} tarihinde otomatik olarak yenileneceğini kabul edersiniz. Dosyadaki ödeme yönteminizden her yenileme döneminde ücret alınacaktır. Gelecekteki ücretlerden kaçınmak için yenileme tarihinizden bir gün öncesine kadar <a target=\"_blank\" href=\"https://support.zoom.com/hc/tr/article?id=zm_kb&sysparm_article=KB0066687\">iptal edin</a>.",
        "pairDiffDateDescTip": "Yeniden etkinleştirerek, yinelenen planlarınızın {date1} ve {date2} tarihlerinde otomatik olarak yenileneceğini kabul edersiniz. Dosyadaki ödeme yönteminizden her yenileme döneminde ücret alınacaktır. Gelecekteki ücretlerden kaçınmak için yenileme tarihinizden bir gün öncesine kadar <a target=\"_blank\" href=\"https://support.zoom.com/hc/tr/article?id=zm_kb&sysparm_article=KB0066687\">iptal edin</a>.",
        "totalLabel": "Toplam",
        "totalContent": "{money} artı geçerli vergiler",
        "taxDesc": "KDV, GST ve benzeri vergiler hariç",
        "reactivateBtn": "Devam Et ve Yeniden Etkinleştir",
        "switchTitle": "Devam etmek için planınızı güncelleyin",
        "successSingleTip": "{planName} planınız yeniden etkinleştirildi",
        "successPairTip": "{planName1} ve {planName2} planınız yeniden etkinleştirildi",
        "switchTip": "Bir Aylık Zoom Webinars planınızın süresi {date} tarihinde doluyor. Bu tarihten sonra web semineri düzenlemek için bir aboneliğe geçmeniz gerekir.",
        "switchBtn": "Aboneliğe Geçin"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Businessness"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Veri Sayfas\u0131n\u0131 \u0130ndirin"
      },
      "one": {
        "new": "YENİ"
      }
    },
    "webinarSetupInWebPortal": "Web Portalında Web Semineri Oluşturma",
    "concurrentEvents": "Tekrarlayan Etkinlikler",
    "coucurrentEventsToolTip": "<span><b></b>Abonelik planı aynı anda tek bir canlı etkinliği destekler",
    "overages": "Fazla kullanım",
    "eventsPlatformHubs": "Events Platformundaki Merkezler",
    "eventsHubToolTip": "Zoom Events <b>merkezleri</b> uygun etkinlik organizasyonu sunar",
    "1HubPerLicense": "Lisans başına 1 merkez",
    "1000Hubs": "1000 merkez",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platformu Oturum Sahipleri (500 ve daha fazla katılımcı)",
    "eventsHost500": "<span>Zoom Events <b>merkezi oturum sahipleri</b> şunları oluşturabilir:",
    "5HubHosts": "5 merkez oturum sahibi",
    "100HubHosts": "100 merkez oturum sahibi",
    "eventsPlatformHosts_100Attendees": "Events Platformu Oturum Sahipleri (100 katılımcı)",
    "eventsHost100": "<span>Zoom Events <b>merkezi oturum sahipleri</b> şunları oluşturabilir:",
    "2HubHosts": "2 merkez oturum sahibi",
    "howAreTheyDifferent": "Aralarındaki fark nedir?",
    "allPlansRequireAZoomOneLicense": "*Tüm planlar için Zoom Workplace lisansı gereklidir",
    "subscription": "Abonelik",
    "subscriptionToolTip": "<span><b>Aboneliğinizin olması</b>, seçtiğiniz kapasitede sınırsız sayıda etkinlik düzenlemenize olanak tanır.</span>",
    "payPerAttendee": "Rolsüz Katılımcı Başına Ödeme",
    "ppaToolTips": "<span><b>Rolsüz katılımcı başına ödeme</b> lisansı, satın alım tarihinden itibaren 12 aylık süreçte hesabınızda oluşturulan tüm etkinliklere toplamda kaç rolsüz katılımcının katılabileceğini belirler.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Anket yapma",
    "meetings.fullPlanItem2": "Lisans say\u0131s\u0131",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Tüm cihazlarda basitleştirilmiş video konferans ve mesajlaşma",
    "meetings.fullPlanItem5": "Toplant\u0131 S\u00FCresi",
    "meetings.fullPlanItem5Tip": "Grup toplant\u0131s\u0131 ba\u015F\u0131na izin verilen maksimum s\u00FCre (3 veya daha fazla kat\u0131l\u0131mc\u0131).",
    "meetings.fullPlanItem5_basic": "40 dk.",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 saat",
    "meetings.fullPlanItem5_biz": "30 saat",
    "meetings.fullPlanItem5_ent": "30 saat",
    "meetings.fullPlanItem1": "Kat\u0131l\u0131mc\u0131 kapasitesi",
    "meetings.fullPlanItem1Tip": "Kat\u0131l\u0131mc\u0131lar toplant\u0131n\u0131za telefonlar\u0131ndan, masa\u00FCst\u00FC, mobil ve tablet cihazlar\u0131ndan \u00FCcretsiz kat\u0131labilir. Bir kat\u0131l\u0131mc\u0131n\u0131n bir toplant\u0131ya kat\u0131lmak i\u00E7in Zoom hesab\u0131na sahip olmas\u0131 gerekmez. Her plan i\u00E7in bir kat\u0131l\u0131mc\u0131 s\u0131n\u0131r\u0131 mevcuttur, ancak kullan\u0131c\u0131lar bir eklenti sat\u0131n alarak \u00F6demeli planlarda bu s\u0131n\u0131r\u0131 art\u0131rabilir.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1000 katılımcı, Enterprise Plus için geçerlidir</span>",
    "meetings.fullPlanItem7": "Kay\u0131t",
    "meetings.fullPlanItem7Tip": "Zoom yerel kay\u0131t olana\u011F\u0131, toplant\u0131 kay\u0131tlar\u0131n\u0131z\u0131 MP4 (video), M4A (ses) ve txt (sohbet) bi\u00E7imlerinde kaydeder.<br>Zoom Buluta Kay\u0131t olana\u011F\u0131 toplant\u0131lar\u0131 Zoom Bulut \u00FCzerinde depolar ve sonras\u0131nda dosya buradan indirilebilir ve/veya bir taray\u0131c\u0131dan dosyan\u0131n ak\u0131\u015F\u0131 yap\u0131labilir.",
    "meetings.fullPlanItem7_basic": "Yerel",
    "meetings.fullPlanItem7_pro": "Yerel ve 5 GB bulut (lisans ba\u015F\u0131na)",
    "meetings.fullPlanItem7_biz": "Yerel ve 10 GB bulut (lisans ba\u015F\u0131na)",
    "meetings.fullPlanItem7_ent": "Yerel ve S\u0131n\u0131rs\u0131z bulut",
    "one.messaging": "Mesajlaşma",
    "meetings.fullPlanItem16Tip": "Sohbet; grup metnini, dosyalar\u0131, ekran yakalamalar\u0131n\u0131, kod par\u00E7ac\u0131klar\u0131n\u0131, sesli mesajlar\u0131 ve g\u00F6r\u00FCnt\u00FCleri kolayca g\u00F6ndermenize olanak tan\u0131r. Metin bi\u00E7imlendirilebilir ve kullan\u0131c\u0131lar ayr\u0131ca GIF ve emoji payla\u015Fabilir. Kat\u0131l\u0131m bilgileri, sohbet kat\u0131l\u0131mc\u0131lar\u0131n\u0131n masa\u00FCst\u00FC veya mobil cihaz \u00FCzerinde aktif veya toplant\u0131larda me\u015Fgul olup olmad\u0131\u011F\u0131n\u0131 g\u00F6sterir.",
    "meetings.fullPlanItem51": "Zoom Beyaz Tahtalar",
    "meetings.unlimited": "S\u0131n\u0131rs\u0131z",
    "meetings.fullPlanItem_EssentialApp": "Temel Uygulamalar",
    "common.learnMore": "Daha Fazla Bilgi",
    "meetings.fullPlanItem_EssentialAppText": "1 yıl boyunca ücretsiz kullanabileceğiniz premium uygulamalar (şartlar geçerlidir)",
    "zoomMailAndCalendarInTheZoomApp": "Poczta i kalendarz Zoom w aplikacji Zoom",
    "mailService": "E-posta Hizmeti",
    "emailServiceWithFullTimeEndToEnd": "Usługa poczty e-mail z pełnym szyfrowaniem end-to-end zapewniającym większą prywatność",
    "customMailDomain": "Özel Posta Etki Alanı",
    "customMailDomainWithMailService": "Özel Posta Etki Alanı z usługą pocztową",
    "calendarClient": "Takvim İstemcisi",
    "scheduleAndJoinMeetings": "Planuj spotkania i dołączaj do nich w aplikacji Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Usługa kalendarza",
    "meetingSchedulingAndAppointment": "Planowanie spotkań i rezerwowanie terminów",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Kolayca kısa videolar oluşturun, düzenleyin ve paylaşın. Saklanan klipler kolaylıkla keşfedilebilir ve etkileşimi artırır.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes, kişisel ve iş birliğine uygun işlevsel bir belge düzenleyicisi sunar. Bu düzenleyicide toplantılarda ve toplantı dışında da erişilebilen geniş biçimlendirme seçenekleri bulunur.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Çevrilen Alt Yazılar",
    "workspaceReservation": "Çalışma Alanı Rezervasyonu",
    "accessAcrossAnyDevice": "Tüm cihazlardan erişim",
    "meetings.fullPlanItem4": "S\u0131n\u0131rs\u0131z Toplant\u0131lar",
    "meetings.fullPlanItem9": "Telefonla arama",
    "meetings.fullPlanItem9Tip": "Zoom toplant\u0131lar\u0131na (geleneksel telefon kullanarak) telekonferans/sesli konferans yoluyla kat\u0131l\u0131n. Kullan\u0131c\u0131lar telefon planlar\u0131na g\u00F6re \u00FCcretlendirilecektir. \u00DCcretsiz arama numaralar\u0131 i\u00E7in Audio Conferencing eklentimizi deneyin.",
    "meetings.fullPlanItem9_pro": "\u00DCcretli",
    "meetings.fullPlanItem9_biz": "\u00DCcretli",
    "meetings.fullPlanItem9_ent": "\u00DCcretli",
    "meetings.fullPlanItem11": "Ekran payla\u015F\u0131m\u0131",
    "meetings.fullPlanItem11Tip": "Masa\u00FCst\u00FC ve uygulama payla\u015F\u0131m\u0131. Lisansl\u0131 toplant\u0131 kullan\u0131c\u0131lar\u0131, d\u00FCzenledi\u011Fi bir toplant\u0131 s\u0131ras\u0131nda birden \u00E7ok kat\u0131l\u0131mc\u0131n\u0131n ayn\u0131 anda ekran\u0131n\u0131 payla\u015Fmas\u0131na izin vermeyi se\u00E7ebilir.",
    "meetings.fullPlanItem12": "Ara odalar",
    "meetings.fullPlanItem12Tip": "Video Ara Odalar\u0131, Zoom toplant\u0131s\u0131n\u0131 tart\u0131\u015Fma, projeler ve daha fazlas\u0131 i\u00E7in 50 ayr\u0131 oturuma b\u00F6lmenize olanak tan\u0131r.",
    "meetings.fullPlanItem14": "Sanal arka plan",
    "meetings.fullPlanItem15": "Ki\u015Fisel Toplant\u0131 Kimli\u011Fi",
    "meetings.fullPlanItem15Tip": "Kendi kal\u0131c\u0131 \u00E7evrimi\u00E7i toplant\u0131 odan\u0131z\u0131 olu\u015Fturun. Bu toplant\u0131y\u0131 istedi\u011Finiz zaman ba\u015Flatabilir veya gelecekte kullan\u0131m i\u00E7in planlayabilirsiniz.",
    "meetings.fullPlanItem17": "Oturum sahibi kontrolleri",
    "meetings.fullPlanItem18": "Ekran payla\u015F\u0131m\u0131nda ortak ek a\u00E7\u0131klama",
    "meetings.fullPlanItem19": "Uzaktan klavye ve fare kontrol\u00FC",
    "meetings.fullPlanItem21": "\u00C7oklu payla\u015F\u0131m",
    "meetings.fullPlanItem29": "Bekleme odas\u0131",
    "meetings.fullPlanItem29Tip": "Bekleme Odas\u0131 \u00F6zelli\u011Fi, oturum sahibinin bir kat\u0131l\u0131mc\u0131n\u0131n toplant\u0131ya ne zaman kat\u0131laca\u011F\u0131n\u0131 kontrol etmesine olanak tan\u0131r. Toplant\u0131 sahibi olarak, rols\u00FCz kat\u0131l\u0131mc\u0131lar\u0131 tek tek veya hep birlikte kabul edebilirsiniz. Ayarlarda kimlerin Bekleme Odas\u0131na al\u0131naca\u011F\u0131n\u0131 ve kimlerin otomatik olarak kabul edilece\u011Fini se\u00E7ebilirsiniz. Her hesap Bekleme Odas\u0131 \u00F6zelli\u011Fine sahiptir. Oturum sahipleri, Bekleme Odas\u0131na mesaj g\u00F6nderebilir. \u00DCcretli plan kullan\u0131yorsan\u0131z Bekleme Odas\u0131n\u0131 \u00F6zelle\u015Ftirebilirsiniz.",
    "meetings.fullPlanItem41": "Ev cihazlar\u0131 i\u00E7in Zoom i\u00E7inde yerle\u015Fik olarak bulunur",
    "meetings.fullPlanItem61": "Birden \u00E7ok ki\u015Fiyi sabitleme",
    "meetings.fullPlanItem61Tip": "Oturum sahibi 9\u2019a kadar ki\u015Fiye kendi \u00F6zel g\u00F6r\u00FCn\u00FCm\u00FCn\u00FC olu\u015Fturmak \u00FCzere video sabitleme olana\u011F\u0131 tan\u0131yabilir. B\u00F6ylece kim konu\u015Fuyor olursa olsun, sabitlenen videolar g\u00F6r\u00FCn\u00FCr olmaya devam eder.",
    "meetings.fullPlanItem62": "Birden \u00E7ok ki\u015Fiyi \u00F6ne \u00E7\u0131karma",
    "meetings.fullPlanItem62Tip": "Oturum sahibi 9\u2019a kadar rols\u00FCz kat\u0131l\u0131mc\u0131n\u0131n videosunu \u00F6ne \u00E7\u0131karabilir. B\u00F6ylece kim konu\u015Fuyor olursa olsun, t\u00FCm toplant\u0131 kat\u0131l\u0131mc\u0131lar\u0131 \u00F6ne \u00E7\u0131kar\u0131lan videolar\u0131 g\u00F6r\u00FCr.",
    "meetings.fullPlanNewItem1": "Filtreler",
    "meetings.fullPlanNewItem1Tip": "E\u011Flenceli renkli filtreler ve dekoratif hayvan \u00E7\u0131kartmalar\u0131 ile happy hour saatlerine, partilere ve di\u011Fer etkinliklere daha fazla e\u011Flence kat\u0131n.",
    "meetings.fullPlanNewItem2": "Anket yapma",
    "meetings.fullPlanNewItem3": "Ortak oturum sahibi ve alternatif oturum sahibi",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Toplant\u0131lar i\u00E7in ortak oturum sahibi kontrollerimiz hakk\u0131nda</a> daha fazla bilgi edinin.",
    "meetings.fullPlanItem24": "Toplant\u0131 planlay\u0131c\u0131y\u0131 atama",
    "meetings.fullPlanItem24Tip": "Ba\u015Fkalar\u0131n\u0131n toplant\u0131lar\u0131n\u0131z\u0131 sizin ad\u0131na yap\u0131land\u0131rmas\u0131na olanak tan\u0131r. Atanan\u0131n Pro plan\u0131 olmal\u0131d\u0131r.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Hesap sahiplerinin, y\u00F6neticilerin ve geli\u015Ftiricilerinizin Zoom REST API\u2019ye eri\u015Fimi g\u00FCvence alt\u0131na almas\u0131na olanak tan\u0131r.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Oran S\u0131n\u0131rlar\u0131</a>, <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Hesap T\u00FCr\u00FCne</a> (Pro, \u0130\u015Fletme, Kurumsal vb.) ve <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API \u0130stek T\u00FCr\u00FCne</a> (Hafif, Orta, A\u011F\u0131r vb.) hesap seviyesinde uygulan\u0131r. Baz\u0131 API\u2019ler i\u00E7in eri\u015Fim belirli hesap t\u00FCrleri ile s\u0131n\u0131rlanm\u0131\u015Ft\u0131r. Ayr\u0131nt\u0131l\u0131 bilgilerin tamam\u0131 i\u00E7in <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Oran S\u0131n\u0131rlar\u0131</a> ve <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Referans Belgeleri</a> kaynaklar\u0131na bak\u0131n.",
    "meetings.fullPlanItem25_pro": "Pro REST API Oran S\u0131n\u0131rlar\u0131",
    "meetings.fullPlanItem25_biz": "REST API Oran S\u0131n\u0131rlar\u0131",
    "meetings.fullPlanItem26": "Skype for Business (Lync) birlikte \u00E7al\u0131\u015Fabilirli\u011Fi",
    "meetings.fullPlanItem26Tip": "Lync 2010, 2013 kullan\u0131c\u0131lar\u0131n\u0131n ve Skype for Business kullan\u0131c\u0131lar\u0131n\u0131n Lync ki\u015Fi listesinden Zoom toplant\u0131s\u0131 ba\u015Flatmas\u0131na olanak tan\u0131r.",
    "meetings.fullPlanItem27": "Ak\u0131\u015F",
    "meetings.fullPlanItem27Tip": "Facebook, Youtube veya bir 3. taraf hizmete canl\u0131 ak\u0131\u015F yap\u0131n.",
    "meetings.fullPlanItem28": "Raporlama",
    "meetings.fullPlanItem28Tip": "Ka\u00E7 toplant\u0131 yap\u0131ld\u0131\u011F\u0131n\u0131, toplant\u0131lar\u0131n hangi g\u00FCnlerde yap\u0131ld\u0131\u011F\u0131n\u0131, kat\u0131l\u0131mc\u0131 say\u0131s\u0131n\u0131, toplant\u0131 dakikas\u0131 say\u0131s\u0131n\u0131 ve daha fazlas\u0131n\u0131 \u00F6\u011Frenmek i\u00E7in kullan\u0131m raporlar\u0131 haz\u0131rlay\u0131n.",
    "meetings.fullPlanItem30": "Kullan\u0131c\u0131 y\u00F6netimi",
    "meetings.fullPlanItem30Tip": "Sahipler ve Y\u00F6neticiler rol ve ek \u00F6zellik ekleyebilir, silebilir ve atayabilir.",
    "one.autoCaptions": "Otomatik alt yazılar",
    "meetings.fullPlanItem31": "Y\u00F6netici portal\u0131",
    "meetings.fullPlanItem31Tip": "T\u00FCm\u00FC Zoom Y\u00F6netici Portal\u0131 \u00FCzerinde yer alan basitle\u015Ftirilmi\u015F faturalama, geli\u015Fmi\u015F kullan\u0131c\u0131 y\u00F6netimi ayarlar\u0131 ve kapsaml\u0131 kullan\u0131m analizleri i\u00E7in \u015Firketinizdeki kullan\u0131c\u0131lar\u0131 tek bir hesapta y\u00F6netin.",
    "meetings.fullPlanItem32": "LTI entegrasyonu",
    "meetings.fullPlanItem32Tip": "Herhangi bir ders aktivitesine kolayca toplant\u0131 ekleyin ve \u00F6\u011Frenim y\u00F6netim sisteminizden do\u011Fru \u00F6\u011Frencileri davet edin (Moodle, Canvas, Desire2Learn ve Blackboard ile \u00E7al\u0131\u015F\u0131r).",
    "meetings.fullPlanItem33": "Kay\u0131t d\u00F6k\u00FCm\u00FC",
    "meetings.fullPlanItem33Tip": "Bulut kay\u0131t d\u00F6k\u00FCmleri, buluta kaydetti\u011Finiz bir toplant\u0131n\u0131n veya web seminerinin sesinin d\u00F6k\u00FCm\u00FCn\u00FC i\u00E7eren ses d\u00F6k\u00FCmleridir. Bu \u00F6zelli\u011Fin \u015Fu an i\u00E7in \u0130ngilizce dilinde desteklendi\u011Fini l\u00FCtfen unutmay\u0131n. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Daha fazla bilgi i\u00E7in</a> buray\u0131 t\u0131klay\u0131n.",
    "meetings.fullPlanItem34": "Markalama",
    "meetings.fullPlanItem34Tip": "Kullan\u0131c\u0131lar\u0131n\u0131z\u0131n bir toplant\u0131ya kat\u0131labilece\u011Fi kendi \u00F6zelle\u015Ftirilmi\u015F sayfan\u0131za \u015Firketinizin markalama i\u00E7eri\u011Fini ekleyin. Rols\u00FCz kat\u0131l\u0131mc\u0131lara davetiye g\u00F6ndermek i\u00E7in markal\u0131 bir e-posta \u015Fablonu olu\u015Fturun.",
    "meetings.fullPlanItem35": "Y\u00F6netilen etki alanlar\u0131",
    "meetings.fullPlanItem35Tip": "Hesab\u0131n\u0131za otomatik olarak kullan\u0131c\u0131 eklemek i\u00E7in \u015Firket/\u00FCniversite e-posta adresi etki alan\u0131n\u0131z\u0131 kullan\u0131n.",
    "meetings.fullPlanItem37": "Terc\u00FCme",
    "meetings.fullPlanItem37Tip": "Toplant\u0131 sahibinin, toplant\u0131lar\u0131nda ve web seminerinde terc\u00FCman tahsis etmesine olanak tan\u0131r. Toplant\u0131 sahibi, toplant\u0131y\u0131 veya web seminerini ba\u015Flatt\u0131ktan sonra terc\u00FCme \u00F6zelli\u011Fini ba\u015Flatabilir. Bu \u00F6zellik, terc\u00FCmanlara kendi ses kanallar\u0131 i\u00E7in eri\u015Fim verir. Rols\u00FCz kat\u0131l\u0131mc\u0131lar, tercih ettikleri dili duymak i\u00E7in bir ses kanal\u0131 se\u00E7ebilir. Rols\u00FCz kat\u0131l\u0131mc\u0131lar, terc\u00FCme edilen sesi duyar ve orijinal sesi daha d\u00FC\u015F\u00FCk ses seviyesinde duymak isteyip istemedi\u011Fini se\u00E7ebilir.",
    "meetings.fullPlanItem39": "\u0130dari i\u015F incelemeleri",
    "meetings.fullPlanItem39Tip": "Ayr\u0131nt\u0131l\u0131 trend benimseme analizi, yat\u0131r\u0131m getirisi izleme, \u00FCr\u00FCn yol haritas\u0131 tart\u0131\u015Fmalar\u0131.",
    "meetings.fullPlanNewItem4": "Web Semineri 500\u2019\u00FC i\u00E7erir",
    "one.translatedCations": "Çevrilen Alt Yazılar",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Doğrudan, Kanal veya Grup Sohbeti",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "1:1 mesajlarda, küçük gruplarda veya büyük ekiplerle kolayca iletişim kurun",
    "messageAndFileHistory": "Mesaj ve dosya geçmişi",
    "findPeopeChannelsAndFilesInSearch": "Aramada kişileri, kanalları ve dosyaları bulun",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Bilgileri parmaklarınızın ucunda tutarak hızlı bir şekilde kişileri, anlık mesajları, grup sohbetlerini ve dosyaları bulun.",
    "applicationIntegrations": "Uygulama Entegrasyonları",
    "secureFileSharing": "Güvenli dosya paylaşımı",
    "enhanceCollaborationWithSeamlessFileSharing": "Sorunsuz dosya paylaşımı ile iş birliğini geliştirin",
    "persistentMeetingChat": "Kalıcı toplantı sohbeti",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Toplantı sohbetlerinin izini asla kaybetmeyin. Zoom Team Chat'te tüm toplantı katılımcıları için özel bir grup sohbeti oluşturarak toplantı öncesinde, sırasında ve sonrasında iletişim kurun.",
    "cloudStorage": "Bulut Depolama",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Kanalları Zoom Bulut'a veya bir üçüncü taraf depolama sağlayıcısına yedekleyin",
    "avatars": "Avatarlar",
    "inMeetingReactions": "Toplantı içi reaksiyonlar",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Katılım gösterin ve diğer katılımcılarla sözlü olmayan bir şekilde hızlıca iletişim kurun",
    "virtualBackgrounds": "Sanal arka planlar",
    "videoFilters": "Video filtreleri",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Videonuzun üzerine yerleştirilmiş çeşitli filtrelerle toplantılarınıza biraz eğlence katın",
    "inMeetingPollsAndQuizzes": "Toplantı içi anketler ve testler",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Toplantılarınız için tek seçenekli veya çoktan seçmeli anket soruları oluşturun.",
    "liveStreamingAcrossPlatforms": "Platformlar arasında canlı yayın",
    "appearanceTouchUp": "Görünüş rötuşu",
    "originalSoundForMusicians": "Müzisyenler için orijinal ses",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings için uçtan uca şifreleme",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Zoom'un, Zoom Meetings için olan uçtan uca şifreleme (E2EE) özelliği etkinleştirildiğinde, belirli bir toplantıdaki Zoom desktop client'ı kullanan tüm toplantı katılımcıları arasındaki iletişimin yalnızca bu katılımcıların cihazları tarafından bilinen şifreleme anahtarları kullanılarak şifrelenmesini sağlar. Bu, Zoom dahil hiçbir üçüncü tarafın toplantının özel anahtarlarına erişemediği anlamına gelir.",
    "zoomCustomerManagedKey": "Zoom Müşteri Tarafından Yönetilen Anahtar",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Zoom verilerinizi korumak için kendi şifreleme anahtarlarınızı kullanın",
    "enterpriseGradeSecurityFeatures": "Kurumsal düzeyde güvenlik özellikleri",
    "256BitAesGcmEncryptionForRealTimeContent": "Gerçek zamanlı içerik ve medyalar için 256 bit AES-GCM şifrelemesi, SIP kaydı sırasında TLS şifrelemesi, arayan kimliğini maskeleme, özel ağ eşleme, ücret sahtekarlığını algılama ve engellenen çağrılar listeleri.",
    "phone.fullPlanItem40": "SAML 2.0 \u00FCzerinden \u00E7oklu oturum a\u00E7ma",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "S\u0131n\u0131rs\u0131z dahili \u00E7a\u011Fr\u0131",
    "phone.fullPlanItem2": "Tarifeli d\u0131\u015Far\u0131 \u00E7a\u011Fr\u0131",
    "phone.fullPlanItem3": "S\u0131n\u0131rs\u0131z d\u0131\u015Far\u0131 \u00E7a\u011Fr\u0131",
    "phone.fullPlanItem4": "End\u00FCstri lideri HD \u00E7a\u011Fr\u0131 kalitesi",
    "phone.fullPlanItem4Tip": "Etkin g\u00FCr\u00FClt\u00FC \u00F6nleme, yank\u0131 \u00F6nleme ve klavyede yazma g\u00FCr\u00FClt\u00FCs\u00FC engelleme",
    "phone.fullPlanItem5": "Yerel Windows, MacOS ve Linux masa\u00FCst\u00FC uygulamalar\u0131",
    "phone.fullPlanItem6": "iOS ve Android i\u00E7in yerel mobil uygulamalar",
    "phone.fullPlanItem7": "Mevcut numaralar\u0131 ta\u015F\u0131ma veya yeni numaralar sat\u0131n alma olana\u011F\u0131 (DID)",
    "phone.fullPlanItem8": "\u00DCcretsiz numaralar",
    "phone.fullPlanItem9": "Telefon dahili numaras\u0131",
    "phone.fullPlanItem10": "D\u00F6k\u00FCm \u00F6zellikli sesli mesaj",
    "phone.fullPlanItem10Tip": "Mobil/masa\u00FCst\u00FC uygulamalar\u0131 ve e-posta \u00FCzerinden sesli mesaj d\u00F6k\u00FCm eri\u015Fimi",
    "phone.fullPlanItem11": "S\u0131n\u0131rs\u0131z otomatik santral/IVR",
    "phone.fullPlanItem12": "Ada g\u00F6re arama dizini",
    "phone.fullPlanItem13": "\u00C7a\u011Fr\u0131 kuyru\u011Fa alma \u00F6zellikli otomatik \u00E7a\u011Fr\u0131 da\u011F\u0131t\u0131m gruplar\u0131 (ACD)",
    "phone.fullPlanItem14": "T\u00FCm Taraflarla Konu\u015Fma/\u0130zleme/F\u0131s\u0131ldama/Devralma",
    "phone.fullPlanItem15": "Tatil ve i\u015F saatleri y\u00F6nlendirmesi",
    "phone.fullPlanItem16": "3 y\u00F6nl\u00FC ge\u00E7ici konferans \u00E7a\u011Fr\u0131lar\u0131",
    "phone.fullPlanItem17": "\u00C7a\u011Fr\u0131 kayd\u0131",
    "phone.fullPlanItem17Tip": "Otomatik ve manuel \u00E7a\u011Fr\u0131 kayd\u0131 mevcuttur. D\u00F6k\u00FCm olana\u011F\u0131yla tam zamanl\u0131 ve talep \u00FCzerine \u00E7a\u011Fr\u0131 kayd\u0131",
    "phone.fullPlanItem18": "Yap\u0131land\u0131r\u0131labilir anonim ve belirtilmi\u015F \u00E7a\u011Fr\u0131 engelleme",
    "phone.fullPlanItem19": "Acil durum \u00E7a\u011Fr\u0131s\u0131",
    "phone.fullPlanItem19Tip": "Yerel acil servislere \u00E7a\u011Fr\u0131 yapma",
    "phone.fullPlanItem20": "Gezici E911 adresleme (ABD ve Kanada) -",
    "phone.fullPlanItem20Tip": "Kullan\u0131c\u0131 konumunu dinamik olarak alg\u0131lar ve ilgili acil durum adresini yerel acil servislere (yaln\u0131zca ABD ve Kanada) ve dahili g\u00FCvenlik ekibine bildirir",
    "phone.fullPlanItem21": "Acil durum yan\u0131t merkezi",
    "phone.fullPlanItem21Tip": "Acil durum aramalar\u0131n\u0131n dahili g\u00FCvenlik ekibinize bildirilmesini sa\u011Flay\u0131n ve yan\u0131ta y\u00F6n vermeye yard\u0131mc\u0131 olmak \u00FCzere acil durum aramalar\u0131n\u0131 kaydedin, izleyin veya bu aramalara kat\u0131l\u0131n.",
    "phone.fullPlanItem22": "Payla\u015F\u0131ml\u0131 hat g\u00F6r\u00FCn\u00FCm\u00FC/atamas\u0131",
    "phone.fullPlanItem23": "Cihazlar aras\u0131nda \u00E7a\u011Fr\u0131 aktarma",
    "phone.fullPlanItem24": "\u00C7a\u011Fr\u0131 park etme",
    "endToEndEncryptionForZoomPhone": "Zoom Phone için uçtan uca şifreleme",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Zoom Phone için uçtan uca şifreleme (E2EE) özelliği etkinleştirildiğinde, çağrının yalnızca arayan ve aranılan kişilerin cihazları tarafından bilinen şifreleme anahtarları kullanılarak şifrelenmesi sağlanır. Kullanıcılar, birbirleriyle benzersiz güvenlik kodunu paylaşarak E2EE durumunu doğrulama seçeneğine de sahip olur.",
    "phone.fullPlanItem43": "Telefonlar i\u00E7in dokunmadan sa\u011Flama",
    "phone.fullPlanItem44": "Bir hesap i\u00E7inde farkl\u0131 plan t\u00FCrlerini bir arada kullanma",
    "phone.fullPlanItem46": "Ger\u00E7ek zamanl\u0131 raporlama ve kalite panolar\u0131",
    "phone.fullPlanItem47": "Sanal masa\u00FCst\u00FC (VDI) ortam\u0131 deste\u011Fi",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">VDI hakk\u0131nda</a> daha fazla bilgi",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Tüm yalnızca telefon müşterileri tarafından kullanılabilir. Destek planları toplantı planlarıyla birleştirildiklerinde farklılık gösterecektir.",
    "phone.fullPlanItem49": "Kendi operat\u00F6r\u00FCn\u00FCz\u00FC getirin deste\u011Fi",
    "phone.fullPlanItem49Tip": "Mevcut PSTN servis sa\u011Flay\u0131c\u0131n\u0131za do\u011Frudan ve i\u015Fletme tabanl\u0131 e\u015Fleme deste\u011Fi",
    "phone.fullPlanItem50": "Eski PBX\u2019lere karma entegrasyon",
    "phone.fullPlanItem51": "Bas Konuş",
    "phone.fullPlanItem61": "Çevrimiçi Faks",
    "phone.fullPlanItem61Tip": "ABD ve Kanada içinde sınırsız faks gönderin ve alın. Uluslararası fakslar için <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\"> fiyatlara bakın</a>",
    "phone.fullPlanSms": "SMS ve MMS",
    "phone.fullPlanSmsTip": "Yaln\u0131zca bir \u00E7a\u011Fr\u0131 plan\u0131 sat\u0131n al\u0131nd\u0131\u011F\u0131nda ABD ve Kanada numaralar\u0131 i\u00E7in sunulmaktad\u0131r. Do\u011Frudan numaralar i\u00E7in kullan\u0131ma sunulmaktad\u0131r (\u015Firket numaralar\u0131 i\u00E7in de\u011Fil).",
    "meetings.fullPlanItem6": "Teknik destek",
    "meetings.fullPlanItem6Tip": "Riski en aza indirmeye ve kesinti s\u00FCresini azaltmaya yard\u0131mc\u0131 olmak \u00FCzere \u00DCst D\u00FCzey destek paketleri sunulmaktad\u0131r.",
    "meetings.fullPlanItem6_basic": "Yard\u0131m merkezi",
    "meetings.fullPlanItem6_pro": "Bilet ve canl\u0131 sohbet",
    "meetings.fullPlanItem6_biz": "Bilet, canl\u0131 sohbet ve telefon",
    "meetings.fullPlanItem6_ent": "Bilet, canl\u0131 sohbet ve telefon",
    "knowledgeBase": "Bilgi Tabanı",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Bilgi tabanı makalelerimizde arama yaparak teknik sorunları giderin ve destek kaynaklarına erişin.",
    "zoomCommunity": "Zoom Topluluğu",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Çözüm bulabileceğiniz, soru sorabileceğiniz ve diğer Zoom kullanıcılarıyla iş birliği yapabileceğiniz bir yerdir.",
    "chatbot": "Sohbet Botu",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Sohbet botumuz ile iletişim kurarak sorularınıza yanıt alın ve teknik sorunları giderin.",
    "submitWebTickets": "Web biletlerini gönder",
    "liveChatSupport": "Canlı sohbet desteği",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Ayda {amount} ABD dolarından fazla tutan abonelik planları",
    "livePhoneSupport": "Canlı telefon desteği",
    "meetWithAgentOnVideo": "Temsilciyle videoda görüşün",
    "subscriptionPlansGreaterThan_200UsdMonth": "Ayda 200 ABD dolarından fazla tutan abonelik planları",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "En sevdiğiniz Uygulamaları, Zoom Team Chat içinde kullanarak üretkenliği artırın",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Toplantılara biraz eğlence katmak ve videoya ihtiyaç duymadan kendinizi dinamik olarak tanıtmak için avatarınızı özelleştirin",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Poczta",
    "common.plans.meeting.title": "Toplantılar",
    "plans.basic_free.upgrade.item1": "Toplantı başına 30 saate varan süre sınırı",
    "common.statistics.participants": "{0} Katılımcılar",
    "common.per_meeting_unit": "toplantı başına",
    "common.participant_limit.increase_with_large_meetings": "Büyük Toplantı ile Artırın",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Beyaz Tahta",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Sınırsız",
    "common.plans.team_chat.title": "Ekip Sohbeti",
    "common.plans.mail_calendar.title": "E-posta ve Takvim",
    "common.plans.cloud_storage.title": "Bulut depolama",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Zoom Çevrilmiş Alt Yazılar",
    "common.plans.extras.title": "Ek özellikler",
    "common.plans.extras.desc": "şirket etki alanlarını yönetin ve daha fazlasını yapın",
    "zoom_one_edu_bundle.school.title": "Eğitim için Zoom One Okul ve Kampüs",
    "zoom_one_edu_bundle.school_plus.title": "Eğitim için Zoom One Okul ve Kampüs Plus",
    "per_billing_cycle_license.monthly": "/ay/lisans",
    "per_billing_cycle_license.yearly": "/yıl/lisans",
    "per_billing_cycle_space.monthly": "/ay/alan",
    "per_billing_cycle_space.yearly": "/yıl/alan",
    "common.dialog.feature_list": "Tüm Özellikler Listesini Gör",
    "detail_dialog.meeting_feature.cloud_recording.pro": "Lisans başına 5 GB",
    "detail_dialog.meeting_feature.cloud_recording.10": "Lisans başına 10 GB",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Kurumsal Plus'a Sınırsız dahildir",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Konferans Odası Bağlayıcısı (1:25 oran)",
    "plans.whiteboard.ent": "Kurumsal Plus'a Sınırsız Plus dahildir",
    "plans.zp.ent": "Kurumsal Plus paketine dahildir",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Gelişmiş veya yerinde çalışma alanı rezervasyonu ve daha fazlası",
    "plans.largeMeeting.intro_tip": "Büyük Toplantılar, ödeme esnasında satın alınabilen isteğe bağlı bir eklentidir ve satın alınan lisansa bağlı olarak 500 veya 1.000 katılımcıya kadar bir toplantıya ev sahipliği yapmanızı sağlar.",
    "common.participant_limit.expandable_with_large_meetings": "Büyük Toplantı ile Genişletilebilir",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1000 katılımcı, Enterprise Plus için geçerlidir</span>",
    "plans.webinar": "Zoom Web Semineri",
    "plans.webinar.ent": "Kurumsal Plus'a Oturum 1000 dahildir (Web Semineri dahildir)",
    "per_billing_cycle_user.monthly": "/ay/kullanıcı",
    "per_billing_cycle_user.annually": "/yıl/kullanıcı",
    "closeComparisonChart": "Karşılaştırma Tablosunu Kapat",
    "archiving_api": "Arşivleme API'si",
    "dlp_api": "DLP API",
    "info_barriers": "Bilgi Engelleri",
    "chat_etiquette": "Sohbet Görgü Kuralları",
    "gdrp": "GDPR",
    "regiona_data_centers": "Bölgesel Veri Merkezleri",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Varsayılan Olarak Şifreleme",
    "end_to_end_encryption": "Uçtan Uca Şifreleme",
    "cryptographic_boundary": "Şifrelemeli Sınır",
    "vdi": "Sanal Masaüstü (VDI)",
    "customer_managed_key": "Müşteri Tarafından Yönetilen Anahtar",
    "gpo_msi_policies": "GPO/MSI Politikaları",
    "msi": "Toplu Yaygınlaştırma (MSI)",
    "ntt": "Ağ Test Aracı (NTT)",
    "dashboards": "Panolar",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Sürdürülebilirliği",
    "zoom_meeting_survivability": "Zoom Meetings Sürdürülebilirliği",
    "paid_option": "Ücretli Seçenek",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Temel Özellikler",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Okul ve Kampüs",
    "zoom_one_edu_bundle.school_plus.brief_title": "Okul ve Kampüs Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "vi-VN": {
    "billing.essential_apps": "Ứng dụng thiết yếu",
    "billing.essential_apps.dialog_desc": "Phát triển và quản lý hoạt động kinh doanh với các ứng dụng cho phép ghi chú cuộc họp, thu hút nhóm tham gia hoạt động tương tác và cung cấp thông tin chuyên sâu để cải thiện cuộc hội thoại với khách hàng. Ứng dụng cao cấp miễn phí được bao gồm trong gói của bạn trong 1 năm.",
    "billing.see_more_details": "Xem thêm chi tiết",
    "billing.essential_app.legal_copy": "Ưu đãi này chỉ dành cho người dùng có giấy phép đang có hiệu lực vào ngày hoặc sau ngày 4 tháng 1 năm 2023 với gói đăng ký Zoom One Chuyên nghiệp, Kinh doanh hoặc Kinh doanh Nâng cao mua qua kênh trực tuyến của Zoom tại zoom.us/buy. Người dùng có gói đăng ký liên kết với tài khoản Y tế, Giáo dục hoặc Chính phủ không đủ điều kiện nhận ưu đãi này.  Quyền truy cập vào từng ứng dụng, ngoại trừ Coda, bắt đầu vào thời điểm người dùng cá nhân kích hoạt ứng dụng và hết hạn vào 1 năm sau đó. Quyền truy cập vào Coda cho mọi người dùng trên cùng tài khoản Zoom bắt đầu vào thời điểm bất kỳ người dùng nào trên cùng tài khoản Zoom kích hoạt Coda lần đầu và hết hạn cho mọi người dùng trên tài khoản Zoom đó 1 năm sau đó, bất kể ngày những người dùng khác sau đó trên cùng tài khoản Zoom kích hoạt ứng dụng lần đầu.Với mọi ứng dụng, việc chỉ định lại hoặc hủy giấy phép hoặc gói đăng ký hợp lệ của một người dùng sẽ ngừng quyền truy cập của người dùng đó, kể cả khi đó vẫn đang trong thời hạn 1 năm truy cập.Mỗi ứng dụng áp dụng điều khoản sử dụng và chính sách quyền riêng tư hiện hành tại thời điểm kích hoạt.Chỉ hỗ trợ tiếng Anh cho các ứng dụng được bao gồm.Không phải ứng dụng nào cũng hoạt động trên điện thoại di động.Bạn không được đổi hay hoàn lại ưu đãi này để lấy tiền mặt.Ưu đãi chỉ áp dụng cho các ứng dụng được liệt kê là có trong Ứng dụng thiết yếu trong <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a>. Người dùng đã có gói đăng ký từ trước cho bất kỳ ứng dụng nào trên đây không đủ điều kiện nhận ưu đãi này liên quan tới các ứng dụng cụ thể đó.Zoom có quyền sửa đổi hoặc hủy ưu đãi này vào bất cứ lúc nào mà không cần thông báo trước và không chịu nghĩa vụ pháp lý nào.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Quản lý khách truy cập"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "Hỗ trợ qua trò chuyện trực tiếp và điện thoại 24x7"
      },
      "learn_more": "T\u00ECm hi\u1EC3u th\u00EAm",
      "new": "MỚI",
      "plan_details": {
        "meeting": {
          "title": "Cu\u1ED9c h\u1ECDp",
          "host_meeting_up_to_participants": "Tổ chức cho tối đa {0} người tham gia",
          "meeting_hours": "Không giới hạn số cuộc họp với thời lượng tối đa 30 tiếng cho mỗi cuộc họp",
          "recording_storage": "Bản ghi lưu trữ trên đám mây với dung lượng {0} GB (cho mỗi giấy phép)",
          "auto_captions": "Phụ đề tự động"
        },
        "whiteboard": {
          "title": "Bảng trắng",
          "boards_storage": "{0} bảng có thể chỉnh sửa",
          "standard_features": "Tính năng tiêu chuẩn"
        },
        "team_chat": {
          "title": "Trò chuyện nhóm",
          "desc": "Trò chuyện nhóm và chia sẻ tệp"
        },
        "main_calendar": {
          "title": "Thư và lịch",
          "desc": "Máy khách cho thư và lịch"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Tạo và chia sẻ tài liệu có thể chỉnh sửa trong Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Dễ dàng ghi, chỉnh sửa và chia sẻ các video có định dạng ngắn",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Truy cập nhanh chóng vào bản tóm tắt cuộc họp, nhận trợ giúp soạn tin nhắn, v.v."
        },
        "EssentialApp": {
          "title": "Ứng dụng thiết yếu",
          "desc1": "Ứng dụng cao cấp miễn phí trong 1 năm (có áp dụng điều khoản)",
          "desc2": "Tăng cường cộng tác nhóm và năng suất"
        },
        "livechat": {
          "title": "Hỗ trợ qua trò chuyện trực tiếp"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Bạn muốn chuyển sang Zoom Workplace Chuyên nghiệp?",
            "content": "Trước đó, bạn đã chọn Zoom Workplace dành cho Kinh doanh cho phép tối đa 300 người tham gia mỗi cuộc họp, Zoom Scheduler và nhiều tính năng khác. Bạn vẫn muốn chuyển sang gói Chuyên nghiệp?",
            "confirm": "Xác nhận thay đổi",
            "keep_current": "Giữ gói hiện tại"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} sản phẩm"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Đóng",
          "cancel": "Hủy",
          "edit": "Chỉnh sửa",
          "got_it": "Đã hiểu"
        },
        "title": {
          "everything_in_and": "Mọi dịch vụ đều có trong {0} và:"
        },
        "tag": {
          "new": "MỚI",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Tính năng hạn chế",
        "pro_plus": {
          "host_meeting_up_to_participants": "Tổ chức cho tối đa {0} người tham gia",
          "gb_of_cloud_recording_storage": "{0}GB bộ nhớ lưu trữ bản ghi lại trên đám mây (cho mỗi giấy phép)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion để tạo và dịch nội dung",
            "features_item2": "Không giới hạn số lượng tài liệu được chia sẻ với nhóm của bạn",
            "features_item3": "Truy cập lịch sử phiên bản không giới hạn",
            "comparison_table_tips": "Thúc đẩy cộng tác với tài liệu tập trung vào AI, tự động chuyển đổi nội dung cuộc họp thành các tài liệu, wiki và dự án hữu ích"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Cơ bản",
            "features_item1": "Tự động phát hiện công việc từ các cuộc họp, cuộc gọi điện thoại, cuộc trò chuyện và tài liệu của bạn",
            "features_item2": "Nhận trợ giúp để hoàn thành công việc, chẳng hạn như lên lịch cuộc họp tiếp theo và soạn thảo tài liệu",
            "features_item3": "Đánh dấu hoàn thành công việc một cách dễ dàng khi làm xong để theo dõi tiến độ và tập trung vào những việc tiếp theo",
            "features_item4": "Quản lý các công việc trên toàn bộ nền tảng Zoom Workplace, bao gồm Zoom Docs",
            "features_item1_opc": "Tận dụng sức mạnh của AI Companion để xác định và tạo công việc từ các cuộc trò chuyện, email, tài liệu, bảng trắng và tóm tắt cuộc họp của bạn",
            "features_item2_opc": "Dễ dàng sắp xếp, lọc, nhóm và tìm kiếm để nhanh chóng truy cập và thu thập thông tin về công việc của bạn",
            "learn_more_header": "Theo dõi các mục hành động của bạn thông qua AI Companion* để hoàn thành nhiều việc hơn trên toàn bộ Zoom Workplace.",
            "learn_more_footer": "\*AI Companion chỉ khả dụng cho các gói Zoom Workplace Chuyên nghiệp, Zoom Workplace dành cho Kinh doanh và Doanh nghiệp lớn.",
            "features_prefix": "Hãy để AI Companion giúp bạn:",
            "comparison_table_tips": "Theo dõi các mục hành động và hoàn thành chúng đúng hạn với giải pháp ưu tiên sử dụng AI cung cấp các đề xuất công việc dựa trên các cuộc trò chuyện và tóm tắt cuộc họp trong Zoom Workplace.",
            "tasks_label_text": " Quản lý công việc ưu tiên sử dụng AI"
          },
          "title": "Kinh doanh Nâng cao",
          "contact_us_for_more_pricing": "Liên hệ với chúng tôi để biết thêm thông tin về mức giá và hơn thế nữa",
          "contact_sales": "Li\u00EAn h\u1EC7 kinh doanh",
          "meetings": "Cu\u1ED9c h\u1ECDp",
          "phone": "\u0110i\u1EC7n tho\u1EA1i",
          "phone_sub_title": "Kh\u00F4ng gi\u1EDBi h\u1EA1n cu\u1ED9c g\u1ECDi",
          "use_only": "Chỉ sử dụng cho mục đích kinh doanh",
          "team_chat": {
            "title": "Trò chuyện nhóm",
            "title_desc": "Trò chuyện nhóm và chia sẻ tệp"
          },
          "cloud_storage": {
            "title": "L\u01B0u tr\u1EEF \u0111\u00E1m m\u00E2y"
          },
          "mail_calender": {
            "title": "Thư và lịch"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Máy khách và dịch vụ"
          },
          "up_to_30_hours_per_meeting": "tối đa 30 tiếng mỗi cuộc họp",
          "300_attendees": "300 người dự thính",
          "per_meeting": "mỗi cuộc họp",
          "whiteboard": {
            "title": "Bảng trắng"
          },
          "new": "MỚI",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "Dịch vụ bổ sung",
          "sso_managed_domains_more": "Đăng nhập một lần, tên miền được quản lý, v.v.",
          "scheduler": "Trình đặt lịch",
          "global_select": "Global Select",
          "unlimited_regional": "Không giới hạn cho gọi trong khu vực",
          "translated_captions": "Phụ đề đã dịch",
          "workspace_reservation": "Đặt trước không gian làm việc",
          "auto_translated_captions": "Phụ đề tự động và phụ đề đã dịch",
          "unlimited_editable_boards": "Bảng có thể chỉnh sửa không giới hạn",
          "standard_features": "Tính năng tiêu chuẩn",
          "advanced_docu_controls": "Điều khiển văn bản nâng cao",
          "chats_channels_for_collaboration": "Trò chuyện và các kênh để cộng tác, chia sẻ tệp và nhiều tính năng khác",
          "zoom_phone_is_biz_use_only": "Zoom Phone chỉ dành cho mục đích kinh doanh",
          "unlimited_regional_calling": "G\u1ECDi trong khu v\u1EF1c kh\u00F4ng gi\u1EDBi h\u1EA1n",
          "domestic_sms_mms": "SMS & MMS n\u1ED9i \u0111\u1ECBa",
          "automatic_call_distribution_groups": "Nh\u00F3m Ph\u00E2n b\u1ED5 cu\u1ED9c g\u1ECDi t\u1EF1 \u0111\u1ED9ng (ADC) c\u00F3 t\u00EDnh n\u0103ng h\u00E0ng \u0111\u1EE3i cu\u1ED9c g\u1ECDi",
          "single_sign_on": "\u0110\u0103ng nh\u1EADp m\u1ED9t l\u1EA7n",
          "managed_domains": "T\u00EAn mi\u1EC1n \u0111\u01B0\u1EE3c qu\u1EA3n l\u00FD",
          "company_branding": "Qu\u1EA3ng b\u00E1 th\u01B0\u01A1ng hi\u1EC7u c\u00F4ng ty",
          "mail_calender_client_services_beta": "Máy khách và dịch vụ thử nghiệm cho thư và lịch",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Không giới hạn số cuộc họp với thời lượng tối đa 30 tiếng cho mỗi cuộc họp",
          "mail_and_calendar_client_and_services_beta": "Máy khách và dịch vụ thử nghiệm cho thư và lịch",
          "easily_record_edit_share_videos": "Dễ dàng ghi, chỉnh sửa và chia sẻ các video có định dạng ngắn",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Tạo và chia sẻ tài liệu có thể chỉnh sửa trong Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Dễ dàng chia sẻ khung thời gian họp để dễ dàng đặt chỗ",
          "works_with_zoom_meeting_mail_calender_google_ms": "Làm việc với Zoom Meetings, Zoom Mail và Zoom Calendar, Google và Microsoft 365",
          "up_to_300_attendees": "Tối đa 300 người dự thính",
          "10_gb_of_storage": "10 GB lưu trữ",
          "host_meeting_up_to_300_participants": "T\u1ED5 ch\u1EE9c cu\u1ED9c h\u1ECDp l\u00EAn t\u1EDBi 300 ng\u01B0\u1EDDi tham gia",
          "10_gb_of_cloud_recording_storage": "Bản ghi lưu trữ trên đám mây với dung lượng 10 GB (cho mỗi giấy phép)",
          "starting_at_licenses_year": "B\u1EAFt \u0111\u1EA7u v\u1EDBi {1} gi\u1EA5y ph\u00E9p v\u1EDBi m\u1EE9c gi\u00E1 {0}/n\u0103m",
          "starting_at_licenses_month": "B\u1EAFt \u0111\u1EA7u v\u1EDBi {1} gi\u1EA5y ph\u00E9p v\u1EDBi m\u1EE9c gi\u00E1 {0}/th\u00E1ng",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Truy cập nhanh chóng vào bản tóm tắt cuộc họp, nhận trợ giúp soạn tin nhắn, v.v.",
          "learn_more": "T\u00ECm hi\u1EC3u th\u00EAm",
          "essential_apps": "Ứng dụng thiết yếu",
          "increase_team_collaboration": "Tăng cường cộng tác nhóm và năng suất",
          "free_premium_apps": "Ứng dụng cao cấp miễn phí trong 1 năm (có áp dụng điều khoản)",
          "visitor_management": "Quản lý khách truy cập",
          "visitor_management_custom_invites": "Tùy chỉnh lời mời",
          "visitor_management_visitor_check": "Xác nhận có mặt tại quầy",
          "visitor_management_receive_detailed": "Nhận số liệu chi tiết về mức sử dụng không gian của khách"
        },
        "custom_avatar": {
          "title": "Ảnh đại diện Tùy chỉnh",
          "label_text": "3 phút mỗi tháng",
          "basic_feature": "1 phút xuyên suốt gói",
          "pricing_feature": "3 phút mỗi tháng",
          "learn_more_subtitle": "Tạo phiên bản AI chân thật của riêng bạn bằng tính năng sao chép giọng nói và giao tiếp đa ngôn ngữ.",
          "features_item1": "Tạo tối đa 3 ảnh đại diện kỹ thuật số chân thật mỗi tháng để mô phỏng ngoại hình và giọng nói của bạn cho các bài thuyết trình và bản demo",
          "features_item2": "Sử dụng ảnh đại diện của bạn để cung cấp các kịch bản dài tới 3 minutes với AI Companion",
          "features_item3": "Chọn từ 18 ảnh đại diện được thiết kế sẵn để tạo video nhanh chóng, chất lượng cao",
          "features_item4": "Tận hưởng hỗ trợ nền ảo",
          "features_item1_opc": "Tạo tối đa 3 ảnh đại diện kỹ thuật số chân thật mỗi tháng để mô phỏng ngoại hình và giọng nói của bạn cho các bài thuyết trình và bản demo",
          "features_item2_opc": "Sử dụng ảnh đại diện của bạn để cung cấp các kịch bản dài tới 3 minutes với AI Companion",
          "comparison_table_tips": "Ảnh đại diện Tùy chỉnh tạo ra phiên bản AI chân thật của riêng bạn bằng tính năng sao chép giọng nói và giao tiếp đa ngôn ngữ."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Truy cập nhanh chóng vào bản tóm tắt cuộc họp, nhận trợ giúp soạn tin nhắn, v.v.",
        "learn_more_dialog": {
          "desc": "Làm được nhiều việc hơn với AI Companion! Trợ lý này có thể viết nội dung, lên lịch cuộc họp, giúp quản lý dự án và hơn thế nữa.",
          "tip1": "Nhận trước chương trình để có thể chủ trì cuộc họp hiệu quả hơn",
          "tip2": "Đảm bảo các dự án đi đúng lộ trình nhờ tính năng tạo nhiệm vụ và thông báo tự động",
          "tip3": "Nhận trợ giúp sắp xếp lịch và quản lý thời gian",
          "tip4": "Tạo nội dung văn bản và hình ảnh phù hợp với phong cách của bạn trong Docs, Whiteboard hoặc trong ứng dụng Zoom Workplace"
        },
        "top_features": "Các tính năng hàng đầu",
        "more_to_come": "Chờ đón nhiều tính năng tuyệt vời khác sắp ra mắt!",
        "discover_more": "Khám phá nhiều cách hơn nữa để hoàn thành công việc tốt nhất với AI Companion!",
        "detail_desc": "AI Companion được cung cấp kèm theo các dịch vụ trả phí trong tài khoản người dùng Zoom mà không tính thêm phí. Có thể không dành cho các phân khúc và vị trí địa lý nhất định."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/năm/giấy phép",
        "month_licnese": "/tháng/giấy phép",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/tháng",
          "per_year": "/năm"
        },
        "unit": {
          "license": "{0}/giấy phép",
          "user": "{0}/người dùng"
        },
        "learn_more": "Tìm hiểu thêm",
        "required": "Bắt buộc",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Mở rộng phạm vi tiếp cận bằng cách tăng số lượng người tham gia tới 1.000 người.",
          "label_title1": "500 người dự thính",
          "label_title2": "1000 người dự thính"
        },
        "cmr": {
          "features_tip": "Lưu trữ, truyền phát và tải xuống các bản ghi video của bạn trực tiếp từ Zoom Cloud.",
          "explain_desc": "Lưu trữ trên đám mây có sẵn trong các gói Zoom One chọn lọc: Chuyên nghiệp (5 GB), Kinh doanh (5 GB), Kinh doanh Nâng cao (10 GB) và Doanh nghiệp lớn (Không giới hạn)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 giờ",
          "option_label2": "≈ 650 giờ",
          "option_label3": "≈ 3,500 giờ",
          "option_label4": "≈ 17,500 giờ",
          "intro_label2": "Tùy chọn lưu trữ bao gồm tối đa 5 TB/tháng",
          "tooltip_content": "Dung lượng lưu trữ bản ghi thay đổi tùy theo số người tham gia bật video, độ phân giải của cuộc họp và độ phân giải của nội dung được chia sẻ."
        },
        "whiteboard": {
          "plus_title": "Bảng trắng Nâng cao",
          "title": "Whiteoard",
          "features_tip": "Cộng tác với người khác theo thời gian thực trên bảng trắng, cả trong và ngoài cuộc họp.",
          "explain_desc": "Được bao gồm trong Zoom One Kinh doanh, Zoom One Kinh doanh Nâng cao và Zoom One Doanh nghiệp lớn",
          "explain_desc_plus": "Có sẵn trong Zoom One dành cho Doanh nghiệp lớn Nâng cao và với mỗi gói đăng ký Zoom Rooms",
          "option_label1": "Bảng không giới hạn với Dung lượng lưu trữ trên đám mây là 1 GB.",
          "option_label2": "Các tính năng nâng cao có số bảng và Dung lượng lưu trữ trên đám mây không giới hạn",
          "intro_label1": "Bảng trắng có thể chỉnh sửa đồng thời không giới hạn",
          "intro_label2": "Tính năng tiêu chuẩn và khả năng kiểm soát tài liệu nâng cao",
          "intro_label3": "Các tính năng bảng trắng nâng cao, bao gồm các mẫu tùy chỉnh, mẫu dành cho tổ chức và các thành phần tích hợp bên thứ ba"
        },
        "translated_captions": {
          "features_tip": "Hỗ trợ cộng tác toàn cầu với phụ đề tự động bằng ngôn ngữ ưu tiên của bạn.",
          "intro_label1": "Người tham gia có thể tự bật phụ đề và chuyển đổi ngôn ngữ.",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "Xem các ngôn ngữ được hỗ trợ"
        },
        "crc": {
          "features_tip": "Cho phép bất kỳ điểm cuối hội nghị video SIP/H.323 theo tiêu chuẩn nào để làm việc hiệu quả theo hình thức kết hợp.",
          "intro_label1": "Làm việc với nhiều điểm cuối cũ bao gồm Polycom, Cisco, Lifesize và các điểm cuối khác",
          "intro_label2": "Trình kết nối phòng dựa trên đám mây hoặc tại chỗ (VM)"
        },
        "scheduler": {
          "simplify_bookings": "Đơn giản hóa việc đặt lịch nhờ trạng thái rảnh/bận linh hoạt và khung thời gian tùy chỉnh được",
          "host_one_on_one": "Tổ chức cuộc họp 1:1 hoặc cuộc họp nhóm bằng một đường liên kết duy nhất dễ dàng chia sẻ",
          "customize_reminders": "Tùy chỉnh lời nhắc qua email/SMS để giảm thiểu việc lỡ hẹn",
          "sync_calendars": "Đồng bộ hóa lịch liền mạch với các thành phần tích hợp của Google, Microsoft 365 và Zoom",
          "features_tip": "Dễ dàng chia sẻ thời gian họp trong giờ hành chính, phỏng vấn và hơn thế nữa.",
          "intro_label1": "Tích hợp lịch",
          "intro_label2": "Tính khả dụng định kỳ",
          "intro_label3": "Cuộc họp có thể mở rộng",
          "intro_label4": "Thông báo tùy chỉnh",
          "intro_sub_label1": "Google, Microsoft 365 và Zoom ",
          "intro_sub_label2": "chia sẻ khung thời gian có thể đặt chỗ ",
          "intro_sub_label3": "một cuộc họp duy nhất cho một hoặc nhiều người tham gia",
          "intro_sub_label4": "tự động nhắc và xác nhận qua email hoặc SMS"
        },
        "zoom_clips_plus": {
          "features_tip": "Ghi lại, chỉnh sửa và chia sẻ tin nhắn video ngắn gọn, chất lượng cao.",
          "intro_label1": "Tạo số lượng video không giới hạn mà không bị hạn chế thời gian",
          "intro_label2": "Chụp màn hình và video cùng nhau hoặc riêng biệt",
          "intro_label3": "Cắt gọn video nếu cần và chia sẻ liên kết",
          "intro_label4": "Truy cập các tính năng nâng cao như bản phiên âm và số liệu thống kê",
          "explain_desc": "Clips Nâng cao có sẵn trong các gói đăng ký Workplace Chuyên nghiệp, Kinh doanh và dành cho Doanh nghiệp lớn. Bạn có thể khám phá các tính năng khác nhau của từng gói trong phần so sánh trên trang định giá."
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Tổ chức các sự kiện ảo kéo dài nhiều ngày với nhiều phòng",
          "events_feature_item2_20240827": "Thúc đẩy kết nối mạng lưới với hồ sơ người dự thính và trò chuyện ở phòng đợi",
          "events_feature_item3_20240827": "Hướng dẫn người dự thính bằng phát trực tuyến phiên ở phòng đợi",
          "events_feature_item4_20240827": "Tăng doanh thu sự kiện với khu vực triển lãm và tài trợ",
          "events_feature_item5_20240827": "Cải thiện các sự kiện trong tương lai bằng khảo sát sau hội nghị",
          "events_feature_item6_20240827": "Tăng tốc quá trình cài đặt sự kiện bằng các mẫu sự kiện tuyển chọn",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Nâng tầm các buổi hội thảo trực tuyến với các cảnh tùy chỉnh và quảng bá thương hiệu",
          "sessions_feature_item2_20240827": "Đơn giản hóa việc lập kế hoạch sự kiện với AI Companion để tạo ra thông điệp và hình ảnh",
          "sessions_feature_item3_20240827": "Quảng bá các sự kiện đã qua và sắp tới trong một trung tâm nội dung có thương hiệu",
          "sessions_feature_item4_20240827": "Tổ chức các sự kiện chuyên nghiệp với Hậu trường, Phát trực tiếp mô phỏng và Giao thức nhắn tin thời gian thực",
          "sessions_feature_item5_20240827": "Cải thiện các buổi hội thảo trực tuyến trong tương lai bằng thông tin chi tiết từ nhiều sự kiện",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Đăng ký hàng tháng",
          "annual_subscription": "Đăng ký hàng năm",
          "one_million": "1 triệu",
          "single_use": "Sử dụng một lần",
          "one_month": "Một tháng",
          "event_attendee": "Người dự thính của Zoom Events/Sessions:",
          "event_attendee_desc": "Bất kỳ ai tham gia mà không phải là người chủ trì được cấp phép trên trung tâm. Những vai trò đặc biệt cũng được tính là người dự thính và có thể tham gia bằng cách chia sẻ âm thanh, video và màn hình (nếu tính năng được bật).",
          "webinar_attendee": "Người dự thính của Zoom Webinars:",
          "webinar_attendee_desc": "Bất kỳ ai tham gia không phải là người chủ trì hoặc tham luận viên. Người dự thính được thiết lập ở chế độ chỉ xem và được kiểm soát bởi người chủ trì. Người chủ trì cuộc họp có thể bỏ tắt tiếng và cho phép họ tương tác thông qua mục Hỏi đáp và trò chuyện.",
          "pay_per_attendee": "Thanh toán theo số người dự thính",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone không giới hạn tại Úc và New Zealand",
          "intro_label8_JP": "Zoom Phone không giới hạn tại Nhật Bản",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Gói đặc quyền Zoom Phone",
          "features_tip": "Số liệu phân tích hàng đợi cuộc gọi được nâng cao và thông tin chuyên sâu trước đây cho các nhóm tổng đài.",
          "intro_label1": "Mở rộng cửa sổ danh bạ để tạo thuận lợi cho việc xử lý cuộc gọi",
          "intro_label2": "Tổng đài tự động và số điện thoại trong hàng đợi cuộc gọi"
        },
        "international_calling": {
          "title": "Gói gọi quốc tế",
          "features_tip": "Gọi quốc tế không giới hạn tới hơn 15 quốc gia và khu vực.",
          "intro_label1": "Có thể được mua cùng với bất kỳ gói cuộc gọi không giới hạn nào",
          "intro_label2": "Khám phá danh sách các quốc gia và khu vực được chúng tôi hỗ trợ gọi quốc tế không giới hạn.",
          "intro_labe2_tooltip": "Hoa Kỳ, Canada, Anh, Ireland, Úc, New Zealand, Áo, Đan Mạch, Pháp, Đức, Ý, Bồ Đào Nha, Tây Ban Nha, Thụy Điển, Bỉ, Hà Lan, Thụy Sĩ, Puerto Rico và Nhật Bản.",
          "intro_label2_view_list": "Xem danh sách"
        },
        "workspace_reservation": {
          "title": "Đặt trước không gian làm việc",
          "intro_title": "Dễ dàng đặt trước không gian làm việc linh hoạt hoặc đặt trước phòng khách sạn hay đặt phòng tại chỗ bằng các thiết bị tích hợp Zoom.",
          "intro_label1": "Truy cập không gian làm việc và đặt phòng khách sạn thông qua ứng dụng Zoom Workplace, máy tính để bàn hoặc trình duyệt",
          "intro_label2": "Nhận các đề xuất bàn làm việc dành riêng cho bạn với sự trợ giúp của AI",
          "intro_label3": "Đặt trước không gian làm việc trực tiếp từ Lịch Google hoặc Outlook, có lời nhắc và cảnh báo khi xác nhận có mặt",
          "intro_label4": "Điều hướng đến không gian làm việc đã đặt trước bằng tính năng tìm đường"
        },
        "visitor_management": {
          "title": "Quản lý khách thăm",
          "intro_title": "Tối ưu hóa quy trình xác nhận có mặt của khách truy cập bằng lời mời tùy chỉnh, xác nhận có mặt tại quầy dễ dàng, báo cáo và số liệu.",
          "intro_label1": "Quản lý lời mời, vị trí của khách truy cập và lịch sử truy cập trong cổng thông tin Zoom",
          "intro_label2": "Tạo, theo dõi, gửi lại và xóa lời mời trong khi nhận thông báo về sự xuất hiện của khách",
          "intro_label3": "Hoàn thành biểu mẫu, nhận chỉ dẫn và xác nhận có mặt thông qua quầy để khách thăm có trải nghiệm thoải mái",
          "intro_label4": "Truy cập tất cả các tính năng trong cổng thông tin Zoom quen thuộc để quản lý dễ dàng"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Cuộc họp lớn",
          "description1": "Tăng dung lượng cuộc họp để hỗ trợ lên đến 1.000 người tham gia tương tác trực tiếp",
          "description2": "Tất cả người tham gia có thể chia sẻ âm thanh, video và màn hình của mình"
        },
        "cloud_storage": {
          "title": "Lưu trữ trên đám mây",
          "description2": "Có sẵn định dạng tệp MP4 hoặc M4A"
        },
        "translated_captions": {
          "title": "Phụ đề đã dịch",
          "description1": "Nâng cao chất lượng cuộc họp với các phụ đề tự động, đa ngôn ngữ cho phép người tham gia bật và chuyển sang ngôn ngữ được hỗ trợ",
          "description2": "Sẵn có trong Zoom Meetings và Zoom Webinars"
        },
        "tollfree": {
          "title": "Hội nghị âm thanh",
          "subcontent": "Quay số gọi vào cuộc họp bằng số điện thoại từ khắp nơi trên thế giới",
          "description1": "Mở rộng tùy chọn cuộc gọi với tính năng triệu tập, quay số truy cập miễn cước toàn cầu và địa phương đối với các quốc gia cao cấp",
          "description2": "Người tham gia có thể gọi đến miễn phí từ bất kỳ thiết bị nào",
          "description3": "Dễ dàng chọn một hoặc nhiều quốc gia để thực hiện cuộc gọi đi miễn cước"
        },
        "rc": {
          "title": "Trình kết nối phòng hội nghị Zoom"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Úc",
        "Austria": "Áo",
        "Belgium": "Bỉ",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "Trung Quốc",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Síp",
        "Czech_Republic": "Cộng hòa Séc",
        "Denmark": "Đan Mạch",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Phần Lan",
        "France": "Pháp",
        "Germany": "Đức",
        "Greece": "Hy Lạp",
        "Hong_Kong_SAR": "Đặc khu hành chính Hồng Kông",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Ý",
        "Japan": "Nhật Bản",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Hà Lan",
        "New_Zealand": "New Zealand",
        "Norway": "Na Uy",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Ba Lan",
        "Portugal": "Bồ Đào Nha",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "Nam Phi",
        "Spain": "Tây Ban Nha",
        "Sweden": "Thụy Điển",
        "Switzerland": "Thụy Sĩ",
        "UK": "Vương quốc Anh",
        "United_Kingdom": "Vương quốc Anh",
        "US": "Hoa Kỳ",
        "United_States": "Hoa Kỳ",
        "title": "Các yêu cầu đối với số điện thoại",
        "subtitle": "Vui lòng chọn quốc gia nơi số điện thoại gói Chọn lọc Toàn cầu của bạn sẽ được kích hoạt.",
        "selector_tip": "Chọn quốc gia",
        "local_and_toll_free": "Số điện thoại địa phương và số miễn cước có sẵn tại {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Gói Chọn lọc Toàn cầu bao gồm một số điện thoại và cuộc gọi nội địa không giới hạn trong quốc gia được chọn cho mỗi giấy phép.",
        "avail_title": "Các quốc gia/vùng lãnh thổ có sẵn"
      },
      "tax_exempt_ecm": {
        "title": "Tình trạng miễn thuế",
        "status_exempt": "Miễn thuế",
        "status_exempt_question": "Miễn thuế?",
        "verify_now": "Xác minh ngay",
        "can_after_checkout": "Là một tùy chọn, bước này có thể được hoàn thành sau khi thanh toán.",
        "status": {
          "exempt": "Miễn",
          "pending": "Đang chờ",
          "pendingTooltip": "Tình trạng miễn thuế của bạn hiện đang được xem xét. Bạn có thể phải trả thuế khi đặt hàng. Nếu đơn miễn trừ của bạn được chấp thuận, chúng tôi sẽ ghi có tất cả các khoản thuế/phí có thể hoàn lại vào tài khoản của bạn.",
          "nonexempt": "Không miễn",
          "rejected": "Đã từ chối",
          "rejectedTooltip": "Tài liệu đã nộp được xác định là không đáp ứng các yêu cầu cho khu vực pháp lý của bạn.",
          "approved": "Đã duyệt",
          "default": "mặc định"
        },
        "confirm_close": {
          "new_desc": "Nếu bạn bỏ dở việc xác minh, bạn có thể phải trả các khoản thuế/phí liên quan. Bạn vẫn có thể gửi chứng từ miễn thuế trong phần Quản lý thanh toán sau khi mua để Zoom xem xét và phê duyệt. Chúng tôi sẽ hoàn lại mọi khoản thuế đã thu sau khi xác thực thành công.",
          "desc": "Bạn có chắc chắn muốn hủy xác minh miễn thuế và tiếp tục khi đủ điều kiện thuế không?",
          "title": "Bạn chắc chắn không?",
          "new_title": "Bỏ xác minh miễn thuế?",
          "yes": "Có, hủy",
          "no": "Không, tiếp tục",
          "abandon": "Bỏ qua xác minh",
          "go_back": "Trở về"
        },
        "confirm_to_add": {
          "title": "Xác nhận miễn thuế mặc định mới",
          "message": "Việc thêm một miễn trừ mới sẽ tự động đặt miễn trừ đó làm miễn trừ mặc định sau khi được chấp thuận hoặc từ chối. Bạn chỉ có thể có một miễn trừ mặc định và miễn trừ này sẽ được áp dụng cho các lần mua hàng trong tương lai. Số tiền thuế của bạn có thể bị ảnh hưởng nếu mức miễn trừ mặc định không khớp với tiểu bang/khu vực “Người mua” của bạn.",
          "yes": "Thêm miễn trừ mới"
        },
        "confirm_set_default": {
          "title": "Địa chỉ và miễn thuế không khớp",
          "message": "Địa chỉ \"Thông tin liên hệ của người mua\" của bạn không khớp với tiểu bang/khu vực bạn đã chọn để miễn thuế. Vui lòng cập nhật địa chỉ \"Thông tin liên hệ của người mua\" của bạn để khớp với địa điểm miễn thuế. Nếu không, giao dịch mua của bạn có thể không được miễn thuế.",
          "yes": "Vẫn đặt làm mặc định",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "Tiểu bang/Khu vực",
          "exemption_type": "Loại miễn trừ",
          "signed_date": "Ngày ký",
          "status": "trạng thái",
          "add_exemption": "Thêm miễn trừ",
          "view": "Xem",
          "set_as_default": "Đặt làm mặc định"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Gói {planName} của bạn sẽ bị hủy vào ngày {date} lúc 12:00 sáng theo Giờ Phối hợp Quốc tế. Nếu bạn muốn tổ chức họp sau ngày hủy, vui lòng kích hoạt lại gói của bạn.",
        "pairPreDescTip": "Gói {planName1} và gói {planName2} của bạn sẽ bị hủy vào ngày {date} lúc 12:00 sáng theo Giờ Phối hợp Quốc tế. Nếu bạn muốn tổ chức họp sau ngày hủy, vui lòng kích hoạt lại các gói của bạn.",
        "pairDiffDatePreDescTip": "Gói {planName1} và gói {planName2} của bạn sẽ bị hủy vào ngày {date1} lúc 12:00 sáng theo Giờ Phối hợp Quốc tế và ngày {date2} lúc 12:00 sáng theo Giờ Phối hợp Quốc tế. Nếu bạn muốn tổ chức họp sau ngày hủy, vui lòng kích hoạt lại các gói của bạn.",
        "title": "Kích hoạt lại gói dịch vụ để tiếp tục",
        "titles": "Kích hoạt lại các gói dịch vụ của bạn để tiếp tục",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Chu kỳ thanh toán",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "Bằng cách kích hoạt lại, bạn đồng ý rằng gói dịch vụ định kỳ của bạn sẽ tự động gia hạn vào ngày {date} và bạn sẽ được tính phí theo phương thức thanh toán mình đã lưu vào mỗi kỳ gia hạn. Để ngừng các khoản phí trong tương lai, hãy <a target=\"_blank\" href=\"https://support.zoom.com/hc/vi/article?id=zm_kb&sysparm_article=KB0066687\">hủy</a> gói đăng ký của mình ít nhất 1 ngày trước ngày gia hạn.",
        "pairDescTip": "Bằng cách kích hoạt lại, bạn đồng ý rằng các gói dịch vụ định kỳ của bạn sẽ tự động gia hạn vào ngày {date}. Bạn sẽ được tính phí theo phương thức thanh toán mình đã lưu vào mỗi kỳ gia hạn. Để ngừng các khoản phí trong tương lai, hãy <a target=\"_blank\" href=\"https://support.zoom.com/hc/vi/article?id=zm_kb&sysparm_article=KB0066687\">hủy</a> gói đăng ký của mình ít nhất 1 ngày trước ngày gia hạn.",
        "pairDiffDateDescTip": "Bằng cách kích hoạt lại, bạn đồng ý rằng các gói dịch vụ định kỳ của bạn sẽ tự động gia hạn vào ngày {date1} và {date2}. Bạn sẽ được tính phí theo phương thức thanh toán mình đã lưu vào mỗi kỳ gia hạn. Để ngừng các khoản phí trong tương lai, hãy <a target=\"_blank\" href=\"https://support.zoom.com/hc/vi/article?id=zm_kb&sysparm_article=KB0066687\">hủy</a> gói đăng ký của mình ít nhất 1 ngày trước ngày gia hạn.",
        "totalLabel": "Tổng cộng",
        "totalContent": "{money} cộng thêm các khoản thuế áp dụng",
        "taxDesc": "không bao gồm VAT, GST hoặc các loại thuế tương tự",
        "reactivateBtn": "Tiến hành và kích hoạt lại",
        "switchTitle": "Cập nhật gói dịch vụ của bạn để tiếp tục",
        "successSingleTip": "Gói {planName} của bạn đã được kích hoạt lại",
        "successPairTip": "Gói {planName1} và {planName2} của bạn đã được kích hoạt lại",
        "switchTip": "Gói Zoom Webinars Một tháng của bạn sẽ hết hạn vào ngày {date}. Để tổ chức hội thảo trực tuyến sau ngày này, bạn phải chuyển sang đăng ký.",
        "switchBtn": "Chuyển sang Đăng ký"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "T\u1EA3i xu\u1ED1ng B\u1EA3ng d\u1EEF li\u1EC7u"
      },
      "one": {
        "new": "MỚI"
      }
    },
    "webinarSetupInWebPortal": "Thiết lập hội thảo trực tuyến trong cổng web",
    "concurrentEvents": "Sự kiện đồng thời",
    "coucurrentEventsToolTip": "<span><b>Gói đăng ký</b> chỉ hỗ trợ một sự kiện trực tiếp tại một thời điểm",
    "overages": "Sử dụng vượt mức",
    "eventsPlatformHubs": "Trung tâm nền tảng sự kiện",
    "eventsHubToolTip": "<b>Trung tâm</b> Zoom Events cho phép tổ chức sự kiện một cách tiện lợi",
    "1HubPerLicense": "1 trung tâm cho mỗi giấy phép",
    "1000Hubs": "1000 trung tâm",
    "eventsPlatformHosts_500AttendeesOrMore": "Người chủ trì nền tảng sự kiện (500 người dự thính trở lên)",
    "eventsHost500": "<b>Người chủ trì trung tâm</b><span>Zoom Events có thể tạo",
    "5HubHosts": "5 người chủ trì trung tâm",
    "100HubHosts": "100 người chủ trì trung tâm",
    "eventsPlatformHosts_100Attendees": "Người chủ trì nền tảng sự kiện (100 người dự thính)",
    "eventsHost100": "<b>Người chủ trì trung tâm</b><span>Zoom Events có thể tạo",
    "2HubHosts": "2 người chủ trì trung tâm",
    "howAreTheyDifferent": "Chúng khác nhau như thế nào?",
    "allPlansRequireAZoomOneLicense": "*Tất cả các gói đều yêu cầu có giấy phép Zoom Workplace",
    "subscription": "Gói đăng ký",
    "subscriptionToolTip": "<span><b>Gói đăng ký</b>cho phép bạn chủ trì số cuộc họp không giới hạn với số lượng người tham gia do bạn chọn.</span>",
    "payPerAttendee": "Thanh toán theo số người dự thính",
    "ppaToolTips": "<span>Giấy phép <b>thanh toán theo số người dự thính</b> xác định tổng số người dự thính có thể tham dự mọi sự kiện trong tài khoản của bạn được tổ chức trong vòng 12 tháng kể từ ngày mua.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "B\u00ECnh ch\u1ECDn",
    "meetings.fullPlanItem2": "S\u1ED1 l\u01B0\u1EE3ng gi\u1EA5y ph\u00E9p",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Hội nghị video và tin nhắn đơn giản trên mọi thiết bị",
    "meetings.fullPlanItem5": "Th\u1EDDi l\u01B0\u1EE3ng cu\u1ED9c h\u1ECDp",
    "meetings.fullPlanItem5Tip": "Th\u1EDDi l\u01B0\u1EE3ng cho ph\u00E9p t\u1ED1i \u0111a v\u1EDBi m\u1ED7i cu\u1ED9c h\u1ECDp nh\u00F3m (t\u1EEB 3 ng\u01B0\u1EDDi tham gia tr\u1EDF l\u00EAn)",
    "meetings.fullPlanItem5_basic": "40 ph\u00FAt",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 gi\u1EDD",
    "meetings.fullPlanItem5_biz": "30 gi\u1EDD",
    "meetings.fullPlanItem5_ent": "30 gi\u1EDD",
    "meetings.fullPlanItem1": "S\u1EE9c ch\u1EE9a ng\u01B0\u1EDDi tham gia",
    "meetings.fullPlanItem1Tip": "Ng\u01B0\u1EDDi tham gia l\u00E0 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c m\u1EDDi trong m\u1ED9t cu\u1ED9c h\u1ECDp \u0111\u01B0\u1EE3c l\u00EAn l\u1ECBch b\u1EDFi m\u1ED9t ng\u01B0\u1EDDi c\u00F3 gi\u1EA5y ph\u00E9p cu\u1ED9c h\u1ECDp. Ng\u01B0\u1EDDi tham gia c\u00F3 th\u1EC3 tham gia mi\u1EC5n ph\u00ED v\u00E0o cu\u1ED9c h\u1ECDp t\u1EEB c\u00E1c thi\u1EBFt b\u1ECB \u0111i\u1EC7n tho\u1EA1i, m\u00E1y t\u00EDnh \u0111\u1EC3 b\u00E0n, thi\u1EBFt b\u1ECB di \u0111\u1ED9ng v\u00E0 m\u00E1y t\u00EDnh b\u1EA3ng. Ng\u01B0\u1EDDi tham gia kh\u00F4ng c\u1EA7n t\u00E0i kho\u1EA3n Zoom \u0111\u1EC3 tham gia cu\u1ED9c h\u1ECDp. M\u1ED7i g\u00F3i d\u1ECBch v\u1EE5 \u0111\u1EC1u gi\u1EDBi h\u1EA1n ng\u01B0\u1EDDi tham gia, nh\u01B0ng ng\u01B0\u1EDDi d\u00F9ng c\u00F3 th\u1EC3 t\u0103ng gi\u1EDBi h\u1EA1n n\u00E0y cho c\u00E1c g\u00F3i tr\u1EA3 ph\u00ED b\u1EB1ng vi\u1EC7c mua th\u00EAm g\u00F3i ti\u1EC7n \u00EDch b\u1ED5 sung.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1.000 dành cho Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Ghi l\u1EA1i",
    "meetings.fullPlanItem7Tip": "T\u00EDnh n\u0103ng ghi l\u1EA1i c\u1EE5c b\u1ED9 c\u1EE7a Zoom l\u01B0u c\u00E1c b\u1EA3n ghi cu\u1ED9c h\u1ECDp c\u1EE7a b\u1EA1n \u1EDF \u0111\u1ECBnh d\u1EA1ng MP4 (video), M4A (\u00E2m thanh) v\u00E0 txt (tr\u00F2 chuy\u1EC7n).<br>T\u00EDnh n\u0103ng Ghi l\u1EA1i tr\u00EAn \u0111\u00E1m m\u00E2y Zoom l\u01B0u tr\u1EEF c\u00E1c cu\u1ED9c h\u1ECDp tr\u00EAn Zoom Cloud v\u00E0 ng\u01B0\u1EDDi d\u00F9ng c\u00F3 th\u1EC3 t\u1EA3i xu\u1ED1ng t\u1EC7p tin v\u00E0/ho\u1EB7c ph\u00E1t tr\u1EF1c ti\u1EBFp t\u1EEB tr\u00ECnh duy\u1EC7t.",
    "meetings.fullPlanItem7_basic": "C\u1EE5c b\u1ED9",
    "meetings.fullPlanItem7_pro": "C\u1EE5c b\u1ED9 v\u00E0 5 GB tr\u00EAn \u0111\u00E1m m\u00E2y (tr\u00EAn m\u1ED7i gi\u1EA5y ph\u00E9p)",
    "meetings.fullPlanItem7_biz": "C\u1EE5c b\u1ED9 v\u00E0 10 GB tr\u00EAn \u0111\u00E1m m\u00E2y (tr\u00EAn m\u1ED7i gi\u1EA5y ph\u00E9p)",
    "meetings.fullPlanItem7_ent": "C\u1EE5c b\u1ED9 v\u00E0 kh\u00F4ng gi\u1EDBi h\u1EA1n tr\u00EAn \u0111\u00E1m m\u00E2y",
    "one.messaging": "Tin nhắn",
    "meetings.fullPlanItem16Tip": "T\u00EDnh n\u0103ng Chat cho ph\u00E9p b\u1EA1n d\u1EC5 d\u00E0ng g\u1EEDi v\u0103n b\u1EA3n, t\u1EC7p, \u1EA3nh ch\u1EE5p m\u00E0n h\u00ECnh, \u0111o\u1EA1n m\u00E3, tin nh\u1EAFn tho\u1EA1i v\u00E0 h\u00ECnh \u1EA3nh cho nh\u00F3m. Ng\u01B0\u1EDDi d\u00F9ng c\u00F3 th\u1EC3 \u0111\u1ECBnh d\u1EA1ng v\u0103n b\u1EA3n c\u0169ng nh\u01B0 chia s\u1EBB GIF v\u00E0 bi\u1EC3u t\u01B0\u1EE3ng c\u1EA3m x\u00FAc. Hi\u1EC7n di\u1EC7n hi\u1EC3n th\u1ECB \u0111\u1EC3 cho bi\u1EBFt ng\u01B0\u1EDDi tham gia tr\u00F2 chuy\u1EC7n \u0111ang ho\u1EA1t \u0111\u1ED9ng tr\u00EAn m\u00E1y t\u00EDnh hay thi\u1EBFt b\u1ECB di \u0111\u1ED9ng ho\u1EB7c \u0111ang b\u1EADn h\u1ECDp.",
    "meetings.fullPlanItem51": "B\u1EA3ng tr\u1EAFng Zoom",
    "meetings.unlimited": "Kh\u00F4ng gi\u1EDBi h\u1EA1n",
    "meetings.fullPlanItem_EssentialApp": "Ứng dụng thiết yếu",
    "common.learnMore": "T\u00ECm hi\u1EC3u th\u00EAm",
    "meetings.fullPlanItem_EssentialAppText": "Ứng dụng cao cấp miễn phí trong 1 năm (có áp dụng điều khoản)",
    "zoomMailAndCalendarInTheZoomApp": "Thư và lịch Zoom trong ứng dụng Zoom",
    "mailService": "Dịch vụ thư",
    "emailServiceWithFullTimeEndToEnd": "Dịch vụ email với mã hóa đầu cuối toàn thời gian cho quyền riêng tư nâng cao",
    "customMailDomain": "Miền thư tùy chỉnh",
    "customMailDomainWithMailService": "Miền thư tùy chỉnh với dịch vụ thư",
    "calendarClient": "Máy khách lịch",
    "scheduleAndJoinMeetings": "Lên lịch và tham gia cuộc họp trong ứng dụng Zoom",
    "aiCompanion": "AI Companion",
    "calendarService": "Dịch vụ lịch",
    "meetingSchedulingAndAppointment": "Lên lịch cuộc họp và đặt lịch hẹn",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Phụ đề đã dịch",
    "workspaceReservation": "Đặt trước không gian làm việc",
    "accessAcrossAnyDevice": "Truy cập trên mọi thiết bị",
    "meetings.fullPlanItem4": "Cu\u1ED9c h\u1ECDp kh\u00F4ng gi\u1EDBi h\u1EA1n",
    "meetings.fullPlanItem9": "Quay s\u1ED1 truy c\u1EADp b\u1EB1ng \u0111i\u1EC7n tho\u1EA1i",
    "meetings.fullPlanItem9Tip": "Tham gia cu\u1ED9c h\u1ECDp Zoom th\u00F4ng qua h\u1ED9i ngh\u1ECB t\u1EEB xa/h\u1ED9i ngh\u1ECB \u00E2m thanh (s\u1EED d\u1EE5ng \u0111i\u1EC7n tho\u1EA1i truy\u1EC1n th\u1ED1ng). C\u01B0\u1EDBc ph\u00ED s\u1EBD \u0111\u01B0\u1EE3c t\u00EDnh theo gi\u00F3i \u0111i\u1EC7n tho\u1EA1i c\u1EE7a ng\u01B0\u1EDDi s\u1EED d\u1EE5ng. Th\u1EED d\u00F9ng g\u00F3i ti\u1EC7n \u00EDch b\u1ED5 sung H\u1ED9i ngh\u1ECB \u00E2m thanh c\u1EE7a ch\u00FAng t\u00F4i \u0111\u1EC3 c\u00F3 \u0111\u01B0\u1EE3c s\u1ED1 \u0111i\u1EC7n tho\u1EA1i quay s\u1ED1 truy c\u1EADp mi\u1EC5n c\u01B0\u1EDBc.",
    "meetings.fullPlanItem9_pro": "C\u00F3 t\u00EDnh c\u01B0\u1EDBc",
    "meetings.fullPlanItem9_biz": "C\u00F3 t\u00EDnh c\u01B0\u1EDBc",
    "meetings.fullPlanItem9_ent": "C\u00F3 t\u00EDnh c\u01B0\u1EDBc",
    "meetings.fullPlanItem11": "Chia s\u1EBB m\u00E0n h\u00ECnh",
    "meetings.fullPlanItem11Tip": "Chia s\u1EBB m\u00E0n h\u00ECnh m\u00E1y t\u00EDnh \u0111\u1EC3 b\u00E0n ho\u1EB7c \u1EE9ng d\u1EE5ng. Ng\u01B0\u1EDDi d\u00F9ng tham gia cu\u1ED9c h\u1ECDp \u0111\u01B0\u1EE3c c\u1EA5p gi\u1EA5y ph\u00E9p c\u00F3 th\u1EC3 l\u1EF1a ch\u1ECDn cho ph\u00E9p nhi\u1EC1u ng\u01B0\u1EDDi tham gia \u0111\u1ED3ng th\u1EDDi chia s\u1EBB m\u00E0n h\u00ECnh c\u1EE7a h\u1ECD khi \u0111ang ch\u1EE7 tr\u00EC cu\u1ED9c h\u1ECDp.",
    "meetings.fullPlanItem12": "Ph\u00F2ng theo nh\u00F3m",
    "meetings.fullPlanItem12Tip": "Video ph\u00F2ng theo nh\u00F3m cho ph\u00E9p b\u1EA1n chia cu\u1ED9c h\u1ECDp tr\u00EAn Zoom th\u00E0nh 50 phi\u00EAn ri\u00EAng bi\u1EC7t \u0111\u1EC3 th\u1EA3o lu\u1EADn, l\u1EADp d\u1EF1 \u00E1n, v.v.",
    "meetings.fullPlanItem14": "N\u1EC1n \u1EA3o",
    "meetings.fullPlanItem15": "ID Cu\u1ED9c h\u1ECDp c\u00E1 nh\u00E2n",
    "meetings.fullPlanItem15Tip": "T\u1EA1o ph\u00F2ng h\u1ECDp tr\u1EF1c tuy\u1EBFn c\u1ED1 \u0111\u1ECBnh c\u1EE7a ri\u00EAng b\u1EA1n. B\u1EA1n c\u00F3 th\u1EC3 b\u1EAFt \u0111\u1EA7u cu\u1ED9c h\u1ECDp n\u00E0y b\u1EA5t c\u1EE9 l\u00FAc n\u00E0o ho\u1EB7c l\u00EAn l\u1ECBch \u0111\u1EC3 s\u1EED d\u1EE5ng trong t\u01B0\u01A1ng lai.",
    "meetings.fullPlanItem17": "Ch\u1EE9c n\u0103ng \u0111i\u1EC1u khi\u1EC3n c\u1EE7a ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC",
    "meetings.fullPlanItem18": "\u0110\u1ED3ng ch\u00FA th\u00EDch khi Chia se\u0309 ma\u0300n hi\u0300nh",
    "meetings.fullPlanItem19": "\u0110i\u1EC1u khi\u1EC3n chu\u1ED9t v\u00E0 b\u00E0n ph\u00EDm t\u1EEB xa",
    "meetings.fullPlanItem21": "Nhi\u1EC1u ng\u01B0\u1EDDi chia s\u1EBB",
    "meetings.fullPlanItem29": "Ph\u00F2ng ch\u1EDD",
    "meetings.fullPlanItem29Tip": "T\u00EDnh n\u0103ng ph\u00F2ng ch\u1EDD cho ph\u00E9p ng\u01B0\u1EDDi chu\u0309 tri\u0300 ki\u1EC3m so\u00E1t khi c\u00F3 ng\u01B0\u1EDDi tham gia v\u00E0o cu\u1ED9c h\u1ECDp. Khi l\u00E0 ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC cu\u1ED9c h\u1ECDp, b\u1EA1n c\u00F3 th\u1EC3 ch\u1EA5p nh\u1EADn t\u1EEBng ng\u01B0\u1EDDi m\u1ED9t ho\u1EB7c t\u1EA5t c\u1EA3 ng\u01B0\u1EDDi tham d\u1EF1 c\u00F9ng m\u1ED9t l\u00FAc. Trong ph\u1EA7n c\u00E0i \u0111\u1EB7t, b\u1EA1n c\u00F3 th\u1EC3 ch\u1ECDn ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u0111\u01B0a v\u00E0o Ph\u00F2ng ch\u1EDD hay \u0111\u01B0\u1EE3c ch\u1EA5p nh\u1EADn t\u1EF1 \u0111\u1ED9ng. M\u1ECDi t\u00E0i kho\u1EA3n \u0111\u1EC1u c\u00F3 t\u00EDnh n\u0103ng Ph\u00F2ng ch\u1EDD. Ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC c\u00F3 th\u1EC3 nh\u1EAFn tin cho Ph\u00F2ng ch\u1EDD. B\u1EA1n c\u00F3 th\u1EC3 t\u00F9y ch\u1EC9nh Ph\u00F2ng ch\u1EDD n\u1EBFu b\u1EA1n \u0111ang s\u1EED d\u1EE5ng g\u00F3i tr\u1EA3 ph\u00ED.",
    "meetings.fullPlanItem41": "T\u00EDch h\u1EE3p trong thi\u1EBFt b\u1ECB Zoom for Home",
    "meetings.fullPlanItem61": "Ghim nhi\u1EC1u ng\u01B0\u1EDDi",
    "meetings.fullPlanItem61Tip": "Ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC c\u00F3 th\u1EC3 c\u1EA5p quy\u1EC1n ghim video cho t\u1ED1i \u0111a 9 ng\u01B0\u1EDDi \u0111\u1EC3 h\u1ECD t\u1EA1o ch\u1EBF \u0111\u1ED9 xem t\u00F9y ch\u1EC9nh c\u1EE7a ri\u00EAng m\u00ECnh. V\u00EC v\u1EADy, cho d\u00F9 ng\u01B0\u1EDDi tham gia \u0111ang ph\u00E1t bi\u1EC3u th\u00EC video \u0111\u01B0\u1EE3c ghim v\u1EABn duy tr\u00EC hi\u1EC3n th\u1ECB v\u1EDBi m\u1ECDi ng\u01B0\u1EDDi.",
    "meetings.fullPlanItem62": "Hi\u1EC3n th\u1ECB n\u1ED5i b\u1EADt video c\u1EE7a nhi\u1EC1u ng\u01B0\u1EDDi",
    "meetings.fullPlanItem62Tip": "Ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC c\u00F3 th\u1EC3 hi\u1EC3n th\u1ECB n\u1ED5i b\u1EADt t\u1ED1i \u0111a video c\u1EE7a 9 ng\u01B0\u1EDDi d\u1EF1 th\u00EDnh \u0111\u1EC3 c\u00F3 th\u1EC3 xem c\u00E1c video n\u1ED5i b\u1EADt n\u00E0y b\u1EA5t k\u1EC3 ai \u0111ang ph\u00E1t bi\u1EC3u trong su\u1ED1t cu\u1ED9c h\u1ECDp.",
    "meetings.fullPlanNewItem1": "B\u1ED9 l\u1ECDc",
    "meetings.fullPlanNewItem1Tip": "Mang l\u1EA1i nhi\u1EC1u ni\u1EC1m vui h\u01A1n cho nh\u1EEFng kho\u1EA3ng th\u1EDDi gian, b\u1EEFa ti\u1EC7c v\u00E0 nhi\u1EC1u d\u1ECBp vui v\u1EBB kh\u00E1c v\u1EDBi b\u1ED9 l\u1ECDc m\u00E0u vui nh\u1ED9n ho\u1EB7c nh\u00E3n d\u00E1n \u0111\u1ED9ng v\u1EADt trang tr\u00ED.",
    "meetings.fullPlanNewItem2": "B\u00ECnh ch\u1ECDn",
    "meetings.fullPlanNewItem3": "\u0110\u1ED3ng ch\u1EE7 tr\u00EC v\u00E0 ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC thay th\u1EBF",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">T\u00ECm hi\u1EC3u th\u00EAm v\u1EC1 quy\u1EC1n \u0111i\u1EC1u khi\u1EC3n c\u1EE7a ng\u01B0\u1EDDi \u0111\u1ED3ng ch\u1EE7 tr\u00EC cho cu\u1ED9c h\u1ECDp.</a>",
    "meetings.fullPlanItem24": "Tr\u00ECnh l\u00EAn l\u1ECBch cu\u1ED9c h\u1ECDp",
    "meetings.fullPlanItem24Tip": "Cho ph\u00E9p b\u1EA1n ch\u1EC9 \u0111\u1ECBnh ng\u01B0\u1EDDi kh\u00E1c thi\u1EBFt l\u1EADp cu\u1ED9c h\u1ECDp cho m\u00ECnh. Ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c ch\u1EC9 \u0111\u1ECBnh ph\u1EA3i c\u00F3 g\u00F3i d\u1ECBch v\u1EE5 Cao c\u1EA5p.",
    "meetings.fullPlanItem25": "API REST",
    "meetings.fullPlanItem25Tip": "Cho ph\u00E9p ch\u1EE7 s\u1EDF h\u1EEFu t\u00E0i kho\u1EA3n, qu\u1EA3n tr\u1ECB vi\u00EAn v\u00E0 nh\u00E0 ph\u00E1t tri\u1EC3n c\u1EE7a b\u1EA1n truy c\u1EADp an to\u00E0n v\u00E0o Zoom REST API. Gi\u1EDBi h\u1EA1n m\u1EE9c gi\u00E1 API \u0111\u01B0\u1EE3c \u00E1p d\u1EE5ng \u1EDF c\u1EA5p t\u00E0i kho\u1EA3n theo Lo\u1EA1i t\u00E0i kho\u1EA3n (Pro, Business, Enterprise, v.v.) v\u00E0 Lo\u1EA1i y\u00EAu c\u1EA7u API (nh\u1EB9, trung b\u00ECnh, n\u1EB7ng, v.v.). M\u1ED9t s\u1ED1 API b\u1ECB gi\u1EDBi h\u1EA1n truy c\u1EADp \u0111\u1ED1i v\u1EDBi c\u00E1c lo\u1EA1i t\u00E0i kho\u1EA3n c\u1EE5 th\u1EC3. S\u1EED d\u1EE5ng Gi\u1EDBi h\u1EA1n m\u1EE9c gi\u00E1 API & T\u00E0i li\u1EC7u tham chi\u1EBFu API \u0111\u1EC3 bi\u1EBFt chi ti\u1EBFt \u0111\u1EA7y \u0111\u1EE7.",
    "meetings.fullPlanItem25_pro": "Gi\u1EDBi h\u1EA1n m\u1EE9c gi\u00E1 API REST Pro",
    "meetings.fullPlanItem25_biz": "Gi\u1EDBi h\u1EA1n m\u1EE9c gi\u00E1 API REST",
    "meetings.fullPlanItem26": "Kh\u1EA3 n\u0103ng t\u01B0\u01A1ng t\u00E1c Skype for Business (Lync)",
    "meetings.fullPlanItem26Tip": "Cho ph\u00E9p ng\u01B0\u1EDDi d\u00F9ng Lync 2010, 2013 v\u00E0 Skype for Business kh\u1EDFi ch\u1EA1y cu\u1ED9c h\u1ECDp Zoom t\u1EEB danh s\u00E1ch li\u00EAn h\u1EC7 Lync.",
    "meetings.fullPlanItem27": "Ph\u00E1t tr\u1EF1c tuy\u1EBFn",
    "meetings.fullPlanItem27Tip": "Ph\u00E1t tr\u1EF1c ti\u1EBFp l\u00EAn Facebook, Youtube ho\u1EB7c d\u1ECBch v\u1EE5 c\u1EE7a b\u00EAn th\u1EE9 ba.",
    "meetings.fullPlanItem28": "B\u00E1o c\u00E1o",
    "meetings.fullPlanItem28Tip": "L\u01B0u c\u00E1c phi\u00EAn b\u1EA3ng tr\u1EAFng",
    "meetings.fullPlanItem30": "Qu\u1EA3n l\u00FD ng\u01B0\u1EDDi d\u00F9ng",
    "meetings.fullPlanItem30Tip": "Ch\u1EE7 t\u00E0i kho\u1EA3n v\u00E0 qu\u1EA3n tr\u1ECB vi\u00EAn c\u00F3 th\u1EC3 th\u00EAm, x\u00F3a v\u00E0 ch\u1EC9 \u0111\u1ECBnh vai tr\u00F2 c\u0169ng nh\u01B0 c\u00E1c t\u00EDnh n\u0103ng b\u1ED5 sung.",
    "one.autoCaptions": "Phụ đề tự động",
    "meetings.fullPlanItem31": "C\u1ED5ng qu\u1EA3n tr\u1ECB",
    "meetings.fullPlanItem31Tip": "Qu\u1EA3n l\u00FD t\u1EA5t c\u1EA3 ng\u01B0\u01A1\u0300i d\u00F9ng trong c\u00F4ng ty c\u1EE7a b\u1EA1n tr\u00EAn m\u1ED9t t\u00E0i kho\u1EA3n \u0111\u1EC3 th\u1EF1c hi\u1EC7n thanh to\u00E1n \u0111\u01A1n gi\u1EA3n, c\u00E0i \u0111\u1EB7t qu\u1EA3n l\u00FD ng\u01B0\u1EDDi d\u00F9ng n\u00E2ng cao v\u00E0 to\u00E0n b\u1ED9 th\u00F4ng tin chi ti\u1EBFt v\u1EC1 s\u1EED d\u1EE5ng trong C\u1ED5ng qu\u1EA3n tr\u1ECB Zoom.",
    "meetings.fullPlanItem32": "T\u00EDch h\u1EE3p Kh\u1EA3 n\u0103ng t\u01B0\u01A1ng t\u00E1c c\u00F4ng c\u1EE5 h\u1ECDc t\u1EADp (LTI)",
    "meetings.fullPlanItem32Tip": "D\u1EC5 d\u00E0ng th\u00EAm m\u1ED9t cu\u1ED9c h\u1ECDp v\u00E0o b\u1EA5t k\u1EF3 ho\u1EA1t \u0111\u1ED9ng n\u00E0o trong kh\u00F3a h\u1ECDc v\u00E0 m\u1EDDi nh\u1EEFng sinh vi\u00EAn ph\u00F9 h\u1EE3p t\u1EEB h\u1EC7 th\u1ED1ng qu\u1EA3n l\u00FD h\u1ECDc t\u1EADp c\u1EE7a b\u1EA1n (ho\u1EA1t \u0111\u1ED9ng v\u1EDBi Moodle, Canvas, Desire2Learn v\u00E0 Blackboard).",
    "meetings.fullPlanItem33": "B\u1EA3n ch\u00E9p l\u1EA1i b\u1EA3n ghi tr\u00EAn \u0111\u00E1m m\u00E2y",
    "meetings.fullPlanItem33Tip": "B\u1EA3n ch\u00E9p l\u1EDDi ghi \u00E2m tr\u00EAn \u0111\u00E1m m\u00E2y l\u00E0 b\u1EA3n ch\u00E9p l\u1EDDi \u00E2m thanh ghi l\u1EA1i t\u1EEB cu\u1ED9c h\u1ECDp ho\u1EB7c h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn l\u01B0u tr\u00EAn \u0111\u00E1m m\u00E2y. Vui l\u00F2ng l\u01B0u \u00FD r\u1EB1ng t\u00EDnh n\u0103ng n\u00E0y hi\u1EC7n t\u1EA1i ch\u1EC9 h\u1ED7 tr\u1EE3 cho ng\u00F4n ng\u1EEF ti\u1EBFng Anh. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Nh\u1EA5n v\u00E0o \u0111\u00E2y</a> \u0111\u1EC3 t\u00ECm hi\u1EC3u th\u00EAm.",
    "meetings.fullPlanItem34": "Qu\u1EA3ng b\u00E1 th\u01B0\u01A1ng hi\u1EC7u",
    "meetings.fullPlanItem34Tip": "Th\u00EAm th\u01B0\u01A1ng hi\u1EC7u c\u00F4ng ty v\u00E0o trang t\u00F9y ch\u1EC9nh c\u1EE7a ri\u00EAng b\u1EA1n, n\u01A1i ng\u01B0\u1EDDi d\u00F9ng c\u1EE7a b\u1EA1n c\u00F3 th\u1EC3 tham gia m\u1ED9t cu\u1ED9c h\u1ECDp. T\u1EA1o m\u1ED9t m\u1EABu email c\u1EE7a th\u01B0\u01A1ng hi\u1EC7u \u0111\u1EC3 g\u1EEDi l\u1EDDi m\u1EDDi \u0111\u1EBFn ng\u01B0\u1EDDi d\u1EF1 th\u00EDnh.",
    "meetings.fullPlanItem35": "T\u00EAn mi\u1EC1n \u0111\u01B0\u1EE3c qu\u1EA3n l\u00FD",
    "meetings.fullPlanItem35Tip": "S\u1EED d\u1EE5ng t\u00EAn mi\u1EC1n \u0111\u1ECBa ch\u1EC9 email c\u00F4ng ty/tr\u01B0\u1EDDng \u0111\u1EA1i h\u1ECDc c\u1EE7a b\u1EA1n \u0111\u1EC3 t\u1EF1 \u0111\u1ED9ng th\u00EAm ng\u01B0\u1EDDi d\u00F9ng v\u00E0o t\u00E0i kho\u1EA3n c\u1EE7a b\u1EA1n.",
    "meetings.fullPlanItem37": "Phi\u00EAn d\u1ECBch ng\u00F4n ng\u1EEF",
    "meetings.fullPlanItem37Tip": "Cho ph\u00E9p ng\u01B0\u1EDDi ch\u1EE7 tr\u00EC cu\u1ED9c h\u1ECDp ch\u1EC9 \u0111\u1ECBnh th\u00F4ng d\u1ECBch vi\u00EAn trong c\u00E1c cu\u1ED9c h\u1ECDp v\u00E0 h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn. Khi cu\u1ED9c h\u1ECDp ho\u1EB7c h\u1ED9i th\u1EA3o tr\u1EF1c tuy\u1EBFn b\u1EAFt \u0111\u1EA7u, ng\u01B0\u1EDDi chu\u0309 tri\u0300 c\u00F3 th\u1EC3 b\u1EAFt \u0111\u1EA7u t\u00EDnh n\u0103ng phi\u00EAn d\u1ECBch, \u0111i\u1EC1u n\u00E0y s\u1EBD cung c\u1EA5p cho th\u00F4ng d\u1ECBch vi\u00EAn quy\u1EC1n truy c\u1EADp v\u00E0o c\u00E1c k\u00EAnh \u00E2m thanh c\u1EE7a ri\u00EAng h\u1ECD. Ng\u01B0\u1EDDi d\u1EF1 th\u00EDnh c\u00F3 th\u1EC3 ch\u1ECDn m\u1ED9t k\u00EAnh \u00E2m thanh \u0111\u1EC3 nghe ng\u00F4n ng\u1EEF h\u1ECD ch\u1ECDn. Ng\u01B0\u1EDDi d\u1EF1 th\u00EDnh s\u1EBD nghe th\u1EA5y \u00E2m thanh \u0111\u01B0\u1EE3c d\u1ECBch v\u00E0 c\u00F3 th\u1EC3 ch\u1ECDn n\u1EBFu h\u1ECD mu\u1ED1n nghe \u00E2m thanh g\u1ED1c \u1EDF m\u1EE9c \u00E2m l\u01B0\u1EE3ng th\u1EA5p h\u01A1n.",
    "meetings.fullPlanItem39": "\u0110\u00E1nh gi\u00E1 \u0111i\u1EC1u h\u00E0nh kinh doanh",
    "meetings.fullPlanItem39Tip": "Ph\u00E2n t\u00EDch chi ti\u1EBFt s\u1EF1 \u0111\u00F3n nh\u1EADn xu h\u01B0\u1EDBng, theo d\u00F5i l\u1EE3i t\u1EE9c \u0111\u1EA7u t\u01B0, th\u1EA3o lu\u1EADn l\u1ED9 tr\u00ECnh s\u1EA3n ph\u1EA9m.",
    "meetings.fullPlanNewItem4": "Bao g\u1ED3m c\u1EA3 Webinar 500",
    "one.translatedCations": "Phụ đề đã dịch",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Trò chuyện trực tiếp, trò chuyện kênh hoặc trò chuyện nhóm",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Dễ dàng giao tiếp trong tin nhắn 1:1, nhóm nhỏ hoặc với nhóm lớn",
    "messageAndFileHistory": "Lịch sử tin nhắn và tệp",
    "findPeopeChannelsAndFilesInSearch": "Tìm người, kênh và tệp trong tìm kiếm",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Tìm kiếm nhanh danh bạ, tin nhắn tức thời, trò chuyện nhóm và tệp tin, dễ dàng tiếp cận kiến thức và thông tin ngay trong tầm tay của bạn.",
    "applicationIntegrations": "Thành phần tích hợp ứng dụng",
    "secureFileSharing": "Bảo mật chia sẻ tệp",
    "enhanceCollaborationWithSeamlessFileSharing": "Tăng cường cộng tác với tính năng chia sẻ tệp mượt mà",
    "persistentMeetingChat": "Trò chuyện liên tục trong cuộc họp",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Không bao giờ mất dấu các cuộc hội thoại trong cuộc họp. Giao tiếp trước, trong và sau cuộc họp trong một cuộc trò chuyện nhóm chuyên dụng trong Zoom Team Chat cho tất cả những người tham gia cuộc họp.",
    "cloudStorage": "Lưu trữ đám mây",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Đưa các kênh về Zoom Cloud hoặc nhà cung cấp dịch vụ lưu trữ bên thứ ba",
    "avatars": "Ảnh đại diện (Avatars)",
    "inMeetingReactions": "Phản ứng trong cuộc họp",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Thể hiện sự tương tác và giao tiếp nhanh chóng với những người tham gia khác theo cách phi ngôn ngữ",
    "virtualBackgrounds": "Nền ảo",
    "videoFilters": "Bộ lọc video",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Mang không khí vui vẻ vào cuộc họp với nhiều bộ lọc đa dạng được đặt lên trên video của bạn",
    "inMeetingPollsAndQuizzes": "Cuộc bình chọn & kiểm tra kiến thức trong cuộc họp",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Tạo các câu hỏi bỏ phiếu có một hoặc nhiều lựa chọn cho cuộc họp.",
    "liveStreamingAcrossPlatforms": "Truyền phát trực tiếp trên các nền tảng",
    "appearanceTouchUp": "Làm đẹp",
    "originalSoundForMusicians": "Âm thanh gốc cho nhạc sĩ",
    "endToEndEncryptionForZoomMeetings": "Mã hóa đầu cuối dành cho Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "Việc bật mã hóa đầu cuối của Zoom (E2EE) dành cho Zoom Meetings có nghĩa rằng hoạt động truyền thông giữa tất cả những người tham gia trong một cuộc họp cụ thể trên Zoom client được mã hóa bằng khóa mã hóa chỉ được cung cấp cho thiết bị của họ. Điều này có nghĩa là không bên thứ ba nào — kể cả Zoom — có quyền tiếp cận các khóa riêng tư của cuộc họp đó.",
    "zoomCustomerManagedKey": "Mã khóa do khách hàng Zoom quản lý",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Sử dụng khoá mã hoá của riêng bạn để bảo vệ dữ liệu Zoom khi lưu trữ",
    "enterpriseGradeSecurityFeatures": "Tính năng bảo mật ở cấp doanh nghiệp lớn",
    "256BitAesGcmEncryptionForRealTimeContent": "Mã hóa AES-GCM 256 bit dùng cho nội dung và phương tiện truyền thông theo thời gian thực, mã hóa Bảo mật tầng giao vận (TLS) trong quá trình đăng ký Giao thức khởi tạo phiên (SIP), giấu số điện thoại gọi đến, kết nối mạng ngang hàng riêng, phát hiện gian lận công cụ và danh sách chặn cuộc gọi.",
    "phone.fullPlanItem40": "\u0110\u0103ng nh\u1EADp m\u1ED9t l\u1EA7n th\u00F4ng qua Ng\u00F4n ng\u1EEF \u0111\u00E1nh d\u1EA5u b\u1EA3o \u0111\u1EA3m an to\u00E0n 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "G\u1ECDi n\u1ED9i b\u1ED9 kh\u00F4ng gi\u1EDBi h\u1EA1n",
    "phone.fullPlanItem2": "G\u1ECDi \u0111i c\u00F3 t\u00EDnh c\u01B0\u1EDBc",
    "phone.fullPlanItem3": "G\u1ECDi \u0111i kh\u00F4ng gi\u1EDBi h\u1EA1n",
    "phone.fullPlanItem4": "Ch\u1EA5t l\u01B0\u1EE3ng cu\u1ED9c g\u1ECDi HD h\u00E0ng \u0111\u1EA7u trong ng\u00E0nh",
    "phone.fullPlanItem4Tip": "V\u1EDBi ch\u1EE9c n\u0103ng kh\u1EED ti\u1EBFng \u1ED3n ch\u1EE7 \u0111\u1ED9ng, kh\u1EED ti\u1EBFng vang v\u00E0 ch\u1EB7n kh\u00F4ng cho g\u00F5 b\u00E0n ph\u00EDm",
    "phone.fullPlanItem5": "C\u00E1c \u1EE9ng d\u1EE5ng d\u00E0nh cho m\u00E1y t\u00EDnh \u0111\u1EC3 b\u00E0n ch\u1EA1y Windows, MacOS v\u00E0 Linux nguy\u00EAn g\u1ED1c",
    "phone.fullPlanItem6": "C\u00E1c \u1EE9ng d\u1EE5ng di \u0111\u1ED9ng nguy\u00EAn g\u1ED1c ch\u1EA1y tr\u00EAn IOS v\u00E0 Android",
    "phone.fullPlanItem7": "Chuy\u1EC3n \u0111\u1ED5i c\u00E1c s\u1ED1 hi\u1EC7n t\u1EA1i ho\u1EB7c mua c\u00E1c s\u1ED1 m\u1EDBi (DID)",
    "phone.fullPlanItem8": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i mi\u1EC5n c\u01B0\u1EDBc",
    "phone.fullPlanItem9": "S\u1ED1 m\u00E1y l\u1EBB",
    "phone.fullPlanItem10": "Th\u01B0 tho\u1EA1i v\u1EDBi b\u1EA3n ch\u00E9p l\u1EDDi",
    "phone.fullPlanItem10Tip": "Truy c\u1EADp b\u1EA3n ch\u00E9p l\u1EDDi th\u01B0 tho\u1EA1i th\u00F4ng qua \u1EE9ng d\u1EE5ng di \u0111\u1ED9ng/m\u00E1y t\u00EDnh \u0111\u1EC3 b\u00E0n v\u00E0 email",
    "phone.fullPlanItem11": "Tr\u1EA3 l\u1EDDi t\u1EF1 \u0111\u1ED9ng kh\u00F4ng gi\u1EDBi h\u1EA1n/IVR",
    "phone.fullPlanItem12": "Th\u01B0 m\u1EE5c quay s\u1ED1 theo t\u00EAn",
    "phone.fullPlanItem13": "Nh\u00F3m Ph\u00E2n b\u1ED5 cu\u1ED9c g\u1ECDi t\u1EF1 \u0111\u1ED9ng (ADC) c\u00F3 t\u00EDnh n\u0103ng h\u00E0ng \u0111\u1EE3i cu\u1ED9c g\u1ECDi",
    "phone.fullPlanItem14": "Can thi\u1EC7p/Gi\u00E1m s\u00E1t/Th\u00EC th\u1EA7m/Chi\u1EBFm quy\u1EC1n",
    "phone.fullPlanItem15": "\u0110\u1ECBnh tuy\u1EBFn cu\u1ED9c g\u1ECDi trong gi\u1EDD l\u00E0m vi\u1EC7c v\u00E0 c\u1EA3 ng\u00E0y l\u1EC5",
    "phone.fullPlanItem16": "Cu\u1ED9c g\u1ECDi h\u1ED9i ngh\u1ECB 3 chi\u1EC1u t\u00F9y bi\u1EBFn",
    "phone.fullPlanItem17": "Ghi \u00E2m cu\u1ED9c g\u1ECDi",
    "phone.fullPlanItem17Tip": "Cung c\u1EA5p t\u00EDnh n\u0103ng ghi \u00E2m cu\u1ED9c g\u1ECDi t\u1EF1 \u0111\u1ED9ng v\u00E0 th\u1EE7 c\u00F4ng.",
    "phone.fullPlanItem18": "C\u1EA5u h\u00ECnh ch\u1EB7n cu\u1ED9c g\u1ECDi \u1EA9n danh v\u00E0 cu\u1ED9c g\u1ECDi ch\u1EC9 \u0111\u1ECBnh",
    "phone.fullPlanItem19": "G\u1ECDi kh\u1EA9n c\u1EA5p",
    "phone.fullPlanItem19Tip": "Th\u1EF1c hi\u1EC7n cu\u1ED9c g\u1ECDi \u0111\u1EBFn c\u00E1c d\u1ECBch v\u1EE5 kh\u1EA9n c\u1EA5p t\u1EA1i \u0111\u1ECBa ph\u01B0\u01A1ng",
    "phone.fullPlanItem20": "\u0110\u1ECBa ch\u1EC9 du m\u1EE5c E911 (Hoa K\u1EF3 v\u00E0 Canada) -",
    "phone.fullPlanItem20Tip": "T\u1EF1 \u0111\u1ED9ng ph\u00E1t hi\u1EC7n v\u1ECB tr\u00ED ng\u01B0\u1EDDi d\u00F9ng v\u00E0 b\u00E1o c\u00E1o \u0111\u1ECBa ch\u1EC9 kh\u1EA9n c\u1EA5p t\u01B0\u01A1ng \u1EE9ng t\u1EDBi c\u00E1c d\u1ECBch v\u1EE5 kh\u1EA9n c\u1EA5p t\u1EA1i \u0111\u1ECBa ph\u01B0\u01A1ng (ch\u1EC9 \u1EDF Hoa K\u1EF3 & Canada) v\u00E0 nh\u00F3m an to\u00E0n n\u1ED9i b\u1ED9",
    "phone.fullPlanItem21": "Trung t\u00E2m \u1EE9ng ph\u00F3 kh\u1EA9n c\u1EA5p",
    "phone.fullPlanItem21Tip": "Cho phép nhóm an toàn nội bộ của bạn nhận cảnh báo về các cuộc gọi khẩn cấp và ghi lại/giám sát/can thiệp nhanh chóng vào các cuộc gọi khẩn cấp để hỗ trợ công tác phối hợp ứng phó.",
    "phone.fullPlanItem22": "\u1EE6y nhi\u1EC7m/\u1EE7y quy\u1EC1n ti\u1EBFp nh\u1EADn cu\u1ED9c g\u1ECDi qua \u0111\u01B0\u1EDDng d\u00E2y chia s\u1EBB",
    "phone.fullPlanItem23": "Chuy\u1EC3n giao cu\u1ED9c g\u1ECDi gi\u1EEFa c\u00E1c thi\u1EBFt b\u1ECB",
    "phone.fullPlanItem24": "\u0110\u1EB7t cu\u1ED9c g\u1ECDi ch\u1EDD",
    "endToEndEncryptionForZoomPhone": "Mã hóa đầu cuối dành cho Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "Khi được bật cho Zoom Phone, mã hóa đầu cuối (E2EE) đảm bảo cuộc gọi được mã hóa bằng khóa mã hóa chỉ cung cấp cho thiết bị của người gọi và người nhận. Ngoài ra, người dùng sẽ có tùy chọn xác minh trạng thái E2EE bằng cách cung cấp mã bảo mật duy nhất cho người kia.",
    "phone.fullPlanItem43": "Tri\u1EC3n khai kh\u00F4ng ch\u1EA1m cho c\u00E1c \u0111i\u1EC7n tho\u1EA1i",
    "phone.fullPlanItem44": "K\u1EBFt h\u1EE3p nhi\u1EC1u lo\u1EA1i g\u00F3i d\u1ECBch v\u1EE5 tr\u00EAn m\u1ED9t t\u00E0i kho\u1EA3n",
    "phone.fullPlanItem46": "B\u00E1o c\u00E1o th\u1EDDi gian th\u1EF1c v\u00E0 b\u1EA3ng \u0111i\u1EC1u khi\u1EC3n ch\u1EA5t l\u01B0\u1EE3ng",
    "phone.fullPlanItem47": "H\u1ED7 tr\u1EE3 m\u00F4i tr\u01B0\u1EDDng m\u00E1y t\u00EDnh \u0111\u1EC3 b\u00E0n \u1EA3o (VDI)",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\">T\u00ECm hi\u1EC3u th\u00EAm</a> v\u1EC1 VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Sẵn có cho tất cả các khách hàng độc lập chỉ sử dụng điện thoại. Các gói hỗ trợ sẽ thay đổi khi kết hợp với các gói cuộc họp.",
    "phone.fullPlanItem49": "S\u1EED d\u1EE5ng h\u1ED7 tr\u1EE3 c\u1EE7a nh\u00E0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\u1EE7a ri\u00EAng b\u1EA1n",
    "phone.fullPlanItem49Tip": "H\u1ED7 tr\u1EE3 gh\u00E9p c\u1EB7p tr\u1EF1c ti\u1EBFp v\u00E0 t\u1EA1i ch\u1ED7 v\u1EDBi h\u1EC7 th\u1ED1ng c\u1EE7a nh\u00E0 cung c\u1EA5p d\u1ECBch v\u1EE5 PSTN hi\u1EC7n t\u1EA1i",
    "phone.fullPlanItem50": "T\u00EDch h\u1EE3p theo ki\u1EC3u lai v\u00E0o c\u00E1c PBX c\u0169",
    "phone.fullPlanItem51": "Nhấn để nói",
    "phone.fullPlanItem61": "Fax trực tuyến",
    "phone.fullPlanItem61Tip": "Gửi và nhận fax không giới hạn trong phạm vi Hoa Kỳ và Canada. Đối với fax quốc tế, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">xem giá</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Ch\u1EC9 kh\u1EA3 d\u1EE5ng cho c\u00E1c s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u1EDF Hoa K\u1EF3 v\u00E0 Canada khi mua m\u1ED9t g\u00F3i cu\u1ED9c g\u1ECDi. Kh\u1EA3 d\u1EE5ng cho c\u00E1c s\u1ED1 \u0111i\u1EC7n tho\u1EA1i tr\u1EF1c ti\u1EBFp (kh\u00F4ng ph\u1EA3i s\u1ED1 \u0111i\u1EC7n tho\u1EA1i c\u00F4ng ty).",
    "meetings.fullPlanItem6": "H\u1ED7 tr\u1EE3 k\u1EF9 thu\u1EADt",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Ch\u1EC9 phi\u1EBFu h\u1ED7 tr\u1EE3",
    "meetings.fullPlanItem6_pro": "Phi\u1EBFu h\u1ED7 tr\u1EE3 v\u00E0 Tr\u00F2 chuy\u1EC7n tr\u1EF1c ti\u1EBFp",
    "meetings.fullPlanItem6_biz": "Phi\u1EBFu h\u1ED7 tr\u1EE3, Tr\u00F2 chuy\u1EC7n tr\u1EF1c ti\u1EBFp v\u00E0 \u0110i\u1EC7n tho\u1EA1i",
    "meetings.fullPlanItem6_ent": "Phi\u1EBFu h\u1ED7 tr\u1EE3, Tr\u00F2 chuy\u1EC7n tr\u1EF1c ti\u1EBFp v\u00E0 \u0110i\u1EC7n tho\u1EA1i",
    "knowledgeBase": "Cơ sở kiến thức",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Khắc phục sự cố kỹ thuật và truy cập tài nguyên hỗ trợ bằng cách tìm kiếm các bài viết thuộc cơ sở kiến thức của chúng tôi.",
    "zoomCommunity": "Cộng đồng Zoom",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "Nơi tìm kiếm giải pháp, đưa ra câu hỏi và cộng tác với những người dùng Zoom khác.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Nhận giải đáp cho những thắc mắc và khắc phục sự cố kỹ thuật bằng cách tương tác với chatbot của chúng tôi.",
    "submitWebTickets": "Gửi phiếu yêu cầu trợ giúp trực tuyến",
    "liveChatSupport": "Hỗ trợ trò chuyện trực tiếp",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Gói đăng ký trên {amount} USD/tháng",
    "livePhoneSupport": "Hỗ trợ gọi điện trực tiếp",
    "meetWithAgentOnVideo": "Gặp gỡ nhân viên hỗ trợ qua video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Gói đăng ký trên 200 USD/tháng",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Tăng hiệu quả làm việc bằng cách tận dụng các Ứng dụng yêu thích ngay trong Zoom Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Tùy chỉnh ảnh đại diện của riêng bạn để mang lại không khí vui vẻ cho cuộc họp và thể hiện bản thân một cách sinh động mà không cần phải xuất hiện trên video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Thư",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} người tham gia",
    "common.per_meeting_unit": "mỗi cuộc họp",
    "common.participant_limit.increase_with_large_meetings": "Tăng lên với tiện ích Cuộc họp lớn",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Dịch vụ bổ sung",
    "common.plans.extras.desc": "quản lý tên miền công ty, v.v.",
    "zoom_one_edu_bundle.school.title": "Gói Trường học và Cơ sở giáo dục bậc cao của Zoom One dành cho Giáo dục",
    "zoom_one_edu_bundle.school_plus.title": "Gói Trường học và Cơ sở giáo dục bậc cao Nâng cao của Zoom One dành cho Giáo dục",
    "per_billing_cycle_license.monthly": "/tháng/giấy phép",
    "per_billing_cycle_license.yearly": "/năm/giấy phép",
    "per_billing_cycle_space.monthly": "/tháng/không gian",
    "per_billing_cycle_space.yearly": "/năm/không gian",
    "common.dialog.feature_list": "Xem danh sách toàn bộ tính năng",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB mỗi giấy phép",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB mỗi giấy phép",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Gói Doanh nghiệp lớn Nâng cao đã bao gồm Không giới hạn",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Trình kết nối phòng hội nghị (tỷ lệ 1:25)",
    "plans.whiteboard.ent": "Gói Doanh nghiệp lớn Nâng cao đã bao gồm Không giới hạn Nâng cao",
    "plans.zp.ent": "Có trong gói Doanh nghiệp lớn Nâng cao",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Đặt trước không gian làm việc nâng cao hoặc tại chỗ, v.v.",
    "plans.largeMeeting.intro_tip": "Cuộc họp lớn là tiện ích mở rộng tùy chọn khi thanh toán, cho phép bạn tổ chức cuộc họp cho tối đa 500 hoặc 1.000 người tham gia, tùy thuộc vào giấy phép đã mua.",
    "common.participant_limit.expandable_with_large_meetings": "Có thể mở rộng quy mô với Cuộc họp lớn",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1.000 dành cho Enterprise Plus</span>",
    "plans.webinar": "Hội thảo trực tuyến Zoom",
    "plans.webinar.ent": "Gói Doanh nghiệp lớn Nâng cao đã bao gồm Phiên 1000 (bao gồm Hội thảo trực tuyến)",
    "per_billing_cycle_user.monthly": "/tháng/người dùng",
    "per_billing_cycle_user.annually": "/năm/người dùng",
    "closeComparisonChart": "Đóng bảng so sánh",
    "archiving_api": "Lưu trữ API",
    "dlp_api": "API của DLP",
    "info_barriers": "Rào cản thông tin",
    "chat_etiquette": "Trò chuyện lịch sự",
    "gdrp": "Quy định chung về bảo vệ dữ liệu (GDPR)",
    "regiona_data_centers": "Trung tâm dữ liệu khu vực",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Mã hóa theo mặc định",
    "end_to_end_encryption": "Mã hóa đầu cuối",
    "cryptographic_boundary": "Ranh giới mật mã",
    "vdi": "Máy tính ảo (VDI)",
    "customer_managed_key": "Khóa do khách hàng quản lý",
    "gpo_msi_policies": "Chính sách GPO/MSI",
    "msi": "Triển khai hàng loạt (MSI)",
    "ntt": "Công cụ kiểm tra mạng (NTT)",
    "dashboards": "Bảng điều khiển",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Khả năng duy trì của Zoom Phone",
    "zoom_meeting_survivability": "Khả năng duy trì của Zoom Meetings",
    "paid_option": "Tùy chọn trả phí",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Các tính năng chính",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "Trường học và Trường đại học",
    "zoom_one_edu_bundle.school_plus.brief_title": "Trường học và Trường đại học nâng cao",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "zh-CN": {
    "billing.essential_apps": "基本应用",
    "billing.essential_apps.dialog_desc": "使用各种应用发展和管理您的业务，这些应用可记录会议笔记，让团队参与互动活动，并提供见解以改善客户对话。 您的套餐中随附有免费使用付费应用 1 年。",
    "billing.see_more_details": "查看更多详细信息",
    "billing.essential_app.legal_copy": "此优惠仅适用于自 2023 年 1 月 4 日起及以后通过 Zoom 在线频道 zoom.us/buy 购买 Zoom One 专业版、商业版或商业加强版订阅而拥有当前许可证的用户。 其订阅与医疗保健、教育或政府账户关联的用户不能享受此优惠。  除 Coda 外，每个应用的访问有效期为自个人用户激活该应用起的 1 年时间。 同一 Zoom 账户中所有用户的 Coda 访问有效期为自同一 Zoom 账户中任何用户首次激活 Coda 起的 1 年时间，而与同一 Zoom 账户中后续用户的初始激活日期无关。对于所有应用，如果重新分配或取消用户的合格许可证或订阅，则将终止该用户的访问权限，无论 1 年访问期限是否还有剩余时间。每个应用都需要遵守激活后所适用的使用条款和隐私政策。随附的应用仅支持英文。并非所有应用都能在移动设备上运行。优惠不可兑换也不可退还现金。优惠仅适用于 <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> 中被列为基本应用的这些应用。 已订阅任何应用的用户不能享受与那些特定应用有关的这项优惠。Zoom 保留随时修改或取消此优惠的权利，无需事先通知和承担任何责任。",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "访客管理"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "全天候实时聊天和电话支持"
      },
      "learn_more": "\u4E86\u89E3\u66F4\u591A",
      "new": "全新",
      "plan_details": {
        "meeting": {
          "title": "\u4F1A\u8BAE",
          "host_meeting_up_to_participants": "可多达{0}名参会者",
          "meeting_hours": "不限次数的会议，每次会议限时 30 小时",
          "recording_storage": "{0} GB 云存储录制空间（每个许可证）",
          "auto_captions": "自动字幕"
        },
        "whiteboard": {
          "title": "白板",
          "boards_storage": "{0} 个可编辑板",
          "standard_features": "标准功能"
        },
        "team_chat": {
          "title": "团队聊天",
          "desc": "群组聊天和文件共享"
        },
        "main_calendar": {
          "title": "邮件和日历",
          "desc": "邮件和日历客户端与服务"
        },
        "notes": {
          "title": "Notes",
          "desc1": "在 Zoom 中创建和共享可编辑文档",
          "desc2": "具有富文本编辑功能的个人笔记和协作笔记"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "轻松录制、编辑和共享短视频",
          "desc2": "无限制的视频和高级功能"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "快速获取会议摘要、协助起草消息等"
        },
        "EssentialApp": {
          "title": "基本应用",
          "desc1": "免费使用付费应用 1 年（需遵守条款）",
          "desc2": "提高团队协作能力和工作效率"
        },
        "livechat": {
          "title": "实时聊天支持"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "更改为 Zoom Workplace 专业版？",
            "content": "您之前选择的是 Zoom Workplace 商业版，它允许每次会议最多有 300 名参会者，还提供 Zoom Scheduler 等功能。您仍然想更改为专业版吗？",
            "confirm": "确认更改",
            "keep_current": "保留当前套餐"
          }
        }
      },
      "test": "Zoom白板",
      "common": {
        "statistics": {
          "attendees": "{0} 观众",
          "participants": "{0} 参会者",
          "user_range": "{0}-{1} 个用户",
          "items": "{num} 个项目"
        },
        "button": {
          "ok": "OK",
          "add": "添加",
          "buy_now": "立即购买",
          "try_for_days": "试用 {0} 天",
          "contact_sales": "联系销售人员",
          "close": "关闭",
          "cancel": "取消",
          "edit": "编辑",
          "got_it": "知道了"
        },
        "title": {
          "everything_in_and": "{0} 的所有功能，以及："
        },
        "tag": {
          "new": "全新",
          "free_trial": "免费试用"
        },
        "billing_cycle": {
          "annual": "每年",
          "monthly": "月度",
          "quarterly": "季度",
          "two_years": "两年",
          "three_years": "三年"
        },
        "errors": {
          "unknown_error_try_again": "交易发生未知错误。请稍后重试。"
        },
        "excluding_tax": {
          "vat_tip": "不含增值税",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "功能受限",
        "pro_plus": {
          "host_meeting_up_to_participants": "可多达{0}名参会者",
          "gb_of_cloud_recording_storage": "{0} GB 云录制文件存储空间（每个许可证）",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion 可生成内容并提供翻译",
            "features_item2": "与团队共享的文档数量不受限制",
            "features_item3": "可访问的版本历史记录不受限制",
            "comparison_table_tips": "利用 AI 优先文档，将会议内容转化为可操作的文档、Wiki 和项目，从而增强协作能力"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks 基础版",
            "features_item1": "从会议、电话通话、聊天和文档中自动检测任务",
            "features_item2": "获得任务完成方面的帮助，例如安排后续会议和起草文档",
            "features_item3": "任务完成后，轻松将其标记为完成，以便随时了解进度并专注于后续工作",
            "features_item4": "在整个 Zoom Workplace 平台（包括 Zoom Docs）中管理任务",
            "features_item1_opc": "利用 AI Companion 的强大功能从您的聊天、电子邮件、文档、白板和会议摘要中识别和创建任务",
            "features_item2_opc": "轻松进行排序、过滤、分组和搜索，以快速访问和收集任务的背景信息",
            "learn_more_header": "使用 AI Companion* 随时了解您的行动项目，在 Zoom Workplace 中完成更多工作。",
            "learn_more_footer": "\*AI Companion 仅适用于 Zoom Workplace 专业版、商业版和企业版套餐。",
            "features_prefix": "让 AI Companion 帮助您：",
            "comparison_table_tips": "通过在 Zoom Workplace 中根据对话和会议摘要提供任务建议的 AI 优先解决方案，随时了解并按时完成行动项目。",
            "tasks_label_text": " AI 优先任务管理"
          },
          "title": "商业加强版",
          "contact_us_for_more_pricing": "联系我们获取定价和更多信息",
          "contact_sales": "\u8054\u7CFB\u9500\u552E\u4EBA\u5458",
          "meetings": "\u4F1A\u8BAE",
          "phone": "\u7535\u8BDD",
          "phone_sub_title": "\u65E0\u9650\u901A\u8BDD",
          "use_only": "仅用于商业用途",
          "team_chat": {
            "title": "团队聊天",
            "title_desc": "群组聊天和文件共享"
          },
          "cloud_storage": {
            "title": "\u4E91\u5B58\u50A8"
          },
          "mail_calender": {
            "title": "邮件和日历"
          },
          "beta": "Beta",
          "client_service": {
            "title": "客户端和服务"
          },
          "up_to_30_hours_per_meeting": "每次会议限时 30 小时",
          "300_attendees": "300 名观众",
          "per_meeting": "按会议",
          "whiteboard": {
            "title": "白板"
          },
          "new": "全新",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10 GB",
          "extras": "赠品",
          "sso_managed_domains_more": "SSO、托管域等",
          "scheduler": "计划程序",
          "global_select": "Global Select",
          "unlimited_regional": "无限制区域通话",
          "translated_captions": "已翻译字幕",
          "workspace_reservation": "工作区预订",
          "auto_translated_captions": "自动和已翻译字幕",
          "unlimited_editable_boards": "无限制可编辑板",
          "standard_features": "标准功能",
          "advanced_docu_controls": "高级文档控制",
          "chats_channels_for_collaboration": "用于进行协作、文件共享等的聊天和频道",
          "zoom_phone_is_biz_use_only": "Zoom Phone 仅供商业使用",
          "unlimited_regional_calling": "\u65E0\u9650\u533A\u57DF\u901A\u8BDD",
          "domestic_sms_mms": "\u56FD\u5185\u77ED\u4FE1\u548C\u5F69\u4FE1",
          "automatic_call_distribution_groups": "\u81EA\u52A8\u547C\u53EB\u5206\u914D (ACD) \u7FA4\u7EC4\uFF0C\u5177\u6709\u547C\u53EB\u961F\u5217\u529F\u80FD",
          "single_sign_on": "\u5355\u70B9\u767B\u5F55",
          "managed_domains": "\u6258\u7BA1\u57DF",
          "company_branding": "\u516C\u53F8\u54C1\u724C",
          "mail_calender_client_services_beta": "邮件和日历客户端与服务测试版",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "不限次数的会议，每次会议限时 30 小时",
          "mail_and_calendar_client_and_services_beta": "邮件和日历客户端与服务测试版",
          "easily_record_edit_share_videos": "轻松录制、编辑和共享短视频",
          "unlimited_videos_advanced_features": "无限制的视频和高级功能",
          "create_share_editabel_docu_within_zoom": "在 Zoom 中创建和共享可编辑文档",
          "personal_collaborative_notes_rich_text_editing": "具有富文本编辑功能的个人笔记和协作笔记",
          "effortlessly_share_meeting": "轻松共享会议时段，轻松预订",
          "works_with_zoom_meeting_mail_calender_google_ms": "与 Zoom Meetings、Zoom Mail 和 Calendar、Google 和 Microsoft 365 配合使用",
          "up_to_300_attendees": "最多 300 名观众",
          "10_gb_of_storage": "10 GB 存储量",
          "host_meeting_up_to_300_participants": "\u4E3B\u6301\u6700\u591A\u6709 300 \u540D\u53C2\u4F1A\u8005\u7684\u4F1A\u8BAE",
          "10_gb_of_cloud_recording_storage": "10 GB 云存储录制空间（每个许可证）",
          "starting_at_licenses_year": "\u6700\u4F4E {1} \u4E2A\u8BB8\u53EF\u8BC1\uFF0C\u6BCF\u5E74 {0} \u8D77",
          "starting_at_licenses_month": "\u6700\u4F4E {1} \u4E2A\u8BB8\u53EF\u8BC1\uFF0C\u6BCF\u6708 {0} \u8D77",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "快速获取会议摘要、协助起草消息等",
          "learn_more": "\u4E86\u89E3\u66F4\u591A",
          "essential_apps": "基本应用",
          "increase_team_collaboration": "提高团队协作能力和工作效率",
          "free_premium_apps": "免费使用付费应用 1 年（需遵守条款）",
          "visitor_management": "访客管理",
          "visitor_management_custom_invites": "自定义邀请",
          "visitor_management_visitor_check": "在 Kiosk 签到",
          "visitor_management_receive_detailed": "接收有关访客空间使用情况的详细指标"
        },
        "custom_avatar": {
          "title": "自定义虚拟形象",
          "label_text": "每月 3 分钟",
          "basic_feature": "每个生命周期 1 分钟",
          "pricing_feature": "每月 3 分钟",
          "learn_more_subtitle": "通过语音复制和多语言沟通，创建您自己的栩栩如生的 AI 版本。",
          "features_item1": "每月最多创建 3 个栩栩如生的数字虚拟形象，它可以复制您的外貌和语音，用于演讲和介绍",
          "features_item2": "使用您的虚拟形象与 AI Companion 一起提供长达 3 分钟的脚本",
          "features_item3": "从 18 个预先设计的虚拟形象中进行选择，以便快速创建高质量的视频",
          "features_item4": "享受虚拟背景支持",
          "features_item1_opc": "每月最多创建 3 个栩栩如生的数字虚拟形象，它可以复制您的外貌和语音，用于演讲和介绍",
          "features_item2_opc": "使用您的虚拟形象与 AI Companion 一起提供长达 3 分钟的脚本",
          "comparison_table_tips": "自定义虚拟形象可通过语音复制和多语言沟通创建您自己的栩栩如生的 AI 版本。"
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "快速获取会议摘要、协助起草消息等",
        "learn_more_dialog": {
          "desc": "借助 AI Companion 完成更多工作！它可以撰写内容、安排会议、帮助管理项目等。",
          "tip1": "提前接收议程，让您主持的会议更有效率",
          "tip2": "自动创建任务并发出通知，确保项目顺利进行",
          "tip3": "帮助您整理日历和管理时间",
          "tip4": "在 Docs、Whiteboard 或 Zoom Workplace 应用中生成符合您风格的书面和视觉内容"
        },
        "top_features": "热门功能",
        "more_to_come": "还有更多不可思议的功能，敬请期待！",
        "discover_more": "探索更多使用 AI Companion 出色完成工作的方法！",
        "detail_desc": "AI Companion 包含在 Zoom 用户账户的付费服务中，无需支付额外费用。可能不包括部分垂直行业和地区。"
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/年/许可证",
        "month_licnese": "/月/许可证",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/月",
          "per_year": "/年"
        },
        "unit": {
          "license": "{0}/许可证",
          "user": "{0}/用户"
        },
        "learn_more": "了解更多",
        "required": "必填",
        "zoom_one_required": "需要 Zoom Workplace",
        "large": {
          "features_tip": "扩大您的影响范围，提高参会者容量，最多可容纳 1,000 名参会者。",
          "label_title1": "500名观众",
          "label_title2": "1000名观众"
        },
        "cmr": {
          "features_tip": "使用 Zoom 云直接存储、流式传输和下载您的视频录制文件。",
          "explain_desc": "部分 Zoom One 套餐中包含云存储：专业版 (5 GB)、商业版 (5 GB)、商业加强版 (10 GB) 和企业版（无限制）",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "大约 100 小时",
          "option_label2": "大约 650 小时",
          "option_label3": "大约 3,500 小时",
          "option_label4": "大约 17,500 小时",
          "intro_label2": "存储空间选项最多可达 5 TB/月",
          "tooltip_content": "录制存储空间根据启用视频的参会者数量、会议分辨率和共享内容分辨率的不同而异。"
        },
        "whiteboard": {
          "plus_title": "白板增强版",
          "title": "Whiteoard",
          "features_tip": "在会议期间和会议之外，在白板上与其他人实时协作。",
          "explain_desc": "Zoom One 商业版、Zoom One 商业加强版和 Zoom One 企业版中均已包含",
          "explain_desc_plus": "Zoom One 企业加强版中已包含，并随每个 Zoom Rooms 订阅一起提供",
          "option_label1": "具有 1 GB 云存储的无限制白板",
          "option_label2": "具有无限制白板和云存储的高级功能",
          "intro_label1": "无限制且可同时编辑的白板",
          "intro_label2": "标准功能和高级文档控制",
          "intro_label3": "高级白板功能，包括自定义和组织模板，以及第三方集成"
        },
        "translated_captions": {
          "features_tip": "使用您首选语言的自动字幕支持全球协作。",
          "intro_label1": "参会者可以自行启用字幕和切换语言。",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "查看支持的语言"
        },
        "crc": {
          "features_tip": "启用任何基于标准的 SIP/H.323 视频会议端点，实现有效的混合式工作。",
          "intro_label1": "适用于 Polycom、Cisco、Lifesize 等多种老旧端点",
          "intro_label2": "基于云或预置型 (VM) 会议室连接器"
        },
        "scheduler": {
          "simplify_bookings": "灵活的空闲时间管理和可自定义的时段安排，从而简化预约",
          "host_one_on_one": "只需一个链接，即可举办一对一或小组会议，轻松实现共享",
          "customize_reminders": "自定义通过电子邮件/短信发送的提醒，减少错过预约的情况",
          "sync_calendars": "与 Google、Microsoft 365 和 Zoom 集成无缝同步日历",
          "features_tip": "轻松共享用于办公时间、访谈等的会议时段。",
          "intro_label1": "日历集成",
          "intro_label2": "周期性可用性",
          "intro_label3": "可扩展会议",
          "intro_label4": "可定制的通知",
          "intro_sub_label1": "Google、Microsoft 365 和 Zoom ",
          "intro_sub_label2": "共享可预订时段 ",
          "intro_sub_label3": "一个或多个参会者的单次会议",
          "intro_sub_label4": "自动发送电子邮件或短信提醒和确认"
        },
        "zoom_clips_plus": {
          "features_tip": "录制、编辑和共享高质量的短视频留言。",
          "intro_label1": "创建没有时间限制的无限时视频。",
          "intro_label2": "同时或分别捕捉屏幕和视频",
          "intro_label3": "根据需要剪辑视频并共享链接",
          "intro_label4": "访问高级功能，如音频转录文字和统计数据",
          "explain_desc": "Workplace 专业版、商业版和企业版订阅中均已包含 Clips 加强版。您可以在定价页面的比较版块了解每种套餐的不同功能。"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "具备强大注册和交流功能的高级直播平台。虚拟和混合式体验的理想选择。",
          "tooltip_content": "以选定的规模举办不限次数的网络研讨会或活动",
          "intro_title": "Zoom Sessions 的所有功能",
          "intro_label1": "通过多场会议活动提高观众参与度",
          "intro_label2": "通过定制的票务和移动应用轻松举办活动",
          "intro_label3": "通过“展会大厅”和“赞助商”区增加活动收入",
          "intro_label4": "通过可定制的个人资料促进观众交流",
          "intro_label5": "通过活动大厅中的视频点播扩大影响范围",
          "intro_label6": "使用精心策划的活动模板加快活动设置",
          "events_feature_item1_20240827": "借助多场主题分会组织多日虚拟活动",
          "events_feature_item2_20240827": "使用观众个人资料和大厅聊天功能促进交流",
          "events_feature_item3_20240827": "使用大厅会议直播功能引导观众",
          "events_feature_item4_20240827": "使用展会大厅和赞助功能增加活动收入",
          "events_feature_item5_20240827": "使用会后调查功能改进后续活动",
          "events_feature_item6_20240827": "使用精心策划的活动模板加快活动设置",
          "attendees_start_at": "{0} 名观众，起价为",
          "explain_desc": "了解有关 Zoom Events 的更多信息",
          "contact_account_owner": "如果要购买 Events，请<a href=\"/account\" target=\"_blank\">联系账户所有者</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "利用直播品牌化、多主持人协作和直播管理等功能简化交互式单场会议直播。",
          "tooltip_content": "以选定的规模举办不限次数的网络研讨会或活动",
          "intro_title": "包含 Zoom Webinars",
          "intro_label1": "自定义活动登录页面实现有效的品牌化设置",
          "intro_label2": "使用品牌化电子邮件推广活动",
          "intro_label3": "使用交互式仪表板衡量绩效",
          "intro_label4": "与联席主持人和合编者开展无缝协作",
          "intro_label5": "专业活动工具：预录后直播",
          "sessions_feature_item1_20240827": "使用自定义场景和品牌化设置提升网络研讨会的影响力",
          "sessions_feature_item2_20240827": "使用 AI Companion 生成消息和图像，简化活动规划",
          "sessions_feature_item3_20240827": "在品牌内容中心宣传往期活动和后续活动",
          "sessions_feature_item4_20240827": "使用“后台”、“预录后直播”和 RTMP 功能举办专业活动",
          "sessions_feature_item5_20240827": "使用跨活动数据分析功能改进后续网络研讨会",
          "explain_desc": "了解有关 Zoom Sessions 的更多信息",
          "contact_account_owner": "如果要购买 Sessions，请<a href=\"/account\" target=\"_blank\">联系账户所有者</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "视频网络研讨会",
          "features_tip": "利用用户友好型网络研讨会平台轻松广播消息。",
          "tooltip_content": "以选定的规模举办不限次数的网络研讨会或活动",
          "intro_label1": "借助高质量的视频 Web 广播吸引观众",
          "intro_label2": "通过问答、问卷和回应形式提高参与度",
          "intro_label3": "通过活动后报告改进网络研讨会策略",
          "intro_label4": "支持多达 100,000 名观众和 100 名嘉宾",
          "monthly_subscription": "月度订阅",
          "annual_subscription": "年度订阅",
          "one_million": "100 万",
          "single_use": "单次",
          "one_month": "一个月",
          "event_attendee": "活动/会议观众：",
          "event_attendee_desc": "参加会议但不是中心授权主持人的任何人。 特殊角色也被视为观众，并且可以通过音频、视频和屏幕共享（如果启用）参与。",
          "webinar_attendee": "网络研讨会观众：",
          "webinar_attendee_desc": "参加会议但不是主持人或小组成员的任何人。 他们处于只观看模式，由主持人控制，主持人可以取消他们的静音，并通过问答和聊天进行互动。",
          "pay_per_attendee": "按观众付费",
          "attendees": "观众"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "通过 AI 驱动的协作平台重塑团队合作方式。",
          "label_title1": "Zoom Workplace 专业版",
          "label_title2": "Zoom Workplace 专业加强版",
          "label_title3": "Zoom Workplace 商业版",
          "label_title4": "Zoom Workplace 商业加强版",
          "intro_label1": "不受限制地举办长达 30 小时的会议，最多可容纳 100 名参会者",
          "intro_label2": "可同时访问最多 3 个具有标准功能的可编辑白板",
          "intro_label3": "通过 Clips 加强版录制、编辑和共享高质量的短视频消息",
          "intro_label4": "使用 Zoom AI Companion 更高效地完成工作",
          "intro_label5": "Zoom Phone 美国和加拿大无限通话（不包括 BYOC、PBX 和第三方 PBX）",
          "intro_label6": "不受限制地举办长达 30 小时的会议，最多可容纳 300 名参会者",
          "intro_label7": "使用 Zoom Scheduler 共享用于办公时间、访谈等的会议时段",
          "intro_label8": "Zoom Phone 美国和加拿大无限量通话",
          "intro_label8_UK": "Zoom Phone 英国与爱尔兰不限时套餐",
          "intro_label8_AU": "Zoom Phone 澳大利亚与新西兰不限时套餐",
          "intro_label8_JP": "Zoom Phone 日本不限时套餐",
          "intro_label9": "访客管理",
          "intro_label10": "其他功能",
          "intro_label11": "实时聊天支持",
          "intro_title1": "专业版的所有功能，以及：",
          "intro_title2": "商业版的所有功能，以及：",
          "intro_label_tip1": "专业加强版中的 Zoom Phone 不包括 BYOC、第三方 PBX 和 VDI 功能。有关更多信息，请参阅 Zoom Phone 定价页面。",
          "intro_label_tip2": "结账时，您可以选择美国与加拿大、澳大利亚与新西兰、英国与爱尔兰或日本的不限时区域通话套餐。",
          "intro_label_tip3": "其他功能包括 10 GB 云存储空间、字幕翻译和工作区预约。",
          "intro_label_tip4": "专业加强版中的 Zoom Phone 不包括 BYOC、第三方 PBX 和 VDI 功能。有关更多信息，请参阅 Zoom Phone 定价页面。"
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "为呼叫中心团队提供增强的呼叫队列分析和历史见解。",
          "intro_label1": "扩展型联系人窗口，可简化通话处理过程",
          "intro_label2": "自动接线员和呼叫队列电话号码"
        },
        "international_calling": {
          "title": "国际通话",
          "features_tip": "超过 15 个国家和地区的无限时国际通话。",
          "intro_label1": "可与任何无限时通话计划一起购买",
          "intro_label2": "浏览我们支持无限时国际通话的国家和地区列表。",
          "intro_labe2_tooltip": "美国、加拿大、英国、爱尔兰、澳大利亚、新西兰、奥地利、丹麦、法国、德国、意大利、葡萄牙、西班牙、瑞典、比利时、荷兰、瑞士、波多黎各、日本。",
          "intro_label2_view_list": "查看列表"
        },
        "workspace_reservation": {
          "title": "工作区预约",
          "intro_title": "使用 Zoom 集成设备，提前或现场轻松预约灵活的工作区或预订酒店房间。",
          "intro_label1": "通过 Zoom Workplace 应用程序、桌面或浏览器访问工作区和酒店预约",
          "intro_label2": "借助人工智能的帮助获得个性化办公桌推荐",
          "intro_label3": "直接从 Google 日历或 Outlook 预约工作区，并设置提醒和签到提示",
          "intro_label4": "使用寻路功能导航到预约的工作区"
        },
        "visitor_management": {
          "title": "访客管理",
          "intro_title": "通过自定义邀请、无障碍 Kiosk 签到、报告和指标，简化访客签到流程。",
          "intro_label1": "在 Zoom 门户网站中管理邀请、访客位置和访问历史记录",
          "intro_label2": "创建、跟踪、重新发送和删除邀请，同时接收访客到达通知",
          "intro_label3": "通过 Kiosk 填写表格、获取指引并办理签到，为访客提供顺畅的体验",
          "intro_label4": "在熟悉的 Zoom 门户网站内访问所有功能，以便管理"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "大型会议",
          "description1": "增加会议人数，最多可支持 1,000 名实时互动参会者",
          "description2": "所有参会者都可以共享他们的音频、视频和屏幕"
        },
        "cloud_storage": {
          "title": "云存储",
          "description2": "支持 MP4 或 M4A 文件格式"
        },
        "translated_captions": {
          "title": "字幕翻译",
          "description1": "通过自动化的多语言字幕增强会议体验，允许参会者启用并切换到受支持的语言",
          "description2": "适用于 Zoom Meetings 和 Zoom Webinars"
        },
        "tollfree": {
          "title": "音频会议",
          "subcontent": "在世界各地使用电话号码拨入会议",
          "description1": "扩展您的呼叫选项，为付费国家/地区增加了呼出、全球免费电话以及本地拨入功能",
          "description2": "参会者可以使用任何设备免费呼入",
          "description3": "轻松选择一个或多个免费呼入国家或地区"
        },
        "rc": {
          "title": "会议室连接器"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "阿根廷",
        "Australia": "澳大利亚",
        "Austria": "奥地利",
        "Belgium": "比利时",
        "Brazil": "巴西",
        "Bulgaria": "保加利亚",
        "Canada": "加拿大",
        "Chile": "智利",
        "China": "中国",
        "Colombia": "哥伦比亚",
        "Costa_Rica": "哥斯达黎加",
        "Croatia": "克罗地亚",
        "Cyprus": "塞浦路斯",
        "Czech_Republic": "捷克共和国",
        "Denmark": "丹麦",
        "Ecuador": "厄瓜多尔",
        "Estonia": "爱沙尼亚",
        "Finland": "芬兰",
        "France": "法国",
        "Germany": "德国",
        "Greece": "希腊",
        "Hong_Kong_SAR": "中国香港特别行政区",
        "Hungary": "匈牙利",
        "Ireland": "爱尔兰",
        "Israel": "以色列",
        "Italy": "意大利",
        "Japan": "日本",
        "Latvia": "拉脱维亚",
        "Lithuania": "立陶宛",
        "Luxembourg": "卢森堡",
        "Mexico": "墨西哥",
        "Netherlands": "荷兰",
        "New_Zealand": "新西兰",
        "Norway": "挪威",
        "Panama": "巴拿马",
        "Peru": "秘鲁",
        "Poland": "波兰",
        "Portugal": "葡萄牙",
        "Puerto_Rico": "波多黎各",
        "Romania": "罗马尼亚",
        "Singapore": "新加坡",
        "Slovakia": "斯洛伐克",
        "Slovenia": "斯洛文尼亚",
        "South_Africa": "南非",
        "Spain": "西班牙",
        "Sweden": "瑞典",
        "Switzerland": "瑞士",
        "UK": "英国",
        "United_Kingdom": "英国",
        "US": "美国",
        "United_States": "美国",
        "title": "电话号码要求",
        "subtitle": "请选择将激活全球精选套餐电话号码的国家/地区。",
        "selector_tip": "选择国家/地区",
        "local_and_toll_free": "在 {0} 提供本地电话号码和免费电话号码",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "全球精选套餐包括一个电话号码以及 每个许可证可在选定国家/地区的不限时国内通话。",
        "avail_title": "可用国家/地区"
      },
      "tax_exempt_ecm": {
        "title": "免税资格",
        "status_exempt": "免税",
        "status_exempt_question": "免税？",
        "verify_now": "立即验证",
        "can_after_checkout": "作为一种选择，此步骤可以在结账后完成。",
        "status": {
          "exempt": "免税",
          "pending": "待处理",
          "pendingTooltip": "目前正在审查您的免税资格。您在下单时可能会被征收税款。如果您的豁免获得批准，我们会将所有可退还的税款/费用存入您的账户。",
          "nonexempt": "不免税",
          "rejected": "已拒绝",
          "rejectedTooltip": "提交的文件被确定不符合您的司法管辖区要求。",
          "approved": "已批准",
          "default": "默认"
        },
        "confirm_close": {
          "new_desc": "如果您放弃验证，您可能会被收取适用的税款/费用。购买后，您仍可以在“账单管理”部分提交免税文件，供 Zoom 审核和批准。验证成功之后，所有已征收的税款将予以退还。",
          "desc": "是否确定放弃免税验证并继续缴纳相应的税费？",
          "title": "确定？",
          "new_title": "放弃免税验证？",
          "yes": "是，放弃",
          "no": "否，继续",
          "abandon": "放弃验证",
          "go_back": "返回"
        },
        "confirm_to_add": {
          "title": "确认新的默认免税",
          "message": "在添加新的豁免时，其将在被批准或拒绝后自动设置为默认豁免。您只能有一项默认豁免，其将适用于以后的购买。如果您的默认豁免与“买方”州/地区不符，您的税额可能会受到影响。",
          "yes": "添加新的豁免"
        },
        "confirm_set_default": {
          "title": "地址和免税地点不匹配",
          "message": "您的“买方联系人”地址与您选择的免税州/地区不匹配。请更新您的“买方联系人”地址以匹配您的免税地点。否则，您的购买可能不予免税。",
          "yes": "无论如何都设置为默认",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "州/地区",
          "exemption_type": "豁免类型",
          "signed_date": "签署日期",
          "status": "状态",
          "add_exemption": "添加豁免",
          "view": "查看",
          "set_as_default": "设为默认"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "您的 {planName} 套餐将于 {date}协调世界时午夜 12:00 取消。如果您想在取消日期后继续主持，请重新激活您的套餐。",
        "pairPreDescTip": "您的 {planName1} 套餐和 {planName2} 套餐将于 {date}协调世界时午夜 12:00 取消。如果您想在取消日期后继续主持，请重新激活您的套餐。",
        "pairDiffDatePreDescTip": "您的 {planName1} 套餐和 {planName2} 套餐将分别于 {date1}协调世界时午夜 12:00 和 {date2}协调世界时午夜 12:00 取消。如果您想在取消日期后继续主持，请重新激活您的套餐。",
        "title": "重新激活套餐以继续",
        "titles": "重新激活套餐以继续",
        "plan": "套餐",
        "licenses": "许可证",
        "billingCycle": "计费周期",
        "effective_date": "生效日期",
        "invoice_amount": "发票金额",
        "singleDescTip": "重新激活即表示您同意定期套餐将于 {date}自动续订，并将在每次续订时以保存的付款方式支付费用。为避免将来产生费用，请在续订日期前<a target=\"_blank\" href=\"https://support.zoom.com/hc/zh/article?id=zm_kb&sysparm_article=KB0066687\">取消</a>套餐。",
        "pairDescTip": "重新激活即表示您同意将在 {date}自动续订您的定期套餐。每次续订时，都会以您保存的付款方式支付费用。为避免将来产生费用，请在续订日期前<a target=\"_blank\" href=\"https://support.zoom.com/hc/zh/article?id=zm_kb&sysparm_article=KB0066687\">取消</a>套餐。",
        "pairDiffDateDescTip": "重新激活即表示您同意将在 {date1}和 {date2}自动续订您的定期套餐。每次续订时，都会以您保存的付款方式支付费用。为避免将来产生费用，请在续订日期前<a target=\"_blank\" href=\"https://support.zoom.com/hc/zh/article?id=zm_kb&sysparm_article=KB0066687\">取消</a>套餐。",
        "totalLabel": "共计",
        "totalContent": "{money} 加上适用税费",
        "taxDesc": "不含增值税、消费税或类似税费",
        "reactivateBtn": "继续并重新激活",
        "switchTitle": "更新您的套餐以继续",
        "successSingleTip": "您的 {planName}套餐已重新激活",
        "successPairTip": "您的 {planName1} 和 {planName2}套餐已重新激活",
        "switchTip": "您的 Zoom Webinars 一个月套餐将于 {date}到期。如果要在此日期之后主持网络研讨会，您必须转为订阅。",
        "switchBtn": "转为订阅"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace专业版"
      },
      "biz": {
        "title": "Zoom Workplace商业版"
      },
      "proPlus": {
        "title": "Zoom Workplace 专业加强版"
      },
      "bizPlus": {
        "title": "Zoom Workplace 商业加强版"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "\u4E0B\u8F7D\u6570\u636E\u8868"
      },
      "one": {
        "new": "全新"
      }
    },
    "webinarSetupInWebPortal": "门户网站中的网络研讨会设置",
    "concurrentEvents": "同时进行的活动",
    "coucurrentEventsToolTip": "<span><b>订阅</b>套餐支持一次进行一场实时活动",
    "overages": "超额",
    "eventsPlatformHubs": "Zoom Events 平台中心",
    "eventsHubToolTip": "Zoom Events <b>中心</b>可以便捷地安排活动",
    "1HubPerLicense": "每个许可证 1 个中心",
    "1000Hubs": "1000 个中心",
    "eventsPlatformHosts_500AttendeesOrMore": "Zoom Events 平台主持人（500 名或 500 名以上的观众）",
    "eventsHost500": "<span>Zoom Events <b>中心主持人</b>可以创建",
    "5HubHosts": "5 名中心主持人",
    "100HubHosts": "100 名中心主持人",
    "eventsPlatformHosts_100Attendees": "Zoom Events 平台主持人（100 名观众）",
    "eventsHost100": "<span>Zoom Events <b>中心主持人</b>可以创建",
    "2HubHosts": "2 名中心主持人",
    "howAreTheyDifferent": "它们有何区别？",
    "allPlansRequireAZoomOneLicense": "*所有套餐均需要 Zoom Workplace 许可证",
    "subscription": "订阅",
    "subscriptionToolTip": "<span><b>订阅</b>支持您以选定的规模举办不限次数的活动。</span>",
    "payPerAttendee": "按观众付费",
    "ppaToolTips": "<span><b>按观众付费</b>许可证规定了自购买之日起的 12 个月内，总共有多少观众可以参加您的账户所举办的所有活动。</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "\u6295\u7968",
    "meetings.fullPlanItem2": "\u8BB8\u53EF\u8BC1\u6570",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom会议",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "简化跨任何设备的视频会议和信息发送",
    "meetings.fullPlanItem5": "\u4F1A\u8BAE\u6301\u7EED\u65F6\u95F4",
    "meetings.fullPlanItem5Tip": "\u6BCF\u6B21\u7FA4\u7EC4\u4F1A\u8BAE\uFF08\u4E0D\u5C11\u4E8E 3 \u540D\u53C2\u4F1A\u8005\uFF09\u5141\u8BB8\u7684\u6700\u957F\u6301\u7EED\u65F6\u95F4\u3002",
    "meetings.fullPlanItem5_basic": "40 \u5206\u949F",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 \u5C0F\u65F6",
    "meetings.fullPlanItem5_biz": "30 \u5C0F\u65F6",
    "meetings.fullPlanItem5_ent": "30 \u5C0F\u65F6",
    "meetings.fullPlanItem1": "\u53C2\u4F1A\u8005\u5BB9\u91CF",
    "meetings.fullPlanItem1Tip": "\u53C2\u4F1A\u8005\u662F\u7531\u6301\u4F1A\u8BAE\u8BB8\u53EF\u8BC1\u7684\u4EBA\u5B89\u6392\u7684\u4F1A\u8BAE\u7684\u53D7\u9080\u4EBA\u3002\u53C2\u4F1A\u8005\u53EF\u4EE5\u4ECE\u624B\u673A\u3001\u53F0\u5F0F\u673A\u3001\u79FB\u52A8\u8BBE\u5907\u548C\u5E73\u677F\u7535\u8111\u514D\u8D39\u52A0\u5165\u4F1A\u8BAE\u3002\u53C2\u4F1A\u8005\u4E0D\u9700\u8981\u6709 Zoom \u8D26\u6237\u5373\u53EF\u52A0\u5165\u4F1A\u8BAE\u3002\u6BCF\u4E2A\u8BA1\u5212\u7684\u53C2\u4F1A\u8005\u4EBA\u6570\u90FD\u6709\u9650\u5236\uFF0C\u4F46\u662F\u7528\u6237\u53EF\u4EE5\u901A\u8FC7\u8D2D\u4E70\u9644\u52A0\u7EC4\u4EF6\u6765\u63D0\u9AD8\u4ED8\u8D39\u8BA1\u5212\u7684\u4EBA\u6570\u4E0A\u9650\u3002",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000（适用于企业加强版）</span>",
    "meetings.fullPlanItem7": "\u5F55\u5236",
    "meetings.fullPlanItem7Tip": "Zoom \u672C\u5730\u5F55\u5236\u53EF\u4EE5\u5C06\u4F1A\u8BAE\u8BB0\u5F55\u4FDD\u5B58\u4E3A MP4\uFF08\u89C6\u9891\uFF09\u3001M4A\uFF08\u97F3\u9891\uFF09\u548C txt\uFF08\u804A\u5929\uFF09\u683C\u5F0F\u3002<br>Zoom \u4E91\u5F55\u5236\u53EF\u4EE5\u5C06\u4F1A\u8BAE\u5B58\u50A8\u5728 Zoom \u4E91\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6D4F\u89C8\u5668\u4E0B\u8F7D\u548C/\u6216\u4F20\u8F93\u5176\u4E2D\u7684\u6587\u4EF6\u3002",
    "meetings.fullPlanItem7_basic": "\u672C\u5730\u5F55\u5236",
    "meetings.fullPlanItem7_pro": "\u672C\u5730\u5F55\u5236\u53CA 5 GB \u4E91\u5B58\u50A8\uFF08\u6BCF\u4E2A\u8BB8\u53EF\u8BC1\uFF09",
    "meetings.fullPlanItem7_biz": "\u672C\u5730\u5F55\u5236\u53CA 10 GB \u4E91\u5B58\u50A8\uFF08\u6BCF\u4E2A\u8BB8\u53EF\u8BC1\uFF09",
    "meetings.fullPlanItem7_ent": "\u672C\u5730\u5F55\u5236\u53CA\u65E0\u9650\u4E91\u5B58\u50A8",
    "one.messaging": "发送消息",
    "meetings.fullPlanItem16Tip": "\u60A8\u53EF\u4EE5\u901A\u8FC7 Chat \u8F7B\u677E\u53D1\u9001\u7FA4\u804A\u4FE1\u606F\u3001\u6587\u4EF6\u3001\u5C4F\u5E55\u622A\u56FE\u3001\u4EE3\u7801\u7247\u6BB5\u3001\u8BED\u97F3\u6D88\u606F\u548C\u56FE\u7247\u3002 \u53EF\u89C4\u5B9A\u6587\u672C\u683C\u5F0F\uFF0C\u7528\u6237\u8FD8\u53EF\u5171\u4EAB GIF \u548C\u8868\u60C5\u3002 \u5728\u7EBF\u72B6\u6001\u663E\u793A\u804A\u5929\u53C2\u4E0E\u8005\u4F7F\u7528\u7684\u662F\u7535\u8111\u3001\u79FB\u52A8\u8BBE\u5907\uFF0C\u8FD8\u662F\u5904\u4E8E\u5FD9\u788C\u72B6\u6001\u3002",
    "meetings.fullPlanItem51": "Zoom \u767D\u677F",
    "meetings.unlimited": "\u65E0\u9650",
    "meetings.fullPlanItem_EssentialApp": "基本应用",
    "common.learnMore": "\u4E86\u89E3\u66F4\u591A",
    "meetings.fullPlanItem_EssentialAppText": "免费使用付费应用 1 年（需遵守条款）",
    "zoomMailAndCalendarInTheZoomApp": "Zoom App 中的 Zoom Mail 和 Calendar",
    "mailService": "邮件服务",
    "emailServiceWithFullTimeEndToEnd": "电子邮件服务具有全时端到端加密功能，可增强隐私保护",
    "customMailDomain": "自定义邮件域",
    "customMailDomainWithMailService": "具有邮件服务的自定义邮件域",
    "calendarClient": "日历客户端",
    "scheduleAndJoinMeetings": "通过 Zoom App 安排和加入会议",
    "aiCompanion": "AI Companion",
    "calendarService": "日历服务",
    "meetingSchedulingAndAppointment": "会议安排和预约",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "轻松创建、编辑和共享短视频。 存储后的剪辑显而易见，从而提高了参与度。",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes 提供了功能强大的个人和协作文档编辑器，可编辑多种格式的文档并且可在会议内外使用。",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "已翻译字幕",
    "workspaceReservation": "工作区预订",
    "accessAcrossAnyDevice": "通过任何设备访问",
    "meetings.fullPlanItem4": "\u65E0\u9650\u5236\u4F1A\u8BAE",
    "meetings.fullPlanItem9": "\u7535\u8BDD\u62E8\u5165",
    "meetings.fullPlanItem9Tip": "\u901A\u8FC7\u7535\u8BDD\u4F1A\u8BAE/\u97F3\u9891\u4F1A\u8BAE\uFF08\u4F7F\u7528\u4F20\u7EDF\u7535\u8BDD\uFF09\u52A0\u5165Zoom\u4F1A\u8BAE\u3002\u6211\u4EEC\u5C06\u6309\u7167\u7528\u6237\u7684\u901A\u8BDD\u5957\u9910\u5411\u7528\u6237\u6536\u53D6\u8D39\u7528\u3002\u8BD5\u7528\u6211\u4EEC\u7684\u97F3\u9891\u4F1A\u8BAE\u9644\u52A0\u5957\u9910\u4EE5\u83B7\u53D6\u88AB\u53EB\u4ED8\u8D39\u62E8\u5165\u53F7\u7801\u3002",
    "meetings.fullPlanItem9_pro": "\u6536\u8D39",
    "meetings.fullPlanItem9_biz": "\u6536\u8D39",
    "meetings.fullPlanItem9_ent": "\u6536\u8D39",
    "meetings.fullPlanItem11": "\u5C4F\u5E55\u5171\u4EAB",
    "meetings.fullPlanItem11Tip": "\u684C\u9762\u548C\u5E94\u7528\u5171\u4EAB\u3002\u6388\u6743\u4F1A\u8BAE\u7528\u6237\u53EF\u4EE5\u9009\u62E9\u5141\u8BB8\u591A\u540D\u53C2\u4F1A\u8005\u5728\u4ED6\u4EEC\u4E3B\u6301\u7684\u4F1A\u8BAE\u671F\u95F4\u540C\u65F6\u5171\u4EAB\u5C4F\u5E55\u3002",
    "meetings.fullPlanItem12": "\u5206\u7EC4\u4F1A\u8BAE\u5BA4",
    "meetings.fullPlanItem12Tip": "\u60A8\u53EF\u4EE5\u901A\u8FC7\u89C6\u9891\u5206\u7EC4\u4F1A\u8BAE\u5BA4\u5C06 Zoom \u4F1A\u8BAE\u5206\u6210\u6700\u591A 50 \u4E2A\u5355\u72EC\u7684\u4F1A\u8BAE\uFF0C\u5206\u522B\u8FDB\u884C\u8BA8\u8BBA\u3001\u4E13\u9898\u7814\u7A76\u7B49\u3002",
    "meetings.fullPlanItem14": "\u865A\u62DF\u80CC\u666F",
    "meetings.fullPlanItem15": "\u4E2A\u4EBA\u4F1A\u8BAE\u53F7",
    "meetings.fullPlanItem15Tip": "\u521B\u5EFA\u60A8\u81EA\u5DF1\u7684\u6C38\u4E45\u5728\u7EBF\u4F1A\u8BAE\u5BA4\u3002\u60A8\u53EF\u4EE5\u968F\u65F6\u5F00\u59CB\u4F1A\u8BAE\uFF0C\u6216\u5B89\u6392\u5C06\u6765\u6240\u9700\u7684\u4F1A\u8BAE\u3002",
    "meetings.fullPlanItem17": "\u4E3B\u6301\u4EBA\u63A7\u4EF6",
    "meetings.fullPlanItem18": "\u5728\u5171\u4EAB\u5C4F\u5E55\u4E0A\u8FDB\u884C\u5171\u540C\u6CE8\u91CA",
    "meetings.fullPlanItem19": "\u8FDC\u7A0B\u952E\u76D8\u548C\u9F20\u6807\u63A7\u5236",
    "meetings.fullPlanItem21": "\u591A\u65B9\u5171\u4EAB",
    "meetings.fullPlanItem29": "\u7B49\u5019\u5BA4",
    "meetings.fullPlanItem29Tip": "\u7B49\u5019\u5BA4\u529F\u80FD\u5141\u8BB8\u4E3B\u6301\u4EBA\u63A7\u5236\u53C2\u4F1A\u8005\u52A0\u5165\u4F1A\u8BAE\u7684\u65F6\u95F4\u3002 \u4F5C\u4E3A\u4F1A\u8BAE\u4E3B\u6301\u4EBA\uFF0C\u60A8\u53EF\u4EE5\u9010\u4E00\u51C6\u8BB8\u53C2\u4F1A\u8005\u6216\u4E00\u6B21\u6027\u51C6\u8BB8\u6240\u6709\u53C2\u4F1A\u8005\u3002 \u5728\u8BBE\u7F6E\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u5C06\u54EA\u4E9B\u4EBA\u7F6E\u5165\u7B49\u5019\u5BA4\u3001\u54EA\u4E9B\u4EBA\u81EA\u52A8\u83B7\u5F97\u51C6\u8BB8\u3002 \u6240\u6709\u8D26\u6237\u90FD\u6709\u7B49\u5019\u5BA4\u529F\u80FD\u3002 \u4E3B\u6301\u4EBA\u53EF\u4EE5\u5411\u7B49\u5019\u5BA4\u53D1\u9001\u6D88\u606F\u3002 \u5982\u679C\u4F7F\u7528\u7684\u662F\u4ED8\u8D39\u5957\u9910\uFF0C\u5219\u53EF\u4EE5\u81EA\u5B9A\u4E49\u7B49\u5019\u5BA4\u3002",
    "meetings.fullPlanItem41": "Zoom for Home \u8BBE\u5907\u5185\u7F6E",
    "meetings.fullPlanItem61": "\u56FA\u5B9A\u591A\u4EBA",
    "meetings.fullPlanItem61Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u6388\u4E88 9 \u4EBA\u56FA\u5B9A\u89C6\u9891\u4EE5\u521B\u5EFA\u81EA\u5B9A\u4E49\u89C6\u56FE\u7684\u6743\u9650\u3002 \u8FD9\u6837\u65E0\u8BBA\u53D1\u8A00\u4EBA\u662F\u8C01\uFF0C\u56FA\u5B9A\u89C6\u9891\u5C06\u4FDD\u6301\u53EF\u89C1\u3002",
    "meetings.fullPlanItem62": "\u805A\u7126\u591A\u4EBA",
    "meetings.fullPlanItem62Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u805A\u7126 9 \u540D\u89C2\u4F17\u7684\u89C6\u9891\uFF0C\u8FD9\u6837\u65E0\u8BBA\u53D1\u8A00\u4EBA\u662F\u8C01\uFF0C\u5168\u4F53\u53C2\u4F1A\u8005\u90FD\u80FD\u770B\u5230\u805A\u96C6\u4EBA\u5458\u7684\u89C6\u9891\u3002",
    "meetings.fullPlanNewItem1": "\u6EE4\u955C",
    "meetings.fullPlanNewItem1Tip": "\u4F7F\u7528\u6709\u8DA3\u7684\u5F69\u8272\u6EE4\u955C\u6216\u88C5\u9970\u6027\u52A8\u7269\u8D34\u7EB8\uFF0C\u4E3A\u6B22\u4E50\u65F6\u523B\u3001\u805A\u4F1A\u7B49\u573A\u5408\u589E\u6DFB\u4E50\u8DA3\u3002",
    "meetings.fullPlanNewItem2": "\u6295\u7968",
    "meetings.fullPlanNewItem3": "\u8054\u5E2D\u4E3B\u6301\u4EBA\u548C\u5907\u9009\u4E3B\u6301\u4EBA",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/zh-cn/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">\u4E86\u89E3\u66F4\u591A</a>\u5173\u4E8E\u6211\u4EEC\u7684\u4F1A\u8BAE\u8054\u5E2D\u4E3B\u6301\u4EBA\u63A7\u4EF6\u7684\u4FE1\u606F\u3002",
    "meetings.fullPlanItem24": "\u5206\u914D\u4F1A\u8BAE\u5B89\u6392\u8005",
    "meetings.fullPlanItem24Tip": "\u60A8\u53EF\u4EE5\u5206\u914D\u5176\u4ED6\u4EBA\u5458\u4E3A\u60A8\u8BBE\u7F6E\u4F1A\u8BAE\u3002\u53D7\u6258\u4EBA\u5FC5\u987B\u62E5\u6709\u4E13\u4E1A\u7248\u8BA1\u5212\u3002",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "\u4F7F\u8D26\u6237\u6240\u6709\u8005\u3001\u7BA1\u7406\u5458\u548C\u60A8\u7684\u5F00\u53D1\u4EBA\u5458\u80FD\u591F\u5B89\u5168\u8BBF\u95EE Zoom REST API\u3002\u6839\u636E\u8D26\u6237\u7C7B\u578B\uFF08\u4E13\u4E1A\u7248\u3001\u5546\u4E1A\u7248\u3001\u4F01\u4E1A\u7248\u7B49\uFF09\u548C API \u8BF7\u6C42\u7C7B\u578B\uFF08\u8F7B\u578B\u3001\u4E2D\u578B\u3001\u91CD\u578B\u7B49\uFF09\uFF0C\u4E0D\u540C\u8D26\u6237\u7EA7\u522B\u9002\u7528\u4E0D\u540C\u7684 API \u901F\u7387\u9650\u5236\u3002\u90E8\u5206 API \u53EA\u5BF9\u7279\u5B9A\u8D26\u6237\u7C7B\u578B\u6709\u8BBF\u95EE\u9650\u5236\u3002\u4F7F\u7528 API \u901F\u7387\u9650\u5236\u548C API \u53C2\u8003\u6587\u6863\u4E86\u89E3\u5B8C\u6574\u4FE1\u606F\u3002",
    "meetings.fullPlanItem25_pro": "REST API \u4E13\u4E1A\u7248\u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem25_biz": "REST API \u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem26": "Skype for Business (Lync) \u4E92\u64CD\u4F5C\u6027",
    "meetings.fullPlanItem26Tip": "Lync 2010 \u548C 2013 \u7528\u6237\u4EE5\u53CA Skype for Business \u7528\u6237\u53EF\u4EE5\u901A\u8FC7 Lync \u8054\u7CFB\u4EBA\u5217\u8868\u53D1\u8D77 Zoom \u4F1A\u8BAE\u3002",
    "meetings.fullPlanItem27": "\u76F4\u64AD",
    "meetings.fullPlanItem27Tip": "\u5411 Facebook\u3001Youtube \u6216\u7B2C\u4E09\u65B9\u670D\u52A1\u76F4\u64AD\u3002",
    "meetings.fullPlanItem28": "\u62A5\u544A",
    "meetings.fullPlanItem28Tip": "\u4FDD\u5B58\u767D\u677F\u4F1A\u8BDD",
    "meetings.fullPlanItem30": "\u7528\u6237\u7BA1\u7406",
    "meetings.fullPlanItem30Tip": "\u6240\u6709\u8005\u548C\u7BA1\u7406\u5458\u53EF\u4EE5\u6DFB\u52A0\u3001\u5220\u9664\u548C\u5206\u914D\u89D2\u8272\u4E0E\u9644\u4EF6\u529F\u80FD\u3002",
    "one.autoCaptions": "自动字幕",
    "meetings.fullPlanItem31": "\u7BA1\u7406\u5458\u95E8\u6237",
    "meetings.fullPlanItem31Tip": "\u901A\u8FC7Zoom\u7BA1\u7406\u5458\u95E8\u6237\u4F7F\u7528\u4E00\u4E2A\u8D26\u6237\u7BA1\u7406\u516C\u53F8\u7684\u6240\u6709\u7528\u6237\uFF0C\u4EE5\u7B80\u5316\u8BA1\u8D39\u65B9\u5F0F\u3001\u5B9E\u73B0\u9AD8\u7EA7\u7528\u6237\u7BA1\u7406\u8BBE\u7F6E\u5E76\u5BF9\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u5168\u9762\u5206\u6790\u3002",
    "meetings.fullPlanItem32": "LTI \u96C6\u6210",
    "meetings.fullPlanItem32Tip": "\u901A\u8FC7\u5B66\u4E60\u7BA1\u7406\u7CFB\u7EDF\uFF08\u642D\u914D Moodle\u3001Canvas\u3001Desire2Learn \u548C Blackboard \u4F7F\u7528\uFF09\uFF0C\u8F7B\u677E\u5C06\u4F1A\u8BAE\u6DFB\u52A0\u81F3\u4EFB\u4F55\u8BFE\u7A0B\u6D3B\u52A8\u5E76\u9080\u8BF7\u9002\u5408\u7684\u5B66\u751F\u3002",
    "meetings.fullPlanItem33": "\u4E91\u5F55\u5236\u6284\u672C",
    "meetings.fullPlanItem33Tip": "\u4E91\u5F55\u5236\u6284\u672C\u662F\u60A8\u5F55\u5236\u5230\u4E91\u7AEF\u7684\u4F1A\u8BAE\u6216\u7F51\u7EDC\u7814\u8BA8\u4F1A\u97F3\u9891\u7684\u8F6C\u5F55\u6587\u5B57\u3002 \u8BF7\u6CE8\u610F\uFF0C\u76EE\u524D\u4EC5\u82F1\u8BED\u8BED\u8A00\u652F\u6301\u6B64\u670D\u52A1\u3002 <a href=\"https://support.zoom.us/hc/zh-cn/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\u70B9\u51FB\u6B64\u5904</a>\u4E86\u89E3\u8BE6\u60C5\u3002",
    "meetings.fullPlanItem34": "\u54C1\u724C\u5BA3\u4F20",
    "meetings.fullPlanItem34Tip": "\u5C06\u516C\u53F8\u54C1\u724C\u4FE1\u606F\u6DFB\u52A0\u5230\u81EA\u5B9A\u4E49\u9875\u9762\uFF0C\u7528\u6237\u4ECE\u8BE5\u9875\u9762\u52A0\u5165\u4F1A\u8BAE\u3002\u521B\u5EFA\u9080\u8BF7\u89C2\u4F17\u6240\u9700\u7684\u54C1\u724C\u7535\u5B50\u90AE\u4EF6\u6A21\u677F\u3002",
    "meetings.fullPlanItem35": "\u6258\u7BA1\u57DF",
    "meetings.fullPlanItem35Tip": "\u4F7F\u7528\u60A8\u7684\u516C\u53F8/\u5927\u5B66\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u57DF\u5C06\u7528\u6237\u81EA\u52A8\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u3002",
    "meetings.fullPlanItem37": "\u8BED\u8A00\u7FFB\u8BD1",
    "meetings.fullPlanItem37Tip": "\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u53EF\u4EE5\u5728\u4F1A\u8BAE\u548C\u7F51\u7EDC\u7814\u8BA8\u4F1A\u4E2D\u6307\u5B9A\u8BD1\u5458\u3002\u5F53\u4F1A\u8BAE\u6216\u7F51\u7EDC\u7814\u8BA8\u4F1A\u5F00\u59CB\u65F6\uFF0C\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u53EF\u4EE5\u5F00\u542F\u7FFB\u8BD1\u529F\u80FD\uFF0C\u8FD9\u5C06\u4E3A\u8BD1\u5458\u63D0\u4F9B\u4E13\u95E8\u7684\u8BED\u8A00\u9891\u9053\u3002\u53C2\u4F1A\u8005\u53EF\u4EE5\u6839\u636E\u9700\u8981\uFF0C\u9009\u62E9\u81EA\u5DF1\u6240\u9700\u7684\u8BED\u8A00\u9891\u9053\u3002\u53C2\u4F1A\u8005\u4E0D\u4F46\u53EF\u4EE5\u542C\u5230\u81EA\u5DF1\u6240\u9700\u7684\u8BED\u8A00\u7FFB\u8BD1\uFF0C\u8FD8\u53EF\u4EE5\u9009\u62E9\u8C03\u4F4E\u539F\u59CB\u97F3\u9891\u7684\u58F0\u97F3\u3002",
    "meetings.fullPlanItem39": "\u9AD8\u7BA1\u5546\u4E1A\u8BC4\u8BBA",
    "meetings.fullPlanItem39Tip": "\u8BE6\u7EC6\u7684\u8D8B\u52BF\u91C7\u7528\u5206\u6790\u3001\u6295\u8D44\u56DE\u62A5\u7387 (ROI) \u8DDF\u8E2A\u4EE5\u53CA\u4EA7\u54C1\u8DEF\u7EBF\u56FE\u8BA8\u8BBA\u3002",
    "meetings.fullPlanNewItem4": "\u5305\u542B Webinar 500",
    "one.translatedCations": "已翻译字幕",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "私聊、频道或群聊",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "轻松地在一对一消息、小型或大型群组中进行交流",
    "messageAndFileHistory": "消息和文件历史记录",
    "findPeopeChannelsAndFilesInSearch": "在搜索中查找人员、频道和文件",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "快速查找联系人、即时消息、群组聊天和文件，随时掌握各类知识和信息。",
    "applicationIntegrations": "应用程序集成",
    "secureFileSharing": "安全的文件共享功能",
    "enhanceCollaborationWithSeamlessFileSharing": "加强协作，实现无缝文件共享",
    "persistentMeetingChat": "持续会议聊天",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "再也不会丢失会议谈话内容。 在会议前、会议中和会议后，所有会议参与者都可以在 Zoom Team Chat 的专用群组聊天中进行沟通。",
    "cloudStorage": "云存储",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "将频道备份到 Zoom 云或第三方存储提供商",
    "avatars": "虚拟形象",
    "inMeetingReactions": "会议内表情符号",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "表现出互动性，并以非口头方式与其他参与者快速沟通",
    "virtualBackgrounds": "虚拟背景",
    "videoFilters": "视频滤镜",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "通过在视频上叠加各种滤镜，为您的会议增添一些乐趣",
    "inMeetingPollsAndQuizzes": "会议内问卷和测验",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "为您的会议创建单选或多选问卷问题。",
    "liveStreamingAcrossPlatforms": "平台直播",
    "appearanceTouchUp": "美颜",
    "originalSoundForMusicians": "音乐人原声",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings 的端到端加密功能",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "启用 Zoom Meetings 的端到端加密 (E2EE) 功能即表示，特定会议中使用 Zoom 客户端的所有会议参会者之间的通信将使用仅限参会者设备已知的加密密钥进行加密。 这意味着，任何第三方（包括 Zoom）都无法获得会议的私钥。",
    "zoomCustomerManagedKey": "Zoom客户管理的密钥",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "自带加密密钥以保护Zoom静态数据",
    "enterpriseGradeSecurityFeatures": "企业级安全功能",
    "256BitAesGcmEncryptionForRealTimeContent": "适用于实时内容和媒体的 256 位 AES-GCM 加密，在 SIP 注册期间使用的 TLS 加密，以及主叫方 ID 屏蔽、专用网络对等互联、工具欺诈检测和呼叫阻止列表。",
    "phone.fullPlanItem40": "\u901A\u8FC7 SAML 2.0 \u5355\u70B9\u767B\u5F55",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "\u65E0\u9650\u56FD\u9645\u901A\u8BDD",
    "phone.fullPlanItem2": "\u8BA1\u65F6\u547C\u51FA",
    "phone.fullPlanItem3": "\u65E0\u9650\u547C\u51FA",
    "phone.fullPlanItem4": "\u4E1A\u754C\u9886\u5148\u7684\u9AD8\u6E05\u901A\u8BDD\u8D28\u91CF",
    "phone.fullPlanItem4Tip": "\u5177\u5907\u4E3B\u52A8\u964D\u566A\u3001\u56DE\u58F0\u6D88\u9664\u53CA\u6309\u952E\u6291\u5236\u529F\u80FD",
    "phone.fullPlanItem5": "\u539F\u751F Windows\u3001MacOS \u548C Linux \u684C\u9762\u5E94\u7528",
    "phone.fullPlanItem6": "\u539F\u751F iOS \u548C Android \u79FB\u52A8\u5E94\u7528",
    "phone.fullPlanItem7": "\u8F6C\u79FB\u73B0\u6709\u53F7\u7801\u6216\u8D2D\u4E70\u65B0\u53F7\u7801 (DID)",
    "phone.fullPlanItem8": "\u88AB\u53EB\u4ED8\u8D39\u53F7\u7801",
    "phone.fullPlanItem9": "\u7535\u8BDD\u5206\u673A\u53F7\u7801",
    "phone.fullPlanItem10": "\u5E26\u8F6C\u5F55\u529F\u80FD\u7684\u8BED\u97F3\u4FE1\u7BB1",
    "phone.fullPlanItem10Tip": "\u901A\u8FC7\u79FB\u52A8/\u684C\u9762\u5E94\u7528\u548C\u7535\u5B50\u90AE\u4EF6\u8BBF\u95EE\u8BED\u97F3\u4FE1\u7BB1\u8F6C\u5F55",
    "phone.fullPlanItem11": "\u65E0\u9650\u81EA\u52A8\u52A9\u7406/ IVR",
    "phone.fullPlanItem12": "\u6309\u59D3\u540D\u76EE\u5F55\u62E8\u53F7",
    "phone.fullPlanItem13": "\u81EA\u52A8\u547C\u53EB\u5206\u914D (ACD) \u7FA4\u7EC4\uFF0C\u5177\u6709\u547C\u53EB\u961F\u5217\u529F\u80FD",
    "phone.fullPlanItem14": "\u5207\u5165/\u76D1\u89C6/\u79C1\u804A/\u63A5\u7BA1",
    "phone.fullPlanItem15": "\u8282\u5047\u65E5\u548C\u5DE5\u4F5C\u65E5\u8DEF\u7531\u9009\u62E9",
    "phone.fullPlanItem16": "3 \u8DEF\u4E13\u7528\u7535\u8BDD\u4F1A\u8BAE",
    "phone.fullPlanItem17": "\u901A\u8BDD\u5F55\u97F3",
    "phone.fullPlanItem17Tip": "\u53EF\u4EE5\u81EA\u52A8\u548C\u624B\u52A8\u5F55\u97F3\u3002",
    "phone.fullPlanItem18": "\u53EF\u914D\u7F6E\u7684\u533F\u540D\u53CA\u6307\u5B9A\u547C\u53EB\u9650\u5236",
    "phone.fullPlanItem19": "\u7D27\u6025\u547C\u53EB",
    "phone.fullPlanItem19Tip": "\u62E8\u6253\u5F53\u5730\u7D27\u6025\u670D\u52A1\u7535\u8BDD",
    "phone.fullPlanItem20": "Nomadic E911 \u5BFB\u5740\uFF08\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\uFF09\u2014\u2014",
    "phone.fullPlanItem20Tip": "\u52A8\u6001\u68C0\u6D4B\u7528\u6237\u4F4D\u7F6E\uFF0C\u5E76\u5C06\u76F8\u5E94\u7684\u7D27\u6025\u5730\u5740\u62A5\u544A\u7ED9\u672C\u5730\u7D27\u6025\u670D\u52A1\u90E8\u95E8\uFF08\u4EC5\u9650\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\uFF09\u548C\u5185\u90E8\u5B89\u5168\u56E2\u961F",
    "phone.fullPlanItem21": "\u7D27\u6025\u54CD\u5E94\u4E2D\u5FC3",
    "phone.fullPlanItem21Tip": "\u60A8\u7684\u5185\u90E8\u5B89\u5168\u56E2\u961F\u80FD\u591F\u6536\u5230\u7D27\u6025\u547C\u53EB\u8B66\u62A5\uFF0C\u5E76\u8BB0\u5F55/\u76D1\u89C6/\u5207\u5165\u7D27\u6025\u547C\u53EB\u4EE5\u5E2E\u52A9\u534F\u8C03\u54CD\u5E94\u3002",
    "phone.fullPlanItem22": "\u5171\u4EAB\u7EBF\u8DEF\u663E\u793A/\u6388\u6743",
    "phone.fullPlanItem23": "\u8BBE\u5907\u95F4\u547C\u53EB\u5207\u6362",
    "phone.fullPlanItem24": "\u547C\u53EB\u5BC4\u5B58",
    "endToEndEncryptionForZoomPhone": "Zoom Phone 的端到端加密功能",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "启用 Zoom Phone 的端到端加密 (E2EE) 功能后，将使用仅限呼叫方和接听方设备已知的加密密钥对通话进行加密。 此外，用户还可以选择向彼此提供唯一安全代码验证 E2EE 状态。",
    "phone.fullPlanItem43": "\u96F6\u63A5\u89E6\u7535\u8BDD\u914D\u7F6E",
    "phone.fullPlanItem44": "\u5728\u5355\u4E2A\u8D26\u6237\u4E2D\u914D\u7F6E\u591A\u4E2A\u8BA1\u5212\u7C7B\u578B",
    "phone.fullPlanItem46": "\u5B9E\u65F6\u62A5\u544A\u548C\u8D28\u91CF\u4EEA\u8868\u677F",
    "phone.fullPlanItem47": "\u652F\u6301\u865A\u62DF\u684C\u9762 (VDI) \u73AF\u5883",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/zh-cn/articles/360031096531-Getting-Started-with-VDI\">\u4E86\u89E3\u66F4\u591A</a> VDI \u8BE6\u60C5",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "适用于所有电话独立客户。 支持套餐与会议套餐搭配使用时会有所不同。",
    "phone.fullPlanItem49": "\u81EA\u5E26\u8FD0\u8425\u5546\u652F\u6301",
    "phone.fullPlanItem49Tip": "\u652F\u6301\u4E0E\u73B0\u6709 PSTN \u670D\u52A1\u63D0\u4F9B\u5546\u76F4\u63A5\u548C\u57FA\u4E8E\u73B0\u573A\u7684\u5BF9\u63A5",
    "phone.fullPlanItem50": "\u4E0E\u4F20\u7EDFPBX\u6DF7\u5408\u96C6\u6210",
    "phone.fullPlanItem51": "对讲机",
    "phone.fullPlanItem61": "在线传真",
    "phone.fullPlanItem61Tip": "在美国和加拿大境内发送和接收无限传真。关于国际传真，<a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">请参阅费率</a>",
    "phone.fullPlanSms": "\u77ED\u4FE1\u548C\u5F69\u4FE1",
    "phone.fullPlanSmsTip": "\u4EC5\u9002\u7528\u4E8E\u8D2D\u4E70\u901A\u8BDD\u8BA1\u5212\u7684\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\u53F7\u7801\u3002 \u9002\u7528\u4E8E\u76F4\u62E8\u53F7\u7801\uFF08\u975E\u516C\u53F8\u53F7\u7801\uFF09\u3002",
    "meetings.fullPlanItem6": "\u6280\u672F\u652F\u6301",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "\u51ED\u7968\u5165\u573A",
    "meetings.fullPlanItem6_pro": "\u7968\u8BC1\u4E0E\u5B9E\u65F6\u804A\u5929",
    "meetings.fullPlanItem6_biz": "\u7968\u8BC1\u3001\u5B9E\u65F6\u804A\u5929\u4E0E\u7535\u8BDD",
    "meetings.fullPlanItem6_ent": "\u7968\u8BC1\u3001\u5B9E\u65F6\u804A\u5929\u4E0E\u7535\u8BDD",
    "knowledgeBase": "知识库",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "通过搜索我们的知识库文章解决技术问题并访问支持资源。",
    "zoomCommunity": "Zoom 社区",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "查找解决方案、提出问题和与其他 Zoom 用户协作的地方。",
    "chatbot": "聊天机器人",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "通过与我们的聊天机器人互动获得问题的答案，并解决技术问题。",
    "submitWebTickets": "提交 Web 工单",
    "liveChatSupport": "实时聊天支持",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "订阅套餐费用超过 {amount} 美元/月",
    "livePhoneSupport": "实时电话支持",
    "meetWithAgentOnVideo": "通过视频与坐席会面",
    "subscriptionPlansGreaterThan_200UsdMonth": "订阅套餐费用超过 200 美元/月",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "通过在 Zoom Team Chat 中使用您最常用的应用程序来提高工作效率",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "定制自己的虚拟形象，为会议增添一些乐趣，并在不需要开启视频的情况下以动态方式展示自己",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "邮件",
    "common.plans.meeting.title": "会议",
    "plans.basic_free.upgrade.item1": "每次会议限时 30 小时",
    "common.statistics.participants": "{0} 参会者",
    "common.per_meeting_unit": "按会议",
    "common.participant_limit.increase_with_large_meetings": "通过“大型会议”增加",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "白板",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "不限时",
    "common.plans.team_chat.title": "团队聊天",
    "common.plans.mail_calendar.title": "邮件和日历",
    "common.plans.cloud_storage.title": "云存储",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Zoom字幕翻译",
    "common.plans.extras.title": "赠品",
    "common.plans.extras.desc": "管理公司域等",
    "zoom_one_edu_bundle.school.title": "Zoom One 教育解决方案学校和校园版",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One 教育解决方案学校和校园加强版",
    "per_billing_cycle_license.monthly": "/月/许可证",
    "per_billing_cycle_license.yearly": "/年/许可证",
    "per_billing_cycle_space.monthly": "/月/空间",
    "per_billing_cycle_space.yearly": "/年/空间",
    "common.dialog.feature_list": "查看完整功能列表",
    "detail_dialog.meeting_feature.cloud_recording.pro": "每个许可证 5 GB",
    "detail_dialog.meeting_feature.cloud_recording.10": "每个许可证 10 GB",
    "detail_dialog.meeting_feature.cloud_recording.ent": "企业加强版包括无限版",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + 会议室连接器（比例为 1:25）",
    "plans.whiteboard.ent": "企业加强版包括无限加强版",
    "plans.zp.ent": "包含在企业加强版中",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "提前或现场工作区预约等",
    "plans.largeMeeting.intro_tip": "大型会议是结账时的可选附加组件，可让您举办最多 500 或 1,000 人参加的会议，具体取决于所购买的许可证。",
    "common.participant_limit.expandable_with_large_meetings": "通过“大型会议”可扩展",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000（适用于企业加强版）</span>",
    "plans.webinar": "Zoom网络研讨会",
    "plans.webinar.ent": "企业加强版包括会话 1000（包括网络研讨会）",
    "per_billing_cycle_user.monthly": "/月/用户",
    "per_billing_cycle_user.annually": "/年/用户",
    "closeComparisonChart": "关闭对比图",
    "archiving_api": "存档 API",
    "dlp_api": "DLP API",
    "info_barriers": "信息屏障",
    "chat_etiquette": "聊天礼仪",
    "gdrp": "GDPR",
    "regiona_data_centers": "区域数据中心",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "默认加密",
    "end_to_end_encryption": "端到端加密",
    "cryptographic_boundary": "加密边界",
    "vdi": "虚拟桌面 (VDI)",
    "customer_managed_key": "受管于客户的密钥",
    "gpo_msi_policies": "GPO/MSI 政策",
    "msi": "大规模部署 (MSI)",
    "ntt": "网络测试工具 (NTT)",
    "dashboards": "仪表板",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone 存活能力",
    "zoom_meeting_survivability": "Zoom Meeting 存活能力",
    "paid_option": "付费选项",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "核心功能",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "学校和校园",
    "zoom_one_edu_bundle.school_plus.brief_title": "学校和校园加强版",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "zh-TW": {
    "billing.essential_apps": "必要的應用程式",
    "billing.essential_apps.dialog_desc": "使用會議記錄、互動式活動提升團隊參與感、提供見解以增進客戶對話，發展和管理您的業務。 您的計劃包含 1 年免費使用付費應用程式。",
    "billing.see_more_details": "查看更多詳情",
    "billing.essential_app.legal_copy": "優惠僅適用於目前授權，即 2023 年 1 月 4 日當日或之後，透過 Zoom 的線上通路 zoom.us/buy 購買 Zoom One Pro、商業版或商業加強版訂閱者。 訂閱醫療保健、教育或政府帳戶的使用者，不符合本次優惠條件。  除了 Coda 以外，每一款應用程式自個別使用者啟用應用程式後 1 年到期，依此類推。 Coda 所有使用者皆使用相同 Zoom 帳戶，由相同 Zoom 帳戶內任何使用者第一次啟用 Coda 後開始計算，相同 Zoom 帳戶內所有使用者皆於該啟用後 1 年到期，無論後續相同 Zoom 帳戶內的使用者啟動的日期為何。對於所有應用程式，重新分配或取消使用者的合格授權或訂閱，無論 1 年使用期限是否尚未到期，都將終止該使用者的使用權限。啟用每一個應用程式時，都適用於自身的使用條款和隱私權政策。包含的應用程式目前僅支援英語。並非所有應用程式都適用於行動裝置。優惠無法以現金形式返回或退款。優惠僅適用於內含在 <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> 中的必要應用程式所列的這些應用程式。 任何應用程式的現有訂閱使用者，皆不適用這些特定應用程式的本次優惠。Zoom 有權隨時修改或取消此優惠，且無須事先通知。",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "訪客管理"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "全天候線上聊天和電話支援"
      },
      "learn_more": "\u77AD\u89E3\u66F4\u591A\u8CC7\u8A0A",
      "new": "全新",
      "plan_details": {
        "meeting": {
          "title": "\u6703\u8B70",
          "host_meeting_up_to_participants": "主持最多 {0} 名與會者的會議",
          "meeting_hours": "無限次數的會議，每次會議限時 30 小時",
          "recording_storage": "{0} GB 雲端儲存錄製空間 (每一個授權)",
          "auto_captions": "自動字幕"
        },
        "whiteboard": {
          "title": "白板",
          "boards_storage": "{0} 個可編輯白板",
          "standard_features": "標準功能"
        },
        "team_chat": {
          "title": "團體聊天",
          "desc": "群組聊天和檔案分享"
        },
        "main_calendar": {
          "title": "郵件與日曆",
          "desc": "Mail 與 Calendar 用戶端和服務"
        },
        "notes": {
          "title": "Notes",
          "desc1": "在 Zoom 內建立和分享可編輯文件",
          "desc2": "設有 RTF 編輯的個人及協作筆記"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "輕鬆錄製、編輯和分享短片",
          "desc2": "無限制的影片和進階功能"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "快速取得會議摘要，協助撰寫訊息草稿等更多內容"
        },
        "EssentialApp": {
          "title": "必要的應用程式",
          "desc1": "1 年內免費使用付費應用程式 (適用條款)",
          "desc2": "增強團隊的協作和生產力"
        },
        "livechat": {
          "title": "即時聊天支援"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "變更為 Zoom Workplace 專業版？",
            "content": "您先前已選擇 Zoom Workplace 商業版 (每次會議可允許最多 300 名與會者)、Zoom Scheduler 等。您仍要變更為專業版嗎？",
            "confirm": "確認變更",
            "keep_current": "保留目前方案"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} 觀眾",
          "participants": "{0} 與會者",
          "user_range": "{0}-{1} 名使用者",
          "items": "{num} 項"
        },
        "button": {
          "ok": "OK",
          "add": "新增",
          "buy_now": "立即購買",
          "try_for_days": "試用 {0} 天",
          "contact_sales": "聯絡銷售人員",
          "close": "關閉",
          "cancel": "取消",
          "edit": "編輯",
          "got_it": "瞭解"
        },
        "title": {
          "everything_in_and": "{0} 中的所有功能，以及："
        },
        "tag": {
          "new": "全新",
          "free_trial": "免費試用"
        },
        "billing_cycle": {
          "annual": "年度",
          "monthly": "每月",
          "quarterly": "季付",
          "two_years": "兩年",
          "three_years": "三年"
        },
        "errors": {
          "unknown_error_try_again": "處理交易時發生未知錯誤。請稍後重試。"
        },
        "excluding_tax": {
          "vat_tip": "不含增值稅",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "功能有限",
        "pro_plus": {
          "host_meeting_up_to_participants": "主持最多 {0} 名與會者的會議",
          "gb_of_cloud_recording_storage": "{0}GB 雲端錄製儲存空間 (每個授權)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "用於產生內容和翻譯的 AI Companion",
            "features_item2": "可與您的團隊無限分享的文件數量",
            "features_item3": "存取無限版本歷史紀錄",
            "comparison_table_tips": "透過 AI 優先的文件增強協作能力，將會議內容轉換成能夠據以採取行動的文件、維基百科和專案"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks 基本功能",
            "features_item1": "自動偵測會議、電話、聊天和文件中要求的任務",
            "features_item2": "獲得完成任務的協助，例如排程後續追蹤會議和草擬文件",
            "features_item3": "完成任務時輕鬆將任務標示為已完成，以掌握您的進度並專注於後續步驟",
            "features_item4": "跨 Zoom Workplace 平台管理任務，包括 Zoom Docs",
            "features_item1_opc": "發揮 AI Companion 的威力，從您的聊天、電子郵件、文件、白板和會議摘要中識別和建立任務",
            "features_item2_opc": "輕鬆排序、篩選、分組和搜尋，以快速存取和收集任務的背景資訊",
            "learn_more_header": "透過 AI Companion* 掌握行動項目，幫助您在 Zoom Workplace 中完成更多工作。",
            "learn_more_footer": "\*AI Companion 僅可於 Zoom Workplace 專業版、商業版和企業版方案使用。",
            "features_prefix": "讓 AI Companion 協助您：",
            "comparison_table_tips": "AI 優先解決方案可根據 Zoom Workplace 中的對話和會議摘要提供任務建議，幫助您隨時掌握行動項目並按時加以完成。",
            "tasks_label_text": " AI 優先的任務管理"
          },
          "title": "商業版 Plus",
          "contact_us_for_more_pricing": "聯絡我們以瞭解定價資訊及其他內容",
          "contact_sales": "\u806F\u7D61\u92B7\u552E\u4EBA\u54E1",
          "meetings": "\u6703\u8B70",
          "phone": "\u96FB\u8A71",
          "phone_sub_title": "\u7121\u9650\u5236\u901A\u8A71",
          "use_only": "僅供商業版使用",
          "team_chat": {
            "title": "團體聊天",
            "title_desc": "群組聊天和檔案分享"
          },
          "cloud_storage": {
            "title": "\u96F2\u7AEF\u5132\u5B58"
          },
          "mail_calender": {
            "title": "郵件與日曆"
          },
          "beta": "Beta",
          "client_service": {
            "title": "用戶端與服務"
          },
          "up_to_30_hours_per_meeting": "每次會議限時 30 小時",
          "300_attendees": "300 名觀眾",
          "per_meeting": "每次會議",
          "whiteboard": {
            "title": "白板"
          },
          "new": "全新",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "贈品",
          "sso_managed_domains_more": "SSO、託管網域等",
          "scheduler": "排程器",
          "global_select": "Global Select",
          "unlimited_regional": "無限制區域",
          "translated_captions": "已翻譯字幕",
          "workspace_reservation": "工作區預約",
          "auto_translated_captions": "自動和已翻譯字幕",
          "unlimited_editable_boards": "無限可編輯白板",
          "standard_features": "標準功能",
          "advanced_docu_controls": "進階文件控制項",
          "chats_channels_for_collaboration": "協作、檔案分享和更多功能的聊天室及頻道",
          "zoom_phone_is_biz_use_only": "Zoom Phone 僅供商業版使用",
          "unlimited_regional_calling": "\u7121\u9650\u5236\u5340\u57DF\u901A\u8A71",
          "domestic_sms_mms": "\u570B\u5167\u7C21\u8A0A\u548C\u591A\u5A92\u9AD4\u8A0A\u606F",
          "automatic_call_distribution_groups": "\u81EA\u52D5\u901A\u8A71\u5206\u914D (ACD) \u7FA4\u7D44\uFF0C\u5E36\u6709\u901A\u8A71\u4F47\u5217\u529F\u80FD",
          "single_sign_on": "\u55AE\u4E00\u767B\u5165",
          "managed_domains": "\u8A17\u7BA1\u7DB2\u57DF",
          "company_branding": "\u516C\u53F8\u54C1\u724C\u5316",
          "mail_calender_client_services_beta": "Mail 與 Calendar 用戶端和服務測試版",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "無限次數的會議，每次會議限時 30 小時",
          "mail_and_calendar_client_and_services_beta": "Mail 與 Calendar 用戶端和服務測試版",
          "easily_record_edit_share_videos": "輕鬆錄製、編輯和分享短片",
          "unlimited_videos_advanced_features": "無限制的影片和進階功能",
          "create_share_editabel_docu_within_zoom": "在 Zoom 內建立和分享可編輯文件",
          "personal_collaborative_notes_rich_text_editing": "設有 RTF 編輯的個人及協作筆記",
          "effortlessly_share_meeting": "輕鬆分享會議時段，以供會議預約",
          "works_with_zoom_meeting_mail_calender_google_ms": "搭配 Zoom Meetings、Zoom Mail 和 Calendar、Google 及 Microsoft 365 一起使用",
          "up_to_300_attendees": "最多 300 名觀眾",
          "10_gb_of_storage": "10GB 儲存空間",
          "host_meeting_up_to_300_participants": "\u4E3B\u6301\u8207\u6703\u4EBA\u6578\u591A\u9054 300 \u4EBA\u7684\u6703\u8B70",
          "10_gb_of_cloud_recording_storage": "10 GB 雲端儲存錄製空間 (每一個授權)",
          "starting_at_licenses_year": "\u81EA {1} \u500B\u6388\u6B0A\u958B\u59CB\uFF0C\u8D77\u552E\u50F9\u70BA {0}/\u5E74",
          "starting_at_licenses_month": "\u81EA {1} \u500B\u6388\u6B0A\u958B\u59CB\uFF0C\u8D77\u552E\u50F9\u70BA {0}/\u6708",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "快速取得會議摘要，協助撰寫訊息草稿等更多內容",
          "learn_more": "\u77AD\u89E3\u66F4\u591A\u8CC7\u8A0A",
          "essential_apps": "必要的應用程式",
          "increase_team_collaboration": "增強團隊的協作和生產力",
          "free_premium_apps": "1 年內免費使用付費應用程式 (適用條款)",
          "visitor_management": "訪客管理",
          "visitor_management_custom_invites": "自訂邀請",
          "visitor_management_visitor_check": "從資訊站查看",
          "visitor_management_receive_detailed": "在訪客的空間使用量上接收詳細的指標"
        },
        "custom_avatar": {
          "title": "自訂虛擬頭像",
          "label_text": "每月 3 分鐘",
          "basic_feature": "每人一生 1 分鐘",
          "pricing_feature": "每月 3 分鐘",
          "learn_more_subtitle": "透過聲音複製和多語溝通，為自己打造一個栩栩如生的 AI 版本。",
          "features_item1": "每月最多可創造 3 個栩栩如生的數位虛擬人偶，複製您的外表和聲音，以進行簡報和示範",
          "features_item2": "透過 AI Companion，使用您的虛擬人偶提供最多 3 分鐘的講稿",
          "features_item3": "從 18 個事先設計好的虛擬頭像中選擇，快速製作高品質的影片",
          "features_item4": "享受虛擬背景支援",
          "features_item1_opc": "每月最多可創造 3 個栩栩如生的數位虛擬人偶，複製您的外表和聲音，以進行簡報和示範",
          "features_item2_opc": "透過 AI Companion，使用您的虛擬人偶提供最多 3 分鐘的講稿",
          "comparison_table_tips": "自訂虛擬頭像可為您打造栩栩如生的 AI 版本，具有聲音複製和多語溝通功能."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "快速取得會議摘要，協助撰寫訊息草稿等更多內容",
        "learn_more_dialog": {
          "desc": "AI Companion 為您代勞更多工作！撰寫內容、安排會議、協助管理專案，還有更多功能。",
          "tip1": "提前收到議程，讓您主持會議更有效率",
          "tip2": "透過自動化的任務建立與通知，輕鬆掌握專案進度",
          "tip3": "協助整理日曆和管理時間",
          "tip4": "在 Docs、Whiteboard 或 Zoom Workplace 應用程式中，產生符合您品牌風格的書面和視覺內容"
        },
        "top_features": "熱門功能",
        "more_to_come": "即將推出更多令人讚嘆的功能！",
        "discover_more": "透過 AI Companion 發掘更多最佳工作方式！",
        "detail_desc": "AI Companion 包含於 Zoom 使用者帳戶的付費服務，無需額外費用。可能排除特定垂直產業和地理區域。"
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/年/授權",
        "month_licnese": "/月/授權",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/月",
          "per_year": "/年"
        },
        "unit": {
          "license": "{0}/授權",
          "user": "{0}/使用者"
        },
        "learn_more": "瞭解更多",
        "required": "必填",
        "zoom_one_required": "需要 Zoom Workplace",
        "large": {
          "features_tip": "將與會者人數容量提升至高達 1,000 名與會者，藉此拓展您的影響力。",
          "label_title1": "500名觀眾",
          "label_title2": "1000名觀眾"
        },
        "cmr": {
          "features_tip": "從 Zoom 雲端直接儲存、串流播放和下載視訊錄製檔案。",
          "explain_desc": "雲端儲存包含在特定 Zoom One 方案中：專業版 (5 GB)、商業版 (5 GB)、商業加強版 (10 GB) 和企業版 (無限制)",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 小時",
          "option_label2": "≈ 650 小時",
          "option_label3": "≈ 3,500 小時",
          "option_label4": "≈ 17,500 小時",
          "intro_label2": "最多可選擇每個月 5TB 的儲存空間",
          "tooltip_content": "錄製儲存空間會依據啟用影片的與會者數量、會議解析度和分享內容的解析度而有不同。"
        },
        "whiteboard": {
          "plus_title": "白板加強版",
          "title": "Whiteoard",
          "features_tip": "在會議期間和會議之外，在白板上與其他人即時協作。",
          "explain_desc": "包含在 Zoom One 商業版、Zoom One 商業加強版及 Zoom One 企業版中",
          "explain_desc_plus": "包含於 Zoom One 企業版 Plus 和每一份 Zoom Rooms 訂閱中",
          "option_label1": "無限制的白板及 1 GB 雲端儲存",
          "option_label2": "包括無限制的白板和雲端儲存的進階功能",
          "intro_label1": "無限制且可同時編輯的白板",
          "intro_label2": "標準功能和進階文件控制項",
          "intro_label3": "進階白板功能，包括自訂和組織範本及第三方整合功能"
        },
        "translated_captions": {
          "features_tip": "透過您偏好的語言的自動字幕強化全球協作。",
          "intro_label1": "與會者可自行啟用字幕和切換語言。",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "檢視支援的語言"
        },
        "crc": {
          "features_tip": "支援任何基於 SIP/H.323 標準的視訊會議端點，以實現有效的混合式工作。",
          "intro_label1": "與 Polycom、Cisco、Lifesize 在內等許多舊式端點相容",
          "intro_label2": "雲端或內部部署 (虛擬機器) 的會議室連接器"
        },
        "scheduler": {
          "simplify_bookings": "彈性的有空選項加上可自訂的時段，簡化預約流程",
          "host_one_on_one": "主持一對一或小組會議，單一連結方便分享",
          "customize_reminders": "自訂電子郵件/簡訊提醒，避免錯過預約",
          "sync_calendars": "整合 Google、Microsoft 365 和 Zoom，無縫同步行事曆",
          "features_tip": "輕鬆分享辦公時間、面試等會議時段。",
          "intro_label1": "日曆整合",
          "intro_label2": "週期性可用時間",
          "intro_label3": "可擴充的會議",
          "intro_label4": "可自訂的通知",
          "intro_sub_label1": "Google、Microsoft 365 和 Zoom ",
          "intro_sub_label2": "分享可預約的時段 ",
          "intro_sub_label3": "一名或多名觀眾的單一會議",
          "intro_sub_label4": "自動傳送電子郵件或 SMS 提醒和確認"
        },
        "zoom_clips_plus": {
          "features_tip": "錄製、編輯和分享高品質的短片訊息。",
          "intro_label1": "建立無限制的影片，沒有時間限制",
          "intro_label2": "一起或個別捕捉您的畫面和影片",
          "intro_label3": "視需要修剪影片並分享連結",
          "intro_label4": "取得音訊逐字稿和統計資料等進階功能",
          "explain_desc": "Workplace 專業版、商業版和企業版訂閱包含 Clips 加強版。您可以在定價頁面的比較區探索每個方案的不同功能。"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "具備強大註冊和網路功能的進階直播平台。虛擬和混合式體驗的理想選擇。",
          "tooltip_content": "根據所選的容量主持無限制網路研討會或活動",
          "intro_title": "一切盡在會議中",
          "intro_label1": "以多段會程活動提高觀眾參與度",
          "intro_label2": "以量身打造的票務和行動應用程式輕鬆主持活動",
          "intro_label3": "利用 Expo 樓層和贊助商區域提高活動營收",
          "intro_label4": "透過可自訂的設定檔促進觀眾進行互動",
          "intro_label5": "透過活動大廳中的隨選觀看擴大觸及範圍",
          "intro_label6": "使用精心策劃的活動範本加快活動設定",
          "events_feature_item1_20240827": "透過多場專題會議組織多日虛擬活",
          "events_feature_item2_20240827": "透過觀眾設定檔和大廳聊天促進人際交流",
          "events_feature_item3_20240827": "透過大廳會議串流媒體指導觀眾",
          "events_feature_item4_20240827": "利用展示樓層和贊助提高活動營收",
          "events_feature_item5_20240827": "透過會議後問卷調查改善未來的活動",
          "events_feature_item6_20240827": "使用精心策劃的活動範本加快活動設定",
          "attendees_start_at": "{0} 名觀眾起價為",
          "explain_desc": "深入探索 Zoom Events",
          "contact_account_owner": "若想購買 Events，請<a href=\"/account\" target=\"_blank\">聯絡您的帳戶擁有者</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "利用直播品牌化、多主持人協作和直播管理等功能簡化互動式單場會議直播。",
          "tooltip_content": "根據所選的容量主持無限制網路研討會或活動",
          "intro_title": "包括 Zoom Webinars",
          "intro_label1": "自訂活動登陸頁面以實現有效的品牌化",
          "intro_label2": "利用品牌化電子郵件推廣活動",
          "intro_label3": "以互動式儀表板衡量績效",
          "intro_label4": "與共同主持人和共同編輯者流暢協作",
          "intro_label5": "專業活動工具：預錄後直播",
          "sessions_feature_item1_20240827": "利用自訂場景和品牌化提升網路研討會",
          "sessions_feature_item2_20240827": "使用 AI Companion 簡化活動規劃，以產生訊息和影像",
          "sessions_feature_item3_20240827": "在品牌內容中心推廣過去和未來的活動",
          "sessions_feature_item4_20240827": "透過後台、預錄後直播和 RTMP 舉辦專業活動",
          "sessions_feature_item5_20240827": "利用跨活動見解改善未來的網路研討會",
          "explain_desc": "深入探索 Zoom Sessions",
          "contact_account_owner": "若想購買 Sessions，請<a href=\"/account\" target=\"_blank\">聯絡您的帳戶擁有者</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "視訊網路研討會",
          "features_tip": "透過方便易用的網路研討會平台輕鬆播放訊息。",
          "tooltip_content": "根據所選的容量主持無限制網路研討會或活動",
          "intro_label1": "透過高品質視訊網路廣播與觀眾互動",
          "intro_label2": "透過問答、投票和回應提高參與度",
          "intro_label3": "使用活動後報告改善網路研討會策略",
          "intro_label4": "支援最多 100,000 名觀眾和 100 名嘉賓",
          "monthly_subscription": "每月訂閱",
          "annual_subscription": "年度訂閱",
          "one_million": "100 萬",
          "single_use": "一次性",
          "one_month": "單月",
          "event_attendee": "活動/會議觀眾：",
          "event_attendee_desc": "任何加入而未在中心成為授權主持人的人。擁有特殊角色的人也被視為觀眾，並且可以 (在已啟用的情況下) 使用音訊、視訊和畫面分享參與活動。",
          "webinar_attendee": "Webinars 觀眾：",
          "webinar_attendee_desc": "任何加入但非主持人或嘉賓的人。這些人僅限觀看，並由主持人控制，主持人可透過問與答和聊天為這些人解除靜音並啟用互動。",
          "pay_per_attendee": "按觀眾人數支付",
          "attendees": "觀眾"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "藉助採用 AI 技術的協作平台，重新塑造團隊工作方式。",
          "label_title1": "Workplace 專業版",
          "label_title2": "Workplace 專業加強版",
          "label_title3": "Workplace 商業版",
          "label_title4": "Workplace 商業加強版",
          "intro_label1": "可以無限制主持會議，每次會議最長 30 小時，與會者上限 100 名",
          "intro_label2": "最多可使用 3 個具有標準功能的可同時編輯白板",
          "intro_label3": "使用 Clips 加強版錄製、編輯和分享高品質的短片訊息",
          "intro_label4": "使用 Zoom AI Companion，以更高效率完成工作",
          "intro_label5": "Zoom Phone 美國和加拿大無限制 (BYOC、PBX 和第三方 PBX 除外)",
          "intro_label6": "可以無限制主持會議，每次會議最長 30 小時，與會者上限 300 名",
          "intro_label7": "使用 Zoom Scheduler 分享辦公時間、面試等會議時段",
          "intro_label8": "Zoom Phone 美國和加拿大無限制",
          "intro_label8_UK": "Zoom Phone 英國和愛爾蘭無限制",
          "intro_label8_AU": "Zoom Phone 澳洲和紐西蘭無限制",
          "intro_label8_JP": "Zoom Phone 日本無限制",
          "intro_label9": "訪客管理",
          "intro_label10": "其他功能",
          "intro_label11": "即時聊天支援",
          "intro_title1": "專業版中的所有功能，以及：",
          "intro_title2": "商業版中的所有功能，以及：",
          "intro_label_tip1": "Zoom Phone 專業加強版不包含 BYOC、第三方 PBX 和 VDI 功能。如需更多資訊，請參閱 Zoom Phone 定價頁面。",
          "intro_label_tip2": "查看時，您可以選取美國和加拿大、澳洲和紐西蘭、英國和愛爾蘭或日本的無限制區域通話。",
          "intro_label_tip3": "額外功能包括 10 GB 雲端儲存、已翻譯字幕和工作區預約。",
          "intro_label_tip4": "Zoom Phone 專業加強版不包含 BYOC、第三方 PBX 和 VDI 功能。如需更多資訊，請參閱 Zoom Phone 定價頁面。"
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "為通話中心團隊提供強化的通話佇列分析和歷史見解。",
          "intro_label1": "展開式聯絡人視窗，提升通話處理效率",
          "intro_label2": "自動總機和通話佇列電話號碼"
        },
        "international_calling": {
          "title": "國際通話",
          "features_tip": "撥打至超過 15 個國家和地區的無限制國際通話。",
          "intro_label1": "可使用任何無限制通話計畫購買",
          "intro_label2": "查看我們支援無限制國際通話的國家和地區列表。",
          "intro_labe2_tooltip": "美國、加拿大、英國、愛爾蘭、澳洲、紐西蘭、奧地利、丹麥、法國、德國、義大利、葡萄牙、西班牙、瑞典、比利時、荷蘭、瑞士、波多黎各、日本。",
          "intro_label2_view_list": "檢視清單"
        },
        "workspace_reservation": {
          "title": "工作區預約",
          "intro_title": "使用 Zoom 整合裝置，輕鬆預約彈性工作區或預訂飯店房間，提前或現場預約都沒問題。",
          "intro_label1": "透過 Zoom Workplace 應用程式、桌面或瀏覽器，存取工作區和飯店預訂",
          "intro_label2": "在 AI 的協助下，接收個人化的辦公桌建議",
          "intro_label3": "直接從 Google 日曆或 Outlook 預約工作區，兩者皆具備提醒和報到警示功能",
          "intro_label4": "使用路線指引功能前往預約的工作區"
        },
        "visitor_management": {
          "title": "訪客管理",
          "intro_title": "利用自訂邀請、簡單方便的 Kiosk 報到、報告和指標，簡化訪客報到程序。",
          "intro_label1": "在 Zoom 入口網站管理邀請、訪客位置和造訪歷史記錄",
          "intro_label2": "建立、追蹤、重新傳送和刪除邀請，同時接收訪客抵達通知",
          "intro_label3": "透過 Kiosk 填寫表格、獲取路線指示和報到，提供順暢的訪客體驗",
          "intro_label4": "在熟悉的 Zoom 入口網站中存取所有功能，實現輕鬆管理"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "大型會議",
          "description1": "增加會議容量，支援最多 1,000 名直播互動與會者",
          "description2": "所有與會者皆可分享其音訊、視訊和畫面"
        },
        "cloud_storage": {
          "title": "雲端儲存",
          "description2": "可選擇 MP4 或 M4A 檔案格式"
        },
        "translated_captions": {
          "title": "字幕翻譯",
          "description1": "使用自動化多語言字幕增強會議效果，允許與會者啟用並切換到支援的語言",
          "description2": "適用於 Zoom Meetings 和 Webinars"
        },
        "tollfree": {
          "title": "語音會議",
          "subcontent": "從世界各地使用電話號碼撥號加入會議",
          "description1": "透過撥出、全球免付費號碼和付費國家/地區的本地撥號來擴展您的通話選項",
          "description2": "與會者可以從任何裝置撥入，無須任何費用",
          "description3": "輕鬆選取一或多個可免付費撥入電話的國家/地區"
        },
        "rc": {
          "title": "會議室連接器"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "阿根廷",
        "Australia": "澳洲",
        "Austria": "奧地利",
        "Belgium": "比利時",
        "Brazil": "巴西",
        "Bulgaria": "保加利亞",
        "Canada": "加拿大",
        "Chile": "智利",
        "China": "中國",
        "Colombia": "哥倫比亞",
        "Costa_Rica": "哥斯大黎加",
        "Croatia": "克羅埃西亞",
        "Cyprus": "塞浦路斯",
        "Czech_Republic": "捷克共和國",
        "Denmark": "丹麥",
        "Ecuador": "厄瓜多爾",
        "Estonia": "愛沙尼亞",
        "Finland": "芬蘭",
        "France": "法國",
        "Germany": "德國",
        "Greece": "希臘",
        "Hong_Kong_SAR": "香港",
        "Hungary": "匈牙利",
        "Ireland": "愛爾蘭",
        "Israel": "以色列",
        "Italy": "義大利",
        "Japan": "日本",
        "Latvia": "拉脫維亞",
        "Lithuania": "立陶宛",
        "Luxembourg": "盧森堡",
        "Mexico": "墨西哥",
        "Netherlands": "荷蘭",
        "New_Zealand": "紐西蘭",
        "Norway": "挪威",
        "Panama": "巴拿馬",
        "Peru": "祕魯",
        "Poland": "波蘭",
        "Portugal": "葡萄牙",
        "Puerto_Rico": "波多黎各",
        "Romania": "羅馬尼亞",
        "Singapore": "新加坡",
        "Slovakia": "斯洛伐克",
        "Slovenia": "斯洛維尼亞",
        "South_Africa": "南非",
        "Spain": "西班牙",
        "Sweden": "瑞典",
        "Switzerland": "瑞士",
        "UK": "英國",
        "United_Kingdom": "英國",
        "US": "美國",
        "United_States": "美國",
        "title": "電話號碼要求",
        "subtitle": "請選取您要啟用全球精選方案電話號碼的所在國家/地區。",
        "selector_tip": "選取國家",
        "local_and_toll_free": "當地號碼與免付費號碼適用於 {0}",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "全球精選方案每份授權包含所選國家境內一組電話號碼及無限量 國內通話方案。",
        "avail_title": "適用國家/地區"
      },
      "tax_exempt_ecm": {
        "title": "免稅狀態",
        "status_exempt": "免稅",
        "status_exempt_question": "有免稅資格嗎？",
        "verify_now": "立即驗證",
        "can_after_checkout": "作為選項，此步驟可以在結帳後完成。",
        "status": {
          "exempt": "免稅",
          "pending": "待處理",
          "pendingTooltip": "您的免稅狀態目前尚在審核。下訂單時可能會向您收取稅金。若您的免稅申請獲得核准，我們會將所有應退稅款/費用存入您的帳戶。",
          "nonexempt": "非免稅",
          "rejected": "未通過",
          "rejectedTooltip": "提交的文件已被確定不符合您的司法管轄區要求。",
          "approved": "已核准",
          "default": "預設"
        },
        "confirm_close": {
          "new_desc": "若放棄驗證，您可能需要支付適用的稅金/費用。購買後，您仍可以在「帳單管理」區段提交免稅文件供 Zoom 審查和核准。驗證有效後，將會退還任何已收取的稅款。",
          "desc": "您確定要放棄免稅驗證並繼續納稅嗎？",
          "title": "您確定嗎？",
          "new_title": "要放棄免稅驗證嗎？",
          "yes": "是的，放棄",
          "no": "否，繼續",
          "abandon": "放棄驗證",
          "go_back": "返回"
        },
        "confirm_to_add": {
          "title": "確認新的預設免稅",
          "message": "若新增免稅項目，該免稅項目將在核准或遭拒後自動設定為預設值。您只能有一個預設免稅項目，將適用於未來的購買。若您的預設免稅項目與您的「銷售至」國家/地區不相符，您的稅額可能會受到影響。",
          "yes": "新增免稅項目"
        },
        "confirm_set_default": {
          "title": "地址與免稅項目不相符",
          "message": "您的「銷售至聯絡人」地址與您選擇的免稅州/地區不符。請更新您的「銷售至聯絡人」地址以符合您的免稅地區位置，否則您的購買可能無法免稅。",
          "yes": "仍要設定為預設值",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "州/地區",
          "exemption_type": "免稅類型",
          "signed_date": "簽署日期",
          "status": "狀態",
          "add_exemption": "新增免稅項目",
          "view": "檢視",
          "set_as_default": "設定為預設值"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "您的 {planName} 方案將於 {date} 國際標準時間上午 12:00 取消。如果您想在取消日期後繼續主持，請重新啟用您的方案。",
        "pairPreDescTip": "您的 {planName1} 方案和 {planName2} 方案將於 {date} 國際標準時間上午 12:00 取消。如果您想在取消日期後繼續主持，請重新啟用您的方案。",
        "pairDiffDatePreDescTip": "您的 {planName1} 方案和 {planName2} 方案將分別於 {date1} 國際標準時間上午 12:00 和 {date2} 國際標準時間上午 12:00 取消。如果您想在取消日期後繼續主持，請重新啟用您的方案。",
        "title": "重新啟用您的方案以繼續",
        "titles": "重新啟用您的方案以繼續",
        "plan": "計畫",
        "licenses": "授權",
        "billingCycle": "計費週期",
        "effective_date": "生效日期",
        "invoice_amount": "發票金額",
        "singleDescTip": "重新啟用後，您同意您的週期性方案將於 {date} 自動續訂，且每次續訂時都將依照您保存的付款方式收取款項。若要避免未來產生費用，請在您的續訂日期至少一天前<a target=\"_blank\" href=\"https://support.zoom.com/hc/zt/article?id=zm_kb&sysparm_article=KB0066687\">取消</a>。",
        "pairDescTip": "重新啟用，即表示您同意您的週期性方案將於 {date} 自動續訂，且每次續訂時都將依照您保存的付款方式收取款項。若要避免未來產生費用，請在您的續訂日期至少一天前<a target=\"_blank\" href=\"https://support.zoom.com/hc/zt/article?id=zm_kb&sysparm_article=KB0066687\">取消</a>。",
        "pairDiffDateDescTip": "重新啟用，即表示您同意您的週期性方案將於 {date1} 和 {date2} 自動續訂，且每次續訂時都將依照您保存的付款方式收取款項。若要避免未來產生費用，請在您的續訂日期至少一天前<a target=\"_blank\" href=\"https://support.zoom.com/hc/zt/article?id=zm_kb&sysparm_article=KB0066687\">取消</a>。",
        "totalLabel": "總計",
        "totalContent": "{money} 加上適用稅金",
        "taxDesc": "不含 VAT、商品及服務稅或類似稅項",
        "reactivateBtn": "繼續並重新啟用",
        "switchTitle": "更新您的方案以繼續",
        "successSingleTip": "您的 {planName} 方案已重新啟用",
        "successPairTip": "您的 {planName1} 和 {planName2} 方案已重新啟用",
        "switchTip": "您的單月 Zoom Webinars 方案於 {date} 到期。如果您想在此日期後繼續主持網路研討會，您必須轉換為訂閱身分。",
        "switchBtn": "切換至訂閱"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace專業版"
      },
      "biz": {
        "title": "Zoom Workplace商業版"
      },
      "proPlus": {
        "title": "Zoom Workplace 專業加強版"
      },
      "bizPlus": {
        "title": "Zoom Workplace 商業版 Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "\u4E0B\u8F09\u898F\u683C\u8868"
      },
      "one": {
        "new": "全新"
      }
    },
    "webinarSetupInWebPortal": "入口網站中的網路研討會設定",
    "concurrentEvents": "同步活動",
    "coucurrentEventsToolTip": "<span><b>訂閱</b>方案一次支援一個直播活動",
    "overages": "超額費用",
    "eventsPlatformHubs": "活動平台中心",
    "eventsHubToolTip": "Zoom Events <b>中心</b>提供便利的活動組織",
    "1HubPerLicense": "每個授權 1 個中心",
    "1000Hubs": "1,000 個中心",
    "eventsPlatformHosts_500AttendeesOrMore": "活動平台主持人 (500 名以上觀眾)",
    "eventsHost500": "<span>Zoom Events <b>中心主持人</b>可以建立",
    "5HubHosts": "5 個中心主持人",
    "100HubHosts": "100 個中心主持人",
    "eventsPlatformHosts_100Attendees": "活動平台主持人 (100 名觀眾)",
    "eventsHost100": "<span>Zoom Events <b>中心主持人</b>可以建立",
    "2HubHosts": "2 個中心主持人",
    "howAreTheyDifferent": "有何不同？",
    "allPlansRequireAZoomOneLicense": "* 所有方案皆需要 Zoom Workplace 授權",
    "subscription": "訂閱",
    "subscriptionToolTip": "<span><b>訂閱</b>可讓您根據所選的容量主持無限制的活動數量。</span>",
    "payPerAttendee": "按觀眾人數支付",
    "ppaToolTips": "<span><b>依觀眾付費</b>授權決定在購買後 12 個月內可參加您帳戶舉辦的所有活動的觀眾總人數。</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "\u6295\u7968",
    "meetings.fullPlanItem2": "\u6388\u6B0A\u6578",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom會議",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "透過任何裝置簡化視訊會議和傳訊",
    "meetings.fullPlanItem5": "\u6703\u8B70\u6301\u7E8C\u6642\u9593",
    "meetings.fullPlanItem5Tip": "\u6BCF\u500B\u7FA4\u7D44\u6703\u8B70\uFF08\u542B 3 \u500B\u6216\u66F4\u591A\u8207\u6703\u8005\uFF09\u5141\u8A31\u7684\u6700\u9577\u6301\u7E8C\u6642\u9593\u3002",
    "meetings.fullPlanItem5_basic": "40 \u5206\u9418",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 \u5C0F\u6642",
    "meetings.fullPlanItem5_biz": "30 \u5C0F\u6642",
    "meetings.fullPlanItem5_ent": "30 \u5C0F\u6642",
    "meetings.fullPlanItem1": "\u8207\u6703\u8005\u5BB9\u91CF",
    "meetings.fullPlanItem1Tip": "\u8207\u6703\u8005\u662F\u6703\u8B70\u7684\u53D7\u9080\u4EBA\uFF0C\u8A72\u6703\u8B70\u662F\u7531\u5177\u6709\u6703\u8B70\u6388\u6B0A\u7684\u4EBA\u8CA0\u8CAC\u6392\u7A0B\u3002\u8207\u6703\u8005\u53EF\u4EE5\u5F9E\u96FB\u8A71\u3001\u684C\u4E0A\u578B\u96FB\u8166\u3001\u884C\u52D5\u548C\u5E73\u677F\u88DD\u7F6E\uFF0C\u514D\u8CBB\u52A0\u5165\u60A8\u7684\u6703\u8B70\u3002\u8207\u6703\u8005\u4E0D\u9700\u8981 Zoom \u5E33\u6236\u5373\u53EF\u53C3\u52A0\u6703\u8B70\u3002\u6BCF\u500B\u8A08\u756B\u90FD\u6709\u8207\u6703\u8005\u4EBA\u6578\u9650\u5236\uFF0C\u4F46\u4F7F\u7528\u8005\u53EF\u900F\u904E\u8CFC\u8CB7\u9644\u52A0\u8A08\u756B\u4F86\u589E\u52A0\u4ED8\u8CBB\u8A08\u756B\u7684\u4EBA\u6578\u9650\u5236\u3002",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*企業版 Plus 為 1,000 名</span>",
    "meetings.fullPlanItem7": "\u9304\u88FD",
    "meetings.fullPlanItem7Tip": "Zoom \u672C\u5730\u9304\u88FD\u5C07\u6703\u8B70\u5132\u5B58\u70BA MP4 (\u8996\u8A0A)\u3001M4A (\u97F3\u8A0A) \u548C txt (\u804A\u5929)\u683C\u5F0F\u3002<br>Zoom \u96F2\u7AEF\u9304\u88FD\u5C07\u6703\u8B70\u5132\u5B58\u5728 Zoom \u96F2\u7AEF\uFF0C\u53EF\u5F9E\u700F\u89BD\u5668\u4E0B\u8F09\u548C/\u6216\u4E32\u6D41\u6A94\u6848\u3002",
    "meetings.fullPlanItem7_basic": "\u672C\u5730",
    "meetings.fullPlanItem7_pro": "\u672C\u5730\u548C 5 GB \u96F2\u7AEF\uFF08\u6BCF\u500B\u6388\u6B0A\uFF09",
    "meetings.fullPlanItem7_biz": "\u672C\u5730\u548C 10 GB \u96F2\u7AEF\uFF08\u6BCF\u500B\u6388\u6B0A\uFF09",
    "meetings.fullPlanItem7_ent": "\u672C\u5730\u548C\u7121\u9650\u5236\u96F2\u7AEF",
    "one.messaging": "傳訊",
    "meetings.fullPlanItem16Tip": "\u60A8\u53EF\u4EE5\u900F\u904E Chat \u8F15\u9B06\u50B3\u9001\u7FA4\u7D44\u6D88\u606F\u3001\u6A94\u6848\u3001\u756B\u9762\u64F7\u53D6\u3001\u7A0B\u5F0F\u78BC\u7247\u6BB5\u3001\u8A9E\u97F3\u8A0A\u606F\u548C\u5F71\u50CF\u3002 \u6587\u5B57\u53EF\u683C\u5F0F\u5316\uFF0C\u4E14\u4F7F\u7528\u8005\u53EF\u5206\u4EAB GIF \u548C\u8868\u60C5\u8CBC\u5716\u3002 \u4E0A\u7DDA\u72C0\u614B\u53EF\u986F\u793A\u804A\u5929\u8207\u6703\u8005\u7576\u524D\u4F7F\u7528\u7684\u662F\u96FB\u8166\u3001\u884C\u52D5\u88DD\u7F6E\uFF0C\u9084\u662F\u70BA\u5FD9\u788C\u72C0\u614B\u3002",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "\u7121\u9650\u5236",
    "meetings.fullPlanItem_EssentialApp": "必要的應用程式",
    "common.learnMore": "\u77AD\u89E3\u66F4\u591A\u8CC7\u8A0A",
    "meetings.fullPlanItem_EssentialAppText": "1 年內免費使用付費應用程式 (適用條款)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom 應用程式中的 Zoom Mail 與 Calendar 用戶端",
    "mailService": "郵件服務",
    "emailServiceWithFullTimeEndToEnd": "電子郵件服務具有全程端對端加密以加強保護隱私權",
    "customMailDomain": "自訂郵件網域",
    "customMailDomainWithMailService": "自訂郵件網域和郵件服務",
    "calendarClient": "Calendar 用戶端",
    "scheduleAndJoinMeetings": "在 Zoom 應用程式中安排和加入會議",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar 服務",
    "meetingSchedulingAndAppointment": "會議排程和預約",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "輕鬆建立、編輯和分享短片。 儲存的短片容易查詢，提高參與度。",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes 提供強大的個人或協作文件編輯器，設有豐富格式選項，不論是會議中或會議外都能使用。",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "已翻譯字幕",
    "workspaceReservation": "工作區預約",
    "accessAcrossAnyDevice": "跨裝置存取",
    "meetings.fullPlanItem4": "\u7121\u9650\u5236\u7684\u6703\u8B70",
    "meetings.fullPlanItem9": "\u96FB\u8A71\u64A5\u865F\u52A0\u5165",
    "meetings.fullPlanItem9Tip": "\u900F\u904E\u96FB\u8A71\u6703\u8B70/\u8A9E\u97F3\u6703\u8B70\uFF08\u4F7F\u7528\u50B3\u7D71\u96FB\u8A71\uFF09\u65B9\u5F0F\u52A0\u5165Zoom\u6703\u8B70\u3002\u800C\u4F7F\u7528\u8005\u9700\u6839\u64DA\u6240\u7528\u7684\u96FB\u8A71\u65B9\u6848\u652F\u4ED8\u76F8\u61C9\u8CBB\u7528\u3002\u8ACB\u8A66\u7528\u6211\u5011\u7684\u8A9E\u97F3\u6703\u8B70\u9644\u52A0\u65B9\u6848\uFF0C\u7372\u5F97\u53D7\u8A71\u65B9\u4ED8\u8CBB\u64A5\u5165\u865F\u78BC\u3002",
    "meetings.fullPlanItem9_pro": "\u4ED8\u8CBB",
    "meetings.fullPlanItem9_biz": "\u4ED8\u8CBB",
    "meetings.fullPlanItem9_ent": "\u4ED8\u8CBB",
    "meetings.fullPlanItem11": "\u756B\u9762\u5206\u4EAB",
    "meetings.fullPlanItem11Tip": "\u684C\u9762\u548C\u61C9\u7528\u7A0B\u5F0F\u5206\u4EAB\u3002\u5DF2\u6388\u6B0A\u6703\u8B70\u4F7F\u7528\u8005\u5728\u4ED6\u5011\u6240\u4E3B\u6301\u7684\u6703\u8B70\u671F\u9593\u5167\uFF0C\u53EF\u9078\u64C7\u5141\u8A31\u591A\u4F4D\u8207\u6703\u8005\u540C\u6642\u5206\u4EAB\u756B\u9762\u3002",
    "meetings.fullPlanItem12": "\u5206\u7D44\u8A0E\u8AD6",
    "meetings.fullPlanItem12Tip": "\u8996\u8A0A\u5206\u7D44\u8A0E\u8AD6\u5141\u8A31\u60A8\u5C07 Zoom \u6703\u8B70\u5206\u6210\u6700\u591A 50 \u500B\u55AE\u7368\u7684\u5DE5\u4F5C\u968E\u6BB5\uFF0C\u9032\u884C\u8A0E\u8AD6\u3001\u5C08\u6848\u548C\u5176\u4ED6\u66F4\u591A\u529F\u80FD\u3002",
    "meetings.fullPlanItem14": "\u865B\u64EC\u80CC\u666F",
    "meetings.fullPlanItem15": "\u500B\u4EBA\u6703\u8B70 ID",
    "meetings.fullPlanItem15Tip": "\u5EFA\u7ACB\u60A8\u81EA\u5DF2\u7684\u6C38\u4E45\u7DDA\u4E0A\u6703\u8B70\u5BA4\u3002\u60A8\u53EF\u96A8\u6642\u958B\u59CB\u6B64\u6703\u8B70\uFF0C\u6216\u70BA\u5C07\u4F86\u4F7F\u7528\u7684\u6703\u8B70\u6392\u7A0B\u3002",
    "meetings.fullPlanItem17": "\u4E3B\u6301\u4EBA\u63A7\u5236\u9805",
    "meetings.fullPlanItem18": "\u5728\u5206\u4EAB\u756B\u9762\u4E0A\u5171\u540C\u8A3B\u8A18",
    "meetings.fullPlanItem19": "\u9060\u7AEF\u9375\u76E4\u548C\u6ED1\u9F20\u63A7\u5236",
    "meetings.fullPlanItem21": "\u591A\u65B9\u5206\u4EAB",
    "meetings.fullPlanItem29": "\u7B49\u5019\u5BA4",
    "meetings.fullPlanItem29Tip": "\u7B49\u5019\u5BA4\u529F\u80FD\u53EF\u4F9B\u4E3B\u6301\u4EBA\u63A7\u5236\u8207\u6703\u8005\u4F55\u6642\u52A0\u5165\u6703\u8B70\u3002 \u4F5C\u70BA\u6703\u8B70\u4E3B\u6301\u4EBA\uFF0C\u60A8\u53EF\u4EE5\u9010\u4E00\u5141\u8A31\u55AE\u500B\u8207\u6703\u8005\u6216\u4E00\u6B21\u6027\u5141\u8A31\u6240\u6709\u8207\u6703\u8005\u52A0\u5165\u6703\u8B70\u3002 \u60A8\u53EF\u5728\u8A2D\u5B9A\u4E2D\u9078\u64C7\u8981\u5C07\u8AB0\u653E\u5165\u7B49\u5019\u5BA4\uFF0C\u6216\u5141\u8A31\u8AB0\u81EA\u52D5\u52A0\u5165\u6703\u8B70\u3002 \u6240\u6709\u5E33\u6236\u7686\u6709\u7B49\u5019\u5BA4\u529F\u80FD\u3002 \u4E3B\u6301\u4EBA\u53EF\u5411\u7B49\u5019\u5BA4\u767C\u9001\u6D88\u606F\u3002 \u5982\u679C\u60A8\u5C6C\u65BC\u4ED8\u8CBB\u8A08\u756B\uFF0C\u5247\u53EF\u81EA\u8A02\u7B49\u5019\u5BA4\u3002",
    "meetings.fullPlanItem41": "Zoom for Home \u88DD\u7F6E\u5167\u5EFA",
    "meetings.fullPlanItem61": "\u91D8\u9078\u591A\u4EBA",
    "meetings.fullPlanItem61Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u4EE5\u6388\u6B0A 9 \u4EBA\u91D8\u9078\u8996\u8A0A\u7684\u529F\u80FD\uFF0C\u5141\u8A31\u4ED6\u5011\u5EFA\u7ACB\u81EA\u8A02\u6AA2\u8996\u756B\u9762\u3002 \u56E0\u6B64\uFF0C\u7121\u8AD6\u767C\u8A00\u8005\u662F\u8AB0\uFF0C\u5DF2\u91D8\u9078\u7684\u8996\u8A0A\u90FD\u4FDD\u6301\u53EF\u898B\u3002",
    "meetings.fullPlanItem62": "\u805A\u7126\u591A\u4EBA",
    "meetings.fullPlanItem62Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u4EE5\u805A\u7126 9 \u4F4D\u89C0\u773E\u7684\u8996\u8A0A\uFF0C\u56E0\u6B64\uFF0C\u7121\u8AD6\u767C\u8A00\u8005\u662F\u8AB0\uFF0C\u5168\u9AD4\u8207\u6703\u8005\u90FD\u6703\u770B\u898B\u5DF2\u805A\u7126\u4EBA\u58EB\u7684\u8996\u8A0A\u3002",
    "meetings.fullPlanNewItem1": "\u6FFE\u93E1",
    "meetings.fullPlanNewItem1Tip": "\u4F7F\u7528\u8DA3\u5473\u5341\u8DB3\u7684\u5F69\u8272\u6FFE\u93E1\u6216\u88DD\u98FE\u6027\u7684\u52D5\u7269\u8CBC\u5716\uFF0C\u70BA\u6B61\u6A02\u6642\u523B\u3001\u6D3E\u5C0D\u7B49\u5834\u5408\u589E\u6DFB\u66F4\u591A\u6A02\u8DA3\u3002",
    "meetings.fullPlanNewItem2": "\u6295\u7968",
    "meetings.fullPlanNewItem3": "\u806F\u5E2D\u4E3B\u6301\u4EBA\u8207\u5099\u9078\u4E3B\u6301\u4EBA",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/zh-tw/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">\u6DF1\u5165\u77AD\u89E3</a>\u6211\u5011\u7684\u6703\u8B70\u806F\u5E2D\u4E3B\u6301\u4EBA\u63A7\u5236\u9805\u3002",
    "meetings.fullPlanItem24": "\u6307\u6D3E\u6703\u8B70\u6392\u7A0B\u8005",
    "meetings.fullPlanItem24Tip": "\u5141\u8A31\u60A8\u6307\u6D3E\u67D0\u4EBA\u70BA\u60A8\u8A2D\u5B9A\u60A8\u7684\u6703\u8B70\u3002\u88AB\u6307\u6D3E\u8005\u5FC5\u9808\u64C1\u6709\u5C08\u696D\u7248\u8A08\u756B\u3002",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "\u5141\u8A31\u5E33\u6236\u64C1\u6709\u8005\u3001\u7BA1\u7406\u54E1\u548C\u60A8\u7684\u958B\u767C\u4EBA\u54E1\u5B89\u5168\u5730\u5B58\u53D6 Zoom REST API\u3002\u6839\u64DA\u5E33\u6236\u985E\u578B (\u5C08\u696D\u7248\u3001\u5546\u696D\u7248\u3001\u4F01\u696D\u7248\u7B49\u7B49) \u548C API \u8ACB\u6C42\u985E\u578B (\u8F15\u578B\u3001\u4E2D\u578B\u3001\u91CD\u578B\u7B49\u7B49)\uFF0C\u70BA\u5E33\u6236\u5C64\u7D1A\u5957\u7528 API \u901F\u7387\u9650\u5236\u3002\u67D0\u4E9B API \u50C5\u9650\u7279\u5B9A\u5E33\u6236\u985E\u578B\u5B58\u53D6\u3002\u5982\u9700\u5B8C\u6574\u7684\u8A73\u7D30\u8CC7\u8A0A\uFF0C\u8ACB\u4F7F\u7528 API \u901F\u7387\u9650\u5236\u548CAPI \u53C3\u8003\u6587\u4EF6\u3002",
    "meetings.fullPlanItem25_pro": "\u5C08\u696D\u7248 REST API \u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem25_biz": "REST API \u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem26": "Skype for Business (Lync) \u4E92\u901A\u6027",
    "meetings.fullPlanItem26Tip": "\u5141\u8A31 Lync 2010\u30012013 \u4F7F\u7528\u8005\u548C Skype for Business \u4F7F\u7528\u8005\u81EA Lync \u806F\u7D61\u4EBA\u8ACB\u55AE\u555F\u52D5 Zoom \u6703\u8B70\u3002",
    "meetings.fullPlanItem27": "\u76F4\u64AD",
    "meetings.fullPlanItem27Tip": "\u53EF\u5C0D Facebook\u3001Youtube \u6216\u7B2C\u4E09\u65B9\u670D\u52D9\u9032\u884C\u76F4\u64AD\u3002",
    "meetings.fullPlanItem28": "\u5831\u544A",
    "meetings.fullPlanItem28Tip": "\u5132\u5B58\u767D\u677F\u5DE5\u4F5C\u968E\u6BB5",
    "meetings.fullPlanItem30": "\u4F7F\u7528\u8005\u7BA1\u7406",
    "meetings.fullPlanItem30Tip": "\u64C1\u6709\u8005\u548C\u7BA1\u7406\u54E1\u53EF\u65B0\u589E\u3001\u522A\u9664\u548C\u6307\u6D3E\u89D2\u8272\u53CA\u9644\u52A0\u529F\u80FD\u3002",
    "one.autoCaptions": "自動字幕",
    "meetings.fullPlanItem31": "\u7BA1\u7406\u54E1\u5165\u53E3\u7DB2\u7AD9",
    "meetings.fullPlanItem31Tip": "\u5229\u7528Zoom\u7BA1\u7406\u54E1\u5165\u53E3\u7DB2\u7AD9\uFF0C\u4EE5\u4E00\u500B\u5E33\u6236\u7BA1\u7406\u60A8\u516C\u53F8\u6240\u6709\u7684\u4F7F\u7528\u8005\uFF0C\u5305\u62EC\u7C21\u5316\u8A08\u8CBB\u6D41\u7A0B\u3001\u9032\u968E\u4F7F\u7528\u8005\u7BA1\u7406\u8A2D\u5B9A\u548C\u5B8C\u6574\u4F7F\u7528\u8005\u8CC7\u8A0A\u3002",
    "meetings.fullPlanItem32": "LTI \u6574\u5408",
    "meetings.fullPlanItem32Tip": "\u8F15\u9B06\u70BA\u4EFB\u4F55\u8AB2\u7A0B\u6D3B\u52D5\u65B0\u589E\u6703\u8B70\uFF0C\u4E26\u4F7F\u7528\u60A8\u7684\u5B78\u7FD2\u7BA1\u7406\u7CFB\u7D71\u9080\u8ACB\u9069\u5408\u7684\u5B78\u751F\uFF08\u53EF\u642D\u914D Moodle\u3001Canvas\u3001Desire2Learn \u548C Blackboard \u4F7F\u7528\uFF09\u3002",
    "meetings.fullPlanItem33": "\u96F2\u7AEF\u9304\u88FD\u6A94\u6848\u9010\u5B57\u7A3F",
    "meetings.fullPlanItem33Tip": "\u96F2\u7AEF\u9304\u88FD\u9010\u5B57\u7A3F\u662F\u60A8\u9304\u88FD\u5230\u96F2\u7AEF\u7684\u6703\u8B70\u6216\u7DB2\u8DEF\u7814\u8A0E\u6703\u97F3\u8A0A\u7684\u97F3\u8A0A\u8F49\u6587\u5B57\u7A3F\u3002\u8ACB\u6CE8\u610F\uFF0C\u73FE\u968E\u6BB5\u50C5\u652F\u63F4\u82F1\u8A9E\u8A9E\u7A2E\u3002 <a href=\"https://support.zoom.us/hc/zh-tw/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\u9EDE\u6309\u6B64\u8655</a> \u4EE5\u77AD\u89E3\u8A73\u60C5\u3002",
    "meetings.fullPlanItem34": "\u54C1\u724C\u5316",
    "meetings.fullPlanItem34Tip": "\u65B0\u589E\u516C\u53F8\u54C1\u724C\u5316\u81F3\u60A8\u81EA\u5DF1\u81EA\u8A02\u7684\u9801\u9762\uFF0C\u60A8\u7684\u4F7F\u7528\u8005\u53EF\u5728\u6B64\u9801\u9762\u52A0\u5165\u6703\u8B70\u3002\u5EFA\u7ACB\u54C1\u724C\u5316\u96FB\u5B50\u90F5\u4EF6\u7BC4\u672C\uFF0C\u4EE5\u767C\u9001\u9080\u8ACB\u7D66\u89C0\u773E\u3002",
    "meetings.fullPlanItem35": "\u8A17\u7BA1\u7DB2\u57DF",
    "meetings.fullPlanItem35Tip": "\u4F7F\u7528\u60A8\u516C\u53F8/\u5927\u5B78\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7DB2\u57DF\u81EA\u52D5\u5C07\u4F7F\u7528\u8005\u65B0\u589E\u81F3\u60A8\u7684\u5E33\u6236\u3002",
    "meetings.fullPlanItem37": "\u8A9E\u8A00\u53E3\u8B6F",
    "meetings.fullPlanItem37Tip": "\u5141\u8A31\u6703\u8B70\u4E3B\u6301\u4EBA\u6307\u5B9A\u6703\u8B70\u548C\u7DB2\u8DEF\u7814\u8A0E\u6703\u4E2D\u7684\u53E3\u8B6F\u8005\u3002\u6703\u8B70\u6216\u7DB2\u8DEF\u7814\u8A0E\u6703\u958B\u59CB\u6642\uFF0C\u6703\u8B70\u4E3B\u6301\u4EBA\u53EF\u4EE5\u958B\u555F\u53E3\u8B6F\u529F\u80FD\uFF0C\u53E3\u8B6F\u4EBA\u54E1\u96A8\u5373\u80FD\u5920\u4F7F\u7528\u81EA\u5DF1\u7684\u8A9E\u8A00\u983B\u9053\u3002\u8207\u6703\u8005\u53EF\u4EE5\u9078\u64C7\u6240\u9700\u7684\u8A9E\u8A00\u983B\u9053\u6536\u807D\u81EA\u5DF1\u6240\u9078\u7684\u8A9E\u8A00\u53E3\u8B6F\u3002\u53C3\u6703\u8005\u4E0D\u4F46\u53EF\u4EE5\u807D\u898B\u7FFB\u8B6F\u904E\u7684\u97F3\u8A0A\u5167\u5BB9\uFF0C\u9084\u53EF\u4EE5\u9078\u64C7\u8ABF\u4F4E\u539F\u59CB\u97F3\u8A0A\u7684\u97F3\u91CF\u3002",
    "meetings.fullPlanItem39": "\u9AD8\u7D1A\u4E3B\u7BA1\u696D\u52D9\u5BE9\u67E5",
    "meetings.fullPlanItem39Tip": "\u8A73\u7D30\u8DA8\u52E2\u63A1\u7D0D\u5206\u6790\u3001\u6295\u8CC7\u5831\u916C\u7387 (ROI) \u8FFD\u8E64\u3001\u7522\u54C1\u8DEF\u7DDA\u5716\u8A0E\u8AD6\u3002",
    "meetings.fullPlanNewItem4": "\u5305\u62ECWebinar 500",
    "one.translatedCations": "已翻譯字幕",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "直接聊天、頻道或群組聊天",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "輕鬆進行一對一交流、小型或大型團體",
    "messageAndFileHistory": "訊息和檔案記錄",
    "findPeopeChannelsAndFilesInSearch": "從搜尋中找到對象、頻道和檔案",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "快速尋找聯絡人、即時訊息、群組聊天和檔案，動動手指即可掌握各類知識和資訊。",
    "applicationIntegrations": "應用程式整合",
    "secureFileSharing": "安全的檔案分享",
    "enhanceCollaborationWithSeamlessFileSharing": "流暢分享檔案增強協作能力",
    "persistentMeetingChat": "持續會議聊天",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "絕不錯過任何會議對話。 Zoom Team Chat 中的專屬群組聊天，可為全部與會者提供會議前、會議期間和會議結束後的交流空間。",
    "cloudStorage": "雲端儲存",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "將頻道備份至 Zoom 雲端或第三方儲存空間",
    "avatars": "虛擬頭像",
    "inMeetingReactions": "會議中回應",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "展現參與度並以非口頭的方式和其他與會者快速交流",
    "virtualBackgrounds": "虛擬背景",
    "videoFilters": "視訊過濾器",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "使用各種會議濾鏡注入繽紛樂趣",
    "inMeetingPollsAndQuizzes": "會議中投票/測驗",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "為會議建立單選或複選投票問題。",
    "liveStreamingAcrossPlatforms": "跨平台現場直播",
    "appearanceTouchUp": "美顏",
    "originalSoundForMusicians": "專為音樂人士提供的原始音效",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings 的端對端加密功能",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "啟用時，Zoom Meetings 的 Zoom 端對端加密 (E2EE) 可確保在特定會議中使用 Zoom 用戶端所有與會者之間的通訊，使用僅與會者裝置才知道的加密金鑰進行加密。 此可確保包含 Zoom 在內的第三方皆無法取得會議的私有金鑰。",
    "zoomCustomerManagedKey": "Zoom客戶自管金鑰",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "攜入您自己的加密金鑰以保護Zoom的靜態資料",
    "enterpriseGradeSecurityFeatures": "企業級安全性功能",
    "256BitAesGcmEncryptionForRealTimeContent": "將 256 位元 AES-GCM 加密用於即時內容與媒體、SIP 註冊期間的 TLS 加密、來電者 ID 遮蔽、私有網路對接、工具詐騙偵測以及通話封鎖清單。",
    "phone.fullPlanItem40": "\u900F\u904E SAML 2.0 \u55AE\u4E00\u767B\u5165",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "\u7121\u9650\u5236\u5167\u90E8\u901A\u8A71",
    "phone.fullPlanItem2": "\u8A08\u91CF\u64A5\u51FA\u901A\u8A71",
    "phone.fullPlanItem3": "\u7121\u9650\u5236\u64A5\u51FA\u901A\u8A71",
    "phone.fullPlanItem4": "\u9818\u5148\u696D\u754C\u7684\u9AD8\u6E05\u6670\u5EA6\u901A\u8A71\u54C1\u8CEA",
    "phone.fullPlanItem4Tip": "\u542B\u4E3B\u52D5\u5F0F\u964D\u566A\u3001\u6D88\u9664\u56DE\u97F3\u548C\u9375\u76E4\u8F38\u5165\u6291\u5236\u529F\u80FD",
    "phone.fullPlanItem5": "\u539F\u751F Windows\u3001MacOS \u548C Linux \u684C\u4E0A\u578B\u61C9\u7528\u7A0B\u5F0F",
    "phone.fullPlanItem6": "iOS \u548C Android \u7248\u539F\u751F\u884C\u52D5\u61C9\u7528\u7A0B\u5F0F",
    "phone.fullPlanItem7": "\u63A5\u5165\u73FE\u6709\u865F\u78BC\u6216\u8CFC\u8CB7\u65B0\u865F\u78BC (DID)",
    "phone.fullPlanItem8": "\u53D7\u8A71\u65B9\u4ED8\u8CBB\u865F\u78BC",
    "phone.fullPlanItem9": "\u96FB\u8A71\u5206\u6A5F\u865F\u78BC",
    "phone.fullPlanItem10": "\u5E36\u6709\u8F49\u9304\u529F\u80FD\u7684\u8A9E\u97F3\u4FE1\u7BB1",
    "phone.fullPlanItem10Tip": "\u900F\u904E\u884C\u52D5/\u684C\u4E0A\u578B\u61C9\u7528\u7A0B\u5F0F\u548C\u96FB\u5B50\u90F5\u4EF6\u5B58\u53D6\u8A9E\u97F3\u4FE1\u7BB1\u9010\u5B57\u7A3F",
    "phone.fullPlanItem11": "\u7121\u9650\u5236\u81EA\u52D5\u61C9\u7B54\u7CFB\u7D71/IVR",
    "phone.fullPlanItem12": "\u4F9D\u64DA\u59D3\u540D\u76EE\u9304\u64A5\u865F",
    "phone.fullPlanItem13": "\u81EA\u52D5\u901A\u8A71\u5206\u914D (ACD) \u7FA4\u7D44\uFF0C\u5E36\u6709\u901A\u8A71\u4F47\u5217\u529F\u80FD",
    "phone.fullPlanItem14": "\u63D2\u8A71/\u76E3\u63A7/\u79C1\u8A9E/\u63A5\u7BA1",
    "phone.fullPlanItem15": "\u5047\u65E5\u548C\u8FA6\u516C\u6642\u9593\u8DEF\u7531",
    "phone.fullPlanItem16": "3 \u65B9\u81E8\u6642\u6703\u8B70\u901A\u8A71",
    "phone.fullPlanItem17": "\u901A\u8A71\u9304\u97F3",
    "phone.fullPlanItem17Tip": "\u63D0\u4F9B\u81EA\u52D5\u548C\u624B\u52D5\u901A\u8A71\u9304\u97F3\u3002",
    "phone.fullPlanItem18": "\u53EF\u914D\u7F6E\u7121\u8A18\u540D\u548C\u5177\u540D\u4F86\u96FB\u5C01\u9396",
    "phone.fullPlanItem19": "\u7DCA\u6025\u901A\u8A71",
    "phone.fullPlanItem19Tip": "\u5C07\u4F86\u96FB\u7F6E\u65BC\u672C\u5730\u7DCA\u6025\u670D\u52D9",
    "phone.fullPlanItem20": "Nomadic E911 \u5730\u5740\u641C\u5C0B\u7CFB\u7D71 (\u7F8E\u570B\u548C\u52A0\u62FF\u5927) -",
    "phone.fullPlanItem20Tip": "\u52D5\u614B\u5075\u6E2C\u4F7F\u7528\u8005\u4F4D\u7F6E\uFF0C\u4E26\u56DE\u5831\u5C0D\u61C9\u7DCA\u6025\u5730\u5740\u81F3\u7576\u5730\u7DCA\u6025\u670D\u52D9\u55AE\u4F4D (\u50C5\u9650\u7F8E\u570B\u548C\u52A0\u62FF\u5927) \u53CA\u5167\u90E8\u5B89\u5168\u5718\u968A",
    "phone.fullPlanItem21": "\u61C9\u6025\u56DE\u61C9\u4E2D\u5FC3",
    "phone.fullPlanItem21Tip": "\u555F\u7528\u5167\u90E8\u5B89\u5168\u5718\u968A\u5C0D\u7DCA\u6025\u4F86\u96FB\u4E4B\u8B66\u5831\uFF0C\u4EE5\u53CA\u5C0D\u7DCA\u6025\u4F86\u96FB\u9032\u884C\u9304\u88FD/\u76E3\u63A7/\u63D2\u8A71\uFF0C\u4EE5\u5354\u52A9\u5354\u8ABF\u56DE\u61C9\u3002",
    "phone.fullPlanItem22": "\u5171\u4EAB\u7DDA\u8DEF\u986F\u793A/\u59D4\u6D3E",
    "phone.fullPlanItem23": "\u88DD\u7F6E\u9593\u901A\u8A71\u5207\u63DB",
    "phone.fullPlanItem24": "\u901A\u8A71\u99D0\u7559",
    "endToEndEncryptionForZoomPhone": "Zoom Phone 的端對端加密",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "在 Zoom Phone 啟用時，端對端加密 (E2EE) 使用僅裝置通話者和接收者知道的加密金鑰，進而為通話加密。 此外，使用者將來也可以向通話者提供一個獨特的安全碼，藉此驗證 E2EE 狀態。",
    "phone.fullPlanItem43": "\u96FB\u8A71\u96F6\u63A5\u89F8\u4F48\u5EFA",
    "phone.fullPlanItem44": "\u5E33\u6236\u6DF7\u5408\u8A08\u756B\u7A2E\u985E",
    "phone.fullPlanItem46": "\u5373\u6642\u5831\u544A\u548C\u54C1\u8CEA\u5100\u8868\u677F",
    "phone.fullPlanItem47": "\u652F\u63F4\u865B\u64EC\u684C\u9762 (VDI) \u74B0\u5883",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/zh-tw/articles/360031096531-Getting-Started-with-VDI\">\u77AD\u89E3\u95DC\u65BC VDI \u7684\u8A73\u60C5</a>",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "適用於所有電話獨立客戶。 與會議計畫配對時，支援計畫會有所不同。",
    "phone.fullPlanItem49": "\u63A5\u5165\u60A8\u7684\u5C08\u7528\u71DF\u904B\u5546\u652F\u63F4",
    "phone.fullPlanItem49Tip": "\u652F\u63F4\u8207\u60A8\u73FE\u6709 PSTN \u670D\u52D9\u4F9B\u61C9\u5546\u7684\u76F4\u63A5\u548C\u73FE\u5834\u70BA\u4E3B\u5C0D\u63A5",
    "phone.fullPlanItem50": "\u8207\u820A\u5F0FPBX\u7684\u6DF7\u5408\u6574\u5408",
    "phone.fullPlanItem51": "對講機",
    "phone.fullPlanItem61": "線上傳真",
    "phone.fullPlanItem61Tip": "在美國與加拿大境內無限量傳送和接收傳真。如需國際傳真，請<a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">查看費率</a>",
    "phone.fullPlanSms": "\u7C21\u8A0A\u548C\u591A\u5A92\u9AD4\u8A0A\u606F",
    "phone.fullPlanSmsTip": "\u50C5\u9069\u7528\u65BC\u8CFC\u8CB7\u901A\u8A71\u8A08\u756B\u7684\u7F8E\u570B\u548C\u52A0\u62FF\u5927\u865F\u78BC \u53EF\u7528\u65BC\u76F4\u64A5\u865F\u78BC (\u975E\u516C\u53F8\u865F\u78BC)\u3002",
    "meetings.fullPlanItem6": "\u6280\u8853\u652F\u63F4",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "\u50C5\u9650\u7968\u8B49",
    "meetings.fullPlanItem6_pro": "\u7968\u8B49\u548C\u7DDA\u4E0A\u804A\u5929",
    "meetings.fullPlanItem6_biz": "\u7968\u8B49\u3001\u7DDA\u4E0A\u804A\u5929\u548C\u96FB\u8A71",
    "meetings.fullPlanItem6_ent": "\u7968\u8B49\u3001\u7DDA\u4E0A\u804A\u5929\u548C\u96FB\u8A71",
    "knowledgeBase": "知識庫",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "搜尋我們的知識庫文件以解決技術問題並取得支援資源。",
    "zoomCommunity": "Zoom 社群",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "尋找解決方案、提出問題並與其他 Zoom 使用者協作的地方。",
    "chatbot": "聊天機器人",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "與我們的聊天機器人互動以獲得問題的解答並解決技術問題。",
    "submitWebTickets": "提交網頁支援票證",
    "liveChatSupport": "線上聊天支援",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "超過每個月 {amount} 美元的訂閱方案",
    "livePhoneSupport": "線上電話支援",
    "meetWithAgentOnVideo": "與專員進行視訊",
    "subscriptionPlansGreaterThan_200UsdMonth": "超過每個月 200 美元的訂閱方案",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "直接於 Zoom Team Chat 內使用喜愛的應用程式大幅提高生產力",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "自訂個人虛擬頭像增添會議趣味性，無須開啟視訊即可展現自我",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "郵件",
    "common.plans.meeting.title": "會議",
    "plans.basic_free.upgrade.item1": "每次會議限時 30 小時",
    "common.statistics.participants": "{0} 與會者",
    "common.per_meeting_unit": "每次會議",
    "common.participant_limit.increase_with_large_meetings": "使用大型會議方案增加人數",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "白板",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "無限量",
    "common.plans.team_chat.title": "團體聊天",
    "common.plans.mail_calendar.title": "郵件與日曆",
    "common.plans.cloud_storage.title": "雲端儲存",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Zoom翻譯字幕",
    "common.plans.extras.title": "贈品",
    "common.plans.extras.desc": "管理公司網域，以及更多功能",
    "zoom_one_edu_bundle.school.title": "Zoom One 教育解決方案學校與校園版",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One 教育解決方案學校與校園加強版",
    "per_billing_cycle_license.monthly": "/月/授權",
    "per_billing_cycle_license.yearly": "/年/授權",
    "per_billing_cycle_space.monthly": "/月/空間",
    "per_billing_cycle_space.yearly": "/年/空間",
    "common.dialog.feature_list": "查看完整功能列表",
    "detail_dialog.meeting_feature.cloud_recording.pro": "每份授權 5GB",
    "detail_dialog.meeting_feature.cloud_recording.10": "每份授權 10GB",
    "detail_dialog.meeting_feature.cloud_recording.ent": "企業加強版包含無限制",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + 會議室連接器 (1:25 比例)",
    "plans.whiteboard.ent": "企業加強版包含無限制加強版",
    "plans.zp.ent": "隨附於企業加強版中",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "預先或現場工作區預約等",
    "plans.largeMeeting.intro_tip": "大型會議是結帳時可以選用的附加元件，可讓您主持最多 500 或 1,000 名與會者的會議 (取決於購買的授權)。",
    "common.participant_limit.expandable_with_large_meetings": "可擴展用於大型會議",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">企業版 Plus 為 1,000 名</span>",
    "plans.webinar": "Zoom網路研討會",
    "plans.webinar.ent": "企業加強版包含 Sessions 1000 (含 Webinar)",
    "per_billing_cycle_user.monthly": "/月/使用者",
    "per_billing_cycle_user.annually": "/年/使用者",
    "closeComparisonChart": "詳細比較圖",
    "archiving_api": "存檔 API",
    "dlp_api": "DLP API",
    "info_barriers": "資訊屏障",
    "chat_etiquette": "聊天禮儀",
    "gdrp": "通用資料保護條例 (GDPR)",
    "regiona_data_centers": "區域資料中心",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "預設加密",
    "end_to_end_encryption": "端對端加密",
    "cryptographic_boundary": "加密界線",
    "vdi": "虛擬桌面 (VDI)",
    "customer_managed_key": "自訂託管金鑰",
    "gpo_msi_policies": "GPO/MSI 政策",
    "msi": "大規模部署 (MSI)",
    "ntt": "網路測試工具 (NTT)",
    "dashboards": "儀表板",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone 生存能力",
    "zoom_meeting_survivability": "Zoom Meeting 續行能力",
    "paid_option": "付費選項",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "核心功能",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "學校與校園",
    "zoom_one_edu_bundle.school_plus.brief_title": "學校與校園加強版",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "plan-downgrade": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "select-tip": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "num-dialog": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "details-biz_plus": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "one-edu": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "revenue-accelerator": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "plan-comparison": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  },
  "plan-details": {
    "billing.essential_apps": "Essential Apps",
    "billing.essential_apps.dialog_desc": "Grow and manage your business with apps that take meeting notes, engage your team with interactive activities, and deliver insights to improve customer conversations. Free premium apps included in your plan for 1 year.",
    "billing.see_more_details": "See More Details",
    "billing.essential_app.legal_copy": "Offer valid only for users with a current license, as of or after January 4, 2023, under a Zoom One Pro, Business, or Business Plus subscription that is ordered through Zoom’s online channel at zoom.us/buy. Users whose subscription is associated with an Healthcare (except if purchasing at zoom.us/buy), Education, or Government account are ineligible for this offer. Access to each app, with the exception of Coda, begins upon the app's activation by the individual user and expires 1 year thereafter. Access to Coda for all users on the same Zoom account begins upon the first activation of Coda by any user on the same Zoom account and expires for all users on that Zoom account 1 year thereafter, regardless of the initial date of activation by subsequent users on the same Zoom account. For all apps, reassignment or cancellation of a user's eligible license or subscription will end access for that user, regardless if there is time remaining on the 1 year access period. Each app is subject to its terms of use and privacy policy available at the time of activation. Included apps are only supported in English. Not all apps work on mobile. Offer not redeemable or refundable for cash. Offer only applies to these apps listed as included at <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Essential Apps in the Zoom App Marketplace</a>. Users with pre-existing subscriptions to any of the apps do not qualify for this offer with respect to those particular apps. Included apps are subject to change. Zoom reserves the right to modify or cancel this offer at any time without prior notice and liability.",
    "billing": {
      "plan": {
        "feature": {
          "workflow": {
            "subTitle": "Automate everyday routine tasks",
            "title": "Workflow Automation",
            "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
            "label": "Complimentary access",
            "desc": "Automate everyday tasks with powerful workflows that streamline your work across Zoom Workplace and third-party applications with the help of AI Companion.",
            "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
            "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
            "summary": "For a limited time, enjoy unlimited runs for Workflow Automation with any paid Zoom Workplace plan. Terms and pricing are subject to change at the end of the promotional period",
            "options": {
              "ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
              "doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
              "auto": "Automate repetitive tasks like welcoming new members in a chat channel, manage time-off requests, and more",
              "workflow": "Build complex workflows across Zoom Workplace and third-party applications like Google, Microsoft, and Jira"
            }
          }
        }
      },
      "visitor_management": {
        "title": "Visitor Management"
      },
      "zone_pro_plus": {
        "pro_plus_phone_features": "Chat only"
      },
      "pbx": {
        "phone_support_24_7_live_chat": "24x7 Live Chat & Phone Support"
      },
      "learn_more": "Learn More",
      "new": "New",
      "plan_details": {
        "meeting": {
          "title": "Meetings",
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "meeting_hours": "Unlimited meetings for up to 30 hours per meeting",
          "recording_storage": "{0} GB of cloud recording storage (per license)",
          "auto_captions": "Automated Captions"
        },
        "whiteboard": {
          "title": "Whiteboard",
          "boards_storage": "{0} editable boards",
          "standard_features": "Standard features"
        },
        "team_chat": {
          "title": "Team Chat",
          "desc": "Group chat & file sharing"
        },
        "main_calendar": {
          "title": "Mail & Calendar",
          "desc": "Mail & Calendar Client & Services"
        },
        "notes": {
          "title": "Notes",
          "desc1": "Create and share editable documents within Zoom",
          "desc2": "Personal and collaborative notes with rich-text editing"
        },
        "clips": {
          "title": "Clips Plus",
          "desc1": "Easily record, edit, and share short-form videos",
          "desc2": "Unlimited videos and advanced features"
        },
        "AI": {
          "title": "AI Companion",
          "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
          "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more"
        },
        "EssentialApp": {
          "title": "Essential Apps",
          "desc1": "Free premium apps for 1 year (terms apply)",
          "desc2": "Increase team collaboration and productivity"
        },
        "livechat": {
          "title": "Live Chat Support"
        }
      }
    },
    "fbc": {
      "base_plan": {
        "downgrade": {
          "biz2pro": {
            "title": "Change to Zoom Workplace Pro?",
            "content": "You’ve previously selected Zoom Workplace Business which allows up to 300 participants per meeting, Zoom Scheduler, and more. Do you still want to change to Pro?",
            "confirm": "Confirm Change",
            "keep_current": "Keep Current Plan"
          }
        }
      },
      "test": "Zoom Whiteboard",
      "common": {
        "statistics": {
          "attendees": "{0} Attendees",
          "participants": "{0} Participants",
          "user_range": "{0}-{1} users",
          "items": "{num} items"
        },
        "button": {
          "ok": "OK",
          "add": "Add",
          "buy_now": "Buy Now",
          "try_for_days": "Try for {0} days",
          "contact_sales": "Contact Sales",
          "close": "Close",
          "cancel": "Cancel",
          "edit": "Edit",
          "got_it": "Got it"
        },
        "title": {
          "everything_in_and": "Everything in {0}, and:"
        },
        "tag": {
          "new": "New",
          "free_trial": "Free Trial"
        },
        "billing_cycle": {
          "annual": "Annual",
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "two_years": "Two Years",
          "three_years": "Three Years"
        },
        "errors": {
          "unknown_error_try_again": "Unknown error processing transaction. Please try again later."
        },
        "excluding_tax": {
          "vat_tip": "excluding VAT",
          "gst_tip": "excluding GST",
          "iva_tip": "excluding IVA",
          "igic_tip": "excluding IGIC",
          "jct_tip": "excluding JCT",
          "stods_tip": "excluding SToDS"
        }
      },
      "plan_details": {
        "limited_features": "Limited features",
        "pro_plus": {
          "host_meeting_up_to_participants": "Host up to {0} participants",
          "gb_of_cloud_recording_storage": "{0} GB of cloud recording storage (per license)",
          "standard_features": "{0} editable boards with {1}MB of cloud storage"
        },
        "biz_plus": {
          "docs": {
            "docs": "Docs",
            "features_item1": "AI Companion for content generation and translations",
            "features_item2": "Unlimited number of shared docs with your team",
            "features_item3": "Access unlimited version history",
            "comparison_table_tips": "Supercharge collaboration with AI-first docs that transform meeting content into actionable documents, wikis, and projects"
          },
          "tasks": {
            "zoom_tasks": "Zoom Tasks",
            "tasks": "Tasks",
            "tasks_basic": "Tasks Basic",
            "features_item1": "Automatically detect tasks from across your meetings, phone calls, chats, and docs",
            "features_item2": "Get assistance on task completion, such as scheduling follow-up meetings and drafting documents",
            "features_item3": "Effortlessly mark tasks as complete when they’re done to stay on top of your progress and focus on what’s next",
            "features_item4": "Manage tasks across the Zoom Workplace platform, including Zoom Docs",
            "features_item1_opc": "Leverage the power of AI Companion to identify and create tasks from your chats, emails, docs, whiteboards, and meeting summaries",
            "features_item2_opc": "Easily sort, filter, group, and search to quickly access and gather context on your tasks",
            "learn_more_header": "Stay on top of your action items with AI Companion* to get more done across Zoom Workplace.",
            "learn_more_footer": "\*AI Companion is only available for Zoom Workplace Pro, Business, and Enterprise plans.",
            "features_prefix": "Let AI Companion help you: ",
            "comparison_table_tips": "Stay on top of action items and complete them on time with an AI-first solution that provides task recommendations based on conversations and meeting summaries in Zoom Workplace.",
            "tasks_label_text": " AI-first task management"
          },
          "title": "Business Plus",
          "contact_us_for_more_pricing": "Contact us for pricing information and more",
          "contact_sales": "Contact Sales",
          "meetings": "Meetings",
          "phone": "Phone",
          "phone_sub_title": "Unlimited Calling",
          "use_only": "Business use only",
          "team_chat": {
            "title": "Team Chat",
            "title_desc": "Group chat & file sharing"
          },
          "cloud_storage": {
            "title": "Cloud Storage"
          },
          "mail_calender": {
            "title": "Mail & Calendar"
          },
          "beta": "Beta",
          "client_service": {
            "title": "Client & Service"
          },
          "up_to_30_hours_per_meeting": "up to 30 hours per meeting",
          "300_attendees": "300 Attendees",
          "per_meeting": "per meeting",
          "whiteboard": {
            "title": "Whiteboard"
          },
          "new": "New",
          "clips_plus": "Clips Plus",
          "notes": "Notes",
          "10GB": "10GB",
          "extras": "Extras",
          "sso_managed_domains_more": "SSO, managed domains & more",
          "scheduler": "Scheduler",
          "global_select": "Global Select",
          "unlimited_regional": "Unlimited regional",
          "translated_captions": "Translated Captions",
          "workspace_reservation": "Workspace Reservation",
          "auto_translated_captions": "Automated and Translated Captions",
          "unlimited_editable_boards": "Unlimited editable boards",
          "standard_features": "Standard features",
          "advanced_docu_controls": "Advanced document controls",
          "chats_channels_for_collaboration": "Chats and channels for collaboration, file sharing, and more",
          "zoom_phone_is_biz_use_only": "Zoom Phone is business use only",
          "unlimited_regional_calling": "Unlimited Regional Calling",
          "domestic_sms_mms": "Domestic SMS & MMS",
          "automatic_call_distribution_groups": "Automatic call distribution groups (ACD) with call queueing",
          "single_sign_on": "Single sign-on",
          "managed_domains": "Managed domains",
          "company_branding": "Company branding",
          "mail_calender_client_services_beta": "Mail & Calendar Client & Services beta",
          "unlimited_meetings_for_up_to_30_hours_per_meeting": "Unlimited meetings for up to 30 hours per meeting",
          "mail_and_calendar_client_and_services_beta": "Mail and Calendar Client & Service",
          "easily_record_edit_share_videos": "Easily record, edit, and share short-form videos",
          "unlimited_videos_advanced_features": "Unlimited videos and advanced features",
          "create_share_editabel_docu_within_zoom": "Create and share editable documents within Zoom",
          "personal_collaborative_notes_rich_text_editing": "Personal and collaborative notes with rich-text editing",
          "effortlessly_share_meeting": "Effortlessly share meeting slots for easy booking",
          "works_with_zoom_meeting_mail_calender_google_ms": "Works with Zoom Meetings, Zoom Mail and Calendar, Google and Microsoft 365",
          "up_to_300_attendees": "Up to <b>300</b> Attendees",
          "10_gb_of_storage": "10 <b>GB</b> of storage",
          "host_meeting_up_to_300_participants": "Host meetings up to 300 participants",
          "10_gb_of_cloud_recording_storage": "10 GB of cloud recording storage (per license)",
          "starting_at_licenses_year": "Starting at {1} licenses for {0}/year",
          "starting_at_licenses_month": "Starting at {1} licenses for {0}/month",
          "ai_companion": "AI Companion",
          "automate_key_tasks": "Automate key tasks across the Zoom platform with an AI assistant",
          "gain_quick_access_to_meeting_summaries": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
          "learn_more": "Learn More",
          "essential_apps": "Essential Apps",
          "increase_team_collaboration": "Increase team collaboration and productivity",
          "free_premium_apps": "Free premium apps for 1 year (terms apply)",
          "visitor_management": "Visitor Management",
          "visitor_management_custom_invites": "Customize invites",
          "visitor_management_visitor_check": "Check in at a kiosk",
          "visitor_management_receive_detailed": "Receive detailed metrics on visitors’ space usage"
        },
        "custom_avatar": {
          "title": "Custom Avatar",
          "label_text": "3 minutes per month",
          "basic_feature": "1 minute per lifetime",
          "pricing_feature": "3 minutes per month",
          "learn_more_subtitle": "Create a lifelike AI version of yourself with voice replication and multilingual communication.",
          "features_item1": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "features_item3": "Choose from 18 pre-designed avatars for quick, high-quality video creation",
          "features_item4": "Enjoy virtual background support",
          "features_item1_opc": "Create up to 3 lifelike digital avatars each month that replicate your appearance and voice for presentations and demos",
          "features_item2_opc": "Use your avatar to deliver scripts up to 3 minutes long with AI Companion",
          "comparison_table_tips": "Custom Avatar creates a lifelike AI version of yourself with voice replication and multilingual communication."
        }
      },
      "ai_companion_dialog": {
        "title": "AI Companion",
        "full_title": "AI Companion",
        "desc1": "Automate key tasks across the Zoom platform with an AI assistant",
        "desc2": "Gain quick access to meeting summaries, assistance with drafting messages, and more",
        "learn_more_dialog": {
          "desc": "Get more done with AI Companion! It can write content, schedule your meetings, help manage your projects, and more.",
          "tip1": "Receive an agenda ahead of time so you can host more effective meetings",
          "tip2": "Keep your projects on track with automated task creation and notifications",
          "tip3": "Get help with organizing your calendar and managing your time ",
          "tip4": "Generate written and visual content that matches your style in Docs, Whiteboard or in the Zoom Workplace app"
        },
        "top_features": "Top Features",
        "more_to_come": "More incredible features to come!",
        "discover_more": "Discover even more ways to do your best work with AI Companion!",
        "detail_desc": "AI Companion is included at no additional cost with the paid services in Zoom user accounts. Select verticals and geos may be excluded."
      },
      "zra": {
        "title": "Zoom Revenue Accelerator",
        "year_license": "/year/license",
        "month_licnese": "/month/license",
        "tip1": "Gain insights into your calls with sentiment and engagement scores",
        "tip2": "Get help to improve seller performance with features like transcription, automate documentation, and more to keep deals moving.",
        "tip3": "Streamline CRM and calendar integration for a comprehensive view of sales opportunities and forcasting"
      },
      "add_ons": {
        "pricing": {
          "per_month": "/month",
          "per_year": "/year"
        },
        "unit": {
          "license": "{0}/license",
          "user": "{0}/user"
        },
        "learn_more": "Learn more",
        "required": "Required",
        "zoom_one_required": "Zoom Workplace Required",
        "large": {
          "features_tip": "Expand your reach with an increased attendee capacity of up to 1,000 participants.",
          "label_title1": "500 Participants",
          "label_title2": "1000 Participants"
        },
        "cmr": {
          "features_tip": "Store, stream, and download your video recordings directly from the Zoom Cloud.",
          "explain_desc": "Cloud storage is included in select Zoom One plans: Pro (5 GB), Business (5 GB), Business Plus (10 GB), and Enterprise (Unlimited) ",
          "label_title1": "30GB",
          "label_title2": "200GB",
          "label_title3": "1TB",
          "label_title4": "5TB",
          "option_label1": "≈ 100 hours",
          "option_label2": "≈ 650 hours",
          "option_label3": "≈ 3,500 hours",
          "option_label4": "≈ 17,500 hours",
          "intro_label2": "Storage options include up to 5TB/month",
          "tooltip_content": "Recording storage varies with the number of video-enabled participants, meeting resolution, and shared content resolution."
        },
        "whiteboard": {
          "plus_title": "Whiteboard Plus",
          "title": "Whiteoard",
          "features_tip": "Collaborate in real-time with others on whiteboards, both during and outside of meetings.",
          "explain_desc": "Included in Zoom One Business, Zoom One Business Plus, and Zoom One Enterprise",
          "explain_desc_plus": "Included in Zoom One Enterprise Plus and with each Zoom Rooms subscription",
          "option_label1": "Unlimited boards with 1 GB Cloud Storage",
          "option_label2": "Advanced features with unlimited boards and Cloud Storage",
          "intro_label1": "Unlimited concurrently editable whiteboards",
          "intro_label2": "Standard features and advanced document control",
          "intro_label3": "Advanced whiteboard features, including custom and organizational templates, and 3rd-party integrations"
        },
        "translated_captions": {
          "features_tip": "Empower global collaboration with automated captions in your preferred language.",
          "intro_label1": "Participants can self-enable captions and switch languages. ",
          "intro_desc1": "<a href='https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions'>{0}</a>",
          "view_support_language": "View supported languages"
        },
        "crc": {
          "features_tip": "Enables any standards based SIP/H.323 video conferencing endpoint for effective hybrid work.",
          "intro_label1": "Works with many legacy endpoints including Polycom, Cisco, Lifesize and others",
          "intro_label2": "Cloud-based or on-premise (VM) room connector"
        },
        "scheduler": {
          "simplify_bookings": "Simplify bookings with flexible availability and customizable time slots",
          "host_one_on_one": "Host one-on-one or group meetings with a single link for easy sharing",
          "customize_reminders": "Customize reminders via email / SMS to reduce missed appointments",
          "sync_calendars": "Sync calendars seamlessly with Google, Microsoft 365, and Zoom integrations",
          "features_tip": "Effortlessly share meeting slots for office hours, interviews and more.",
          "intro_label1": "Calendar Integration",
          "intro_label2": "Recurring Availability",
          "intro_label3": "Scalable Meeting",
          "intro_label4": "Customizable Notifications",
          "intro_sub_label1": "Google, Microsoft 365, and Zoom ",
          "intro_sub_label2": "share bookable time slots ",
          "intro_sub_label3": "single meeting for one or multiple attendees",
          "intro_sub_label4": "automate email or SMS reminders and confirmations"
        },
        "zoom_clips_plus": {
          "features_tip": "Record, edit, and share high-quality, short-form video messages.",
          "intro_label1": "Create unlimited videos with no time limits",
          "intro_label2": "Capture your screen and video together or separately",
          "intro_label3": "Trim your video as needed and share the link",
          "intro_label4": "Access advanced features like audio transcripts and statistics",
          "explain_desc": "Included in all paid Zoom Workplace plans"
        },
        "eventsaas": {
          "title": "Zoom Events",
          "features_tip": "Advanced events platform with robust registration and networking features. Ideal for both virtual and hybrid experiences.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Everything in Sessions, plus:",
          "intro_label1": "Boost audience engagement with multi-session events",
          "intro_label2": "Easily host events with tailored ticketing and mobile app",
          "intro_label3": "Increase event revenue with Expo Floor and Sponsor area",
          "intro_label4": "Foster attendee networking with customizable profiles",
          "intro_label5": "Extend reach with on-demand viewing in Event Lobby",
          "intro_label6": "Accelerate event setup with curated event templates",
          "events_feature_item1_20240827": "Organize multi-day virtual events with multiple tracks",
          "events_feature_item2_20240827": "Promote networking with attendee profiles and lobby chat",
          "events_feature_item3_20240827": "Guide attendees with lobby session streaming",
          "events_feature_item4_20240827": "Increase event revenue with expo floor and sponsorships",
          "events_feature_item5_20240827": "Improve future events with post-conference surveys",
          "events_feature_item6_20240827": "Accelerate event setup with curated event templates",
          "attendees_start_at": "{0} attendees starting at",
          "explain_desc": "Discover more about Zoom Events",
          "contact_account_owner": "If you would like to purchase Events, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Events, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "eventsaascore": {
          "title": "Zoom Sessions",
          "features_tip": "Streamline interactive single-session events with features like event branding, multiple-host collaboration, and event management.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_title": "Includes Zoom Webinars, plus:",
          "intro_label1": "Customize event landing pages for effective branding",
          "intro_label2": "Promote events with branded emails",
          "intro_label3": "Measure performance with an interactive dashboard",
          "intro_label4": "Seamless collaboration with co-hosts and co-editors",
          "intro_label5": "Professional events tools: Simulive, Backstage, and more",
          "sessions_feature_item1_20240827": "Elevate webinars with custom scenes and branding",
          "sessions_feature_item2_20240827": "Simplify event planning with AI Companion to generate messaging and images",
          "sessions_feature_item3_20240827": "Promote past and future events in a branded content hub",
          "sessions_feature_item4_20240827": "Run professional events with Backstage, Simulive, and RTMP",
          "sessions_feature_item5_20240827": "Improve future webinars with cross-event insights",
          "explain_desc": "Discover more about Zoom Sessions",
          "contact_account_owner": "If you would like to purchase Sessions, please <a href=\"/account\" target=\"_blank\">contact your account owner</a>",
          "enable_settings": "If you would like to purchase Sessions, please <a href=\"/account/privacy\" target=\"_blank\">enable settings</a> to contact sales."
        },
        "webinar": {
          "title": "Zoom Webinars",
          "features_tip": "Effortlessly broadcast messages with a user-friendly webinar platform.",
          "tooltip_content": "Host unlimited webinars or events at the chosen capacity",
          "intro_label1": "Engage audience with high-quality video webcasting",
          "intro_label2": "Boost engagement with Q&A, polling, and reactions",
          "intro_label3": "Improve webinar strategy with post-event reporting",
          "intro_label4": "Support up to 100,000 attendees and 100 panelists",
          "monthly_subscription": "Monthly Subscription",
          "annual_subscription": "Annual Subscription",
          "one_million": "1 Million",
          "single_use": "Single-Use",
          "one_month": "One-Month",
          "event_attendee": "Events/Sessions attendees: ",
          "event_attendee_desc": "Anyone who joins without being a licensed host on the hub. Special roles are also counted as attendees and can participate with audio, video, and screen sharing (if enabled).",
          "webinar_attendee": "Webinars attendees: ",
          "webinar_attendee_desc": "Anyone who joins but isn’t a host or panelist. They are in view-only mode and controlled by the host, who can unmute them and enable interaction via Q&A and chat.",
          "pay_per_attendee": "Pay Per Attendee",
          "attendees": "Attendees"
        },
        "zoom_one": {
          "title": "Zoom Workplace",
          "features_tip": "Reimagine how your teams work with your AI-powered collaboration platform.",
          "label_title1": "Workplace Pro",
          "label_title2": "Workplace Pro Plus",
          "label_title3": "Workplace Business",
          "label_title4": "Workplace Business Plus",
          "intro_label1": "Host unlimited meetings up to 30 hours with up to 100 participants",
          "intro_label2": "Access up to 3 concurrently editable whiteboards with standard features",
          "intro_label3": "Record, edit, and share high-quality, short-form video messages with Clips Plus",
          "intro_label4": "Get work done more efficiently with Zoom AI Companion",
          "intro_label5": "Zoom Phone US & CA Unlimited (BYOC, PBX, and 3rd-party PBX excluded)",
          "intro_label6": "Host unlimited meetings up to 30 hours with up to 300 participants",
          "intro_label7": "Share meeting slots for office hours, interviews and more using Zoom Scheduler",
          "intro_label8": "Zoom Phone US & CA Unlimited",
          "intro_label8_UK": "Zoom Phone UK & Ireland Unlimited",
          "intro_label8_AU": "Zoom Phone Australia & New Zealand Unlimited",
          "intro_label8_JP": "Zoom Phone Japan Unlimited",
          "intro_label9": "Visitor Management",
          "intro_label10": "Additional features",
          "intro_label11": "Live chat support",
          "intro_title1": "Everything in Pro, and:",
          "intro_title2": "Everything in Business, and:",
          "intro_label_tip1": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page.",
          "intro_label_tip2": "During checkout, you can select Unlimited Regional Calling for US & Canada, Australia & New Zealand, UK & Ireland, or Japan.",
          "intro_label_tip3": "Additional features include 10 GB Cloud Storage, Translated Captions, and Workspace Reservations.",
          "intro_label_tip4": "Zoom Phone in Pro Plus does not include BYOC, 3rd Party PBX, and VDI features. For more information, please refer to the Zoom Phone pricing page."
        },
        "power_pack": {
          "title": "Zoom Phone Power Pack",
          "features_tip": "Enhanced call queue analytics and historical insights for call center teams.",
          "intro_label1": "Expanded contacts window to streamline call handling",
          "intro_label2": "Auto Receptionist and Call Queue phone numbers"
        },
        "international_calling": {
          "title": "International Calling",
          "features_tip": "Unlimited international calling to more than 15 countries and regions.",
          "intro_label1": "Can be purchased with any unlimited calling plans",
          "intro_label2": "Explore our list of supported countries and regions for unlimited international calling.",
          "intro_labe2_tooltip": "USA, Kanada, Vereinigtes Königreich, Australien, Neuseeland, Belgien, Dänemark, Deutschland, Frankreich, Irland, Italien, Niederlande, Österreich, Portugal, Schweden, Spanien, Schweiz, Puerto Rico, Japan.",
          "intro_label2_view_list": "View List"
        },
        "workspace_reservation": {
          "title": "Workspace Reservation",
          "intro_title": "Easily reserve flexible workspaces or book hotel rooms in advance or on-site, with Zoom-integrated devices.",
          "intro_label1": "Access workspace and hotel reservations through the Zoom Workplace app, desktop, or browser",
          "intro_label2": "Receive personalized desk recommendations with the help of AI",
          "intro_label3": "Reserve workspaces directly from Google Calendar or Outlook, with reminders and check-in alerts",
          "intro_label4": "Navigate to reserved workspaces with wayfinding"
        },
        "visitor_management": {
          "title": "Visitor Management",
          "intro_title": "Streamline visitor check-ins with custom invites, hassle-free kiosk check-in, reporting, and metrics.",
          "intro_label1": "Manage invites, visitor locations, and visit history in the Zoom portal",
          "intro_label2": "Create, track, resend, and delete invites while receiving guest arrival notifications",
          "intro_label3": "Complete forms, get directions, and check in via kiosk for a smooth visitor experience",
          "intro_label4": "Access all features within the familiar Zoom portal for easy management"
        }
      },
      "plans": {
        "zoom_one": {
          "plan_name": "Zoom One"
        },
        "zoom_phone": {
          "title": "Zoom Phone"
        },
        "large_meeting": {
          "title": "Large Meeting",
          "description1": "Increase the meeting capacity to support up to 1,000 live interactive participants",
          "description2": "All participants can share their audio, video, and screen"
        },
        "cloud_storage": {
          "title": "Cloud Storage",
          "description2": "MP4 or M4A file formats available"
        },
        "translated_captions": {
          "title": "Translated Captions",
          "description1": "Enhance meetings with automated, multilingual captions that allow participants to enable and switch to a supported language",
          "description2": "Available in Zoom Meetings and Webinars"
        },
        "tollfree": {
          "title": "Audio Conferencing",
          "subcontent": "Dial into meetings with phones numbers from around the world",
          "description1": "Expand your call options with call out, global toll-free, and local dial-in for premium countries",
          "description2": "No cost for participants to call in from any device",
          "description3": "Easily select one or multiple countries for toll-free call-in"
        },
        "rc": {
          "title": "Conference Room Connector"
        },
        "clips_plus": {
          "title": "Zoom Clips Plus"
        },
        "zoom_scheduler": {
          "title": "Zoom Scheduler"
        }
      },
      "phone_num_dialog": {
        "Argentina": "Argentina",
        "Australia": "Australia",
        "Austria": "Austria",
        "Belgium": "Belgium",
        "Brazil": "Brazil",
        "Bulgaria": "Bulgaria",
        "Canada": "Canada",
        "Chile": "Chile",
        "China": "China",
        "Colombia": "Colombia",
        "Costa_Rica": "Costa Rica",
        "Croatia": "Croatia",
        "Cyprus": "Cyprus",
        "Czech_Republic": "Czech Republic",
        "Denmark": "Denmark",
        "Ecuador": "Ecuador",
        "Estonia": "Estonia",
        "Finland": "Finland",
        "France": "France",
        "Germany": "Germany",
        "Greece": "Greece",
        "Hong_Kong_SAR": "Hong Kong SAR",
        "Hungary": "Hungary",
        "Ireland": "Ireland",
        "Israel": "Israel",
        "Italy": "Italy",
        "Japan": "Japan",
        "Latvia": "Latvia",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg",
        "Mexico": "Mexico",
        "Netherlands": "Netherlands",
        "New_Zealand": "New Zealand",
        "Norway": "Norway",
        "Panama": "Panama",
        "Peru": "Peru",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Puerto_Rico": "Puerto Rico",
        "Romania": "Romania",
        "Singapore": "Singapore",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "South_Africa": "South Africa",
        "Spain": "Spain",
        "Sweden": "Sweden",
        "Switzerland": "Switzerland",
        "UK": "UK",
        "United_Kingdom": "United Kingdom",
        "US": "US",
        "United_States": "United States",
        "title": "Phone Number Requirements",
        "subtitle": "Please select the country where your Global Select phone number will be activated.",
        "selector_tip": "Select Country",
        "local_and_toll_free": "Local and toll-free numbers are available in {0} ",
        "just_local": "Local numbers are available in {0} "
      },
      "global_select_tip": {
        "header": "Global Select includes one phone number and unlimited domestic calling within the selected country per license.",
        "avail_title": "Available countries/territories"
      },
      "tax_exempt_ecm": {
        "title": "Tax Exemption Status",
        "status_exempt": "Tax Exempt",
        "status_exempt_question": "Tax Exempt?",
        "verify_now": "Verify Now",
        "can_after_checkout": "As an option, this step can be completed after checkout.",
        "status": {
          "exempt": "Exempt",
          "pending": "Pending",
          "pendingTooltip": "Your tax exemption status is currently under review. You may be charged tax upon placing an order. Should your exemption be approved, we will credit all refundable taxes/fees to your account.",
          "nonexempt": "Non-Exempt",
          "rejected": "Rejected",
          "rejectedTooltip": "The document submitted has been determined not to meet the requirements for your jurisdiction.",
          "approved": "Approved",
          "default": "default"
        },
        "confirm_close": {
          "new_desc": "If you abandon the verification, you may be charged applicable taxes/fees.  You can still submit your tax exemption document in the Billing Management section after purchase for Zoom's review and approval. Once validated, a refund will be issued for any applicable taxes charged.",
          "desc": "Are you sure you want to abandon tax exemption verification and proceed as tax eligible?",
          "title": "Are you sure?",
          "new_title": "Abandon Tax Exemption Verification?",
          "yes": "Yes, Abandon",
          "no": "No, Continue",
          "abandon": "Abandon Verification",
          "go_back": "Go Back"
        },
        "confirm_to_add": {
          "title": "Confirm new default tax exemption",
          "message": "Adding a new exemption will automatically set it as the default once approved or rejected. You can only have one default exemption, which will apply to future purchases. Your tax amount could be affected if your default exemption doesn’t match your “Sold To” state/region.",
          "yes": "Add new exemption"
        },
        "confirm_set_default": {
          "title": "Address and tax exemption mismatch",
          "message": "Your \"Sold To Contact\" address does not match the state/region you’ve selected for tax exemption. Please update your \"Sold To Contact\" address to match the location of your tax exemption. Otherwise, your purchase may not be tax exempt.",
          "yes": "Set as default anyways",
          "success_notify": "You’ve successfully set {0} as your default tax exemption"
        },
        "certificate_table": {
          "state_region": "State/Region",
          "exemption_type": "Exemption Type",
          "signed_date": "Signed Date",
          "status": "Status",
          "add_exemption": "Add Exemption",
          "view": "View",
          "set_as_default": "Set as Default"
        },
        "confirm_os_not_support": {
          "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
          "subtext_portal": "You can apply for tax exemption from a desktop. Submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged.",
          "subtext_checkout": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
        }
      },
      "reactivate": {
        "singlePreDescTip": "Your {planName} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plan.",
        "pairPreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date} at 12:00 AM Coordinated Universal Time. If you want to host past your cancellation date, please reactivate your plans.",
        "pairDiffDatePreDescTip": "Your {planName1} plan and {planName2} plan will be cancelled on {date1} at 12:00 AM Coordinated Universal Time and on {date2} at 12:00 AM Coordinated Universal Time, respectively. If you want to host past your cancellation date, please reactivate your plans.",
        "title": "Reactivate your plan to continue",
        "titles": "Reactivate your plans to continue",
        "plan": "Plan",
        "licenses": "License(s)",
        "billingCycle": "Billing Cycle",
        "effective_date": "Effective Date",
        "invoice_amount": "Invoice Amount",
        "singleDescTip": "By reactivating, you agree that your recurring plan will automatically renew on {date}, and your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "pairDiffDateDescTip": "By reactivating, you agree that your recurring plans will automatically renew on {date1} and {date2}. Your payment method on file will be charged each renewal period. To avoid future charges, <a target=\"_blank\" href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0066687\">cancel</a> by the day before your renewal date.",
        "totalLabel": "Total",
        "totalContent": "{money} plus applicable taxes",
        "taxDesc": "excluding VAT, GST or similar taxes",
        "reactivateBtn": "Proceed and Reactivate",
        "switchTitle": "Update your plan to continue",
        "successSingleTip": "Your {planName} plan has been reactivated",
        "successPairTip": "Your {planName1} and {planName2} plan have been reactivated",
        "switchTip": "Your Zoom One-Month Webinars plan expires on {date}. In order to host a webinar past this date, you must switch to a subscription.",
        "switchBtn": "Switch to Subscription"
      }
    },
    "meta": {
      "pro": {
        "title": "Zoom Workplace Pro"
      },
      "biz": {
        "title": "Zoom Workplace Business"
      },
      "proPlus": {
        "title": "Zoom Workplace Pro Plus"
      },
      "bizPlus": {
        "title": "Zoom Workplace Business Plus"
      }
    },
    "marketing": {
      "plan_comparison": {
        "security": {
          "gdpr_control": "GDPR control",
          "chat_etiquette": "Chat Etiquette",
          "enc_by_default": "Encryption by Default"
        }
      },
      "notIncluded": "Not Included",
      "included": "Included",
      "helpTooltipIcon": "Help Tooltip icon",
      "phone": {
        "fullPlanItem20Pdf": "Download the Data Sheet"
      },
      "one": {
        "new": "New"
      }
    },
    "webinarSetupInWebPortal": "Webinar Setup in Web Portal",
    "concurrentEvents": "Concurrent Events",
    "coucurrentEventsToolTip": "<span>A <b>subscription</b> plan supports one live event at a time, while the <b>pay per attendee</b> plan allows concurrent live events.</span>",
    "overages": "Overages",
    "eventsPlatformHubs": "Events Platform Hubs",
    "eventsHubToolTip": "Zoom Events <b>hubs</b> offer convenient event organization, allowing hosts to group related events based on specific topics.",
    "1HubPerLicense": "1 hub per license",
    "1000Hubs": "1000 hubs",
    "eventsPlatformHosts_500AttendeesOrMore": "Events Platform Hosts (500 attendees or more)",
    "eventsHost500": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "5HubHosts": "5 hub hosts",
    "100HubHosts": "100 hub hosts",
    "eventsPlatformHosts_100Attendees": "Events Platform Hosts (100 attendees)",
    "eventsHost100": "<span>Zoom Events <b>hub hosts</b> can create, edit, and publish events that have been created by the hub owner.</span>",
    "2HubHosts": "2 hub hosts",
    "howAreTheyDifferent": "How are they different?",
    "allPlansRequireAZoomOneLicense": "*All plans require a Zoom Workplace license",
    "subscription": "Subscription",
    "subscriptionToolTip": "<span>A <b>subscription</b> allows you to host an unlimited amount of events at your chosen capacity.</span>",
    "payPerAttendee": "Pay Per Attendee",
    "ppaToolTips": "<span>The <b>pay per attendee</b> license determine how many total attendees can attend all of your account’s events held within a 12-month period from purchase.</span>",
    "included": "Included",
    "notIncluded": "Not Included",
    "multiLanguage": "Multi-language",
    "meetings.fullPlanItem2": "License count",
    "meetings.fullPlanItem2Tip": "Each plan has specific limits on how many users can be assigned meeting licenses or other user accounts.",
    "phone.fullPlanItem30": "Zoom Meetings",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "Simplified video conferencing and messaging across any device",
    "meetings.fullPlanItem5": "Meeting duration",
    "meetings.fullPlanItem5Tip": "The maximum duration allowed per group meeting (3 or more participants).",
    "meetings.fullPlanItem5_basic": "40 mins",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 hours",
    "meetings.fullPlanItem5_biz": "30 hours",
    "meetings.fullPlanItem5_ent": "30 hours",
    "meetings.fullPlanItem1": "Participant capacity",
    "meetings.fullPlanItem1Tip": "Participants can join your meeting for free from their phone, desktop, mobile and tablet devices. A participant does not need a Zoom account in order to join a meeting. Each plan has a participant limit, but users can increase this limit on paid plans by purchasing an add-on.",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000 for Enterprise Plus</span>",
    "meetings.fullPlanItem7": "Recording",
    "meetings.fullPlanItem7Tip": "Zoom local recording saves your meeting recordings in MP4 (video), M4A (audio) and txt (chat) formats.<br>Zoom Cloud Recording stores meetings in the Zoom Cloud, where the file can then be downloaded and/or streamed from a browser.",
    "meetings.fullPlanItem7_basic": "Local",
    "meetings.fullPlanItem7_pro": "Local & 5 GB cloud (per license)",
    "meetings.fullPlanItem7_biz": "Local & 10 GB cloud (per license)",
    "meetings.fullPlanItem7_ent": "Local & Unlimited cloud",
    "one.messaging": "Team Chat",
    "meetings.fullPlanItem16Tip": "Chat allows you to easily send group text, files, screen captures, code snippets, voice messages and images. Text can be formatted and users can share GIFs and emojis as well. Presence displays whether chat participants are active on desktop or mobile devices, or busy in meetings.",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "Unlimited",
    "meetings.fullPlanItem_EssentialApp": "Essential Apps",
    "common.learnMore": "Learn More",
    "meetings.fullPlanItem_EssentialAppText": "Free premium Zoom apps for 1 year (terms apply)",
    "zoomMailAndCalendarInTheZoomApp": "Zoom Mail and Calendar in the Zoom app",
    "mailService": "Mail Service",
    "emailServiceWithFullTimeEndToEnd": "Email service with full-time end-to-end encryption for enhanced privacy",
    "customMailDomain": "Custom Mail Domain",
    "customMailDomainWithMailService": "Custom Mail Domain with Mail Service",
    "calendarClient": "Calendar Client",
    "scheduleAndJoinMeetings": "Schedule and join meetings in the Zoom app",
    "aiCompanion": "AI Companion",
    "calendarService": "Calendar Service",
    "meetingSchedulingAndAppointment": "Meeting scheduling and appointment booking",
    "marketing.new_pricing.clips": "Clips",
    "allPlansClipsCoreFeatureToolTip": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "allPlansNotesCoreFeatureToolTip": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "Translated Captions",
    "workspaceReservation": "Workspace Reservation",
    "accessAcrossAnyDevice": "Access across any device",
    "meetings.fullPlanItem4": "Unlimited meetings",
    "meetings.fullPlanItem9": "Telephone dial-in",
    "meetings.fullPlanItem9Tip": "Join a Zoom meeting via teleconferencing/audio conferencing (using a traditional telephone). Users will be charged according to their telephone plan. Try our Audio Conferencing add-on for toll-free dial-in numbers.",
    "meetings.fullPlanItem9_pro": "Toll-based",
    "meetings.fullPlanItem9_biz": "Toll-based",
    "meetings.fullPlanItem9_ent": "Toll-based",
    "meetings.fullPlanItem11": "Screen sharing",
    "meetings.fullPlanItem11Tip": "Desktop and application sharing. Licensed meeting users can choose to allow multiple participants to share their screens simultaneously during a meeting they are hosting.",
    "meetings.fullPlanItem12": "Breakout rooms",
    "meetings.fullPlanItem12Tip": "Video Breakout Rooms allow you to split your Zoom meeting into as many as 50 separate sessions for discussion, projects and more.",
    "meetings.fullPlanItem14": "Virtual background",
    "meetings.fullPlanItem15": "Personal Meeting ID",
    "meetings.fullPlanItem15Tip": "Create your own permanent online meeting room. You can start this meeting at any time or schedule it for future use.",
    "meetings.fullPlanItem17": "Host controls",
    "meetings.fullPlanItem18": "Co-Annotation on screen share",
    "meetings.fullPlanItem19": "Remote keyboard & mouse Control",
    "meetings.fullPlanItem21": "Multi-share",
    "meetings.fullPlanItem29": "Waiting room",
    "meetings.fullPlanItem29Tip": "The Waiting Room feature allows the host to control when a participant joins the meeting. As the meeting host, you can admit participants one by one or all at once. In settings, you can choose who gets put into the Waiting Room or gets automatically admitted. Every account has the Waiting Room feature. Hosts can message the Waiting Room. You can customize the Waiting Room, if you're on a paid plan.",
    "meetings.fullPlanItem41": "Built into Zoom for home devices",
    "meetings.fullPlanItem61": "Pin multiple people",
    "meetings.fullPlanItem61Tip": "The host can grant up to 9 people, the ability to pin videos to create their own custom view. So no matter who is speaking, the pinned videos stay visible.",
    "meetings.fullPlanItem62": "Spotlight multiple people",
    "meetings.fullPlanItem62Tip": "The host can spotlight up to 9 attendee’s videos, so that no matter who is speaking the entire meeting sees the spotlighted videos.",
    "meetings.fullPlanNewItem1": "Filters",
    "meetings.fullPlanNewItem1Tip": "Bring more fun into happy hours, parties and more with fun color filters or decorative animal stickers.",
    "meetings.fullPlanNewItem2": "Polling",
    "meetings.fullPlanNewItem3": "Co-host & alternate host",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">Learn more</a> about our co-host controls for meetings.",
    "meetings.fullPlanItem24": "Assign meeting scheduler",
    "meetings.fullPlanItem24Tip": "Allows you to assign someone else to set up your meetings for you. Assignee must also have a Pro plan.",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "Allows account owners, admins, and your developers secure access to Zoom REST API.<br><a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> are applied at the account-level according to <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#account-types\" target=\"_blank\">Account Type</a> (Pro, Business, Enterprise, etc…) and the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#request-types\" target=\"_blank\">API Request Type</a> (Light, Medium, Heavy, etc…). Some APIs are access-limited to specific account types. Use the <a href=\"https://marketplace.zoom.us/docs/api-reference/rate-limits#rate-limits-1\" target=\"_blank\">API Rate Limits</a> & <a href=\"https://marketplace.zoom.us/docs/api-reference/introduction\" target=\"_blank\">API Reference Documentation</a> for complete details.",
    "meetings.fullPlanItem25_pro": "Pro REST API Rate Limits",
    "meetings.fullPlanItem25_biz": "REST API Rate Limits",
    "meetings.fullPlanItem26": "Skype for Business (Lync) interoperability",
    "meetings.fullPlanItem26Tip": "Allows Lync users 2010, 2013 and Skype for Business users to initiate a Zoom meeting from the Lync contact list.",
    "meetings.fullPlanItem27": "Streaming",
    "meetings.fullPlanItem27Tip": "Stream live to Facebook, Youtube or a 3rd party service.",
    "meetings.fullPlanItem28": "Reporting",
    "meetings.fullPlanItem28Tip": "Run usage reports to learn how many meetings are taking place, which days, number of participants, number of meeting minutes and more.",
    "meetings.fullPlanItem30": "User management",
    "meetings.fullPlanItem30Tip": "Owners and Admins can add, delete and assign roles and add-on features.",
    "one.autoCaptions": "Automated Captions",
    "meetings.fullPlanItem31": "Admin portal",
    "meetings.fullPlanItem31Tip": "Manage users in your company on one account for simplified billing, advanced user management settings, and comprehensive usage insights all in the Zoom Admin Portal.",
    "meetings.fullPlanItem32": "LTI integration",
    "meetings.fullPlanItem32Tip": "Easily add a meeting to any course activity and invite the right students from your learning management system (works with Moodle, Canvas, Desire2Learn and Blackboard).",
    "meetings.fullPlanItem33": "Recording transcripts",
    "meetings.fullPlanItem33Tip": "Cloud recording transcripts are audio transcripts that transcribe the audio of a meeting or webinar that you record to the cloud. Please note this is currently supported for English language. <a href=\"https://support.zoom.us/hc/en-us/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">Click here</a> to learn more.",
    "meetings.fullPlanItem34": "Branding",
    "meetings.fullPlanItem34Tip": "Add your company's branding to your own customized page where your users can join a meeting. Create a branded email template to send invites to participants.",
    "meetings.fullPlanItem35": "Managed domains",
    "meetings.fullPlanItem35Tip": "Use your company/university email address domain to add users to your account automatically.",
    "meetings.fullPlanItem37": "Language interpretations",
    "meetings.fullPlanItem37Tip": "Allows the meeting host to designate interpreters in their meetings and webinar. Upon starting the meeting or webinar, the meeting host can start the interpretation feature, which will give the interpreters access to their own audio channels. Participants can select an audio channel to hear their language of choice. Participants will hear the translated audio and can choose if they want to hear the original audio at a lower volume.",
    "meetings.fullPlanItem39": "Executive business reviews",
    "meetings.fullPlanItem39Tip": "Detailed trending adoption analysis, ROI tracking, product roadmap discussions.",
    "meetings.fullPlanNewItem4": "Includes Webinar 500",
    "one.translatedCations": "Translated Captions",
    "one.entPlus": "Enterprise Plus",
    "directChannelOrGroupChat": "Direct, Channel, or Group Chat",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "Easily communicate in 1:1 messages, small groups, or with large teams",
    "messageAndFileHistory": "Message and file history",
    "findPeopeChannelsAndFilesInSearch": "Find peope, channels, and files in search",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "Quickly find contacts, instant messages, group chats, and files, keeping knowledge and information at your fingertips.",
    "applicationIntegrations": "Application Integrations",
    "secureFileSharing": "Secure file sharing",
    "enhanceCollaborationWithSeamlessFileSharing": "Enhance collaboration with seamless file sharing",
    "persistentMeetingChat": "Persistent meeting chat",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "Never lose track of meeting conversations. Communicate before, during, and after a meeting in a dedicated group chat in Zoom Team Chat for all meeting participants.",
    "cloudStorage": "Cloud Storage",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "Back channels to the Zoom Cloud or a third-party storage provider",
    "avatars": "Avatars",
    "inMeetingReactions": "In-meeting reactions",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "Show engagement and quickly communicate with other participants in a non-verbal way",
    "virtualBackgrounds": "Virtual backgrounds",
    "videoFilters": "Video filters",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "Inject some fun into your meetings with a variety of filters overlayed onto your video",
    "inMeetingPollsAndQuizzes": "In-meeting polls & quizzes",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "Create single-choice or multiple-choice polling questions for your meetings.",
    "liveStreamingAcrossPlatforms": "Live streaming across platforms",
    "appearanceTouchUp": "Appearance touch up",
    "originalSoundForMusicians": "Original sound for musicians",
    "endToEndEncryptionForZoomMeetings": "End-to-end encryption for Zoom Meetings",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "When enabled, Zoom’s end-to-end encryption (E2EE) for Zoom Meetings means that communications between all meeting participants using Zoom clients in a given meeting are encrypted using cryptographic keys known only to the devices of those participants. This means that no third party — including Zoom — has access to the meeting’s private keys.",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "enterpriseGradeSecurityFeatures": "Enterprise-grade security features",
    "256BitAesGcmEncryptionForRealTimeContent": "256-bit AES-GCM encryption for real-time content and media, TLS encryption during SIP registration, caller ID masking, private network peering, tool fraud detection, and calling block lists.",
    "phone.fullPlanItem40": "Single sign-on via SAML 2.0",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem1": "Unlimited internal calling",
    "phone.fullPlanItem2": "Metered outbound calling",
    "phone.fullPlanItem3": "Unlimited outbound calling",
    "phone.fullPlanItem4": "Industry-leading HD call quality",
    "phone.fullPlanItem4Tip": "With active noise cancellation, echo cancellation, and keyboard typing suppression",
    "phone.fullPlanItem5": "Native Windows, MacOS and Linux desktop apps",
    "phone.fullPlanItem6": "Native mobile apps for iOS and Android",
    "phone.fullPlanItem7": "Port existing phone numbers or purchase new ones (DID)",
    "phone.fullPlanItem8": "Toll free numbers",
    "phone.fullPlanItem9": "Phone extension number",
    "phone.fullPlanItem10": "Voicemail with transcription",
    "phone.fullPlanItem10Tip": "Voicemail transcript access via mobile/desktop apps and email",
    "phone.fullPlanItem11": "Unlimited auto attendants/IVR",
    "phone.fullPlanItem12": "Dial by name directory",
    "phone.fullPlanItem13": "Automatic call distribution groups (ACD) with call queueing",
    "phone.fullPlanItem14": "Barge/Monitor/Whisper/Takeover",
    "phone.fullPlanItem15": "Holiday and business hours routing",
    "phone.fullPlanItem16": "3-Way ad hoc conference calls",
    "phone.fullPlanItem17": "Call recording",
    "phone.fullPlanItem17Tip": "Automatic and manual call recording are available. Full time and on-demand call recording with transcriptions",
    "phone.fullPlanItem18": "Configurable anonymous and specified call blocking",
    "phone.fullPlanItem19": "Emergency calling",
    "phone.fullPlanItem19Tip": "Place calls to local emergency services",
    "phone.fullPlanItem20": "Nomadic E911 addressing (US and Canada) -",
    "phone.fullPlanItem20Tip": "Dynamically detect user location and report corresponding emergency address to local emergency services (US & Canada only) and to internal safety team",
    "phone.fullPlanItem21": "Emergency response center",
    "phone.fullPlanItem21Tip": "Enable your internal safety team to be alerted for emergency calls and record/monitor/barge into emergency calls to help coordinate the response.",
    "phone.fullPlanItem22": "Shared line appearance/delegation",
    "phone.fullPlanItem23": "Call handoff between devices",
    "phone.fullPlanItem24": "Call park",
    "endToEndEncryptionForZoomPhone": "End-to-end encryption for Zoom Phone",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "When enabled for Zoom Phone, end-to-end encryption (E2EE) provides that the call is encrypted using cryptographic keys known only to the devices of the caller and receiver. Additionally, users will have the option to verify E2EE status by providing a unique security code to one another.",
    "phone.fullPlanItem43": "Zero-touch provisioning of phones",
    "phone.fullPlanItem44": "Mix types of plans in an account",
    "phone.fullPlanItem46": "Real time reporting and quality dashboards",
    "phone.fullPlanItem47": "Support for virtual desktop (VDI) environment",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/en-us/articles/360031096531-Getting-Started-with-VDI\" target=\"_blank\">Learn More</a> about VDI",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "phone.fullPlanItem49": "Bring your own carrier support",
    "phone.fullPlanItem49Tip": "Support for direct and premise-based peering to your existing PSTN service provider",
    "phone.fullPlanItem50": "Hybrid integration to legacy PBXs",
    "phone.fullPlanItem51": "Push-to-Talk",
    "phone.fullPlanItem61": "Online Fax",
    "phone.fullPlanItem61Tip": "Send and receive unlimited faxes within the US & CA. For international faxes, <a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">see rates</a>",
    "phone.fullPlanSms": "SMS & MMS",
    "phone.fullPlanSmsTip": "Available for US, Canada and Australia numbers only with the purchase of a calling plan. Available to use for direct numbers (not company numbers).",
    "meetings.fullPlanItem6": "Technical support",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime",
    "meetings.fullPlanItem6_basic": "Help center",
    "meetings.fullPlanItem6_pro": "Ticket & live chat",
    "meetings.fullPlanItem6_biz": "Ticket, live chat, & phone",
    "meetings.fullPlanItem6_ent": "Ticket, live chat, & phone",
    "knowledgeBase": "Knowledge Base",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "Troubleshoot technical issues and access support resources by searching our knowledge base articles.",
    "zoomCommunity": "Zoom Community",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "A place to find solutions, ask questions and collaborate with other Zoom users.",
    "chatbot": "Chatbot",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "Get answers to questions and troubleshoot technical issues by interacting with our chatbot.",
    "submitWebTickets": "Submit web tickets",
    "liveChatSupport": "Live chat support",
    "subscriptionPlansGreaterThan_dynamicUsdMonth": "Subscription plans greater than ${amount} USD/month",
    "livePhoneSupport": "Live phone support",
    "meetWithAgentOnVideo": "Meet with agent on video",
    "subscriptionPlansGreaterThan_200UsdMonth": "Subscription plans greater than $200 USD/month",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "Boost productivity by leveraging your favorite Apps right within Team Chat",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "Customize your own avatar to bring some fun into meetings and present yourself dynamically without needing to be on video",
    "enterprisePlusIncludesZoomSessions_1000": "Enterprise Plus includes Zoom Sessions 1000*",
    "mail": "Mail",
    "common.plans.meeting.title": "Meetings",
    "plans.basic_free.upgrade.item1": "Up to 30 hours per meeting",
    "common.statistics.participants": "{0} Participants",
    "common.per_meeting_unit": "per meeting",
    "common.participant_limit.increase_with_large_meetings": "Increase with Large Meeting",
    "plans.ai_companion.title": "AI Companion",
    "common.plans.whiteboard.title": "Whiteboard",
    "detail_dialog.meeting_feature.zoom_whiteboards.unlimited": "Unlimited",
    "common.plans.team_chat.title": "Team Chat",
    "common.plans.mail_calendar.title": "Mail & Calendar",
    "common.plans.cloud_storage.title": "Cloud Storage",
    "plans.bundle_credit.storage": "{0} GB",
    "plans.translation.title": "Translated Captions",
    "common.plans.extras.title": "Extras",
    "common.plans.extras.desc": "manage company domains, and more",
    "zoom_one_edu_bundle.school.title": "Zoom One for Education School and Campus",
    "zoom_one_edu_bundle.school_plus.title": "Zoom One for Education School and Campus Plus",
    "per_billing_cycle_license.monthly": "/month/license",
    "per_billing_cycle_license.yearly": "/year/license",
    "per_billing_cycle_space.monthly": "/month/space",
    "per_billing_cycle_space.yearly": "/year/space",
    "common.dialog.feature_list": "See Full Feature List",
    "detail_dialog.meeting_feature.cloud_recording.pro": "5 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.10": "10 GB per License",
    "detail_dialog.meeting_feature.cloud_recording.ent": "Enterprise Plus includes Unlimited",
    "plans.zr_crc": "Zoom Rooms & CRC",
    "plans.zr_crc.ent": "Zoom Room + Conference Room Connector (1:25 ratio)",
    "plans.whiteboard.ent": "Enterprise Plus includes Unlimited Plus",
    "plans.zp.ent": "Included in Enterprise Plus",
    "plans.zoom_scheduler.title": "Zoom Scheduler",
    "plans.zoom_scheduler.desc": "Advanced or on-site workspace reservation, and more",
    "plans.largeMeeting.intro_tip": "Large Meeting is an optional add-on during checkout, allowing you to host a meeting for up to 500 or 1,000 participants, depending on the license purchased.",
    "common.participant_limit.expandable_with_large_meetings": "Expandable with Large Meeting",
    "common.plans.meeting.enterprise": "500<br><span class=\"cell-desc\">1,000 for Enterprise Plus</span>",
    "plans.webinar": "Zoom Webinar",
    "plans.webinar.ent": "Enterprise Plus includes Session 1000 (includes Webinar)",
    "per_billing_cycle_user.monthly": "/month/user",
    "per_billing_cycle_user.annually": "/year/user",
    "closeComparisonChart": "Close Comparison Chart",
    "archiving_api": "Archiving API",
    "dlp_api": "DLP API",
    "info_barriers": "Info Barriers",
    "chat_etiquette": "Chat Etiquette",
    "gdrp": "GDPR",
    "regiona_data_centers": "Regiona Data Centers",
    "zoom_compliance_manager": "Zoom Compliance Manager",
    "encryption_by_default": "Encryption by Default",
    "end_to_end_encryption": "End-to-End Encryption",
    "cryptographic_boundary": "Cryptographic Boundary",
    "vdi": "Virtual Desktop (VDI)",
    "customer_managed_key": "Customer Managed Key",
    "gpo_msi_policies": "GPO/MSI Policies",
    "msi": "Mass Deployment (MSI)",
    "ntt": "Network Test Tool (NTT)",
    "dashboards": "Dashboards",
    "zoom_mesh": "Zoom Mesh",
    "zoom_phone_survivability": "Zoom Phone Survivability",
    "zoom_meeting_survivability": "Zoom Meeting Survivability",
    "paid_option": "Paid Option",
    "marketing.meet_with_agent_on_video_tooltip": "This feature is only available for admin",
    "marketing.live_phone_support_tooltip": "This feature is only available for admin",
    "fbc.common.core_features": "Core Features",
    "fbc.common.support": "Support",
    "zoom_one_edu_bundle.school.brief_title": "School and Campus",
    "zoom_one_edu_bundle.school_plus.brief_title": "School and Campus Plus",
    "enterprise_essentials_zp_not_available": "Not available with Enterprise Essentials"
  }
}
export default i18n
